import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
  Long: { input: any; output: any; }
  TimeSpan: { input: any; output: any; }
  URL: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AcceptContactListShareResult = {
  __typename?: 'AcceptContactListShareResult';
  success: Scalars['Boolean']['output'];
};

export type AcceptContactShareResult = {
  __typename?: 'AcceptContactShareResult';
  jobId: Scalars['String']['output'];
};

export type AcceptInviteResult = {
  __typename?: 'AcceptInviteResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AcceptInviteResultAction = {
  __typename?: 'AcceptInviteResultAction';
  acceptAction?: Maybe<InviteAcceptActionBase>;
  disclosure?: Maybe<AcceptInviteResultActionDisclosure>;
};

export type AcceptInviteResultActionDisclosure = {
  __typename?: 'AcceptInviteResultActionDisclosure';
  acceptButtonTitle?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  declineButtonTitle?: Maybe<Scalars['String']['output']>;
  declineConfirmationText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AcceptInviteWithEmailVerificationResult = {
  __typename?: 'AcceptInviteWithEmailVerificationResult';
  blockedUntil?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  failedAttempts: Scalars['Int']['output'];
  maxAttempts: Scalars['Int']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  verificationResult: OtpVerificationResult;
};

export type AcceptedInvite = {
  __typename?: 'AcceptedInvite';
  acceptedAt: Scalars['DateTime']['output'];
  acceptedBy: UserWithAddress;
  createdAt: Scalars['DateTime']['output'];
  inviteId: Scalars['String']['output'];
  memo: Scalars['String']['output'];
};

export type AccessPassPayloadInput = {
  code: Scalars['String']['input'];
  guide?: InputMaybe<Scalars['String']['input']>;
  isGenerated: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type AccessPassRewardRedemption = {
  __typename?: 'AccessPassRewardRedemption';
  code: Scalars['String']['output'];
  guide?: Maybe<Scalars['String']['output']>;
  isGenerated: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  redemptionType: RewardRedemptionType;
};

export type AccountVerificationRequired = {
  __typename?: 'AccountVerificationRequired';
  identifier: Scalars['String']['output'];
  methods: Array<VerificationMethod>;
  provider: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type Achievement = ILimitedAchievementModel & {
  __typename?: 'Achievement';
  /** Id of Achievement */
  achievementId: Scalars['UUID']['output'];
  /** Active from date of achievement */
  activeFromUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Active to date of achievement */
  activeToUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Avatar url of achievement */
  avatarUrl: Scalars['String']['output'];
  /**
   * List of rewards that trigger awarded achievement
   * @deprecated Please use awardedTriggerByRewards2 instead
   */
  awardedTriggerByRewards?: Maybe<RewardOffsetPage>;
  /** List of rewards that trigger awarded achievement */
  awardedTriggerByRewards2?: Maybe<Array<Maybe<Reward>>>;
  /** Bio of achievement */
  bio: Scalars['String']['output'];
  /** Category of achievement */
  category?: Maybe<AchievementCategory>;
  /**
   * A list of claimed rewards
   * @deprecated Please use claimedByRewards2 instead
   */
  claimedByRewards?: Maybe<RewardOffsetPage>;
  /** A list of claimed rewards */
  claimedByRewards2?: Maybe<Array<Maybe<Reward>>>;
  /** Created date of achievement */
  createdUtc: Scalars['DateTime']['output'];
  /** Display name of achievement */
  displayName: Scalars['String']['output'];
  /** Details of reward that achievement was claimed from */
  fromReward?: Maybe<Reward>;
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Is hidden of achievement */
  isHidden: Scalars['Boolean']['output'];
  /** Max supply of achievement */
  maxSupply?: Maybe<Scalars['Int']['output']>;
  /** Owner */
  owner?: Maybe<User>;
  /** Pie of achievement */
  pie?: Maybe<CompletePieWithBalance>;
  /** Slug of achievement */
  slug: Scalars['String']['output'];
  /** List activated users of reward */
  statisticsByRewards?: Maybe<GroupedUserAchievement>;
  /** Status of achievement */
  status: AchievementStatus;
  /** A list of my tickets associated with this achievement */
  tickets?: Maybe<UserTicketPageX>;
  /** Total users who have unlocked this achievement */
  totalUnlockedUsers?: Maybe<Scalars['Int']['output']>;
  /** Id of uploaded asset */
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
  /** Verification code of achievement */
  verificationCode: Scalars['String']['output'];
};


export type AchievementStatisticsByRewardsArgs = {
  triggeredRewardIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type AchievementTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type AchievementArgsInput = {
  activeFromUtc?: InputMaybe<Scalars['DateTime']['input']>;
  activeToUtc?: InputMaybe<Scalars['DateTime']['input']>;
  avatarUrl: Scalars['String']['input'];
  bio: Scalars['String']['input'];
  category: AchievementCategory;
  displayName: Scalars['String']['input'];
  isHidden: Scalars['Boolean']['input'];
  maxSupply?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  status: AchievementStatus;
  type: AchievementType;
};

export type AchievementAvatarType = {
  __typename?: 'AchievementAvatarType';
  completeUpload: Scalars['Boolean']['output'];
  /** @deprecated Use mutation UploadedAsset.presignUploadUrl instead */
  presignUploadUrl: Scalars['String']['output'];
};


export type AchievementAvatarTypeCompleteUploadArgs = {
  achievementId: Scalars['UUID']['input'];
  avatarUrl: Scalars['String']['input'];
};


export type AchievementAvatarTypePresignUploadUrlArgs = {
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
};

export type AchievementAwardedTrigger = {
  __typename?: 'AchievementAwardedTrigger';
  awardedTriggerBy: AwardedTriggerBy;
  awardedTriggerById: Scalars['UUID']['output'];
  awardedTriggerDate: Scalars['DateTime']['output'];
  logs?: Maybe<Scalars['String']['output']>;
};

export type AchievementBadgeConditionArgsInput = {
  achievementId: Scalars['UUID']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type AchievementBadgeRewardConditionInput = {
  achievementId: Scalars['UUID']['input'];
};

export type AchievementBonusReward = {
  __typename?: 'AchievementBonusReward';
  achievement?: Maybe<AchievementState>;
  settingType: BonusRewardType;
};

export enum AchievementCategory {
  BrandBadge = 'BRAND_BADGE',
  CommunityBadge = 'COMMUNITY_BADGE',
  EventBadge = 'EVENT_BADGE',
  LaunchDaySupporter = 'LAUNCH_DAY_SUPPORTER',
  OgSupporter = 'OG_SUPPORTER',
  Other = 'OTHER',
  ParticipationBadge = 'PARTICIPATION_BADGE',
  ProductBadge = 'PRODUCT_BADGE',
  TierBadgeDiamond = 'TIER_BADGE_DIAMOND',
  TierBadgeEmerald = 'TIER_BADGE_EMERALD',
  TierBadgeRuby = 'TIER_BADGE_RUBY'
}

export type AchievementContentPayloadInput = {
  achievementId: Scalars['UUID']['input'];
};

export type AchievementEdgeX = {
  __typename?: 'AchievementEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Achievement>;
};

/** Represents a slice or page */
export type AchievementGrainPageX = {
  __typename?: 'AchievementGrainPageX';
  /** A list of edges */
  edges: Array<AchievementEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<Achievement>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type AchievementListType = ILimitedAchievementModel & {
  __typename?: 'AchievementListType';
  achievementId: Scalars['UUID']['output'];
  activeFromUtc?: Maybe<Scalars['DateTime']['output']>;
  activeToUtc?: Maybe<Scalars['DateTime']['output']>;
  avatarUrl: Scalars['String']['output'];
  bio: Scalars['String']['output'];
  category?: Maybe<AchievementCategory>;
  /**
   * A list of claimed rewards
   * @deprecated Please use claimedByRewards2 instead
   */
  claimedByRewards?: Maybe<RewardOffsetPage>;
  /** A list of claimed rewards */
  claimedByRewards2?: Maybe<Array<Maybe<Reward>>>;
  createdUtc: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  maxSupply?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<User>;
  pie?: Maybe<CompletePieWithBalance>;
  slug: Scalars['String']['output'];
  status: AchievementStatus;
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
  verificationCode: Scalars['String']['output'];
};

export type AchievementMutationApi = {
  __typename?: 'AchievementMutationApi';
  achievementAvatar: AchievementAvatarType;
  /** Award achievement */
  award: Scalars['Boolean']['output'];
  /** PLACEHOLDER: Trade or update a achievement */
  createOrUpdate: PublicAchievementModel;
  /** Delete achievement */
  delete: Scalars['Boolean']['output'];
  /** Recover achievement */
  recover: Scalars['Boolean']['output'];
  /** Set achievement status */
  setStatus: Scalars['Boolean']['output'];
  /** Set achievement visibility */
  setVisibility: Scalars['Boolean']['output'];
  /** Get test ticket */
  ticketGetTestTicket: TicketGrantResult;
  /** Grant new ticket */
  ticketGrant: TicketGrantResult;
  /** Revoke an existing ticket */
  ticketRevoke?: Maybe<Scalars['Boolean']['output']>;
  /** Verify Ticket */
  ticketVerify?: Maybe<TicketVerifyResult>;
};


export type AchievementMutationApiAwardArgs = {
  achievementId: Scalars['UUID']['input'];
  pieId?: InputMaybe<Scalars['UUID']['input']>;
  userName: Scalars['String']['input'];
};


export type AchievementMutationApiCreateOrUpdateArgs = {
  activeFromUtc?: InputMaybe<Scalars['DateTime']['input']>;
  activeToUtc?: InputMaybe<Scalars['DateTime']['input']>;
  adminUpdate?: Scalars['Boolean']['input'];
  adminUpdateUser?: InputMaybe<Scalars['UUID']['input']>;
  avatarUrl: Scalars['String']['input'];
  bio: Scalars['String']['input'];
  category: AchievementCategory;
  claimByRewardId?: InputMaybe<Scalars['UUID']['input']>;
  displayName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  maxSupply?: InputMaybe<Scalars['Int']['input']>;
  pieId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
  status?: AchievementStatus;
  uploadedAssetId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AchievementMutationApiDeleteArgs = {
  achievementId: Scalars['UUID']['input'];
};


export type AchievementMutationApiRecoverArgs = {
  achievementId: Scalars['UUID']['input'];
};


export type AchievementMutationApiSetStatusArgs = {
  id: Scalars['UUID']['input'];
  status: AchievementStatus;
};


export type AchievementMutationApiSetVisibilityArgs = {
  id: Scalars['UUID']['input'];
  visibility: Scalars['Boolean']['input'];
};


export type AchievementMutationApiTicketGetTestTicketArgs = {
  achievementId: Scalars['UUID']['input'];
};


export type AchievementMutationApiTicketGrantArgs = {
  achievementId: Scalars['UUID']['input'];
  associatedUserId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AchievementMutationApiTicketRevokeArgs = {
  achievementId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
};


export type AchievementMutationApiTicketVerifyArgs = {
  achievementId: Scalars['UUID']['input'];
  ticketId: Scalars['String']['input'];
};

export type AchievementMutator = {
  __typename?: 'AchievementMutator';
  achievementId: Scalars['UUID']['output'];
  clubId: Scalars['UUID']['output'];
  updateAchievement: Scalars['Boolean']['output'];
};


export type AchievementMutatorUpdateAchievementArgs = {
  payload: UpdateAchievementPayloadInput;
};

/** Represents a slice or page of Achievement */
export type AchievementOffsetPage = {
  __typename?: 'AchievementOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<Achievement>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

/** Represents a slice or page */
export type AchievementPageX = {
  __typename?: 'AchievementPageX';
  /** A list of edges */
  edges: Array<AchievementEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<Achievement>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type AchievementPublicQueryApi = {
  __typename?: 'AchievementPublicQueryApi';
  byId?: Maybe<Achievement>;
};


export type AchievementPublicQueryApiByIdArgs = {
  id: Scalars['UUID']['input'];
};

export type AchievementQueryApi = {
  __typename?: 'AchievementQueryApi';
  byId?: Maybe<Achievement>;
  /** Use for manager of pie only */
  bySlugOrId?: Maybe<Achievement>;
  /** @deprecated Use listAchievements2 instead */
  listAchievements?: Maybe<AchievementStatistic>;
  listAchievements2?: Maybe<AchievementStatisticV2>;
  /** @deprecated Please use listAllAchievements2 */
  listAllAchievements?: Maybe<AchievementOffsetPage>;
  listAllAchievements2?: Maybe<AchievementGrainPageX>;
  /** @deprecated Use listByPieId2 instead */
  listByPieId?: Maybe<AchievementStatistic>;
  listByPieId2?: Maybe<AchievementStatisticV2>;
  /** @deprecated Use listCreatedAchievements2 instead */
  listCreatedAchievements?: Maybe<AchievementOffsetPage>;
  listCreatedAchievements2?: Maybe<AchievementGrainPageX>;
  slugAvailable: Scalars['Boolean']['output'];
  slugAvailable2: AvailableCheckingResult;
  userAchievements?: Maybe<AchievementGrainPageX>;
  /** @deprecated Please use userAchievements3 */
  userAchievements2?: Maybe<AchievementOffsetPage>;
  userAchievements3?: Maybe<AchievementGrainPageX>;
};


export type AchievementQueryApiByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AchievementQueryApiBySlugOrIdArgs = {
  achievementSlugOrId: Scalars['String']['input'];
  pieSlugOrId: Scalars['String']['input'];
  triggeredRewardIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type AchievementQueryApiListAchievementsArgs = {
  limit?: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  offset?: Scalars['Int']['input'];
  sortingOrder?: PageSortOrder;
  sortingType?: AchievementSortType;
  status?: AchievementStatus;
};


export type AchievementQueryApiListAchievements2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sortingOrder?: PageSortOrder;
  sortingType?: AchievementSortType;
  status?: AchievementStatus;
};


export type AchievementQueryApiListByPieIdArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  pieId: Scalars['UUID']['input'];
  sortingOrder?: PageSortOrder;
  sortingType?: AchievementSortType;
  status?: AchievementStatus;
};


export type AchievementQueryApiListByPieId2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pieId: Scalars['UUID']['input'];
  sortingOrder?: PageSortOrder;
  sortingType?: AchievementSortType;
  status?: AchievementStatus;
};


export type AchievementQueryApiListCreatedAchievementsArgs = {
  limit?: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  offset?: Scalars['Int']['input'];
  sortingOrder?: PageSortOrder;
  sortingType?: AchievementSortType;
  status?: AchievementStatus;
};


export type AchievementQueryApiListCreatedAchievements2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sortingOrder?: PageSortOrder;
  sortingType?: AchievementSortType;
  status?: AchievementStatus;
};


export type AchievementQueryApiSlugAvailableArgs = {
  slug: Scalars['String']['input'];
};


export type AchievementQueryApiSlugAvailable2Args = {
  slug: Scalars['String']['input'];
};


export type AchievementQueryApiUserAchievementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortingType?: PageSortOrder;
};


export type AchievementQueryApiUserAchievements2Args = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sortingType?: PageSortOrder;
};


export type AchievementQueryApiUserAchievements3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortingType?: PageSortOrder;
};

export enum AchievementSortType {
  AchievementName = 'ACHIEVEMENT_NAME',
  CreatedDate = 'CREATED_DATE'
}

export type AchievementState = {
  __typename?: 'AchievementState';
  achievementId: Scalars['UUID']['output'];
  avatarUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  triggers: Array<Maybe<AchievementTriggerGqlType>>;
  type: ClubAchievementType;
};

export type AchievementStatistic = {
  __typename?: 'AchievementStatistic';
  /** List created achievements */
  achievementList?: Maybe<AchievementOffsetPage>;
  totalUnlockAchievementAmount: Scalars['Int']['output'];
};

export type AchievementStatisticV2 = {
  __typename?: 'AchievementStatisticV2';
  /** List created achievements */
  achievementList?: Maybe<AchievementGrainPageX>;
  totalUnlockAchievementAmount: Scalars['Int']['output'];
};

export enum AchievementStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  None = 'NONE'
}

export type AchievementTriggerGqlType = FromRewardTrigger;

export type AchievementTriggerPayloadInput = {
  fromReward?: InputMaybe<FromRewardTriggerPayloadInput>;
};

export enum AchievementTriggerType {
  FromReward = 'FROM_REWARD',
  Unknown = 'UNKNOWN'
}

export enum AchievementType {
  Invite = 'INVITE',
  None = 'NONE'
}

export type AchievementTypeOperationFilterInput = {
  eq?: InputMaybe<AchievementType>;
  in?: InputMaybe<Array<AchievementType>>;
  neq?: InputMaybe<AchievementType>;
  nin?: InputMaybe<Array<AchievementType>>;
};

export type AchievementUserInfo = {
  __typename?: 'AchievementUserInfo';
  achievementAwardedTriggers: Array<AchievementAwardedTrigger>;
  claimedByRewardId?: Maybe<Scalars['UUID']['output']>;
  createdUtc: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type AchievementsConditionPayloadInput = {
  achievementIds: Array<Scalars['UUID']['input']>;
};

/** A connection to a list of items. */
export type AchievementsConnection = {
  __typename?: 'AchievementsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AchievementsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<AchievementState>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AchievementsEdge = {
  __typename?: 'AchievementsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AchievementState>;
};

export type AchievementsRewardCondition = {
  __typename?: 'AchievementsRewardCondition';
  achievements: Array<Maybe<AchievementState>>;
  type: RewardConditionType;
};

export enum ActionTaken {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

export type ActionTakenStatisticsResult = {
  __typename?: 'ActionTakenStatisticsResult';
  approved: Scalars['Long']['output'];
  denied: Scalars['Long']['output'];
  pending: Scalars['Long']['output'];
};

export type ActivatedUserAgeRange = {
  __typename?: 'ActivatedUserAgeRange';
  totalFemaleAmount: Scalars['Int']['output'];
  totalFemaleAmountPercentage: Scalars['Float']['output'];
  totalMaleAmount: Scalars['Int']['output'];
  totalMaleAmountPercentage: Scalars['Float']['output'];
  totalOtherAmount: Scalars['Int']['output'];
  totalOtherAmountPercentage: Scalars['Float']['output'];
};

export type ActivatedUserAgeRangeStatistic = {
  __typename?: 'ActivatedUserAgeRangeStatistic';
  ageOver44: ActivatedUserAgeRange;
  ageRangeFrom18To24: ActivatedUserAgeRange;
  ageRangeFrom25To34: ActivatedUserAgeRange;
  ageRangeFrom35To44: ActivatedUserAgeRange;
  totalFemaleAmount: Scalars['Int']['output'];
  totalFemaleAmountPercentage: Scalars['Float']['output'];
  totalMaleAmount: Scalars['Int']['output'];
  totalMaleAmountPercentage: Scalars['Float']['output'];
  totalOtherAmount: Scalars['Int']['output'];
  totalOtherAmountPercentage: Scalars['Float']['output'];
  totalUserAmount: Scalars['Int']['output'];
};

export type ActiveJobSummary = {
  __typename?: 'ActiveJobSummary';
  eventId?: Maybe<Scalars['UUID']['output']>;
  jobId: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: JobStatus;
  totalCount: Scalars['Int']['output'];
  type: ActiveJobType;
};

export enum ActiveJobType {
  Delete = 'DELETE',
  Import = 'IMPORT',
  Invite = 'INVITE',
  Message = 'MESSAGE'
}

export type ActiveRewardUserType = {
  __typename?: 'ActiveRewardUserType';
  rewardUserInfo?: Maybe<RewardUserInfoType>;
  userId: Scalars['UUID']['output'];
};

export type AddEventGuestRowArgsInput = {
  guest: EventGuestInfoArgsInput;
  ref: Scalars['String']['input'];
  tickets: Array<AddEventGuestTicketArgsInput>;
};

export type AddEventGuestTicketArgsInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  eventTicketId: Scalars['UUID']['input'];
  guestName?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type AddGuestQrPassArgsInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  sendEmail: Scalars['Boolean']['input'];
  sendText: Scalars['Boolean']['input'];
};

export type AddGuestsResult = {
  __typename?: 'AddGuestsResult';
  failedRefs: Array<Scalars['String']['output']>;
  sucessfulRefs: Array<Scalars['String']['output']>;
};

export type AdditionalGuestCatchUpState = {
  __typename?: 'AdditionalGuestCatchUpState';
  backlogChecked: Scalars['Boolean']['output'];
  lastRunUtc: Scalars['DateTime']['output'];
  reconciledEventIds: Array<Scalars['UUID']['output']>;
};

export type AdditionalGuestResetPreview = {
  __typename?: 'AdditionalGuestResetPreview';
  activeToExpire: Scalars['Int']['output'];
  batchSize: Scalars['Int']['output'];
  endedEventId: Scalars['UUID']['output'];
  nextEventId?: Maybe<Scalars['UUID']['output']>;
  sample: Array<AdditionalGuestTicketRow>;
  skippedAlreadyReplaced: Scalars['Int']['output'];
  skippedHolderHasNoPass: Scalars['Int']['output'];
  skippedNoNextEvent: Scalars['Int']['output'];
  wouldGrant: Scalars['Int']['output'];
};

export type AdditionalGuestRestampResult = {
  __typename?: 'AdditionalGuestRestampResult';
  currentEventId?: Maybe<Scalars['UUID']['output']>;
  dryRun: Scalars['Boolean']['output'];
  eventTicketId: Scalars['UUID']['output'];
  skipped: Scalars['Int']['output'];
  stamped: Scalars['Int']['output'];
};

export type AdditionalGuestScanRecord = {
  __typename?: 'AdditionalGuestScanRecord';
  scanCount: Scalars['Int']['output'];
  scanTimes: Array<Scalars['DateTime']['output']>;
  zoneId: Scalars['UUID']['output'];
  zoneName?: Maybe<Scalars['String']['output']>;
};

export type AdditionalGuestTicketRow = {
  __typename?: 'AdditionalGuestTicketRow';
  displayEventTicketId?: Maybe<Scalars['UUID']['output']>;
  eventTicketId?: Maybe<Scalars['UUID']['output']>;
  expiredAtUtc?: Maybe<Scalars['DateTime']['output']>;
  firstSeenUtc?: Maybe<Scalars['DateTime']['output']>;
  isExpired: Scalars['Boolean']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerUserId: Scalars['UUID']['output'];
  parentTicketId?: Maybe<Scalars['UUID']['output']>;
  replacementExists: Scalars['Boolean']['output'];
  replacementTicketId: Scalars['UUID']['output'];
  resetHolderName?: Maybe<Scalars['String']['output']>;
  resetHolderUserId?: Maybe<Scalars['UUID']['output']>;
  scanCount: Scalars['Int']['output'];
  statusFlags: Array<Scalars['String']['output']>;
  ticketId: Scalars['UUID']['output'];
  ticketKind?: Maybe<TicketType>;
  ticketTypeName?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['UUID']['output']>;
  validForEventId?: Maybe<Scalars['UUID']['output']>;
};

export type AdditionalGuestTicketTypeInfo = {
  __typename?: 'AdditionalGuestTicketTypeInfo';
  additionalGuests: Scalars['Int']['output'];
  eventTicketId: Scalars['UUID']['output'];
  isShareable: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  resetAdditionalGuestsAfterEachEvent: Scalars['Boolean']['output'];
};

export type AdditionalGuestTrail = {
  __typename?: 'AdditionalGuestTrail';
  ownerAttendeeState?: Maybe<EventAttendeeState>;
  replacedTicket?: Maybe<AdditionalGuestTicketRow>;
  replacementTicket?: Maybe<AdditionalGuestTicketRow>;
  sameCycle: Array<AdditionalGuestTicketRow>;
  scans: Array<AdditionalGuestScanRecord>;
  ticket: AdditionalGuestTicketRow;
  ticketType?: Maybe<AdditionalGuestTicketTypeInfo>;
};

export type AddressDetails = {
  __typename?: 'AddressDetails';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
};

export type AddressDetailsPayloadInput = {
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type AddressModel = {
  __typename?: 'AddressModel';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type AddressModelInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  locationName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type AdminAcceptInviteResult = {
  __typename?: 'AdminAcceptInviteResult';
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminAchievement = {
  __typename?: 'AdminAchievement';
  delete?: Maybe<Achievement>;
  fullAchievement?: Maybe<Achievement>;
  listUsers?: Maybe<UserGrainPageX>;
  recover?: Maybe<Achievement>;
  removeAllUsers: Scalars['Boolean']['output'];
  setBio: Achievement;
  setDisplayName: Achievement;
  setSlug: Achievement;
  setStatus: Achievement;
};


export type AdminAchievementListUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminAchievementSetBioArgs = {
  bio: Scalars['String']['input'];
};


export type AdminAchievementSetDisplayNameArgs = {
  name: Scalars['String']['input'];
};


export type AdminAchievementSetSlugArgs = {
  slug: Scalars['String']['input'];
};


export type AdminAchievementSetStatusArgs = {
  status: AchievementStatus;
};

export type AdminAchievementFilterInput = {
  and?: InputMaybe<Array<AdminAchievementFilterInput>>;
  or?: InputMaybe<Array<AdminAchievementFilterInput>>;
};

export type AdminApiClient = {
  __typename?: 'AdminApiClient';
  addUnsupportedVersion: Scalars['Boolean']['output'];
  check?: Maybe<SimpleApiClientSettings>;
  debug?: Maybe<ApiClientTestResult>;
  removeUnsupportedVersion: Scalars['Boolean']['output'];
  setMinimumVersion: Scalars['Boolean']['output'];
};


export type AdminApiClientAddUnsupportedVersionArgs = {
  clientId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type AdminApiClientCheckArgs = {
  clientId: Scalars['String']['input'];
};


export type AdminApiClientDebugArgs = {
  clientId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type AdminApiClientRemoveUnsupportedVersionArgs = {
  clientId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type AdminApiClientSetMinimumVersionArgs = {
  clientId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type AdminBlacklist = {
  __typename?: 'AdminBlacklist';
  add: Scalars['Boolean']['output'];
  check?: Maybe<BlacklistEntry>;
  remove: Scalars['Boolean']['output'];
};


export type AdminBlacklistAddArgs = {
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};


export type AdminBlacklistCheckArgs = {
  userId: Scalars['UUID']['input'];
};


export type AdminBlacklistRemoveArgs = {
  userId: Scalars['UUID']['input'];
};

export type AdminClub = {
  __typename?: 'AdminClub';
  addMember: Scalars['Boolean']['output'];
  clubId: Scalars['UUID']['output'];
  deleteClub: Scalars['Boolean']['output'];
  memberById: AdminClubMember;
  removeMember: Scalars['Boolean']['output'];
  setSlug: Scalars['Boolean']['output'];
  updateClub: UpdateClubResult;
};


export type AdminClubAddMemberArgs = {
  userId: Scalars['UUID']['input'];
};


export type AdminClubMemberByIdArgs = {
  memberId: Scalars['UUID']['input'];
};


export type AdminClubRemoveMemberArgs = {
  userId: Scalars['UUID']['input'];
};


export type AdminClubSetSlugArgs = {
  slug: Scalars['String']['input'];
};


export type AdminClubUpdateClubArgs = {
  payload: AdminUpdateClubPayloadInput;
};

export type AdminClubMember = {
  __typename?: 'AdminClubMember';
  addRole: Scalars['Boolean']['output'];
  addSpecialPermission: Scalars['Boolean']['output'];
  dumpPermissionState?: Maybe<Scalars['String']['output']>;
  listCombinedPermissions: Array<ClubPermissionId>;
  listRoles: Array<RoleId>;
  listUserClubRole: Array<ClubAndRole>;
  memberId: Scalars['UUID']['output'];
  removeRole: Scalars['Boolean']['output'];
  removeSpecialPermission: Scalars['Boolean']['output'];
  setRole: Scalars['Boolean']['output'];
  setTier: Scalars['Boolean']['output'];
};


export type AdminClubMemberAddRoleArgs = {
  roleId: Scalars['UUID']['input'];
};


export type AdminClubMemberAddSpecialPermissionArgs = {
  permission: ClubPermissionId;
};


export type AdminClubMemberRemoveRoleArgs = {
  roleId: Scalars['UUID']['input'];
};


export type AdminClubMemberRemoveSpecialPermissionArgs = {
  permission: ClubPermissionId;
};


export type AdminClubMemberSetRoleArgs = {
  roleId: Scalars['UUID']['input'];
};


export type AdminClubMemberSetTierArgs = {
  tier: Scalars['Int']['input'];
};

export type AdminCreateClubPayloadInput = {
  access?: InputMaybe<ClubAccess>;
  colors?: InputMaybe<ClubColorsInput>;
  description: Scalars['String']['input'];
  joinRequirements?: InputMaybe<ClubRequirementInput>;
  name: Scalars['String']['input'];
  ownerId: Scalars['UUID']['input'];
  tiers?: InputMaybe<Array<ClubTierPayloadInput>>;
  visibleRequirements?: InputMaybe<ClubRequirementInput>;
};

export type AdminCreateOfferPayloadInput = {
  access?: InputMaybe<ClubOfferAccess>;
  accessRequirements?: InputMaybe<ClubOfferRequirementInput>;
  clubId: Scalars['UUID']['input'];
  configuration?: InputMaybe<OfferConfigurationPayloadInput>;
  offerFlow?: InputMaybe<OfferFlowPayloadInput>;
  published?: InputMaybe<ClubOfferPublished>;
  rewards?: InputMaybe<Array<RewardOfferFlowPayloadInput>>;
  type: OfferType;
  visibilityRequirements?: InputMaybe<ClubOfferRequirementInput>;
};

export type AdminEvent = {
  __typename?: 'AdminEvent';
  /** Admin-approves a contest winner's attendee record, settling their pending contest/free-ticket booking. Reuses the host approval flow (grain ApproveAttendee + payment settlement). Admin-role gated at the mutation root, so no host/co-host permission check. Idempotent — a non-pending attendee is a no-op. */
  approveWinnerAttendee: AttendeeApprovalResponse;
  deleteEvent: Scalars['Boolean']['output'];
  /** Read-only: generate the top-N contest candidate list, ranked by verified-referral count (capped at 35) then the time each entrant reached that count. Returns contact info + fraud flags for staff to verify. Does not notify or change status. Contest events only. */
  generateContestWinners: Array<ContestWinner>;
  recoverEvent: Scalars['Boolean']['output'];
  /** Rebuilds this event's attendee search documents in place. Shares a single-run guard with reindexEventAttendees, so it returns false, and does nothing, while another attendee backfill is running. */
  reindexAttendees: Scalars['Boolean']['output'];
  /** Rebuilds this event's invitee search documents in place: deletes the event's current invitation documents and rewrites them from grain state, so an invitee no longer on the event does not leave a stale row. Runs detached with its own single-run guard (independent of reindexAttendees), so it returns false, and does nothing, while another invitee reindex is running. */
  reindexInvitees: Scalars['Boolean']['output'];
  /** Selects a verified contest entrant as a winner: flags them and sends the winner in-app notification + email + SMS. The optional emailMessage (HTML), entryPassContent (HTML), and smsMessage are the admin-authored copy; when omitted the default template copy is used. Idempotent. Contest events only. */
  selectContestWinner: Scalars['Boolean']['output'];
  setCoHost: Scalars['Boolean']['output'];
  /** Switch this event's payment processor. Validates the host's connected account for the target processor and soft-blocks when tickets were already sold under a different processor unless acknowledged. Affects future orders only; in-flight orders settle on their stamped processor. */
  setPaymentProcessor: Scalars['Boolean']['output'];
  setPaymentStrategy: Scalars['Boolean']['output'];
  /** Set a ticket type's fulfillment method (electronic, ship, or pickup). Admin override; determines whether a shipping address is collected at checkout and whether a scannable pass is issued. */
  setTicketFulfillmentMethod: Scalars['Boolean']['output'];
  /** Set a ticket type's product type (admission or merchandise), or clear it (null) to reset to the default. Admin override; the tax classification is derived from the product type. */
  setTicketProductType: Scalars['Boolean']['output'];
  syncAttendeesToContactList: Scalars['Boolean']['output'];
};


export type AdminEventApproveWinnerAttendeeArgs = {
  forceRelease?: Scalars['Boolean']['input'];
  userId: Scalars['UUID']['input'];
};


export type AdminEventGenerateContestWinnersArgs = {
  count: Scalars['Int']['input'];
};


export type AdminEventSelectContestWinnerArgs = {
  emailMessage?: InputMaybe<Scalars['String']['input']>;
  entryPassContent?: InputMaybe<Scalars['String']['input']>;
  smsMessage?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};


export type AdminEventSetCoHostArgs = {
  coHostId: Scalars['UUID']['input'];
  inviterId: Scalars['UUID']['input'];
};


export type AdminEventSetPaymentProcessorArgs = {
  acknowledgePriorSales?: Scalars['Boolean']['input'];
  processor: PaymentMethod;
};


export type AdminEventSetPaymentStrategyArgs = {
  strategy?: InputMaybe<PaymentSplitStrategyInput>;
};


export type AdminEventSetTicketFulfillmentMethodArgs = {
  eventTicketId: Scalars['UUID']['input'];
  method: FulfillmentMethod;
};


export type AdminEventSetTicketProductTypeArgs = {
  eventTicketId: Scalars['UUID']['input'];
  productType?: InputMaybe<ProductType>;
};

export enum AdminEventStatus {
  Active = 'ACTIVE',
  All = 'ALL',
  Ongoing = 'ONGOING',
  Past = 'PAST'
}

export type AdminMutationAdditionalGuests = {
  __typename?: 'AdminMutationAdditionalGuests';
  /** Runs the ended-event catch-up of a series now, ignoring its throttle and what it already handled. dryRun returns the overview only. */
  forceCatchUp: ForceCatchUpReport;
  /** Re-registers the end-of-event reminder of every member event of a series (seriesId) or of one member event (eventId). Returns each event's reminder before and, unless dryRun, after. */
  rearmReminders: RearmRemindersReport;
  /** Stamps a ticket type's unshared +1s for the current event, or only counts them on a dryRun. eventId is the series' parent or any member event. */
  restamp: RestampReport;
  /** Runs the +1 reset of an ended member event now, batch after batch for up to 60 seconds. dryRun returns the preview and changes nothing. moreRemain says whether another run is needed. */
  runReset: RunResetReport;
  /** QA only, not in production: moves a member event's end (and start) and re-arms its reminder, so the event can end in a few minutes. Not a dry run. The end must be at least 60 seconds ahead; without a startDate, a start after the new end moves back by the event's duration. */
  setSchedule: EventScheduleChange;
};


export type AdminMutationAdditionalGuestsForceCatchUpArgs = {
  dryRun?: Scalars['Boolean']['input'];
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  reason: Scalars['String']['input'];
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AdminMutationAdditionalGuestsRearmRemindersArgs = {
  dryRun?: Scalars['Boolean']['input'];
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  reason: Scalars['String']['input'];
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AdminMutationAdditionalGuestsRestampArgs = {
  dryRun?: Scalars['Boolean']['input'];
  eventId: Scalars['UUID']['input'];
  eventTicketId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


export type AdminMutationAdditionalGuestsRunResetArgs = {
  dryRun?: Scalars['Boolean']['input'];
  eventId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


export type AdminMutationAdditionalGuestsSetScheduleArgs = {
  endDate: Scalars['DateTime']['input'];
  eventId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminMutationApi = {
  __typename?: 'AdminMutationApi';
  achievementById: AdminAchievement;
  activateAllPieGrain: Scalars['Boolean']['output'];
  activateAllUserGrains: Scalars['Boolean']['output'];
  addContactByUserToUser: Scalars['Boolean']['output'];
  apiClient: AdminApiClient;
  backfillAllInstagramUsers: Scalars['Boolean']['output'];
  backfillDisclosureLedger: Scalars['Boolean']['output'];
  backfillFirstInstagramUser: Scalars['Boolean']['output'];
  blacklist: AdminBlacklist;
  bulkCreateEvents: Scalars['Boolean']['output'];
  clearGlobalListGrain: Scalars['Boolean']['output'];
  club: AdminMutationClub;
  copyContactsBetweenAccounts: ContactCopyJobResult;
  createPie: AdminPie;
  createShortLink: Scalars['URL']['output'];
  createUser: AdminUser;
  deleteContactsByCreatedDate: ContactBulkDeleteJobResult;
  event: AdminMutationEvent;
  eventById: AdminEvent;
  eventBySlugOrId: AdminEvent;
  eventSeries: AdminMutationEventSeries;
  externalApplication: AdminMutationExternalApplication;
  fetchAllTransactionsForMigration: Scalars['Boolean']['output'];
  forEachAchievement: Array<FilteredAchievement>;
  forEachPie: Array<FilteredPie>;
  forEachReward: Array<FilteredReward>;
  forEachUser: Array<FilteredUser>;
  getCopyContactsStatus?: Maybe<ContactCopyStatusModel>;
  migrateAchievementTotalUnlockUsers: Scalars['Boolean']['output'];
  migratePayoutBalance: Scalars['Boolean']['output'];
  migratePayoutMetricsFromRequests: Scalars['Boolean']['output'];
  migratePayoutTransactions: Scalars['Boolean']['output'];
  migrateRewardTotalActiveUsers: Scalars['Boolean']['output'];
  migrateRewardTotalUnlockUsers: Scalars['Boolean']['output'];
  overridePiePricePerSlice: Amount;
  passedWaitingListUser: Scalars['Boolean']['output'];
  pieById: AdminPie;
  pieBySlug: AdminPie;
  /** Rebuilds event attendee search documents in place, in the live index (no alias swap). Omit eventIds to rebuild every event, or only the member events of every series with seriesMemberEventsOnly; an empty list rebuilds none. seriesSlugOrId rebuilds the member events of that one series instead of eventIds. Runs in the background; progress is in the logs. Returns false, and does nothing, if a run is already in progress. */
  reindexEventAttendees: Scalars['Boolean']['output'];
  reindexSearchEngine: Scalars['Boolean']['output'];
  releaseEventTicketWaitingList: Scalars['Int']['output'];
  /** Links every contact that has no user to the account its email or verified phone belongs to, across all contact lists, so the Contacts ticket-type filter can find them. Runs in the background; the totals are in the logs. Returns false, and does nothing, if a run is already in progress. */
  relinkContactsToUsers: Scalars['Boolean']['output'];
  /** Approve or decline a create-event access request. Approving flips the user's corresponding creation toggle. */
  resolveCreateEventRequest: Scalars['Boolean']['output'];
  restoreDB: Scalars['Boolean']['output'];
  rewardById: AdminReward;
  rewardBySlug: AdminReward;
  setProfileCompletionRequired: ProfileCompletionToggleResult;
  syncLegacyGlobalGrainList: Scalars['Boolean']['output'];
  syncRepBetsPieSlices: Scalars['Boolean']['output'];
  ticket: AdminTicket;
  /** Transfer event ownership to another user. Admin only. */
  transferEventOwnership: Scalars['Boolean']['output'];
  updatePayoutRequestStatus: Scalars['Boolean']['output'];
  userByEmail: AdminUser;
  userById: AdminUser;
  userByUserName: AdminUser;
};


export type AdminMutationApiAchievementByIdArgs = {
  achievementId: Scalars['UUID']['input'];
};


export type AdminMutationApiAddContactByUserToUserArgs = {
  contactUserIds: Array<Scalars['UUID']['input']>;
  toUserId: Scalars['UUID']['input'];
};


export type AdminMutationApiBackfillDisclosureLedgerArgs = {
  dryRun?: Scalars['Boolean']['input'];
  eventIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  firstEvents?: InputMaybe<Scalars['Int']['input']>;
  honorIdenticalReupload?: Scalars['Boolean']['input'];
  phase?: DisclosureBackfillPhase;
};


export type AdminMutationApiBulkCreateEventsArgs = {
  attendeeCount: Scalars['Int']['input'];
  avatarUrl: Scalars['String']['input'];
  baseDisplayName: Scalars['String']['input'];
  baseSlug: Scalars['String']['input'];
  coHostEmails: Array<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
  creatorEmail: Scalars['String']['input'];
  delayCreateUserMs?: Scalars['Int']['input'];
  delayTicketPurchaseMs?: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  eventTimeZoneId?: InputMaybe<Scalars['String']['input']>;
  eventType?: EventType;
  exclusiveAvatarUrl?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  promoterEmails: Array<Scalars['String']['input']>;
  requireApproval?: Scalars['Boolean']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type AdminMutationApiCopyContactsBetweenAccountsArgs = {
  groupName?: InputMaybe<Scalars['String']['input']>;
  sourceUserId: Scalars['UUID']['input'];
  targetUserId: Scalars['UUID']['input'];
};


export type AdminMutationApiCreatePieArgs = {
  ownerId: Scalars['UUID']['input'];
  pieArgs: PieArgsInput;
};


export type AdminMutationApiCreateShortLinkArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type AdminMutationApiCreateUserArgs = {
  authArgs: AuthenticationArgsInput;
  profileArgs: ProfileArgsInput;
};


export type AdminMutationApiDeleteContactsByCreatedDateArgs = {
  range: ContactCreatedDateRangeInput;
  userId: Scalars['UUID']['input'];
};


export type AdminMutationApiEventByIdArgs = {
  eventId: Scalars['UUID']['input'];
};


export type AdminMutationApiEventBySlugOrIdArgs = {
  slugOrId: Scalars['String']['input'];
};


export type AdminMutationApiFetchAllTransactionsForMigrationArgs = {
  batchSize?: Scalars['Int']['input'];
};


export type AdminMutationApiForEachAchievementArgs = {
  where?: InputMaybe<FilteredAchievementFilterInput>;
};


export type AdminMutationApiForEachPieArgs = {
  where?: InputMaybe<FilteredPieFilterInput>;
};


export type AdminMutationApiForEachRewardArgs = {
  where?: InputMaybe<FilteredRewardFilterInput>;
};


export type AdminMutationApiForEachUserArgs = {
  where?: InputMaybe<FilteredUserFilterInput>;
};


export type AdminMutationApiGetCopyContactsStatusArgs = {
  jobId: Scalars['String']['input'];
  targetUserId: Scalars['UUID']['input'];
};


export type AdminMutationApiMigrateAchievementTotalUnlockUsersArgs = {
  skippedUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type AdminMutationApiMigratePayoutBalanceArgs = {
  batchSize?: Scalars['Int']['input'];
};


export type AdminMutationApiMigratePayoutMetricsFromRequestsArgs = {
  batchSize?: Scalars['Int']['input'];
};


export type AdminMutationApiMigrateRewardTotalActiveUsersArgs = {
  skippedUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type AdminMutationApiMigrateRewardTotalUnlockUsersArgs = {
  skippedUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type AdminMutationApiOverridePiePricePerSliceArgs = {
  pieId: Scalars['UUID']['input'];
  pricePerSlice: AmountInput;
};


export type AdminMutationApiPassedWaitingListUserArgs = {
  userId: Scalars['UUID']['input'];
};


export type AdminMutationApiPieByIdArgs = {
  pieId: Scalars['UUID']['input'];
};


export type AdminMutationApiPieBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type AdminMutationApiReindexEventAttendeesArgs = {
  eventIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  seriesMemberEventsOnly?: Scalars['Boolean']['input'];
  seriesSlugOrId?: InputMaybe<Scalars['String']['input']>;
};


export type AdminMutationApiReindexSearchEngineArgs = {
  forceBootstrap?: Scalars['Boolean']['input'];
  keepOldIndices?: Scalars['Boolean']['input'];
  specificIndices?: InputMaybe<Array<OpenSearchIndex>>;
};


export type AdminMutationApiReleaseEventTicketWaitingListArgs = {
  eventId: Scalars['UUID']['input'];
  eventTicketId: Scalars['UUID']['input'];
};


export type AdminMutationApiResolveCreateEventRequestArgs = {
  approve: Scalars['Boolean']['input'];
  requestId: Scalars['UUID']['input'];
};


export type AdminMutationApiRewardByIdArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type AdminMutationApiRewardBySlugArgs = {
  pie: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type AdminMutationApiSetProfileCompletionRequiredArgs = {
  required: Scalars['Boolean']['input'];
  userIds: Array<Scalars['UUID']['input']>;
};


export type AdminMutationApiSyncLegacyGlobalGrainListArgs = {
  aliasArgs?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type AdminMutationApiSyncRepBetsPieSlicesArgs = {
  skippedUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type AdminMutationApiTransferEventOwnershipArgs = {
  eventId: Scalars['UUID']['input'];
  newOwnerUserId: Scalars['UUID']['input'];
};


export type AdminMutationApiUpdatePayoutRequestStatusArgs = {
  paid: Scalars['Boolean']['input'];
  requestId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type AdminMutationApiUserByEmailArgs = {
  emailAddress: Scalars['String']['input'];
};


export type AdminMutationApiUserByIdArgs = {
  userId: Scalars['UUID']['input'];
};


export type AdminMutationApiUserByUserNameArgs = {
  userName: Scalars['String']['input'];
};

export type AdminMutationClub = {
  __typename?: 'AdminMutationClub';
  byId?: Maybe<AdminClub>;
  createClub: CreateClubResult;
  createRole: CreateUpdateClubRoleResult;
  deleteRole: Scalars['Boolean']['output'];
  migrateDefaultClubRoles: Scalars['Boolean']['output'];
  migrateUserClubRoleCatalog: Scalars['Boolean']['output'];
  migrateUserClubRolesPermissions: Scalars['Boolean']['output'];
  offer: AdminMutationClubOffer;
  updateRole: CreateUpdateClubRoleResult;
};


export type AdminMutationClubByIdArgs = {
  clubId: Scalars['UUID']['input'];
};


export type AdminMutationClubCreateClubArgs = {
  payload: AdminCreateClubPayloadInput;
};


export type AdminMutationClubCreateRoleArgs = {
  payload: CreateClubRolePayloadInput;
};


export type AdminMutationClubDeleteRoleArgs = {
  roleId: Scalars['UUID']['input'];
};


export type AdminMutationClubUpdateRoleArgs = {
  payload: UpdateClubRolePayloadInput;
};

export type AdminMutationClubOffer = {
  __typename?: 'AdminMutationClubOffer';
  createOffer: CreateOfferResult;
  updateOffer: Scalars['Boolean']['output'];
};


export type AdminMutationClubOfferCreateOfferArgs = {
  payload: AdminCreateOfferPayloadInput;
};


export type AdminMutationClubOfferUpdateOfferArgs = {
  payload: AdminUpdateOfferPayloadInput;
};

export type AdminMutationEvent = {
  __typename?: 'AdminMutationEvent';
  additionalGuests: AdminMutationAdditionalGuests;
};

export type AdminMutationEventSeries = {
  __typename?: 'AdminMutationEventSeries';
  createRole: CreateUpdateEventSeriesRoleResult;
  deleteRole: Scalars['Boolean']['output'];
  /** Seed (idempotently) the built-in series roles mirroring the event roles (Door, Coordinator, Promoter, Co-Host, Sponsor, Talent). Co-Host and Coordinator also receive full series-management permissions. */
  seedDefaultRoles: Scalars['Boolean']['output'];
  updateRole: CreateUpdateEventSeriesRoleResult;
};


export type AdminMutationEventSeriesCreateRoleArgs = {
  payload: CreateEventSeriesRolePayloadInput;
};


export type AdminMutationEventSeriesDeleteRoleArgs = {
  roleId: Scalars['UUID']['input'];
};


export type AdminMutationEventSeriesUpdateRoleArgs = {
  payload: UpdateEventSeriesRolePayloadInput;
};

export type AdminMutationExternalApplication = {
  __typename?: 'AdminMutationExternalApplication';
  connect?: Maybe<PartnerConnectionModel>;
  delete: Scalars['Boolean']['output'];
  disable?: Maybe<ExternalApplication>;
  disableConnection?: Maybe<PartnerConnectionModel>;
  enable?: Maybe<ExternalApplication>;
  enableConnection?: Maybe<PartnerConnectionModel>;
  generateToken?: Maybe<ExternalApplication>;
  removeToken?: Maybe<ExternalApplication>;
  setConnectionPermissions?: Maybe<PartnerConnectionModel>;
  setConsentDetails?: Maybe<ExternalApplication>;
  setRedirectUris?: Maybe<ExternalApplication>;
  unlinkConnection?: Maybe<PartnerConnectionModel>;
  upsert?: Maybe<ExternalApplication>;
};


export type AdminMutationExternalApplicationConnectArgs = {
  accountId: Scalars['UUID']['input'];
  externalApplicationId: Scalars['UUID']['input'];
  permissions: Array<Scalars['String']['input']>;
};


export type AdminMutationExternalApplicationDeleteArgs = {
  externalApplicationId: Scalars['UUID']['input'];
};


export type AdminMutationExternalApplicationDisableArgs = {
  externalApplicationId: Scalars['UUID']['input'];
};


export type AdminMutationExternalApplicationDisableConnectionArgs = {
  accountId: Scalars['UUID']['input'];
  externalApplicationId: Scalars['UUID']['input'];
};


export type AdminMutationExternalApplicationEnableArgs = {
  externalApplicationId: Scalars['UUID']['input'];
};


export type AdminMutationExternalApplicationEnableConnectionArgs = {
  accountId: Scalars['UUID']['input'];
  externalApplicationId: Scalars['UUID']['input'];
};


export type AdminMutationExternalApplicationGenerateTokenArgs = {
  args: ExternalApplicationTokenArgsInput;
  externalApplicationId: Scalars['UUID']['input'];
};


export type AdminMutationExternalApplicationRemoveTokenArgs = {
  externalApplicationId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
};


export type AdminMutationExternalApplicationSetConnectionPermissionsArgs = {
  accountId: Scalars['UUID']['input'];
  externalApplicationId: Scalars['UUID']['input'];
  permissions: Array<Scalars['String']['input']>;
};


export type AdminMutationExternalApplicationSetConsentDetailsArgs = {
  dataUseStatement?: InputMaybe<Scalars['String']['input']>;
  externalApplicationId: Scalars['UUID']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
};


export type AdminMutationExternalApplicationSetRedirectUrisArgs = {
  externalApplicationId: Scalars['UUID']['input'];
  redirectUris: Array<Scalars['String']['input']>;
};


export type AdminMutationExternalApplicationUnlinkConnectionArgs = {
  accountId: Scalars['UUID']['input'];
  externalApplicationId: Scalars['UUID']['input'];
};


export type AdminMutationExternalApplicationUpsertArgs = {
  args: ExternalApplicationArgsInput;
  externalApplicationId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AdminPie = {
  __typename?: 'AdminPie';
  completeUploadAvatar: Scalars['Boolean']['output'];
  delete?: Maybe<CompletePieWithBalance>;
  fullPie?: Maybe<CompletePieWithBalance>;
  presignUploadAvatarUrl: Scalars['String']['output'];
  recover?: Maybe<CompletePieWithBalance>;
  removeAvatar?: Maybe<CompletePieWithBalance>;
  replaceSocialMedia?: Maybe<CompletePieWithBalance>;
  reward: AdminReward;
  setBio?: Maybe<CompletePieWithBalance>;
  setCreateDate?: Maybe<CompletePieWithBalance>;
  setCreatedBy?: Maybe<CompletePieWithBalance>;
  setDisabled?: Maybe<CompletePieWithBalance>;
  setDisplayName?: Maybe<CompletePieWithBalance>;
  setMaxSlices?: Maybe<CompletePieWithBalance>;
  setSlug?: Maybe<CompletePieWithBalance>;
  setVisible?: Maybe<CompletePieWithBalance>;
  updateSlices?: Maybe<CompletePieWithBalance>;
};


export type AdminPieCompleteUploadAvatarArgs = {
  avatarUrl: Scalars['String']['input'];
};


export type AdminPiePresignUploadAvatarUrlArgs = {
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
};


export type AdminPieReplaceSocialMediaArgs = {
  socialMedia: Array<SocialMediaPairInput>;
};


export type AdminPieRewardArgs = {
  reward: Scalars['String']['input'];
};


export type AdminPieSetBioArgs = {
  bio: Scalars['String']['input'];
};


export type AdminPieSetCreateDateArgs = {
  date: Scalars['DateTime']['input'];
};


export type AdminPieSetCreatedByArgs = {
  user: Scalars['String']['input'];
};


export type AdminPieSetDisabledArgs = {
  disabled?: Scalars['Boolean']['input'];
};


export type AdminPieSetDisplayNameArgs = {
  name: Scalars['String']['input'];
};


export type AdminPieSetMaxSlicesArgs = {
  maxSlices: Scalars['Decimal']['input'];
};


export type AdminPieSetSlugArgs = {
  slug: Scalars['String']['input'];
};


export type AdminPieSetVisibleArgs = {
  visible?: Scalars['Boolean']['input'];
};


export type AdminPieUpdateSlicesArgs = {
  slices: PieUpdateSlicesArgsInput;
};

export type AdminPieFilterInput = {
  and?: InputMaybe<Array<AdminPieFilterInput>>;
  or?: InputMaybe<Array<AdminPieFilterInput>>;
};

export type AdminQueryAchievement = {
  __typename?: 'AdminQueryAchievement';
  listCreatedAchievements?: Maybe<AchievementOffsetPage>;
  search?: Maybe<AchievementOffsetPage>;
  slugAvailable: AvailableCheckingResult;
};


export type AdminQueryAchievementListCreatedAchievementsArgs = {
  limit?: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  offset?: Scalars['Int']['input'];
  sortingOrder?: PageSortOrder;
  sortingType?: AchievementSortType;
  status?: AchievementStatus;
  userId: Scalars['UUID']['input'];
};


export type AdminQueryAchievementSearchArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type AdminQueryAchievementSlugAvailableArgs = {
  ownerId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
};

export type AdminQueryAdditionalGuests = {
  __typename?: 'AdminQueryAdditionalGuests';
  /** A user's attendee state, their own passes on the series' parent event, and the +1s they own or originally held and shared. eventId is the series' parent or any member event. Name the user by exactly one of userId, email or userName (the account's username, for example Khang2Tran: no spaces, not the display name). */
  holder: HolderAdditionalGuests;
  /** A member event's end-of-event reminder: what the event says it should have next to what is registered, and the server's clock. */
  memberEventReminder: EndedReminderInfo;
  /** What resetting an ended member event would do: +1s to expire, fresh +1s to grant, and why the rest are skipped. Changes nothing. */
  resetPreview: AdditionalGuestResetPreview;
  /** Per member event: live, expired and transferred +1 counts, pending resets and reminder state, plus the ticket types, the event a +1 handed out now is good for, and the catch-up state. Give the series id, or an event id (the series' parent or any member event). */
  seriesOverview: SeriesAdditionalGuestOverview;
  /** One +1 ticket with the tickets of its cycle, the ticket it replaced and the one that replaced it, its scans and its owner's attendee state. eventId is the series' parent or any member event; ticketId is the id the app shows or a raw UUID. Null when the ticket does not exist. */
  ticketTrail?: Maybe<AdditionalGuestTrail>;
};


export type AdminQueryAdditionalGuestsHolderArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type AdminQueryAdditionalGuestsMemberEventReminderArgs = {
  eventId: Scalars['UUID']['input'];
};


export type AdminQueryAdditionalGuestsResetPreviewArgs = {
  eventId: Scalars['UUID']['input'];
};


export type AdminQueryAdditionalGuestsSeriesOverviewArgs = {
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AdminQueryAdditionalGuestsTicketTrailArgs = {
  eventId: Scalars['UUID']['input'];
  ticketId: Scalars['String']['input'];
};

export type AdminQueryApi = {
  __typename?: 'AdminQueryApi';
  achievement: AdminQueryAchievement;
  club: AdminQueryClub;
  contactList: AdminQueryContactList;
  event: AdminQueryEvent;
  eventBookingByTransactionId: EventAttendeesBookingInfo;
  eventSeries: AdminQueryEventSeries;
  externalApplication: AdminQueryExternalApplication;
  /** PLACEHOLDER: List transactions e.g deposit, payout, withdraw... */
  listAllTransactions?: Maybe<TradingTransactionOffsetPage>;
  listCreateEventRequests?: Maybe<Array<CreateEventRequestAdmin>>;
  listEventPolicyReactions: Array<EventPolicyReactionModel>;
  listPayoutRequests: Array<PayoutRequestAdmin>;
  listPayoutTransactions: Array<PayoutTransactionState>;
  listPieWaitingList?: Maybe<ListPieWaitingListConnection>;
  listUsers?: Maybe<ListUsersConnection>;
  migrateOldSharedUserTickets: Array<MigrateOldSharedUserTickets>;
  offer: AdminQueryClubOffer;
  pie: AdminQueryPie;
  reward: AdminQueryReward;
  transactionById: PublicTradingTransactionModel;
  user: AdminQueryUser;
};


export type AdminQueryApiEventBookingByTransactionIdArgs = {
  eventId: Scalars['UUID']['input'];
  transactionId: Scalars['UUID']['input'];
};


export type AdminQueryApiListAllTransactionsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  pieId?: InputMaybe<Scalars['UUID']['input']>;
  pieName?: InputMaybe<Scalars['String']['input']>;
  transactionStatus?: TransactionStatus;
  transactionType?: InputMaybe<TransactionType>;
};


export type AdminQueryApiListCreateEventRequestsArgs = {
  status?: InputMaybe<CreateEventRequestStatus>;
};


export type AdminQueryApiListEventPolicyReactionsArgs = {
  eventId: Scalars['UUID']['input'];
};


export type AdminQueryApiListPayoutRequestsArgs = {
  userId: Scalars['UUID']['input'];
};


export type AdminQueryApiListPayoutTransactionsArgs = {
  userId: Scalars['UUID']['input'];
};


export type AdminQueryApiListPieWaitingListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryApiListUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminQueryApiMigrateOldSharedUserTicketsArgs = {
  ticketStatus: TicketStatus;
};


export type AdminQueryApiTransactionByIdArgs = {
  transactionId: Scalars['UUID']['input'];
};

export type AdminQueryClub = {
  __typename?: 'AdminQueryClub';
  byId?: Maybe<ClubState>;
  count: Scalars['Long']['output'];
  permissions: Array<ClubPermissionId>;
  roleById?: Maybe<ClubRolePermissionState>;
  roles?: Maybe<Array<ClubRolePermissionState>>;
  search?: Maybe<ClubStateOffsetPage>;
};


export type AdminQueryClubByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AdminQueryClubCountArgs = {
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AdminQueryClubRoleByIdArgs = {
  roleId: Scalars['UUID']['input'];
};


export type AdminQueryClubSearchArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

export type AdminQueryClubOffer = {
  __typename?: 'AdminQueryClubOffer';
  byId?: Maybe<ClubOfferState>;
  /** Get offers belonging to a specific user's clubs. Admin-only. */
  byUser?: Maybe<UserOffersConnection>;
  search?: Maybe<PublicClubOfferStateOffsetPage>;
};


export type AdminQueryClubOfferByIdArgs = {
  clubId: Scalars['UUID']['input'];
  offerId: Scalars['UUID']['input'];
};


export type AdminQueryClubOfferByUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['UUID']['input'];
};


export type AdminQueryClubOfferSearchArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

export type AdminQueryContactList = {
  __typename?: 'AdminQueryContactList';
  cities?: Maybe<Array<Maybe<ContactCountryCity>>>;
  contacts?: Maybe<ContactsConnection>;
  contactsByCreatedDate?: Maybe<ContactModelOffsetPage>;
  groups?: Maybe<GroupsConnection>;
};


export type AdminQueryContactListCitiesArgs = {
  userId: Scalars['UUID']['input'];
};


export type AdminQueryContactListContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  filterArgs: ContactPageFilterArgsInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['UUID']['input'];
};


export type AdminQueryContactListContactsByCreatedDateArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  range: ContactCreatedDateRangeInput;
  userId: Scalars['UUID']['input'];
};


export type AdminQueryContactListGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['UUID']['input'];
};

export type AdminQueryEvent = {
  __typename?: 'AdminQueryEvent';
  additionalGuests: AdminQueryAdditionalGuests;
  byId?: Maybe<FullEvent>;
  /** Get events created by a specific user. Admin-only. */
  byUser?: Maybe<ByUserConnection>;
  /** Admin read for a contest event: the count of real entrants (drives the generate-count max) and the winners already selected, with contact info. */
  contestWinnerOverview: ContestWinnerOverview;
  /** Admin read for the Notify Winner dialog: the tickets a winner holds in this event, each with its display type and status (Pending / Approved / Declined / CheckedIn). Status is the winner's attendee approval state, except a scanned ticket reads as CheckedIn. */
  contestWinnerTickets: Array<ContestWinnerTicket>;
  count: Scalars['Long']['output'];
  search?: Maybe<FullEventOffsetPage>;
  searchPayoutRequests?: Maybe<PayoutRequestStateOffsetPage>;
};


export type AdminQueryEventByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AdminQueryEventByUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['UUID']['input'];
};


export type AdminQueryEventContestWinnerOverviewArgs = {
  eventId: Scalars['UUID']['input'];
};


export type AdminQueryEventContestWinnerTicketsArgs = {
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type AdminQueryEventCountArgs = {
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isListed?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AdminEventStatus>;
};


export type AdminQueryEventSearchArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  status?: AdminEventStatus;
};


export type AdminQueryEventSearchPayoutRequestsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AdminQueryEventSeries = {
  __typename?: 'AdminQueryEventSeries';
  /** The permission catalog as a parent-child tree for the role editor UI. Grouping is presentational only; each permission is still stored and enforced independently. */
  permissionTree: Array<EventSeriesPermissionNode>;
  permissions: Array<EventSeriesPermissionId>;
  roleById?: Maybe<EventSeriesRolePermissionState>;
  roles?: Maybe<Array<EventSeriesRolePermissionState>>;
};


export type AdminQueryEventSeriesRoleByIdArgs = {
  roleId: Scalars['UUID']['input'];
};

export type AdminQueryExternalApplication = {
  __typename?: 'AdminQueryExternalApplication';
  byId?: Maybe<ExternalApplication>;
  list?: Maybe<ExternalApplicationPageX>;
};


export type AdminQueryExternalApplicationByIdArgs = {
  externalApplicationId: Scalars['UUID']['input'];
};


export type AdminQueryExternalApplicationListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type AdminQueryPie = {
  __typename?: 'AdminQueryPie';
  byId?: Maybe<CompletePieWithBalance>;
  search?: Maybe<PieOffsetPage>;
};


export type AdminQueryPieByIdArgs = {
  pieId: Scalars['UUID']['input'];
};


export type AdminQueryPieSearchArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

export type AdminQueryReward = {
  __typename?: 'AdminQueryReward';
  byId?: Maybe<FullReward>;
  search?: Maybe<RewardOffsetPage>;
};


export type AdminQueryRewardByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AdminQueryRewardSearchArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

export type AdminQueryUser = {
  __typename?: 'AdminQueryUser';
  byId?: Maybe<CompleteAdminUserType>;
  count: Scalars['Long']['output'];
  search?: Maybe<AdminUserOffsetPage>;
};


export type AdminQueryUserByIdArgs = {
  userId: Scalars['UUID']['input'];
};


export type AdminQueryUserCountArgs = {
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdminQueryUserSearchArgs = {
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

export type AdminReward = {
  __typename?: 'AdminReward';
  delete?: Maybe<FullReward>;
  fullReward?: Maybe<FullReward>;
  migrateToEvent?: Maybe<FullEvent>;
  recover?: Maybe<FullReward>;
  removeAllUsers?: Maybe<FullReward>;
  removeUser?: Maybe<FullReward>;
  setCreatedDate?: Maybe<FullReward>;
  setEndDate?: Maybe<FullReward>;
  setExpireDate?: Maybe<FullReward>;
  setPrivate?: Maybe<FullReward>;
  setSlug?: Maybe<FullReward>;
  setStartDate?: Maybe<FullReward>;
};


export type AdminRewardMigrateToEventArgs = {
  newOwnerId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AdminRewardRemoveUserArgs = {
  user: Scalars['String']['input'];
};


export type AdminRewardSetCreatedDateArgs = {
  date: Scalars['DateTime']['input'];
};


export type AdminRewardSetEndDateArgs = {
  date: Scalars['DateTime']['input'];
};


export type AdminRewardSetExpireDateArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AdminRewardSetPrivateArgs = {
  private?: Scalars['Boolean']['input'];
};


export type AdminRewardSetSlugArgs = {
  slug: Scalars['String']['input'];
};


export type AdminRewardSetStartDateArgs = {
  date: Scalars['DateTime']['input'];
};

export type AdminRewardFilterInput = {
  and?: InputMaybe<Array<AdminRewardFilterInput>>;
  or?: InputMaybe<Array<AdminRewardFilterInput>>;
};

export type AdminTicket = {
  __typename?: 'AdminTicket';
  createDeviceInvitation: DeviceInvitation;
  createEvent: Scalars['Boolean']['output'];
  createTicket: CreatedTicket;
  findEvent?: Maybe<AdminTicketEventInfo>;
  listInvitedDevices: Array<EventDevice>;
  listTicketScans: Array<ScanEvent>;
  listTickets: Array<TicketInformation>;
  /** This creates an unauthenticated scan event */
  registerScanEvent?: Maybe<TicketInformationWithScans>;
  revokeDeviceInvitation: Scalars['Boolean']['output'];
  /** This undoes an unauthenticated scan event */
  undoRegisterScanEvent?: Maybe<TicketInformationWithScans>;
  updateTicket?: Maybe<TicketInformationWithScans>;
};


export type AdminTicketCreateDeviceInvitationArgs = {
  eventId: Scalars['UUID']['input'];
  notAfter: Scalars['DateTime']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  zoneId: Scalars['UUID']['input'];
};


export type AdminTicketCreateEventArgs = {
  endAt: Scalars['DateTime']['input'];
  eventId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  startAt: Scalars['DateTime']['input'];
  ticketTypes: Array<CreateEventTicketTypeInput>;
  zones: Array<CreateEventZoneInput>;
};


export type AdminTicketCreateTicketArgs = {
  eventId: Scalars['UUID']['input'];
  extras?: Scalars['Int']['input'];
  metadata?: InputMaybe<Scalars['Any']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ticketId?: InputMaybe<Scalars['UUID']['input']>;
  ticketTypeId: Scalars['UUID']['input'];
};


export type AdminTicketFindEventArgs = {
  eventId: Scalars['UUID']['input'];
};


export type AdminTicketListInvitedDevicesArgs = {
  eventId: Scalars['UUID']['input'];
};


export type AdminTicketListTicketScansArgs = {
  ticketId: Scalars['UUID']['input'];
};


export type AdminTicketListTicketsArgs = {
  eventId: Scalars['UUID']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AdminTicketRegisterScanEventArgs = {
  deviceId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  scanId: Scalars['String']['input'];
  scannedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ticketId: Scalars['UUID']['input'];
  zoneId: Scalars['UUID']['input'];
};


export type AdminTicketRevokeDeviceInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type AdminTicketUndoRegisterScanEventArgs = {
  deviceId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  scanId: Scalars['String']['input'];
  ticketId: Scalars['UUID']['input'];
  zoneId: Scalars['UUID']['input'];
};


export type AdminTicketUpdateTicketArgs = {
  eventId: Scalars['UUID']['input'];
  extras?: Scalars['Int']['input'];
  metadata?: InputMaybe<Scalars['Any']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ticketId: Scalars['UUID']['input'];
  ticketTypeId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AdminTicketEventInfo = {
  __typename?: 'AdminTicketEventInfo';
  endAt: Scalars['DateTime']['output'];
  eventId: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  startAt: Scalars['DateTime']['output'];
  ticketTypes: Array<AdminTicketEventTicketTypeInfo>;
  zones: Array<AdminTicketEventZoneInfo>;
};

export type AdminTicketEventTicketTypeInfo = {
  __typename?: 'AdminTicketEventTicketTypeInfo';
  name: Scalars['String']['output'];
  ticketTypeId: Scalars['UUID']['output'];
  validZoneIds: Array<Scalars['UUID']['output']>;
};

export type AdminTicketEventZoneInfo = {
  __typename?: 'AdminTicketEventZoneInfo';
  maxCapacity?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  zoneId: Scalars['UUID']['output'];
};

export type AdminUpdateClubPayloadInput = {
  access?: InputMaybe<ClubAccess>;
  colors?: InputMaybe<ClubColorsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  visibleRequirements?: InputMaybe<ClubRequirementInput>;
};

export type AdminUpdateOfferPayloadInput = {
  access?: InputMaybe<ClubOfferAccess>;
  accessRequirements?: InputMaybe<ClubOfferRequirementInput>;
  clubId: Scalars['UUID']['input'];
  configuration?: InputMaybe<OfferConfigurationPayloadInput>;
  offerFlow?: InputMaybe<OfferFlowPayloadInput>;
  offerId: Scalars['UUID']['input'];
  published?: InputMaybe<ClubOfferPublished>;
  rewards?: InputMaybe<Array<RewardOfferFlowPayloadInput>>;
  visibilityRequirements?: InputMaybe<ClubOfferRequirementInput>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  acceptInvite: AdminAcceptInviteResult;
  addReward?: Maybe<CompleteAdminUser>;
  authenticationInformation: Array<UserAuthenticationRecord>;
  completeUploadAvatar: Scalars['Boolean']['output'];
  createInvite: InvitedResult;
  createInvites: Array<GeneratedInvite>;
  delete?: Maybe<CompleteAdminUser>;
  deleteMatchingInvites?: Maybe<Array<Maybe<DeletedPendingInvite>>>;
  fullUser?: Maybe<CompleteAdminUser>;
  grantInvites: UserInvites;
  impersonate: ExternalAuthenticationResult;
  listAcceptedInvites?: Maybe<Array<Maybe<AcceptedInvite>>>;
  listCreatedAchievements?: Maybe<ListCreatedAchievementsConnection>;
  listInvites?: Maybe<Array<Maybe<PendingInvite>>>;
  listPendingInvites?: Maybe<Array<Maybe<PendingInvite>>>;
  listRelationships: Array<UserRelationship>;
  presignUploadAvatarUrl: Scalars['String']['output'];
  recover?: Maybe<CompleteAdminUser>;
  removeSocialMedia?: Maybe<CompleteAdminUser>;
  revokeAllSessions: Scalars['Boolean']['output'];
  revokeInvite: RevokeInviteResult;
  setDisableReceiveSms?: Maybe<CompleteAdminUser>;
  setDisableSendSms?: Maybe<CompleteAdminUser>;
  setEmailAddress?: Maybe<CompleteAdminUser>;
  setEnableCreateContestEvent?: Maybe<CompleteAdminUser>;
  setEnableCreateEvent?: Maybe<CompleteAdminUser>;
  setInvitedBy?: Maybe<CompleteAdminUser>;
  setIsAdmin?: Maybe<CompleteAdminUser>;
  setName?: Maybe<CompleteAdminUser>;
  setPassword?: Maybe<CompleteAdminUser>;
  setPhoneNumber?: Maybe<CompleteAdminUser>;
  setPieCreateQuotaRemaining?: Maybe<CompleteAdminUser>;
  setSkipMfa?: Maybe<CompleteAdminUser>;
  setSkipPasskeyRegistration?: Maybe<CompleteAdminUser>;
  setSmsNotificationSettings?: Maybe<CompleteAdminUser>;
  setSocialMedia?: Maybe<CompleteAdminUser>;
  /** Admin set this user's tax configuration. Used to manage PayPal-mode sellers, whose tax is platform-controlled and not seller-editable. */
  setTaxConfiguration?: Maybe<CompleteAdminUser>;
  setTier?: Maybe<CompleteAdminUser>;
  setUserName?: Maybe<CompleteAdminUser>;
  syncAllEventAttendeesContacts: Scalars['Boolean']['output'];
  updateEmailSubscription: Scalars['Boolean']['output'];
  updateInviteActions: InvitedResult;
  updateInviteRedirectUrl: AdminAcceptInviteResult;
  updateInvitesRedirectUrl: AdminAcceptInviteResult;
  /** Admin manually marks this user's current phone number as verified, recording the admin as the approver. */
  verifyPhoneNumber?: Maybe<CompleteAdminUser>;
};


export type AdminUserAcceptInviteArgs = {
  acceptDisclosures?: Scalars['Boolean']['input'];
  inviteId: Scalars['String']['input'];
};


export type AdminUserAddRewardArgs = {
  addTicket?: Scalars['Boolean']['input'];
  force?: Scalars['Boolean']['input'];
  rewardId: Scalars['UUID']['input'];
};


export type AdminUserCompleteUploadAvatarArgs = {
  avatarUrl: Scalars['String']['input'];
};


export type AdminUserCreateInviteArgs = {
  actions?: InputMaybe<Array<InviteActionInput>>;
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  memo: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  usesPerInvite?: Scalars['Int']['input'];
};


export type AdminUserCreateInvitesArgs = {
  actions?: InputMaybe<Array<InviteActionInput>>;
  count?: Scalars['Int']['input'];
  createBitlyLink?: Scalars['Boolean']['input'];
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  memo: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  repBetsUrl?: InputMaybe<RepBetsShortUrlArgsInput>;
  usesPerInvite?: Scalars['Int']['input'];
};


export type AdminUserDeleteMatchingInvitesArgs = {
  memoPattern: Scalars['String']['input'];
};


export type AdminUserGrantInvitesArgs = {
  invites: Scalars['Int']['input'];
};


export type AdminUserListCreatedAchievementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminUserPresignUploadAvatarUrlArgs = {
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
};


export type AdminUserRemoveSocialMediaArgs = {
  scheme: Scalars['String']['input'];
};


export type AdminUserRevokeInviteArgs = {
  inviteId: Scalars['String']['input'];
};


export type AdminUserSetDisableReceiveSmsArgs = {
  disabled: Scalars['Boolean']['input'];
};


export type AdminUserSetDisableSendSmsArgs = {
  disabled: Scalars['Boolean']['input'];
};


export type AdminUserSetEmailAddressArgs = {
  emailAddress: Scalars['String']['input'];
};


export type AdminUserSetEnableCreateContestEventArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type AdminUserSetEnableCreateEventArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type AdminUserSetInvitedByArgs = {
  user1: Scalars['String']['input'];
};


export type AdminUserSetIsAdminArgs = {
  isAdmin: Scalars['Boolean']['input'];
};


export type AdminUserSetNameArgs = {
  name: Scalars['String']['input'];
};


export type AdminUserSetPasswordArgs = {
  password: Scalars['String']['input'];
};


export type AdminUserSetPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type AdminUserSetPieCreateQuotaRemainingArgs = {
  value: Scalars['Int']['input'];
};


export type AdminUserSetSkipMfaArgs = {
  skip: Scalars['Boolean']['input'];
};


export type AdminUserSetSkipPasskeyRegistrationArgs = {
  skip: Scalars['Boolean']['input'];
};


export type AdminUserSetSmsNotificationSettingsArgs = {
  disableContactAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  disableInviteContacts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdminUserSetSocialMediaArgs = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  profileLink?: InputMaybe<Scalars['String']['input']>;
  scheme: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type AdminUserSetTaxConfigurationArgs = {
  args: UpdateTaxConfigurationArgInput;
};


export type AdminUserSetTierArgs = {
  tier: UserTier;
};


export type AdminUserSetUserNameArgs = {
  userName: Scalars['String']['input'];
};


export type AdminUserUpdateEmailSubscriptionArgs = {
  args: Array<EmailSubscriptionArgsInput>;
};


export type AdminUserUpdateInviteActionsArgs = {
  actions: Array<InviteActionInput>;
  inviteId: Scalars['UUID']['input'];
};


export type AdminUserUpdateInviteRedirectUrlArgs = {
  inviteId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type AdminUserUpdateInvitesRedirectUrlArgs = {
  memoPattern: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type AdminUserFilterInput = {
  and?: InputMaybe<Array<AdminUserFilterInput>>;
  or?: InputMaybe<Array<AdminUserFilterInput>>;
};

/** Represents a slice or page of User */
export type AdminUserOffsetPage = {
  __typename?: 'AdminUserOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<CompleteAdminUserType>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type AgeConstraint = {
  __typename?: 'AgeConstraint';
  maximumAge?: Maybe<Scalars['Int']['output']>;
  minimumAge?: Maybe<Scalars['Int']['output']>;
};

export type AgeConstraintPayloadInput = {
  maximumAge?: InputMaybe<Scalars['Int']['input']>;
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
};

export enum AllowCreateEventType {
  Contest = 'CONTEST',
  None = 'NONE'
}

export type Amount = {
  __typename?: 'Amount';
  symbol: Scalars['String']['output'];
  value: Scalars['Decimal']['output'];
};

export type AmountFilterInput = {
  and?: InputMaybe<Array<AmountFilterInput>>;
  or?: InputMaybe<Array<AmountFilterInput>>;
  symbol?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<DecimalOperationFilterInput>;
};

export type AmountInput = {
  symbol: Scalars['String']['input'];
  value: Scalars['Decimal']['input'];
};

export enum ApiClientTestResult {
  NotFound = 'NOT_FOUND',
  Supported = 'SUPPORTED',
  TooOld = 'TOO_OLD',
  Unsupported = 'UNSUPPORTED'
}

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

/** Payload returned when starting the process of attaching an existing Stripe account. Contains the authorization URL for the user to complete the attachment. */
export type AttachAccountPayload = {
  __typename?: 'AttachAccountPayload';
  authorizationUrl: Scalars['String']['output'];
};

export type AttendeeAgeRange = {
  __typename?: 'AttendeeAgeRange';
  totalFemaleAmount: Scalars['Int']['output'];
  totalFemaleAmountPercentage: Scalars['Float']['output'];
  totalFemaleTicketAmount: Scalars['Int']['output'];
  totalMaleAmount: Scalars['Int']['output'];
  totalMaleAmountPercentage: Scalars['Float']['output'];
  totalMaleTicketAmount: Scalars['Int']['output'];
  totalOtherAmount: Scalars['Int']['output'];
  totalOtherAmountPercentage: Scalars['Float']['output'];
  totalOtherTicketAmount: Scalars['Int']['output'];
};

export type AttendeeAgeRangeStatistic = {
  __typename?: 'AttendeeAgeRangeStatistic';
  ageOver44: AttendeeAgeRange;
  ageRangeFrom18To24: AttendeeAgeRange;
  ageRangeFrom25To34: AttendeeAgeRange;
  ageRangeFrom35To44: AttendeeAgeRange;
  ageRangeUnder18: AttendeeAgeRange;
  totalFemaleAmount: Scalars['Int']['output'];
  totalFemaleAmountPercentage: Scalars['Float']['output'];
  totalFemaleTicketAmount: Scalars['Int']['output'];
  totalMaleAmount: Scalars['Int']['output'];
  totalMaleAmountPercentage: Scalars['Float']['output'];
  totalMaleTicketAmount: Scalars['Int']['output'];
  totalOtherAmount: Scalars['Int']['output'];
  totalOtherAmountPercentage: Scalars['Float']['output'];
  totalOtherTicketAmount: Scalars['Int']['output'];
  totalTicketAmount: Scalars['Int']['output'];
  totalUserAmount: Scalars['Int']['output'];
};

export type AttendeeApprovalResponse = {
  __typename?: 'AttendeeApprovalResponse';
  failedReasons: Array<Scalars['String']['output']>;
  result: AttendeeApprovalResult;
  totalFailedBookings: Scalars['Int']['output'];
  totalProcessedBookings: Scalars['Int']['output'];
  totalProcessingBookings: Scalars['Int']['output'];
  totalSkippedBookings: Scalars['Int']['output'];
};

export enum AttendeeApprovalResult {
  Failed = 'FAILED',
  None = 'NONE',
  PartialySucceeded = 'PARTIALY_SUCCEEDED',
  Succeeded = 'SUCCEEDED'
}

export type AttendeeEligibilityInfo = {
  __typename?: 'AttendeeEligibilityInfo';
  hasConnectedInstagram: Scalars['Boolean']['output'];
  hasDownloadedApp: Scalars['Boolean']['output'];
  hasProfilePicture: Scalars['Boolean']['output'];
  instagramConnectedAt?: Maybe<Scalars['DateTime']['output']>;
  instagramHandle?: Maybe<Scalars['String']['output']>;
};

export type AttendeeEligibilityMatch = {
  __typename?: 'AttendeeEligibilityMatch';
  appDownload?: Maybe<Scalars['Boolean']['output']>;
  instagramConnected?: Maybe<Scalars['Boolean']['output']>;
  overallMatch: Scalars['Boolean']['output'];
  profilePicture?: Maybe<Scalars['Boolean']['output']>;
  shareClicks?: Maybe<Scalars['Boolean']['output']>;
  shareLogins?: Maybe<Scalars['Boolean']['output']>;
  shareTicketAcquisitions?: Maybe<Scalars['Boolean']['output']>;
};

export type AttendeeExportedInfo = {
  __typename?: 'AttendeeExportedInfo';
  acceptedPolicyTime?: Maybe<Scalars['DateTime']['output']>;
  additionalGuests: Scalars['Int']['output'];
  ageRange: Scalars['String']['output'];
  answers: Array<Scalars['String']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  approvedTime?: Maybe<Scalars['DateTime']['output']>;
  checkedInCount: Scalars['Int']['output'];
  displayEventTickets?: Maybe<Array<DisplayEventTicketInfo>>;
  emailAddress: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paypalOrderId?: Maybe<Scalars['String']['output']>;
  paypalPaymentId?: Maybe<Scalars['String']['output']>;
  paypalTotalPrice?: Maybe<Scalars['Decimal']['output']>;
  paypalTransactionFee?: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Use additionalGuests instead */
  plus1: Scalars['String']['output'];
  purchasedItems?: Maybe<Array<PaymentItems>>;
  questions: Array<Scalars['String']['output']>;
  repScore: Scalars['Decimal']['output'];
  status: Scalars['String']['output'];
  ticketPrices: Array<Maybe<Scalars['Decimal']['output']>>;
  tickets: Scalars['String']['output'];
  totalAmountWithoutFees: Scalars['Decimal']['output'];
  totalSpent: Scalars['Decimal']['output'];
  transactionTime?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['UUID']['output'];
  waiverStatus: AttendeeWaiverStatus;
};

export type AttendeeExportedMaster = {
  __typename?: 'AttendeeExportedMaster';
  attendees: Array<AttendeeExportedInfo>;
  eventTickets: Array<AttendeeExportedTicket>;
  guestList?: Maybe<Array<GuestInfoWithEventAndMatch>>;
};

export type AttendeeExportedTicket = {
  __typename?: 'AttendeeExportedTicket';
  additionalGuests: Scalars['Int']['output'];
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  gratuityPercentage?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
};

export type AttendeeFilterArgsInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  eventTicketType?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  sortOrder?: InputMaybe<PageSortOrder>;
  sortingType?: InputMaybe<AttendeeSortingType>;
  statuses?: InputMaybe<Array<EventAttendeeState>>;
};

export enum AttendeeFilterStatus {
  Approved = 'APPROVED',
  CheckedIn = 'CHECKED_IN',
  Declined = 'DECLINED',
  None = 'NONE',
  Pending = 'PENDING'
}

export type AttendeeShareStats = {
  __typename?: 'AttendeeShareStats';
  clicks: Scalars['Int']['output'];
  logins: Scalars['Int']['output'];
  ticketAcquisitions: Scalars['Int']['output'];
};

export enum AttendeeSortingField {
  Age = 'AGE',
  Approved = 'APPROVED',
  CheckedIn = 'CHECKED_IN',
  Declined = 'DECLINED',
  Gender = 'GENDER',
  Name = 'NAME',
  None = 'NONE',
  ParticipatedDate = 'PARTICIPATED_DATE',
  Pending = 'PENDING'
}

export enum AttendeeSortingType {
  Age = 'AGE',
  Name = 'NAME',
  ParticipatedDate = 'PARTICIPATED_DATE'
}

export enum AttendeeWaiverStatus {
  NotRequired = 'NOT_REQUIRED',
  WaiverRequired = 'WAIVER_REQUIRED',
  WaiverSigned = 'WAIVER_SIGNED'
}

export enum AttributionChannel {
  AppNotification = 'APP_NOTIFICATION',
  DirectUrl = 'DIRECT_URL',
  Email = 'EMAIL',
  OrganicBrowse = 'ORGANIC_BROWSE',
  OrganicFeed = 'ORGANIC_FEED',
  OrganicSearch = 'ORGANIC_SEARCH',
  PushAndroid = 'PUSH_ANDROID',
  PushIos = 'PUSH_IOS',
  PushWeb = 'PUSH_WEB',
  ShareLink = 'SHARE_LINK',
  Sms = 'SMS',
  Unknown = 'UNKNOWN'
}

export type AuthenticationArgsInput = {
  password: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type AvailableCheckingResult = {
  __typename?: 'AvailableCheckingResult';
  isAvailable: Scalars['Boolean']['output'];
  objectId?: Maybe<Scalars['UUID']['output']>;
};

export enum AvatarSource {
  Instagram = 'INSTAGRAM',
  System = 'SYSTEM',
  TikTok = 'TIK_TOK',
  Twitch = 'TWITCH'
}

export type AvatarType = {
  __typename?: 'AvatarType';
  completeUpload: Scalars['Boolean']['output'];
  presignUploadUrl: Scalars['String']['output'];
};


export type AvatarTypeCompleteUploadArgs = {
  avatarUrl: Scalars['String']['input'];
};


export type AvatarTypePresignUploadUrlArgs = {
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
};

export enum AwardedTriggerBy {
  None = 'NONE',
  Reward = 'REWARD'
}

export type BasicRequirementNotAfterDateOfClubOfferRequirementEvalContext = {
  __typename?: 'BasicRequirementNotAfterDateOfClubOfferRequirementEvalContext';
  notAfter: Scalars['DateTime']['output'];
};

export type BasicRequirementNotAfterDateOfClubOfferRequirementEvalContextInput = {
  notAfter: Scalars['DateTime']['input'];
};

export type BasicRequirementNotAfterDateOfClubRequirementEvalContext = {
  __typename?: 'BasicRequirementNotAfterDateOfClubRequirementEvalContext';
  notAfter: Scalars['DateTime']['output'];
};

export type BasicRequirementNotAfterDateOfClubRequirementEvalContextInput = {
  notAfter: Scalars['DateTime']['input'];
};

export type BasicRequirementNotAfterDateOfClubTierRequirementEvalContext = {
  __typename?: 'BasicRequirementNotAfterDateOfClubTierRequirementEvalContext';
  notAfter: Scalars['DateTime']['output'];
};

export type BasicRequirementNotAfterDateOfClubTierRequirementEvalContextInput = {
  notAfter: Scalars['DateTime']['input'];
};

export type BasicRequirementNotBeforeDateOfClubOfferRequirementEvalContext = {
  __typename?: 'BasicRequirementNotBeforeDateOfClubOfferRequirementEvalContext';
  notBefore: Scalars['DateTime']['output'];
};

export type BasicRequirementNotBeforeDateOfClubOfferRequirementEvalContextInput = {
  notBefore: Scalars['DateTime']['input'];
};

export type BasicRequirementNotBeforeDateOfClubRequirementEvalContext = {
  __typename?: 'BasicRequirementNotBeforeDateOfClubRequirementEvalContext';
  notBefore: Scalars['DateTime']['output'];
};

export type BasicRequirementNotBeforeDateOfClubRequirementEvalContextInput = {
  notBefore: Scalars['DateTime']['input'];
};

export type BasicRequirementNotBeforeDateOfClubTierRequirementEvalContext = {
  __typename?: 'BasicRequirementNotBeforeDateOfClubTierRequirementEvalContext';
  notBefore: Scalars['DateTime']['output'];
};

export type BasicRequirementNotBeforeDateOfClubTierRequirementEvalContextInput = {
  notBefore: Scalars['DateTime']['input'];
};

export type BasicUser = {
  /** Url of the avatar image for the user */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Name of user */
  name?: Maybe<Scalars['String']['output']>;
  /** Unique ID of user */
  userId: Scalars['UUID']['output'];
  /** unique user name */
  userName?: Maybe<Scalars['String']['output']>;
};

export type BlacklistEntry = {
  __typename?: 'BlacklistEntry';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type BonusRewardContentGqlType = AchievementBonusReward;

export type BonusRewardPayloadInput = {
  achievement?: InputMaybe<AchievementContentPayloadInput>;
};

export enum BonusRewardType {
  Achievement = 'ACHIEVEMENT',
  Unknown = 'UNKNOWN'
}

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BucketPointsPurchaseStrategyPayload = {
  __typename?: 'BucketPointsPurchaseStrategyPayload';
  percentageDiscountStrategy?: Maybe<PercentageBucketPointsPurchaseStrategy>;
};

export type BucketPointsPurchaseStrategyPayloadInput = {
  percentageDiscountStrategy?: InputMaybe<PercentageBucketPointsPurchaseStrategyInput>;
};

export type BulkInviteFailureDto = {
  __typename?: 'BulkInviteFailureDto';
  email?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
};

export type BulkInviteStatusModel = {
  __typename?: 'BulkInviteStatusModel';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  failCount: Scalars['Int']['output'];
  failures?: Maybe<Array<BulkInviteFailureDto>>;
  jobId: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: JobStatus;
  totalCount: Scalars['Int']['output'];
};

export type BulkResendCountResult = {
  __typename?: 'BulkResendCountResult';
  bounced: Scalars['Int']['output'];
  resendable: Scalars['Int']['output'];
  skippedAccepted: Scalars['Int']['output'];
  skippedBounced: Scalars['Int']['output'];
  skippedNoContact: Scalars['Int']['output'];
  totalMatched: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type ByUserConnection = {
  __typename?: 'ByUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ByUserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<FullEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ByUserEdge = {
  __typename?: 'ByUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FullEvent>;
};

export type CanInviteOfferResultType = {
  __typename?: 'CanInviteOfferResultType';
  canNotInviteReason: CannotInviteReason;
  result: Scalars['Boolean']['output'];
};

export type CanShareSetting = {
  __typename?: 'CanShareSetting';
  enabled: Scalars['Boolean']['output'];
  settingType: RewardSettingType;
};

export type CanShareSettingPayloadInput = {
  enabled: Scalars['Boolean']['input'];
};

export enum CannotInviteReason {
  MissingPermission = 'MISSING_PERMISSION',
  None = 'NONE',
  OfferClaimed = 'OFFER_CLAIMED',
  OfferEnded = 'OFFER_ENDED',
  WrongData = 'WRONG_DATA'
}

export type ChangeDisplayTicketIdInput = {
  newDisplayEventTicketId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  ticketId: Scalars['UUID']['input'];
};

export type ClientMutationApi = {
  __typename?: 'ClientMutationApi';
  /** Create a client */
  create: Scalars['Boolean']['output'];
  /** Create a achievement */
  createAchievement: Scalars['Boolean']['output'];
};


export type ClientMutationApiCreateArgs = {
  client: ClientSeedingArgsInput;
};


export type ClientMutationApiCreateAchievementArgs = {
  achievements: Array<AchievementArgsInput>;
  userName: Scalars['String']['input'];
};

export type ClientSeedingArgsInput = {
  account: AuthenticationArgsInput;
  achievements?: InputMaybe<Array<AchievementArgsInput>>;
  pie: PieArgsInput;
  profile?: InputMaybe<ProfileArgsInput>;
  rewards?: InputMaybe<Array<RewardArgsInput>>;
  seedAdminPie: Scalars['Boolean']['input'];
  socialMedias?: InputMaybe<Array<SocialMediaConnectionsArgsInput>>;
};

export enum ClientSocialMediaScheme {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Twitter = 'TWITTER'
}

export enum ClubAccess {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Unknown = 'UNKNOWN'
}

export enum ClubAchievementType {
  BrandBadge = 'BRAND_BADGE',
  CommunityBadge = 'COMMUNITY_BADGE',
  EventBadge = 'EVENT_BADGE',
  LaunchDaySupporter = 'LAUNCH_DAY_SUPPORTER',
  None = 'NONE',
  ParticipationBadge = 'PARTICIPATION_BADGE',
  ProductBadge = 'PRODUCT_BADGE',
  TierBadge = 'TIER_BADGE',
  Unknown = 'UNKNOWN'
}

/** A connection to a list of items. */
export type ClubAchievementsConnection = {
  __typename?: 'ClubAchievementsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClubAchievementsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<AchievementState>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClubAchievementsEdge = {
  __typename?: 'ClubAchievementsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AchievementState>;
};

export type ClubAndRole = {
  __typename?: 'ClubAndRole';
  clubId: Scalars['UUID']['output'];
  role: ClubRoleId;
};

export type ClubColors = {
  __typename?: 'ClubColors';
  background: Scalars['String']['output'];
  border: Scalars['String']['output'];
  dropShadow?: Maybe<Scalars['String']['output']>;
  foreground: Scalars['String']['output'];
};

export type ClubColorsInput = {
  background: Scalars['String']['input'];
  border: Scalars['String']['input'];
  dropShadow?: InputMaybe<Scalars['String']['input']>;
  foreground: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type ClubEventsConnection = {
  __typename?: 'ClubEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClubEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClubEventsEdge = {
  __typename?: 'ClubEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Event>;
};

export type ClubImages = {
  __typename?: 'ClubImages';
  background?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
};

export type ClubInformationCondensed = {
  __typename?: 'ClubInformationCondensed';
  access: ClubAccess;
  canJoin: Scalars['Boolean']['output'];
  clubId: Scalars['UUID']['output'];
  colors?: Maybe<ClubColors>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  images?: Maybe<ClubImages>;
  isMember: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  memberCount?: Maybe<Scalars['Long']['output']>;
  membership?: Maybe<ClubMembership>;
  name: Scalars['String']['output'];
  published: ClubPublished;
  slug?: Maybe<Scalars['String']['output']>;
  tiers: Array<Maybe<ClubTier>>;
};

export type ClubMembership = {
  __typename?: 'ClubMembership';
  /** A list of balances by class, if any exist */
  balances: Array<Maybe<ClubMembershipBalance>>;
  joinedAt: Scalars['DateTime']['output'];
  tier?: Maybe<ClubTier>;
  userClasses?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
};

export type ClubMembershipBalance = {
  __typename?: 'ClubMembershipBalance';
  balance: Scalars['Decimal']['output'];
  class: Scalars['Int']['output'];
  isTransferable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type ClubMembershipWithUser = {
  __typename?: 'ClubMembershipWithUser';
  /** A list of balances by class, if any exist */
  balances: Array<Maybe<ClubMembershipBalance>>;
  club?: Maybe<ClubInformationCondensed>;
  joinedAt: Scalars['DateTime']['output'];
  tier?: Maybe<ClubTier>;
  user?: Maybe<User>;
  userClasses?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
};

/** A connection to a list of items. */
export type ClubMembershipWithUserConnection = {
  __typename?: 'ClubMembershipWithUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClubMembershipWithUserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClubMembershipWithUser>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClubMembershipWithUserEdge = {
  __typename?: 'ClubMembershipWithUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClubMembershipWithUser>;
};

export type ClubMutation = {
  __typename?: 'ClubMutation';
  achievementById: AchievementMutator;
  clearMetadata: Scalars['Boolean']['output'];
  clubId: Scalars['UUID']['output'];
  completeTierUpload: Scalars['Boolean']['output'];
  completeUpload: Scalars['Boolean']['output'];
  createAchievement: CreateAchievementResult;
  createOffer: CreateOfferResult;
  createOrUpdateTiers: Scalars['Boolean']['output'];
  createTier: Scalars['Boolean']['output'];
  deleteTeamCollaborator: Scalars['Boolean']['output'];
  deleteTeamMember: Scalars['Boolean']['output'];
  inviteTeamCollaborator: InvitedResult;
  inviteTeamMember: InvitedResult;
  issuePoints: Scalars['Boolean']['output'];
  join: Scalars['Boolean']['output'];
  leave: Scalars['Boolean']['output'];
  offerById: OfferMutator;
  prepareTierUpload: PrepareUploadResponse;
  prepareUpload?: Maybe<PrepareUploadResponse>;
  removeMetadata: Scalars['Boolean']['output'];
  removePointsClass: Scalars['Boolean']['output'];
  removeTier: Scalars['Boolean']['output'];
  resolveClubId: Scalars['UUID']['output'];
  setJoinRequirements: Scalars['Boolean']['output'];
  setMetadata: Scalars['Boolean']['output'];
  setPointsClass: Scalars['Boolean']['output'];
  setPublishStatus: Scalars['Boolean']['output'];
  setVisibleRequirements: Scalars['Boolean']['output'];
  takePoints: Scalars['Boolean']['output'];
  transferOwnership: Scalars['Boolean']['output'];
  updateClub: UpdateClubResult;
  updateSlug: Scalars['Boolean']['output'];
  updateTeamCollaborator: Scalars['Boolean']['output'];
  updateTeamMember: Scalars['Boolean']['output'];
  updateTier: Scalars['Boolean']['output'];
};


export type ClubMutationAchievementByIdArgs = {
  achievementId: Scalars['UUID']['input'];
};


export type ClubMutationCompleteTierUploadArgs = {
  token: Scalars['String']['input'];
  type: ClubTierUploadAsset;
};


export type ClubMutationCompleteUploadArgs = {
  token: Scalars['String']['input'];
  type: ClubUploadAsset;
};


export type ClubMutationCreateAchievementArgs = {
  payload: CreateAchievementPayloadInput;
};


export type ClubMutationCreateOfferArgs = {
  payload: CreateOfferPayloadInput;
};


export type ClubMutationCreateOrUpdateTiersArgs = {
  tiers: Array<ClubTierPayloadInput>;
};


export type ClubMutationCreateTierArgs = {
  tier: ClubTierPayloadInput;
};


export type ClubMutationDeleteTeamCollaboratorArgs = {
  userId: Scalars['UUID']['input'];
};


export type ClubMutationDeleteTeamMemberArgs = {
  userId: Scalars['UUID']['input'];
};


export type ClubMutationInviteTeamCollaboratorArgs = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  memo: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  role: TeamCollaboratorRole;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  usesPerInvite?: Scalars['Int']['input'];
};


export type ClubMutationInviteTeamMemberArgs = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  memo: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
  usesPerInvite?: Scalars['Int']['input'];
};


export type ClubMutationIssuePointsArgs = {
  amount: Scalars['Decimal']['input'];
  memberId: Scalars['UUID']['input'];
  pointsClass: Scalars['Int']['input'];
};


export type ClubMutationOfferByIdArgs = {
  offerId: Scalars['UUID']['input'];
};


export type ClubMutationPrepareTierUploadArgs = {
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
  tier: Scalars['Int']['input'];
  type: ClubTierUploadAsset;
};


export type ClubMutationPrepareUploadArgs = {
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
  type: ClubUploadAsset;
};


export type ClubMutationRemoveMetadataArgs = {
  name: Scalars['String']['input'];
};


export type ClubMutationRemovePointsClassArgs = {
  payload: PointsClassPayloadInput;
  pointsClass: Scalars['Int']['input'];
};


export type ClubMutationRemoveTierArgs = {
  level: Scalars['Int']['input'];
};


export type ClubMutationSetJoinRequirementsArgs = {
  requirements?: InputMaybe<ClubRequirementInput>;
};


export type ClubMutationSetMetadataArgs = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Any']['input']>;
};


export type ClubMutationSetPointsClassArgs = {
  payload: PointsClassPayloadInput;
  pointsClass: Scalars['Int']['input'];
};


export type ClubMutationSetPublishStatusArgs = {
  status: ClubPublished;
};


export type ClubMutationSetVisibleRequirementsArgs = {
  requirements?: InputMaybe<ClubRequirementInput>;
};


export type ClubMutationTakePointsArgs = {
  amount: Scalars['Decimal']['input'];
  memberId: Scalars['UUID']['input'];
  pointsClass: Scalars['Int']['input'];
};


export type ClubMutationTransferOwnershipArgs = {
  userId: Scalars['UUID']['input'];
};


export type ClubMutationUpdateClubArgs = {
  payload: UpdateClubPayloadInput;
};


export type ClubMutationUpdateSlugArgs = {
  slug: Scalars['String']['input'];
};


export type ClubMutationUpdateTeamCollaboratorArgs = {
  role: TeamCollaboratorRole;
  userId: Scalars['UUID']['input'];
};


export type ClubMutationUpdateTeamMemberArgs = {
  roleId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type ClubMutationUpdateTierArgs = {
  level: Scalars['Int']['input'];
  tier: ClubTierPayloadWithoutLevelInput;
};

export enum ClubOfferAccess {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Unknown = 'UNKNOWN'
}

export type ClubOfferIdInput = {
  clubId: Scalars['UUID']['input'];
  offerId: Scalars['UUID']['input'];
};

export enum ClubOfferPublished {
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Unpublished = 'UNPUBLISHED'
}

export type ClubOfferRequirement = {
  __typename?: 'ClubOfferRequirement';
  age?: Maybe<ClubOfferRequirementAge>;
  and?: Maybe<Array<ClubOfferRequirement>>;
  clubMembership?: Maybe<ClubOfferRequirementOtherClubMembership>;
  membershipAge?: Maybe<ClubOfferRequirementMembershipAge>;
  minimumPoints?: Maybe<ClubOfferRequirementMinimumPoints>;
  notAfter?: Maybe<BasicRequirementNotAfterDateOfClubOfferRequirementEvalContext>;
  notBefore?: Maybe<BasicRequirementNotBeforeDateOfClubOfferRequirementEvalContext>;
  or?: Maybe<Array<ClubOfferRequirement>>;
};

export type ClubOfferRequirementAge = {
  __typename?: 'ClubOfferRequirementAge';
  minimumAge: Scalars['Int']['output'];
};

export type ClubOfferRequirementAgeInput = {
  minimumAge: Scalars['Int']['input'];
};

export type ClubOfferRequirementInput = {
  age?: InputMaybe<ClubOfferRequirementAgeInput>;
  and?: InputMaybe<Array<ClubOfferRequirementInput>>;
  clubMembership?: InputMaybe<ClubOfferRequirementOtherClubMembershipInput>;
  membershipAge?: InputMaybe<ClubOfferRequirementMembershipAgeInput>;
  minimumPoints?: InputMaybe<ClubOfferRequirementMinimumPointsInput>;
  notAfter?: InputMaybe<BasicRequirementNotAfterDateOfClubOfferRequirementEvalContextInput>;
  notBefore?: InputMaybe<BasicRequirementNotBeforeDateOfClubOfferRequirementEvalContextInput>;
  or?: InputMaybe<Array<ClubOfferRequirementInput>>;
};

export type ClubOfferRequirementMembershipAge = {
  __typename?: 'ClubOfferRequirementMembershipAge';
  age: Scalars['TimeSpan']['output'];
};

export type ClubOfferRequirementMembershipAgeInput = {
  age: Scalars['TimeSpan']['input'];
};

export type ClubOfferRequirementMinimumPoints = {
  __typename?: 'ClubOfferRequirementMinimumPoints';
  amount: Scalars['Decimal']['output'];
  class?: Maybe<Scalars['Int']['output']>;
};

export type ClubOfferRequirementMinimumPointsInput = {
  amount: Scalars['Decimal']['input'];
  class?: InputMaybe<Scalars['Int']['input']>;
};

export type ClubOfferRequirementOtherClubMembership = {
  __typename?: 'ClubOfferRequirementOtherClubMembership';
  clubId: Scalars['UUID']['output'];
  minimumMembershipAge?: Maybe<Scalars['TimeSpan']['output']>;
};

export type ClubOfferRequirementOtherClubMembershipInput = {
  clubId: Scalars['UUID']['input'];
  minimumMembershipAge?: InputMaybe<Scalars['TimeSpan']['input']>;
};

export type ClubOfferState = {
  __typename?: 'ClubOfferState';
  access: ClubOfferAccess;
  /** Calculate final offer cost including all applicable fees */
  calculateOfferCost?: Maybe<OfferCostInfo>;
  canProcessPayment: Scalars['Boolean']['output'];
  configuration?: Maybe<OfferConfigurationPayload>;
  isCurrentUserCanInvite?: Maybe<CanInviteOfferResultType>;
  isCurrentUserEditable?: Maybe<Scalars['Boolean']['output']>;
  isCurrentUserRedeemable?: Maybe<Scalars['Boolean']['output']>;
  isCurrentUserWinner?: Maybe<Scalars['Boolean']['output']>;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  isPublicUserRedeemable?: Maybe<Scalars['Boolean']['output']>;
  isStarted?: Maybe<Scalars['Boolean']['output']>;
  isTimeFrameTypeEditable?: Maybe<Scalars['Boolean']['output']>;
  isWinnerGenerated?: Maybe<Scalars['Boolean']['output']>;
  listOfferUser?: Maybe<DetailsOfferUserConnection>;
  offerId: Scalars['UUID']['output'];
  published: ClubOfferPublished;
  requirements?: Maybe<ClubOfferRequirement>;
  rewardOffer?: Maybe<RewardOfferFlow>;
  rewards: Array<Maybe<RewardState>>;
  shortLink?: Maybe<Scalars['String']['output']>;
  totalWinnerCount?: Maybe<Scalars['Int']['output']>;
  type: OfferType;
  userOffer?: Maybe<OfferUserState>;
};


export type ClubOfferStateCalculateOfferCostArgs = {
  offerCostArgs?: InputMaybe<OfferCostArgsInput>;
};


export type ClubOfferStateListOfferUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DetailsOfferUserFilterArgsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type ClubOffersConnection = {
  __typename?: 'ClubOffersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClubOffersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClubOfferState>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClubOffersEdge = {
  __typename?: 'ClubOffersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClubOfferState>;
};

export type ClubPermission = {
  __typename?: 'ClubPermission';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum ClubPermissionId {
  CanApproveCollaboratorRequests = 'CAN_APPROVE_COLLABORATOR_REQUESTS',
  CanApproveMemberRequests = 'CAN_APPROVE_MEMBER_REQUESTS',
  CanAssignAccountManagers = 'CAN_ASSIGN_ACCOUNT_MANAGERS',
  CanAssignAdministrators = 'CAN_ASSIGN_ADMINISTRATORS',
  CanAssignFinanceManagers = 'CAN_ASSIGN_FINANCE_MANAGERS',
  CanAwardRewards = 'CAN_AWARD_REWARDS',
  CanChangeBio = 'CAN_CHANGE_BIO',
  CanChangeClubName = 'CAN_CHANGE_CLUB_NAME',
  CanChangeSlug = 'CAN_CHANGE_SLUG',
  CanChangeUrl = 'CAN_CHANGE_URL',
  CanConnectPaypalAccount = 'CAN_CONNECT_PAYPAL_ACCOUNT',
  CanConnectSocialAccounts = 'CAN_CONNECT_SOCIAL_ACCOUNTS',
  CanCreateAchievement = 'CAN_CREATE_ACHIEVEMENT',
  CanCreateEvents = 'CAN_CREATE_EVENTS',
  CanCreateOffer = 'CAN_CREATE_OFFER',
  CanCreatePointsClass = 'CAN_CREATE_POINTS_CLASS',
  CanCreateRewards = 'CAN_CREATE_REWARDS',
  CanCreateTier = 'CAN_CREATE_TIER',
  CanCreateWaysToBuyPoints = 'CAN_CREATE_WAYS_TO_BUY_POINTS',
  CanCreateWaysToEarnPoints = 'CAN_CREATE_WAYS_TO_EARN_POINTS',
  CanCreateWaysToEarnStatus = 'CAN_CREATE_WAYS_TO_EARN_STATUS',
  CanDeleteAchievements = 'CAN_DELETE_ACHIEVEMENTS',
  CanDeleteOffer = 'CAN_DELETE_OFFER',
  CanDeletePointsClass = 'CAN_DELETE_POINTS_CLASS',
  CanDeleteRewards = 'CAN_DELETE_REWARDS',
  CanEditAchievement = 'CAN_EDIT_ACHIEVEMENT',
  CanEditClub = 'CAN_EDIT_CLUB',
  CanEditOffer = 'CAN_EDIT_OFFER',
  CanEditRewards = 'CAN_EDIT_REWARDS',
  CanEditTiers = 'CAN_EDIT_TIERS',
  CanIssuePoints = 'CAN_ISSUE_POINTS',
  CanManageClub = 'CAN_MANAGE_CLUB',
  CanManageClubAccounts = 'CAN_MANAGE_CLUB_ACCOUNTS',
  CanManageClubAchievements = 'CAN_MANAGE_CLUB_ACHIEVEMENTS',
  CanManageClubDetail = 'CAN_MANAGE_CLUB_DETAIL',
  CanManageClubEvents = 'CAN_MANAGE_CLUB_EVENTS',
  CanManageClubLoyaltyStatus = 'CAN_MANAGE_CLUB_LOYALTY_STATUS',
  CanManageClubOffers = 'CAN_MANAGE_CLUB_OFFERS',
  CanManageClubRepPoint = 'CAN_MANAGE_CLUB_REP_POINT',
  CanManageTeams = 'CAN_MANAGE_TEAMS',
  CanModifyExistingRewards = 'CAN_MODIFY_EXISTING_REWARDS',
  CanPricePointBundles = 'CAN_PRICE_POINT_BUNDLES',
  CanRemoveClubTier = 'CAN_REMOVE_CLUB_TIER',
  CanRemoveSocialAccounts = 'CAN_REMOVE_SOCIAL_ACCOUNTS',
  CanReviewAchievements = 'CAN_REVIEW_ACHIEVEMENTS',
  CanSendAchievements = 'CAN_SEND_ACHIEVEMENTS',
  CanSendCollaboratorRequests = 'CAN_SEND_COLLABORATOR_REQUESTS',
  CanSendMemberRequests = 'CAN_SEND_MEMBER_REQUESTS',
  CanSendPoints = 'CAN_SEND_POINTS',
  CanSendRewards = 'CAN_SEND_REWARDS',
  CanShareAchievements = 'CAN_SHARE_ACHIEVEMENTS',
  CanShareClub = 'CAN_SHARE_CLUB',
  CanShareRewards = 'CAN_SHARE_REWARDS',
  CanTakePoints = 'CAN_TAKE_POINTS',
  CanTradeClubPoints = 'CAN_TRADE_CLUB_POINTS',
  CanTransferClubOwnership = 'CAN_TRANSFER_CLUB_OWNERSHIP',
  CanViewClub = 'CAN_VIEW_CLUB',
  CanViewRewards = 'CAN_VIEW_REWARDS'
}

export enum ClubPublished {
  Deleted = 'DELETED',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Unpublished = 'UNPUBLISHED'
}

export type ClubRequirement = {
  __typename?: 'ClubRequirement';
  age?: Maybe<ClubRequirementAge>;
  and?: Maybe<Array<ClubRequirement>>;
  clubMembership?: Maybe<ClubRequirementOtherClubMembership>;
  notAfter?: Maybe<BasicRequirementNotAfterDateOfClubRequirementEvalContext>;
  notBefore?: Maybe<BasicRequirementNotBeforeDateOfClubRequirementEvalContext>;
  or?: Maybe<Array<ClubRequirement>>;
};

export type ClubRequirementAge = {
  __typename?: 'ClubRequirementAge';
  minimumAge: Scalars['Int']['output'];
};

export type ClubRequirementAgeInput = {
  minimumAge: Scalars['Int']['input'];
};

export type ClubRequirementInput = {
  age?: InputMaybe<ClubRequirementAgeInput>;
  and?: InputMaybe<Array<ClubRequirementInput>>;
  clubMembership?: InputMaybe<ClubRequirementOtherClubMembershipInput>;
  notAfter?: InputMaybe<BasicRequirementNotAfterDateOfClubRequirementEvalContextInput>;
  notBefore?: InputMaybe<BasicRequirementNotBeforeDateOfClubRequirementEvalContextInput>;
  or?: InputMaybe<Array<ClubRequirementInput>>;
};

export type ClubRequirementOtherClubMembership = {
  __typename?: 'ClubRequirementOtherClubMembership';
  clubId: Scalars['UUID']['output'];
  minimumMembershipAge?: Maybe<Scalars['TimeSpan']['output']>;
};

export type ClubRequirementOtherClubMembershipInput = {
  clubId: Scalars['UUID']['input'];
  minimumMembershipAge?: InputMaybe<Scalars['TimeSpan']['input']>;
};

export enum ClubRoleId {
  AccountManager = 'ACCOUNT_MANAGER',
  Admin = 'ADMIN',
  EventManager = 'EVENT_MANAGER',
  FinanceManager = 'FINANCE_MANAGER',
  LoyaltyManager = 'LOYALTY_MANAGER',
  Owner = 'OWNER',
  Scanner = 'SCANNER'
}

export type ClubRolePermissionState = {
  __typename?: 'ClubRolePermissionState';
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<ClubPermissionId>>;
  roleId: Scalars['UUID']['output'];
  roleName: Scalars['String']['output'];
};

export type ClubState = {
  __typename?: 'ClubState';
  access: ClubAccess;
  achievements?: Maybe<AchievementsConnection>;
  canJoin: Scalars['Boolean']['output'];
  clubId: Scalars['UUID']['output'];
  colors?: Maybe<ClubColors>;
  createdAt: Scalars['DateTime']['output'];
  defaultBuyPointsOffer?: Maybe<ClubOfferState>;
  description: Scalars['String']['output'];
  images?: Maybe<ClubImages>;
  isMember: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  joinRequirements?: Maybe<ClubRequirement>;
  memberCount?: Maybe<Scalars['Long']['output']>;
  membership?: Maybe<ClubMembership>;
  metadata?: Maybe<Scalars['Any']['output']>;
  name: Scalars['String']['output'];
  offers?: Maybe<OffersConnection>;
  owner?: Maybe<User>;
  permissions: Array<Maybe<ClubPermission>>;
  published: ClubPublished;
  slug?: Maybe<Scalars['String']['output']>;
  teamCollaborators?: Maybe<Array<Maybe<ClubTeamCollaboratorState>>>;
  teamMemberRoles?: Maybe<Array<Maybe<ClubTeamMemberRoleState>>>;
  tiers: Array<Maybe<ClubTier>>;
  visibleRequirements?: Maybe<ClubRequirement>;
};


export type ClubStateAchievementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterAchievementCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ClubStateOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterOfferCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a slice or page of ClubState */
export type ClubStateOffsetPage = {
  __typename?: 'ClubStateOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<ClubState>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type ClubTeamCollaboratorState = {
  __typename?: 'ClubTeamCollaboratorState';
  assignDate: Scalars['DateTime']['output'];
  role: TeamCollaboratorRole;
  user?: Maybe<User>;
};

export type ClubTeamMemberRoleState = {
  __typename?: 'ClubTeamMemberRoleState';
  role?: Maybe<ClubRolePermissionState>;
  roleId: Scalars['UUID']['output'];
  user?: Maybe<User>;
};

export type ClubTier = {
  __typename?: 'ClubTier';
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  colors?: Maybe<ClubTierColors>;
  description?: Maybe<Scalars['String']['output']>;
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** @deprecated THIS IS NOT AVAILABLE IN PRODUCTION! */
  points?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<ClubTierRequirement>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ClubTierAgeRequirement = {
  __typename?: 'ClubTierAgeRequirement';
  minimumAge: Scalars['Int']['output'];
};

export type ClubTierAgeRequirementInput = {
  minimumAge: Scalars['Int']['input'];
};

export type ClubTierColors = {
  __typename?: 'ClubTierColors';
  background: Scalars['String']['output'];
  border: Scalars['String']['output'];
  foreground: Scalars['String']['output'];
};

export type ClubTierColorsInput = {
  background: Scalars['String']['input'];
  border: Scalars['String']['input'];
  foreground: Scalars['String']['input'];
};

export type ClubTierMaximumPointsRequirement = {
  __typename?: 'ClubTierMaximumPointsRequirement';
  amount: Scalars['Decimal']['output'];
  class?: Maybe<Scalars['Int']['output']>;
};

export type ClubTierMaximumPointsRequirementInput = {
  amount: Scalars['Decimal']['input'];
  class?: InputMaybe<Scalars['Int']['input']>;
};

export type ClubTierMinimumPointsRequirement = {
  __typename?: 'ClubTierMinimumPointsRequirement';
  amount: Scalars['Decimal']['output'];
  class?: Maybe<Scalars['Int']['output']>;
};

export type ClubTierMinimumPointsRequirementInput = {
  amount: Scalars['Decimal']['input'];
  class?: InputMaybe<Scalars['Int']['input']>;
};

export type ClubTierPayloadInput = {
  colors?: InputMaybe<ClubTierColorsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<ClubTierRequirementInput>;
};

export type ClubTierPayloadWithoutLevelInput = {
  colors?: InputMaybe<ClubTierColorsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<ClubTierRequirementInput>;
};

export type ClubTierRequirement = {
  __typename?: 'ClubTierRequirement';
  age?: Maybe<ClubTierAgeRequirement>;
  and?: Maybe<Array<ClubTierRequirement>>;
  maximumPoints?: Maybe<ClubTierMaximumPointsRequirement>;
  membershipAge?: Maybe<ClubTierRequirementMembershipAge>;
  minimumPoints?: Maybe<ClubTierMinimumPointsRequirement>;
  notAfter?: Maybe<BasicRequirementNotAfterDateOfClubTierRequirementEvalContext>;
  notBefore?: Maybe<BasicRequirementNotBeforeDateOfClubTierRequirementEvalContext>;
  or?: Maybe<Array<ClubTierRequirement>>;
};

export type ClubTierRequirementInput = {
  age?: InputMaybe<ClubTierAgeRequirementInput>;
  and?: InputMaybe<Array<ClubTierRequirementInput>>;
  maximumPoints?: InputMaybe<ClubTierMaximumPointsRequirementInput>;
  membershipAge?: InputMaybe<ClubTierRequirementMembershipAgeInput>;
  minimumPoints?: InputMaybe<ClubTierMinimumPointsRequirementInput>;
  notAfter?: InputMaybe<BasicRequirementNotAfterDateOfClubTierRequirementEvalContextInput>;
  notBefore?: InputMaybe<BasicRequirementNotBeforeDateOfClubTierRequirementEvalContextInput>;
  or?: InputMaybe<Array<ClubTierRequirementInput>>;
};

export type ClubTierRequirementMembershipAge = {
  __typename?: 'ClubTierRequirementMembershipAge';
  age: Scalars['TimeSpan']['output'];
};

export type ClubTierRequirementMembershipAgeInput = {
  age: Scalars['TimeSpan']['input'];
};

export enum ClubTierUploadAsset {
  Background = 'BACKGROUND'
}

export enum ClubUploadAsset {
  Background = 'BACKGROUND',
  Icon = 'ICON'
}

/** A connection to a list of items. */
export type ClubsConnection = {
  __typename?: 'ClubsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ClubsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClubInformationCondensed>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClubsEdge = {
  __typename?: 'ClubsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClubInformationCondensed>;
};

export type CompleteAdminUser = BasicUser & {
  __typename?: 'CompleteAdminUser';
  IsPhoneNumberVerified: Scalars['Boolean']['output'];
  /** List accepted invites */
  acceptedInvites?: Maybe<Array<Maybe<AcceptedInvite>>>;
  /**
   * List achievements have been achieved by user
   * @deprecated Please use userAchievements in achievement query instead
   */
  achievements?: Maybe<Array<Maybe<AchievementListType>>>;
  /** The Address of a User */
  address?: Maybe<AddressModel>;
  age?: Maybe<Scalars['Int']['output']>;
  ageRange?: Maybe<Scalars['String']['output']>;
  /** Did the user agree to the latest terms and conditions? */
  agreeToTermsAndConditions: Scalars['Boolean']['output'];
  /** Agree to T&C version */
  agreeToTermsAndConditionsVersion?: Maybe<Scalars['Int']['output']>;
  avatarSource: AvatarSource;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Bio is an optional field that will probably only be filled */
  bio?: Maybe<Scalars['String']['output']>;
  brandedEventId?: Maybe<Scalars['UUID']['output']>;
  /** Branded url is a custom path that can be used to link to a specific event page */
  brandedUrl?: Maybe<Scalars['String']['output']>;
  /** True if the current user is allowed to create pies */
  canCreatePies: Scalars['Boolean']['output'];
  /** True if the user has a connected payment account capable of processing payments */
  canProcessPayment: Scalars['Boolean']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  /** The time in UTC timezone that this account was deleted */
  deletedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Is this account deleted by admin */
  deletedByAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this user has opted out of receiving bulk/invite SMS (OTP/verification still send) */
  disableReceiveSms: Scalars['Boolean']['output'];
  /** Returns true if this account is blocked from SENDING mass/invite SMS (organizer-side). Email still sends. */
  disableSendSms: Scalars['Boolean']['output'];
  displayNameSource: DisplayNameSource;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** User email subscriptions */
  emailSubscriptions?: Maybe<Array<Maybe<EmailSubscription>>>;
  /** Returns true if this account is allowed to create contest events. */
  enableCreateContestEvent: Scalars['Boolean']['output'];
  /** Returns true if this account can create events. */
  enableCreateEvent: Scalars['Boolean']['output'];
  gender?: Maybe<UserGender>;
  /** List holding pies */
  holdingPies?: Maybe<Array<Maybe<HoldingPie>>>;
  /** Instagram avatar URL from connected Instagram account, regardless of which avatar is active */
  instagramAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Instagram display name from connected Instagram account, regardless of which display name is active */
  instagramDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected Instagram account */
  instagramFollowsCount?: Maybe<Scalars['Long']['output']>;
  invitedBy?: Maybe<User>;
  /** Is Repbets Administrator */
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Soft delete flag */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Returns if the current user is already in the waiting list */
  isInWaitingList: Scalars['Boolean']['output'];
  /** Returns if the current user is already skip mfa */
  isSkipMultiFactorAuthentication: Scalars['Boolean']['output'];
  /** Returns if the current user already skipped passkey registration */
  isSkipPasskeyRegistration: Scalars['Boolean']['output'];
  /** If a user have been verified, this will be true */
  isVerified: Scalars['Boolean']['output'];
  /** Clubs where the current user has management access */
  managedClubs: Array<ClubState>;
  /** User club memberships */
  memberships?: Maybe<ClubMembershipWithUserConnection>;
  name?: Maybe<Scalars['String']['output']>;
  /** List payout accounts */
  payoutAccounts?: Maybe<Array<Maybe<PayoutAccount>>>;
  /** List pending invites */
  pendingInvites?: Maybe<Array<Maybe<PendingInvite>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** UserId of the admin who manually verified the phone number. Null when verified by the user or not verified. */
  phoneNumberVerifiedBy?: Maybe<Scalars['UUID']['output']>;
  pieCreateQuotaRemaining?: Maybe<Scalars['Int']['output']>;
  /** List users pies */
  pies?: Maybe<PieGrainPageX>;
  /** Information about the users portfolio */
  portfolio?: Maybe<UserPortfolio>;
  /** Per-feature SMS receipt settings (null field = enabled). Overridden by disableReceiveSms. */
  smsNotificationSettings?: Maybe<SmsNotificationSettings>;
  /** List social media connections */
  socialMediaConnections?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  /**
   * List social media connections
   * @deprecated Use socialMediaConnections instead
   */
  socialMedias?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  /** The Stripe payment account for processing payments */
  stripeAccount?: Maybe<UserStripeAccountType>;
  /** User tax configuration for checkout */
  taxConfiguration?: Maybe<UserTaxConfiguration>;
  /** Dictionary contains version and time at the point that user agreed */
  termsAndConditionsAgreedVersions?: Maybe<Array<KeyValuePairOfInt32AndDateTime>>;
  tier: UserTier;
  /** TikTok avatar URL from connected TikTok account, regardless of which avatar is active */
  tikTokAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** TikTok display name from connected TikTok account, regardless of which display name is active */
  tikTokDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected TikTok account */
  tikTokFollowsCount?: Maybe<Scalars['Long']['output']>;
  /** List of users transactions in reverse chronological order */
  transactions?: Maybe<TransactionsConnection>;
  /** Twitch avatar URL from connected Twitch account, regardless of which avatar is active */
  twitchAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Twitch display name from connected Twitch account, regardless of which display name is active */
  twitchDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected Twitch account */
  twitchFollowsCount?: Maybe<Scalars['Long']['output']>;
  /** Returns if the current user use biometric */
  useBiometric: Scalars['Boolean']['output'];
  userId: Scalars['UUID']['output'];
  userInvitesRemaining: Scalars['Int']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  verifiedEmailAddress?: Maybe<Scalars['String']['output']>;
  verifiedPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** User walkthrough */
  walkthrough?: Maybe<Array<Maybe<UserWalkthrough>>>;
};


export type CompleteAdminUserHoldingPiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CompleteAdminUserMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompleteAdminUserPiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CompleteAdminUserTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CompleteAdminUserType = BasicUser & {
  __typename?: 'CompleteAdminUserType';
  IsPhoneNumberVerified: Scalars['Boolean']['output'];
  /** List accepted invites */
  acceptedInvites?: Maybe<Array<Maybe<AcceptedInvite>>>;
  /**
   * List achievements have been achieved by user
   * @deprecated Please use userAchievements in achievement query instead
   */
  achievements?: Maybe<Array<Maybe<AchievementListType>>>;
  /** The Address of a User */
  address?: Maybe<AddressModel>;
  age?: Maybe<Scalars['Int']['output']>;
  ageRange?: Maybe<Scalars['String']['output']>;
  /** Did the user agree to the latest terms and conditions? */
  agreeToTermsAndConditions: Scalars['Boolean']['output'];
  /** Agree to T&C version */
  agreeToTermsAndConditionsVersion?: Maybe<Scalars['Int']['output']>;
  avatarSource: AvatarSource;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Bio is an optional field that will probably only be filled */
  bio?: Maybe<Scalars['String']['output']>;
  brandedEventId?: Maybe<Scalars['UUID']['output']>;
  /** Branded url is a custom path that can be used to link to a specific event page */
  brandedUrl?: Maybe<Scalars['String']['output']>;
  /** True if the current user is allowed to create pies */
  canCreatePies: Scalars['Boolean']['output'];
  /** True if the user has a connected payment account capable of processing payments */
  canProcessPayment: Scalars['Boolean']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  /** The time in UTC timezone that this account was deleted */
  deletedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Is this account deleted by admin */
  deletedByAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this user has opted out of receiving bulk/invite SMS (OTP/verification still send) */
  disableReceiveSms: Scalars['Boolean']['output'];
  /** Returns true if this account is blocked from SENDING mass/invite SMS (organizer-side). Email still sends. */
  disableSendSms: Scalars['Boolean']['output'];
  displayNameSource: DisplayNameSource;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** User email subscriptions */
  emailSubscriptions?: Maybe<Array<Maybe<EmailSubscription>>>;
  /** Returns true if this account is allowed to create contest events. */
  enableCreateContestEvent: Scalars['Boolean']['output'];
  /** Returns true if this account can create events. */
  enableCreateEvent: Scalars['Boolean']['output'];
  gender?: Maybe<UserGender>;
  /** List holding pies */
  holdingPies?: Maybe<Array<Maybe<HoldingPie>>>;
  /** Instagram avatar URL from connected Instagram account, regardless of which avatar is active */
  instagramAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Instagram display name from connected Instagram account, regardless of which display name is active */
  instagramDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected Instagram account */
  instagramFollowsCount?: Maybe<Scalars['Long']['output']>;
  invitedBy?: Maybe<User>;
  /** Is Repbets Administrator */
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Soft delete flag */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Returns if the current user is already in the waiting list */
  isInWaitingList: Scalars['Boolean']['output'];
  /** Returns if the current user is already skip mfa */
  isSkipMultiFactorAuthentication: Scalars['Boolean']['output'];
  /** Returns if the current user already skipped passkey registration */
  isSkipPasskeyRegistration: Scalars['Boolean']['output'];
  /** If a user have been verified, this will be true */
  isVerified: Scalars['Boolean']['output'];
  /** Clubs where the current user has management access */
  managedClubs: Array<ClubState>;
  /** User club memberships */
  memberships?: Maybe<ClubMembershipWithUserConnection>;
  name?: Maybe<Scalars['String']['output']>;
  /** List payout accounts */
  payoutAccounts?: Maybe<Array<Maybe<PayoutAccount>>>;
  /** List pending invites */
  pendingInvites?: Maybe<Array<Maybe<PendingInvite>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** UserId of the admin who manually verified the phone number. Null when verified by the user or not verified. */
  phoneNumberVerifiedBy?: Maybe<Scalars['UUID']['output']>;
  pieCreateQuotaRemaining?: Maybe<Scalars['Int']['output']>;
  /** List users pies */
  pies?: Maybe<PieGrainPageX>;
  /** Information about the users portfolio */
  portfolio?: Maybe<UserPortfolio>;
  /** Per-feature SMS receipt settings (null field = enabled). Overridden by disableReceiveSms. */
  smsNotificationSettings?: Maybe<SmsNotificationSettings>;
  /** List social media connections */
  socialMediaConnections?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  /**
   * List social media connections
   * @deprecated Use socialMediaConnections instead
   */
  socialMedias?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  /** The Stripe payment account for processing payments */
  stripeAccount?: Maybe<UserStripeAccountType>;
  /** User tax configuration for checkout */
  taxConfiguration?: Maybe<UserTaxConfiguration>;
  /** Dictionary contains version and time at the point that user agreed */
  termsAndConditionsAgreedVersions?: Maybe<Array<KeyValuePairOfInt32AndDateTime>>;
  tier: UserTier;
  /** TikTok avatar URL from connected TikTok account, regardless of which avatar is active */
  tikTokAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** TikTok display name from connected TikTok account, regardless of which display name is active */
  tikTokDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected TikTok account */
  tikTokFollowsCount?: Maybe<Scalars['Long']['output']>;
  /** List of users transactions in reverse chronological order */
  transactions?: Maybe<TransactionsConnection>;
  /** Twitch avatar URL from connected Twitch account, regardless of which avatar is active */
  twitchAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Twitch display name from connected Twitch account, regardless of which display name is active */
  twitchDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected Twitch account */
  twitchFollowsCount?: Maybe<Scalars['Long']['output']>;
  /** Returns if the current user use biometric */
  useBiometric: Scalars['Boolean']['output'];
  userId: Scalars['UUID']['output'];
  userInvitesRemaining: Scalars['Int']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  verifiedEmailAddress?: Maybe<Scalars['String']['output']>;
  verifiedPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** User walkthrough */
  walkthrough?: Maybe<Array<Maybe<UserWalkthrough>>>;
};


export type CompleteAdminUserTypeHoldingPiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CompleteAdminUserTypeMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompleteAdminUserTypePiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CompleteAdminUserTypeTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CompletePieWithBalance = HasCanonicalUrl & ILimitedPieModel & {
  __typename?: 'CompletePieWithBalance';
  /** Current balance of this pie for the user */
  balance?: Maybe<Scalars['Decimal']['output']>;
  /** Description or bio of the pie */
  bio?: Maybe<Scalars['String']['output']>;
  /** True if this pie can be for sale */
  canBeForSale?: Maybe<Scalars['Boolean']['output']>;
  /** True if this pie can be bought by placing an order */
  canBuy?: Maybe<Scalars['Boolean']['output']>;
  /** True if this pie can be sold by owner */
  canSell?: Maybe<Scalars['Boolean']['output']>;
  /** True if this pie can be transfer to another user */
  canTransfer?: Maybe<Scalars['Boolean']['output']>;
  /** The absolute canonical url for this pie, can be used for sharing */
  canonicalUrl?: Maybe<Scalars['URL']['output']>;
  /** The user created the pie */
  createdBy?: Maybe<User>;
  /** Created at */
  createdUtc: Scalars['DateTime']['output'];
  /** Name of the pie */
  displayName: Scalars['String']['output'];
  /** How many number of slices percentage that publisher is selling */
  floatPercentage: Scalars['Decimal']['output'];
  /** Whether a user used to buy a particular pie or not */
  hasPurchasedPiePreviously?: Maybe<Scalars['Boolean']['output']>;
  /** The total number of slices that publisher is holding */
  holdingSlices: Scalars['Decimal']['output'];
  /** List individual assets images to compose the full pie image */
  individualAssets?: Maybe<IndividualAssetGrainPageX>;
  /** Initial offer */
  initialOffer?: Maybe<PublicPieInitialOfferModel>;
  /** Is Pie deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Is Pie disabled */
  isDisabled: Scalars['Boolean']['output'];
  /**
   * True if this pie is activated for onboarding process
   * @deprecated Please use onBoardingProcess instead
   */
  isOnboardingActivated?: Maybe<Scalars['Boolean']['output']>;
  /** Is the pie in transfer ownership process */
  isTransfering?: Maybe<Scalars['Boolean']['output']>;
  /** True if this pie is verified */
  isVerified: Scalars['Boolean']['output'];
  /** Is Pie visible */
  isVisible: Scalars['Boolean']['output'];
  /** The maximum number of slices for a pie and can not be changed after creation */
  issuedSlices: Scalars['Decimal']['output'];
  /** Pie launched date */
  launchedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Market symbol of pie */
  marketSymbol?: Maybe<Scalars['String']['output']>;
  /** Max slices of pie, only available to pie creator */
  maxSlices?: Maybe<Scalars['Decimal']['output']>;
  /** A list of moderators of a pie */
  moderators?: Maybe<StoredModeratorPageX>;
  /** Get onboarding process */
  onBoardingProcess?: Maybe<OnboardingProcess>;
  /** Current state of the pie */
  operationalState: PieOperationalState;
  /** Url for pie avatar */
  pieAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Pie balance */
  pieBalance?: Maybe<PieBalance>;
  /** Id of pie */
  pieId: Scalars['UUID']['output'];
  /** Global rank of pie */
  rank?: Maybe<Scalars['Int']['output']>;
  /**
   * List pie rewards
   * @deprecated Please use rewardList2 instead
   */
  rewardList?: Maybe<RewardOffsetPage>;
  /** List pie rewards */
  rewardList2?: Maybe<RewardGrainPageX>;
  /** Current sales state of the pie. This is similar to the OperationalState but calculated */
  salesStatus: PieSalesState;
  /** Price per slice of pie */
  slicePrice: Amount;
  /** How many number of slices percentage that publisher is holing */
  slicesHeld: Scalars['Decimal']['output'];
  /** Slug of pie */
  slug: Scalars['String']['output'];
  /** List of associated social media */
  socialMedia: Array<SocialMediaPair>;
  /** Total members */
  totalMembers: Scalars['Long']['output'];
  /** Total number of unique subscribers of this pie */
  totalUniqueSubscribers: Scalars['Int']['output'];
  /** Total value of all slices */
  totalValue: Amount;
  /** Url of the Pie avatar which is in generating or generated */
  truePieAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** List uploaded assets images */
  uploadedAssets?: Maybe<UploadedAssetGrainPageX>;
  /** Permissions of user based on pie role */
  userPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Did current user wish this pie */
  wished?: Maybe<Scalars['Boolean']['output']>;
  /** Count number of wishers who wished this pie */
  wishersCount?: Maybe<Scalars['Int']['output']>;
};


export type CompletePieWithBalanceIndividualAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CompletePieWithBalanceModeratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CompletePieWithBalanceRewardListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompletePieWithBalanceRewardList2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompletePieWithBalanceUploadedAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CompleteUser = BasicUser & {
  __typename?: 'CompleteUser';
  IsPhoneNumberVerified: Scalars['Boolean']['output'];
  /** The Address of a User */
  address?: Maybe<AddressModel>;
  age?: Maybe<Scalars['Int']['output']>;
  ageRange?: Maybe<Scalars['String']['output']>;
  /** Agree to T&C version */
  agreeToTermsAndConditionsVersion?: Maybe<Scalars['Int']['output']>;
  avatarSource: AvatarSource;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Bio is an optional field that will probably only be filled */
  bio?: Maybe<Scalars['String']['output']>;
  brandedEventId?: Maybe<Scalars['UUID']['output']>;
  /** Branded url is a custom path that can be used to link to a specific event page */
  brandedUrl?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  /** The time in UTC timezone that this account was deleted */
  deletedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Is this account deleted by admin */
  deletedByAdmin?: Maybe<Scalars['Boolean']['output']>;
  displayNameSource: DisplayNameSource;
  emailAddress?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<UserGender>;
  /** Instagram avatar URL from connected Instagram account, regardless of which avatar is active */
  instagramAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Instagram display name from connected Instagram account, regardless of which display name is active */
  instagramDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected Instagram account */
  instagramFollowsCount?: Maybe<Scalars['Long']['output']>;
  invitedBy?: Maybe<User>;
  /** Is Repbets Administrator */
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Soft delete flag */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** If a user have been verified, this will be true */
  isVerified: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** List social media connections */
  socialMediaConnections?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  /**
   * List social media connections
   * @deprecated Use socialMediaConnections instead
   */
  socialMedias?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  /** Dictionary contains version and time at the point that user agreed */
  termsAndConditionsAgreedVersions?: Maybe<Array<KeyValuePairOfInt32AndDateTime>>;
  tier: UserTier;
  /** TikTok avatar URL from connected TikTok account, regardless of which avatar is active */
  tikTokAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** TikTok display name from connected TikTok account, regardless of which display name is active */
  tikTokDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected TikTok account */
  tikTokFollowsCount?: Maybe<Scalars['Long']['output']>;
  /** Twitch avatar URL from connected Twitch account, regardless of which avatar is active */
  twitchAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Twitch display name from connected Twitch account, regardless of which display name is active */
  twitchDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected Twitch account */
  twitchFollowsCount?: Maybe<Scalars['Long']['output']>;
  userId: Scalars['UUID']['output'];
  userInvitesRemaining: Scalars['Int']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  verifiedEmailAddress?: Maybe<Scalars['String']['output']>;
  verifiedPhoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ConfirmEventPrivacyPolicyResult = {
  __typename?: 'ConfirmEventPrivacyPolicyResult';
  referenceId: Scalars['String']['output'];
  signedDisclosureFileUrl?: Maybe<Scalars['String']['output']>;
};

export type ConfirmingContact = {
  __typename?: 'ConfirmingContact';
  invitee: Contact;
  inviter?: Maybe<UserWithAddress>;
};

export type Contact = {
  __typename?: 'Contact';
  contactId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Array<ContactCustomField>>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  emailBounceReason?: Maybe<Scalars['String']['output']>;
  emailBounced: Scalars['Boolean']['output'];
  emailBouncedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Events that contact is joined */
  events?: Maybe<LimitedEventConnection>;
  gender?: Maybe<UserGender>;
  /** Groups that contact is in */
  groups?: Maybe<ContactGroupConnection>;
  /** Event's invitation status */
  invitationStatus: InvitationStatus;
  /** Invitation info */
  inviteInfo?: Maybe<InvitationInfo>;
  /** List invited tickets sent to this contact by event id */
  invitedTickets: Array<InvitedTicket>;
  /** Inviter info who invited this contact by event id */
  inviter?: Maybe<User>;
  /** Check this contact is invited to the event by event id */
  isInvitedToEvent: Scalars['Boolean']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Offer's invitation status */
  offerInvitationStatus: InvitationStatus;
  /** Inviter info who invited this contact by offer id */
  offerInviter?: Maybe<User>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  smsBounceReason?: Maybe<Scalars['String']['output']>;
  smsBounced: Scalars['Boolean']['output'];
  smsBouncedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
  /** User info. Available when contact linked to existing user */
  userInfo?: Maybe<UserWithAddress>;
};


export type ContactEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactInvitationStatusArgs = {
  eventId: Scalars['UUID']['input'];
};


export type ContactInviteInfoArgs = {
  eventId: Scalars['UUID']['input'];
};


export type ContactInvitedTicketsArgs = {
  eventId: Scalars['UUID']['input'];
};


export type ContactInviterArgs = {
  eventId: Scalars['UUID']['input'];
};


export type ContactIsInvitedToEventArgs = {
  eventId: Scalars['UUID']['input'];
};


export type ContactOfferInvitationStatusArgs = {
  clubId: Scalars['UUID']['input'];
  offerId: Scalars['UUID']['input'];
};


export type ContactOfferInviterArgs = {
  clubId: Scalars['UUID']['input'];
  offerId: Scalars['UUID']['input'];
};

export type ContactBulkDeleteJobResult = {
  __typename?: 'ContactBulkDeleteJobResult';
  jobId: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ContactBulkDeleteStatusModel = {
  __typename?: 'ContactBulkDeleteStatusModel';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  jobId: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: JobStatus;
  totalCount: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type ContactConnection = {
  __typename?: 'ContactConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContactEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Contact>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContactCopyJobResult = {
  __typename?: 'ContactCopyJobResult';
  jobId: Scalars['String']['output'];
};

export type ContactCopyStatusModel = {
  __typename?: 'ContactCopyStatusModel';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  copiedContactCount: Scalars['Int']['output'];
  failContactCount: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
  newContactIds?: Maybe<Array<Scalars['UUID']['output']>>;
  newGroupId?: Maybe<Scalars['UUID']['output']>;
  processedContacts: Scalars['Int']['output'];
  skippedContactCount: Scalars['Int']['output'];
  sourceContactListId: Scalars['UUID']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: JobStatus;
  totalContacts: Scalars['Int']['output'];
};

export type ContactCountryCity = {
  __typename?: 'ContactCountryCity';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
};

export type ContactCreatedDateRangeInput = {
  /** First day included, in timeZoneId. */
  createdFrom: Scalars['LocalDate']['input'];
  /** Last day included, in timeZoneId. */
  createdTo: Scalars['LocalDate']['input'];
  /** IANA time zone the days are read in, e.g. America/New_York. Defaults to UTC. */
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCustomField = {
  __typename?: 'ContactCustomField';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ContactCustomFieldInput = {
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** An edge in a connection. */
export type ContactEdge = {
  __typename?: 'ContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Contact>;
};

export type ContactExportRow = {
  __typename?: 'ContactExportRow';
  city?: Maybe<Scalars['String']['output']>;
  contactId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  eventCount: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type ContactFieldMappingDtoInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ContactGroup = {
  __typename?: 'ContactGroup';
  /** Number of contacts in the group */
  contactCount?: Maybe<Scalars['Int']['output']>;
  /** Contacts in the group */
  contacts?: Maybe<ContactConnection>;
  groupId: Scalars['UUID']['output'];
  groupName: Scalars['String']['output'];
};


export type ContactGroupContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type ContactGroupConnection = {
  __typename?: 'ContactGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContactGroupEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ContactGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContactGroupEdge = {
  __typename?: 'ContactGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContactGroup>;
};

export type ContactImportFailureDto = {
  __typename?: 'ContactImportFailureDto';
  email?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type ContactImportJobResult = {
  __typename?: 'ContactImportJobResult';
  jobId: Scalars['String']['output'];
  totalRows: Scalars['Int']['output'];
};

export type ContactImportStatusModel = {
  __typename?: 'ContactImportStatusModel';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  failCount: Scalars['Int']['output'];
  failures?: Maybe<Array<ContactImportFailureDto>>;
  jobId: Scalars['String']['output'];
  processedRows: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: JobStatus;
  successCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
};

export enum ContactInviteStatus {
  All = 'ALL',
  Invited = 'INVITED',
  InvitePending = 'INVITE_PENDING',
  NotInvited = 'NOT_INVITED'
}

export type ContactListMutationApi = {
  __typename?: 'ContactListMutationApi';
  /** Accept a contact list share invite. Grants live read access to the sharer's contact list. */
  acceptContactListShare: AcceptContactListShareResult;
  /** Accept a contact share invite. Optionally place the received contacts into a named group. */
  acceptContactShare: AcceptContactShareResult;
  /** Add contacts to group */
  addContactsToGroup: Scalars['Boolean']['output'];
  /** Bulk delete contacts asynchronously. Returns a job ID for tracking progress. */
  bulkDeleteContacts: ContactBulkDeleteJobResult;
  /** Clear the bounce flag on a contact for a given delivery channel. The flag will re-trip on the next failed delivery if nothing actually changed. */
  clearContactBounceFlag: Scalars['Boolean']['output'];
  /** Create or update contact to contact list */
  createOrUpdateContact?: Maybe<Contact>;
  /** Create or update contacts to contact list */
  createOrUpdateContacts?: Maybe<Array<Maybe<ContactMutation>>>;
  /** Create or update group */
  createOrUpdateGroup?: Maybe<ContactGroup>;
  /** Delete contacts */
  deleteContacts: Scalars['Boolean']['output'];
  /** Delete contacts from group */
  deleteContactsFromGroup: Scalars['Boolean']['output'];
  /** Delete group */
  deleteGroup: Scalars['Boolean']['output'];
  /** Import contacts from CSV content. Returns a job ID for async processing. */
  importContactsCsv: ContactImportJobResult;
  /** Revoke a shared contact list so the recipient loses access. */
  revokeContactListShare: Scalars['Boolean']['output'];
  /** Send a message to contacts asynchronously. Returns a job ID for tracking progress. */
  sendMessageToContacts: ContactMessageJobResult;
  /** Share your entire contact list with another user. The recipient gets live read access, not a copy. */
  shareContactList: ContactShareResult;
  /** Share contacts with another user via invitation. The recipient must accept before contacts are added to their account. */
  shareContacts: ContactShareResult;
};


export type ContactListMutationApiAcceptContactListShareArgs = {
  inviteToken: Scalars['String']['input'];
};


export type ContactListMutationApiAcceptContactShareArgs = {
  groupName?: InputMaybe<Scalars['String']['input']>;
  inviteToken: Scalars['String']['input'];
};


export type ContactListMutationApiAddContactsToGroupArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filter?: InputMaybe<ContactPageFilterArgsInput>;
  groupId: Scalars['UUID']['input'];
};


export type ContactListMutationApiBulkDeleteContactsArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filter?: InputMaybe<ContactPageFilterArgsInput>;
};


export type ContactListMutationApiClearContactBounceFlagArgs = {
  channel: DeliveryChannel;
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  contactId: Scalars['UUID']['input'];
};


export type ContactListMutationApiCreateOrUpdateContactArgs = {
  args: ContactModelArgsInput;
  clubId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactListMutationApiCreateOrUpdateContactsArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  contacts: Array<ContactModelArgsInput>;
};


export type ContactListMutationApiCreateOrUpdateGroupArgs = {
  args: GroupModelArgsInput;
  clubId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactListMutationApiDeleteContactsArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filter?: InputMaybe<ContactPageFilterArgsInput>;
};


export type ContactListMutationApiDeleteContactsFromGroupArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filter?: InputMaybe<ContactPageFilterArgsInput>;
  groupId: Scalars['UUID']['input'];
};


export type ContactListMutationApiDeleteGroupArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  groupId: Scalars['UUID']['input'];
};


export type ContactListMutationApiImportContactsCsvArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  csvContent: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  mappings: ContactFieldMappingDtoInput;
};


export type ContactListMutationApiRevokeContactListShareArgs = {
  recipientUserId: Scalars['UUID']['input'];
};


export type ContactListMutationApiSendMessageToContactsArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filter?: InputMaybe<ContactPageFilterArgsInput>;
  isViaEmail: Scalars['Boolean']['input'];
  isViaSms: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  smsMessage?: InputMaybe<Scalars['String']['input']>;
};


export type ContactListMutationApiShareContactListArgs = {
  targetUserId: Scalars['UUID']['input'];
};


export type ContactListMutationApiShareContactsArgs = {
  contactIds: Array<Scalars['UUID']['input']>;
  targetUserId: Scalars['UUID']['input'];
};

export type ContactListQueryApi = {
  __typename?: 'ContactListQueryApi';
  bulkDeleteStatus?: Maybe<ContactBulkDeleteStatusModel>;
  bulkImportStatus?: Maybe<ContactImportStatusModel>;
  cities?: Maybe<Array<Maybe<ContactCountryCity>>>;
  contactListSharePreview: ContactListSharePreviewResult;
  contactSharePreview: ContactSharePreviewResult;
  contacts?: Maybe<ContactsConnection>;
  contactsOffset?: Maybe<ContactModelOffsetPage>;
  count: Scalars['Long']['output'];
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  emailsExist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exportContacts: Array<ContactExportRow>;
  groups?: Maybe<GroupsConnection>;
  messageStatus?: Maybe<ContactMessageStatusModel>;
  phonesExist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shareCopyStatus?: Maybe<ContactCopyStatusModel>;
  sharedContactLists: Array<ContactListShareResult>;
  sharedContactsFromList?: Maybe<SharedContactsFromListConnection>;
  sharedWithUsers: Array<SharedWithUserResult>;
};


export type ContactListQueryApiBulkDeleteStatusArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  jobId: Scalars['String']['input'];
};


export type ContactListQueryApiBulkImportStatusArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  jobId: Scalars['String']['input'];
};


export type ContactListQueryApiCitiesArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactListQueryApiContactListSharePreviewArgs = {
  inviteToken: Scalars['String']['input'];
};


export type ContactListQueryApiContactSharePreviewArgs = {
  inviteToken: Scalars['String']['input'];
};


export type ContactListQueryApiContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  filterArgs: ContactPageFilterArgsInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offerId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactListQueryApiContactsOffsetArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  filterArgs: ContactPageFilterArgsInput;
  limit?: Scalars['Int']['input'];
  offerId?: InputMaybe<Scalars['UUID']['input']>;
  offset?: Scalars['Int']['input'];
};


export type ContactListQueryApiCountArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactListQueryApiCountriesArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactListQueryApiEmailsExistArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  emails: Array<Scalars['String']['input']>;
};


export type ContactListQueryApiExportContactsArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  filterArgs: ContactPageFilterArgsInput;
  offerId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactListQueryApiGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactListQueryApiMessageStatusArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  jobId: Scalars['String']['input'];
};


export type ContactListQueryApiPhonesExistArgs = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  phones: Array<Scalars['String']['input']>;
};


export type ContactListQueryApiShareCopyStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type ContactListQueryApiSharedContactsFromListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactListId: Scalars['UUID']['input'];
  filterArgs: ContactPageFilterArgsInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactListSharePreviewResult = {
  __typename?: 'ContactListSharePreviewResult';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  contactCount: Scalars['Long']['output'];
  isAlreadyAccepted: Scalars['Boolean']['output'];
  sharerUserAvatarUrl?: Maybe<Scalars['String']['output']>;
  sharerUserId: Scalars['UUID']['output'];
  sharerUserName?: Maybe<Scalars['String']['output']>;
};

export type ContactListShareResult = {
  __typename?: 'ContactListShareResult';
  contactCount: Scalars['Long']['output'];
  grantedAt: Scalars['DateTime']['output'];
  sharerContactListId: Scalars['UUID']['output'];
  sharerUserAvatarUrl?: Maybe<Scalars['String']['output']>;
  sharerUserId: Scalars['UUID']['output'];
  sharerUserName?: Maybe<Scalars['String']['output']>;
};

export type ContactMessageFailureDto = {
  __typename?: 'ContactMessageFailureDto';
  channel: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
};

export type ContactMessageJobResult = {
  __typename?: 'ContactMessageJobResult';
  jobId: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ContactMessageStatusModel = {
  __typename?: 'ContactMessageStatusModel';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  failCount: Scalars['Int']['output'];
  failureListTruncated: Scalars['Boolean']['output'];
  failures?: Maybe<Array<ContactMessageFailureDto>>;
  jobId: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: JobStatus;
  suppressedByListCount: Scalars['Int']['output'];
  suppressedCount: Scalars['Int']['output'];
  suppressedUnsubscribedCount: Scalars['Int']['output'];
  suppressedWhitelistCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ContactModelArgsInput = {
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  customFields?: InputMaybe<Array<ContactCustomFieldInput>>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents a slice or page of ContactModel */
export type ContactModelOffsetPage = {
  __typename?: 'ContactModelOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<Contact>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type ContactMutation = {
  __typename?: 'ContactMutation';
  contactId?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customFields?: Maybe<Array<ContactCustomField>>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<UserGender>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  mutationResult: MutationResult;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type ContactPageFilterArgsInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  eventIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  eventTicketIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gender?: InputMaybe<UserGender>;
  groupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  inviteStatus?: ContactInviteStatus;
  keyword?: InputMaybe<Scalars['String']['input']>;
  offerIds?: InputMaybe<Array<ClubOfferIdInput>>;
  sortOrder: PageSortOrder;
  sortType: ContactSortType;
};

export type ContactSharePreviewResult = {
  __typename?: 'ContactSharePreviewResult';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  contactCount: Scalars['Int']['output'];
  isAlreadyAccepted: Scalars['Boolean']['output'];
  sharerUserAvatarUrl?: Maybe<Scalars['String']['output']>;
  sharerUserId: Scalars['UUID']['output'];
  sharerUserName?: Maybe<Scalars['String']['output']>;
};

export type ContactShareResult = {
  __typename?: 'ContactShareResult';
  inviteId: Scalars['UUID']['output'];
  inviteToken: Scalars['String']['output'];
  shareType: ShareType;
};

export enum ContactSortType {
  CreatedAt = 'CREATED_AT',
  ModifiedAt = 'MODIFIED_AT',
  Name = 'NAME'
}

/** A connection to a list of items. */
export type ContactsConnection = {
  __typename?: 'ContactsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContactsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Contact>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContactsEdge = {
  __typename?: 'ContactsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Contact>;
};

export enum ContestEntryType {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  None = 'NONE'
}

export type ContestReferralDetail = {
  __typename?: 'ContestReferralDetail';
  emailAddress?: Maybe<Scalars['String']['output']>;
  enteredAt?: Maybe<Scalars['DateTime']['output']>;
  hasConnectedInstagram: Scalars['Boolean']['output'];
  hasDownloadedApp: Scalars['Boolean']['output'];
  hasProfilePicture: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  userId: Scalars['UUID']['output'];
};

export type ContestWinner = {
  __typename?: 'ContestWinner';
  alreadyWon: Scalars['Boolean']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  fraudFlags: Array<Scalars['String']['output']>;
  instagramHandle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  reachedCountAt?: Maybe<Scalars['DateTime']['output']>;
  referrals: Array<ContestReferralDetail>;
  userId: Scalars['UUID']['output'];
  verifiedReferralCount: Scalars['Int']['output'];
};

export type ContestWinnerOverview = {
  __typename?: 'ContestWinnerOverview';
  entrantCount: Scalars['Int']['output'];
  winners: Array<ContestWinner>;
};

export type ContestWinnerTicket = {
  __typename?: 'ContestWinnerTicket';
  count: Scalars['Int']['output'];
  status: AttendeeFilterStatus;
  ticketId: Scalars['UUID']['output'];
  ticketType?: Maybe<Scalars['String']['output']>;
};

export type CreateAchievementPayloadInput = {
  avatarUrl: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  triggers?: InputMaybe<Array<AchievementTriggerPayloadInput>>;
  type: ClubAchievementType;
};

export type CreateAchievementResult = {
  __typename?: 'CreateAchievementResult';
  achievementId: Scalars['UUID']['output'];
};

export type CreateClubPayloadInput = {
  access?: InputMaybe<ClubAccess>;
  colors?: InputMaybe<ClubColorsInput>;
  description: Scalars['String']['input'];
  joinRequirements?: InputMaybe<ClubRequirementInput>;
  name: Scalars['String']['input'];
  tiers?: InputMaybe<Array<ClubTierPayloadInput>>;
  visibleRequirements?: InputMaybe<ClubRequirementInput>;
};

export type CreateClubResult = {
  __typename?: 'CreateClubResult';
  clubId: Scalars['UUID']['output'];
  prepareUpload?: Maybe<PrepareUploadResponse>;
  resolveClubId: Scalars['UUID']['output'];
};


export type CreateClubResultPrepareUploadArgs = {
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
  type: ClubUploadAsset;
};

export type CreateClubRolePayloadInput = {
  permissions: Array<ClubPermissionId>;
  roleName: Scalars['String']['input'];
};

export type CreateEventRequestAdmin = {
  __typename?: 'CreateEventRequestAdmin';
  kind: CreateEventRequestKind;
  requestId: Scalars['UUID']['output'];
  requestedTime: Scalars['DateTime']['output'];
  resolvedTime?: Maybe<Scalars['DateTime']['output']>;
  status: CreateEventRequestStatus;
  user: CompleteUser;
  userId: Scalars['UUID']['output'];
};

export enum CreateEventRequestKind {
  ContestEvent = 'CONTEST_EVENT',
  CreateEvent = 'CREATE_EVENT'
}

export enum CreateEventRequestStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type CreateEventSeriesRolePayloadInput = {
  permissions: Array<EventSeriesPermissionId>;
  roleName: Scalars['String']['input'];
};

export type CreateEventTicketTypeInput = {
  name: Scalars['String']['input'];
  ticketTypeId: Scalars['UUID']['input'];
  validZones: Array<Scalars['UUID']['input']>;
};

export type CreateEventZoneInput = {
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  zoneId: Scalars['UUID']['input'];
};

export type CreateOfferPayloadInput = {
  access?: InputMaybe<ClubOfferAccess>;
  accessRequirements?: InputMaybe<ClubOfferRequirementInput>;
  configuration?: InputMaybe<OfferConfigurationPayloadInput>;
  offerFlow?: InputMaybe<OfferFlowPayloadInput>;
  published?: InputMaybe<ClubOfferPublished>;
  rewards?: InputMaybe<Array<RewardOfferFlowPayloadInput>>;
  type: OfferType;
  visibilityRequirements?: InputMaybe<ClubOfferRequirementInput>;
};

export type CreateOfferResult = {
  __typename?: 'CreateOfferResult';
  offerId: Scalars['UUID']['output'];
  rewardIds: Array<Scalars['UUID']['output']>;
};

export type CreateUpdateClubRoleResult = {
  __typename?: 'CreateUpdateClubRoleResult';
  roleId: Scalars['UUID']['output'];
};

export type CreateUpdateEventSeriesRoleResult = {
  __typename?: 'CreateUpdateEventSeriesRoleResult';
  roleId: Scalars['UUID']['output'];
};

export type CreatedInvite = {
  __typename?: 'CreatedInvite';
  inviteAcceptLink: Scalars['URL']['output'];
  inviteId: Scalars['String']['output'];
};

export type CreatedTicket = {
  __typename?: 'CreatedTicket';
  ticketId: Scalars['UUID']['output'];
  url: Scalars['String']['output'];
};

export type CurrentUser = BasicUser & {
  __typename?: 'CurrentUser';
  IsPhoneNumberVerified: Scalars['Boolean']['output'];
  /** List accepted invites */
  acceptedInvites?: Maybe<Array<Maybe<AcceptedInvite>>>;
  /**
   * List achievements have been achieved by user
   * @deprecated Please use userAchievements in achievement query instead
   */
  achievements?: Maybe<Array<Maybe<AchievementListType>>>;
  /** The Address of a User */
  address?: Maybe<AddressModel>;
  age?: Maybe<Scalars['Int']['output']>;
  ageRange?: Maybe<Scalars['String']['output']>;
  /** Did the user agree to the latest terms and conditions? */
  agreeToTermsAndConditions: Scalars['Boolean']['output'];
  /** Agree to T&C version */
  agreeToTermsAndConditionsVersion?: Maybe<Scalars['Int']['output']>;
  avatarSource: AvatarSource;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Bio is an optional field that will probably only be filled */
  bio?: Maybe<Scalars['String']['output']>;
  brandedEventId?: Maybe<Scalars['UUID']['output']>;
  /** Branded url is a custom path that can be used to link to a specific event page */
  brandedUrl?: Maybe<Scalars['String']['output']>;
  /** True if the current user is allowed to create pies */
  canCreatePies: Scalars['Boolean']['output'];
  /** True if the user has a connected payment account capable of processing payments */
  canProcessPayment: Scalars['Boolean']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  /** The time in UTC timezone that this account was deleted */
  deletedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Is this account deleted by admin */
  deletedByAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this user has opted out of receiving bulk/invite SMS (OTP/verification still send) */
  disableReceiveSms: Scalars['Boolean']['output'];
  /** Returns true if this account is blocked from SENDING mass/invite SMS (organizer-side). Email still sends. */
  disableSendSms: Scalars['Boolean']['output'];
  displayNameSource: DisplayNameSource;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** User email subscriptions */
  emailSubscriptions?: Maybe<Array<Maybe<EmailSubscription>>>;
  /** Returns true if this account is allowed to create contest events. */
  enableCreateContestEvent: Scalars['Boolean']['output'];
  /** Returns true if this account can create events. */
  enableCreateEvent: Scalars['Boolean']['output'];
  gender?: Maybe<UserGender>;
  /** List holding pies */
  holdingPies?: Maybe<Array<Maybe<HoldingPie>>>;
  /** Instagram avatar URL from connected Instagram account, regardless of which avatar is active */
  instagramAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Instagram display name from connected Instagram account, regardless of which display name is active */
  instagramDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected Instagram account */
  instagramFollowsCount?: Maybe<Scalars['Long']['output']>;
  invitedBy?: Maybe<User>;
  /** Is Repbets Administrator */
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Soft delete flag */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Returns if the current user is already in the waiting list */
  isInWaitingList: Scalars['Boolean']['output'];
  /** Returns if the current user is already skip mfa */
  isSkipMultiFactorAuthentication: Scalars['Boolean']['output'];
  /** Returns if the current user already skipped passkey registration */
  isSkipPasskeyRegistration: Scalars['Boolean']['output'];
  /** If a user have been verified, this will be true */
  isVerified: Scalars['Boolean']['output'];
  /** Clubs where the current user has management access */
  managedClubs: Array<ClubState>;
  /** User club memberships */
  memberships?: Maybe<ClubMembershipWithUserConnection>;
  name?: Maybe<Scalars['String']['output']>;
  /** List payout accounts */
  payoutAccounts?: Maybe<Array<Maybe<PayoutAccount>>>;
  /** List pending invites */
  pendingInvites?: Maybe<Array<Maybe<PendingInvite>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** List users pies */
  pies?: Maybe<PieGrainPageX>;
  /** Information about the users portfolio */
  portfolio?: Maybe<UserPortfolio>;
  /** True when an admin created this account and its owner has not completed the required profile yet. */
  profileCompletionRequired: Scalars['Boolean']['output'];
  /** Per-feature SMS receipt settings (null field = enabled). Overridden by disableReceiveSms. */
  smsNotificationSettings?: Maybe<SmsNotificationSettings>;
  /** List social media connections */
  socialMediaConnections?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  /**
   * List social media connections
   * @deprecated Use socialMediaConnections instead
   */
  socialMedias?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  /** The Stripe payment account for processing payments */
  stripeAccount?: Maybe<UserStripeAccountType>;
  /** User tax configuration for checkout */
  taxConfiguration?: Maybe<UserTaxConfiguration>;
  /** Dictionary contains version and time at the point that user agreed */
  termsAndConditionsAgreedVersions?: Maybe<Array<KeyValuePairOfInt32AndDateTime>>;
  tier: UserTier;
  /** TikTok avatar URL from connected TikTok account, regardless of which avatar is active */
  tikTokAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** TikTok display name from connected TikTok account, regardless of which display name is active */
  tikTokDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected TikTok account */
  tikTokFollowsCount?: Maybe<Scalars['Long']['output']>;
  /** List of users transactions in reverse chronological order */
  transactions?: Maybe<TransactionsConnection>;
  /** Twitch avatar URL from connected Twitch account, regardless of which avatar is active */
  twitchAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Twitch display name from connected Twitch account, regardless of which display name is active */
  twitchDisplayName?: Maybe<Scalars['String']['output']>;
  /** Follower count from connected Twitch account */
  twitchFollowsCount?: Maybe<Scalars['Long']['output']>;
  /** Returns if the current user use biometric */
  useBiometric: Scalars['Boolean']['output'];
  userId: Scalars['UUID']['output'];
  userInvitesRemaining: Scalars['Int']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  verifiedEmailAddress?: Maybe<Scalars['String']['output']>;
  verifiedPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** User walkthrough */
  walkthrough?: Maybe<Array<Maybe<UserWalkthrough>>>;
};


export type CurrentUserHoldingPiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserPiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrentUserTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomProperty = {
  __typename?: 'CustomProperty';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomerInformationPayloadInput = {
  customerInformationScope: CustomerInformationScopePayloadInput;
  guide?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerInformationRewardRedemption = {
  __typename?: 'CustomerInformationRewardRedemption';
  customerInformationScope: CustomerInformationScope;
  guide?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  redemptionType: RewardRedemptionType;
};

export type CustomerInformationScope = {
  __typename?: 'CustomerInformationScope';
  isAddressEnabled: Scalars['Boolean']['output'];
  isEmailEnabled: Scalars['Boolean']['output'];
  isNameEnabled: Scalars['Boolean']['output'];
  isPhoneNumberEnabled: Scalars['Boolean']['output'];
  isSocialMediaAccountEnabled: Scalars['Boolean']['output'];
  isUserNameEnabled: Scalars['Boolean']['output'];
  socialMediaAccountScope: SocialMediaAccountScope;
};

export type CustomerInformationScopePayloadInput = {
  isAddressEnabled: Scalars['Boolean']['input'];
  isEmailEnabled: Scalars['Boolean']['input'];
  isNameEnabled: Scalars['Boolean']['input'];
  isPhoneNumberEnabled: Scalars['Boolean']['input'];
  isSocialMediaAccountEnabled: Scalars['Boolean']['input'];
  isUserNameEnabled: Scalars['Boolean']['input'];
  socialMediaAccountScope: SocialMediaAccountScopePayloadInput;
};

export type DailyScanCount = {
  __typename?: 'DailyScanCount';
  date: Scalars['LocalDate']['output'];
  totalScans: Scalars['Int']['output'];
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeletedPendingInvite = {
  __typename?: 'DeletedPendingInvite';
  actions?: Maybe<Array<InviteActionUnion>>;
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  inviteAcceptLink: Scalars['URL']['output'];
  inviteId: Scalars['String']['output'];
  memo: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  validInvitesRemaining: Scalars['Int']['output'];
};

export type DeliveryAttempt = {
  __typename?: 'DeliveryAttempt';
  bounceReason?: Maybe<Scalars['String']['output']>;
  bouncedAt?: Maybe<Scalars['DateTime']['output']>;
  bulkSendId?: Maybe<Scalars['UUID']['output']>;
  channels: Array<DeliveryChannel>;
  deliveryId: Scalars['UUID']['output'];
  firstViewedAt?: Maybe<Scalars['DateTime']['output']>;
  lastViewedAt?: Maybe<Scalars['DateTime']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reminderTemplateKey?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['DateTime']['output'];
  triggeredBy?: Maybe<User>;
  triggeredByUserId: Scalars['UUID']['output'];
  viewSource?: Maybe<AttributionChannel>;
};

export enum DeliveryChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export enum DeliveryStatus {
  Bounced = 'BOUNCED',
  NotOpened = 'NOT_OPENED',
  Opened = 'OPENED',
  Viewed = 'VIEWED'
}

export type DetailsAttendee = {
  __typename?: 'DetailsAttendee';
  /** User who approved or declined or undo this attendee */
  approvalUser?: Maybe<User>;
  attendeeInfo: EventUserInfo;
  /** Roles assigned to this attendee */
  attendeeRoles?: Maybe<Array<Maybe<EventAttendeeRole>>>;
  /** List of bookings associated with this attendee */
  bookings?: Maybe<Array<Maybe<EventAttendeesBookingInfo>>>;
  checkedInCount: Scalars['Int']['output'];
  /** Eligibility action completion status for review */
  eligibility: AttendeeEligibilityInfo;
  /** Per-criterion match result against this event's configured eligibility criteria. Null if no criteria are configured. */
  eligibilityMatch?: Maybe<AttendeeEligibilityMatch>;
  eventId: Scalars['UUID']['output'];
  /** User who invited this attendee */
  inviter?: Maybe<User>;
  /** Referral share performance for this attendee, aggregated across the event's series if applicable */
  shareStats: AttendeeShareStats;
  status: AttendeeFilterStatus;
  /** List of tickets associated with this attendee */
  tickets: Array<DetailsAttendeeTicket>;
  /** User info */
  user?: Maybe<UserWithAddress>;
  /** Waiver signing status for this attendee based on event configuration and their acceptance state */
  waiverStatus: AttendeeWaiverStatus;
};

/** A connection to a list of items. */
export type DetailsAttendeeConnection = {
  __typename?: 'DetailsAttendeeConnection';
  checkedInCount?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<DetailsAttendeeEdge>>;
  invitedCount?: Maybe<Scalars['Int']['output']>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<DetailsAttendee>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  pendingAttendeesCount?: Maybe<Scalars['Int']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  totalCheckedInCount?: Maybe<Scalars['Int']['output']>;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DetailsAttendeeEdge = {
  __typename?: 'DetailsAttendeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DetailsAttendee>;
};

export type DetailsAttendeeFilterArgsInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  approvalByUserId?: InputMaybe<Scalars['UUID']['input']>;
  eventTicketIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gender?: InputMaybe<UserGender>;
  hasGiftTicket?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantExtraEventTicket?: InputMaybe<Scalars['Boolean']['input']>;
  inviter?: InputMaybe<Scalars['UUID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<PageSortOrder>;
  sortingType?: InputMaybe<AttendeeSortingField>;
  statuses?: InputMaybe<Array<AttendeeFilterStatus>>;
  waiverStates?: InputMaybe<Array<EventPrivacyPolicyState>>;
};

export type DetailsAttendeeTicket = {
  __typename?: 'DetailsAttendeeTicket';
  bookingInfo?: Maybe<EventAttendeesBookingInfo>;
  isSeriesPass: Scalars['Boolean']['output'];
  ticketId: Scalars['UUID']['output'];
  /** Ticket information */
  ticketInfo: StoredTicket;
};

export type DetailsOfferUser = {
  __typename?: 'DetailsOfferUser';
  isWinner?: Maybe<Scalars['Boolean']['output']>;
  offerUserState?: Maybe<OfferUserState>;
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

/** A connection to a list of items. */
export type DetailsOfferUserConnection = {
  __typename?: 'DetailsOfferUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DetailsOfferUserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<DetailsOfferUser>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DetailsOfferUserEdge = {
  __typename?: 'DetailsOfferUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DetailsOfferUser>;
};

export type DetailsOfferUserFilterArgsInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  approvalAt?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<UserGender>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  sortOrder: PageSortOrder;
  sortingType?: InputMaybe<OfferUserSortingField>;
  status?: InputMaybe<OfferUserStatus>;
};

export type DetailsStaffAttendee = {
  __typename?: 'DetailsStaffAttendee';
  attendeeInfo: EventUserInfo;
  checkedInCount: Scalars['Int']['output'];
  eventId: Scalars['UUID']['output'];
  /** List of tickets associated with this attendee */
  tickets: Array<DetailsAttendeeTicket>;
  /** User info */
  user?: Maybe<UserWithAddress>;
};

/** A connection to a list of items. */
export type DetailsStaffAttendeeConnection = {
  __typename?: 'DetailsStaffAttendeeConnection';
  checkedInCount?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<DetailsStaffAttendeeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<DetailsStaffAttendee>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  totalCheckedInCount?: Maybe<Scalars['Int']['output']>;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DetailsStaffAttendeeEdge = {
  __typename?: 'DetailsStaffAttendeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DetailsStaffAttendee>;
};

export type DetailsStaffAttendeeFilterArgsInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<PageSortOrder>;
  sortingType?: InputMaybe<RoleAttendeeSortingField>;
};

export type Device = ILimitedDeviceModel & {
  __typename?: 'Device';
  deviceId: Scalars['String']['output'];
  deviceName?: Maybe<Scalars['String']['output']>;
  platform: DevicePlatform;
  pushEndpointAddress?: Maybe<Scalars['String']['output']>;
  pushNotificationToken: Scalars['String']['output'];
};

export type DeviceApi = {
  __typename?: 'DeviceApi';
  deregister: Scalars['Boolean']['output'];
  register: Scalars['Boolean']['output'];
};


export type DeviceApiDeregisterArgs = {
  deviceId: Scalars['String']['input'];
};


export type DeviceApiRegisterArgs = {
  args: RegisterDeviceArgsInput;
};

export type DeviceInvitation = {
  __typename?: 'DeviceInvitation';
  invitationId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum DevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  IosDebug = 'IOS_DEBUG',
  Web = 'WEB'
}

export type DeviceQueryApi = {
  __typename?: 'DeviceQueryApi';
  list?: Maybe<Array<Maybe<Device>>>;
};

export enum DisclosureBackfillPhase {
  Both = 'BOTH',
  Reindex = 'REINDEX',
  Scan = 'SCAN'
}

export enum DisclosureType {
  Consent = 'CONSENT',
  LiabilityWaiver = 'LIABILITY_WAIVER',
  Nda = 'NDA'
}

export type DisplayEventTicketInfo = {
  __typename?: 'DisplayEventTicketInfo';
  additionalGuests: Scalars['Int']['output'];
  checkedInCount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  eventTicketId: Scalars['UUID']['output'];
  gratuityPercentage?: Maybe<Scalars['Decimal']['output']>;
  price: Scalars['Decimal']['output'];
  ticketType: Scalars['String']['output'];
  tickets?: Maybe<Array<DetailsAttendeeTicket>>;
  totalPrice: Scalars['Decimal']['output'];
};

export enum DisplayNameSource {
  Instagram = 'INSTAGRAM',
  System = 'SYSTEM',
  TikTok = 'TIK_TOK',
  Twitch = 'TWITCH'
}

export type EmailSubscription = {
  __typename?: 'EmailSubscription';
  status: EmailSubscriptionStatus;
  type: EmailSubscriptionType;
};

export type EmailSubscriptionArgsInput = {
  status: EmailSubscriptionStatus;
  type: EmailSubscriptionType;
};

export enum EmailSubscriptionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  None = 'NONE'
}

export enum EmailSubscriptionType {
  Achievement = 'ACHIEVEMENT',
  All = 'ALL',
  CLub = 'C_LUB',
  Event = 'EVENT',
  Marketing = 'MARKETING',
  None = 'NONE',
  Reward = 'REWARD',
  Slice = 'SLICE'
}

/** Payload returned after creating an embedded session. Contains only the information needed by Connect.js. */
export type EmbeddedSessionPayload = {
  __typename?: 'EmbeddedSessionPayload';
  clientSecret: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
};

export type EndedReminderInfo = {
  __typename?: 'EndedReminderInfo';
  armedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  armedForUtc?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['DateTime']['output'];
  eventId: Scalars['UUID']['output'];
  eventSeriesId?: Maybe<Scalars['UUID']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isSeriesParentEvent: Scalars['Boolean']['output'];
  reminderPeriod?: Maybe<Scalars['TimeSpan']['output']>;
  reminderRegistered: Scalars['Boolean']['output'];
  serverNowUtc: Scalars['DateTime']['output'];
  shouldHaveReminder: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type EntryCount = {
  __typename?: 'EntryCount';
  checkedIn: Scalars['Int']['output'];
  entries: Scalars['Int']['output'];
  scans?: Maybe<Scalars['Int']['output']>;
};

export type Event = ILimitedEventModel & {
  __typename?: 'Event';
  achievements?: Maybe<AchievementPageX>;
  /** Age limit of event */
  ageLimit?: Maybe<Scalars['Int']['output']>;
  approvedAttendeeTickets?: Maybe<Array<Maybe<EventAttendeeTicket>>>;
  approvedAttendees?: Maybe<Scalars['Long']['output']>;
  approvedAttendeesList?: Maybe<Array<Maybe<EventAttendeeInfo>>>;
  approvedTickets: Scalars['Long']['output'];
  /** Attendee age range statistic */
  attendeeAgeRangeStatistic?: Maybe<AttendeeAgeRangeStatistic>;
  /** Information of attendee status of current user */
  attendeeInfo?: Maybe<EventAttendeeInfo>;
  attendees?: Maybe<Array<Maybe<EventAttendeeInfo>>>;
  attendeesPage?: Maybe<EventAttendeeInfoPageX>;
  /** Avatar url of event */
  avatarUrl: Scalars['String']['output'];
  canProcessPayment: Scalars['Boolean']['output'];
  /** Club id of event */
  clubId?: Maybe<Scalars['UUID']['output']>;
  coHosts?: Maybe<UserPageX>;
  /** A list of comments on event */
  comments?: Maybe<EventCommentModelPageX>;
  /** A list of scheme of connected social networks */
  connectedSocialNetworks?: Maybe<Array<Scalars['String']['output']>>;
  coordinators?: Maybe<Array<User>>;
  /** Event host or creator */
  createdBy?: Maybe<User>;
  /** Created date of event */
  createdDate: Scalars['DateTime']['output'];
  /** ISO 4217 currency code for event pricing (e.g. USD, GBP) */
  currency?: Maybe<Scalars['String']['output']>;
  /** Description of event */
  description: Scalars['String']['output'];
  /** Disclosure or privacy policy content */
  disclosureOrPrivacyPolicyContent?: Maybe<Scalars['String']['output']>;
  /** Disclosure or privacy policy file url */
  disclosureOrPrivacyPolicyFileUrl?: Maybe<Scalars['String']['output']>;
  /** Disclosure or privacy policy file title */
  disclosureOrPrivacyPolicyTitle?: Maybe<Scalars['String']['output']>;
  /** Display name of event */
  displayName: Scalars['String']['output'];
  /** End date of event */
  endDate: Scalars['DateTime']['output'];
  /** Id of event */
  eventId: Scalars['UUID']['output'];
  /** Id of the Event Series this event belongs to, or null if it is independent */
  eventSeriesId?: Maybe<Scalars['UUID']['output']>;
  /** List event tickets for host */
  eventTickets?: Maybe<EventTicketConnection>;
  /** List event tickets V2 for public */
  eventTickets2?: Maybe<Array<Maybe<EventTicket>>>;
  /** Event type */
  eventType: EventType;
  /** Returns the full exclusiveAvatarUrl (with MediaBaseUrl) if the viewer is the event's creator, an attendee with a role or approved status, or the holder of an approved season pass for the event's series; otherwise returns null */
  exclusiveAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Description of event */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** FAQ entries */
  faqEntries?: Maybe<Array<FaqEntry>>;
  /** FAQs */
  faqs?: Maybe<Scalars['String']['output']>;
  hasAttendeeInfo: Scalars['Boolean']['output'];
  hasRsvpOnlyTicket: Scalars['Boolean']['output'];
  /** Is current user has tickets */
  hasUserEventBookings: Scalars['Boolean']['output'];
  inviterEarnings?: Maybe<Array<Maybe<InviterEarningMetric>>>;
  /** Flag if event is all-in pricing */
  isAllInPricing?: Maybe<Scalars['Boolean']['output']>;
  /** Is current user invited as a attendee role to the event */
  isAttendeeRoleInvited: Scalars['Boolean']['output'];
  isCoHost?: Maybe<Scalars['Boolean']['output']>;
  /** Flag if event is deleted */
  isDeleted: Scalars['Boolean']['output'];
  isEnded?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveAvatarAvailable?: Maybe<Scalars['Boolean']['output']>;
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  /** Is featured event */
  isFeatured: Scalars['Boolean']['output'];
  /** Is current user invited to the event */
  isInvited: Scalars['Boolean']['output'];
  isListFull?: Maybe<Scalars['Boolean']['output']>;
  /** Is listed event */
  isListed?: Maybe<Scalars['Boolean']['output']>;
  /** Flag if event is private */
  isPrivate: Scalars['Boolean']['output'];
  isPromoter?: Maybe<Scalars['Boolean']['output']>;
  /** True only for the hidden event created automatically to back an event series' tickets/payment/revenue — see EventModel.IsSeriesParentEvent. */
  isSeriesParentEvent: Scalars['Boolean']['output'];
  /** Check if current user is a special guest in this event */
  isSpecialGuest: Scalars['Boolean']['output'];
  isSponsor?: Maybe<Scalars['Boolean']['output']>;
  isStarted?: Maybe<Scalars['Boolean']['output']>;
  isTalent?: Maybe<Scalars['Boolean']['output']>;
  /** Location of event */
  location?: Maybe<EventLocation>;
  /** Location with radius of event */
  locationRadius?: Maybe<EventLocation>;
  /** Attendees minimum Rep Score */
  minimumRepScore?: Maybe<Scalars['Decimal']['output']>;
  /** Music embed url */
  musicEmbedUrl?: Maybe<Scalars['String']['output']>;
  myAchievements?: Maybe<Array<Achievement>>;
  /** Names of the series roles the current user holds on this event's parent series (empty when the event is in no series or the user holds none) */
  mySeriesRoles: Array<Scalars['String']['output']>;
  /** Note of event */
  note: Scalars['String']['output'];
  /** Opt-in age limit */
  optInAgeLimit: Scalars['Boolean']['output'];
  /** Opt-in allow guest to invite other guests */
  optInAllowGuestInviteOthers: Scalars['Boolean']['output'];
  /** Opt-in allow public event page preview */
  optInAllowPublicEventPagePreview?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in disclosure or privacy policy */
  optInDisclosureOrPrivacyPolicy: Scalars['Boolean']['output'];
  /** Opt-in display Rep Score */
  optInDisplayRepScore: Scalars['Boolean']['output'];
  /** Opt-in location radius */
  optInLocationRadius: Scalars['Boolean']['output'];
  /** Opt-in question requirements */
  optInQuestionRequirements: Scalars['Boolean']['output'];
  /** Opt-in require guest approval */
  optInRequireGuestApproval: Scalars['Boolean']['output'];
  /** Opt-in show guest count */
  optInShowGuestCount: Scalars['Boolean']['output'];
  /** Opt-in show guest list */
  optInShowGuestList: Scalars['Boolean']['output'];
  /** Opt-in show music embed */
  optInShowMusicEmbed: Scalars['Boolean']['output'];
  /** Opt-in show ticket amount */
  optInShowTicketAmount: Scalars['Boolean']['output'];
  /** Opt-in social account requirements */
  optInSocialAccountRequirements: Scalars['Boolean']['output'];
  /** Opt-in use Repbets QR pass */
  optInUseRepbetsQrPass: Scalars['Boolean']['output'];
  /** The payment processor assigned to this event. Pre-migration events are automatically backfilled on first access. Always returns a non-null value. */
  paymentProcessor: PaymentMethod;
  pendingAttendees?: Maybe<Scalars['Long']['output']>;
  pendingRoleInvites: Array<Scalars['String']['output']>;
  promoters?: Maybe<UserPageX>;
  /** List of question requirements */
  questionRequirements?: Maybe<Array<QuestionRequirement>>;
  recurringId?: Maybe<Scalars['UUID']['output']>;
  /** Require attendees to connect a social account before they can get a ticket */
  requireSocialAccountConnection: Scalars['Boolean']['output'];
  /** True when this event has a disclosure/privacy policy (NDA/waiver) enabled and the current viewer has no valid signature for its current document version. Signatures are matched by the policy file's content checksum, so an updated NDA reopens signing; within an event series a signature on any member event counts series-wide. False for anonymous viewers and events without a disclosure. */
  requiresDisclosureSignature: Scalars['Boolean']['output'];
  /** List of scanning zones */
  scanningZones?: Maybe<Array<ScanningZone>>;
  /** Attendee state of the current user's season pass for this event's series, read from the series' hidden parent event: InviteeAccepted while the pass awaits host approval, Approved once issued. Null when the event is in no series or the user holds no pass. For events listed because of a pass, where attendeeInfo is empty. */
  seriesPassAttendeeState?: Maybe<EventAttendeeState>;
  /** Season-pass ticket types of the series this event belongs to, read live from the series' hidden parent event — empty for an event that isn't in a series. Lets hosts offer a pass (e.g. comp or private invites) from a member event; grants of these ticket types are issued on the parent event. */
  seriesPassTickets?: Maybe<EventTicketConnection>;
  /** Holders of the parent series' Host, Talent and Sponsor roles, shown in the event's public team alongside the event-level roles. Empty when the event is in no series. */
  seriesTeam: Array<EventSeriesTeamMember>;
  /**
   * Season-pass holders expected at this event, read live from the series' hidden parent event — empty for an event that doesn't belong to a series, or if the caller lacks attendee-viewing permission. Lets hosts see expected series-ticket attendees before they check in.
   * @deprecated Series pass holders are listed in detailsAttendees, with their passes marked isSeriesPass.
   */
  seriesTicketHolders: Array<SeriesTicketHolderInfo>;
  /** Slug of event */
  slug: Scalars['String']['output'];
  /** List of social account requirements */
  socialAccountRequirements?: Maybe<Array<SocialAccountRequirement>>;
  sponsors?: Maybe<UserPageX>;
  /** Start date of event */
  startDate: Scalars['DateTime']['output'];
  /** Description of event */
  status: EventStatus;
  /** The Talent shown on the event page, in display order: the event's own talent followed by the parent series' Talent role holders (each person once), arranged by the saved Talent order. Clients render this as is. */
  talentLineup: Array<User>;
  /** Display order of the Talent list, as user ids, covering event-level and series-level talent. An event in a series shares the series' order. It may name only some people; the rest keep their place. Empty when no order was set. */
  talentOrder: Array<Scalars['UUID']['output']>;
  talents?: Maybe<Array<User>>;
  /** Jurisdiction-aware tax-collection posture for the event owner's connected account: whether any active Stripe Tax registration exists, the owner's home (head-office) state, and whether they're registered there. Under automatic tax, an owner not registered where they have nexus collects no tax on this event's sales, so co-hosts and the owner can see the gap on the event dashboard. */
  taxCollection?: Maybe<StripeTaxCollectionStatus>;
  /** The event owner's tax configuration, which is applied to this event's sales. */
  taxConfiguration?: Maybe<UserTaxConfiguration>;
  /** Terms and Conditions */
  terms?: Maybe<Scalars['String']['output']>;
  /** Ticket terms & purchase policy */
  ticketTermsPurchasePolicy?: Maybe<Scalars['String']['output']>;
  /** A list of my tickets associated with this event */
  tickets?: Maybe<Array<Maybe<TicketWithIdOfStoredTicket>>>;
  /** Event time zone */
  timeZone?: Maybe<Scalars['String']['output']>;
  totalAttendees?: Maybe<Scalars['Long']['output']>;
  /** @deprecated To be removed. Must use FullEventType for totalEarnings! */
  totalEarnings?: Maybe<Scalars['Decimal']['output']>;
  totalEventTickets?: Maybe<Scalars['Long']['output']>;
  /** Updated date of event */
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Uploaded asset id of event */
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
  /** A list of my ticket bookings associated with this event */
  userEventBookings?: Maybe<Array<Maybe<EventAttendeesBookingInfo>>>;
  /** List of ticket ids that user waiting for amount available */
  waitingTickets?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
};


export type EventAchievementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type EventAttendeeAgeRangeStatisticArgs = {
  attendeeFilterStatus?: InputMaybe<AttendeeFilterStatus>;
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
};


export type EventAttendeesPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type EventCoHostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type EventCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type EventEventTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EventPromotersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSeriesPassTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSponsorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type EventAttendeeInfo = {
  __typename?: 'EventAttendeeInfo';
  attendeeInfo?: Maybe<EventUserInfo>;
  userInfo?: Maybe<UserWithAddress>;
};

export type EventAttendeeInfoEdgeX = {
  __typename?: 'EventAttendeeInfoEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<EventAttendeeInfo>;
};

/** Represents a slice or page */
export type EventAttendeeInfoPageX = {
  __typename?: 'EventAttendeeInfoPageX';
  /** A list of edges */
  edges: Array<EventAttendeeInfoEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<EventAttendeeInfo>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export enum EventAttendeeRole {
  Coordinator = 'COORDINATOR',
  CoHost = 'CO_HOST',
  Door = 'DOOR',
  None = 'NONE',
  Producer = 'PRODUCER',
  Promoter = 'PROMOTER',
  Sponsor = 'SPONSOR',
  Talent = 'TALENT',
  Vip = 'VIP'
}

export type EventAttendeeRoleDeleteArgsInput = {
  role: EventAttendeeRole;
  userKey: Scalars['String']['input'];
};

export enum EventAttendeeState {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Invited = 'INVITED',
  InviteeAccepted = 'INVITEE_ACCEPTED',
  InviteeDeclined = 'INVITEE_DECLINED',
  None = 'NONE'
}

export type EventAttendeeTicket = {
  __typename?: 'EventAttendeeTicket';
  eventTicketInfo: EventTicket;
  purchasedTicketInfo: EventTicketPurchaseInfoLite;
  userInfo?: Maybe<User>;
};

export type EventAttendeesBookingInfo = {
  __typename?: 'EventAttendeesBookingInfo';
  acceptedById?: Maybe<Scalars['UUID']['output']>;
  /** Information of attendee status of transaction user */
  attendeeInfo?: Maybe<EventAttendeeInfo>;
  captureOrderId?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['DateTime']['output'];
  /** Information of event */
  event?: Maybe<LimitedEvent>;
  eventId: Scalars['UUID']['output'];
  /** Even tickets that user has purchased */
  eventTickets?: Maybe<Array<Maybe<EventTicketPurchaseInfo>>>;
  extraSenderId?: Maybe<Scalars['UUID']['output']>;
  giftSenderId?: Maybe<Scalars['UUID']['output']>;
  items?: Maybe<Array<PaymentItems>>;
  paidDateUtc?: Maybe<Scalars['DateTime']['output']>;
  parentTicketId?: Maybe<Scalars['UUID']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  quantity: Scalars['Decimal']['output'];
  /** Shipping address for this booking's order, when it has one (Ship-fulfillment items only). Requires organizer/co-host attendee-view permission on the event, checked here explicitly since detailsAttendee/detailsAttendees carry no authorization of their own. */
  shippingAddress?: Maybe<AddressModel>;
  status?: Maybe<PaymentStatus>;
  /** A list of user ticket tickets associated with this booking */
  tickets?: Maybe<Array<Maybe<TicketWithIdOfStoredTicket>>>;
  totalPrice: Scalars['Decimal']['output'];
  transactionId: Scalars['UUID']['output'];
  /** Transaction information */
  transactionInfo?: Maybe<TradingTransaction>;
  transactionStatus: TransactionStatus;
  transferedTickets?: Maybe<Array<TransactionTransferOutTicketArgs>>;
  type: TransactionType;
  updateAtUtc: Scalars['DateTime']['output'];
  user?: Maybe<UserWithGeneralLocation>;
  userId: Scalars['UUID']['output'];
};

export type EventAttendeesBookingInfoEdgeX = {
  __typename?: 'EventAttendeesBookingInfoEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<EventAttendeesBookingInfo>;
};

/** Represents a slice or page */
export type EventAttendeesBookingInfoPageX = {
  __typename?: 'EventAttendeesBookingInfoPageX';
  /** A list of edges */
  edges: Array<EventAttendeesBookingInfoEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<EventAttendeesBookingInfo>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type EventBillInfo = {
  __typename?: 'EventBillInfo';
  processingFee: Scalars['Decimal']['output'];
  serviceFee: Scalars['Decimal']['output'];
  subTotal: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
};

export type EventBookingFilterArgsInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  eventTicketType?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<PageSortOrder>;
  sortingType?: InputMaybe<EventBookingSortingType>;
  statuses?: InputMaybe<Array<TransactionStatus>>;
};

export enum EventBookingSortingType {
  Age = 'AGE',
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Gender = 'GENDER',
  Name = 'NAME',
  ParticipatedDate = 'PARTICIPATED_DATE',
  Pending = 'PENDING'
}

export type EventComment = {
  __typename?: 'EventComment';
  comment: Scalars['String']['output'];
  commentId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventId: Scalars['UUID']['output'];
  medias: Array<Scalars['String']['output']>;
  parentCommentId?: Maybe<Scalars['UUID']['output']>;
  /** Reactions list of comment */
  reactions?: Maybe<Array<Maybe<EventCommentReaction>>>;
  /** Replies list of comment */
  replies?: Maybe<EventCommentModelPageX>;
  user: User;
};


export type EventCommentReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type EventCommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type EventCommentModelEdgeX = {
  __typename?: 'EventCommentModelEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<EventComment>;
};

/** Represents a slice or page */
export type EventCommentModelPageX = {
  __typename?: 'EventCommentModelPageX';
  /** A list of edges */
  edges: Array<EventCommentModelEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<EventComment>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type EventCommentReaction = {
  __typename?: 'EventCommentReaction';
  commentId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventId: Scalars['UUID']['output'];
  reaction: Scalars['String']['output'];
  reactionId: Scalars['UUID']['output'];
  user: User;
};

export type EventDevice = {
  __typename?: 'EventDevice';
  assignedDeviceId?: Maybe<Scalars['UUID']['output']>;
  invitationId: Scalars['String']['output'];
  notAfter: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  zoneId?: Maybe<Scalars['UUID']['output']>;
};

export type EventEarningsFilterInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includeAllEventTickets?: InputMaybe<Scalars['Boolean']['input']>;
  inviterIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  onlyCreatedEvents?: InputMaybe<Scalars['Boolean']['input']>;
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventEarningsStatistics = {
  __typename?: 'EventEarningsStatistics';
  hostBalance: Scalars['Decimal']['output'];
  processingFee: Scalars['Decimal']['output'];
  serviceFee: Scalars['Decimal']['output'];
  subTotal: Scalars['Decimal']['output'];
  ticketBreakdown: Array<TicketEarningsBreakdown>;
  totalFees: Scalars['Decimal']['output'];
  totalGratuity: Scalars['Decimal']['output'];
  totalPrice: Scalars['Decimal']['output'];
  totalQuantity: Scalars['Int']['output'];
  totalTaxes: Scalars['Decimal']['output'];
};

export type EventEdgeX = {
  __typename?: 'EventEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Event>;
};

export type EventEligibilityCriteria = {
  __typename?: 'EventEligibilityCriteria';
  minShareClicks?: Maybe<Scalars['Int']['output']>;
  minShareLogins?: Maybe<Scalars['Int']['output']>;
  minShareTicketAcquisitions?: Maybe<Scalars['Int']['output']>;
  requireAppDownload: Scalars['Boolean']['output'];
  requireInstagramConnected: Scalars['Boolean']['output'];
  requireProfilePicture: Scalars['Boolean']['output'];
  requireShare: Scalars['Boolean']['output'];
};

export type EventEligibilityCriteriaInput = {
  minShareClicks?: InputMaybe<Scalars['Int']['input']>;
  minShareLogins?: InputMaybe<Scalars['Int']['input']>;
  minShareTicketAcquisitions?: InputMaybe<Scalars['Int']['input']>;
  requireAppDownload: Scalars['Boolean']['input'];
  requireInstagramConnected: Scalars['Boolean']['input'];
  requireProfilePicture: Scalars['Boolean']['input'];
  requireShare: Scalars['Boolean']['input'];
};

export type EventEntryStats = {
  __typename?: 'EventEntryStats';
  /** The event's own limited ticket capacity plus the series pass capacity, in tickets (each unit of capacity with its +1 guests). Null when either has an unlimited ticket type, so a percentage of capacity is not defined. */
  capacity?: Maybe<Scalars['Int']['output']>;
  /** Own check-ins + pass holders checked in + pass guests checked in */
  checkedIn: Scalars['Int']['output'];
  /** Own entries + pass holders + pass guests */
  entries: Scalars['Int']['output'];
  eventId: Scalars['UUID']['output'];
  /** The event's own tickets. Scans is not computed for these and is null. */
  own: EntryCount;
  /** +1 guest tickets valid at this event */
  passGuests: EntryCount;
  /** Series pass tickets: an entry at every member event while the pass is valid */
  passHolders: EntryCount;
  /** The +1 guests of this event beyond passGuests (whose entries are every +1 that counts here): shared with a guest, live (issued for this event and not expired, the health view's active count) and everyEvent (valid at every event, never expire with one). */
  plusOnes?: Maybe<PlusOneBreakdown>;
};

/** Represents a slice or page */
export type EventGrainPageX = {
  __typename?: 'EventGrainPageX';
  /** A list of edges */
  edges: Array<EventEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<Event>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type EventGuest = {
  __typename?: 'EventGuest';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['UUID']['output'];
  customFields: Array<GuestCustomField>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['UUID']['output'];
  eventTicketIds?: Maybe<Array<Scalars['UUID']['output']>>;
  fullName: Scalars['String']['output'];
  guestId: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  qrPassCheckedInQuantity?: Maybe<Scalars['Int']['output']>;
  qrPassEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who last scanned this guest's shared QR pass */
  qrPassLastScannedBy?: Maybe<CompleteUser>;
  qrPassQuantity?: Maybe<Scalars['Int']['output']>;
  qrPassTextSentAt?: Maybe<Scalars['DateTime']['output']>;
  tickets?: Maybe<Array<Maybe<EventGuestTicket>>>;
};

export type EventGuestInfoArgsInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<GuestCustomFieldInput>>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  qrPassQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type EventGuestRowArgsInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<GuestCustomFieldInput>>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  eventTicketId: Scalars['UUID']['input'];
  fullName: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  parentRef?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  ref: Scalars['String']['input'];
};

export type EventGuestTicket = {
  __typename?: 'EventGuestTicket';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  checkedInAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['UUID']['output'];
  eventTicket?: Maybe<EventTicket>;
  eventTicketId: Scalars['UUID']['output'];
  guestId: Scalars['UUID']['output'];
  guestName: Scalars['String']['output'];
  /** The user who scanned this attendee in */
  scannedBy?: Maybe<CompleteUser>;
  ticketId: Scalars['UUID']['output'];
  ticketNo: Scalars['Int']['output'];
};

export type EventGuestTicketArgsInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  eventTicketId: Scalars['UUID']['input'];
  guestName?: InputMaybe<Scalars['String']['input']>;
};

export type EventInvitation = {
  __typename?: 'EventInvitation';
  attendeeState?: Maybe<EventAttendeeState>;
  bulkSendId?: Maybe<Scalars['UUID']['output']>;
  event?: Maybe<FullEvent>;
  giftTickets?: Maybe<GiftTicketsArgs>;
  invitationMessage?: Maybe<Scalars['String']['output']>;
  invitationSource: EventInvitationSource;
  invitationSourceKey: Scalars['String']['output'];
  invitedAt: Scalars['DateTime']['output'];
  invitees: Array<EventInviteeInfo>;
  inviterId: Scalars['UUID']['output'];
  isResend: Scalars['Boolean']['output'];
  isViaSms: Scalars['Boolean']['output'];
  linkOffersArgs?: Maybe<LinkOffersArgs>;
  privateTicketsArgs?: Maybe<PrivateTicketsArgs>;
  smsMessage?: Maybe<Scalars['String']['output']>;
  type: EventInvitationKind;
};

export enum EventInvitationKind {
  Attendee = 'ATTENDEE',
  Coordinator = 'COORDINATOR',
  CoHost = 'CO_HOST',
  Door = 'DOOR',
  LinkOffer = 'LINK_OFFER',
  Promoter = 'PROMOTER',
  Sponsor = 'SPONSOR',
  Talent = 'TALENT'
}

export enum EventInvitationSource {
  Contact = 'CONTACT',
  Direct = 'DIRECT',
  PreviousEvent = 'PREVIOUS_EVENT',
  SavedList = 'SAVED_LIST'
}

export type EventInvitationSourceArgsInput = {
  directInvitees?: InputMaybe<Array<GuestInvitationInfoInput>>;
  key: Scalars['String']['input'];
  source: EventInvitationSource;
  type: EventInvitationKind;
};

export type EventInviteeInfo = {
  __typename?: 'EventInviteeInfo';
  contactId?: Maybe<Scalars['UUID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  plus1?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type EventLocation = {
  __typename?: 'EventLocation';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isOnlyVisibleToApprovedAttendees?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  unitLengthType?: Maybe<EventLocationUnitLengthType>;
};

export type EventLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlyVisibleToApprovedAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  unitLengthType?: InputMaybe<EventLocationUnitLengthType>;
};

export enum EventLocationUnitLengthType {
  Kilometers = 'KILOMETERS',
  Miles = 'MILES',
  None = 'NONE'
}

export type EventMessageFilterArgs = {
  __typename?: 'EventMessageFilterArgs';
  attendeeStatuses?: Maybe<Array<SendMessageGroupAttendeeStatus>>;
  eventAttendeeRoles?: Maybe<Array<EventAttendeeRole>>;
  eventMessageType: EventMessageType;
  eventTicketIds?: Maybe<Array<Scalars['UUID']['output']>>;
};

export type EventMessageFilterArgsInput = {
  attendeeStatuses?: InputMaybe<Array<SendMessageGroupAttendeeStatus>>;
  eventAttendeeRoles?: InputMaybe<Array<EventAttendeeRole>>;
  eventMessageType: EventMessageType;
  eventTicketIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export enum EventMessageType {
  AttendeeStatus = 'ATTENDEE_STATUS',
  None = 'NONE',
  Role = 'ROLE',
  TicketType = 'TICKET_TYPE'
}

export type EventMutationApi = {
  __typename?: 'EventMutationApi';
  /** Add attendee role */
  addAttendeeRole: Scalars['Boolean']['output'];
  /** Add co-host */
  addCoHost: Scalars['Boolean']['output'];
  /** Add permissions for door role */
  addDoorRole: Scalars['Boolean']['output'];
  /** Add event guest */
  addEventGuest: Scalars['UUID']['output'];
  /** Add event guest ticket */
  addEventGuestTicket: Scalars['Boolean']['output'];
  /** Add event guests */
  addEventGuests: AddGuestsResult;
  /**
   * Add guest
   * @deprecated Use addEventGuest instead.
   */
  addGuest: Array<Scalars['UUID']['output']>;
  /**
   * Add a guest QR pass — one guest entry with a single QR code scannable up to its quantity
   * @deprecated Use addEventGuest (no tickets, with qrPassQuantity set) followed by shareGuestQr instead — addEventGuest alone does not send the pass automatically.
   */
  addGuestQrPass: Scalars['UUID']['output'];
  /**
   * Add guests
   * @deprecated Use addEventGuests instead.
   */
  addGuests: AddGuestsResult;
  /** Add promoter */
  addPromoter: Scalars['Boolean']['output'];
  /** Answer question requirements */
  answerQuestionRequirements: Scalars['Boolean']['output'];
  /** Approve one or more RSVP(s) of event */
  approve: Scalars['Int']['output'];
  /** Approve attendee */
  approveAttendee: AttendeeApprovalResponse;
  /** Cancel a sent or viewed invitation by removing the host-facing index doc. The original invite link remains valid (can't recall an email or SMS), but the invitee no longer appears on the Invitees screen and won't be re-counted in stats. */
  cancelInvitation: Scalars['Boolean']['output'];
  /** Cancel a pending scheduled message */
  cancelScheduledEventMessage: Scalars['Boolean']['output'];
  /** Change the display identifier for multiple existing tickets. */
  changeDisplayTickets: Scalars['Boolean']['output'];
  /** Move an attendee to a series ticket or pass: grants it on the series' parent event and revokes their ticket for this event. */
  changeTicketToSeriesPass: Scalars['Boolean']['output'];
  /** Check in event guest ticket */
  checkInEventGuestTicket: Scalars['Boolean']['output'];
  /**
   * Check in guest without ticket
   * @deprecated Use checkInEventGuestTicket instead.
   */
  checkInGuest: GuestInfo;
  /** Add comment to event */
  comment?: Maybe<EventComment>;
  /** Confirm Event Privacy Policy */
  confirmEventPrivacyPolicy: ConfirmEventPrivacyPolicyResult;
  /** Connect social account */
  connectSocialAccount: Scalars['Boolean']['output'];
  /** PLACEHOLDER: Create or update a event */
  createOrUpdate: PublicEventModel;
  /** Create Payment Order */
  createPaymentOrder: Scalars['String']['output'];
  createRecurringEvent: PublicEventModel;
  /** Decline one or more RSVP(s) of event */
  decline: Scalars['Int']['output'];
  /** Decline attendee */
  declineAttendee: AttendeeApprovalResponse;
  /** Delete event */
  delete: Scalars['Boolean']['output'];
  /** Delete event guest */
  deleteEventGuest: Scalars['Boolean']['output'];
  /** Delete event guest ticket */
  deleteEventGuestTicket: Scalars['Boolean']['output'];
  /** Delete event ticket type */
  deleteEventTicket: Scalars['Boolean']['output'];
  /** Delete free ticket */
  deleteFreeTicket: Scalars['Boolean']['output'];
  /**
   * Delete guest
   * @deprecated Use deleteEventGuest instead.
   */
  deleteGuest: Scalars['Boolean']['output'];
  /** Generate invite link */
  generateInviteLink: Scalars['URL']['output'];
  generateShareTicketLink: Scalars['String']['output'];
  /** Generate QR code for ticket */
  generateTicketQrCode: QrCodeModel;
  /** Get test ticket */
  getTestTicket: TicketGrantResult;
  /** Grant extra ticket to user */
  grantTickets: Scalars['Boolean']['output'];
  /** Increase max tickets amount */
  increaseMaxTicketsAmount: Scalars['Boolean']['output'];
  /**
   * Deprecated. Use startBulkInvite instead. Always throws BadRequestDeprecatedUseBulkInvite.
   * @deprecated use startBulkInvite instead
   */
  inviteFromContacts: Scalars['Boolean']['output'];
  /**
   * Deprecated. Use startBulkInvite instead. Currently functional but logs a warning on every call.
   * @deprecated use startBulkInvite instead
   */
  inviteFromContacts2: InviteFromContactResult;
  joinEventTicketWaitingList: Scalars['Boolean']['output'];
  leaveEventTicketWaitingList: Scalars['Boolean']['output'];
  linkClubOffers: LinkClubOfferResult;
  /** Add reaction to comment */
  reactComment?: Maybe<EventCommentReaction>;
  /** Remove attendee role */
  removeAttendeeRole: Scalars['Boolean']['output'];
  /** Remove co-host */
  removeCoHost: Scalars['Boolean']['output'];
  /** Remove reaction from comment */
  removeCommentReaction: Scalars['Boolean']['output'];
  /** Remove permissions for door role */
  removeDoorRole: Scalars['Boolean']['output'];
  /** Remove saved guest list */
  removeGuestList: Scalars['Boolean']['output'];
  removePendingRole: Scalars['Boolean']['output'];
  /** Remove promoter */
  removePromoter: Scalars['Boolean']['output'];
  /**
   * Request payout for event
   * @deprecated Please use requestEventPayout2 instead.
   */
  requestEventPayout: Scalars['Boolean']['output'];
  /** Request payout for event V2 */
  requestEventPayout2: Scalars['Boolean']['output'];
  /** Re-send a specific prior invitation send to a contact. contactId is optional — pass sendId when the invitee has no contact record (e.g. an unregistered invitee) and the target send will be resolved from it instead. When sendId is null and contactId is present, the latest send is replayed. Flagged IsResend so comp tickets are not re-granted and private-ticket allotments are not duplicated. Returns the original ticket args / message so the FE can echo them back to the host for confirmation. */
  resendInvitation?: Maybe<ResendInvitationResult>;
  /**
   * [DEPRECATED] RSVP for event. Free-RSVP events are no longer supported — every event must have at least one ticket, and attendees should book a ticket instead.
   * @deprecated rsvpForEvent is deprecated. Free-RSVP events are no longer supported — every event must have at least one ticket, and attendees should book a ticket instead.
   */
  rsvpForEvent: EventAttendeeState;
  /** Save guest list for later use. Returns guest list name */
  saveGuestList: Scalars['String']['output'];
  /** Schedule a message to be sent to an event's attendees at a future time */
  scheduleEventMessage: ScheduledMessageModel;
  /** Send message group for event */
  sendMessageGroup: Scalars['Boolean']['output'];
  /** Send a copy of the signed disclosure */
  sendSignedDisclosureCopy: Scalars['Boolean']['output'];
  /** Share (or resend) a guest's QR pass via email and/or text */
  shareGuestQr: Scalars['Boolean']['output'];
  /** Share ticket to another user */
  shareTicket: Scalars['Boolean']['output'];
  /** Start async bulk invite from contacts */
  startBulkInvite: Scalars['String']['output'];
  /** Kick off an async bulk-resend job for every invitee matching the filter. Skips invitees who have accepted, have no resolvable identifier (contact/user/email/phone), or whose last delivery bounced (unless includeBounced is true). Returns a jobId for status polling via getBulkInviteStatus — bulk resend jobs share the same status surface as bulk invites. */
  startBulkResend: Scalars['String']['output'];
  /** Verify Ticket */
  ticketVerify?: Maybe<TicketVerifyResult>;
  /** Verify Ticket with QR Code V2 */
  ticketVerify2?: Maybe<TicketVerifyResult>;
  /** Track that the current user viewed an event via a share link */
  trackShareLinkView: Scalars['Boolean']['output'];
  /** Undo attendee */
  undoAttendee: AttendeeApprovalResponse;
  /** Undo check in event guest ticket */
  undoCheckInEventGuestTicket: Scalars['Boolean']['output'];
  /**
   * Undo check in guest without ticket
   * @deprecated Use undoCheckInEventGuestTicket instead.
   */
  undoCheckInGuest: GuestInfo;
  /** Undo free ticket approval */
  undoFreeTicketApproval: Scalars['Boolean']['output'];
  /** Update event guest */
  updateEventGuest: Scalars['Boolean']['output'];
  /** Update event guest ticket */
  updateEventGuestTicket: Scalars['Boolean']['output'];
  /**
   * Update guest
   * @deprecated Use updateEventGuest instead.
   */
  updateGuest: Scalars['Boolean']['output'];
  /** Edit a scheduled message that has not yet been sent */
  updateScheduledEventMessage: ScheduledMessageModel;
  /** Verify Ticket */
  verifyTicket?: Maybe<TicketVerifyResult>;
  /** Verify Ticket QR Code */
  verifyTicketQrCode?: Maybe<TicketVerifyResult>;
};


export type EventMutationApiAddAttendeeRoleArgs = {
  attendeeRole: EventAttendeeRole;
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventMutationApiAddCoHostArgs = {
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventMutationApiAddDoorRoleArgs = {
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventMutationApiAddEventGuestArgs = {
  eventId: Scalars['UUID']['input'];
  guest: EventGuestInfoArgsInput;
  tickets: Array<AddEventGuestTicketArgsInput>;
};


export type EventMutationApiAddEventGuestTicketArgs = {
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  ticket: AddEventGuestTicketArgsInput;
};


export type EventMutationApiAddEventGuestsArgs = {
  eventId: Scalars['UUID']['input'];
  guests: Array<AddEventGuestRowArgsInput>;
};


export type EventMutationApiAddGuestArgs = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<GuestCustomFieldInput>>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['UUID']['input'];
  eventTicketId: Scalars['UUID']['input'];
  fullName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  quantity?: Scalars['Int']['input'];
};


export type EventMutationApiAddGuestQrPassArgs = {
  args: AddGuestQrPassArgsInput;
  eventId: Scalars['UUID']['input'];
};


export type EventMutationApiAddGuestsArgs = {
  eventId: Scalars['UUID']['input'];
  guests: Array<EventGuestRowArgsInput>;
};


export type EventMutationApiAddPromoterArgs = {
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventMutationApiAnswerQuestionRequirementsArgs = {
  eventId: Scalars['UUID']['input'];
  questionRequirementAnswers: Array<QuestionRequirementAnswerInput>;
};


export type EventMutationApiApproveArgs = {
  eventId: Scalars['UUID']['input'];
  filterArgs?: InputMaybe<DetailsAttendeeFilterArgsInput>;
  forceRelease?: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type EventMutationApiApproveAttendeeArgs = {
  attendeeId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  forceRelease?: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type EventMutationApiCancelInvitationArgs = {
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['UUID']['input'];
  inviteeUserId?: InputMaybe<Scalars['UUID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type EventMutationApiCancelScheduledEventMessageArgs = {
  eventId: Scalars['UUID']['input'];
  scheduledMessageId: Scalars['UUID']['input'];
};


export type EventMutationApiChangeDisplayTicketsArgs = {
  changes: Array<ChangeDisplayTicketIdInput>;
  eventId: Scalars['UUID']['input'];
};


export type EventMutationApiChangeTicketToSeriesPassArgs = {
  eventId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  seriesPassTicketId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
};


export type EventMutationApiCheckInEventGuestTicketArgs = {
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
};


export type EventMutationApiCheckInGuestArgs = {
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
};


export type EventMutationApiCommentArgs = {
  content: Scalars['String']['input'];
  eventId: Scalars['UUID']['input'];
  medias?: InputMaybe<Array<Scalars['String']['input']>>;
  parentCommentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type EventMutationApiConfirmEventPrivacyPolicyArgs = {
  disclosureType?: DisclosureType;
  eventId: Scalars['UUID']['input'];
  memberEventId?: InputMaybe<Scalars['UUID']['input']>;
  privacyPolicyState: EventPrivacyPolicyState;
  signatoryName?: InputMaybe<Scalars['String']['input']>;
  signatureData?: InputMaybe<Scalars['String']['input']>;
};


export type EventMutationApiConnectSocialAccountArgs = {
  eventId: Scalars['UUID']['input'];
  scheme: Scalars['String']['input'];
};


export type EventMutationApiCreateOrUpdateArgs = {
  adminUpdate?: Scalars['Boolean']['input'];
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  avatarUrl: Scalars['String']['input'];
  clubSlugOrId?: InputMaybe<Scalars['String']['input']>;
  coHostUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  coordinatorUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  copiedFromEventSlugOrId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  disclosureOrPrivacyPolicyContent?: InputMaybe<Scalars['String']['input']>;
  disclosureOrPrivacyPolicyFileUrl?: InputMaybe<Scalars['String']['input']>;
  disclosureOrPrivacyPolicyTitle?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  doorUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  eligibilityCriteria?: InputMaybe<EventEligibilityCriteriaInput>;
  endDate: Scalars['DateTime']['input'];
  eventSeriesId?: InputMaybe<Scalars['UUID']['input']>;
  eventTickets?: InputMaybe<Array<EventTicketArgsInput>>;
  eventTimeZoneId?: InputMaybe<Scalars['String']['input']>;
  eventType?: EventType;
  exclusiveAvatarUrl?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  faqEntries?: InputMaybe<Array<FaqEntryInput>>;
  faqs?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitations?: InputMaybe<Array<EventInvitationSourceArgsInput>>;
  isAllInPricing?: InputMaybe<Scalars['Boolean']['input']>;
  isListed?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: Scalars['Boolean']['input'];
  location?: InputMaybe<EventLocationInput>;
  locationRadius?: InputMaybe<EventLocationInput>;
  minimumRepScore?: InputMaybe<Scalars['Decimal']['input']>;
  musicEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  optInAgeLimit?: InputMaybe<Scalars['Boolean']['input']>;
  optInAllowGuestInviteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  optInAllowPublicEventPagePreview?: InputMaybe<Scalars['Boolean']['input']>;
  optInDisclosureOrPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  optInDisplayRepScore?: InputMaybe<Scalars['Boolean']['input']>;
  optInLocationRadius?: InputMaybe<Scalars['Boolean']['input']>;
  optInQuestionRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  optInRequireGuestApproval?: InputMaybe<Scalars['Boolean']['input']>;
  optInShowGuestCount?: InputMaybe<Scalars['Boolean']['input']>;
  optInShowGuestList?: InputMaybe<Scalars['Boolean']['input']>;
  optInShowMusicEmbed?: Scalars['Boolean']['input'];
  optInShowTicketAmount?: Scalars['Boolean']['input'];
  optInSocialAccountRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  optInUseRepbetsQrPass?: InputMaybe<Scalars['Boolean']['input']>;
  pendingRoleDeleteArgs?: InputMaybe<Array<EventAttendeeRoleDeleteArgsInput>>;
  pieIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  promoterUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  questionRequirements?: InputMaybe<Array<QuestionRequirementInput>>;
  requireSocialAccountConnection?: InputMaybe<Scalars['Boolean']['input']>;
  rewardIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  scanningZones?: InputMaybe<Array<ScanningZoneInput>>;
  slug: Scalars['String']['input'];
  socialAccountRequirements?: InputMaybe<Array<SocialAccountRequirementInput>>;
  sponsorUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  startDate: Scalars['DateTime']['input'];
  status?: EventStatus;
  talentOrder?: InputMaybe<Array<Scalars['UUID']['input']>>;
  talentUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  terms?: InputMaybe<Scalars['String']['input']>;
  ticketTermsPurchasePolicy?: InputMaybe<Scalars['String']['input']>;
  uploadedAssetId?: InputMaybe<Scalars['UUID']['input']>;
};


export type EventMutationApiCreatePaymentOrderArgs = {
  eventId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
};


export type EventMutationApiCreateRecurringEventArgs = {
  adminUpdate?: Scalars['Boolean']['input'];
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  avatarUrl: Scalars['String']['input'];
  clubSlugOrId?: InputMaybe<Scalars['String']['input']>;
  coHostUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  coordinatorUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  copiedFromEventSlugOrId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  disclosureOrPrivacyPolicyContent?: InputMaybe<Scalars['String']['input']>;
  disclosureOrPrivacyPolicyFileUrl?: InputMaybe<Scalars['String']['input']>;
  disclosureOrPrivacyPolicyTitle?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  doorUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  endDate: Scalars['DateTime']['input'];
  eventSeriesId?: InputMaybe<Scalars['UUID']['input']>;
  eventTickets?: InputMaybe<Array<EventTicketArgsInput>>;
  eventTimeZoneId?: InputMaybe<Scalars['String']['input']>;
  eventType?: EventType;
  faqs?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<Array<EventInvitationSourceArgsInput>>;
  isAllInPricing?: InputMaybe<Scalars['Boolean']['input']>;
  isListed?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: Scalars['Boolean']['input'];
  location?: InputMaybe<EventLocationInput>;
  locationRadius?: InputMaybe<EventLocationInput>;
  minimumRepScore?: InputMaybe<Scalars['Decimal']['input']>;
  musicEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  optInAgeLimit?: InputMaybe<Scalars['Boolean']['input']>;
  optInAllowGuestInviteOthers?: InputMaybe<Scalars['Boolean']['input']>;
  optInAllowPublicEventPagePreview?: InputMaybe<Scalars['Boolean']['input']>;
  optInDisclosureOrPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  optInDisplayRepScore?: InputMaybe<Scalars['Boolean']['input']>;
  optInLocationRadius?: InputMaybe<Scalars['Boolean']['input']>;
  optInQuestionRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  optInRequireGuestApproval?: InputMaybe<Scalars['Boolean']['input']>;
  optInShowGuestCount?: InputMaybe<Scalars['Boolean']['input']>;
  optInShowGuestList?: InputMaybe<Scalars['Boolean']['input']>;
  optInShowMusicEmbed?: Scalars['Boolean']['input'];
  optInShowTicketAmount?: Scalars['Boolean']['input'];
  optInSocialAccountRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  optInUseRepbetsQrPass?: InputMaybe<Scalars['Boolean']['input']>;
  pieIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  promoterUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  questionRequirements?: InputMaybe<Array<QuestionRequirementInput>>;
  recurringInfo: RecurringEventInfoArgsInput;
  requireSocialAccountConnection?: InputMaybe<Scalars['Boolean']['input']>;
  rewardIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  scanningZones?: InputMaybe<Array<ScanningZoneInput>>;
  slug: Scalars['String']['input'];
  socialAccountRequirements?: InputMaybe<Array<SocialAccountRequirementInput>>;
  sponsorUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  startDate: Scalars['DateTime']['input'];
  status?: EventStatus;
  talentOrder?: InputMaybe<Array<Scalars['UUID']['input']>>;
  talentUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  terms?: InputMaybe<Scalars['String']['input']>;
  ticketTermsPurchasePolicy?: InputMaybe<Scalars['String']['input']>;
  uploadedAssetId?: InputMaybe<Scalars['UUID']['input']>;
};


export type EventMutationApiDeclineArgs = {
  eventId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['UUID']['input']>;
};


export type EventMutationApiDeclineAttendeeArgs = {
  attendeeId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type EventMutationApiDeleteArgs = {
  eventId: Scalars['UUID']['input'];
};


export type EventMutationApiDeleteEventGuestArgs = {
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
};


export type EventMutationApiDeleteEventGuestTicketArgs = {
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
};


export type EventMutationApiDeleteEventTicketArgs = {
  eventId: Scalars['UUID']['input'];
  eventTicketId: Scalars['UUID']['input'];
};


export type EventMutationApiDeleteFreeTicketArgs = {
  eventId: Scalars['UUID']['input'];
  ticketId?: InputMaybe<Scalars['UUID']['input']>;
  transactionId: Scalars['UUID']['input'];
};


export type EventMutationApiDeleteGuestArgs = {
  deleteParentAndChildren?: Scalars['Boolean']['input'];
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
};


export type EventMutationApiGenerateInviteLinkArgs = {
  eventId: Scalars['UUID']['input'];
  privateTicketsArgs?: InputMaybe<PrivateTicketsArgsInput>;
};


export type EventMutationApiGenerateShareTicketLinkArgs = {
  eventId: Scalars['UUID']['input'];
  landingEventId?: InputMaybe<Scalars['UUID']['input']>;
  ticketId: Scalars['String']['input'];
};


export type EventMutationApiGenerateTicketQrCodeArgs = {
  eventId: Scalars['UUID']['input'];
  ticketId: Scalars['String']['input'];
};


export type EventMutationApiGrantTicketsArgs = {
  eventId: Scalars['UUID']['input'];
  receiverId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
  totalRequestTickets: Scalars['Int']['input'];
};


export type EventMutationApiIncreaseMaxTicketsAmountArgs = {
  args: Array<IncreaseTicketsAmountArgsInput>;
  eventId: Scalars['UUID']['input'];
};


export type EventMutationApiInviteFromContactsArgs = {
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  contactPageFilterArgs?: InputMaybe<ContactPageFilterArgsInput>;
  eventId: Scalars['UUID']['input'];
  giftTicketsArgs?: InputMaybe<GiftTicketsArgsInput>;
  invitationMessage?: InputMaybe<Scalars['String']['input']>;
  inviteAll: Scalars['Boolean']['input'];
  isViaSms?: Scalars['Boolean']['input'];
  privateTicketsArgs?: InputMaybe<PrivateTicketsArgsInput>;
};


export type EventMutationApiInviteFromContacts2Args = {
  confirmedDoNotResendContactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  confirmedResendContactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  contactPageFilterArgs?: InputMaybe<ContactPageFilterArgsInput>;
  eventId: Scalars['UUID']['input'];
  giftTicketsArgs?: InputMaybe<GiftTicketsArgsInput>;
  ignoreExistingAttendees?: Scalars['Boolean']['input'];
  invitationMessage?: InputMaybe<Scalars['String']['input']>;
  inviteAll: Scalars['Boolean']['input'];
  isViaSms?: Scalars['Boolean']['input'];
  privateTicketsArgs?: InputMaybe<PrivateTicketsArgsInput>;
};


export type EventMutationApiJoinEventTicketWaitingListArgs = {
  eventId: Scalars['UUID']['input'];
  eventTicketId: Scalars['UUID']['input'];
};


export type EventMutationApiLeaveEventTicketWaitingListArgs = {
  eventId: Scalars['UUID']['input'];
  eventTicketId: Scalars['UUID']['input'];
};


export type EventMutationApiLinkClubOffersArgs = {
  clubId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  offerIds: Array<Scalars['UUID']['input']>;
};


export type EventMutationApiReactCommentArgs = {
  commentId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  reaction: Scalars['String']['input'];
};


export type EventMutationApiRemoveAttendeeRoleArgs = {
  attendeeRole: EventAttendeeRole;
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventMutationApiRemoveCoHostArgs = {
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventMutationApiRemoveCommentReactionArgs = {
  commentId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  reactionId: Scalars['UUID']['input'];
};


export type EventMutationApiRemoveDoorRoleArgs = {
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventMutationApiRemoveGuestListArgs = {
  listName: Scalars['String']['input'];
};


export type EventMutationApiRemovePendingRoleArgs = {
  attendeeRole: EventAttendeeRole;
  eventId: Scalars['UUID']['input'];
  userKey: Scalars['String']['input'];
};


export type EventMutationApiRemovePromoterArgs = {
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventMutationApiRequestEventPayoutArgs = {
  amount: Scalars['Decimal']['input'];
  eventId: Scalars['UUID']['input'];
};


export type EventMutationApiRequestEventPayout2Args = {
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
};


export type EventMutationApiResendInvitationArgs = {
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  eventId: Scalars['UUID']['input'];
  sendId?: InputMaybe<Scalars['UUID']['input']>;
};


export type EventMutationApiRsvpForEventArgs = {
  accept?: Scalars['Boolean']['input'];
  eventId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  questionRequirementAnswers?: InputMaybe<Array<QuestionRequirementAnswerInput>>;
};


export type EventMutationApiSaveGuestListArgs = {
  guestList: SaveGuestListArgsInput;
};


export type EventMutationApiScheduleEventMessageArgs = {
  eventId: Scalars['UUID']['input'];
  input: ScheduleEventMessageInput;
};


export type EventMutationApiSendMessageGroupArgs = {
  eventId: Scalars['UUID']['input'];
  filterArgs?: InputMaybe<EventMessageFilterArgsInput>;
  groupAttendeeStatus?: InputMaybe<SendMessageGroupAttendeeStatus>;
  isViaEmail: Scalars['Boolean']['input'];
  isViaSms: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  smsMessage?: InputMaybe<Scalars['String']['input']>;
};


export type EventMutationApiSendSignedDisclosureCopyArgs = {
  emailAddresses: Array<Scalars['String']['input']>;
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventMutationApiShareGuestQrArgs = {
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  sendEmail: Scalars['Boolean']['input'];
  sendText: Scalars['Boolean']['input'];
};


export type EventMutationApiShareTicketArgs = {
  shareTicketArgs: ShareTicketArgsInput;
};


export type EventMutationApiStartBulkInviteArgs = {
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  contactPageFilterArgs?: InputMaybe<ContactPageFilterArgsInput>;
  eventId: Scalars['UUID']['input'];
  giftTicketsArgs?: InputMaybe<GiftTicketsArgsInput>;
  includeAlreadyInvited?: Scalars['Boolean']['input'];
  invitationMessage?: InputMaybe<Scalars['String']['input']>;
  inviteAll: Scalars['Boolean']['input'];
  isViaSms?: Scalars['Boolean']['input'];
  privateTicketsArgs?: InputMaybe<PrivateTicketsArgsInput>;
  smsMessage?: InputMaybe<Scalars['String']['input']>;
};


export type EventMutationApiStartBulkResendArgs = {
  eventId: Scalars['UUID']['input'];
  filter?: InputMaybe<SearchInviteesFilterArgs>;
  includeBounced?: Scalars['Boolean']['input'];
  reminderMessage?: InputMaybe<Scalars['String']['input']>;
};


export type EventMutationApiTicketVerifyArgs = {
  eventId: Scalars['UUID']['input'];
  scanningZone?: InputMaybe<ScanningZoneInput>;
  ticketId: Scalars['String']['input'];
};


export type EventMutationApiTicketVerify2Args = {
  eventId: Scalars['UUID']['input'];
  qrCode: Scalars['String']['input'];
  scanningZone?: InputMaybe<ScanningZoneInput>;
};


export type EventMutationApiTrackShareLinkViewArgs = {
  eventId: Scalars['UUID']['input'];
  refCode: Scalars['String']['input'];
  viewSource?: AttributionChannel;
};


export type EventMutationApiUndoAttendeeArgs = {
  attendeeId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type EventMutationApiUndoCheckInEventGuestTicketArgs = {
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
};


export type EventMutationApiUndoCheckInGuestArgs = {
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
};


export type EventMutationApiUndoFreeTicketApprovalArgs = {
  eventId: Scalars['UUID']['input'];
  transactionId: Scalars['UUID']['input'];
};


export type EventMutationApiUpdateEventGuestArgs = {
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  guestInfo: EventGuestInfoArgsInput;
  ticket?: InputMaybe<AddEventGuestTicketArgsInput>;
};


export type EventMutationApiUpdateEventGuestTicketArgs = {
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  ticket: EventGuestTicketArgsInput;
  ticketId: Scalars['UUID']['input'];
};


export type EventMutationApiUpdateGuestArgs = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<GuestCustomFieldInput>>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['UUID']['input'];
  fullName: Scalars['String']['input'];
  guestId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type EventMutationApiUpdateScheduledEventMessageArgs = {
  eventId: Scalars['UUID']['input'];
  input: ScheduleEventMessageInput;
  scheduledMessageId: Scalars['UUID']['input'];
};


export type EventMutationApiVerifyTicketArgs = {
  eventId: Scalars['UUID']['input'];
  scannedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  scanningZoneId: Scalars['UUID']['input'];
  ticketId: Scalars['String']['input'];
};


export type EventMutationApiVerifyTicketQrCodeArgs = {
  eventId: Scalars['UUID']['input'];
  qrCode: Scalars['String']['input'];
  scannedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  scanningZoneId: Scalars['UUID']['input'];
};

export type EventPendingOrganizerInfo = {
  __typename?: 'EventPendingOrganizerInfo';
  email?: Maybe<Scalars['String']['output']>;
  userInfo?: Maybe<User>;
};

export type EventPermissionGroup = {
  __typename?: 'EventPermissionGroup';
  category: Scalars['String']['output'];
  permissions: Array<EventPermissionInfo>;
};

export enum EventPermissionId {
  AddExtraTicket = 'ADD_EXTRA_TICKET',
  Base = 'BASE',
  CanAddCoordinatorAttendee = 'CAN_ADD_COORDINATOR_ATTENDEE',
  CanAddCoHostAttendee = 'CAN_ADD_CO_HOST_ATTENDEE',
  CanAddDoorAttendee = 'CAN_ADD_DOOR_ATTENDEE',
  CanAddDoorMyAttendee = 'CAN_ADD_DOOR_MY_ATTENDEE',
  CanAddGuest = 'CAN_ADD_GUEST',
  CanAddPromoterAttendee = 'CAN_ADD_PROMOTER_ATTENDEE',
  CanAddSponsorAttendee = 'CAN_ADD_SPONSOR_ATTENDEE',
  CanAddTalentAttendee = 'CAN_ADD_TALENT_ATTENDEE',
  CanApproveAttendee = 'CAN_APPROVE_ATTENDEE',
  CanApproveMyAttendee = 'CAN_APPROVE_MY_ATTENDEE',
  CanCreateTicket = 'CAN_CREATE_TICKET',
  CanDeclineAttendee = 'CAN_DECLINE_ATTENDEE',
  CanDeclineMyAttendee = 'CAN_DECLINE_MY_ATTENDEE',
  CanDuplicateEvent = 'CAN_DUPLICATE_EVENT',
  CanEditEvent = 'CAN_EDIT_EVENT',
  CanEditTicket = 'CAN_EDIT_TICKET',
  CanMessageAttendee = 'CAN_MESSAGE_ATTENDEE',
  CanRemoveCoordinatorAttendee = 'CAN_REMOVE_COORDINATOR_ATTENDEE',
  CanRemoveCoHostAttendee = 'CAN_REMOVE_CO_HOST_ATTENDEE',
  CanRemoveDoorAttendee = 'CAN_REMOVE_DOOR_ATTENDEE',
  CanRemoveDoorMyAttendee = 'CAN_REMOVE_DOOR_MY_ATTENDEE',
  CanRemovePromoterAttendee = 'CAN_REMOVE_PROMOTER_ATTENDEE',
  CanRemoveSponsorAttendee = 'CAN_REMOVE_SPONSOR_ATTENDEE',
  CanRemoveTalentAttendee = 'CAN_REMOVE_TALENT_ATTENDEE',
  CanResendInvite = 'CAN_RESEND_INVITE',
  CanScanTicket = 'CAN_SCAN_TICKET',
  CanSearchGuests = 'CAN_SEARCH_GUESTS',
  CanSendCompInvite = 'CAN_SEND_COMP_INVITE',
  CanSendPrivateInvite = 'CAN_SEND_PRIVATE_INVITE',
  CanSendStandardInvite = 'CAN_SEND_STANDARD_INVITE',
  CanShareEventLink = 'CAN_SHARE_EVENT_LINK',
  CanSharePrivateTicket = 'CAN_SHARE_PRIVATE_TICKET',
  CanUndoAttendee = 'CAN_UNDO_ATTENDEE',
  CanUndoMyAttendee = 'CAN_UNDO_MY_ATTENDEE',
  CanViewAttendee = 'CAN_VIEW_ATTENDEE',
  CanViewEarnings = 'CAN_VIEW_EARNINGS',
  CanViewEventStats = 'CAN_VIEW_EVENT_STATS',
  CanViewMyAttendee = 'CAN_VIEW_MY_ATTENDEE',
  CanViewMyEarnings = 'CAN_VIEW_MY_EARNINGS',
  None = 'NONE'
}

export type EventPermissionInfo = {
  __typename?: 'EventPermissionInfo';
  id: EventPermissionId;
  name: Scalars['String']['output'];
};

export enum EventPolicyReaction {
  Agree = 'AGREE',
  Disagree = 'DISAGREE',
  None = 'NONE'
}

export type EventPolicyReactionModel = {
  __typename?: 'EventPolicyReactionModel';
  policyFileUrl?: Maybe<Scalars['String']['output']>;
  policyTitle?: Maybe<Scalars['String']['output']>;
  reaction: EventPolicyReaction;
  reactionTime: Scalars['DateTime']['output'];
  userId: Scalars['UUID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export enum EventPrivacyPolicyState {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  None = 'NONE'
}

export type EventQueryApi = {
  __typename?: 'EventQueryApi';
  /** List all clubs has offer that can be linked to the event */
  availableClubsForOfferLink?: Maybe<Array<Maybe<PublicClubState>>>;
  /** Check the status of an async bulk invite job */
  bulkInviteStatus?: Maybe<BulkInviteStatusModel>;
  /** Get event by Id */
  byId?: Maybe<Event>;
  /** Get event by slug or id */
  bySlugOrId?: Maybe<Event>;
  /** Calculate fees */
  calculateFees?: Maybe<FeeCalculationResult>;
  /** Calculate final ticket cost including all applicable fees */
  calculateTicketCost?: Maybe<TicketCostInfo>;
  /** Get the file URL for a signed disclosure/waiver certificate by its reference id */
  certificateFileUrl?: Maybe<Scalars['String']['output']>;
  /** Get public events for a specific club by slug or id */
  clubEvents?: Maybe<ClubEventsConnection>;
  /** Get replies of comment */
  commentReplies?: Maybe<EventCommentModelPageX>;
  /** Count unique invitees */
  countUniqueInvitees: Scalars['Int']['output'];
  /** Best-effort tax estimate for a ticket order against a buyer postal code (automatic-tax events). Returns 0 both when the seller is not registered for that jurisdiction and when the estimate can't be computed (processor error), so 0 is not a definitive 'not taxable'; the real amount is charged at checkout. */
  estimateEventTax: TaxEstimateResult;
  /** Total number of tickets across all of this event's guests, unfiltered by search — one guest may hold multiple tickets */
  eventGuestTicketCount: Scalars['Int']['output'];
  /** Consolidated, paginated per-scan detail table for an event: one row per scan with scan time, ticket type, attendee, scanner, and zone. Filterable by zone/ticket type/scanner, searchable by free-text query (filterArgs.query — a diacritic-insensitive substring match on attendee name/email, ticket-type name, and zone name), and sortable by column. Row counts reconcile with the ticketSummary dashboard. */
  eventScanRecords?: Maybe<EventScanRecordsConnection>;
  /** Get event by Id */
  fullEventById?: Maybe<FullEvent>;
  /** Get event by slug or id */
  fullEventBySlugOrId?: Maybe<FullEvent>;
  /** Get active QR codes for ticket */
  getActiveQrCodes: Array<QrCodeModel>;
  /** Get event bill info */
  getBillInfo?: Maybe<EventBillInfo>;
  /** Get event earnings */
  getEventEarnings?: Maybe<EventEarningsStatistics>;
  /** Get saved guest list */
  getSavedGuestList?: Maybe<SavedGuestList>;
  /** Get tickets amount required for approval */
  getTicketsAmountRequiredForApproval?: Maybe<Array<Maybe<IncreaseTicketsAmountInfo>>>;
  /** Get user's policy reaction for an event */
  getUserEventPolicyReaction?: Maybe<StoredUserReactionEventPolicy>;
  /** Get every disclosure the user has signed for an event that is still in use. For a series' hidden parent event this is the current-only audit across all member events (documents no longer used by any member are dropped); otherwise it is today's single-file behavior as a list. */
  getUserEventPolicyReactions?: Maybe<Array<StoredUserReactionEventPolicy>>;
  /** Get the shareable guest QR pass link for a guest */
  guestQrLink?: Maybe<Scalars['String']['output']>;
  /** Public, unauthenticated lookup for a guest QR pass by its scannable token — used by the guest-facing pass page */
  guestQrPass?: Maybe<GuestQrPassInfo>;
  /**
   * Check if user has requested payout for the event
   * @deprecated Please use requestedPayoutInfo instead
   */
  hasRequestedEventPayout: Scalars['Boolean']['output'];
  /** List all guests */
  listGuests?: Maybe<GuestInfoWithEventGrainPageX>;
  listPayoutRequests: Array<PayoutRequestAdmin>;
  /** List payout requests filtered by currency (ISO 4217 code e.g. USD, GBP) */
  listPayoutRequestsByCurrency: Array<PayoutRequestAdmin>;
  /** List all saved guest list names */
  listSaveGuestListNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Get my events for a specific club by slug or id (events created by the club owner)
   * @deprecated Use clubEvents instead
   */
  myClubEvents?: Maybe<MyClubEventsConnection>;
  /** Get events created by current user */
  myCreatedEvents?: Maybe<MyCreatedEventsConnection>;
  /** Get personal events (not under a club) created by current user or where they are co-host/promoter. Club events are shown only in the club's Events tab. */
  myEvents?: Maybe<MyEventsConnection>;
  /** Check if user has requested event payout V2 */
  requestedPayoutInfo: RequestedPayoutResult;
  /** Get payout info filtered by currency (ISO 4217 code e.g. USD, GBP) */
  requestedPayoutInfoByCurrency: RequestedPayoutResult;
  /** List scheduled messages for an event, optionally filtered by status */
  scheduledEventMessages: Array<ScheduledMessageModel>;
  /** Search events */
  search?: Maybe<EventGrainPageX>;
  searchEventGuests?: Maybe<SearchEventGuestsConnection>;
  /** Search guests by name */
  searchGuests?: Maybe<Array<Maybe<GuestInfoWithEventAndMatch>>>;
  /** Simulate ticket cost calculation during ticket creation */
  simulateTicketCost?: Maybe<TicketCostInfo>;
  ticketSummary?: Maybe<TicketSummary>;
  /** Get public events for a specific user by username */
  userEvents?: Maybe<UserEventsConnection>;
  /** Get public events where a specific user appears in the given non-producer role (Coordinator, Talent, Sponsor, Promoter, or CoHost) */
  userEventsByRole?: Maybe<UserEventsByRoleConnection>;
  /** Validate PDF watermarking functionality */
  validatePdfWatermark?: Maybe<WatermarkValidationResult>;
};


export type EventQueryApiAvailableClubsForOfferLinkArgs = {
  eventId: Scalars['UUID']['input'];
};


export type EventQueryApiBulkInviteStatusArgs = {
  eventId: Scalars['UUID']['input'];
  jobId: Scalars['String']['input'];
};


export type EventQueryApiByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type EventQueryApiBySlugOrIdArgs = {
  slugOrId: Scalars['String']['input'];
};


export type EventQueryApiCalculateFeesArgs = {
  items: Array<PaymentItemInput>;
};


export type EventQueryApiCalculateTicketCostArgs = {
  ticketCostArgs: TicketCostArgsInput;
};


export type EventQueryApiCertificateFileUrlArgs = {
  certificateReferenceId: Scalars['String']['input'];
};


export type EventQueryApiClubEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clubSlugOrId: Scalars['String']['input'];
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EventQueryApiCommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type EventQueryApiCountUniqueInviteesArgs = {
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  includeSources?: InputMaybe<Array<EventInvitationSourceArgsInput>>;
};


export type EventQueryApiEstimateEventTaxArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['UUID']['input'];
  paymentAuthCode: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
};


export type EventQueryApiEventGuestTicketCountArgs = {
  eventId: Scalars['UUID']['input'];
};


export type EventQueryApiEventScanRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['UUID']['input'];
  filterArgs?: InputMaybe<ScanRecordFilterArgsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: PageSortOrder;
  sortType?: ScanRecordSortType;
};


export type EventQueryApiFullEventByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type EventQueryApiFullEventBySlugOrIdArgs = {
  slugOrId: Scalars['String']['input'];
};


export type EventQueryApiGetActiveQrCodesArgs = {
  eventId: Scalars['UUID']['input'];
  ticketId: Scalars['String']['input'];
};


export type EventQueryApiGetBillInfoArgs = {
  subTotal: Scalars['Decimal']['input'];
};


export type EventQueryApiGetEventEarningsArgs = {
  filter: EventEarningsFilterInput;
};


export type EventQueryApiGetSavedGuestListArgs = {
  listName: Scalars['String']['input'];
};


export type EventQueryApiGetTicketsAmountRequiredForApprovalArgs = {
  eventId: Scalars['UUID']['input'];
};


export type EventQueryApiGetUserEventPolicyReactionArgs = {
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventQueryApiGetUserEventPolicyReactionsArgs = {
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventQueryApiGuestQrLinkArgs = {
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
};


export type EventQueryApiGuestQrPassArgs = {
  eventId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
};


export type EventQueryApiHasRequestedEventPayoutArgs = {
  eventId: Scalars['UUID']['input'];
};


export type EventQueryApiListGuestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type EventQueryApiListPayoutRequestsByCurrencyArgs = {
  currency: Scalars['String']['input'];
};


export type EventQueryApiMyClubEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clubSlugOrId: Scalars['String']['input'];
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EventQueryApiMyCreatedEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EventQueryApiMyEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EventQueryApiRequestedPayoutInfoByCurrencyArgs = {
  currency: Scalars['String']['input'];
};


export type EventQueryApiScheduledEventMessagesArgs = {
  eventId: Scalars['UUID']['input'];
  status?: InputMaybe<ScheduledMessageStatus>;
};


export type EventQueryApiSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  criteria?: InputMaybe<SearchEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type EventQueryApiSearchEventGuestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['UUID']['input'];
  filterArgs?: InputMaybe<SearchEventGuestFilterArgsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: PageSortOrder;
  sortType?: SearchEventGuestSortType;
};


export type EventQueryApiSearchGuestsArgs = {
  eventId: Scalars['UUID']['input'];
  nameQuery: Scalars['String']['input'];
};


export type EventQueryApiSimulateTicketCostArgs = {
  isAllInPricing?: Scalars['Boolean']['input'];
  items: Array<TicketCostSimulationItemInput>;
};


export type EventQueryApiTicketSummaryArgs = {
  eventId: Scalars['UUID']['input'];
};


export type EventQueryApiUserEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userName: Scalars['String']['input'];
};


export type EventQueryApiUserEventsByRoleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  role: EventAttendeeRole;
  userName: Scalars['String']['input'];
};


export type EventQueryApiValidatePdfWatermarkArgs = {
  fileUrl: Scalars['String']['input'];
};

export type EventRolePermissions = {
  __typename?: 'EventRolePermissions';
  groups: Array<EventPermissionGroup>;
  permissions: Array<EventPermissionInfo>;
  role: EventAttendeeRole;
  roleName: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type EventScanRecordsConnection = {
  __typename?: 'EventScanRecordsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventScanRecordsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ScanRecord>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventScanRecordsEdge = {
  __typename?: 'EventScanRecordsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ScanRecord>;
};

export type EventScheduleChange = {
  __typename?: 'EventScheduleChange';
  afterEndUtc: Scalars['DateTime']['output'];
  afterStartUtc: Scalars['DateTime']['output'];
  beforeEndUtc: Scalars['DateTime']['output'];
  beforeStartUtc: Scalars['DateTime']['output'];
  eventId: Scalars['UUID']['output'];
  reminder: EndedReminderInfo;
};

export type EventSeries = {
  __typename?: 'EventSeries';
  /** Age and gender statistics across the series' member events and its parent, with the same shape and age buckets as an event's attendeeAgeRangeStatistic. Attendee records are one per person per event, so a person at two events counts twice; season pass holders are attendees of the parent and count once. Pass eventId to narrow it to one member event or the parent. Requires the series owner, a series role with CanViewEventStats, or an admin, and the OpenSearch attendee index. */
  audience?: Maybe<AttendeeAgeRangeStatistic>;
  /** The series' image: the avatar of its hidden parent event. Null when none has been uploaded. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  /** Entries and check-ins per member event: each event's own tickets, the series pass holders and the +1 guests valid at it, counted by one calculation shared with FullEvent.entryStats. Requires the series owner, a series role with CanViewEventStats, or an admin. */
  entries?: Maybe<SeriesEntries>;
  eventSeriesId: Scalars['UUID']['output'];
  /** Whether any of the series' events — its parent (season passes) and every member — can take money: a paid ticket type is on sale, or was on sale and already released tickets. Free, RSVP-only and staff-role types never count, so false means the series' gross revenue and net earnings can never move. Requires the series owner, a series role with CanViewEarnings, or an admin. */
  hasTicketsForSale: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  /** Whether the current user owns this series */
  isOwner: Scalars['Boolean']['output'];
  /** Number of events that belong to this series */
  memberCount: Scalars['Int']['output'];
  /** Number of events in this series the current user has access to (all events for the owner). Populated for series returned by mySeries. */
  myEventsCount: Scalars['Int']['output'];
  /** The series-level permissions the current user holds on this series (all permissions for the owner, empty for anonymous users). Used to gate series-management UI. */
  mySeriesPermissions: Array<EventSeriesPermissionId>;
  name: Scalars['String']['output'];
  /** The user who owns this series */
  owner?: Maybe<User>;
  ownerId: Scalars['UUID']['output'];
  parentEventId: Scalars['UUID']['output'];
  /** The series' season passes: each pass type with its price, guest rules, scanning setting, passes sold and capacity, plus totals. Pass tickets and their +1 guest tickets are counted apart. Requires the series owner, a series role with CanViewEventStats, or an admin. */
  passes?: Maybe<SeriesPasses>;
  /** The series owner, or anyone holding a series role. How the series' +1 returns are doing: status, reasons and a row per event. isEnabled is false when no ticket type of the series returns +1s after each event. */
  plusOneReturnHealth: PlusOneReturnHealth;
  /** Get the public (listed, active, non-private) events that belong to this series */
  publicEvents?: Maybe<PublicEventsConnection>;
  slug: Scalars['String']['output'];
  /** Headline totals across the series' parent and member events: season passes sold, member-event tickets sold and check-ins (member-event tickets plus season passes scanned at each member). Requires the series owner, a series role with CanViewEventStats, or an admin. */
  stats?: Maybe<EventSeriesStats>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};


export type EventSeriesAudienceArgs = {
  attendeeFilterStatus?: InputMaybe<AttendeeFilterStatus>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
};


export type EventSeriesPublicEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SeriesEventsSortBy>;
  sortOrder?: InputMaybe<PageSortOrder>;
  status?: InputMaybe<SearchEventStatus>;
};

export type EventSeriesMemberRole = {
  __typename?: 'EventSeriesMemberRole';
  role?: Maybe<EventSeriesRolePermissionState>;
  roleId: Scalars['UUID']['output'];
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type EventSeriesMutationApi = {
  __typename?: 'EventSeriesMutationApi';
  /** Add one or more existing events to a series. Rejects if an event already belongs to another series — use moveEvent instead. */
  addEventToSeries?: Maybe<EventSeries>;
  /** Assign a series role to a user (owner, or a user holding CanAssignSeriesRoles). The role grants its mapped permissions on every event in the series. */
  assignSeriesRole?: Maybe<EventSeries>;
  /** Create a new, empty event series owned by the current user */
  createSeries?: Maybe<EventSeries>;
  /** Delete a series. Member events are released (become independent), not deleted. */
  deleteSeries: Scalars['Boolean']['output'];
  /** The series owner, or anyone holding a series role. Checks, and unless dryRun is true fixes, the series' +1 returns: +1s that should have gone back to their holders after an event ended, and holders still waiting for a +1. dryRun (the default) only reports what would happen. */
  fixPlusOneReturns: FixPlusOneReturnsReport;
  /** Invite one or more users (registered by userId, or unregistered by email) to hold a series role. Records a pending role and emails an accept link; the role activates when the invite is accepted. (owner, or a user holding CanAssignSeriesRoles) */
  inviteSeriesRole?: Maybe<EventSeries>;
  /** Move one or more events from their current series (if any) into another series */
  moveEvent?: Maybe<EventSeries>;
  /** Remove one or more events from a series. The events become independent again. */
  removeEventFromSeries?: Maybe<EventSeries>;
  /** Remove a pending (invited-but-not-accepted) series role for a userKey (userId-as-string or lowercased email). (owner, or a user holding CanAssignSeriesRoles) */
  removePendingSeriesRole?: Maybe<EventSeries>;
  /** Remove a series role from a user (owner, or a user holding CanAssignSeriesRoles) */
  removeSeriesRole?: Maybe<EventSeries>;
  /** Rename an event series (owner, or a user holding CanEditSeries) */
  renameSeries?: Maybe<EventSeries>;
  /** Rename an event series and set its image (owner, or a user holding CanEditSeries) */
  updateSeries?: Maybe<EventSeries>;
};


export type EventSeriesMutationApiAddEventToSeriesArgs = {
  eventIds: Array<Scalars['UUID']['input']>;
  seriesId: Scalars['UUID']['input'];
};


export type EventSeriesMutationApiAssignSeriesRoleArgs = {
  roleId: Scalars['UUID']['input'];
  seriesId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventSeriesMutationApiCreateSeriesArgs = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type EventSeriesMutationApiDeleteSeriesArgs = {
  seriesId: Scalars['UUID']['input'];
};


export type EventSeriesMutationApiFixPlusOneReturnsArgs = {
  dryRun?: Scalars['Boolean']['input'];
  seriesId: Scalars['UUID']['input'];
};


export type EventSeriesMutationApiInviteSeriesRoleArgs = {
  invitees: Array<SeriesRoleInviteeInput>;
  roleId: Scalars['UUID']['input'];
  seriesId: Scalars['UUID']['input'];
};


export type EventSeriesMutationApiMoveEventArgs = {
  eventIds: Array<Scalars['UUID']['input']>;
  toSeriesId: Scalars['UUID']['input'];
};


export type EventSeriesMutationApiRemoveEventFromSeriesArgs = {
  eventIds: Array<Scalars['UUID']['input']>;
  seriesId: Scalars['UUID']['input'];
};


export type EventSeriesMutationApiRemovePendingSeriesRoleArgs = {
  roleId: Scalars['UUID']['input'];
  seriesId: Scalars['UUID']['input'];
  userKey: Scalars['String']['input'];
};


export type EventSeriesMutationApiRemoveSeriesRoleArgs = {
  roleId: Scalars['UUID']['input'];
  seriesId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type EventSeriesMutationApiRenameSeriesArgs = {
  name: Scalars['String']['input'];
  seriesId: Scalars['UUID']['input'];
};


export type EventSeriesMutationApiUpdateSeriesArgs = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  seriesId: Scalars['UUID']['input'];
};

export type EventSeriesPendingMemberRole = {
  __typename?: 'EventSeriesPendingMemberRole';
  email?: Maybe<Scalars['String']['output']>;
  role?: Maybe<EventSeriesRolePermissionState>;
  roleId: Scalars['UUID']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export enum EventSeriesPermissionId {
  AddExtraTicket = 'ADD_EXTRA_TICKET',
  CanAddCoordinatorAttendee = 'CAN_ADD_COORDINATOR_ATTENDEE',
  CanAddCoHostAttendee = 'CAN_ADD_CO_HOST_ATTENDEE',
  CanAddDoorAttendee = 'CAN_ADD_DOOR_ATTENDEE',
  CanAddEventsToSeries = 'CAN_ADD_EVENTS_TO_SERIES',
  CanAddGuest = 'CAN_ADD_GUEST',
  CanAddPromoterAttendee = 'CAN_ADD_PROMOTER_ATTENDEE',
  CanAddSponsorAttendee = 'CAN_ADD_SPONSOR_ATTENDEE',
  CanAddTalentAttendee = 'CAN_ADD_TALENT_ATTENDEE',
  CanApproveAttendee = 'CAN_APPROVE_ATTENDEE',
  CanAssignSeriesRoles = 'CAN_ASSIGN_SERIES_ROLES',
  CanCreateTicket = 'CAN_CREATE_TICKET',
  CanDeclineAttendee = 'CAN_DECLINE_ATTENDEE',
  CanDuplicateEvent = 'CAN_DUPLICATE_EVENT',
  CanEditEvent = 'CAN_EDIT_EVENT',
  CanEditSeries = 'CAN_EDIT_SERIES',
  CanEditTicket = 'CAN_EDIT_TICKET',
  CanManageEvent = 'CAN_MANAGE_EVENT',
  CanMessageAttendee = 'CAN_MESSAGE_ATTENDEE',
  CanRemoveCoordinatorAttendee = 'CAN_REMOVE_COORDINATOR_ATTENDEE',
  CanRemoveCoHostAttendee = 'CAN_REMOVE_CO_HOST_ATTENDEE',
  CanRemoveDoorAttendee = 'CAN_REMOVE_DOOR_ATTENDEE',
  CanRemoveEventsFromSeries = 'CAN_REMOVE_EVENTS_FROM_SERIES',
  CanRemovePromoterAttendee = 'CAN_REMOVE_PROMOTER_ATTENDEE',
  CanRemoveSponsorAttendee = 'CAN_REMOVE_SPONSOR_ATTENDEE',
  CanRemoveTalentAttendee = 'CAN_REMOVE_TALENT_ATTENDEE',
  CanResendInvite = 'CAN_RESEND_INVITE',
  CanScanTicket = 'CAN_SCAN_TICKET',
  CanSearchGuests = 'CAN_SEARCH_GUESTS',
  CanSendCompInvite = 'CAN_SEND_COMP_INVITE',
  CanSendPrivateInvite = 'CAN_SEND_PRIVATE_INVITE',
  CanSendStandardInvite = 'CAN_SEND_STANDARD_INVITE',
  CanShareEventLink = 'CAN_SHARE_EVENT_LINK',
  CanSharePrivateTicket = 'CAN_SHARE_PRIVATE_TICKET',
  CanUndoAttendee = 'CAN_UNDO_ATTENDEE',
  CanViewAttendee = 'CAN_VIEW_ATTENDEE',
  CanViewEarnings = 'CAN_VIEW_EARNINGS',
  CanViewEventStats = 'CAN_VIEW_EVENT_STATS'
}

export type EventSeriesPermissionNode = {
  __typename?: 'EventSeriesPermissionNode';
  children: Array<EventSeriesPermissionNode>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permission: EventSeriesPermissionId;
};

export type EventSeriesQueryApi = {
  __typename?: 'EventSeriesQueryApi';
  /** Admin only. Recomputes a series' entry numbers the slow way and compares them with what the series page gets, and each event's own entry stats with its row in the series result. An empty list of differences means they agree. A mismatch is also logged as series_numbers_mismatch. */
  adminSeriesNumbersAudit?: Maybe<SeriesNumbersAudit>;
  /** Get a single event series by slug or id (public read) */
  bySlugOrId?: Maybe<EventSeries>;
  /** Get the event series owned by the current user or containing events they help manage, optionally filtered by name */
  mySeries?: Maybe<MySeriesConnection>;
  /** The pending (invited-but-not-accepted) series roles on a series (owner or a user holding CanAssignSeriesRoles) */
  pendingSeriesRoles?: Maybe<Array<EventSeriesPendingMemberRole>>;
  /** Get the public (listed, active, non-private) events that belong to an event series */
  publicSeriesEvents?: Maybe<PublicSeriesEventsConnection>;
  /** The global catalog of event series roles that can be assigned to users */
  roles?: Maybe<Array<EventSeriesRolePermissionState>>;
  /** Get a single event series by id */
  series?: Maybe<EventSeries>;
  /** Get the events that belong to an event series (owner sees all; team members see only the events they have access to) */
  seriesEvents?: Maybe<SeriesEventsConnection>;
  /** The users assigned series roles on a series, with their roles (owner or a user holding CanAssignSeriesRoles) */
  seriesMemberRoles?: Maybe<Array<EventSeriesMemberRole>>;
};


export type EventSeriesQueryApiAdminSeriesNumbersAuditArgs = {
  seriesId: Scalars['UUID']['input'];
};


export type EventSeriesQueryApiBySlugOrIdArgs = {
  slugOrId: Scalars['String']['input'];
};


export type EventSeriesQueryApiMySeriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EventSeriesQueryApiPendingSeriesRolesArgs = {
  seriesId: Scalars['UUID']['input'];
};


export type EventSeriesQueryApiPublicSeriesEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SeriesEventsSortBy>;
  sortOrder?: InputMaybe<PageSortOrder>;
  status?: InputMaybe<SearchEventStatus>;
};


export type EventSeriesQueryApiSeriesArgs = {
  id: Scalars['UUID']['input'];
};


export type EventSeriesQueryApiSeriesEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SeriesEventsSortBy>;
  sortOrder?: InputMaybe<PageSortOrder>;
  status?: InputMaybe<SearchEventStatus>;
};


export type EventSeriesQueryApiSeriesMemberRolesArgs = {
  seriesId: Scalars['UUID']['input'];
};

export type EventSeriesRolePermissionState = {
  __typename?: 'EventSeriesRolePermissionState';
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<EventSeriesPermissionId>>;
  roleId: Scalars['UUID']['output'];
  roleName: Scalars['String']['output'];
};

export type EventSeriesStats = {
  __typename?: 'EventSeriesStats';
  /** Check-ins across member events: their own tickets plus season passes scanned at each */
  checkedIn: Scalars['Long']['output'];
  /** Number of member events in the series */
  eventCount: Scalars['Int']['output'];
  /** Season passes sold (approved tickets on the series' parent event) */
  passesSold: Scalars['Long']['output'];
  /** Tickets sold across the member events, excluding season passes */
  ticketsSold: Scalars['Long']['output'];
};

export type EventSeriesTeamMember = {
  __typename?: 'EventSeriesTeamMember';
  role: EventSeriesTeamRole;
  user: User;
};

export enum EventSeriesTeamRole {
  Host = 'HOST',
  Sponsor = 'SPONSOR',
  Talent = 'TALENT'
}

export type EventSocialNetworkReaches = {
  __typename?: 'EventSocialNetworkReaches';
  reaches: Scalars['Long']['output'];
  socialNetworkScheme: Scalars['String']['output'];
};

export enum EventStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  None = 'NONE'
}

export type EventTicket = {
  __typename?: 'EventTicket';
  actionLabel?: Maybe<Scalars['String']['output']>;
  additionalGuests?: Maybe<Scalars['Int']['output']>;
  /** Event ticket balance */
  balance?: Maybe<EventTicketBalance>;
  /** Can the ticket be deleted */
  canBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  creatorId: Scalars['UUID']['output'];
  /**
   * Event ticket earning amount
   * @deprecated To be removed. Must use FullEventTicketType for earning!
   */
  earning?: Maybe<Scalars['Decimal']['output']>;
  eventId: Scalars['UUID']['output'];
  eventTicketId: Scalars['UUID']['output'];
  /** Fulfillment methods offered for this ticket-type; electronic when unset. */
  fulfillmentMethods?: Maybe<FulfillmentMethods>;
  gratuityPercentage?: Maybe<Scalars['Decimal']['output']>;
  isActive: Scalars['Boolean']['output'];
  isEnabledWishList: Scalars['Boolean']['output'];
  /** Event ticket has no remaining available amount */
  isFull?: Maybe<Scalars['Boolean']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  isRequiredApproval: Scalars['Boolean']['output'];
  isRsvpOnly: Scalars['Boolean']['output'];
  isShareable?: Maybe<Scalars['Boolean']['output']>;
  /** Current user is a special guest */
  isSpecialGuest?: Maybe<Scalars['Boolean']['output']>;
  isUserAttendeeRole?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  optInQrCodePass: Scalars['Boolean']['output'];
  optInShowTicketAmount: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  /** Product classification of the ticket-type (admission or merchandise); admission when unset. */
  productType: ProductType;
  repPoints?: Maybe<Scalars['Decimal']['output']>;
  /** Whether buying this ticket-type requires signing the event's disclosure (when the event has one); required when unset. */
  requiresDisclosureSignature: Scalars['Boolean']['output'];
  resetAdditionalGuestsAfterEachEvent?: Maybe<Scalars['Boolean']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** Special guest info of current user */
  specialGuestInfo?: Maybe<SpecialGuestInfo>;
  ticketType?: Maybe<Scalars['String']['output']>;
  /** Status of the current user's booking for this ticket. A series ticket type is shared by every member event: pass forEventId (the member event being viewed) so a +1 that is only good for another event does not read as claimed here. */
  transactionStatus?: Maybe<TransactionStatus>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  visibleEndAt?: Maybe<Scalars['DateTime']['output']>;
  visibleStartAt?: Maybe<Scalars['DateTime']['output']>;
};


export type EventTicketTransactionStatusArgs = {
  forEventId?: InputMaybe<Scalars['UUID']['input']>;
};

export type EventTicketArgsInput = {
  actionLabel?: InputMaybe<Scalars['String']['input']>;
  additionalGuests?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  eventTicketId?: InputMaybe<Scalars['UUID']['input']>;
  eventTicketTempId?: InputMaybe<Scalars['UUID']['input']>;
  gratuityPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  isActive: Scalars['Boolean']['input'];
  isEnabledWishList?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredApproval: Scalars['Boolean']['input'];
  isRsvpOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isShareable?: InputMaybe<Scalars['Boolean']['input']>;
  isUserAttendeeRole?: InputMaybe<Scalars['Boolean']['input']>;
  limitedAmount?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  optInQrCodePass?: InputMaybe<Scalars['Boolean']['input']>;
  optInShowTicketAmount?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  repPoints?: InputMaybe<Scalars['Decimal']['input']>;
  requiresDisclosureSignature?: InputMaybe<Scalars['Boolean']['input']>;
  resetAdditionalGuestsAfterEachEvent?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  ticketType?: InputMaybe<Scalars['String']['input']>;
  visibleEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  visibleStartAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventTicketBalance = {
  __typename?: 'EventTicketBalance';
  availableAmount?: Maybe<Scalars['Int']['output']>;
  isUnlimitedAvailableAmount: Scalars['Boolean']['output'];
  limitedAmount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated No longer supported. */
  lockedAmount: Scalars['Int']['output'];
  releasedAmount: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type EventTicketConnection = {
  __typename?: 'EventTicketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventTicketEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<EventTicket>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventTicketEdge = {
  __typename?: 'EventTicketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EventTicket>;
};

export type EventTicketMutationApi = {
  __typename?: 'EventTicketMutationApi';
  /** Generate apple wallet pass download token */
  appleWalletDownloadToken?: Maybe<Scalars['String']['output']>;
  enterContest: TransactionOperationResult;
  /** Purchase ticket */
  purchaseTicket: TransactionOperationResult;
};


export type EventTicketMutationApiAppleWalletDownloadTokenArgs = {
  eventId: Scalars['UUID']['input'];
  ticketId: Scalars['String']['input'];
};


export type EventTicketMutationApiEnterContestArgs = {
  eventId: Scalars['UUID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type EventTicketMutationApiPurchaseTicketArgs = {
  contestEntry?: InputMaybe<Scalars['Boolean']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['UUID']['input'];
  memberEventId?: InputMaybe<Scalars['UUID']['input']>;
  orderId: Scalars['String']['input'];
  orderReferenceId?: InputMaybe<Scalars['String']['input']>;
};

export type EventTicketPurchaseInfo = {
  __typename?: 'EventTicketPurchaseInfo';
  eventId: Scalars['UUID']['output'];
  /** Event ticket */
  eventTicket?: Maybe<EventTicket>;
  eventTicketId: Scalars['UUID']['output'];
  gratuityPercentage?: Maybe<Scalars['Decimal']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  purchaseAmount: Scalars['Int']['output'];
  repPoints?: Maybe<Scalars['Decimal']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  ticketType?: Maybe<Scalars['String']['output']>;
};

export type EventTicketPurchaseInfoLite = {
  __typename?: 'EventTicketPurchaseInfoLite';
  purchasedQuantity: Scalars['Decimal']['output'];
  ticketType: Scalars['String']['output'];
};

export type EventTicketQueryApi = {
  __typename?: 'EventTicketQueryApi';
  /** Get event ticket by Id */
  byId?: Maybe<EventTicket>;
  /** Where the current user's ticket checkout stands (by its processor reference, e.g. a Stripe Checkout Session id), so the app can finish a purchase it lost track of. Only call purchaseTicket again when this is PAID. */
  checkoutStatus: TicketCheckoutStatus;
};


export type EventTicketQueryApiByIdArgs = {
  eventId: Scalars['UUID']['input'];
  eventTicketId: Scalars['UUID']['input'];
};


export type EventTicketQueryApiCheckoutStatusArgs = {
  paymentReferenceId: Scalars['String']['input'];
};

export type EventTicketWaitingUsers = {
  __typename?: 'EventTicketWaitingUsers';
  eventTicketId: Scalars['UUID']['output'];
  users?: Maybe<Array<Maybe<User>>>;
};

export type EventTicketWaitingUsersCount = {
  __typename?: 'EventTicketWaitingUsersCount';
  count: Scalars['Long']['output'];
  eventTicketId: Scalars['UUID']['output'];
};

export enum EventType {
  ArtShow = 'ART_SHOW',
  ComedyShow = 'COMEDY_SHOW',
  Concert = 'CONCERT',
  Conference = 'CONFERENCE',
  Contest = 'CONTEST',
  Festival = 'FESTIVAL',
  None = 'NONE',
  Other = 'OTHER',
  Party = 'PARTY',
  Podcast = 'PODCAST',
  Sporting = 'SPORTING',
  Workshop = 'WORKSHOP'
}

export type EventUserInfo = {
  __typename?: 'EventUserInfo';
  approvalAt?: Maybe<Scalars['DateTime']['output']>;
  approvalBy?: Maybe<Scalars['UUID']['output']>;
  attendeeRole?: Maybe<EventAttendeeRole>;
  attendeeState: EventAttendeeState;
  contestEnteredAt?: Maybe<Scalars['DateTime']['output']>;
  contestEntryType: ContestEntryType;
  contestReferralSourceEventId?: Maybe<Scalars['UUID']['output']>;
  contestReferredBy?: Maybe<Scalars['UUID']['output']>;
  contestWinnerSelectedAt?: Maybe<Scalars['DateTime']['output']>;
  disclosureReferenceId?: Maybe<Scalars['String']['output']>;
  firstParticipatedAt?: Maybe<Scalars['DateTime']['output']>;
  inviter?: Maybe<Scalars['UUID']['output']>;
  isActive: Scalars['Boolean']['output'];
  isContestWinner: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<EventPermissionId>>;
  privacyPolicyState: EventPrivacyPolicyState;
  privacyPolicyStateUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  questionRequirementAnswers?: Maybe<Array<QuestionRequirementAnswer>>;
  signedDisclosureFileUrl?: Maybe<Scalars['String']['output']>;
  signedWaiverFileUrl?: Maybe<Scalars['String']['output']>;
  stateChangedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type EventUserRole = {
  __typename?: 'EventUserRole';
  role: EventAttendeeRole;
  user?: Maybe<User>;
};

export type ExternalApplication = ILimitedExternalApplicationModel & {
  __typename?: 'ExternalApplication';
  createdAt: Scalars['DateTime']['output'];
  dataUseStatement?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalApplicationId: Scalars['UUID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  redirectUris: Array<Scalars['String']['output']>;
  tokens: Array<KeyValuePairOfStringAndExternalApplicationToken>;
};

export type ExternalApplicationArgsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ExternalApplicationEdgeX = {
  __typename?: 'ExternalApplicationEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ExternalApplication>;
};

/** Represents a slice or page */
export type ExternalApplicationPageX = {
  __typename?: 'ExternalApplicationPageX';
  /** A list of edges */
  edges: Array<ExternalApplicationEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<ExternalApplication>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type ExternalApplicationToken = {
  __typename?: 'ExternalApplicationToken';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  scopes: Array<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type ExternalApplicationTokenArgsInput = {
  expiresAt: Scalars['DateTime']['input'];
  scopes: Array<Scalars['String']['input']>;
};

export type ExternalAuthenticationResult = {
  __typename?: 'ExternalAuthenticationResult';
  agreeToTermsAndConditions: Scalars['Boolean']['output'];
  canRecover: Scalars['Boolean']['output'];
  expiresIn: Scalars['Int']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPhoneNumberVerified: Scalars['Boolean']['output'];
  notAfter: Scalars['DateTime']['output'];
  refreshToken: Scalars['String']['output'];
  skipMultiFactorAuthentication: Scalars['Boolean']['output'];
  skipPasskeyRegistration: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  type: Scalars['String']['output'];
  verificationRequired?: Maybe<AccountVerificationRequired>;
};

export type FaqEntry = {
  __typename?: 'FaqEntry';
  answer?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type FaqEntryInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FeeCalculationResult = {
  __typename?: 'FeeCalculationResult';
  partnerFeeAmount: Scalars['Decimal']['output'];
  processingFeeAmount: Scalars['Decimal']['output'];
  serviceFeeAmount: Scalars['Decimal']['output'];
  subTotalAmount: Scalars['Decimal']['output'];
  taxes: Array<TaxItem>;
  totalAmount: Scalars['Decimal']['output'];
  totalTaxFeeAmount: Scalars['Decimal']['output'];
};

export type FilterAchievementCriteriaInput = {
  achievementId?: InputMaybe<Scalars['UUID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type FilterOfferCriteriaInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['UUID']['input']>;
  searchStatus?: InputMaybe<SearchOfferStatus>;
  sortOrder?: PageSortOrder;
  sortingType?: InputMaybe<OfferSortingField>;
};

export type FilteredAchievement = {
  __typename?: 'FilteredAchievement';
  achievement: AdminAchievement;
  achievementId: Scalars['UUID']['output'];
  category?: Maybe<AchievementCategory>;
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  status?: Maybe<AchievementStatus>;
  type: AchievementType;
};

export type FilteredAchievementFilterInput = {
  achievement?: InputMaybe<AdminAchievementFilterInput>;
  achievementId?: InputMaybe<UuidOperationFilterInput>;
  and?: InputMaybe<Array<FilteredAchievementFilterInput>>;
  category?: InputMaybe<NullableOfAchievementCategoryOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isHidden?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FilteredAchievementFilterInput>>;
  slug?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<NullableOfAchievementStatusOperationFilterInput>;
  type?: InputMaybe<AchievementTypeOperationFilterInput>;
};

export type FilteredPie = {
  __typename?: 'FilteredPie';
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  holdingSlices?: Maybe<Scalars['Decimal']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  issuedSlices?: Maybe<Scalars['Decimal']['output']>;
  operationalState?: Maybe<PieOperationalState>;
  pie: AdminPie;
  pieId: Scalars['UUID']['output'];
  slicePrice?: Maybe<Amount>;
  slug?: Maybe<Scalars['String']['output']>;
  totalMembers?: Maybe<Scalars['Long']['output']>;
  totalUniqueSubscribers?: Maybe<Scalars['Int']['output']>;
};

export type FilteredPieFilterInput = {
  and?: InputMaybe<Array<FilteredPieFilterInput>>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  holdingSlices?: InputMaybe<DecimalOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isDisabled?: InputMaybe<BooleanOperationFilterInput>;
  issuedSlices?: InputMaybe<DecimalOperationFilterInput>;
  operationalState?: InputMaybe<NullableOfPieOperationalStateOperationFilterInput>;
  or?: InputMaybe<Array<FilteredPieFilterInput>>;
  pie?: InputMaybe<AdminPieFilterInput>;
  pieId?: InputMaybe<UuidOperationFilterInput>;
  slicePrice?: InputMaybe<AmountFilterInput>;
  slug?: InputMaybe<StringOperationFilterInput>;
  totalMembers?: InputMaybe<LongOperationFilterInput>;
  totalUniqueSubscribers?: InputMaybe<IntOperationFilterInput>;
};

export type FilteredReward = {
  __typename?: 'FilteredReward';
  category?: Maybe<RewardCategory>;
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  reward: AdminReward;
  rewardId: Scalars['UUID']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RewardStatus>;
  type: RewardType;
};

export type FilteredRewardFilterInput = {
  and?: InputMaybe<Array<FilteredRewardFilterInput>>;
  category?: InputMaybe<NullableOfRewardCategoryOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  expiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isHidden?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FilteredRewardFilterInput>>;
  reward?: InputMaybe<AdminRewardFilterInput>;
  rewardId?: InputMaybe<UuidOperationFilterInput>;
  slug?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<NullableOfRewardStatusOperationFilterInput>;
  type?: InputMaybe<RewardTypeOperationFilterInput>;
};

export type FilteredUser = {
  __typename?: 'FilteredUser';
  age?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  /** Deactivate the user object, and release all resources */
  deactivate: Scalars['Boolean']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<UserGender>;
  invitedBy?: Maybe<FilteredUser>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  tier: UserTier;
  user: AdminUser;
  userId: Scalars['UUID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type FilteredUserFilterInput = {
  age?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<FilteredUserFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  dateOfBirth?: InputMaybe<LocalDateOperationFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  gender?: InputMaybe<NullableOfUserGenderOperationFilterInput>;
  invitedBy?: InputMaybe<FilteredUserFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FilteredUserFilterInput>>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  tier?: InputMaybe<UserTierOperationFilterInput>;
  user?: InputMaybe<AdminUserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type FixPlusOneReturnsReport = {
  __typename?: 'FixPlusOneReturnsReport';
  dryRun: Scalars['Boolean']['output'];
  eventsToRepair: Scalars['Int']['output'];
  health: PlusOneReturnHealth;
  holdersGetNewPlusOne: Scalars['Int']['output'];
  holdersWithoutPass: Scalars['Int']['output'];
  moreRemain: Scalars['Boolean']['output'];
  plusOnesToReturn: Scalars['Int']['output'];
  seriesId: Scalars['UUID']['output'];
  waitingForNextEvent: Scalars['Int']['output'];
};

export type ForceCatchUpReport = {
  __typename?: 'ForceCatchUpReport';
  after?: Maybe<SeriesAdditionalGuestOverview>;
  before: SeriesAdditionalGuestOverview;
  dryRun: Scalars['Boolean']['output'];
  seriesId: Scalars['UUID']['output'];
};

export enum FrequencyType {
  Day = 'DAY',
  Month = 'MONTH',
  None = 'NONE',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type FromRewardTrigger = {
  __typename?: 'FromRewardTrigger';
  rewardId: Scalars['UUID']['output'];
  type: AchievementTriggerType;
};

export type FromRewardTriggerPayloadInput = {
  rewardId: Scalars['UUID']['input'];
};

export enum FulfillmentMethod {
  Electronic = 'ELECTRONIC',
  Pickup = 'PICKUP',
  Ship = 'SHIP'
}

export type FulfillmentMethods = {
  __typename?: 'FulfillmentMethods';
  electronic: Scalars['Boolean']['output'];
  pickup: Scalars['Boolean']['output'];
  resolve: FulfillmentMethod;
  ship: Scalars['Boolean']['output'];
};

export type FullEvent = ILimitedEventModel & {
  __typename?: 'FullEvent';
  achievements?: Maybe<AchievementPageX>;
  /** Denied/Pending/Approved breakdown for the Invitees dashboard's Action Taken tile. Covers every attendee on the event, including shared-link/QR joins. */
  actionTakenStatistics: ActionTakenStatisticsResult;
  /** Age limit of event */
  ageLimit?: Maybe<Scalars['Int']['output']>;
  /** All event tickets, unfiltered by visibility (includes private/hidden). Returned only to an admin or the event host/co-host; null otherwise. */
  allEventTickets?: Maybe<Array<Maybe<EventTicket>>>;
  approvedAttendeeTickets?: Maybe<Array<Maybe<EventAttendeeTicket>>>;
  approvedAttendees?: Maybe<Scalars['Long']['output']>;
  approvedAttendeesList?: Maybe<Array<Maybe<EventAttendeeInfo>>>;
  approvedTickets: Scalars['Long']['output'];
  /** False on existing events whose invitations have not yet been written to the OpenSearch index by the backfill job. The Invitees screen shows a 'preparing your data' banner while this is false. */
  areInvitationsIndexed: Scalars['Boolean']['output'];
  /** Attendee age range statistic */
  attendeeAgeRangeStatistic?: Maybe<AttendeeAgeRangeStatistic>;
  /** Information of attendee status of current user */
  attendeeInfo?: Maybe<EventAttendeeInfo>;
  attendees?: Maybe<Array<Maybe<EventAttendeeInfo>>>;
  attendees2?: Maybe<EventAttendeeInfoPageX>;
  attendeesExport?: Maybe<AttendeeExportedMaster>;
  attendeesPage?: Maybe<EventAttendeeInfoPageX>;
  /** Avatar url of event */
  avatarUrl: Scalars['String']['output'];
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  canProcessPayment: Scalars['Boolean']['output'];
  cannotDeleteReason?: Maybe<Scalars['String']['output']>;
  /** Club id of event */
  clubId?: Maybe<Scalars['UUID']['output']>;
  coHosts?: Maybe<UserPageX>;
  /** A list of comments on event */
  comments?: Maybe<EventCommentModelPageX>;
  /** A list of scheme of connected social networks */
  connectedSocialNetworks?: Maybe<Array<Scalars['String']['output']>>;
  coordinators?: Maybe<Array<User>>;
  /** The event this one was duplicated from. Null when it was created from scratch, or when the caller is neither an admin nor allowed to duplicate the source event. */
  copiedFromEventId?: Maybe<Scalars['UUID']['output']>;
  /** Estimate how many invitees the Send Reminders action would actually remind under the given filter, broken down by skip reason. Drives the confirmation popup before the host commits. */
  countResendCandidates: BulkResendCountResult;
  /** Event host or creator */
  createdBy?: Maybe<User>;
  /** Created date of event */
  createdDate: Scalars['DateTime']['output'];
  /** ISO 4217 currency code for event pricing (e.g. USD, GBP) */
  currency?: Maybe<Scalars['String']['output']>;
  /** Description of event */
  description: Scalars['String']['output'];
  detailsAttendee?: Maybe<DetailsAttendee>;
  detailsAttendees?: Maybe<DetailsAttendeeConnection>;
  detailsStaffAttendees?: Maybe<DetailsStaffAttendeeConnection>;
  /** SHA-256 (lowercase hex) of the current disclosure/NDA file's content — the document version signatures are validated against. Returned only to an admin or the event host/co-host; null otherwise, or when the event has no policy file. Legacy events are backfilled on first read. */
  disclosureOrPrivacyPolicyChecksum?: Maybe<Scalars['String']['output']>;
  /** Disclosure or privacy policy content */
  disclosureOrPrivacyPolicyContent?: Maybe<Scalars['String']['output']>;
  /** Disclosure or privacy policy file url */
  disclosureOrPrivacyPolicyFileUrl?: Maybe<Scalars['String']['output']>;
  /** Disclosure or privacy policy file title */
  disclosureOrPrivacyPolicyTitle?: Maybe<Scalars['String']['output']>;
  /** Display name of event */
  displayName: Scalars['String']['output'];
  doors?: Maybe<Array<User>>;
  /** Eligibility criteria configured for this event */
  eligibilityCriteria?: Maybe<EventEligibilityCriteria>;
  /** End date of event */
  endDate: Scalars['DateTime']['output'];
  /** Entries and check-ins at this event: its own tickets plus the series pass holders and +1 guests valid at it. Null unless the event belongs to a series. The series' entries field returns the same numbers for the same event. approvedTickets and scannedTickets keep counting the event's own tickets only. */
  entryStats?: Maybe<EventEntryStats>;
  /** Attendees to register their booking for the event */
  eventBookings?: Maybe<EventAttendeesBookingInfoPageX>;
  /** Attendees to register their booking for the event */
  eventBookings2?: Maybe<EventAttendeesBookingInfoPageX>;
  /** Id of event */
  eventId: Scalars['UUID']['output'];
  /** Id of the Event Series this event belongs to, or null if it is independent */
  eventSeriesId?: Maybe<Scalars['UUID']['output']>;
  /** List event tickets for host */
  eventTickets?: Maybe<EventTicketConnection>;
  /** List event tickets V2 for public */
  eventTickets2?: Maybe<Array<Maybe<EventTicket>>>;
  /** Event type */
  eventType: EventType;
  /** Returns the relative exclusiveAvatarUrl if the viewer is the event's creator, an attendee with a role or approved status, or the holder of an approved season pass for the event's series; otherwise returns null */
  exclusiveAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Description of event */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** FAQ entries */
  faqEntries?: Maybe<Array<FaqEntry>>;
  /** FAQs */
  faqs?: Maybe<Scalars['String']['output']>;
  hasAnyAttendeeApproved?: Maybe<Scalars['Boolean']['output']>;
  hasAttendeeInfo: Scalars['Boolean']['output'];
  hasRsvpOnlyTicket: Scalars['Boolean']['output'];
  /** Whether this event can take money: a paid ticket type is on sale, or was on sale and already released tickets. Free, RSVP-only and staff-role types never count, so false means gross revenue and net earnings can never move. Null when the caller is neither an admin nor allowed to view earnings. */
  hasTicketsForSale?: Maybe<Scalars['Boolean']['output']>;
  /** Is current user has tickets */
  hasUserEventBookings: Scalars['Boolean']['output'];
  invitationCount: Scalars['Int']['output'];
  /** @deprecated Use searchInvitees instead. This field always returns empty and will be removed. */
  invitations?: Maybe<Array<Maybe<EventInvitation>>>;
  invitedAttendees: Scalars['Long']['output'];
  /** Aggregated counts for the Invitees dashboard: Invited vs. Shared-link/QR totals, Method of Entry breakdown, and Delivery Status (Not opened/Viewed/Bounced/Opened), plus the same delivery outcomes restricted to invitees reached by email (emailNotOpened/emailOpenedOnly/emailLinkOpened/emailBounced). */
  inviteeStatistics?: Maybe<InviteeStatisticsResult>;
  inviterEarnings?: Maybe<Array<Maybe<InviterEarningMetric>>>;
  /** Flag if event is all-in pricing */
  isAllInPricing?: Maybe<Scalars['Boolean']['output']>;
  /** Is current user invited as a attendee role to the event */
  isAttendeeRoleInvited: Scalars['Boolean']['output'];
  isCoHost?: Maybe<Scalars['Boolean']['output']>;
  /** Flag if event is deleted */
  isDeleted: Scalars['Boolean']['output'];
  isEnded?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveAvatarAvailable?: Maybe<Scalars['Boolean']['output']>;
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  /** Is featured event */
  isFeatured: Scalars['Boolean']['output'];
  /** Is current user invited to the event */
  isInvited: Scalars['Boolean']['output'];
  isListFull?: Maybe<Scalars['Boolean']['output']>;
  /** Is listed event */
  isListed?: Maybe<Scalars['Boolean']['output']>;
  /** Flag if event is private */
  isPrivate: Scalars['Boolean']['output'];
  isPromoter?: Maybe<Scalars['Boolean']['output']>;
  /** True only for the hidden event created automatically to back an event series' tickets/payment/revenue — see EventModel.IsSeriesParentEvent. */
  isSeriesParentEvent: Scalars['Boolean']['output'];
  /** Check if current user is a special guest in this event */
  isSpecialGuest: Scalars['Boolean']['output'];
  isSponsor?: Maybe<Scalars['Boolean']['output']>;
  isStarted?: Maybe<Scalars['Boolean']['output']>;
  isTalent?: Maybe<Scalars['Boolean']['output']>;
  linkedClubOffers: Array<LinkClubState>;
  linkedOffers?: Maybe<LinkOfferStateConnection>;
  /** Location of event */
  location?: Maybe<EventLocation>;
  /** Location with radius of event */
  locationRadius?: Maybe<EventLocation>;
  migratedFromRewardId?: Maybe<Scalars['UUID']['output']>;
  /** Attendees minimum Rep Score */
  minimumRepScore?: Maybe<Scalars['Decimal']['output']>;
  /** Music embed url */
  musicEmbedUrl?: Maybe<Scalars['String']['output']>;
  myAchievements?: Maybe<Array<Achievement>>;
  /** Names of the series roles the current user holds on this event's parent series (empty when the event is in no series or the user holds none) */
  mySeriesRoles: Array<Scalars['String']['output']>;
  /** Note of event */
  note: Scalars['String']['output'];
  /** Opt-in age limit */
  optInAgeLimit: Scalars['Boolean']['output'];
  /** Opt-in allow guest to invite other guests */
  optInAllowGuestInviteOthers: Scalars['Boolean']['output'];
  /** Opt-in allow public event page preview */
  optInAllowPublicEventPagePreview?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in disclosure or privacy policy */
  optInDisclosureOrPrivacyPolicy: Scalars['Boolean']['output'];
  /** Opt-in display Rep Score */
  optInDisplayRepScore: Scalars['Boolean']['output'];
  /** Opt-in location radius */
  optInLocationRadius: Scalars['Boolean']['output'];
  /** Opt-in question requirements */
  optInQuestionRequirements: Scalars['Boolean']['output'];
  /** Opt-in require guest approval */
  optInRequireGuestApproval: Scalars['Boolean']['output'];
  /** Opt-in show guest count */
  optInShowGuestCount: Scalars['Boolean']['output'];
  /** Opt-in show guest list */
  optInShowGuestList: Scalars['Boolean']['output'];
  /** Opt-in show music embed */
  optInShowMusicEmbed: Scalars['Boolean']['output'];
  /** Opt-in show ticket amount */
  optInShowTicketAmount: Scalars['Boolean']['output'];
  /** Opt-in social account requirements */
  optInSocialAccountRequirements: Scalars['Boolean']['output'];
  /** Opt-in use Repbets QR pass */
  optInUseRepbetsQrPass: Scalars['Boolean']['output'];
  /** The payment processor assigned to this event. Pre-migration events are automatically backfilled on first access. Always returns a non-null value. */
  paymentProcessor: PaymentMethod;
  pendingAttendees?: Maybe<Scalars['Long']['output']>;
  pendingAttendees2: Scalars['Long']['output'];
  pendingCoHosts?: Maybe<Array<EventPendingOrganizerInfo>>;
  pendingCoordinators?: Maybe<Array<EventPendingOrganizerInfo>>;
  pendingDoors?: Maybe<Array<EventPendingOrganizerInfo>>;
  pendingPromoters?: Maybe<Array<EventPendingOrganizerInfo>>;
  pendingRoleInvites: Array<Scalars['String']['output']>;
  pendingSponsors?: Maybe<Array<EventPendingOrganizerInfo>>;
  pendingTalents?: Maybe<Array<EventPendingOrganizerInfo>>;
  pendingUsersRoles?: Maybe<Array<PendingEventUserRole>>;
  promoters?: Maybe<UserPageX>;
  /** List of question requirements */
  questionRequirements?: Maybe<Array<QuestionRequirement>>;
  recurringId?: Maybe<Scalars['UUID']['output']>;
  /** Require attendees to connect a social account before they can get a ticket */
  requireSocialAccountConnection: Scalars['Boolean']['output'];
  /** True when this event has a disclosure/privacy policy (NDA/waiver) enabled and the current viewer has no valid signature for its current document version. Signatures are matched by the policy file's content checksum, so an updated NDA reopens signing; within an event series a signature on any member event counts series-wide. False for anonymous viewers and events without a disclosure. */
  requiresDisclosureSignature: Scalars['Boolean']['output'];
  scannedTickets: Scalars['Long']['output'];
  /** List of scanning zones */
  scanningZones?: Maybe<Array<ScanningZone>>;
  /** Paginated list of everyone invited to this event, including attribution path and PII-suppressed email/phone for invitees not in the viewer's contacts. */
  searchInvitees?: Maybe<InviteeConnection>;
  /** People the series passes add to this event's attendee counts: approved pass holders and pending pass purchases the event's own approvedAttendees and pendingAttendees2 do not count. Zero unless the event belongs to a series. */
  seriesPassAttendeeCounts: SeriesPassAttendeeCounts;
  /** Attendee state of the current user's season pass for this event's series, read from the series' hidden parent event: InviteeAccepted while the pass awaits host approval, Approved once issued. Null when the event is in no series or the user holds no pass. For events listed because of a pass, where attendeeInfo is empty. */
  seriesPassAttendeeState?: Maybe<EventAttendeeState>;
  /** Season-pass ticket types of the series this event belongs to, read live from the series' hidden parent event — empty for an event that isn't in a series. Lets hosts offer a pass (e.g. comp or private invites) from a member event; grants of these ticket types are issued on the parent event. */
  seriesPassTickets?: Maybe<EventTicketConnection>;
  /** Holders of the parent series' Host, Talent and Sponsor roles, shown in the event's public team alongside the event-level roles. Empty when the event is in no series. */
  seriesTeam: Array<EventSeriesTeamMember>;
  /**
   * Season-pass holders expected at this event, read live from the series' hidden parent event — empty for an event that doesn't belong to a series, or if the caller lacks attendee-viewing permission. Lets hosts see expected series-ticket attendees before they check in.
   * @deprecated Series pass holders are listed in detailsAttendees, with their passes marked isSeriesPass.
   */
  seriesTicketHolders: Array<SeriesTicketHolderInfo>;
  /** Slug of event */
  slug: Scalars['String']['output'];
  /** List of social account requirements */
  socialAccountRequirements?: Maybe<Array<SocialAccountRequirement>>;
  socialReaches?: Maybe<Array<Maybe<EventSocialNetworkReaches>>>;
  sponsors?: Maybe<UserPageX>;
  /** Start date of event */
  startDate: Scalars['DateTime']['output'];
  /** Description of event */
  status: EventStatus;
  /** The Talent shown on the event page, in display order: the event's own talent followed by the parent series' Talent role holders (each person once), arranged by the saved Talent order. Clients render this as is. */
  talentLineup: Array<User>;
  /** Display order of the Talent list, as user ids, covering event-level and series-level talent. An event in a series shares the series' order. It may name only some people; the rest keep their place. Empty when no order was set. */
  talentOrder: Array<Scalars['UUID']['output']>;
  talents?: Maybe<Array<User>>;
  /** Jurisdiction-aware tax-collection posture for the event owner's connected account: whether any active Stripe Tax registration exists, the owner's home (head-office) state, and whether they're registered there. Under automatic tax, an owner not registered where they have nexus collects no tax on this event's sales, so co-hosts and the owner can see the gap on the event dashboard. */
  taxCollection?: Maybe<StripeTaxCollectionStatus>;
  /** The event owner's tax configuration, which is applied to this event's sales. */
  taxConfiguration?: Maybe<UserTaxConfiguration>;
  /** Terms and Conditions */
  terms?: Maybe<Scalars['String']['output']>;
  /** Ticket terms & purchase policy */
  ticketTermsPurchasePolicy?: Maybe<Scalars['String']['output']>;
  /** A list of my tickets associated with this event */
  tickets?: Maybe<Array<Maybe<TicketWithIdOfStoredTicket>>>;
  /** Event time zone */
  timeZone?: Maybe<Scalars['String']['output']>;
  totalAttendees?: Maybe<Scalars['Long']['output']>;
  totalAvailableTickets: Scalars['Int']['output'];
  /** @deprecated To be removed. Must use FullEventType for totalEarnings! */
  totalEarnings?: Maybe<Scalars['Decimal']['output']>;
  totalEventTickets?: Maybe<Scalars['Long']['output']>;
  /** Updated date of event */
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Uploaded asset id of event */
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
  /** A list of my ticket bookings associated with this event */
  userEventBookings?: Maybe<Array<Maybe<EventAttendeesBookingInfo>>>;
  usersRoles?: Maybe<Array<EventUserRole>>;
  /** List of ticket ids that user waiting for amount available */
  waitingTickets?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  waitingTicketsUsers?: Maybe<Array<Maybe<EventTicketWaitingUsers>>>;
  waitingTicketsUsersCount?: Maybe<Array<Maybe<EventTicketWaitingUsersCount>>>;
  /** For each configured scanning zone, whether it can be deleted (has no recorded scans). */
  zoneDeletability: Array<ZoneDeletability>;
};


export type FullEventAchievementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventAttendeeAgeRangeStatisticArgs = {
  attendeeFilterStatus?: InputMaybe<AttendeeFilterStatus>;
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
};


export type FullEventAttendees2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AttendeeFilterArgsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventAttendeesPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventCoHostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventCountResendCandidatesArgs = {
  filter?: InputMaybe<SearchInviteesFilterArgs>;
  includeBounced?: Scalars['Boolean']['input'];
};


export type FullEventDetailsAttendeeArgs = {
  attendeeId: Scalars['UUID']['input'];
};


export type FullEventDetailsAttendeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DetailsAttendeeFilterArgsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventDetailsStaffAttendeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DetailsStaffAttendeeFilterArgsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventEventBookingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventEventBookings2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EventBookingFilterArgsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventEventTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventLinkedOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LinkOfferStateFilterArgsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventPromotersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventSearchInviteesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchInviteesFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventSeriesPassTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullEventSocialReachesArgs = {
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
};


export type FullEventSponsorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a slice or page of Event */
export type FullEventOffsetPage = {
  __typename?: 'FullEventOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<FullEvent>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type FullReward = ILimitedRewardModel & {
  __typename?: 'FullReward';
  /** A list of achievement badge conditions to participate a reward */
  achievementBadgeConditions?: Maybe<StoredAchievementBadgeConditionPageX>;
  /** List rewards achievements */
  achievements?: Maybe<AchievementGrainPageX>;
  /** Activated user age range statistic */
  activatedUserAgeRangeStatistic?: Maybe<ActivatedUserAgeRangeStatistic>;
  /** Age limit */
  ageLimit?: Maybe<Scalars['Int']['output']>;
  /** Avatar url of reward */
  avatarUrl: Scalars['String']['output'];
  /** Bio of reward */
  bio?: Maybe<Scalars['String']['output']>;
  /** List rewards bonus achievements */
  bonusAchievements?: Maybe<AchievementGrainPageX>;
  /** Can share by participants */
  canShareByParticipants: Scalars['Boolean']['output'];
  /** Category of reward */
  category?: Maybe<RewardCategory>;
  /** Created date of reward */
  createdUtc: Scalars['DateTime']['output'];
  /** Display name of reward */
  displayName: Scalars['String']['output'];
  /** End date */
  endDate: Scalars['DateTime']['output'];
  /**
   * Expired date of reward
   * @deprecated Use expiresAt instead
   */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Expire date of reward */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Geo Range Condition */
  geoRangeCondition?: Maybe<RewardGeoRangeCondition>;
  /** Individual api url of reward */
  individualApiUrl: Scalars['String']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Represents if the reward is expired or not */
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  /** Is hidden of reward */
  isHidden: Scalars['Boolean']['output'];
  /** Represents if the reward is started or not */
  isStarted?: Maybe<Scalars['Boolean']['output']>;
  /** List of all policy info in this reward */
  listPolicyInfo?: Maybe<RewardPolicyInfoPageX>;
  /** Policy reaction list of all users to this reward */
  listPolicyReaction?: Maybe<RewardPolicyReactionInfoPageX>;
  /** Maximum number of winners */
  maxWinners?: Maybe<Scalars['Int']['output']>;
  migratedEvent?: Maybe<FullEvent>;
  /** Must own amount of slices */
  mustOwnSlicesAmount?: Maybe<Scalars['Decimal']['output']>;
  /** Must own amount of slices end date */
  mustOwnSlicesEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Must own slices from another pie */
  mustOwnSlicesFromPieId?: Maybe<Scalars['UUID']['output']>;
  /** Must own amount of slices start date */
  mustOwnSlicesStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** Need new slices */
  needNewSlices: Scalars['Boolean']['output'];
  /** Redeem Notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Opt-in privacy policy for participants */
  optInParticipantPrivacyPolicy: Scalars['Boolean']['output'];
  /** A list of own slices conditions to participate a reward */
  ownSlicesConditions?: Maybe<StoredOwnSlicesConditionPageX>;
  /** Privacy policy for participants content */
  participantPrivacyPolicyContent?: Maybe<Scalars['String']['output']>;
  /** Title for privacy policy for participants */
  participantPrivacyPolicyTitle?: Maybe<Scalars['String']['output']>;
  /** List participants of reward */
  participants?: Maybe<Array<Maybe<RewardParticipant>>>;
  /** Pie of reward */
  pie?: Maybe<CompletePieWithBalance>;
  /** Privacy policy file path */
  policyFileUrl?: Maybe<Scalars['String']['output']>;
  /** Information of reaction status of current user to this reward policy */
  policyReaction?: Maybe<StoredUserReactionRewardPolicy>;
  /** Redeem Code */
  redeemCode?: Maybe<Scalars['String']['output']>;
  /** How to redeem */
  redeemDescription?: Maybe<Scalars['String']['output']>;
  /** Redeem type */
  redeemType?: Maybe<RedeemType>;
  /** Require all achievements for activation */
  requireAllAchievements: Scalars['Boolean']['output'];
  /** Id of reward */
  rewardId: Scalars['UUID']['output'];
  /**
   * List activated users of reward
   * @deprecated Use rewardUsers2 instead
   */
  rewardUsers?: Maybe<UserRewardOffsetPage>;
  /** List activated users of reward */
  rewardUsers2?: Maybe<UserRewardPageX>;
  /** Slug of reward */
  slug: Scalars['String']['output'];
  /** Start date */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Status of reward */
  status: RewardStatus;
  /** A list of my tickets associated with this reward */
  tickets?: Maybe<TicketWithIdPageX>;
  /** The total user amount has claimed the reward */
  totalActivatedUserAmount?: Maybe<Scalars['Int']['output']>;
  /** Total count of participants of reward */
  totalParticipants?: Maybe<Scalars['Int']['output']>;
  /** Total count of users claimed the reward */
  totalUnlockedUser?: Maybe<Scalars['Int']['output']>;
  /** Type of reward */
  type: RewardType;
  /** Id of selected uploaded asset */
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
  /** Information of participation status of current user */
  userRewardInfo?: Maybe<UserReward>;
  /** Winners are chosen */
  winnersChosenOption?: Maybe<WinnersChosenOption>;
  /** A list of winning boosts of a reward */
  winningBoosts?: Maybe<StoredWinningBoostPageX>;
};


export type FullRewardAchievementBadgeConditionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullRewardAchievementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullRewardActivatedUserAgeRangeStatisticArgs = {
  participateStates?: InputMaybe<Array<ParticipateState>>;
};


export type FullRewardBonusAchievementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullRewardListPolicyInfoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullRewardListPolicyReactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullRewardOwnSlicesConditionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullRewardParticipantsArgs = {
  participateStates?: InputMaybe<Array<ParticipateState>>;
};


export type FullRewardRewardUsersArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  participateStates?: InputMaybe<Array<ParticipateState>>;
  sortingOrder?: InputMaybe<PageSortOrder>;
  sortingType?: InputMaybe<RewardSortingType>;
};


export type FullRewardRewardUsers2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  participateStates?: InputMaybe<Array<ParticipateState>>;
  sortingOrder?: InputMaybe<PageSortOrder>;
  sortingType?: InputMaybe<RewardSortingType>;
};


export type FullRewardTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FullRewardTotalParticipantsArgs = {
  participateStates?: InputMaybe<Array<ParticipateState>>;
};


export type FullRewardWinningBoostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type FundingApi = {
  __typename?: 'FundingApi';
  /** PLACEHOLDER: Add a funding source */
  addFundingSource: Scalars['Boolean']['output'];
  /** PLACEHOLDER: Add a funding target */
  addFundingTarget: Scalars['Boolean']['output'];
  /** PLACEHOLDER: Add funds from an existing funding source to the wallet balance */
  addFunds: Scalars['Boolean']['output'];
  /** PLACEHOLDER: Remove an existing funding source */
  removeFundingSource: Scalars['Boolean']['output'];
  /** PLACEHOLDER: Remove an existing funding target */
  removeFundingTarget: Scalars['Boolean']['output'];
  /** PLACEHOLDER: Withdraw funds from an existing balance to an existing funding target */
  withdrawFunds: Scalars['Boolean']['output'];
};

export type FundingSourceArgsInput = {
  stripe?: InputMaybe<FundingSourceStripeInput>;
};

export type FundingSourceStripeInput = {
  /** The Payment Intent created with stripe.createPaymentIntent() */
  paymentIntentId: Scalars['String']['input'];
};

export type GeneratedInvite = {
  __typename?: 'GeneratedInvite';
  bitlyUrl?: Maybe<Scalars['URL']['output']>;
  inviteAcceptLink: Scalars['URL']['output'];
  inviteId: Scalars['String']['output'];
  repBetsUrl?: Maybe<Scalars['URL']['output']>;
};

export type GiftTicketsArgs = {
  __typename?: 'GiftTicketsArgs';
  amount: Scalars['Int']['output'];
  eventTicketId: Scalars['UUID']['output'];
};

export type GiftTicketsArgsInput = {
  amount: Scalars['Int']['input'];
  eventTicketId: Scalars['UUID']['input'];
};

export type GroupModelArgsInput = {
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupName: Scalars['String']['input'];
};

export type GroupedUserAchievement = {
  __typename?: 'GroupedUserAchievement';
  ageRangeStatistic?: Maybe<ActivatedUserAgeRangeStatistic>;
  triggeredByRewards?: Maybe<Array<Maybe<Reward>>>;
  userAchievements?: Maybe<Array<Maybe<UserAchievement>>>;
};

/** A connection to a list of items. */
export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<GroupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ContactGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GroupsEdge = {
  __typename?: 'GroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContactGroup>;
};

export type GuestCustomField = {
  __typename?: 'GuestCustomField';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GuestCustomFieldInput = {
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type GuestInfo = {
  __typename?: 'GuestInfo';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  checkedInAt?: Maybe<Scalars['DateTime']['output']>;
  checkedInQuantity?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields: Array<GuestCustomField>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  eventTicketId?: Maybe<Scalars['UUID']['output']>;
  fullName: Scalars['String']['output'];
  guestId: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
};

export type GuestInfoMatch = {
  __typename?: 'GuestInfoMatch';
  emailAddress: Scalars['Int']['output'];
  fullName: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type GuestInfoWithEvent = {
  __typename?: 'GuestInfoWithEvent';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  checkedInAt?: Maybe<Scalars['DateTime']['output']>;
  checkedInQuantity?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields: Array<GuestCustomField>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['UUID']['output'];
  eventTicket?: Maybe<EventTicket>;
  eventTicketId?: Maybe<Scalars['UUID']['output']>;
  fullName: Scalars['String']['output'];
  guestId: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
};

export type GuestInfoWithEventAndMatch = {
  __typename?: 'GuestInfoWithEventAndMatch';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  checkedInAt?: Maybe<Scalars['DateTime']['output']>;
  checkedInQuantity?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields: Array<GuestCustomField>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['UUID']['output'];
  eventTicket?: Maybe<EventTicket>;
  eventTicketId?: Maybe<Scalars['UUID']['output']>;
  fullName: Scalars['String']['output'];
  guestId: Scalars['UUID']['output'];
  match: GuestInfoMatch;
  note?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
};

export type GuestInfoWithEventEdgeX = {
  __typename?: 'GuestInfoWithEventEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<GuestInfoWithEvent>;
};

/** Represents a slice or page */
export type GuestInfoWithEventGrainPageX = {
  __typename?: 'GuestInfoWithEventGrainPageX';
  /** A list of edges */
  edges: Array<GuestInfoWithEventEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<GuestInfoWithEvent>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type GuestInvitationInfo = {
  __typename?: 'GuestInvitationInfo';
  email: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  plus1?: Maybe<Scalars['String']['output']>;
};

export type GuestInvitationInfoInput = {
  email: Scalars['String']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  plus1?: InputMaybe<Scalars['String']['input']>;
};

export type GuestQrCodeModel = {
  __typename?: 'GuestQrCodeModel';
  count: Scalars['Int']['output'];
  expiresAt: Scalars['DateTime']['output'];
  firstSeen?: Maybe<Scalars['DateTime']['output']>;
  guestId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  qrCode: Scalars['String']['output'];
};

export type GuestQrPassInfo = {
  __typename?: 'GuestQrPassInfo';
  /** The event's end date/time */
  endDate: Scalars['DateTime']['output'];
  /** The full URL of the event's image, or null if the event has no image */
  eventImageUrl?: Maybe<Scalars['String']['output']>;
  /** The event's display name */
  eventName: Scalars['String']['output'];
  /** True if this pass has already been scanned its maximum number of times and can no longer be redeemed */
  fullyRedeemed: Scalars['Boolean']['output'];
  /** The guest's name */
  guestName: Scalars['String']['output'];
  /** The scannable value to render as a QR code */
  qrValue: Scalars['String']['output'];
  /** The event's start date/time */
  startDate: Scalars['DateTime']['output'];
  /** A human-readable summary of the guest's ticket type(s) and quantities, e.g. "General Admission (x2), VIP (x1)", or "QR Pass (xN)" for guests without assigned tickets */
  ticketType: Scalars['String']['output'];
  /** The event's IANA time zone id, or null if unset */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** Short-lived token to append to /api/wallet/v1/download/{token} to download this guest's Apple Wallet pass */
  walletDownloadToken?: Maybe<Scalars['String']['output']>;
};

export type HasCanonicalUrl = {
  /** The absolute canonical url for this object, can be used for sharing */
  canonicalUrl?: Maybe<Scalars['URL']['output']>;
};

export type HighestSlicesOfParticipateRewards = {
  __typename?: 'HighestSlicesOfParticipateRewards';
  slicesOfAwarded: Scalars['Decimal']['output'];
  slicesOfParticipating: Scalars['Decimal']['output'];
};

export type HolderAdditionalGuests = {
  __typename?: 'HolderAdditionalGuests';
  attendeeState?: Maybe<EventAttendeeState>;
  passes: Array<AdditionalGuestTicketRow>;
  plusOnes: Array<AdditionalGuestTicketRow>;
  userId: Scalars['UUID']['output'];
};

export type HoldingPie = ILimitedHoldingPieModel & {
  __typename?: 'HoldingPie';
  /** Id of holding pie */
  holdingPieId: Scalars['UUID']['output'];
  /** Pie is holding */
  pie?: Maybe<CompletePieWithBalance>;
  /** How many slices of the pie that user is holding */
  slices: Scalars['Decimal']['output'];
};

export type HostInboxResponse = {
  __typename?: 'HostInboxResponse';
  endCursor?: Maybe<Scalars['String']['output']>;
  messages: Array<HostMessageResponse>;
  total: Scalars['Long']['output'];
};

export type HostMessageDeliveryResponse = {
  __typename?: 'HostMessageDeliveryResponse';
  completedAt: Scalars['DateTime']['output'];
  failCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  suppressedCount: Scalars['Int']['output'];
};

export enum HostMessageKind {
  Broadcast = 'BROADCAST',
  Direct = 'DIRECT'
}

export type HostMessageMutationApi = {
  __typename?: 'HostMessageMutationApi';
  /** Mark a host message as read. Only a participant (sender, recipient, or listed receiver) may call this. */
  markRead: Scalars['Boolean']['output'];
  /** Mark a host message as unread. Only a participant (sender, recipient, or listed receiver) may call this. */
  markUnread: Scalars['Boolean']['output'];
  /** Reply to an existing message. Only participants in the original conversation may reply. */
  reply: SendHostMessageResult;
  /** Send a message to the host of an event. */
  send: SendHostMessageResult;
  /** Send a direct message to any user without needing an event context. */
  sendDirect: SendHostMessageResult;
};


export type HostMessageMutationApiMarkReadArgs = {
  messageId: Scalars['UUID']['input'];
};


export type HostMessageMutationApiMarkUnreadArgs = {
  messageId: Scalars['UUID']['input'];
};


export type HostMessageMutationApiReplyArgs = {
  body: Scalars['String']['input'];
  messageId: Scalars['UUID']['input'];
};


export type HostMessageMutationApiSendArgs = {
  body: Scalars['String']['input'];
  eventId: Scalars['UUID']['input'];
};


export type HostMessageMutationApiSendDirectArgs = {
  body: Scalars['String']['input'];
  recipientId: Scalars['UUID']['input'];
};

export type HostMessageQueryApi = {
  __typename?: 'HostMessageQueryApi';
  /** Get a single host message by ID. Accessible by sender or host only. */
  get?: Maybe<HostMessageResponse>;
  /** Get the inbox for the authenticated user. Optionally filter by eventId — event producers/managers see all messages for that event. Sorted newest first. */
  inbox: HostInboxResponse;
};


export type HostMessageQueryApiGetArgs = {
  messageId: Scalars['UUID']['input'];
};


export type HostMessageQueryApiInboxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  count?: Scalars['Int']['input'];
  eventId?: InputMaybe<Scalars['UUID']['input']>;
};

export type HostMessageResponse = {
  __typename?: 'HostMessageResponse';
  body: Scalars['String']['output'];
  delivery?: Maybe<HostMessageDeliveryResponse>;
  eventAvatar?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['UUID']['output'];
  eventName?: Maybe<Scalars['String']['output']>;
  eventSlug?: Maybe<Scalars['String']['output']>;
  hostId: Scalars['UUID']['output'];
  isRead: Scalars['Boolean']['output'];
  isViaEmail?: Maybe<Scalars['Boolean']['output']>;
  isViaSms?: Maybe<Scalars['Boolean']['output']>;
  kind: HostMessageKind;
  messageId: Scalars['UUID']['output'];
  parentMessageId?: Maybe<Scalars['UUID']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  recipientCount: Scalars['Int']['output'];
  senderAvatar?: Maybe<Scalars['String']['output']>;
  senderAvatarSource?: Maybe<AvatarSource>;
  senderId: Scalars['UUID']['output'];
  senderInstagramAvatarUrl?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  senderTikTokAvatarUrl?: Maybe<Scalars['String']['output']>;
  senderTwitchAvatarUrl?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['DateTime']['output'];
  threadId: Scalars['UUID']['output'];
};

export type ILimitedAchievementModel = {
  achievementId: Scalars['UUID']['output'];
  activeFromUtc?: Maybe<Scalars['DateTime']['output']>;
  activeToUtc?: Maybe<Scalars['DateTime']['output']>;
  avatarUrl: Scalars['String']['output'];
  bio: Scalars['String']['output'];
  category?: Maybe<AchievementCategory>;
  createdUtc: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  maxSupply?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<User>;
  pie?: Maybe<CompletePieWithBalance>;
  slug: Scalars['String']['output'];
  status: AchievementStatus;
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
  verificationCode: Scalars['String']['output'];
};

export type ILimitedDeviceModel = {
  deviceId: Scalars['String']['output'];
  deviceName?: Maybe<Scalars['String']['output']>;
  platform: DevicePlatform;
  pushEndpointAddress?: Maybe<Scalars['String']['output']>;
  pushNotificationToken: Scalars['String']['output'];
};

export type ILimitedEventModel = {
  /** Age limit of event */
  ageLimit?: Maybe<Scalars['Int']['output']>;
  avatarUrl: Scalars['String']['output'];
  /** Club id of event */
  clubId?: Maybe<Scalars['UUID']['output']>;
  createdBy?: Maybe<User>;
  createdDate: Scalars['DateTime']['output'];
  /** ISO 4217 currency code for event pricing (e.g. USD, GBP) */
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  /** Disclosure or privacy policy content */
  disclosureOrPrivacyPolicyContent?: Maybe<Scalars['String']['output']>;
  /** Disclosure or privacy policy file url */
  disclosureOrPrivacyPolicyFileUrl?: Maybe<Scalars['String']['output']>;
  /** Disclosure or privacy policy file title */
  disclosureOrPrivacyPolicyTitle?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  eventId: Scalars['UUID']['output'];
  /** Id of the Event Series this event belongs to, or null if it is independent */
  eventSeriesId?: Maybe<Scalars['UUID']['output']>;
  eventType: EventType;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** FAQ entries */
  faqEntries?: Maybe<Array<FaqEntry>>;
  /** FAQs */
  faqs?: Maybe<Scalars['String']['output']>;
  isAllInPricing?: Maybe<Scalars['Boolean']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  /** Is featured event */
  isFeatured: Scalars['Boolean']['output'];
  /** Is listed event */
  isListed?: Maybe<Scalars['Boolean']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  /** True only for the hidden event created automatically to back an event series' tickets/payment/revenue — see EventModel.IsSeriesParentEvent. */
  isSeriesParentEvent: Scalars['Boolean']['output'];
  location?: Maybe<EventLocation>;
  locationRadius?: Maybe<EventLocation>;
  /** Attendees minimum Rep Score */
  minimumRepScore?: Maybe<Scalars['Decimal']['output']>;
  /** Music embed url */
  musicEmbedUrl?: Maybe<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  /** Opt-in age limit */
  optInAgeLimit: Scalars['Boolean']['output'];
  /** Opt-in allow guest to invite other guests */
  optInAllowGuestInviteOthers: Scalars['Boolean']['output'];
  optInAllowPublicEventPagePreview?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in disclosure or privacy policy */
  optInDisclosureOrPrivacyPolicy: Scalars['Boolean']['output'];
  /** Opt-in display Rep Score */
  optInDisplayRepScore: Scalars['Boolean']['output'];
  /** Opt-in location radius */
  optInLocationRadius: Scalars['Boolean']['output'];
  /** Opt-in question requirements */
  optInQuestionRequirements: Scalars['Boolean']['output'];
  /** Opt-in require guest approval */
  optInRequireGuestApproval: Scalars['Boolean']['output'];
  /** Opt-in show guest count */
  optInShowGuestCount: Scalars['Boolean']['output'];
  /** Opt-in show guest list */
  optInShowGuestList: Scalars['Boolean']['output'];
  /** Opt-in show music embed */
  optInShowMusicEmbed: Scalars['Boolean']['output'];
  optInShowTicketAmount: Scalars['Boolean']['output'];
  /** Opt-in social account requirements */
  optInSocialAccountRequirements: Scalars['Boolean']['output'];
  /** Opt-in use Repbets QR pass */
  optInUseRepbetsQrPass: Scalars['Boolean']['output'];
  /** List of question requirements */
  questionRequirements?: Maybe<Array<QuestionRequirement>>;
  recurringId?: Maybe<Scalars['UUID']['output']>;
  /** Require attendees to connect a social account before they can get a ticket */
  requireSocialAccountConnection: Scalars['Boolean']['output'];
  /** List of scanning zones */
  scanningZones?: Maybe<Array<ScanningZone>>;
  slug: Scalars['String']['output'];
  /** List of social account requirements */
  socialAccountRequirements?: Maybe<Array<SocialAccountRequirement>>;
  startDate: Scalars['DateTime']['output'];
  status: EventStatus;
  /** Terms and Conditions */
  terms?: Maybe<Scalars['String']['output']>;
  /** Ticket terms & purchase policy */
  ticketTermsPurchasePolicy?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
};

export type ILimitedExternalApplicationModel = {
  createdAt: Scalars['DateTime']['output'];
  dataUseStatement?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalApplicationId: Scalars['UUID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  redirectUris: Array<Scalars['String']['output']>;
  tokens: Array<KeyValuePairOfStringAndExternalApplicationToken>;
};

export type ILimitedHoldingPieModel = {
  holdingPieId: Scalars['UUID']['output'];
  pie?: Maybe<CompletePieWithBalance>;
  slices: Scalars['Decimal']['output'];
};

export type ILimitedPieModel = {
  /** Description or bio of the pie */
  bio?: Maybe<Scalars['String']['output']>;
  /** The user created the pie */
  createdBy?: Maybe<User>;
  /** Created at */
  createdUtc: Scalars['DateTime']['output'];
  /** Name of the pie */
  displayName: Scalars['String']['output'];
  /** How many number of slices percentage that publisher is selling */
  floatPercentage: Scalars['Decimal']['output'];
  /** The total number of slices that publisher is holding */
  holdingSlices: Scalars['Decimal']['output'];
  /** Initial offer */
  initialOffer?: Maybe<PublicPieInitialOfferModel>;
  /** Is Pie deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Is Pie disabled */
  isDisabled: Scalars['Boolean']['output'];
  /** True if this pie is verified */
  isVerified: Scalars['Boolean']['output'];
  /** Is Pie visible */
  isVisible: Scalars['Boolean']['output'];
  /** The maximum number of slices for a pie and can not be changed after creation */
  issuedSlices: Scalars['Decimal']['output'];
  /** Pie launched date */
  launchedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Market symbol of pie */
  marketSymbol?: Maybe<Scalars['String']['output']>;
  /** Current state of the pie */
  operationalState: PieOperationalState;
  /** Url for pie avatar */
  pieAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Id of pie */
  pieId: Scalars['UUID']['output'];
  /** Global rank of pie */
  rank?: Maybe<Scalars['Int']['output']>;
  /** Price per slice of pie */
  slicePrice: Amount;
  /** How many number of slices percentage that publisher is holing */
  slicesHeld: Scalars['Decimal']['output'];
  /** Slug of pie */
  slug: Scalars['String']['output'];
  /** List of associated social media */
  socialMedia: Array<SocialMediaPair>;
  /** Total members */
  totalMembers: Scalars['Long']['output'];
  /** Total number of unique subscribers of this pie */
  totalUniqueSubscribers: Scalars['Int']['output'];
  /** Total value of all slices */
  totalValue: Amount;
  /** Url of the Pie avatar which is in generating or generated */
  truePieAvatarUrl?: Maybe<Scalars['String']['output']>;
};

export type ILimitedRewardModel = {
  ageLimit?: Maybe<Scalars['Int']['output']>;
  avatarUrl: Scalars['String']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  canShareByParticipants: Scalars['Boolean']['output'];
  category?: Maybe<RewardCategory>;
  createdUtc: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  /** @deprecated Use expiresAt instead */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  geoRangeCondition?: Maybe<RewardGeoRangeCondition>;
  individualApiUrl: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  maxWinners?: Maybe<Scalars['Int']['output']>;
  mustOwnSlicesAmount?: Maybe<Scalars['Decimal']['output']>;
  mustOwnSlicesEndDate?: Maybe<Scalars['DateTime']['output']>;
  mustOwnSlicesFromPieId?: Maybe<Scalars['UUID']['output']>;
  mustOwnSlicesStartDate?: Maybe<Scalars['DateTime']['output']>;
  needNewSlices: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  optInParticipantPrivacyPolicy: Scalars['Boolean']['output'];
  participantPrivacyPolicyContent?: Maybe<Scalars['String']['output']>;
  participantPrivacyPolicyTitle?: Maybe<Scalars['String']['output']>;
  pie?: Maybe<CompletePieWithBalance>;
  policyFileUrl?: Maybe<Scalars['String']['output']>;
  redeemCode?: Maybe<Scalars['String']['output']>;
  redeemDescription?: Maybe<Scalars['String']['output']>;
  redeemType?: Maybe<RedeemType>;
  requireAllAchievements: Scalars['Boolean']['output'];
  rewardId: Scalars['UUID']['output'];
  slug: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: RewardStatus;
  totalActivatedUserAmount?: Maybe<Scalars['Int']['output']>;
  type: RewardType;
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
  winnersChosenOption?: Maybe<WinnersChosenOption>;
};

export type IncreaseTicketsAmountArgsInput = {
  availableAmount: Scalars['Int']['input'];
  eventTicketId: Scalars['UUID']['input'];
  newPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type IncreaseTicketsAmountInfo = {
  __typename?: 'IncreaseTicketsAmountInfo';
  eventTicket: EventTicket;
  requiredAmount: Scalars['Int']['output'];
};

export type IndividualAsset = {
  __typename?: 'IndividualAsset';
  category: IndividualAssetCategory;
  createdUtc: Scalars['DateTime']['output'];
  currentSupply: Scalars['Decimal']['output'];
  imageUrl: Scalars['String']['output'];
  individualAssetId: Scalars['UUID']['output'];
  isHidden: Scalars['Boolean']['output'];
  maxSupply: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  price: Amount;
  priority: Scalars['Int']['output'];
  status: IndividualAssetStatus;
};

export enum IndividualAssetCategory {
  Background = 'BACKGROUND',
  Crust = 'CRUST',
  Filling = 'FILLING',
  Fork = 'FORK',
  Napkin = 'NAPKIN',
  Plate = 'PLATE',
  Topping = 'TOPPING'
}

export type IndividualAssetEdgeX = {
  __typename?: 'IndividualAssetEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<IndividualAsset>;
};

/** Represents a slice or page */
export type IndividualAssetGrainPageX = {
  __typename?: 'IndividualAssetGrainPageX';
  /** A list of edges */
  edges: Array<IndividualAssetEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<IndividualAsset>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type IndividualAssetMutationApi = {
  __typename?: 'IndividualAssetMutationApi';
  /** PLACEHOLDER: Create or update an individual asset */
  createOrUpdate: PublicIndividualAssetModel;
  /** PLACEHOLDER: Set price for all individual assets */
  setPriceForAll?: Maybe<Array<IndividualAsset>>;
  /** PLACEHOLDER: Update name and image url of an individual asset */
  updateBasicInfo: PublicIndividualAssetModel;
};


export type IndividualAssetMutationApiCreateOrUpdateArgs = {
  category: IndividualAssetCategory;
  currentSupply: Scalars['Decimal']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl: Scalars['String']['input'];
  maxSupply: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  price: AmountInput;
  priority: Scalars['Int']['input'];
};


export type IndividualAssetMutationApiSetPriceForAllArgs = {
  price: AmountInput;
};


export type IndividualAssetMutationApiUpdateBasicInfoArgs = {
  id: Scalars['UUID']['input'];
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
};

export type IndividualAssetQueryApi = {
  __typename?: 'IndividualAssetQueryApi';
  list?: Maybe<Array<Maybe<IndividualAsset>>>;
};

export enum IndividualAssetStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  None = 'NONE'
}

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type InvitationInfo = {
  __typename?: 'InvitationInfo';
  giftTicketName?: Maybe<Scalars['String']['output']>;
  giftTicketQuantity?: Maybe<Scalars['Int']['output']>;
  privateTicketName?: Maybe<Scalars['String']['output']>;
  privateTicketQuantity?: Maybe<Scalars['Int']['output']>;
};

export enum InvitationSource {
  Direct = 'DIRECT',
  PrivateTicket = 'PRIVATE_TICKET',
  SharedLink = 'SHARED_LINK',
  Unknown = 'UNKNOWN'
}

export enum InvitationStatus {
  Acceptted = 'ACCEPTTED',
  Bounced = 'BOUNCED',
  Claimed = 'CLAIMED',
  Invited = 'INVITED',
  None = 'NONE',
  Pending = 'PENDING',
  Viewed = 'VIEWED'
}

export type InviteAcceptActionBase = {
  __typename?: 'InviteAcceptActionBase';
  inviteActionData: Array<KeyValuePairOfStringAndString>;
  inviteActionName: Scalars['String']['output'];
};

export type InviteActionAchievement = {
  __typename?: 'InviteActionAchievement';
  achievementId: Scalars['UUID']['output'];
  checkingRewardId?: Maybe<Scalars['UUID']['output']>;
  claimedByRewardId?: Maybe<Scalars['UUID']['output']>;
};

export type InviteActionAchievementInput = {
  achievementId: Scalars['UUID']['input'];
  checkingRewardId?: InputMaybe<Scalars['UUID']['input']>;
  claimedByRewardId?: InputMaybe<Scalars['UUID']['input']>;
};

export type InviteActionCanCreatePiesInput = {
  canCreatePies: Scalars['Boolean']['input'];
};

export type InviteActionEmailInput = {
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type InviteActionEventInvitation = {
  __typename?: 'InviteActionEventInvitation';
  attendeeState?: Maybe<EventAttendeeState>;
  contactId?: Maybe<Scalars['UUID']['output']>;
  eventId: Scalars['UUID']['output'];
  grantTicketCount?: Maybe<Scalars['Int']['output']>;
  grantTicketEventId?: Maybe<Scalars['UUID']['output']>;
  grantTicketTypeId?: Maybe<Scalars['UUID']['output']>;
  invitationMessage?: Maybe<Scalars['String']['output']>;
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  inviteeEmail?: Maybe<Scalars['String']['output']>;
  inviteeId?: Maybe<Scalars['UUID']['output']>;
  inviterId: Scalars['UUID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  privateTicketAmount?: Maybe<Scalars['Int']['output']>;
  privateTicketEventId?: Maybe<Scalars['UUID']['output']>;
  privateTicketTypeId?: Maybe<Scalars['UUID']['output']>;
  processedGiftTicketsBeforeSend: Scalars['Boolean']['output'];
  processedPrivateTicketsBeforeSend: Scalars['Boolean']['output'];
  sendId?: Maybe<Scalars['UUID']['output']>;
};

export type InviteActionEventInvitationInput = {
  attendeeState?: InputMaybe<EventAttendeeState>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  eventId: Scalars['UUID']['input'];
  grantTicketCount?: InputMaybe<Scalars['Int']['input']>;
  grantTicketEventId?: InputMaybe<Scalars['UUID']['input']>;
  grantTicketTypeId?: InputMaybe<Scalars['UUID']['input']>;
  invitationMessage?: InputMaybe<Scalars['String']['input']>;
  invitedAt?: InputMaybe<Scalars['DateTime']['input']>;
  inviteeEmail?: InputMaybe<Scalars['String']['input']>;
  inviteeId?: InputMaybe<Scalars['UUID']['input']>;
  inviterId: Scalars['UUID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  privateTicketAmount?: InputMaybe<Scalars['Int']['input']>;
  privateTicketEventId?: InputMaybe<Scalars['UUID']['input']>;
  privateTicketTypeId?: InputMaybe<Scalars['UUID']['input']>;
  processedGiftTicketsBeforeSend: Scalars['Boolean']['input'];
  processedPrivateTicketsBeforeSend: Scalars['Boolean']['input'];
  sendId?: InputMaybe<Scalars['UUID']['input']>;
};

export type InviteActionGrantInvites = {
  __typename?: 'InviteActionGrantInvites';
  additionalActions?: Maybe<InviteActionUnion>;
  copyActionsFromCurrentInvite: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  memo: Scalars['String']['output'];
  numberOfInvitesToGrant: Scalars['Int']['output'];
  usesPerInvite: Scalars['Int']['output'];
};

export type InviteActionGrantInvitesWrapperInput = {
  additionalActions?: InputMaybe<Array<InviteActionInput>>;
  copyActionsFromCurrentInvite: Scalars['Boolean']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  memo: Scalars['String']['input'];
  numberOfInvitesToGrant: Scalars['Int']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  usesPerInvite: Scalars['Int']['input'];
};

export type InviteActionGrantRewardTicketInput = {
  rewardId: Scalars['UUID']['input'];
};

export type InviteActionInput = {
  achievement?: InputMaybe<InviteActionAchievementInput>;
  canCreatePies?: InputMaybe<InviteActionCanCreatePiesInput>;
  email?: InputMaybe<InviteActionEmailInput>;
  eventInvitation?: InputMaybe<InviteActionEventInvitationInput>;
  generateSlices?: InputMaybe<InviteActionPieSlicesGenerateInput>;
  grantInvites?: InputMaybe<InviteActionGrantInvitesWrapperInput>;
  grantRewardTicket?: InputMaybe<InviteActionGrantRewardTicketInput>;
  joinClub?: InputMaybe<InviteActionJoinClubInput>;
  joinClubTeam?: InputMaybe<InviteActionJoinClubTeamInput>;
  notify?: InputMaybe<InviteActionNotifyInput>;
  relationship?: InputMaybe<InviteActionUserRelationshipInput>;
  reward?: InputMaybe<InviteActionRewardInput>;
  sendSlices?: InputMaybe<InviteActionPieSlicesSendInput>;
  tier?: InputMaybe<InviteActionTierInput>;
};

export type InviteActionJoinClubInput = {
  clubId: Scalars['UUID']['input'];
  memberClassId?: InputMaybe<Scalars['UUID']['input']>;
  tierId?: InputMaybe<Scalars['Int']['input']>;
};

export type InviteActionJoinClubTeamInput = {
  acceptingUserId?: InputMaybe<Scalars['UUID']['input']>;
  clubId: Scalars['UUID']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  inviterId: Scalars['UUID']['input'];
  role: TeamMemberRole;
  roleId?: InputMaybe<Scalars['UUID']['input']>;
};

export type InviteActionNotify = {
  __typename?: 'InviteActionNotify';
  message: Scalars['String']['output'];
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type InviteActionNotifyInput = {
  message: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type InviteActionPieSlicesGenerate = {
  __typename?: 'InviteActionPieSlicesGenerate';
  pieId: Scalars['UUID']['output'];
  slices: Scalars['Decimal']['output'];
};

export type InviteActionPieSlicesGenerateInput = {
  pieId: Scalars['UUID']['input'];
  slices: Scalars['Decimal']['input'];
};

export type InviteActionPieSlicesSend = {
  __typename?: 'InviteActionPieSlicesSend';
  pieId: Scalars['UUID']['output'];
  slices: Scalars['Decimal']['output'];
};

export type InviteActionPieSlicesSendInput = {
  pieId: Scalars['UUID']['input'];
  slices: Scalars['Decimal']['input'];
};

export type InviteActionReward = {
  __typename?: 'InviteActionReward';
  rewardId: Scalars['UUID']['output'];
};

export type InviteActionRewardInput = {
  rewardId: Scalars['UUID']['input'];
};

export type InviteActionTier = {
  __typename?: 'InviteActionTier';
  tier: UserTier;
};

export type InviteActionTierInput = {
  tier: UserTier;
};

export type InviteActionUnion = InviteActionAchievement | InviteActionEventInvitation | InviteActionGrantInvites | InviteActionNotify | InviteActionPieSlicesGenerate | InviteActionPieSlicesSend | InviteActionReward | InviteActionTier | InviteActionUserRelationship;

export type InviteActionUserRelationship = {
  __typename?: 'InviteActionUserRelationship';
  incomingRelationshipType: UserRelationshipType;
  outgoingRelationshipType: UserRelationshipType;
  userId: Scalars['UUID']['output'];
};

export type InviteActionUserRelationshipInput = {
  incomingRelationshipType: UserRelationshipType;
  outgoingRelationshipType: UserRelationshipType;
  userId: Scalars['UUID']['input'];
};

export type InviteFromContactResult = {
  __typename?: 'InviteFromContactResult';
  confirmingContacts?: Maybe<Array<ConfirmingContact>>;
  resentContacts: Scalars['Int']['output'];
  sentContacts: Scalars['Int']['output'];
  submittedContacts: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type InviteLinkPayloadInput = {
  code: Scalars['String']['input'];
  guide?: InputMaybe<Scalars['String']['input']>;
  isGenerated: Scalars['Boolean']['input'];
  link: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type InviteLinkRewardRedemption = {
  __typename?: 'InviteLinkRewardRedemption';
  code: Scalars['String']['output'];
  guide?: Maybe<Scalars['String']['output']>;
  isGenerated: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  redemptionType: RewardRedemptionType;
};

export type InvitedResult = {
  __typename?: 'InvitedResult';
  formattedInviteId: Scalars['String']['output'];
  inviteId: Scalars['UUID']['output'];
};

export type InvitedTicket = {
  __typename?: 'InvitedTicket';
  giftEventTicketAmount?: Maybe<Scalars['Int']['output']>;
  giftEventTicketId?: Maybe<Scalars['UUID']['output']>;
  giftEventTicketName?: Maybe<Scalars['String']['output']>;
  invitedAt: Scalars['DateTime']['output'];
  inviter?: Maybe<User>;
  privateEventTicketAmount?: Maybe<Scalars['Int']['output']>;
  privateEventTicketId?: Maybe<Scalars['UUID']['output']>;
  privateEventTicketName?: Maybe<Scalars['String']['output']>;
};

export type Invitee = {
  __typename?: 'Invitee';
  actionTaken?: Maybe<ActionTaken>;
  contactId?: Maybe<Scalars['UUID']['output']>;
  deliveryStatus: DeliveryStatus;
  emailAddress?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['UUID']['output'];
  invitee?: Maybe<User>;
  inviteeUserId?: Maybe<Scalars['UUID']['output']>;
  methodOfEntry?: Maybe<MethodOfEntry>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sends?: Maybe<Array<SendRecord>>;
  source: InvitationSource;
};

/** A connection to a list of items. */
export type InviteeConnection = {
  __typename?: 'InviteeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InviteeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Invitee>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InviteeEdge = {
  __typename?: 'InviteeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Invitee>;
};

export type InviteeEmailVerificationResult = {
  __typename?: 'InviteeEmailVerificationResult';
  blockedUntil?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Masked address the code was sent to */
  maskedEmail?: Maybe<Scalars['String']['output']>;
  nextResend?: Maybe<Scalars['DateTime']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum InviteeSortField {
  Name = 'NAME',
  SentAt = 'SENT_AT',
  Status = 'STATUS'
}

export type InviteeStatisticsResult = {
  __typename?: 'InviteeStatisticsResult';
  bounced: Scalars['Long']['output'];
  emailBounced: Scalars['Long']['output'];
  emailCount: Scalars['Long']['output'];
  emailLinkOpened: Scalars['Long']['output'];
  emailNotOpened: Scalars['Long']['output'];
  emailOpenedOnly: Scalars['Long']['output'];
  invited: Scalars['Long']['output'];
  linkCount: Scalars['Long']['output'];
  notOpened: Scalars['Long']['output'];
  opened: Scalars['Long']['output'];
  sharedLinkOrQr: Scalars['Long']['output'];
  textCount: Scalars['Long']['output'];
  viewed: Scalars['Long']['output'];
};

export type InviterEarningByTicketMetric = {
  __typename?: 'InviterEarningByTicketMetric';
  earning: Scalars['Decimal']['output'];
  inviterId: Scalars['UUID']['output'];
  ticketId: Scalars['UUID']['output'];
};

export type InviterEarningMetric = {
  __typename?: 'InviterEarningMetric';
  earnings: Scalars['Decimal']['output'];
  earningsByTickets: Array<InviterEarningByTicketMetric>;
  inviterId: Scalars['UUID']['output'];
};

export enum JobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Interrupted = 'INTERRUPTED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type KeyValuePairOfInt32AndDateTime = {
  __typename?: 'KeyValuePairOfInt32AndDateTime';
  key: Scalars['Int']['output'];
  value: Scalars['DateTime']['output'];
};

export type KeyValuePairOfStringAndExternalApplicationToken = {
  __typename?: 'KeyValuePairOfStringAndExternalApplicationToken';
  key: Scalars['String']['output'];
  value: ExternalApplicationToken;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LimitedEvent = ILimitedEventModel & {
  __typename?: 'LimitedEvent';
  /** Age limit of event */
  ageLimit?: Maybe<Scalars['Int']['output']>;
  /** Avatar url of event */
  avatarUrl: Scalars['String']['output'];
  /** Club id of event */
  clubId?: Maybe<Scalars['UUID']['output']>;
  /** Event host or creator */
  createdBy?: Maybe<User>;
  /** Created date of event */
  createdDate: Scalars['DateTime']['output'];
  /** ISO 4217 currency code for event pricing (e.g. USD, GBP) */
  currency?: Maybe<Scalars['String']['output']>;
  /** Description of event */
  description: Scalars['String']['output'];
  /** Disclosure or privacy policy content */
  disclosureOrPrivacyPolicyContent?: Maybe<Scalars['String']['output']>;
  /** Disclosure or privacy policy file url */
  disclosureOrPrivacyPolicyFileUrl?: Maybe<Scalars['String']['output']>;
  /** Disclosure or privacy policy file title */
  disclosureOrPrivacyPolicyTitle?: Maybe<Scalars['String']['output']>;
  /** Display name of event */
  displayName: Scalars['String']['output'];
  /** End date of event */
  endDate: Scalars['DateTime']['output'];
  /** Id of event */
  eventId: Scalars['UUID']['output'];
  /** Id of the Event Series this event belongs to, or null if it is independent */
  eventSeriesId?: Maybe<Scalars['UUID']['output']>;
  /** Event type */
  eventType: EventType;
  /** Description of event */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** FAQ entries */
  faqEntries?: Maybe<Array<FaqEntry>>;
  /** FAQs */
  faqs?: Maybe<Scalars['String']['output']>;
  /** Flag if event is all-in pricing */
  isAllInPricing?: Maybe<Scalars['Boolean']['output']>;
  /** Flag if event is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Is featured event */
  isFeatured: Scalars['Boolean']['output'];
  /** Is listed event */
  isListed?: Maybe<Scalars['Boolean']['output']>;
  /** Flag if event is private */
  isPrivate: Scalars['Boolean']['output'];
  /** True only for the hidden event created automatically to back an event series' tickets/payment/revenue — see EventModel.IsSeriesParentEvent. */
  isSeriesParentEvent: Scalars['Boolean']['output'];
  /** Location of event */
  location?: Maybe<EventLocation>;
  /** Location with radius of event */
  locationRadius?: Maybe<EventLocation>;
  /** Attendees minimum Rep Score */
  minimumRepScore?: Maybe<Scalars['Decimal']['output']>;
  /** Music embed url */
  musicEmbedUrl?: Maybe<Scalars['String']['output']>;
  /** Note of event */
  note: Scalars['String']['output'];
  /** Opt-in age limit */
  optInAgeLimit: Scalars['Boolean']['output'];
  /** Opt-in allow guest to invite other guests */
  optInAllowGuestInviteOthers: Scalars['Boolean']['output'];
  /** Opt-in allow public event page preview */
  optInAllowPublicEventPagePreview?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in disclosure or privacy policy */
  optInDisclosureOrPrivacyPolicy: Scalars['Boolean']['output'];
  /** Opt-in display Rep Score */
  optInDisplayRepScore: Scalars['Boolean']['output'];
  /** Opt-in location radius */
  optInLocationRadius: Scalars['Boolean']['output'];
  /** Opt-in question requirements */
  optInQuestionRequirements: Scalars['Boolean']['output'];
  /** Opt-in require guest approval */
  optInRequireGuestApproval: Scalars['Boolean']['output'];
  /** Opt-in show guest count */
  optInShowGuestCount: Scalars['Boolean']['output'];
  /** Opt-in show guest list */
  optInShowGuestList: Scalars['Boolean']['output'];
  /** Opt-in show music embed */
  optInShowMusicEmbed: Scalars['Boolean']['output'];
  /** Opt-in show ticket amount */
  optInShowTicketAmount: Scalars['Boolean']['output'];
  /** Opt-in social account requirements */
  optInSocialAccountRequirements: Scalars['Boolean']['output'];
  /** Opt-in use Repbets QR pass */
  optInUseRepbetsQrPass: Scalars['Boolean']['output'];
  /** List of question requirements */
  questionRequirements?: Maybe<Array<QuestionRequirement>>;
  recurringId?: Maybe<Scalars['UUID']['output']>;
  /** Require attendees to connect a social account before they can get a ticket */
  requireSocialAccountConnection: Scalars['Boolean']['output'];
  /** List of scanning zones */
  scanningZones?: Maybe<Array<ScanningZone>>;
  /** Slug of event */
  slug: Scalars['String']['output'];
  /** List of social account requirements */
  socialAccountRequirements?: Maybe<Array<SocialAccountRequirement>>;
  /** Start date of event */
  startDate: Scalars['DateTime']['output'];
  /** Description of event */
  status: EventStatus;
  /** Terms and Conditions */
  terms?: Maybe<Scalars['String']['output']>;
  /** Ticket terms & purchase policy */
  ticketTermsPurchasePolicy?: Maybe<Scalars['String']['output']>;
  /** Event time zone */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** Updated date of event */
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Uploaded asset id of event */
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
};

/** A connection to a list of items. */
export type LimitedEventConnection = {
  __typename?: 'LimitedEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LimitedEventEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<LimitedEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LimitedEventEdge = {
  __typename?: 'LimitedEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LimitedEvent>;
};

export type LinkClubOfferResult = {
  __typename?: 'LinkClubOfferResult';
  success: Scalars['Boolean']['output'];
};

export type LinkClubState = {
  __typename?: 'LinkClubState';
  clubId: Scalars['UUID']['output'];
  colors?: Maybe<ClubColors>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  images?: Maybe<ClubImages>;
  name: Scalars['String']['output'];
  offers: Array<LinkOfferState>;
};

export type LinkOfferState = {
  __typename?: 'LinkOfferState';
  approvedBy?: Maybe<Scalars['UUID']['output']>;
  linkedAt: Scalars['DateTime']['output'];
  linkedBy: Scalars['UUID']['output'];
  offer: ClubOfferState;
  status: LinkOfferStatus;
};

/** A connection to a list of items. */
export type LinkOfferStateConnection = {
  __typename?: 'LinkOfferStateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LinkOfferStateEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<LinkOfferState>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LinkOfferStateEdge = {
  __typename?: 'LinkOfferStateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LinkOfferState>;
};

export type LinkOfferStateFilterArgsInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<PageSortOrder>;
  sortingType?: InputMaybe<LinkOfferStateSortingField>;
  status?: InputMaybe<LinkOfferStatus>;
};

export enum LinkOfferStateSortingField {
  LinkedAt = 'LINKED_AT',
  None = 'NONE'
}

export enum LinkOfferStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING'
}

export type LinkOffersArgs = {
  __typename?: 'LinkOffersArgs';
  clubId: Scalars['UUID']['output'];
  offerIds: Array<Scalars['UUID']['output']>;
};

/** A connection to a list of items. */
export type ListCreatedAchievementsConnection = {
  __typename?: 'ListCreatedAchievementsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ListCreatedAchievementsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Achievement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ListCreatedAchievementsEdge = {
  __typename?: 'ListCreatedAchievementsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Achievement>;
};

/** A connection to a list of items. */
export type ListPieWaitingListConnection = {
  __typename?: 'ListPieWaitingListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ListPieWaitingListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<WaitingListEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ListPieWaitingListEdge = {
  __typename?: 'ListPieWaitingListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WaitingListEntry>;
};

/** A connection to a list of items. */
export type ListUsersConnection = {
  __typename?: 'ListUsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ListUsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<CompleteUser>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ListUsersEdge = {
  __typename?: 'ListUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CompleteUser>;
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  neq?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type LocationInformationPayloadInput = {
  addressDetails: AddressDetailsPayloadInput;
  code: Scalars['String']['input'];
  guide?: InputMaybe<Scalars['String']['input']>;
  isGenerated: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type LocationInformationRewardRedemption = {
  __typename?: 'LocationInformationRewardRedemption';
  addressDetails: AddressDetails;
  code: Scalars['String']['output'];
  guide?: Maybe<Scalars['String']['output']>;
  isGenerated: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  redemptionType: RewardRedemptionType;
};

export type LocationRadiusSetting = {
  __typename?: 'LocationRadiusSetting';
  address: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  latitude: Scalars['Decimal']['output'];
  longitude: Scalars['Decimal']['output'];
  radius: Scalars['Decimal']['output'];
  settingType: RewardSettingType;
  unit: LocationUnit;
};

export type LocationRadiusSettingPayloadInput = {
  address: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  latitude: Scalars['Decimal']['input'];
  longitude: Scalars['Decimal']['input'];
  radius: Scalars['Decimal']['input'];
  unit: LocationUnit;
};

export enum LocationUnit {
  Kilometers = 'KILOMETERS',
  Miles = 'MILES',
  None = 'NONE'
}

export enum LocationUnitLengthType {
  Kilometers = 'KILOMETERS',
  Miles = 'MILES',
  None = 'NONE'
}

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type LoyaltyTierByClubCondition = {
  __typename?: 'LoyaltyTierByClubCondition';
  club?: Maybe<ClubState>;
  isSatisfied?: Maybe<Scalars['Boolean']['output']>;
  level: Scalars['Int']['output'];
};

export type LoyaltyTierByClubConditionPayloadInput = {
  clubId: Scalars['UUID']['input'];
  level: Scalars['Int']['input'];
};

export type LoyaltyTierConditionPayloadInput = {
  loyaltyTierByClubConditions?: InputMaybe<Array<LoyaltyTierByClubConditionPayloadInput>>;
};

export type LoyaltyTierRewardCondition = {
  __typename?: 'LoyaltyTierRewardCondition';
  loyaltyTiersByClub: Array<Maybe<LoyaltyTierByClubCondition>>;
  type: RewardConditionType;
};

export type MarketApi = {
  __typename?: 'MarketApi';
  /** This is Fill-or-kill strategy, simple order only that never enters the order book. A user will `offer` something for a `product` */
  placeBuyOrder: Scalars['Boolean']['output'];
  /** This is Fill-or-kill strategy, simple order only that never enters the order book */
  placeSellOrder: Scalars['Boolean']['output'];
};


export type MarketApiPlaceBuyOrderArgs = {
  fundingSource?: InputMaybe<FundingSourceArgsInput>;
  order: SimpleOrderInput;
};


export type MarketApiPlaceSellOrderArgs = {
  order: SimpleOrderInput;
};

export type MemberEventAdditionalGuestOverview = {
  __typename?: 'MemberEventAdditionalGuestOverview';
  activeCount: Scalars['Int']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  eventId: Scalars['UUID']['output'];
  expiredCount: Scalars['Int']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isOver: Scalars['Boolean']['output'];
  pendingReset: Scalars['Boolean']['output'];
  reminder: EndedReminderInfo;
  startDate: Scalars['DateTime']['output'];
  transferredCount: Scalars['Int']['output'];
};

export enum MethodOfEntry {
  Email = 'EMAIL',
  Link = 'LINK',
  Text = 'TEXT'
}

export type MigrateOldSharedUserTickets = {
  __typename?: 'MigrateOldSharedUserTickets';
  createdDate: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  eventId: Scalars['UUID']['output'];
  eventName: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  tickets: Array<TicketWithIdOfStoredTicket>;
};

export type Mutation = {
  __typename?: 'Mutation';
  Client: ClientMutationApi;
  achievement: AchievementMutationApi;
  admin: AdminMutationApi;
  clubById: ClubMutation;
  clubBySlug: ClubMutation;
  /** Completes the required profile of an admin-provisioned account once: confirms email, phone and date of birth, and replaces the password. */
  completeProfile?: Maybe<CurrentUser>;
  contactList: ContactListMutationApi;
  createClub: CreateClubResult;
  /** Trade or update user achievement */
  createOrUpdateUserAchievement: Scalars['Boolean']['output'];
  /** Trade or update user reward */
  createOrUpdateUserReward: Scalars['Boolean']['output'];
  /** Delete a passkey credential for the current user */
  deletePasskeyCredential: Scalars['Boolean']['output'];
  device: DeviceApi;
  event: EventMutationApi;
  eventSeries: EventSeriesMutationApi;
  eventTicket: EventTicketMutationApi;
  funding: FundingApi;
  hostMessage: HostMessageMutationApi;
  individual_asset: IndividualAssetMutationApi;
  market: MarketApi;
  /** Update the current users common data */
  me?: Maybe<CompleteUser>;
  notification: NotificationApi;
  paypal: PaypalMutationApi;
  pie: PieMutationApi;
  public: PublicMutationApi;
  /** Redeem club offer */
  redeemClubOffer?: Maybe<RedeemOfferResult>;
  referral: ReferralMutationApi;
  /** Report user geo fence */
  reportUserLocation: Scalars['Boolean']['output'];
  reward: RewardMutationApi;
  /** Mutations for managing a user's connected Stripe account via Stripe Connect Embedded Components. */
  stripeAccount: StripeAccountMutationApi;
  termsAndConditions: TermsAndConditionsMutationApi;
  uploaded_asset: UploadedAssetMutationApi;
  user: UserMutationApi;
  wallet: WalletMutationApi;
};


export type MutationClubByIdArgs = {
  clubId: Scalars['UUID']['input'];
};


export type MutationClubBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type MutationCompleteProfileArgs = {
  args: MutationCompleteProfileArgsInput;
};


export type MutationCreateClubArgs = {
  payload: CreateClubPayloadInput;
};


export type MutationCreateOrUpdateUserAchievementArgs = {
  args: UserAchievementArgsInput;
};


export type MutationCreateOrUpdateUserRewardArgs = {
  args: UserRewardArgsInput;
};


export type MutationDeletePasskeyCredentialArgs = {
  credentialId: Scalars['String']['input'];
};


export type MutationMeArgs = {
  args: MutationUserUpdateArgsInput;
};


export type MutationRedeemClubOfferArgs = {
  token: Scalars['String']['input'];
};


export type MutationReportUserLocationArgs = {
  locations: Array<ReportUserGeoFenceArgsInput>;
  otp?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCompleteProfileArgsInput = {
  /** The account owner's date of birth */
  dateOfBirth: Scalars['LocalDate']['input'];
  /** The email address this account signs in with */
  emailAddress: Scalars['String']['input'];
  /** The new password for the account */
  newPassword: Scalars['String']['input'];
  /** The phone number to store on the account */
  phoneNumber: Scalars['String']['input'];
};

export type MutationResult = {
  __typename?: 'MutationResult';
  reason?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

export enum MutationStatus {
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN'
}

export type MutationUserUpdateArgsInput = {
  brandedUrl?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Providing an email address that's different from the stored one will trigger an automatic email verification process */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Gender of user */
  gender?: InputMaybe<UserGender>;
  /** Name of me */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Providing a phone number that's different from the stored one will trigger an automatic email verification process */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type MyClubEventsConnection = {
  __typename?: 'MyClubEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyClubEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyClubEventsEdge = {
  __typename?: 'MyClubEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Event>;
};

/** A connection to a list of items. */
export type MyCreatedEventsConnection = {
  __typename?: 'MyCreatedEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyCreatedEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<FullEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyCreatedEventsEdge = {
  __typename?: 'MyCreatedEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FullEvent>;
};

export enum MyCreatedEventsSortBy {
  DisplayName = 'DISPLAY_NAME',
  EndDate = 'END_DATE',
  StartDate = 'START_DATE'
}

/** A connection to a list of items. */
export type MyEventsConnection = {
  __typename?: 'MyEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<FullEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MyEventsEdge = {
  __typename?: 'MyEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FullEvent>;
};

/** A connection to a list of items. */
export type MyOffersConnection = {
  __typename?: 'MyOffersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyOffersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PublicClubOfferState>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MyOffersEdge = {
  __typename?: 'MyOffersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PublicClubOfferState>;
};

/** A connection to a list of items. */
export type MySeriesConnection = {
  __typename?: 'MySeriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MySeriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<EventSeries>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MySeriesEdge = {
  __typename?: 'MySeriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EventSeries>;
};

export type NeededSlicesPerPie = {
  __typename?: 'NeededSlicesPerPie';
  amount: Scalars['Decimal']['output'];
  pieId: Scalars['UUID']['output'];
};

export type NoneRewardRedemptionMethod = {
  __typename?: 'NoneRewardRedemptionMethod';
  redemptionMethodType: RewardRedemptionMethodType;
};

export type Notification = {
  __typename?: 'Notification';
  content: NotificationContent;
  createdAt: Scalars['DateTime']['output'];
  isPushed: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  notificationId: Scalars['UUID']['output'];
  pushedAt?: Maybe<Scalars['DateTime']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  receiver?: Maybe<User>;
};

export type NotificationApi = {
  __typename?: 'NotificationApi';
  /** Mark a notification as read/unread */
  read: Scalars['Boolean']['output'];
  /** Mark all notification as read */
  readAll: Scalars['Boolean']['output'];
};


export type NotificationApiReadArgs = {
  isRead?: Scalars['Boolean']['input'];
  notificationId: Scalars['UUID']['input'];
};

export type NotificationContent = {
  __typename?: 'NotificationContent';
  defaultMessage: Scalars['String']['output'];
  defaultPayload: NotificationPayload;
};

export type NotificationEdgeX = {
  __typename?: 'NotificationEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Notification>;
};

/** Represents a slice or page */
export type NotificationGrainPageX = {
  __typename?: 'NotificationGrainPageX';
  /** A list of edges */
  edges: Array<NotificationEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<Notification>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type NotificationIndexDocument2 = {
  __typename?: 'NotificationIndexDocument2';
  createdAt: Scalars['DateTime']['output'];
  defaultMessage: Scalars['String']['output'];
  defaultPayload: NotificationPayload;
  isRead: Scalars['Boolean']['output'];
  notificationId: Scalars['UUID']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['UUID']['output'];
};

/** Represents a slice or page of NotificationIndexDocument */
export type NotificationIndexDocumentOffsetPage = {
  __typename?: 'NotificationIndexDocumentOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<NotificationIndexDocument2>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type NotificationPayload = {
  __typename?: 'NotificationPayload';
  createdAt: Scalars['DateTime']['output'];
  customProperties: Array<CustomProperty>;
  notificationType: NotificationType;
};

export type NotificationQueryApi = {
  __typename?: 'NotificationQueryApi';
  /** In-flight async jobs (import, delete, message, invite) for the current user */
  activeJobs?: Maybe<Array<ActiveJobSummary>>;
  /** Count unread notifications */
  countUnreadNotifications: Scalars['Long']['output'];
  /**
   * List notifications
   * @deprecated Use listNotifications2 instead.
   */
  listNotifications?: Maybe<NotificationIndexDocumentOffsetPage>;
  /** List notifications */
  listNotifications2?: Maybe<NotificationGrainPageX>;
};


export type NotificationQueryApiListNotificationsArgs = {
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  notificationTypes?: InputMaybe<Array<NotificationType>>;
  offset?: Scalars['Int']['input'];
};


export type NotificationQueryApiListNotifications2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  notificationTypes?: InputMaybe<Array<NotificationType>>;
};

export enum NotificationType {
  AwardedReward = 'AWARDED_REWARD',
  AwardPie = 'AWARD_PIE',
  BuySlices = 'BUY_SLICES',
  ClubOfferUserNotSelected = 'CLUB_OFFER_USER_NOT_SELECTED',
  ClubOfferUserSelected = 'CLUB_OFFER_USER_SELECTED',
  ClubTeamInvite = 'CLUB_TEAM_INVITE',
  ClubTeamInviteAccepted = 'CLUB_TEAM_INVITE_ACCEPTED',
  ClubUserClaimedOffer = 'CLUB_USER_CLAIMED_OFFER',
  ClubUserEnteredOffer = 'CLUB_USER_ENTERED_OFFER',
  ContactDeleteCompleted = 'CONTACT_DELETE_COMPLETED',
  ContactDeleteFailed = 'CONTACT_DELETE_FAILED',
  ContactDeleteStarted = 'CONTACT_DELETE_STARTED',
  ContactImportCompleted = 'CONTACT_IMPORT_COMPLETED',
  ContactImportFailed = 'CONTACT_IMPORT_FAILED',
  ContactImportStarted = 'CONTACT_IMPORT_STARTED',
  ContactInviteCompleted = 'CONTACT_INVITE_COMPLETED',
  ContactInviteFailed = 'CONTACT_INVITE_FAILED',
  ContactInviteStarted = 'CONTACT_INVITE_STARTED',
  ContactMessageCompleted = 'CONTACT_MESSAGE_COMPLETED',
  ContactMessageFailed = 'CONTACT_MESSAGE_FAILED',
  ContactMessageStarted = 'CONTACT_MESSAGE_STARTED',
  ContestWinnerSelected = 'CONTEST_WINNER_SELECTED',
  CreateEventRequestResolved = 'CREATE_EVENT_REQUEST_RESOLVED',
  CreatePie = 'CREATE_PIE',
  DirectMessageReceived = 'DIRECT_MESSAGE_RECEIVED',
  EventApproved = 'EVENT_APPROVED',
  EventCheckinSuccess = 'EVENT_CHECKIN_SUCCESS',
  EventCoordinatorInvitation = 'EVENT_COORDINATOR_INVITATION',
  EventCoHostInvitation = 'EVENT_CO_HOST_INVITATION',
  EventDeclined = 'EVENT_DECLINED',
  EventDetails = 'EVENT_DETAILS',
  EventDoorInvitation = 'EVENT_DOOR_INVITATION',
  EventFull = 'EVENT_FULL',
  EventGroupMessageReceived = 'EVENT_GROUP_MESSAGE_RECEIVED',
  EventInvitation = 'EVENT_INVITATION',
  EventLinkOffer = 'EVENT_LINK_OFFER',
  EventPending = 'EVENT_PENDING',
  EventPromoteInvitation = 'EVENT_PROMOTE_INVITATION',
  EventPublishedToFollowers = 'EVENT_PUBLISHED_TO_FOLLOWERS',
  EventRoleUpdate = 'EVENT_ROLE_UPDATE',
  EventSeriesRoleInvitation = 'EVENT_SERIES_ROLE_INVITATION',
  EventSponsorInvitation = 'EVENT_SPONSOR_INVITATION',
  EventStarted = 'EVENT_STARTED',
  EventTalentInvitation = 'EVENT_TALENT_INVITATION',
  EventTicketAmountIncreased = 'EVENT_TICKET_AMOUNT_INCREASED',
  EventTicketReceived = 'EVENT_TICKET_RECEIVED',
  GenerateRewardWinnersReminder = 'GENERATE_REWARD_WINNERS_REMINDER',
  HostMessageReceived = 'HOST_MESSAGE_RECEIVED',
  HostMessageReplyReceived = 'HOST_MESSAGE_REPLY_RECEIVED',
  NewWisherAdded = 'NEW_WISHER_ADDED',
  PieOwnershipTransferAccepted = 'PIE_OWNERSHIP_TRANSFER_ACCEPTED',
  PieOwnershipTransferRejected = 'PIE_OWNERSHIP_TRANSFER_REJECTED',
  PieOwnershipTransferRequest = 'PIE_OWNERSHIP_TRANSFER_REQUEST',
  ReceiveAchievement = 'RECEIVE_ACHIEVEMENT',
  ReceiveReward = 'RECEIVE_REWARD',
  ReceiveSlices = 'RECEIVE_SLICES',
  ReservedPieTransfered = 'RESERVED_PIE_TRANSFERED',
  RewardLoser = 'REWARD_LOSER',
  SendSlices = 'SEND_SLICES',
  SomeoneBuySlices = 'SOMEONE_BUY_SLICES',
  UserAcceptedEventRole = 'USER_ACCEPTED_EVENT_ROLE',
  UserDeclinedEventRole = 'USER_DECLINED_EVENT_ROLE',
  UserInvitesIncreased = 'USER_INVITES_INCREASED',
  UserInviteAccepted = 'USER_INVITE_ACCEPTED',
  UserInviteAction = 'USER_INVITE_ACTION',
  UserPassedWaitingList = 'USER_PASSED_WAITING_LIST',
  UseReportedInsideRewardLocation = 'USE_REPORTED_INSIDE_REWARD_LOCATION',
  WishedPieActivated = 'WISHED_PIE_ACTIVATED'
}

export type NullableOfAchievementCategoryOperationFilterInput = {
  eq?: InputMaybe<AchievementCategory>;
  in?: InputMaybe<Array<InputMaybe<AchievementCategory>>>;
  neq?: InputMaybe<AchievementCategory>;
  nin?: InputMaybe<Array<InputMaybe<AchievementCategory>>>;
};

export type NullableOfAchievementStatusOperationFilterInput = {
  eq?: InputMaybe<AchievementStatus>;
  in?: InputMaybe<Array<InputMaybe<AchievementStatus>>>;
  neq?: InputMaybe<AchievementStatus>;
  nin?: InputMaybe<Array<InputMaybe<AchievementStatus>>>;
};

export type NullableOfPieOperationalStateOperationFilterInput = {
  eq?: InputMaybe<PieOperationalState>;
  in?: InputMaybe<Array<InputMaybe<PieOperationalState>>>;
  neq?: InputMaybe<PieOperationalState>;
  nin?: InputMaybe<Array<InputMaybe<PieOperationalState>>>;
};

export type NullableOfRewardCategoryOperationFilterInput = {
  eq?: InputMaybe<RewardCategory>;
  in?: InputMaybe<Array<InputMaybe<RewardCategory>>>;
  neq?: InputMaybe<RewardCategory>;
  nin?: InputMaybe<Array<InputMaybe<RewardCategory>>>;
};

export type NullableOfRewardStatusOperationFilterInput = {
  eq?: InputMaybe<RewardStatus>;
  in?: InputMaybe<Array<InputMaybe<RewardStatus>>>;
  neq?: InputMaybe<RewardStatus>;
  nin?: InputMaybe<Array<InputMaybe<RewardStatus>>>;
};

export type NullableOfUserGenderOperationFilterInput = {
  eq?: InputMaybe<UserGender>;
  in?: InputMaybe<Array<InputMaybe<UserGender>>>;
  neq?: InputMaybe<UserGender>;
  nin?: InputMaybe<Array<InputMaybe<UserGender>>>;
};

export type NumberOfSlicesOption = {
  __typename?: 'NumberOfSlicesOption';
  price: Scalars['Decimal']['output'];
  slice: Scalars['Decimal']['output'];
};

export type OfferConfigurationPayload = {
  __typename?: 'OfferConfigurationPayload';
  pointsPurchase?: Maybe<OfferPointsPurchaseConfigurationPayload>;
};

export type OfferConfigurationPayloadInput = {
  pointsPurchase?: InputMaybe<OfferPointsPurchaseConfigurationPayloadInput>;
};

export type OfferCostArgsInput = {
  items: Array<OfferCostItemArgsInput>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type OfferCostInfo = {
  __typename?: 'OfferCostInfo';
  expiresAt: Scalars['DateTime']['output'];
  hostBalance: Scalars['Decimal']['output'];
  isAllInPricing: Scalars['Boolean']['output'];
  items: Array<OfferCostItem>;
  paymentAuthCode: Scalars['String']['output'];
  processingFee: Scalars['Decimal']['output'];
  referralUserId?: Maybe<Scalars['UUID']['output']>;
  serviceFee: Scalars['Decimal']['output'];
  subTotal: Scalars['Decimal']['output'];
  taxName?: Maybe<Scalars['String']['output']>;
  taxPercentage?: Maybe<Scalars['Decimal']['output']>;
  total: Scalars['Decimal']['output'];
  totalFees: Scalars['Decimal']['output'];
  totalGratuity: Scalars['Decimal']['output'];
  totalTaxes: Scalars['Decimal']['output'];
};

export type OfferCostItem = {
  __typename?: 'OfferCostItem';
  gratuityPercentage?: Maybe<Scalars['Decimal']['output']>;
  offerId: Scalars['UUID']['output'];
  originalPrice: Scalars['Decimal']['output'];
  price: Scalars['Decimal']['output'];
  quantity: Scalars['Int']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
};

export type OfferCostItemArgsInput = {
  offerId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
};

export type OfferFlowPayloadInput = {
  reward?: InputMaybe<RewardOfferFlowPayloadInput>;
};

export type OfferMutator = {
  __typename?: 'OfferMutator';
  clubId: Scalars['UUID']['output'];
  /** Create Payment Order */
  createPaymentOrder: Scalars['String']['output'];
  generateWinners: Array<Scalars['UUID']['output']>;
  /** Invite people from contacts to claim an offer */
  inviteFromContacts: InviteFromContactResult;
  offerId: Scalars['UUID']['output'];
  /** Purchase Offer */
  purchaseOffer: TransactionOperationResult;
  /** Redeem offer via QR Code */
  redeemViaQrCode?: Maybe<RedeemOfferResult>;
  resolveClubId: Scalars['UUID']['output'];
  /** Submit contact information for redeeming an offer that requires it */
  submitRedeemContactInfo: Scalars['Boolean']['output'];
  updateOffer: Scalars['Boolean']['output'];
};


export type OfferMutatorCreatePaymentOrderArgs = {
  token: Scalars['String']['input'];
};


export type OfferMutatorInviteFromContactsArgs = {
  confirmedDoNotResendContactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  confirmedResendContactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  contactPageFilterArgs?: InputMaybe<ContactPageFilterArgsInput>;
  invitationMessage?: InputMaybe<Scalars['String']['input']>;
  inviteAll: Scalars['Boolean']['input'];
  isViaSms?: Scalars['Boolean']['input'];
};


export type OfferMutatorPurchaseOfferArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};


export type OfferMutatorRedeemViaQrCodeArgs = {
  code: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};


export type OfferMutatorSubmitRedeemContactInfoArgs = {
  args: SubmitRedeemOfferContactInfoArgsInput;
};


export type OfferMutatorUpdateOfferArgs = {
  payload: UpdateOfferPayloadInput;
};

export type OfferPointsPurchaseConfigurationPayload = {
  __typename?: 'OfferPointsPurchaseConfigurationPayload';
  isDefault: Scalars['Boolean']['output'];
  strategy?: Maybe<BucketPointsPurchaseStrategyPayload>;
};

export type OfferPointsPurchaseConfigurationPayloadInput = {
  isDefault: Scalars['Boolean']['input'];
  strategy?: InputMaybe<BucketPointsPurchaseStrategyPayloadInput>;
};

export enum OfferRewardType {
  BuyNow = 'BUY_NOW',
  Community = 'COMMUNITY',
  Coupon = 'COUPON',
  Event = 'EVENT',
  ExclusiveContent = 'EXCLUSIVE_CONTENT',
  Invite = 'INVITE',
  MeetUp = 'MEET_UP',
  MerchGiveaway = 'MERCH_GIVEAWAY',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  VipPass = 'VIP_PASS'
}

export enum OfferSortingField {
  EndDateTime = 'END_DATE_TIME',
  ExpiresDateTime = 'EXPIRES_DATE_TIME',
  Name = 'NAME',
  None = 'NONE',
  StartDateTime = 'START_DATE_TIME'
}

export enum OfferTimePeriod {
  ThisMonth = 'THIS_MONTH',
  ThisWeek = 'THIS_WEEK'
}

export enum OfferType {
  BuyPoints = 'BUY_POINTS',
  Custom = 'CUSTOM',
  EarnPoints = 'EARN_POINTS',
  EarnStatus = 'EARN_STATUS',
  RewardMembers = 'REWARD_MEMBERS',
  Unknown = 'UNKNOWN'
}

export enum OfferUserSortingField {
  Age = 'AGE',
  ApprovalAt = 'APPROVAL_AT',
  CreatedAtUtc = 'CREATED_AT_UTC',
  Gender = 'GENDER',
  Name = 'NAME',
  None = 'NONE'
}

export type OfferUserState = {
  __typename?: 'OfferUserState';
  approvalAt?: Maybe<Scalars['DateTime']['output']>;
  clubId: Scalars['UUID']['output'];
  createdAtUtc: Scalars['DateTime']['output'];
  inviteLink?: Maybe<Scalars['String']['output']>;
  offerId: Scalars['UUID']['output'];
  redemption?: Maybe<UserRewardRedemptionGqlType>;
  status: OfferUserStatus;
  updateAtUtc: Scalars['DateTime']['output'];
  userId: Scalars['UUID']['output'];
};

export enum OfferUserStatus {
  Claimed = 'CLAIMED',
  Declined = 'DECLINED',
  Entered = 'ENTERED',
  None = 'NONE',
  NotSelected = 'NOT_SELECTED',
  Pending = 'PENDING'
}

/** A connection to a list of items. */
export type OffersConnection = {
  __typename?: 'OffersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OffersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClubOfferState>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OffersEdge = {
  __typename?: 'OffersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClubOfferState>;
};

export enum OnboardingProcess {
  Active = 'ACTIVE',
  Complete = 'COMPLETE',
  None = 'NONE',
  Pending = 'PENDING'
}

export enum OpenSearchIndex {
  Achievement = 'ACHIEVEMENT',
  AchievementParticipant = 'ACHIEVEMENT_PARTICIPANT',
  Club = 'CLUB',
  ContactList = 'CONTACT_LIST',
  Event = 'EVENT',
  EventAttendee = 'EVENT_ATTENDEE',
  EventInvitation = 'EVENT_INVITATION',
  EventLocationRadius = 'EVENT_LOCATION_RADIUS',
  EventSeries = 'EVENT_SERIES',
  HoldingEventTicket = 'HOLDING_EVENT_TICKET',
  HoldingPie = 'HOLDING_PIE',
  HostMessage = 'HOST_MESSAGE',
  Notification = 'NOTIFICATION',
  Offer = 'OFFER',
  OfferTransaction = 'OFFER_TRANSACTION',
  OfferUser = 'OFFER_USER',
  PayoutRequest = 'PAYOUT_REQUEST',
  Pie = 'PIE',
  RecurringEvent = 'RECURRING_EVENT',
  Reward = 'REWARD',
  RewardLocation = 'REWARD_LOCATION',
  RewardParticipant = 'REWARD_PARTICIPANT',
  TradingTransaction = 'TRADING_TRANSACTION',
  Unknown = 'UNKNOWN',
  UploadedAsset = 'UPLOADED_ASSET',
  User = 'USER',
  UserOffer = 'USER_OFFER'
}

export type OperationResult = {
  __typename?: 'OperationResult';
  exMessage?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type OptInPrivacyPolicySetting = {
  __typename?: 'OptInPrivacyPolicySetting';
  content: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  settingType: RewardSettingType;
  title: Scalars['String']['output'];
};

export type OptInPrivacyPolicySettingPayloadInput = {
  content: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  link: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type OptInPublicPagePreviewSetting = {
  __typename?: 'OptInPublicPagePreviewSetting';
  enabled: Scalars['Boolean']['output'];
  settingType: RewardSettingType;
};

export type OptInPublicPagePreviewSettingPayloadInput = {
  enabled: Scalars['Boolean']['input'];
};

export enum OtpVerificationResult {
  Failed = 'FAILED',
  Invalid = 'INVALID',
  Succeeded = 'SUCCEEDED'
}

export type OwnSlicesConditionArgsInput = {
  amount: Scalars['Decimal']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  pieId: Scalars['UUID']['input'];
};

export type OwnSlicesRewardConditionInput = {
  amount: Scalars['Decimal']['input'];
  pieId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum PageArgsFlags {
  None = 'NONE',
  ProjectRowCursors = 'PROJECT_ROW_CURSORS',
  ProjectTotalCount = 'PROJECT_TOTAL_COUNT'
}

export type PageArgsInput = {
  count: Scalars['Int']['input'];
  flags: PageArgsFlags;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order: PageSortOrder;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Contains information about navigating large result sets */
export type PageInfoX = {
  __typename?: 'PageInfoX';
  /** If non null, this represents the last observed cursor of a page */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** True if there are more records in the result set */
  hasNextPage: Scalars['Boolean']['output'];
};

export enum PageSortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
  None = 'NONE'
}

export enum ParticipantPrivacyPolicyState {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  None = 'NONE'
}

export enum ParticipateReason {
  AgeLimit = 'AGE_LIMIT',
  EnoughWinners = 'ENOUGH_WINNERS',
  Expired = 'EXPIRED',
  FromOtherUser = 'FROM_OTHER_USER',
  FromOwner = 'FROM_OWNER',
  InactiveUser = 'INACTIVE_USER',
  InvalidLocation = 'INVALID_LOCATION',
  MatchAllConditions = 'MATCH_ALL_CONDITIONS',
  None = 'NONE',
  NotAcceptedPrivacyPolicy = 'NOT_ACCEPTED_PRIVACY_POLICY',
  NotEnoughAchievements = 'NOT_ENOUGH_ACHIEVEMENTS',
  NotEnoughSlices = 'NOT_ENOUGH_SLICES',
  OptOut = 'OPT_OUT',
  OutOfDateRanges = 'OUT_OF_DATE_RANGES'
}

export enum ParticipateState {
  Awarded = 'AWARDED',
  CantParticipate = 'CANT_PARTICIPATE',
  None = 'NONE',
  NotParticipating = 'NOT_PARTICIPATING',
  Participating = 'PARTICIPATING',
  Sent = 'SENT'
}

export enum PartnerConnectionAction {
  Approved = 'APPROVED',
  Connected = 'CONNECTED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  PermissionsChanged = 'PERMISSIONS_CHANGED',
  Unknown = 'UNKNOWN',
  Unlinked = 'UNLINKED'
}

export type PartnerConnectionChange = {
  __typename?: 'PartnerConnectionChange';
  action: PartnerConnectionAction;
  actorUserId: Scalars['UUID']['output'];
  at: Scalars['DateTime']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export type PartnerConnectionModel = {
  __typename?: 'PartnerConnectionModel';
  accountId: Scalars['UUID']['output'];
  applicationId: Scalars['UUID']['output'];
  changedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  history: Array<PartnerConnectionChange>;
  partnerAccountId: Scalars['UUID']['output'];
  permissions: Array<Scalars['String']['output']>;
  status: PartnerConnectionStatus;
};

export enum PartnerConnectionStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Unknown = 'UNKNOWN',
  Unlinked = 'UNLINKED'
}

export enum PaymentAccountStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Disconnected = 'DISCONNECTED',
  Restricted = 'RESTRICTED',
  Unknown = 'UNKNOWN'
}

export type PaymentItemInput = {
  amount: Scalars['Decimal']['input'];
  taxCode: Scalars['String']['input'];
};

export type PaymentItems = {
  __typename?: 'PaymentItems';
  entityId: Scalars['UUID']['output'];
  eventId?: Maybe<Scalars['UUID']['output']>;
  fulfillmentMethod: FulfillmentMethod;
  gratuityPercentage?: Maybe<Scalars['Decimal']['output']>;
  isFree: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  originalProductPrice: Scalars['Decimal']['output'];
  parentEntityId?: Maybe<Scalars['UUID']['output']>;
  price: Scalars['Decimal']['output'];
  priceCurrency: Scalars['String']['output'];
  productType?: Maybe<ProductType>;
  quantity: Scalars['Decimal']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
  taxType?: Maybe<TaxType>;
  ticketType?: Maybe<Scalars['String']['output']>;
  totalPrice: Scalars['Decimal']['output'];
};

export enum PaymentMethod {
  CreditCard = 'CREDIT_CARD',
  None = 'NONE',
  Paypal = 'PAYPAL',
  Stripe = 'STRIPE'
}

export type PaymentSplitStrategyInput = {
  transactionCost: Scalars['Decimal']['input'];
  transactionPercentage: Scalars['Decimal']['input'];
};

export enum PaymentStatus {
  Approved = 'APPROVED',
  Authorized = 'AUTHORIZED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Failed = 'FAILED',
  None = 'NONE',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Voided = 'VOIDED'
}

export type PayoutAccount = {
  __typename?: 'PayoutAccount';
  accountId: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
};

export type PayoutAccountType = {
  __typename?: 'PayoutAccountType';
  connect: Scalars['Boolean']['output'];
  /** Connect via oidc */
  connectViaOidc?: Maybe<Scalars['String']['output']>;
  disconnect: Scalars['Boolean']['output'];
};


export type PayoutAccountTypeConnectArgs = {
  accountId: Scalars['String']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  isPrimary: Scalars['Boolean']['input'];
  provider: Scalars['String']['input'];
};


export type PayoutAccountTypeConnectViaOidcArgs = {
  code: Scalars['String']['input'];
};


export type PayoutAccountTypeDisconnectArgs = {
  provider: Scalars['String']['input'];
};

export type PayoutFees = {
  __typename?: 'PayoutFees';
  percentageSplit: Scalars['Decimal']['output'];
};

export type PayoutRequestAdmin = {
  __typename?: 'PayoutRequestAdmin';
  amount: Scalars['Decimal']['output'];
  currency: Scalars['String']['output'];
  currentPayoutBalance: Scalars['Decimal']['output'];
  lastRequestedTime?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  requestId: Scalars['UUID']['output'];
  status: PayoutRequestStatus;
  user: CompleteUser;
  userId: Scalars['UUID']['output'];
};

/** Represents a slice or page of PayoutRequestState */
export type PayoutRequestStateOffsetPage = {
  __typename?: 'PayoutRequestStateOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<PayoutRequestAdmin>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export enum PayoutRequestStatus {
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type PayoutTransactionState = {
  __typename?: 'PayoutTransactionState';
  buyerId: Scalars['UUID']['output'];
  createdAtUtc: Scalars['DateTime']['output'];
  eventId: Scalars['UUID']['output'];
  hostBalance: Scalars['Decimal']['output'];
  originalTransactionId: Scalars['UUID']['output'];
  ownerId: Scalars['UUID']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  priceCurrency?: Maybe<Scalars['String']['output']>;
  processingFee: Scalars['Decimal']['output'];
  serviceFee: Scalars['Decimal']['output'];
  status?: Maybe<PaymentStatus>;
  subTotal: Scalars['Decimal']['output'];
  totalGratuity: Scalars['Decimal']['output'];
  totalPrice: Scalars['Decimal']['output'];
  totalTaxes: Scalars['Decimal']['output'];
  transactionFee?: Maybe<Scalars['Decimal']['output']>;
  transactionId: Scalars['UUID']['output'];
  transactionStatus: TransactionStatus;
  type: TransactionType;
};

export type PaypalMutationApi = {
  __typename?: 'PaypalMutationApi';
  /** Process create pie */
  processCreatePie: OperationResult;
  /** Process purchase pie */
  processPurchasePie: OperationResult;
  /** Process upgrade pie */
  processUpgradePie: OperationResult;
  /** Place an order to upgrade pie */
  upgradePieOrder: Scalars['String']['output'];
};


export type PaypalMutationApiProcessCreatePieArgs = {
  orderId: Scalars['String']['input'];
};


export type PaypalMutationApiProcessPurchasePieArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};


export type PaypalMutationApiProcessUpgradePieArgs = {
  paypalOrderId: Scalars['String']['input'];
};


export type PaypalMutationApiUpgradePieOrderArgs = {
  pieId: Scalars['UUID']['input'];
  slices: Scalars['Decimal']['input'];
};

export type PaypalOptions = {
  __typename?: 'PaypalOptions';
  clientId: Scalars['String']['output'];
  payoutFees: PayoutFees;
  transactionFees: TransactionFees;
};

export type PaypalQueryApi = {
  __typename?: 'PaypalQueryApi';
  options: PaypalOptions;
};

export type PendingEventUserRole = {
  __typename?: 'PendingEventUserRole';
  email?: Maybe<Scalars['String']['output']>;
  role: EventAttendeeRole;
  user?: Maybe<User>;
};

export type PendingInvite = {
  __typename?: 'PendingInvite';
  actions?: Maybe<Array<InviteActionUnion>>;
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  inviteAcceptLink: Scalars['URL']['output'];
  inviteId: Scalars['String']['output'];
  memo: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  validInvitesRemaining: Scalars['Int']['output'];
};

export type PercentageBucketPointsPurchaseStrategy = {
  __typename?: 'PercentageBucketPointsPurchaseStrategy';
  baseCostPerPoint: Scalars['Decimal']['output'];
  discountBuckets: Array<PercentageDiscountBucketPoints>;
};

export type PercentageBucketPointsPurchaseStrategyInput = {
  baseCostPerPoint: Scalars['Decimal']['input'];
  discountBuckets: Array<PercentageDiscountBucketPointsInput>;
};

export type PercentageDiscountBucketPoints = {
  __typename?: 'PercentageDiscountBucketPoints';
  discountPercentage: Scalars['Decimal']['output'];
  points: Scalars['Long']['output'];
};

export type PercentageDiscountBucketPointsInput = {
  discountPercentage: Scalars['Decimal']['input'];
  points: Scalars['Long']['input'];
};

export type Pie = HasCanonicalUrl & ILimitedPieModel & {
  __typename?: 'Pie';
  /** Description or bio of the pie */
  bio?: Maybe<Scalars['String']['output']>;
  /** True if this pie can be for sale */
  canBeForSale?: Maybe<Scalars['Boolean']['output']>;
  /** True if this pie can be bought by placing an order */
  canBuy?: Maybe<Scalars['Boolean']['output']>;
  /** True if this pie can be sold by owner */
  canSell?: Maybe<Scalars['Boolean']['output']>;
  /** True if this pie can be transfer to another user */
  canTransfer?: Maybe<Scalars['Boolean']['output']>;
  /** The absolute canonical url for this pie, can be used for sharing */
  canonicalUrl?: Maybe<Scalars['URL']['output']>;
  /** The user created the pie */
  createdBy?: Maybe<User>;
  /** Created at */
  createdUtc: Scalars['DateTime']['output'];
  /** Name of the pie */
  displayName: Scalars['String']['output'];
  /** How many number of slices percentage that publisher is selling */
  floatPercentage: Scalars['Decimal']['output'];
  /** The total number of slices that publisher is holding */
  holdingSlices: Scalars['Decimal']['output'];
  /** Initial offer */
  initialOffer?: Maybe<PublicPieInitialOfferModel>;
  /** Is Pie deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Is Pie disabled */
  isDisabled: Scalars['Boolean']['output'];
  /**
   * True if this pie is activated for onboarding process
   * @deprecated Please use onBoardingProcess instead
   */
  isOnboardingActivated?: Maybe<Scalars['Boolean']['output']>;
  /** True if this pie is verified */
  isVerified: Scalars['Boolean']['output'];
  /** Is Pie visible */
  isVisible: Scalars['Boolean']['output'];
  /** The maximum number of slices for a pie and can not be changed after creation */
  issuedSlices: Scalars['Decimal']['output'];
  /** Pie launched date */
  launchedUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Market symbol of pie */
  marketSymbol?: Maybe<Scalars['String']['output']>;
  /** Get onboarding process */
  onBoardingProcess?: Maybe<OnboardingProcess>;
  /** Current state of the pie */
  operationalState: PieOperationalState;
  /** Url for pie avatar */
  pieAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Id of pie */
  pieId: Scalars['UUID']['output'];
  /** Global rank of pie */
  rank?: Maybe<Scalars['Int']['output']>;
  /** Current sales state of the pie. This is similar to the OperationalState but calculated */
  salesStatus: PieSalesState;
  /** Price per slice of pie */
  slicePrice: Amount;
  /** How many number of slices percentage that publisher is holing */
  slicesHeld: Scalars['Decimal']['output'];
  /** Slug of pie */
  slug: Scalars['String']['output'];
  /** List of associated social media */
  socialMedia: Array<SocialMediaPair>;
  /** Total members */
  totalMembers: Scalars['Long']['output'];
  /** Total number of unique subscribers of this pie */
  totalUniqueSubscribers: Scalars['Int']['output'];
  /** Total value of all slices */
  totalValue: Amount;
  /** Url of the Pie avatar which is in generating or generated */
  truePieAvatarUrl?: Maybe<Scalars['String']['output']>;
};

export type PieArgsInput = {
  availableSlices: Scalars['Decimal']['input'];
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  bio: Scalars['String']['input'];
  createdUtc?: InputMaybe<Scalars['DateTime']['input']>;
  displayName: Scalars['String']['input'];
  individualAssets: Array<Scalars['UUID']['input']>;
  isFeatured: Scalars['Boolean']['input'];
  isVerified: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  issuedSlices: Scalars['Decimal']['input'];
  launchedUtc?: InputMaybe<Scalars['DateTime']['input']>;
  marketSymbol: Scalars['String']['input'];
  operationalState: PieOperationalState;
  rank?: InputMaybe<Scalars['Int']['input']>;
  sentSlices: Scalars['Decimal']['input'];
  slicePrice: AmountInput;
  slug: Scalars['String']['input'];
  soldSlices: Scalars['Decimal']['input'];
  totalUniqueSubscribers: Scalars['Int']['input'];
};

export type PieBalance = {
  __typename?: 'PieBalance';
  /** Number of available pies for sale, when a pie is in PreSale or InitialOffer state */
  availableSlices: Scalars['Decimal']['output'];
  receivedSlices: Scalars['Decimal']['output'];
  sentSlices: Scalars['Decimal']['output'];
  slicesOwnedByUsers: Scalars['Decimal']['output'];
  soldSlices: Scalars['Decimal']['output'];
};

export type PieEdgeX = {
  __typename?: 'PieEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CompletePieWithBalance>;
};

/** Represents a slice or page */
export type PieGrainPageX = {
  __typename?: 'PieGrainPageX';
  /** A list of edges */
  edges: Array<PieEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<CompletePieWithBalance>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type PieIndexDocument = {
  __typename?: 'PieIndexDocument';
  availableSlices: Scalars['Decimal']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  createdBy: UserIndexDocument;
  createdUtc: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  /** How many number of slices percentage that publisher is selling */
  floatPercentage: Scalars['Decimal']['output'];
  holdingSlices: Scalars['Decimal']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  issuedSlices: Scalars['Decimal']['output'];
  operationalState: PieOperationalState;
  pieAvatarUrl?: Maybe<Scalars['String']['output']>;
  pieBalance: PieBalance;
  pieId: Scalars['UUID']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  sentSlices: Scalars['Decimal']['output'];
  slicePrice: Amount;
  /** How many number of slices percentage that publisher is holing */
  slicesHeld: Scalars['Decimal']['output'];
  slug: Scalars['String']['output'];
  soldSlices: Scalars['Decimal']['output'];
  totalMembers: Scalars['Long']['output'];
  totalUniqueSubscribers: Scalars['Int']['output'];
  /** Total value of all slices */
  totalValue: Amount;
  uploadedAssets?: Maybe<Array<UploadedAssetIndexDocument>>;
};

export type PieMutationApi = {
  __typename?: 'PieMutationApi';
  /** Accept pie ownership */
  acceptPieOwnership: Scalars['Boolean']['output'];
  /** Activate the onboarding process for pie */
  activateOnboardingProcess: Scalars['Boolean']['output'];
  /** PLACEHOLDER: update pie */
  completePieActivationProcess: OnboardingProcess;
  /** PLACEHOLDER: Trade or update a pie */
  createOrUpdate: PublicPieModel;
  /** Delete a pie */
  delete: Scalars['Boolean']['output'];
  /** Delete moderator */
  deleteModerator: Scalars['Boolean']['output'];
  /** Grant moderator */
  grantModerator: Scalars['Boolean']['output'];
  /** Migrate buyers to buyerTransactions */
  migrateBuyersToBuyersTransactions: Scalars['Boolean']['output'];
  /** Recover pie */
  recover: Scalars['Boolean']['output'];
  /** Release slices */
  releaseSlices: Scalars['Boolean']['output'];
  /** Send purchase pie notification */
  sendNotificationForPurchase: Scalars['Boolean']['output'];
  /** Set pie disable status */
  setDisable: Scalars['Boolean']['output'];
  /** Set pie hidden status */
  setHidden: Scalars['Boolean']['output'];
  /** Transfer pie */
  transferPie: Scalars['Boolean']['output'];
  /** Transfer pie slices */
  transferSlices: Scalars['Boolean']['output'];
  /** Transfer slices to pie */
  transferSlicesToPie: Scalars['Boolean']['output'];
  /** PLACEHOLDER: update pie appearance */
  updateAppearance: Scalars['Boolean']['output'];
  /** PLACEHOLDER: Update basic pie info */
  updateBasicInfo: PublicPieModel;
};


export type PieMutationApiAcceptPieOwnershipArgs = {
  accept: Scalars['Boolean']['input'];
  pieId: Scalars['UUID']['input'];
};


export type PieMutationApiActivateOnboardingProcessArgs = {
  pieId: Scalars['UUID']['input'];
};


export type PieMutationApiCompletePieActivationProcessArgs = {
  availableSlices?: InputMaybe<Scalars['Decimal']['input']>;
  bio: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  individualAssetIds: Array<Scalars['UUID']['input']>;
  slicePrice: AmountInput;
  slug: Scalars['String']['input'];
  socialMedia: Array<SocialMediaPairInput>;
};


export type PieMutationApiCreateOrUpdateArgs = {
  availableSlices?: InputMaybe<Scalars['Decimal']['input']>;
  bio: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  individualAssetIds: Array<Scalars['UUID']['input']>;
  issuedSlices: Scalars['Decimal']['input'];
  operationalState?: PieOperationalState;
  shouldSendEmail?: Scalars['Boolean']['input'];
  slicePrice: AmountInput;
  slug: Scalars['String']['input'];
  socialMedia: Array<SocialMediaPairInput>;
};


export type PieMutationApiDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type PieMutationApiDeleteModeratorArgs = {
  pieId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type PieMutationApiGrantModeratorArgs = {
  pieId: Scalars['UUID']['input'];
  pieRole: PieRole;
  userName: Scalars['String']['input'];
};


export type PieMutationApiRecoverArgs = {
  pieId: Scalars['UUID']['input'];
};


export type PieMutationApiReleaseSlicesArgs = {
  availableSlices: Scalars['Decimal']['input'];
  pieId: Scalars['UUID']['input'];
  slicePrice: AmountInput;
};


export type PieMutationApiSendNotificationForPurchaseArgs = {
  context: TradingContext;
  pieId: Scalars['UUID']['input'];
  type: TransactionType;
};


export type PieMutationApiSetDisableArgs = {
  disable: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
};


export type PieMutationApiSetHiddenArgs = {
  hidden: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
};


export type PieMutationApiTransferPieArgs = {
  pieId: Scalars['UUID']['input'];
  userName: Scalars['String']['input'];
};


export type PieMutationApiTransferSlicesArgs = {
  pieId: Scalars['UUID']['input'];
  slices: Scalars['Int']['input'];
  source: WithdrawSource;
  targetUserName: Scalars['String']['input'];
};


export type PieMutationApiTransferSlicesToPieArgs = {
  pieId: Scalars['UUID']['input'];
  slices: Scalars['Int']['input'];
};


export type PieMutationApiUpdateAppearanceArgs = {
  id: Scalars['UUID']['input'];
  individualAssetIds: Array<Scalars['UUID']['input']>;
};


export type PieMutationApiUpdateBasicInfoArgs = {
  bio: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
};

/** Represents a slice or page of Pie */
export type PieOffsetPage = {
  __typename?: 'PieOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<CompletePieWithBalance>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export enum PieOperationalState {
  /** Pie is closed and de-listed */
  Closed = 'CLOSED',
  /** Pie is open */
  Open = 'OPEN',
  /** Pie is pending by waiting for payment or other reasons */
  Pending = 'PENDING',
  /** Pie is statically priced */
  Static = 'STATIC',
  /** Pie is suspended */
  Suspended = 'SUSPENDED'
}

export type PiePublicQueryApi = {
  __typename?: 'PiePublicQueryApi';
  bySlugOrId?: Maybe<CompletePieWithBalance>;
};


export type PiePublicQueryApiBySlugOrIdArgs = {
  slugOrId: Scalars['String']['input'];
};

export type PieQueryApi = {
  __typename?: 'PieQueryApi';
  byId?: Maybe<CompletePieWithBalance>;
  bySlugOrId?: Maybe<CompletePieWithBalance>;
  defaultMaxSlices: Scalars['Decimal']['output'];
  /**
   * List sales
   * @deprecated Use listSales2 instead
   */
  listSales?: Maybe<TradingTransactionOffsetPage>;
  /** List sales */
  listSales2?: Maybe<TradingTransactionGrainPageX>;
  myModeratorPies?: Maybe<PieGrainPageX>;
  /** @deprecated Use me.pies instead */
  myPies?: Maybe<PieGrainPageX>;
  numberOfSlicesOptions: Array<NumberOfSlicesOption>;
  pieSettings: PieSetting;
  repbets?: Maybe<CompletePieWithBalance>;
  /** @deprecated Use search2 instead */
  search?: Maybe<PieOffsetPage>;
  search2?: Maybe<PieGrainPageX>;
  searchRandom?: Maybe<PieGrainPageX>;
  slugAvailable: Scalars['Boolean']['output'];
  slugAvailable2: AvailableCheckingResult;
};


export type PieQueryApiByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type PieQueryApiBySlugOrIdArgs = {
  slugOrId: Scalars['String']['input'];
};


export type PieQueryApiListSalesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  pieId: Scalars['UUID']['input'];
  sortingOrder?: PageSortOrder;
  sortingType?: TradingTransactionSortingType;
};


export type PieQueryApiListSales2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  pieId: Scalars['UUID']['input'];
  sortingOrder?: PageSortOrder;
  sortingType?: TradingTransactionSortingType;
};


export type PieQueryApiMyModeratorPiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PieQueryApiMyPiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortingType?: InputMaybe<PageSortOrder>;
};


export type PieQueryApiSearchArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  repbetsPieFirst?: Scalars['Boolean']['input'];
  sortingOrder?: InputMaybe<PageSortOrder>;
  type?: InputMaybe<PieType>;
};


export type PieQueryApiSearch2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  repbetsPieFirst?: Scalars['Boolean']['input'];
  sortingOrder?: InputMaybe<PageSortOrder>;
  type?: InputMaybe<PieType>;
};


export type PieQueryApiSearchRandomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  sortingOrder?: InputMaybe<PageSortOrder>;
  type?: InputMaybe<PieType>;
};


export type PieQueryApiSlugAvailableArgs = {
  slug: Scalars['String']['input'];
};


export type PieQueryApiSlugAvailable2Args = {
  slug: Scalars['String']['input'];
};

export enum PieRole {
  AccountManager = 'ACCOUNT_MANAGER',
  Admin = 'ADMIN',
  None = 'NONE',
  RewardManager = 'REWARD_MANAGER'
}

export enum PieSalesState {
  /** Pie sales status is closed */
  Closed = 'CLOSED',
  /** Pie sales status is open */
  Open = 'OPEN',
  /** Pie sales status is currently private */
  Private = 'PRIVATE',
  /** Pie sales status is open, but sold out */
  SoldOut = 'SOLD_OUT',
  /** Pie sales status is temporarily suspended */
  Suspended = 'SUSPENDED'
}

export type PieSetting = {
  __typename?: 'PieSetting';
  maxNumberOfSlicesForFreePie: Scalars['Int']['output'];
};

export enum PieSortingType {
  CreatedDate = 'CREATED_DATE',
  Price = 'PRICE',
  Rank = 'RANK',
  Volume24H = 'VOLUME24H'
}

export enum PieType {
  Featured = 'FEATURED',
  Newcomers = 'NEWCOMERS',
  Watchlist = 'WATCHLIST'
}

export type PieUpdateSlicesArgsInput = {
  availableSlices?: InputMaybe<Scalars['Decimal']['input']>;
  holdingSlices?: InputMaybe<Scalars['Decimal']['input']>;
  issuedSlices?: InputMaybe<Scalars['Decimal']['input']>;
  receivedSlices?: InputMaybe<Scalars['Decimal']['input']>;
  sentSlices?: InputMaybe<Scalars['Decimal']['input']>;
  slicePrice?: InputMaybe<AmountInput>;
  soldSlices?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PlusOneBreakdown = {
  __typename?: 'PlusOneBreakdown';
  everyEvent: Scalars['Int']['output'];
  live: Scalars['Int']['output'];
  shared: Scalars['Int']['output'];
};

export type PlusOneReturnEventRow = {
  __typename?: 'PlusOneReturnEventRow';
  activeCount: Scalars['Int']['output'];
  endDate: Scalars['DateTime']['output'];
  eventId: Scalars['UUID']['output'];
  expiredCount: Scalars['Int']['output'];
  isOver: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  state: PlusOneReturnEventState;
  transferredCount: Scalars['Int']['output'];
};

export enum PlusOneReturnEventState {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  NotScheduled = 'NOT_SCHEDULED',
  Pending = 'PENDING',
  Stuck = 'STUCK',
  Upcoming = 'UPCOMING'
}

export type PlusOneReturnHealth = {
  __typename?: 'PlusOneReturnHealth';
  checkedAtUtc: Scalars['DateTime']['output'];
  events: Array<PlusOneReturnEventRow>;
  isEnabled: Scalars['Boolean']['output'];
  reasons: Array<PlusOneReturnReason>;
  seriesId: Scalars['UUID']['output'];
  status: PlusOneReturnStatus;
};

export type PlusOneReturnReason = {
  __typename?: 'PlusOneReturnReason';
  code: PlusOneReturnReasonCode;
  count: Scalars['Int']['output'];
  eventId?: Maybe<Scalars['UUID']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  severity: PlusOneReturnSeverity;
};

export enum PlusOneReturnReasonCode {
  HoldersMissingPlusOne = 'HOLDERS_MISSING_PLUS_ONE',
  ReturnNotScheduled = 'RETURN_NOT_SCHEDULED',
  ReturnPending = 'RETURN_PENDING',
  ReturnStuck = 'RETURN_STUCK',
  WaitingForNextEvent = 'WAITING_FOR_NEXT_EVENT',
  WillNotReturn = 'WILL_NOT_RETURN'
}

export enum PlusOneReturnSeverity {
  Attention = 'ATTENTION',
  Failure = 'FAILURE',
  Info = 'INFO'
}

export enum PlusOneReturnStatus {
  Failing = 'FAILING',
  Healthy = 'HEALTHY',
  NeedsAttention = 'NEEDS_ATTENTION'
}

export type PointsClassPayloadInput = {
  isTransferable: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  symbol: Scalars['String']['input'];
};

export type PrepareUploadResponse = {
  __typename?: 'PrepareUploadResponse';
  method: Scalars['String']['output'];
  token: Scalars['String']['output'];
  uploadUrl: Scalars['URL']['output'];
};

export type PriceConditionPayloadInput = {
  price: Scalars['Decimal']['input'];
  repPoints: Scalars['Decimal']['input'];
};

export type PricePayloadInput = {
  price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PriceRewardCondition = {
  __typename?: 'PriceRewardCondition';
  price: Scalars['Decimal']['output'];
  repPoints: Scalars['Decimal']['output'];
  type: RewardConditionType;
};

export type PriceRewardRedemptionMethod = {
  __typename?: 'PriceRewardRedemptionMethod';
  price?: Maybe<Scalars['Decimal']['output']>;
  redemptionMethodType: RewardRedemptionMethodType;
};

export type PrivateTicketsArgs = {
  __typename?: 'PrivateTicketsArgs';
  amount: Scalars['Int']['output'];
  eventTicketId: Scalars['UUID']['output'];
};

export type PrivateTicketsArgsInput = {
  amount: Scalars['Int']['input'];
  eventTicketId: Scalars['UUID']['input'];
};

export enum ProductType {
  EventTicket = 'EVENT_TICKET',
  Merchandise = 'MERCHANDISE',
  None = 'NONE',
  RewardOffer = 'REWARD_OFFER',
  TotalGratuity = 'TOTAL_GRATUITY',
  TransactionFee = 'TRANSACTION_FEE'
}

export type ProfileArgsInput = {
  address?: InputMaybe<AddressModelInput>;
  agreeToTermsAndConditions: Scalars['Boolean']['input'];
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['LocalDate']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  tier: UserTier;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileCompletionToggleResult = {
  __typename?: 'ProfileCompletionToggleResult';
  skippedUserIds: Array<Scalars['UUID']['output']>;
  updatedUserIds: Array<Scalars['UUID']['output']>;
};

export type PromoCodePayloadInput = {
  code: Scalars['String']['input'];
  guide?: InputMaybe<Scalars['String']['input']>;
  isGenerated: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type PromoCodeRewardRedemption = {
  __typename?: 'PromoCodeRewardRedemption';
  code: Scalars['String']['output'];
  guide?: Maybe<Scalars['String']['output']>;
  isGenerated: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  redemptionType: RewardRedemptionType;
};

export type PublicAchievementModel = ILimitedAchievementModel & {
  __typename?: 'PublicAchievementModel';
  achievementId: Scalars['UUID']['output'];
  achievementLookupMigrated: Scalars['Boolean']['output'];
  achievementToPieMigrated: Scalars['Boolean']['output'];
  achievementType: AchievementType;
  activeFromUtc?: Maybe<Scalars['DateTime']['output']>;
  activeToUtc?: Maybe<Scalars['DateTime']['output']>;
  avatarUrl: Scalars['String']['output'];
  bio: Scalars['String']['output'];
  category?: Maybe<AchievementCategory>;
  createdUtc: Scalars['DateTime']['output'];
  deletedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isDeletedByAdmin?: Maybe<Scalars['Boolean']['output']>;
  isHidden: Scalars['Boolean']['output'];
  maxSupply?: Maybe<Scalars['Int']['output']>;
  owner: User;
  pie?: Maybe<CompletePieWithBalance>;
  slug: Scalars['String']['output'];
  status: AchievementStatus;
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
  verificationCode: Scalars['String']['output'];
};

export type PublicClubOfferState = {
  __typename?: 'PublicClubOfferState';
  access: ClubOfferAccess;
  /** Calculate final offer cost including all applicable fees */
  calculateOfferCost?: Maybe<OfferCostInfo>;
  canProcessPayment: Scalars['Boolean']['output'];
  club?: Maybe<ClubState>;
  configuration?: Maybe<OfferConfigurationPayload>;
  isCurrentUserCanInvite?: Maybe<CanInviteOfferResultType>;
  isCurrentUserEditable?: Maybe<Scalars['Boolean']['output']>;
  isCurrentUserRedeemable?: Maybe<Scalars['Boolean']['output']>;
  isCurrentUserWinner?: Maybe<Scalars['Boolean']['output']>;
  isFree?: Maybe<Scalars['Boolean']['output']>;
  isPublicUserRedeemable?: Maybe<Scalars['Boolean']['output']>;
  isStarted?: Maybe<Scalars['Boolean']['output']>;
  isTimeFrameTypeEditable?: Maybe<Scalars['Boolean']['output']>;
  isWinnerGenerated?: Maybe<Scalars['Boolean']['output']>;
  listOfferUser?: Maybe<DetailsOfferUserConnection>;
  offerId: Scalars['UUID']['output'];
  published: ClubOfferPublished;
  requirements?: Maybe<ClubOfferRequirement>;
  rewardOffer?: Maybe<RewardOfferFlow>;
  rewards: Array<Maybe<RewardState>>;
  shortLink?: Maybe<Scalars['String']['output']>;
  totalWinnerCount?: Maybe<Scalars['Int']['output']>;
  type: OfferType;
  userOffer?: Maybe<OfferUserState>;
};


export type PublicClubOfferStateCalculateOfferCostArgs = {
  offerCostArgs?: InputMaybe<OfferCostArgsInput>;
};


export type PublicClubOfferStateListOfferUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DetailsOfferUserFilterArgsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a slice or page of PublicClubOfferState */
export type PublicClubOfferStateOffsetPage = {
  __typename?: 'PublicClubOfferStateOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<PublicClubOfferState>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type PublicClubState = {
  __typename?: 'PublicClubState';
  clubId: Scalars['UUID']['output'];
  colors?: Maybe<ClubColors>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  images?: Maybe<ClubImages>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

export type PublicConfigurationModel = {
  __typename?: 'PublicConfigurationModel';
  defaultTaxName: Scalars['String']['output'];
  defaultTaxPercentage: Scalars['Decimal']['output'];
  paymentProcessor: PaymentMethod;
};

export type PublicEventModel = ILimitedEventModel & {
  __typename?: 'PublicEventModel';
  ageLimit?: Maybe<Scalars['Int']['output']>;
  avatarUrl: Scalars['String']['output'];
  clubId?: Maybe<Scalars['UUID']['output']>;
  createdBy?: Maybe<User>;
  createdDate: Scalars['DateTime']['output'];
  /** ISO 4217 currency code for event pricing (e.g. USD, GBP) */
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  disclosureOrPrivacyPolicyContent?: Maybe<Scalars['String']['output']>;
  disclosureOrPrivacyPolicyFileUrl?: Maybe<Scalars['String']['output']>;
  disclosureOrPrivacyPolicyTitle?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  eligibilityCriteria?: Maybe<EventEligibilityCriteria>;
  endDate: Scalars['DateTime']['output'];
  eventId: Scalars['UUID']['output'];
  eventSeriesId?: Maybe<Scalars['UUID']['output']>;
  eventType: EventType;
  exclusiveAvatarUrl?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  faqEntries?: Maybe<Array<FaqEntry>>;
  faqs?: Maybe<Scalars['String']['output']>;
  isAllInPricing?: Maybe<Scalars['Boolean']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isDeletedByAdmin: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  isListed?: Maybe<Scalars['Boolean']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  isSeriesParentEvent: Scalars['Boolean']['output'];
  location?: Maybe<EventLocation>;
  locationRadius?: Maybe<EventLocation>;
  minimumRepScore?: Maybe<Scalars['Decimal']['output']>;
  musicEmbedUrl?: Maybe<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  optInAgeLimit: Scalars['Boolean']['output'];
  optInAllowGuestInviteOthers: Scalars['Boolean']['output'];
  optInAllowPublicEventPagePreview?: Maybe<Scalars['Boolean']['output']>;
  optInDisclosureOrPrivacyPolicy: Scalars['Boolean']['output'];
  optInDisplayRepScore: Scalars['Boolean']['output'];
  optInLocationRadius: Scalars['Boolean']['output'];
  optInQuestionRequirements: Scalars['Boolean']['output'];
  optInRequireGuestApproval: Scalars['Boolean']['output'];
  optInShowGuestCount: Scalars['Boolean']['output'];
  optInShowGuestList: Scalars['Boolean']['output'];
  optInShowMusicEmbed: Scalars['Boolean']['output'];
  optInShowTicketAmount: Scalars['Boolean']['output'];
  optInSocialAccountRequirements: Scalars['Boolean']['output'];
  optInUseRepbetsQrPass: Scalars['Boolean']['output'];
  paymentProcessor?: Maybe<PaymentMethod>;
  questionRequirements?: Maybe<Array<QuestionRequirement>>;
  recurringId?: Maybe<Scalars['UUID']['output']>;
  requireSocialAccountConnection: Scalars['Boolean']['output'];
  scanningZones?: Maybe<Array<ScanningZone>>;
  slug: Scalars['String']['output'];
  socialAccountRequirements?: Maybe<Array<SocialAccountRequirement>>;
  startDate: Scalars['DateTime']['output'];
  status: EventStatus;
  terms?: Maybe<Scalars['String']['output']>;
  ticketTermsPurchasePolicy?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
};

/** A connection to a list of items. */
export type PublicEventsConnection = {
  __typename?: 'PublicEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PublicEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<LimitedEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PublicEventsEdge = {
  __typename?: 'PublicEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LimitedEvent>;
};

export type PublicIndividualAssetModel = {
  __typename?: 'PublicIndividualAssetModel';
  category: IndividualAssetCategory;
  createdUtc: Scalars['DateTime']['output'];
  currentSupply: Scalars['Decimal']['output'];
  imageUrl: Scalars['String']['output'];
  individualAssetId: Scalars['UUID']['output'];
  isHidden: Scalars['Boolean']['output'];
  maxSupply: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  price: Amount;
  priority: Scalars['Int']['output'];
  status: IndividualAssetStatus;
};

export type PublicKeyCredential = {
  __typename?: 'PublicKeyCredential';
  id: Scalars['String']['output'];
};

export type PublicMutationApi = {
  __typename?: 'PublicMutationApi';
  /** Generate a rotating (60s) QR code for a guest pass — gated by possession of the guest's static token, used by the guest-facing pass page */
  generateGuestQrCode: GuestQrCodeModel;
  userByEmail: PublicUser;
};


export type PublicMutationApiGenerateGuestQrCodeArgs = {
  eventId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
};


export type PublicMutationApiUserByEmailArgs = {
  emailAddress: Scalars['String']['input'];
};

export type PublicPieInitialOfferModel = {
  __typename?: 'PublicPieInitialOfferModel';
  maximumPurchaseVolume: Scalars['Decimal']['output'];
  minimumPurchaseVolume: Scalars['Decimal']['output'];
  purchaseMultiple: Scalars['Decimal']['output'];
};

export type PublicPieModel = ILimitedPieModel & {
  __typename?: 'PublicPieModel';
  avatarIsPending: Scalars['Boolean']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  canBuy: Scalars['Boolean']['output'];
  canSell: Scalars['Boolean']['output'];
  canTransfer: Scalars['Boolean']['output'];
  createdBy?: Maybe<User>;
  createdUtc: Scalars['DateTime']['output'];
  deletedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  deletedByAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the pie */
  displayName: Scalars['String']['output'];
  /** The percentage number of slices that publisher is selling */
  floatPercentage: Scalars['Decimal']['output'];
  hasSocialMediaSizedImage: Scalars['Boolean']['output'];
  holdingSlices: Scalars['Decimal']['output'];
  /** Ordered list of individual assets ids to compose the full pie image */
  individualAssets?: Maybe<Array<Scalars['UUID']['output']>>;
  initialOffer?: Maybe<PublicPieInitialOfferModel>;
  isDeleted: Scalars['Boolean']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  issuedSlices: Scalars['Decimal']['output'];
  launchedUtc?: Maybe<Scalars['DateTime']['output']>;
  marketSymbol?: Maybe<Scalars['String']['output']>;
  /** Current state of the pie */
  operationalState: PieOperationalState;
  /** Url of the Pie avatar, sometimes just the pie */
  pieAvatarUrl: Scalars['String']['output'];
  pieBalance: PieBalance;
  /** Id of pie */
  pieId: Scalars['UUID']['output'];
  /** Global rank of pie */
  rank?: Maybe<Scalars['Int']['output']>;
  /** Current sales state of the pie. This is similar to the OperationalState but calculated */
  salesStatus: PieSalesState;
  slicePrice: Amount;
  /** The percentage number of slices that publisher is holing */
  slicesHeld: Scalars['Decimal']['output'];
  /** Slug of the pie */
  slug: Scalars['String']['output'];
  socialMedia: Array<SocialMediaPair>;
  totalMembers: Scalars['Long']['output'];
  totalUniqueSubscribers: Scalars['Int']['output'];
  /** Total value of all slices */
  totalValue: Amount;
  /** Url of the Pie avatar which is in generating or generated */
  truePieAvatarUrl: Scalars['String']['output'];
  /** Ordered list of uploaded assets */
  uploadedAssets?: Maybe<Array<UploadedAssetModel>>;
};

export type PublicQueryApi = {
  __typename?: 'PublicQueryApi';
  userByEmail: QueryPublicUser;
};


export type PublicQueryApiUserByEmailArgs = {
  emailAddress: Scalars['String']['input'];
};

export type PublicRewardModel = ILimitedRewardModel & {
  __typename?: 'PublicRewardModel';
  ageLimit?: Maybe<Scalars['Int']['output']>;
  avatarUrl: Scalars['String']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  canShareByParticipants: Scalars['Boolean']['output'];
  category?: Maybe<RewardCategory>;
  createdUtc: Scalars['DateTime']['output'];
  dateRangesMigrated: Scalars['Boolean']['output'];
  deletedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  /** @deprecated use expiresAt instead */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAtMigrated: Scalars['Boolean']['output'];
  geoRangeCondition?: Maybe<RewardGeoRangeCondition>;
  hasSocialMediaSizedImage: Scalars['Boolean']['output'];
  individualApiUrl: Scalars['String']['output'];
  invalidAwardedUsersMigrated: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isDeletedByAdmin?: Maybe<Scalars['Boolean']['output']>;
  isHidden: Scalars['Boolean']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  maxWinners?: Maybe<Scalars['Int']['output']>;
  /** @deprecated No longer supported. */
  mustOwnSlicesAmount?: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated No longer supported. */
  mustOwnSlicesEndDate?: Maybe<Scalars['DateTime']['output']>;
  mustOwnSlicesFromPieId?: Maybe<Scalars['UUID']['output']>;
  /** @deprecated No longer supported. */
  mustOwnSlicesStartDate?: Maybe<Scalars['DateTime']['output']>;
  needNewSlices: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  optInParticipantPrivacyPolicy: Scalars['Boolean']['output'];
  participantPrivacyPolicyContent?: Maybe<Scalars['String']['output']>;
  participantPrivacyPolicyTitle?: Maybe<Scalars['String']['output']>;
  pie?: Maybe<CompletePieWithBalance>;
  policyFileUrl?: Maybe<Scalars['String']['output']>;
  redeemCode?: Maybe<Scalars['String']['output']>;
  redeemDescription?: Maybe<Scalars['String']['output']>;
  redeemType?: Maybe<RedeemType>;
  requireAllAchievements: Scalars['Boolean']['output'];
  rewardId: Scalars['UUID']['output'];
  rewardLookupMigrated: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: RewardStatus;
  totalActivatedUserAmount?: Maybe<Scalars['Int']['output']>;
  type: RewardType;
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
  winnersChosenOption?: Maybe<WinnersChosenOption>;
};

/** A connection to a list of items. */
export type PublicSeriesEventsConnection = {
  __typename?: 'PublicSeriesEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PublicSeriesEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<LimitedEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PublicSeriesEventsEdge = {
  __typename?: 'PublicSeriesEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LimitedEvent>;
};

export type PublicTradingTransactionModel = {
  __typename?: 'PublicTradingTransactionModel';
  acceptedBy?: Maybe<User>;
  authorizationTransactionId?: Maybe<Scalars['String']['output']>;
  authorizationTransactionMessage?: Maybe<Scalars['String']['output']>;
  authorizationTransactionStatus?: Maybe<Scalars['String']['output']>;
  captureOrderId?: Maybe<Scalars['String']['output']>;
  captureTransactionId?: Maybe<Scalars['String']['output']>;
  captureTransactionMessage?: Maybe<Scalars['String']['output']>;
  captureTransactionStatus?: Maybe<Scalars['String']['output']>;
  cardbrand?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['DateTime']['output'];
  event?: Maybe<Event>;
  hostBalance: Scalars['Decimal']['output'];
  isAllInPricing: Scalars['Boolean']['output'];
  orderId?: Maybe<Scalars['UUID']['output']>;
  originalTransactionId?: Maybe<Scalars['UUID']['output']>;
  paidDateUtc?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentSource?: Maybe<Scalars['String']['output']>;
  pie?: Maybe<CompletePieWithBalance>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCurrency?: Maybe<Scalars['String']['output']>;
  processingFee: Scalars['Decimal']['output'];
  referralUser?: Maybe<User>;
  serviceFee: Scalars['Decimal']['output'];
  status?: Maybe<PaymentStatus>;
  subTotal: Scalars['Decimal']['output'];
  totalGratuity: Scalars['Decimal']['output'];
  totalPrice?: Maybe<Scalars['Decimal']['output']>;
  totalTaxes: Scalars['Decimal']['output'];
  tradeSlices?: Maybe<Scalars['Decimal']['output']>;
  transactionFee?: Maybe<Scalars['Decimal']['output']>;
  transactionId: Scalars['UUID']['output'];
  transactionStatus: TransactionStatus;
  type: TransactionType;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type PublicUploadedAssetModel = {
  __typename?: 'PublicUploadedAssetModel';
  createdUtc: Scalars['DateTime']['output'];
  pie?: Maybe<CompletePieWithBalance>;
  status: UploadedAssetStatus;
  target: UploadedAssetTarget;
  uploadedAssetId: Scalars['UUID']['output'];
  url: Scalars['String']['output'];
};

export type PublicUser = {
  __typename?: 'PublicUser';
  /** Update email subscription with specific types */
  updateEmailSubscription: Scalars['Boolean']['output'];
};


export type PublicUserUpdateEmailSubscriptionArgs = {
  args: Array<EmailSubscriptionArgsInput>;
};

export type QrCodeModel = {
  __typename?: 'QrCodeModel';
  count: Scalars['Int']['output'];
  eventTicketId?: Maybe<Scalars['UUID']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  firstSeen?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  qrCode: Scalars['String']['output'];
  ticketId: Scalars['String']['output'];
  userTicketId: Scalars['UUID']['output'];
};

export type Query = {
  __typename?: 'Query';
  achievement: AchievementQueryApi;
  achievementPublic: AchievementPublicQueryApi;
  admin: AdminQueryApi;
  club?: Maybe<ClubState>;
  /** @deprecated Use Achievements on ClubState instead */
  clubAchievements?: Maybe<ClubAchievementsConnection>;
  clubBySlug?: Maybe<ClubState>;
  clubOffer?: Maybe<ClubOfferState>;
  /** @deprecated Use Offers on ClubState instead */
  clubOffers?: Maybe<ClubOffersConnection>;
  clubRoles?: Maybe<Array<ClubRolePermissionState>>;
  clubs?: Maybe<ClubsConnection>;
  contactList: ContactListQueryApi;
  device: DeviceQueryApi;
  event: EventQueryApi;
  eventRolePermissions: Array<EventRolePermissions>;
  eventSeries: EventSeriesQueryApi;
  eventTicket: EventTicketQueryApi;
  findGeoFences: Array<UserGeoFenceModel>;
  hostMessage: HostMessageQueryApi;
  individualAsset: IndividualAssetQueryApi;
  /** @deprecated use individualAsset */
  individual_asset: IndividualAssetQueryApi;
  me?: Maybe<CurrentUser>;
  myOffers?: Maybe<MyOffersConnection>;
  myPasskeyCredentials?: Maybe<Array<Maybe<StoredPasskeyCredential>>>;
  myReferralCode: Scalars['String']['output'];
  notification: NotificationQueryApi;
  paypal: PaypalQueryApi;
  pie: PieQueryApi;
  piePublic: PiePublicQueryApi;
  public: PublicQueryApi;
  publicConfiguration: PublicConfigurationModel;
  referral: ReferralQueryApi;
  reward: RewardQueryApi;
  searchClubs?: Maybe<SearchClubsConnection>;
  searchOffers?: Maybe<SearchOffersConnection>;
  /** Returns the list of currencies supported for payments */
  supportedCurrencies: Array<SupportedCurrencyType>;
  termsAndConditions: TermsAndConditionsQueryApi;
  uploadedAsset: UploadedAssetQueryApi;
  /** @deprecated Use uploadedAsset instead */
  uploaded_asset: UploadedAssetQueryApi;
  user?: Maybe<User>;
  userNameAvailable: Scalars['Boolean']['output'];
  users?: Maybe<UserOffsetPage>;
  wallet: WalletQueryApi;
};


export type QueryClubArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryClubAchievementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clubId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClubBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryClubOfferArgs = {
  clubSlug: Scalars['String']['input'];
  offerId: Scalars['UUID']['input'];
};


export type QueryClubOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clubId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClubsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindGeoFencesArgs = {
  locationArgs: UserLocationArgsInput;
  otp?: InputMaybe<Scalars['String']['input']>;
  pageSize?: Scalars['Int']['input'];
};


export type QueryMyOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  criteria?: InputMaybe<SearchMyOfferCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pageArgs: PageArgsInput;
};


export type QuerySearchClubsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};


export type QuerySearchOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  criteria?: InputMaybe<SearchOfferCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pageArgs: PageArgsInput;
};


export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUserNameAvailableArgs = {
  userName: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryInviteResult = {
  __typename?: 'QueryInviteResult';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  actions: Array<AcceptInviteResultAction>;
  additionalProperties: Array<KeyValuePairOfStringAndString>;
  assignedUser?: Maybe<User>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  isDeclined: Scalars['Boolean']['output'];
  isInviteUsed: Scalars['Boolean']['output'];
  isInvited: Scalars['Boolean']['output'];
  /** A private ticket invite for someone else: show that the link can't be shared and won't work */
  isPrivateToAnotherPerson: Scalars['Boolean']['output'];
  isUsedByMe: Scalars['Boolean']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** The private ticket or pass a shared link offers, for a signed-out visitor to preview before signing up. Null for a signed-in caller, a named invite, or an event that turned off the public page preview. */
  sharedTicket?: Maybe<EventTicket>;
  validInvitesRemaining: Scalars['Int']['output'];
};

export type QueryPublicUser = {
  __typename?: 'QueryPublicUser';
  /** Get email subscriptions */
  emailSubscriptions?: Maybe<Array<EmailSubscription>>;
};

export type QuestionRequirement = {
  __typename?: 'QuestionRequirement';
  isRequired: Scalars['Boolean']['output'];
  optInSpecificTicketTypes: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
  /** @deprecated use ticketTypeIds / optInSpecificTicketTypes instead */
  showPrivateTickets?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use ticketTypeIds / optInSpecificTicketTypes instead */
  showPublicTickets?: Maybe<Scalars['Boolean']['output']>;
  ticketTypeIds?: Maybe<Array<Scalars['UUID']['output']>>;
};

export type QuestionRequirementAnswer = {
  __typename?: 'QuestionRequirementAnswer';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type QuestionRequirementAnswerInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type QuestionRequirementInput = {
  isRequired: Scalars['Boolean']['input'];
  optInSpecificTicketTypes: Scalars['Boolean']['input'];
  question: Scalars['String']['input'];
  ticketTypeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type RearmReminderResult = {
  __typename?: 'RearmReminderResult';
  after?: Maybe<EndedReminderInfo>;
  before: EndedReminderInfo;
  eventId: Scalars['UUID']['output'];
};

export type RearmRemindersReport = {
  __typename?: 'RearmRemindersReport';
  dryRun: Scalars['Boolean']['output'];
  events: Array<RearmReminderResult>;
  seriesId: Scalars['UUID']['output'];
};

export type RecurringEventInfoArgsInput = {
  dayOfMonths?: InputMaybe<Array<Scalars['Int']['input']>>;
  dayOfWeeks?: InputMaybe<Array<DayOfWeek>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  frequencyInterval: Scalars['Int']['input'];
  frequencyType: FrequencyType;
  occurrences?: InputMaybe<Scalars['Int']['input']>;
  seqNoDayOfWeeks?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RedeemInviteLinkArgsInput = {
  generateQrCode: Scalars['Boolean']['input'];
  inviteLink: Scalars['String']['input'];
};

export type RedeemLocationInfoArgsInput = {
  address: AddressModelInput;
  generateQrCode: Scalars['Boolean']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type RedeemOfferResult = {
  __typename?: 'RedeemOfferResult';
  club?: Maybe<ClubState>;
  isValid: Scalars['Boolean']['output'];
  offer?: Maybe<ClubOfferState>;
  redeemedCount: Scalars['Int']['output'];
  redemption?: Maybe<RewardRedemptionGqlType>;
  rejectionReason: RewardOfferRedemptionRejectionReason;
};

export type RedeemPromoCodeArgsInput = {
  generateQrCode: Scalars['Boolean']['input'];
  promoCode: Scalars['String']['input'];
};

export type RedeemQrCodeArgsInput = {
  qrCode: Scalars['String']['input'];
};

export enum RedeemType {
  InviteLink = 'INVITE_LINK',
  LocationInfo = 'LOCATION_INFO',
  PromoCode = 'PROMO_CODE',
  QrCode = 'QR_CODE',
  UserContactInfo = 'USER_CONTACT_INFO'
}

export type RedeemUserContactInfoArgsInput = {
  applyAddress: Scalars['Boolean']['input'];
  applyEmail: Scalars['Boolean']['input'];
  applyName: Scalars['Boolean']['input'];
  applyPhoneNumber: Scalars['Boolean']['input'];
  applySocialMediaAccount: Scalars['Boolean']['input'];
  applyUserName: Scalars['Boolean']['input'];
  generateQrCode: Scalars['Boolean']['input'];
  socialMediaAccounts?: InputMaybe<Array<SocialMediaAccountInput>>;
};

export type ReferralConversionModel = {
  __typename?: 'ReferralConversionModel';
  milestone: ReferralMilestone;
  occurredAt: Scalars['DateTime']['output'];
  referredUserId?: Maybe<Scalars['UUID']['output']>;
};

export enum ReferralMilestone {
  AccountCreated = 'ACCOUNT_CREATED',
  PageView = 'PAGE_VIEW',
  TicketObtained = 'TICKET_OBTAINED'
}

export type ReferralMutationApi = {
  __typename?: 'ReferralMutationApi';
  /** Get or generate the stable referral link token for an event. Reuse the same token on repeated calls. */
  getLink: Scalars['String']['output'];
  /** Record a page view milestone for a referral link. Pass anonymousSessionId for unauthenticated visitors; authenticated callers use their user identity automatically. */
  recordPageView: Scalars['Boolean']['output'];
  /** Record account creation milestone for the authenticated user who signed up via a referral link. */
  recordSignup: Scalars['Boolean']['output'];
};


export type ReferralMutationApiGetLinkArgs = {
  eventId: Scalars['UUID']['input'];
};


export type ReferralMutationApiRecordPageViewArgs = {
  anonymousSessionId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type ReferralMutationApiRecordSignupArgs = {
  token: Scalars['String']['input'];
};

export type ReferralQueryApi = {
  __typename?: 'ReferralQueryApi';
  /** List all recorded referral conversions for the authenticated user's referral link for an event. */
  conversions: Array<ReferralConversionModel>;
};


export type ReferralQueryApiConversionsArgs = {
  eventId: Scalars['UUID']['input'];
};

export type RegisterDeviceArgsInput = {
  deviceId: Scalars['String']['input'];
  deviceName?: InputMaybe<Scalars['String']['input']>;
  platform: DevicePlatform;
  pushNotificationToken: Scalars['String']['input'];
};

export type RepBetsShortUrlArgsInput = {
  description: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type RepPointsByClubCondition = {
  __typename?: 'RepPointsByClubCondition';
  club?: Maybe<ClubState>;
  repPoints: Scalars['Decimal']['output'];
};

export type RepPointsByClubConditionPayloadInput = {
  clubId: Scalars['UUID']['input'];
  repPoints: Scalars['Decimal']['input'];
};

export type RepPointsConditionPayloadInput = {
  repPointsByClubConditions?: InputMaybe<Array<RepPointsByClubConditionPayloadInput>>;
};

export type RepPointsPayloadInput = {
  repPoints?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RepPointsRewardCondition = {
  __typename?: 'RepPointsRewardCondition';
  repPointsByClub: Array<Maybe<RepPointsByClubCondition>>;
  type: RewardConditionType;
};

export type RepPointsRewardRedemptionMethod = {
  __typename?: 'RepPointsRewardRedemptionMethod';
  redemptionMethodType: RewardRedemptionMethodType;
  repPoints?: Maybe<Scalars['Decimal']['output']>;
};

export type RepScoreConditionPayloadInput = {
  repScore: Scalars['Decimal']['input'];
};

export type RepScoreRewardCondition = {
  __typename?: 'RepScoreRewardCondition';
  repScore: Scalars['Decimal']['output'];
  type: RewardConditionType;
};

export type ReportUserGeoFenceArgsInput = {
  notify: Scalars['Boolean']['input'];
  otp?: InputMaybe<Scalars['String']['input']>;
  rewardId: Scalars['UUID']['input'];
  trackingTime: Scalars['DateTime']['input'];
};

export type RequestedPayoutResult = {
  __typename?: 'RequestedPayoutResult';
  canRequestPayout: Scalars['Boolean']['output'];
  lastRequestedTime?: Maybe<Scalars['DateTime']['output']>;
  paidAmount?: Maybe<Scalars['Decimal']['output']>;
  totalAmount: Scalars['Decimal']['output'];
  totalBalance: Scalars['Decimal']['output'];
  totalReleasedAmount: Scalars['Decimal']['output'];
};

export type RequireSocialMediaToEarnBonusSetting = {
  __typename?: 'RequireSocialMediaToEarnBonusSetting';
  enabled: Scalars['Boolean']['output'];
  settingType: RewardSettingType;
  socialMediaAccountBonusSetting: SocialMediaAccountBonusSetting;
};

export type RequireSocialMediaToEarnBonusSettingPayloadInput = {
  enabled: Scalars['Boolean']['input'];
  socialMediaAccountBonusSetting: SocialMediaAccountBonusSettingPayloadInput;
};

export type ResendInvitationResult = {
  __typename?: 'ResendInvitationResult';
  giftTickets?: Maybe<GiftTicketsArgs>;
  invitationMessage?: Maybe<Scalars['String']['output']>;
  isViaSms: Scalars['Boolean']['output'];
  privateTickets?: Maybe<PrivateTicketsArgs>;
  resentAt: Scalars['DateTime']['output'];
  smsMessage?: Maybe<Scalars['String']['output']>;
};

export type RestampReport = {
  __typename?: 'RestampReport';
  after?: Maybe<SeriesAdditionalGuestOverview>;
  before: SeriesAdditionalGuestOverview;
  dryRun: Scalars['Boolean']['output'];
  result: AdditionalGuestRestampResult;
  seriesId: Scalars['UUID']['output'];
};

export enum RevokeInviteResult {
  NotAssociatedWithUser = 'NOT_ASSOCIATED_WITH_USER',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type Reward = ILimitedRewardModel & {
  __typename?: 'Reward';
  /** A list of achievement badge conditions to participate a reward */
  achievementBadgeConditions?: Maybe<StoredAchievementBadgeConditionPageX>;
  /** List rewards achievements */
  achievements?: Maybe<AchievementGrainPageX>;
  /** Activated user age range statistic */
  activatedUserAgeRangeStatistic?: Maybe<ActivatedUserAgeRangeStatistic>;
  /** Age limit */
  ageLimit?: Maybe<Scalars['Int']['output']>;
  /** Avatar url of reward */
  avatarUrl: Scalars['String']['output'];
  /** Bio of reward */
  bio?: Maybe<Scalars['String']['output']>;
  /** List rewards bonus achievements */
  bonusAchievements?: Maybe<AchievementGrainPageX>;
  /** Can share by participants */
  canShareByParticipants: Scalars['Boolean']['output'];
  /** Category of reward */
  category?: Maybe<RewardCategory>;
  /** Created date of reward */
  createdUtc: Scalars['DateTime']['output'];
  /** Display name of reward */
  displayName: Scalars['String']['output'];
  /** End date */
  endDate: Scalars['DateTime']['output'];
  /**
   * Expired date of reward
   * @deprecated Use expiresAt instead
   */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Expire date of reward */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Geo Range Condition */
  geoRangeCondition?: Maybe<RewardGeoRangeCondition>;
  /** Individual api url of reward */
  individualApiUrl: Scalars['String']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Represents if the reward is expired or not */
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  /** Is hidden of reward */
  isHidden: Scalars['Boolean']['output'];
  /** Represents if the reward is started or not */
  isStarted?: Maybe<Scalars['Boolean']['output']>;
  /** List of all policy info in this reward */
  listPolicyInfo?: Maybe<RewardPolicyInfoPageX>;
  /** Policy reaction list of all users to this reward */
  listPolicyReaction?: Maybe<RewardPolicyReactionInfoPageX>;
  /** Maximum number of winners */
  maxWinners?: Maybe<Scalars['Int']['output']>;
  /** Must own amount of slices */
  mustOwnSlicesAmount?: Maybe<Scalars['Decimal']['output']>;
  /** Must own amount of slices end date */
  mustOwnSlicesEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Must own slices from another pie */
  mustOwnSlicesFromPieId?: Maybe<Scalars['UUID']['output']>;
  /** Must own amount of slices start date */
  mustOwnSlicesStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** Need new slices */
  needNewSlices: Scalars['Boolean']['output'];
  /** Redeem Notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Opt-in privacy policy for participants */
  optInParticipantPrivacyPolicy: Scalars['Boolean']['output'];
  /** A list of own slices conditions to participate a reward */
  ownSlicesConditions?: Maybe<StoredOwnSlicesConditionPageX>;
  /** Privacy policy for participants content */
  participantPrivacyPolicyContent?: Maybe<Scalars['String']['output']>;
  /** Title for privacy policy for participants */
  participantPrivacyPolicyTitle?: Maybe<Scalars['String']['output']>;
  /** List participants of reward */
  participants?: Maybe<Array<Maybe<RewardParticipant>>>;
  /** Pie of reward */
  pie?: Maybe<CompletePieWithBalance>;
  /** Privacy policy file path */
  policyFileUrl?: Maybe<Scalars['String']['output']>;
  /** Information of reaction status of current user to this reward policy */
  policyReaction?: Maybe<StoredUserReactionRewardPolicy>;
  /** Redeem Code */
  redeemCode?: Maybe<Scalars['String']['output']>;
  /** How to redeem */
  redeemDescription?: Maybe<Scalars['String']['output']>;
  /** Redeem type */
  redeemType?: Maybe<RedeemType>;
  /** Require all achievements for activation */
  requireAllAchievements: Scalars['Boolean']['output'];
  /** Id of reward */
  rewardId: Scalars['UUID']['output'];
  /**
   * List activated users of reward
   * @deprecated Use rewardUsers2 instead
   */
  rewardUsers?: Maybe<UserRewardOffsetPage>;
  /** List activated users of reward */
  rewardUsers2?: Maybe<UserRewardPageX>;
  /** Slug of reward */
  slug: Scalars['String']['output'];
  /** Start date */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Status of reward */
  status: RewardStatus;
  /** A list of my tickets associated with this reward */
  tickets?: Maybe<UserTicketPageX>;
  /** The total user amount has claimed the reward */
  totalActivatedUserAmount?: Maybe<Scalars['Int']['output']>;
  /** Total count of participants of reward */
  totalParticipants?: Maybe<Scalars['Int']['output']>;
  /** Total count of users claimed the reward */
  totalUnlockedUser?: Maybe<Scalars['Int']['output']>;
  /** Type of reward */
  type: RewardType;
  /** Id of selected uploaded asset */
  uploadedAssetId?: Maybe<Scalars['UUID']['output']>;
  /** Information of participation status of current user */
  userRewardInfo?: Maybe<UserReward>;
  /** Winners are chosen */
  winnersChosenOption?: Maybe<WinnersChosenOption>;
  /** A list of winning boosts of a reward */
  winningBoosts?: Maybe<StoredWinningBoostPageX>;
};


export type RewardAchievementBadgeConditionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RewardAchievementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RewardActivatedUserAgeRangeStatisticArgs = {
  participateStates?: InputMaybe<Array<ParticipateState>>;
};


export type RewardBonusAchievementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RewardListPolicyInfoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RewardListPolicyReactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RewardOwnSlicesConditionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RewardParticipantsArgs = {
  participateStates?: InputMaybe<Array<ParticipateState>>;
};


export type RewardRewardUsersArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  participateStates?: InputMaybe<Array<ParticipateState>>;
  sortingOrder?: InputMaybe<PageSortOrder>;
  sortingType?: InputMaybe<RewardSortingType>;
};


export type RewardRewardUsers2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  participateStates?: InputMaybe<Array<ParticipateState>>;
  sortingOrder?: InputMaybe<PageSortOrder>;
  sortingType?: InputMaybe<RewardSortingType>;
};


export type RewardTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RewardTotalParticipantsArgs = {
  participateStates?: InputMaybe<Array<ParticipateState>>;
};


export type RewardWinningBoostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type RewardArgsInput = {
  achievementBadgeConditions?: InputMaybe<Array<AchievementBadgeRewardConditionInput>>;
  achievementIndexes?: InputMaybe<Array<Scalars['Int']['input']>>;
  avatarUrl: Scalars['String']['input'];
  bio?: InputMaybe<Scalars['String']['input']>;
  category: RewardCategory;
  displayName: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  individualApiUrl: Scalars['String']['input'];
  isHidden: Scalars['Boolean']['input'];
  mustOwnSlicesAmount?: InputMaybe<Scalars['Decimal']['input']>;
  mustOwnSlicesConditions?: InputMaybe<Array<OwnSlicesRewardConditionInput>>;
  mustOwnSlicesEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  mustOwnSlicesStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: RewardStatus;
  type: RewardType;
};

export type RewardAvatarType = {
  __typename?: 'RewardAvatarType';
  completeUpload: Scalars['Boolean']['output'];
  /** @deprecated Use mutation UploadedAsset.presignUploadUrl instead */
  presignUploadUrl: Scalars['String']['output'];
};


export type RewardAvatarTypeCompleteUploadArgs = {
  avatarUrl: Scalars['String']['input'];
  rewardId: Scalars['UUID']['input'];
};


export type RewardAvatarTypePresignUploadUrlArgs = {
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
};

export enum RewardCategory {
  AccessPass = 'ACCESS_PASS',
  Community = 'COMMUNITY',
  Coupon = 'COUPON',
  ExclusiveContent = 'EXCLUSIVE_CONTENT',
  Invite = 'INVITE',
  MeetUp = 'MEET_UP',
  MerchandiseGiveAWay = 'MERCHANDISE_GIVE_A_WAY',
  Other = 'OTHER',
  Race = 'RACE',
  Raffle = 'RAFFLE',
  VipPass = 'VIP_PASS'
}

export type RewardConditionGqlType = AchievementsRewardCondition | LoyaltyTierRewardCondition | PriceRewardCondition | RepPointsRewardCondition | RepScoreRewardCondition;

export type RewardConditionPayloadInput = {
  achievements?: InputMaybe<AchievementsConditionPayloadInput>;
  loyaltyTier?: InputMaybe<LoyaltyTierConditionPayloadInput>;
  price?: InputMaybe<PriceConditionPayloadInput>;
  repPoints?: InputMaybe<RepPointsConditionPayloadInput>;
  repScore?: InputMaybe<RepScoreConditionPayloadInput>;
};

export enum RewardConditionType {
  Achievements = 'ACHIEVEMENTS',
  LoyaltyTier = 'LOYALTY_TIER',
  Price = 'PRICE',
  RepPoints = 'REP_POINTS',
  RepScore = 'REP_SCORE',
  Unknown = 'UNKNOWN'
}

export type RewardConstraintPayloadInput = {
  age?: InputMaybe<AgeConstraintPayloadInput>;
  timeFrame?: InputMaybe<TimeFrameConstraintPayloadInput>;
};

export type RewardEdgeX = {
  __typename?: 'RewardEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Reward>;
};

export type RewardGeoRangeCondition = {
  __typename?: 'RewardGeoRangeCondition';
  address?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  locationUnitLengthType: LocationUnitLengthType;
  longitude: Scalars['Float']['output'];
  radius: Scalars['Float']['output'];
};

export type RewardGeoRangeConditionArgInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  latitude: Scalars['Float']['input'];
  locationUnitLengthType: LocationUnitLengthType;
  longitude: Scalars['Float']['input'];
  radius: Scalars['Float']['input'];
};

/** Represents a slice or page */
export type RewardGrainPageX = {
  __typename?: 'RewardGrainPageX';
  /** A list of edges */
  edges: Array<RewardEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<Reward>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export enum RewardLaunchStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  None = 'NONE'
}

export type RewardMutationApi = {
  __typename?: 'RewardMutationApi';
  /** Award reward */
  award: Scalars['Boolean']['output'];
  /** Confirm Participant Privacy Policy */
  confirmParticipantPrivacyPolicy: Scalars['Boolean']['output'];
  /** PLACEHOLDER: Trade or update a reward */
  createOrUpdate: PublicRewardModel;
  /** Delete reward */
  delete: Scalars['Boolean']['output'];
  /** Disable reward */
  disable: Scalars['Boolean']['output'];
  /** Enable reward */
  enable: Scalars['Boolean']['output'];
  /** Generate reward winners */
  generateWinners: Scalars['Boolean']['output'];
  /** Migrate invalid awarded users */
  migrateInvalidAwardedUsers?: Maybe<Array<Maybe<ActiveRewardUserType>>>;
  /** Opt out reward */
  optOut: Scalars['Boolean']['output'];
  /** Recover reward */
  recover: Scalars['Boolean']['output'];
  rewardAvatar: RewardAvatarType;
  /** Save winner shared address */
  saveWinnerSharedAddress: Scalars['Boolean']['output'];
  /** PLACEHOLDER: Send redeem code */
  sendSmsRedeemCode: Scalars['Boolean']['output'];
  /** PLACEHOLDER: Set achievements to reward */
  setAchievements: PublicRewardModel;
  /** PLACEHOLDER: Set bonus achievements to reward */
  setBonusAchievements: PublicRewardModel;
  /** Set Process Expired Reward Reminder */
  setProcessExpiredRewardReminder: Scalars['Boolean']['output'];
  /** Get test ticket */
  ticketGetTestTicket: TicketGrantResult;
  /** Get test ticket v2 */
  ticketGetTestTicket2: TicketGrantResult;
  /** Grant new ticket */
  ticketGrant: TicketGrantResult;
  /** Revoke existing ticket */
  ticketRevoke?: Maybe<Scalars['Boolean']['output']>;
  /** Verify Ticket */
  ticketVerify?: Maybe<TicketVerifyResult>;
};


export type RewardMutationApiAwardArgs = {
  rewardId: Scalars['UUID']['input'];
  userName: Scalars['String']['input'];
};


export type RewardMutationApiConfirmParticipantPrivacyPolicyArgs = {
  participantPrivacyPolicyState: ParticipantPrivacyPolicyState;
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiCreateOrUpdateArgs = {
  achievementBadgeConditions: Array<AchievementBadgeConditionArgsInput>;
  adminUpdate?: Scalars['Boolean']['input'];
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  avatarUrl: Scalars['String']['input'];
  bio: Scalars['String']['input'];
  canShareByParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  category: RewardCategory;
  displayName: Scalars['String']['input'];
  doRewardToUser?: Scalars['Boolean']['input'];
  endDate: Scalars['DateTime']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  individualApiUrl: Scalars['String']['input'];
  isPrivate?: Scalars['Boolean']['input'];
  maxWinners?: InputMaybe<Scalars['Int']['input']>;
  needNewSlices?: InputMaybe<Scalars['Boolean']['input']>;
  notes: Scalars['String']['input'];
  optInParticipantPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  ownSlicesConditions: Array<OwnSlicesConditionArgsInput>;
  participantPrivacyPolicyContent?: InputMaybe<Scalars['String']['input']>;
  participantPrivacyPolicyTitle?: InputMaybe<Scalars['String']['input']>;
  pieId: Scalars['UUID']['input'];
  policyFileUrl?: InputMaybe<Scalars['String']['input']>;
  redeemCode: Scalars['String']['input'];
  redeemDescription: Scalars['String']['input'];
  redeemInviteLinkArgs?: InputMaybe<RedeemInviteLinkArgsInput>;
  redeemLocationInfoArgs?: InputMaybe<RedeemLocationInfoArgsInput>;
  redeemPromoCodeArgs?: InputMaybe<RedeemPromoCodeArgsInput>;
  redeemQRCodeArgs?: InputMaybe<RedeemQrCodeArgsInput>;
  redeemType?: InputMaybe<RedeemType>;
  redeemUserContactInfoArgs?: InputMaybe<RedeemUserContactInfoArgsInput>;
  requireAllAchievements?: Scalars['Boolean']['input'];
  rewardGeoRangeConditionArg?: InputMaybe<RewardGeoRangeConditionArgInput>;
  slug: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: RewardStatus;
  type: RewardType;
  uploadedAssetId?: InputMaybe<Scalars['UUID']['input']>;
  winnersChosenOption?: InputMaybe<WinnersChosenOption>;
  winningBoosts?: InputMaybe<Array<WinningBoostArgsInput>>;
};


export type RewardMutationApiDeleteArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiDisableArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiEnableArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiGenerateWinnersArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiMigrateInvalidAwardedUsersArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiOptOutArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiRecoverArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiSaveWinnerSharedAddressArgs = {
  rewardId: Scalars['UUID']['input'];
  sharedAddress?: InputMaybe<AddressModelInput>;
  sharedEmailAddress?: InputMaybe<Scalars['String']['input']>;
  sharedName?: InputMaybe<Scalars['String']['input']>;
  sharedPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  socialMediaAccounts?: InputMaybe<Array<SocialMediaAccountInput>>;
};


export type RewardMutationApiSendSmsRedeemCodeArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiSetAchievementsArgs = {
  achievementIds: Array<Scalars['UUID']['input']>;
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiSetBonusAchievementsArgs = {
  achievementIds: Array<Scalars['UUID']['input']>;
  adminUpdate?: Scalars['Boolean']['input'];
  doRewardToUser?: Scalars['Boolean']['input'];
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiSetProcessExpiredRewardReminderArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiTicketGetTestTicketArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiTicketGrantArgs = {
  associatedUserId?: InputMaybe<Scalars['UUID']['input']>;
  rewardId: Scalars['UUID']['input'];
};


export type RewardMutationApiTicketRevokeArgs = {
  rewardId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
};


export type RewardMutationApiTicketVerifyArgs = {
  rewardId: Scalars['UUID']['input'];
  ticketId: Scalars['String']['input'];
};

export type RewardOfferFlow = {
  __typename?: 'RewardOfferFlow';
  state?: Maybe<RewardState>;
};

export type RewardOfferFlowPayloadInput = {
  avatarUrl: Scalars['String']['input'];
  bonusRewards?: InputMaybe<Array<BonusRewardPayloadInput>>;
  conditions: Array<RewardConditionPayloadInput>;
  constraints: Array<RewardConstraintPayloadInput>;
  coverUrl: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  redemption?: InputMaybe<RewardRedemptionPayloadInput>;
  redemptionMethod?: InputMaybe<RewardRedemptionMethodPayloadInput>;
  settings?: InputMaybe<RewardSettingsPayloadInput>;
  type: OfferRewardType;
};

export enum RewardOfferRedemptionRejectionReason {
  Expired = 'EXPIRED',
  None = 'NONE',
  NotEligible = 'NOT_ELIGIBLE',
  Other = 'OTHER'
}

/** Represents a slice or page of Reward */
export type RewardOffsetPage = {
  __typename?: 'RewardOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<Reward>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type RewardParticipant = {
  __typename?: 'RewardParticipant';
  achievementEarned: Scalars['String']['output'];
  ageRange: Scalars['String']['output'];
  /** Date used */
  dateUsed?: Maybe<Scalars['String']['output']>;
  gender: Scalars['String']['output'];
  isWinner: Scalars['String']['output'];
  location: Scalars['String']['output'];
  rewardId: Scalars['UUID']['output'];
  rewardUserId: Scalars['UUID']['output'];
  slicePurchaseDate: Scalars['String']['output'];
  unlockDate: Scalars['String']['output'];
  /** user */
  user?: Maybe<RewardParticipantUser>;
  userId: Scalars['String']['output'];
};

export type RewardParticipantUser = {
  __typename?: 'RewardParticipantUser';
  ageRange: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  location: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type RewardParticipateIndexDocument = {
  __typename?: 'RewardParticipateIndexDocument';
  ageLimit?: Maybe<Scalars['Int']['output']>;
  avatarUrl: Scalars['String']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  canShareByParticipants: Scalars['Boolean']['output'];
  category?: Maybe<RewardCategory>;
  createdUtc: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use ExpiresAt instead */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  maxWinners?: Maybe<Scalars['Int']['output']>;
  mustOwnSlicesAmount?: Maybe<Scalars['Decimal']['output']>;
  mustOwnSlicesEndDate?: Maybe<Scalars['DateTime']['output']>;
  mustOwnSlicesFromPieId?: Maybe<Scalars['UUID']['output']>;
  mustOwnSlicesStartDate?: Maybe<Scalars['DateTime']['output']>;
  needNewSlices: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  optInParticipantPrivacyPolicy: Scalars['Boolean']['output'];
  participantPrivacyPolicyContent?: Maybe<Scalars['String']['output']>;
  participateCreatedUtc: Scalars['DateTime']['output'];
  participateReason: ParticipateReason;
  participateState: ParticipateState;
  pie: PieIndexDocument;
  redeemCode?: Maybe<Scalars['String']['output']>;
  redeemDescription?: Maybe<Scalars['String']['output']>;
  redeemType?: Maybe<RedeemType>;
  rewardId: Scalars['UUID']['output'];
  /** Reward Slug */
  slug?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: RewardStatus;
  totalActivatedUserAmount?: Maybe<Scalars['Int']['output']>;
  totalActiveUsers: Scalars['Int']['output'];
  totalUnlockUsers: Scalars['Int']['output'];
  type: RewardType;
  winnersChosenOption?: Maybe<WinnersChosenOption>;
};

/** Represents a slice or page of RewardParticipateIndexDocument */
export type RewardParticipateIndexDocumentOffsetPage = {
  __typename?: 'RewardParticipateIndexDocumentOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<RewardParticipateIndexDocument>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type RewardPolicyInfo = {
  __typename?: 'RewardPolicyInfo';
  policyInfo: StoredRewardPolicyInfo;
};

export type RewardPolicyInfoEdgeX = {
  __typename?: 'RewardPolicyInfoEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<RewardPolicyInfo>;
};

/** Represents a slice or page */
export type RewardPolicyInfoPageX = {
  __typename?: 'RewardPolicyInfoPageX';
  /** A list of edges */
  edges: Array<RewardPolicyInfoEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<RewardPolicyInfo>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export enum RewardPolicyReaction {
  Agree = 'AGREE',
  Disagree = 'DISAGREE',
  None = 'NONE'
}

export type RewardPolicyReactionInfo = {
  __typename?: 'RewardPolicyReactionInfo';
  reactionInfo: StoredUserReactionRewardPolicy;
  userInfo?: Maybe<User>;
};

export type RewardPolicyReactionInfoEdgeX = {
  __typename?: 'RewardPolicyReactionInfoEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<RewardPolicyReactionInfo>;
};

/** Represents a slice or page */
export type RewardPolicyReactionInfoPageX = {
  __typename?: 'RewardPolicyReactionInfoPageX';
  /** A list of edges */
  edges: Array<RewardPolicyReactionInfoEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<RewardPolicyReactionInfo>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type RewardQueryApi = {
  __typename?: 'RewardQueryApi';
  byId?: Maybe<Reward>;
  bySlugOrId?: Maybe<Reward>;
  getHighestSlicesOfParticipateRewards?: Maybe<HighestSlicesOfParticipateRewards>;
  getHighestSlicesOfParticipatingRewards: Scalars['Decimal']['output'];
  getNeededSlices?: Maybe<Array<Maybe<NeededSlicesPerPie>>>;
  /** @deprecated Use listByPieId2 */
  listByPieId?: Maybe<RewardStatistic>;
  listByPieId2?: Maybe<RewardStatisticV2>;
  nameAvailable: Scalars['Boolean']['output'];
  nameAvailable2: AvailableCheckingResult;
  /** @deprecated Use rewardsPieGroupList2 */
  rewardsPieGroupList: Array<PieIndexDocument>;
  rewardsPieGroupList2?: Maybe<Array<CompletePieWithBalance>>;
  /** @deprecated Use search2 */
  search?: Maybe<RewardParticipateIndexDocumentOffsetPage>;
  search2?: Maybe<RewardGrainPageX>;
  slugAvailable: Scalars['Boolean']['output'];
  slugAvailable2: AvailableCheckingResult;
  /** @deprecated Use statistic2 */
  statistic?: Maybe<RewardStatistic>;
  statistic2?: Maybe<RewardStatisticV2>;
};


export type RewardQueryApiByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type RewardQueryApiBySlugOrIdArgs = {
  pieSlugOrId: Scalars['String']['input'];
  rewardSlugOrId: Scalars['String']['input'];
};


export type RewardQueryApiGetHighestSlicesOfParticipateRewardsArgs = {
  pieId: Scalars['UUID']['input'];
};


export type RewardQueryApiGetHighestSlicesOfParticipatingRewardsArgs = {
  pieId: Scalars['UUID']['input'];
};


export type RewardQueryApiGetNeededSlicesArgs = {
  rewardId: Scalars['UUID']['input'];
};


export type RewardQueryApiListByPieIdArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  pieId: Scalars['UUID']['input'];
  rewardLaunchStatus?: RewardLaunchStatus;
  sortingOrder?: PageSortOrder;
  sortingType?: RewardSortType;
  status?: RewardStatus;
};


export type RewardQueryApiListByPieId2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pieId: Scalars['UUID']['input'];
  rewardLaunchStatus?: RewardLaunchStatus;
  sortingOrder?: PageSortOrder;
  sortingType?: RewardSortType;
  status?: RewardStatus;
};


export type RewardQueryApiNameAvailableArgs = {
  name: Scalars['String']['input'];
  pieId: Scalars['UUID']['input'];
};


export type RewardQueryApiNameAvailable2Args = {
  name: Scalars['String']['input'];
  pieId: Scalars['UUID']['input'];
};


export type RewardQueryApiRewardsPieGroupListArgs = {
  type?: InputMaybe<RewardType>;
};


export type RewardQueryApiRewardsPieGroupList2Args = {
  type?: InputMaybe<RewardType>;
};


export type RewardQueryApiSearchArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  participateReason?: InputMaybe<ParticipateReason>;
  participateState?: InputMaybe<ParticipateState>;
  pieIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sortingOrder?: PageSortOrder;
  sortingType?: UserRewardSortType;
};


export type RewardQueryApiSearch2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  participateReason?: InputMaybe<ParticipateReason>;
  participateState?: InputMaybe<ParticipateState>;
  pieIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sortingOrder?: PageSortOrder;
  sortingType?: UserRewardSortType;
};


export type RewardQueryApiSlugAvailableArgs = {
  pieId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
};


export type RewardQueryApiSlugAvailable2Args = {
  pieId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
};


export type RewardQueryApiStatisticArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  pieIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sortingType?: PageSortOrder;
  type?: InputMaybe<RewardType>;
};


export type RewardQueryApiStatistic2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  pieIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sortingType?: PageSortOrder;
  type?: InputMaybe<RewardType>;
};

export type RewardRedemptionGqlType = AccessPassRewardRedemption | CustomerInformationRewardRedemption | InviteLinkRewardRedemption | LocationInformationRewardRedemption | PromoCodeRewardRedemption;

export type RewardRedemptionMethodGqlType = NoneRewardRedemptionMethod | PriceRewardRedemptionMethod | RepPointsRewardRedemptionMethod;

export type RewardRedemptionMethodPayloadInput = {
  price?: InputMaybe<PricePayloadInput>;
  repPoints?: InputMaybe<RepPointsPayloadInput>;
};

export enum RewardRedemptionMethodType {
  None = 'NONE',
  Price = 'PRICE',
  RepPoints = 'REP_POINTS',
  Unknown = 'UNKNOWN'
}

export type RewardRedemptionPayloadInput = {
  accessPass?: InputMaybe<AccessPassPayloadInput>;
  customerInformation?: InputMaybe<CustomerInformationPayloadInput>;
  inviteLink?: InputMaybe<InviteLinkPayloadInput>;
  locationInformation?: InputMaybe<LocationInformationPayloadInput>;
  promoCode?: InputMaybe<PromoCodePayloadInput>;
};

export enum RewardRedemptionType {
  AccessPass = 'ACCESS_PASS',
  CustomerInformation = 'CUSTOMER_INFORMATION',
  InviteLink = 'INVITE_LINK',
  LocationInformation = 'LOCATION_INFORMATION',
  PromoCode = 'PROMO_CODE',
  Unknown = 'UNKNOWN'
}

export type RewardSettingGqlType = CanShareSetting | LocationRadiusSetting | OptInPrivacyPolicySetting | OptInPublicPagePreviewSetting | RequireSocialMediaToEarnBonusSetting;

export enum RewardSettingType {
  CanShare = 'CAN_SHARE',
  LocationRadius = 'LOCATION_RADIUS',
  OptInPrivacyPolicy = 'OPT_IN_PRIVACY_POLICY',
  OptInPublicPagePreview = 'OPT_IN_PUBLIC_PAGE_PREVIEW',
  RequireSocialMediaToEarnBonus = 'REQUIRE_SOCIAL_MEDIA_TO_EARN_BONUS',
  Unknown = 'UNKNOWN'
}

export type RewardSettingsPayloadInput = {
  canShare?: InputMaybe<CanShareSettingPayloadInput>;
  locationRadius?: InputMaybe<LocationRadiusSettingPayloadInput>;
  optInPrivacyPolicy?: InputMaybe<OptInPrivacyPolicySettingPayloadInput>;
  optInPublicPagePreview?: InputMaybe<OptInPublicPagePreviewSettingPayloadInput>;
  requireSocialMediaToEarnBonus?: InputMaybe<RequireSocialMediaToEarnBonusSettingPayloadInput>;
};

export enum RewardSortType {
  CreatedDate = 'CREATED_DATE'
}

export enum RewardSortingType {
  AgeRange = 'AGE_RANGE',
  Gender = 'GENDER',
  Location = 'LOCATION',
  UnlockDate = 'UNLOCK_DATE'
}

export type RewardState = {
  __typename?: 'RewardState';
  ageConstraint?: Maybe<AgeConstraint>;
  avatarUrl: Scalars['String']['output'];
  bonusRewards: Array<Maybe<BonusRewardContentGqlType>>;
  conditions: Array<Maybe<RewardConditionGqlType>>;
  coverUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  limitedQty: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  redemption?: Maybe<RewardRedemptionGqlType>;
  redemptionMethod?: Maybe<RewardRedemptionMethodGqlType>;
  rewardId: Scalars['UUID']['output'];
  settings: Array<Maybe<RewardSettingGqlType>>;
  timeFrameConstraint?: Maybe<TimeFrameConstraint>;
  type: OfferRewardType;
};

export type RewardStatistic = {
  __typename?: 'RewardStatistic';
  /** List pie rewards */
  rewardList?: Maybe<RewardOffsetPage>;
  totalUnlockRewardAmount: Scalars['Int']['output'];
};

export type RewardStatisticV2 = {
  __typename?: 'RewardStatisticV2';
  /** List pie rewards */
  rewardList?: Maybe<RewardGrainPageX>;
  totalUnlockRewardAmount: Scalars['Int']['output'];
};

export enum RewardStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  None = 'NONE'
}

export enum RewardTimeFrameType {
  Draw = 'DRAW',
  Promotion = 'PROMOTION',
  Unknown = 'UNKNOWN'
}

export enum RewardType {
  Digital = 'DIGITAL',
  Physical = 'PHYSICAL'
}

export type RewardTypeOperationFilterInput = {
  eq?: InputMaybe<RewardType>;
  in?: InputMaybe<Array<RewardType>>;
  neq?: InputMaybe<RewardType>;
  nin?: InputMaybe<Array<RewardType>>;
};

export type RewardUserInfoType = {
  __typename?: 'RewardUserInfoType';
  confirmSharedUserInfo?: Maybe<Scalars['Boolean']['output']>;
  createdUtc: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  ordinalWinner?: Maybe<Scalars['Int']['output']>;
  participantPrivacyPolicyState: ParticipantPrivacyPolicyState;
  participateReason: ParticipateReason;
  participateState: ParticipateState;
  sharedAddress?: Maybe<AddressModel>;
  sharedEmailAddress?: Maybe<Scalars['String']['output']>;
  sharedName?: Maybe<Scalars['String']['output']>;
  sharedPhoneNumber?: Maybe<Scalars['String']['output']>;
  socialMediaAccounts?: Maybe<Array<SocialMediaAccount>>;
  totalWinner?: Maybe<Scalars['Int']['output']>;
};

export enum RoleAttendeeSortingField {
  AttendeeRole = 'ATTENDEE_ROLE',
  Name = 'NAME'
}

export type RoleId = {
  __typename?: 'RoleId';
  toGuid: Scalars['UUID']['output'];
};

export type RunResetReport = {
  __typename?: 'RunResetReport';
  after?: Maybe<SeriesAdditionalGuestOverview>;
  batches: Scalars['Int']['output'];
  before: SeriesAdditionalGuestOverview;
  dryRun: Scalars['Boolean']['output'];
  endedEventId: Scalars['UUID']['output'];
  moreRemain: Scalars['Boolean']['output'];
  preview?: Maybe<AdditionalGuestResetPreview>;
  seriesId: Scalars['UUID']['output'];
};

export type SaveGuestListArgsInput = {
  guestListName: Scalars['String']['input'];
  guests: Array<GuestInvitationInfoInput>;
};

export type SavedGuestList = {
  __typename?: 'SavedGuestList';
  guestInvitations: Array<GuestInvitationInfo>;
  lastUpdatedUtc: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
};

export type ScanEntry = {
  __typename?: 'ScanEntry';
  scannedAtUtc: Scalars['DateTime']['output'];
  source: Scalars['String']['output'];
};

export type ScanEvent = {
  __typename?: 'ScanEvent';
  deviceId: Scalars['UUID']['output'];
  scanId: Scalars['String']['output'];
  scannedAt: Scalars['DateTime']['output'];
  ticketId: Scalars['UUID']['output'];
  undone: Scalars['Boolean']['output'];
  zoneId: Scalars['UUID']['output'];
};

export type ScanRecord = {
  __typename?: 'ScanRecord';
  associatedUserId?: Maybe<Scalars['UUID']['output']>;
  attendee?: Maybe<CompleteUser>;
  eventId: Scalars['UUID']['output'];
  eventTicketId: Scalars['UUID']['output'];
  isSeriesPass: Scalars['Boolean']['output'];
  memberEventId?: Maybe<Scalars['UUID']['output']>;
  scanTime: Scalars['DateTime']['output'];
  /** The user who performed this specific scan. Scans recorded before per-scan attribution was tracked fall back to the last known scanner for this ticket in this zone; null only when no scanner was ever recorded. */
  scanner?: Maybe<CompleteUser>;
  ticketId: Scalars['UUID']['output'];
  ticketType?: Maybe<EventTicket>;
  zoneId: Scalars['UUID']['output'];
  zoneName?: Maybe<Scalars['String']['output']>;
};

export type ScanRecordFilterArgsInput = {
  eventTicketIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  memberEventIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  scannedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  zoneIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export enum ScanRecordSortType {
  AttendeeName = 'ATTENDEE_NAME',
  None = 'NONE',
  ScanTime = 'SCAN_TIME',
  TicketType = 'TICKET_TYPE',
  Zone = 'ZONE'
}

export type ScanningZone = {
  __typename?: 'ScanningZone';
  eventTicketIds?: Maybe<Array<Scalars['UUID']['output']>>;
  eventTicketSettings?: Maybe<Array<ScanningZoneEventTicketSetting>>;
  eventTicketTempIds?: Maybe<Array<Scalars['UUID']['output']>>;
  id?: Maybe<Scalars['UUID']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  resetScansDaily?: Maybe<Scalars['Boolean']['output']>;
};

export type ScanningZoneEventTicketSetting = {
  __typename?: 'ScanningZoneEventTicketSetting';
  eventTempTicketId?: Maybe<Scalars['UUID']['output']>;
  eventTicketId?: Maybe<Scalars['UUID']['output']>;
  isUnlimitedScans?: Maybe<Scalars['Boolean']['output']>;
  maxScans?: Maybe<Scalars['Int']['output']>;
};

export type ScanningZoneEventTicketSettingInput = {
  eventTempTicketId?: InputMaybe<Scalars['UUID']['input']>;
  eventTicketId?: InputMaybe<Scalars['UUID']['input']>;
  isUnlimitedScans?: InputMaybe<Scalars['Boolean']['input']>;
  maxScans?: InputMaybe<Scalars['Int']['input']>;
};

export type ScanningZoneInfo = {
  __typename?: 'ScanningZoneInfo';
  id: Scalars['UUID']['output'];
  isUnlimitedScans?: Maybe<Scalars['Boolean']['output']>;
  maxScans?: Maybe<Scalars['Int']['output']>;
  memberEventId?: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  resetScansDaily?: Maybe<Scalars['Boolean']['output']>;
  scanCount: Scalars['Int']['output'];
  scanEntries?: Maybe<Array<ScanEntry>>;
  scanTimes?: Maybe<Array<Scalars['DateTime']['output']>>;
  scannedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  scannedByUserId?: Maybe<Scalars['UUID']['output']>;
  scannedByUserIds?: Maybe<Array<Scalars['UUID']['output']>>;
};

export type ScanningZoneInput = {
  eventTicketIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  eventTicketSettings?: InputMaybe<Array<ScanningZoneEventTicketSettingInput>>;
  eventTicketTempIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  resetScansDaily?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScheduleEventMessageInput = {
  filterArgs?: InputMaybe<EventMessageFilterArgsInput>;
  groupAttendeeStatus?: InputMaybe<SendMessageGroupAttendeeStatus>;
  isViaEmail: Scalars['Boolean']['input'];
  isViaSms: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  sendAt: Scalars['DateTime']['input'];
  smsMessage?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledMessageModel = {
  __typename?: 'ScheduledMessageModel';
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  canceledBy?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['UUID']['output'];
  filterArgs: EventMessageFilterArgs;
  id: Scalars['UUID']['output'];
  isViaEmail: Scalars['Boolean']['output'];
  isViaSms: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  sendAt: Scalars['DateTime']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  smsMessage?: Maybe<Scalars['String']['output']>;
  status: ScheduledMessageStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['UUID']['output']>;
};

export enum ScheduledMessageStatus {
  Canceled = 'CANCELED',
  None = 'NONE',
  Pending = 'PENDING',
  Sent = 'SENT'
}

/** A connection to a list of items. */
export type SearchClubsConnection = {
  __typename?: 'SearchClubsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SearchClubsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ClubInformationCondensed>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SearchClubsEdge = {
  __typename?: 'SearchClubsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClubInformationCondensed>;
};

export type SearchEventCriteriaInput = {
  eventType?: InputMaybe<SearchEventTypeEnum>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  locationDistanceInMiles?: InputMaybe<Scalars['Float']['input']>;
  locationLat?: InputMaybe<Scalars['Float']['input']>;
  locationLong?: InputMaybe<Scalars['Float']['input']>;
  onlyFeatured: Scalars['Boolean']['input'];
  onlyMyEvents: Scalars['Boolean']['input'];
  startDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startDateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SearchEventGuestFilterArgsInput = {
  checkedIn?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  eventTicketIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  hasQrPassEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  hasQrPassTextSent?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SearchEventGuestSortType {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  None = 'NONE'
}

/** A connection to a list of items. */
export type SearchEventGuestsConnection = {
  __typename?: 'SearchEventGuestsConnection';
  checkedInCount?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<SearchEventGuestsEdge>>;
  guestCount?: Maybe<Scalars['Int']['output']>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<EventGuest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SearchEventGuestsEdge = {
  __typename?: 'SearchEventGuestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EventGuest>;
};

export enum SearchEventStatus {
  Active = 'ACTIVE',
  All = 'ALL',
  Past = 'PAST'
}

export enum SearchEventTypeEnum {
  All = 'ALL',
  Open = 'OPEN',
  Private = 'PRIVATE'
}

export type SearchInviteesFilterArgs = {
  deliveryStatuses?: InputMaybe<Array<DeliveryStatus>>;
  inMyContactsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  invitedByUserIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  methodOfEntries?: InputMaybe<Array<MethodOfEntry>>;
  sortField?: InputMaybe<InviteeSortField>;
  sortOrder?: InputMaybe<PageSortOrder>;
  sources?: InputMaybe<Array<InvitationSource>>;
  statuses?: InputMaybe<Array<InvitationStatus>>;
};

export type SearchMyCreatedEventCriteriaInput = {
  eventStatus?: InputMaybe<SearchEventStatus>;
  eventType?: InputMaybe<SearchEventTypeEnum>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  myEventsOnly?: Scalars['Boolean']['input'];
  sortBy?: InputMaybe<MyCreatedEventsSortBy>;
  sortOrder?: InputMaybe<PageSortOrder>;
};

export type SearchMyOfferCriteriaInput = {
  relationshipTypes?: InputMaybe<Array<UserOfferRelationshipType>>;
  searchStatus?: InputMaybe<SearchOfferStatus>;
  sortOrder?: PageSortOrder;
  sortingType?: InputMaybe<UserOfferSortingField>;
  userStatuses?: InputMaybe<Array<OfferUserStatus>>;
};

export type SearchOfferCriteriaInput = {
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  rewardTimeFrameType?: InputMaybe<RewardTimeFrameType>;
  searchStatus?: InputMaybe<SearchOfferStatus>;
  sortOrder: PageSortOrder;
  sortingType?: InputMaybe<OfferSortingField>;
  timePeriod?: InputMaybe<OfferTimePeriod>;
};

export enum SearchOfferStatus {
  Active = 'ACTIVE',
  All = 'ALL',
  Past = 'PAST'
}

/** A connection to a list of items. */
export type SearchOffersConnection = {
  __typename?: 'SearchOffersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SearchOffersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PublicClubOfferState>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SearchOffersEdge = {
  __typename?: 'SearchOffersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PublicClubOfferState>;
};

export type SendHostMessageResult = {
  __typename?: 'SendHostMessageResult';
  messageId: Scalars['UUID']['output'];
  sentAt: Scalars['DateTime']['output'];
  threadId: Scalars['UUID']['output'];
};

export enum SendMessageGroupAttendeeStatus {
  All = 'ALL',
  Approved = 'APPROVED',
  None = 'NONE',
  Pending = 'PENDING'
}

export type SendRecord = {
  __typename?: 'SendRecord';
  acceptanceSource?: Maybe<AttributionChannel>;
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  acceptedDeliveryId?: Maybe<Scalars['UUID']['output']>;
  deliveries?: Maybe<Array<DeliveryAttempt>>;
  formattedInviteId?: Maybe<Scalars['String']['output']>;
  giftTickets?: Maybe<GiftTicketsArgs>;
  invitationMessage?: Maybe<Scalars['String']['output']>;
  lastDeliveryAt?: Maybe<Scalars['DateTime']['output']>;
  legacyFirstViewedAt?: Maybe<Scalars['DateTime']['output']>;
  legacyIsResend: Scalars['Boolean']['output'];
  legacyIsViaSms: Scalars['Boolean']['output'];
  legacyLastViewedAt?: Maybe<Scalars['DateTime']['output']>;
  legacySentAt?: Maybe<Scalars['DateTime']['output']>;
  legacySentByUserId?: Maybe<Scalars['UUID']['output']>;
  legacyViewSource?: Maybe<AttributionChannel>;
  privateTickets?: Maybe<PrivateTicketsArgs>;
  sendId: Scalars['UUID']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentBy?: Maybe<User>;
  smsMessage?: Maybe<Scalars['String']['output']>;
  source: InvitationSource;
  status: InvitationStatus;
};

export type SeriesAdditionalGuestOverview = {
  __typename?: 'SeriesAdditionalGuestOverview';
  activeCount: Scalars['Int']['output'];
  awaitingNextEventCount: Scalars['Int']['output'];
  catchUp: AdditionalGuestCatchUpState;
  currentEventId?: Maybe<Scalars['UUID']['output']>;
  events: Array<MemberEventAdditionalGuestOverview>;
  expiredCount: Scalars['Int']['output'];
  parentEventId: Scalars['UUID']['output'];
  seriesId: Scalars['UUID']['output'];
  ticketTypes: Array<AdditionalGuestTicketTypeInfo>;
  unstampedActiveCount: Scalars['Int']['output'];
};

export type SeriesEntries = {
  __typename?: 'SeriesEntries';
  /** When these numbers were computed */
  asOfUtc?: Maybe<Scalars['DateTime']['output']>;
  /** One row per member event, in the series' member order */
  events: Array<EventEntryStats>;
  /** Pass scan rows recorded under a zone none of the members owns (a retired zone, for example). They belong to no event's numbers and are listed here for audits. */
  unmappedScanRows: Scalars['Int']['output'];
  /** The scans in those rows */
  unmappedScans: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type SeriesEventsConnection = {
  __typename?: 'SeriesEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SeriesEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<FullEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SeriesEventsEdge = {
  __typename?: 'SeriesEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FullEvent>;
};

export enum SeriesEventsSortBy {
  EndDate = 'END_DATE',
  Name = 'NAME',
  StartDate = 'START_DATE'
}

export type SeriesNumbersAudit = {
  __typename?: 'SeriesNumbersAudit';
  /** Every number on which the fast calculation and an independent check disagree. Empty means they agree. */
  differences: Array<SeriesNumbersDifference>;
  eventsChecked: Scalars['Int']['output'];
  /** The series entries as the page gets them */
  fast: SeriesEntries;
};

export type SeriesNumbersDifference = {
  __typename?: 'SeriesNumbersDifference';
  check: Scalars['String']['output'];
  eventId: Scalars['UUID']['output'];
  fast: Scalars['String']['output'];
  field: Scalars['String']['output'];
};

export type SeriesPassAttendeeCounts = {
  __typename?: 'SeriesPassAttendeeCounts';
  /** Pass holders the attendee list shows as approved here, whose own row does not already count them */
  approvedPeople: Scalars['Int']['output'];
  /** Buyers of a pass awaiting approval, not already counted by the event's own pending attendees */
  pendingPeople: Scalars['Int']['output'];
};

export type SeriesPassType = {
  __typename?: 'SeriesPassType';
  additionalGuests: Scalars['Int']['output'];
  capacity?: Maybe<Scalars['Int']['output']>;
  eventTicketId: Scalars['UUID']['output'];
  guestTickets: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  optInQrCodePass: Scalars['Boolean']['output'];
  passesSold: Scalars['Int']['output'];
  price: Scalars['Decimal']['output'];
  resetAdditionalGuestsAfterEachEvent: Scalars['Boolean']['output'];
  ticketType: Scalars['String']['output'];
};

export type SeriesPasses = {
  __typename?: 'SeriesPasses';
  /** When these numbers were computed */
  asOfUtc?: Maybe<Scalars['DateTime']['output']>;
  /** Passes that can be sold across all pass types; null when any pass type is unlimited */
  capacity?: Maybe<Scalars['Int']['output']>;
  /** The same capacity counted in tickets, each pass with its +1 guests; null when any pass type is unlimited */
  capacityTickets?: Maybe<Scalars['Int']['output']>;
  /** +1 guest tickets currently valid */
  guestTickets: Scalars['Int']['output'];
  /** Whether the pass types can take money: a paid type on sale, or one that was sold before it went off sale. False means pass revenue can never move */
  hasTicketsForSale: Scalars['Boolean']['output'];
  passTypes: Array<SeriesPassType>;
  /** Pass tickets held, with revoked, transferred and expired ones left out and +1 guest tickets not counted */
  passesSold: Scalars['Int']['output'];
  /** The +1s right now: valid for the current event (and how many of those are shared), expired so far, and the ones that are good at every event (a ticket type that does not return +1s, or +1s that pre-date the setting). Whether returns are healthy is plusOneReturnHealth. Null when the series has no pass types. */
  plusOnes?: Maybe<SeriesPlusOneSummary>;
};

export type SeriesPlusOneSummary = {
  __typename?: 'SeriesPlusOneSummary';
  everyEventActive: Scalars['Int']['output'];
  expired: Scalars['Int']['output'];
  legacyUnstamped: Scalars['Int']['output'];
  shared: Scalars['Int']['output'];
  validForEventId?: Maybe<Scalars['UUID']['output']>;
  validNow: Scalars['Int']['output'];
};

export type SeriesRoleInviteeInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SeriesTicketHolderInfo = {
  __typename?: 'SeriesTicketHolderInfo';
  eventTicketId: Scalars['UUID']['output'];
  isAdditionalGuest: Scalars['Boolean']['output'];
  isCheckedInHere: Scalars['Boolean']['output'];
  ticketId: Scalars['UUID']['output'];
  userId: Scalars['UUID']['output'];
  validForEventId?: Maybe<Scalars['UUID']['output']>;
};

export type ShareTicketArgsInput = {
  eventId: Scalars['UUID']['input'];
  landingEventId?: InputMaybe<Scalars['UUID']['input']>;
  targetContactId?: InputMaybe<Scalars['UUID']['input']>;
  targetUserEmail?: InputMaybe<Scalars['String']['input']>;
  targetUserId?: InputMaybe<Scalars['UUID']['input']>;
  ticketId: Scalars['String']['input'];
};

export enum ShareType {
  Contacts = 'CONTACTS',
  ContactList = 'CONTACT_LIST'
}

export type SharedAdditionalGuest = {
  __typename?: 'SharedAdditionalGuest';
  guest: CompleteUser;
  validForEvent: Event;
};

/** A connection to a list of items. */
export type SharedContactsFromListConnection = {
  __typename?: 'SharedContactsFromListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SharedContactsFromListEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Contact>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SharedContactsFromListEdge = {
  __typename?: 'SharedContactsFromListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Contact>;
};

export type SharedWithUserResult = {
  __typename?: 'SharedWithUserResult';
  userAvatarUrl?: Maybe<Scalars['String']['output']>;
  userId: Scalars['UUID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type SimpleApiClientSettings = {
  __typename?: 'SimpleApiClientSettings';
  minimumVersion: Scalars['String']['output'];
  unsupportedVersions: Array<Scalars['String']['output']>;
};

export type SimpleOrderInput = {
  /** The users offer for the product */
  offer: AmountInput;
  /** The product of the order */
  product: AmountInput;
};

export type SmsNotificationSettings = {
  __typename?: 'SmsNotificationSettings';
  disableContactAttendees?: Maybe<Scalars['Boolean']['output']>;
  disableInviteContacts?: Maybe<Scalars['Boolean']['output']>;
};

export type SocialAccountRequirement = {
  __typename?: 'SocialAccountRequirement';
  isRequired: Scalars['Boolean']['output'];
  scheme: Scalars['String']['output'];
};

export type SocialAccountRequirementInput = {
  isRequired: Scalars['Boolean']['input'];
  scheme: Scalars['String']['input'];
};

export type SocialMediaAccount = {
  __typename?: 'SocialMediaAccount';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  profileLink?: Maybe<Scalars['String']['output']>;
  scheme: Scalars['String']['output'];
};

export type SocialMediaAccountBonusSetting = {
  __typename?: 'SocialMediaAccountBonusSetting';
  apple: Scalars['Boolean']['output'];
  appleBonus?: Maybe<Scalars['Decimal']['output']>;
  facebook: Scalars['Boolean']['output'];
  facebookBonus?: Maybe<Scalars['Decimal']['output']>;
  instagram: Scalars['Boolean']['output'];
  instagramBonus?: Maybe<Scalars['Decimal']['output']>;
  linkedIn: Scalars['Boolean']['output'];
  linkedInBonus?: Maybe<Scalars['Decimal']['output']>;
  tikTok: Scalars['Boolean']['output'];
  tikTokBonus?: Maybe<Scalars['Decimal']['output']>;
  twitch: Scalars['Boolean']['output'];
  twitchBonus?: Maybe<Scalars['Decimal']['output']>;
  x: Scalars['Boolean']['output'];
  xBonus?: Maybe<Scalars['Decimal']['output']>;
  youTube: Scalars['Boolean']['output'];
  youTubeBonus?: Maybe<Scalars['Decimal']['output']>;
};

export type SocialMediaAccountBonusSettingPayloadInput = {
  apple: Scalars['Boolean']['input'];
  appleBonus?: InputMaybe<Scalars['Decimal']['input']>;
  facebook: Scalars['Boolean']['input'];
  facebookBonus?: InputMaybe<Scalars['Decimal']['input']>;
  instagram: Scalars['Boolean']['input'];
  instagramBonus?: InputMaybe<Scalars['Decimal']['input']>;
  linkedIn: Scalars['Boolean']['input'];
  linkedInBonus?: InputMaybe<Scalars['Decimal']['input']>;
  tikTok: Scalars['Boolean']['input'];
  tikTokBonus?: InputMaybe<Scalars['Decimal']['input']>;
  twitch: Scalars['Boolean']['input'];
  twitchBonus?: InputMaybe<Scalars['Decimal']['input']>;
  x: Scalars['Boolean']['input'];
  xBonus?: InputMaybe<Scalars['Decimal']['input']>;
  youTube: Scalars['Boolean']['input'];
  youTubeBonus?: InputMaybe<Scalars['Decimal']['input']>;
};

export type SocialMediaAccountConnectArgsInput = {
  accessKey?: InputMaybe<Scalars['String']['input']>;
  scheme: Scalars['String']['input'];
  verifier?: InputMaybe<Scalars['String']['input']>;
};

export type SocialMediaAccountInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  profileLink?: InputMaybe<Scalars['String']['input']>;
  scheme: Scalars['String']['input'];
};

export type SocialMediaAccountScope = {
  __typename?: 'SocialMediaAccountScope';
  apple: Scalars['Boolean']['output'];
  facebook: Scalars['Boolean']['output'];
  instagram: Scalars['Boolean']['output'];
  linkedIn: Scalars['Boolean']['output'];
  tikTok: Scalars['Boolean']['output'];
  twitch: Scalars['Boolean']['output'];
  x: Scalars['Boolean']['output'];
  youTube: Scalars['Boolean']['output'];
};

export type SocialMediaAccountScopePayloadInput = {
  apple: Scalars['Boolean']['input'];
  facebook: Scalars['Boolean']['input'];
  instagram: Scalars['Boolean']['input'];
  linkedIn: Scalars['Boolean']['input'];
  tikTok: Scalars['Boolean']['input'];
  twitch: Scalars['Boolean']['input'];
  x: Scalars['Boolean']['input'];
  youTube: Scalars['Boolean']['input'];
};

export type SocialMediaConnection = {
  __typename?: 'SocialMediaConnection';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  followsCount?: Maybe<Scalars['Long']['output']>;
  profileLink?: Maybe<Scalars['String']['output']>;
  scheme: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type SocialMediaConnectionsArgsInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  profileLink?: InputMaybe<Scalars['String']['input']>;
  scheme: ClientSocialMediaScheme;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SocialMediaPair = {
  __typename?: 'SocialMediaPair';
  /** Social Media Scheme such as Facebook/Google/Twitter/etc */
  scheme: Scalars['String']['output'];
  /** Username or Id of the associated socialmedia account */
  value: Scalars['String']['output'];
};

export type SocialMediaPairInput = {
  /** Social Media Scheme such as Facebook/Google/Twitter/etc */
  scheme: Scalars['String']['input'];
  /** Username or Id of the associated socialmedia account */
  value: Scalars['String']['input'];
};

export type SocialMediaType = {
  __typename?: 'SocialMediaType';
  connect: Scalars['Boolean']['output'];
  disconnect: Scalars['Boolean']['output'];
  /** Generate a verification code the user must DM to our Instagram account. The webhook will connect their Instagram once the code is received. */
  startInstagramVerification: StartInstagramVerificationResult;
};


export type SocialMediaTypeConnectArgs = {
  accessKey: Scalars['String']['input'];
  scheme: Scalars['String']['input'];
  verifier?: InputMaybe<Scalars['String']['input']>;
};


export type SocialMediaTypeDisconnectArgs = {
  scheme: Scalars['String']['input'];
};

export type SpecialGuestInfo = {
  __typename?: 'SpecialGuestInfo';
  limitAmount: Scalars['Int']['output'];
  purchasedAmount: Scalars['Int']['output'];
  remainingAmount: Scalars['Int']['output'];
};

export type StartInstagramVerificationResult = {
  __typename?: 'StartInstagramVerificationResult';
  code: Scalars['String']['output'];
  dmDeepLink?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
};

export type StoredAchievementBadgeCondition = {
  __typename?: 'StoredAchievementBadgeCondition';
  /** Achievement */
  achievement?: Maybe<PublicAchievementModel>;
  /** Achievement Id */
  achievementId: Scalars['UUID']['output'];
  /** EndDate */
  endDate: Scalars['DateTime']['output'];
  /** Id */
  id?: Maybe<Scalars['UUID']['output']>;
  /** StartDate */
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type StoredAchievementBadgeConditionEdgeX = {
  __typename?: 'StoredAchievementBadgeConditionEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<StoredAchievementBadgeCondition>;
};

/** Represents a slice or page */
export type StoredAchievementBadgeConditionPageX = {
  __typename?: 'StoredAchievementBadgeConditionPageX';
  /** A list of edges */
  edges: Array<StoredAchievementBadgeConditionEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<StoredAchievementBadgeCondition>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type StoredModerator = {
  __typename?: 'StoredModerator';
  /** AssignDate */
  assignDate: Scalars['DateTime']['output'];
  /** PieRole */
  pieRole: PieRole;
  /** User */
  user?: Maybe<CompleteUser>;
};

export type StoredModeratorEdgeX = {
  __typename?: 'StoredModeratorEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<StoredModerator>;
};

/** Represents a slice or page */
export type StoredModeratorPageX = {
  __typename?: 'StoredModeratorPageX';
  /** A list of edges */
  edges: Array<StoredModeratorEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<StoredModerator>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type StoredOwnSlicesCondition = {
  __typename?: 'StoredOwnSlicesCondition';
  /** Amount */
  amount: Scalars['Decimal']['output'];
  /** EndDate */
  endDate: Scalars['DateTime']['output'];
  /** Id */
  id?: Maybe<Scalars['UUID']['output']>;
  /** pie */
  pie?: Maybe<CompletePieWithBalance>;
  /** Pie Id */
  pieId: Scalars['UUID']['output'];
  /** StartDate */
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type StoredOwnSlicesConditionEdgeX = {
  __typename?: 'StoredOwnSlicesConditionEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<StoredOwnSlicesCondition>;
};

/** Represents a slice or page */
export type StoredOwnSlicesConditionPageX = {
  __typename?: 'StoredOwnSlicesConditionPageX';
  /** A list of edges */
  edges: Array<StoredOwnSlicesConditionEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<StoredOwnSlicesCondition>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type StoredPasskeyCredential = {
  __typename?: 'StoredPasskeyCredential';
  aaGuid: Scalars['UUID']['output'];
  credType?: Maybe<Scalars['String']['output']>;
  credentialId: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  generation: Scalars['Int']['output'];
  lastUsedDate: Scalars['DateTime']['output'];
  publicKey?: Maybe<Scalars['String']['output']>;
  publicKeyCredential?: Maybe<PublicKeyCredential>;
  regDate: Scalars['DateTime']['output'];
  signatureCounter: Scalars['Int']['output'];
  userHandle?: Maybe<Scalars['String']['output']>;
  userId: Scalars['UUID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type StoredRewardPolicyInfo = {
  __typename?: 'StoredRewardPolicyInfo';
  createdUtc: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type StoredTicket = {
  __typename?: 'StoredTicket';
  /** The user who holds this ticket (for a transferred ticket, the user who handed it over) */
  associatedUser?: Maybe<CompleteUser>;
  associatedUserId: Scalars['UUID']['output'];
  attendeeRole?: Maybe<EventAttendeeRole>;
  count: Scalars['Int']['output'];
  /** Display Event Ticket */
  displayEventTicket?: Maybe<EventTicket>;
  displayEventTicketId?: Maybe<Scalars['UUID']['output']>;
  eventId?: Maybe<Scalars['UUID']['output']>;
  expiredAtUtc?: Maybe<Scalars['DateTime']['output']>;
  firstSeen: Scalars['DateTime']['output'];
  isExpired: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  originalTicketId?: Maybe<Scalars['UUID']['output']>;
  originalTransactionId?: Maybe<Scalars['UUID']['output']>;
  parentTicketId?: Maybe<Scalars['UUID']['output']>;
  /** For a +1 that resets after each event, the user it returns to when its event ends */
  plusOneHolder?: Maybe<CompleteUser>;
  resetHolderUserId?: Maybe<Scalars['UUID']['output']>;
  scannedByUserId?: Maybe<Scalars['UUID']['output']>;
  /** The user who shared or transferred this ticket to its current holder (the latest sender) */
  sharedBy?: Maybe<CompleteUser>;
  sharedByUserId?: Maybe<Scalars['UUID']['output']>;
  status: TicketStatus;
  /** Display ticket name */
  ticketName?: Maybe<Scalars['String']['output']>;
  ticketType?: Maybe<TicketType>;
  transactionId?: Maybe<Scalars['UUID']['output']>;
  /** For a transferred ticket, the user it was transferred to (read from the transfer note) */
  transferredTo?: Maybe<CompleteUser>;
  /** For a +1 that resets after each event, the series member event it is good for */
  validForEvent?: Maybe<Event>;
  validForEventId?: Maybe<Scalars['UUID']['output']>;
};

export type StoredUserReactionEventPolicy = {
  __typename?: 'StoredUserReactionEventPolicy';
  disclosureReferenceId?: Maybe<Scalars['String']['output']>;
  policyFileUrl?: Maybe<Scalars['String']['output']>;
  policyTitle?: Maybe<Scalars['String']['output']>;
  reaction: EventPolicyReaction;
  reactionTime: Scalars['DateTime']['output'];
  signedDisclosureFileUrl?: Maybe<Scalars['String']['output']>;
  signedEventId?: Maybe<Scalars['UUID']['output']>;
  signedEventName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use signedDisclosureFileUrl instead. Retained for records signed before this field existed. */
  signedWaiverFileUrl?: Maybe<Scalars['String']['output']>;
  userId: Scalars['UUID']['output'];
};

export type StoredUserReactionRewardPolicy = {
  __typename?: 'StoredUserReactionRewardPolicy';
  reaction: RewardPolicyReaction;
  reactionTime: Scalars['DateTime']['output'];
  userId: Scalars['UUID']['output'];
};

export type StoredWinningBoost = {
  __typename?: 'StoredWinningBoost';
  /** Id */
  id?: Maybe<Scalars['UUID']['output']>;
  /** Key */
  key?: Maybe<Scalars['String']['output']>;
  /** Score */
  score: Scalars['Decimal']['output'];
  /** Type */
  type: WinningBoostType;
};

export type StoredWinningBoostEdgeX = {
  __typename?: 'StoredWinningBoostEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<StoredWinningBoost>;
};

/** Represents a slice or page */
export type StoredWinningBoostPageX = {
  __typename?: 'StoredWinningBoostPageX';
  /** A list of edges */
  edges: Array<StoredWinningBoostEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<StoredWinningBoost>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeAccountMutationApi = {
  __typename?: 'StripeAccountMutationApi';
  /** Start the process of attaching an existing Stripe account. */
  attachExistingAccount: AttachAccountPayload;
  /** Disconnect a user’s Stripe account from the user profile. */
  disconnect: SuccessPayload;
  /** Start an embedded Account Management session for a user’s Stripe account. */
  startManagementSession: EmbeddedSessionPayload;
  /** Start or continue the onboarding flow for a user’s Stripe account. */
  startOnboardingSession: EmbeddedSessionPayload;
};

export type StripeTaxCollectionStatus = {
  __typename?: 'StripeTaxCollectionStatus';
  hasActiveRegistration: Scalars['Boolean']['output'];
  homeState?: Maybe<Scalars['String']['output']>;
  registeredStates: Array<Scalars['String']['output']>;
};

export type SubmitRedeemOfferContactInfoArgsInput = {
  address?: InputMaybe<AddressModelInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  socialMediaAccounts?: InputMaybe<Array<SocialMediaAccountConnectArgsInput>>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  tick: TickModel;
};

/** Generic success payload used by disconnect. */
export type SuccessPayload = {
  __typename?: 'SuccessPayload';
  success: Scalars['Boolean']['output'];
};

export type SupportedCurrencyType = {
  __typename?: 'SupportedCurrencyType';
  /** ISO 4217 currency code */
  code: Scalars['String']['output'];
  /** True for currencies with no minor unit (e.g. JPY) */
  isZeroDecimal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type TaxEstimateResult = {
  __typename?: 'TaxEstimateResult';
  currency: Scalars['String']['output'];
  estimatedTax: Scalars['Decimal']['output'];
};

export type TaxItem = {
  __typename?: 'TaxItem';
  amount: Scalars['Decimal']['output'];
  taxCode: Scalars['String']['output'];
};

export enum TaxType {
  EventAdmissionAmusementParticipant = 'EVENT_ADMISSION_AMUSEMENT_PARTICIPANT',
  EventAdmissionAmusementSpectator = 'EVENT_ADMISSION_AMUSEMENT_SPECTATOR',
  EventAdmissionCinema = 'EVENT_ADMISSION_CINEMA',
  EventAdmissionCulturalVenue = 'EVENT_ADMISSION_CULTURAL_VENUE',
  EventAdmissionProfessionalEvent = 'EVENT_ADMISSION_PROFESSIONAL_EVENT',
  EventAdmissionSportingCollegeSpectator = 'EVENT_ADMISSION_SPORTING_COLLEGE_SPECTATOR',
  EventAdmissionSportingCompetitionFee = 'EVENT_ADMISSION_SPORTING_COMPETITION_FEE',
  EventAdmissionSportingFacilityParticipant = 'EVENT_ADMISSION_SPORTING_FACILITY_PARTICIPANT',
  EventAdmissionSportingHighSchoolSpectator = 'EVENT_ADMISSION_SPORTING_HIGH_SCHOOL_SPECTATOR',
  EventAdmissionSportingSpectator = 'EVENT_ADMISSION_SPORTING_SPECTATOR',
  EventAdmissionTradeShow = 'EVENT_ADMISSION_TRADE_SHOW',
  Merchandise = 'MERCHANDISE',
  NonTaxable = 'NON_TAXABLE',
  Unknown = 'UNKNOWN'
}

export enum TeamCollaboratorRole {
  Event = 'EVENT',
  EventAndOffer = 'EVENT_AND_OFFER',
  None = 'NONE',
  Offer = 'OFFER'
}

export enum TeamMemberRole {
  AccountManager = 'ACCOUNT_MANAGER',
  Admin = 'ADMIN',
  EventManager = 'EVENT_MANAGER',
  FinanceManager = 'FINANCE_MANAGER',
  LoyaltyManager = 'LOYALTY_MANAGER',
  None = 'NONE',
  Scanner = 'SCANNER'
}

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  createdAtUtc: Scalars['DateTime']['output'];
  marketingTermsUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use PrivacyPolicyUrl instead */
  privacyPolicyFilePath: Scalars['String']['output'];
  privacyPolicyUrl: Scalars['String']['output'];
  /** @deprecated Use TermsAndConditionsUrl instead */
  termsAndConditionsFilePath: Scalars['String']['output'];
  termsAndConditionsUrl: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type TermsAndConditionsCreateArgsInput = {
  marketingTermsUrl?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl: Scalars['String']['input'];
  termsAndConditionsUrl: Scalars['String']['input'];
};

export type TermsAndConditionsModel = {
  __typename?: 'TermsAndConditionsModel';
  createdAtUtc: Scalars['DateTime']['output'];
  marketingTermsUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use PrivacyPolicyUrl instead */
  privacyPolicyFilePath: Scalars['String']['output'];
  privacyPolicyUrl: Scalars['String']['output'];
  /** @deprecated Use TermsAndConditionsUrl instead */
  termsAndConditionsFilePath: Scalars['String']['output'];
  termsAndConditionsUrl: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type TermsAndConditionsMutationApi = {
  __typename?: 'TermsAndConditionsMutationApi';
  createTermsAndConditions: Scalars['Boolean']['output'];
  updateTermsAndConditions: Scalars['Boolean']['output'];
};


export type TermsAndConditionsMutationApiCreateTermsAndConditionsArgs = {
  args: TermsAndConditionsCreateArgsInput;
};


export type TermsAndConditionsMutationApiUpdateTermsAndConditionsArgs = {
  args: TermsAndConditionsCreateArgsInput;
  version: Scalars['Int']['input'];
};

export type TermsAndConditionsQueryApi = {
  __typename?: 'TermsAndConditionsQueryApi';
  current?: Maybe<TermsAndConditions>;
  list: Array<TermsAndConditionsModel>;
};

export type TickModel = {
  __typename?: 'TickModel';
  symbol: Scalars['String']['output'];
  value: Amount;
};

export enum TicketCheckoutStatus {
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  NotFound = 'NOT_FOUND',
  Open = 'OPEN',
  Paid = 'PAID',
  Processing = 'PROCESSING'
}

export type TicketCostArgsInput = {
  eventId: Scalars['UUID']['input'];
  items: Array<TicketCostItemArgsInput>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<AddressModelInput>;
};

export type TicketCostInfo = {
  __typename?: 'TicketCostInfo';
  eventId: Scalars['UUID']['output'];
  expiresAt: Scalars['DateTime']['output'];
  hostBalance: Scalars['Decimal']['output'];
  isAllInPricing: Scalars['Boolean']['output'];
  items: Array<TicketCostItem>;
  paymentAuthCode: Scalars['String']['output'];
  processingFee: Scalars['Decimal']['output'];
  referralUserId?: Maybe<Scalars['UUID']['output']>;
  serviceFee: Scalars['Decimal']['output'];
  shippingAddress?: Maybe<AddressModel>;
  subTotal: Scalars['Decimal']['output'];
  taxName?: Maybe<Scalars['String']['output']>;
  taxPercentage?: Maybe<Scalars['Decimal']['output']>;
  total: Scalars['Decimal']['output'];
  totalFees: Scalars['Decimal']['output'];
  totalGratuity: Scalars['Decimal']['output'];
  totalTaxes: Scalars['Decimal']['output'];
  useAutomaticTax: Scalars['Boolean']['output'];
};

export type TicketCostItem = {
  __typename?: 'TicketCostItem';
  eventTicketId: Scalars['UUID']['output'];
  fulfillmentMethod: FulfillmentMethod;
  gratuityPercentage?: Maybe<Scalars['Decimal']['output']>;
  originalPrice: Scalars['Decimal']['output'];
  price: Scalars['Decimal']['output'];
  productType?: Maybe<ProductType>;
  quantity: Scalars['Int']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
  taxType?: Maybe<TaxType>;
  ticketType?: Maybe<Scalars['String']['output']>;
};

export type TicketCostItemArgsInput = {
  eventTicketId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
};

export type TicketCostSimulationItemInput = {
  gratuityPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  price: Scalars['Decimal']['input'];
  quantity: Scalars['Int']['input'];
  ticketType?: InputMaybe<Scalars['String']['input']>;
};

export type TicketEarningsBreakdown = {
  __typename?: 'TicketEarningsBreakdown';
  event?: Maybe<Event>;
  eventTicketId: Scalars['UUID']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  ticketType: Scalars['String']['output'];
  totalPrice: Scalars['Decimal']['output'];
  totalQuantity: Scalars['Int']['output'];
  unitPrice: Scalars['Decimal']['output'];
};

export type TicketGrantResult = {
  __typename?: 'TicketGrantResult';
  associatedUser?: Maybe<User>;
  ticketId: Scalars['String']['output'];
};

export type TicketInformation = {
  __typename?: 'TicketInformation';
  associatedUserId: Scalars['UUID']['output'];
  extras: Scalars['Int']['output'];
  isRevoked: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['Any']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  ticketId: Scalars['UUID']['output'];
  ticketTypeId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  zonedScans: Array<TicketInformationZoneScan>;
};

export type TicketInformationWithScans = {
  __typename?: 'TicketInformationWithScans';
  associatedUserId: Scalars['UUID']['output'];
  extras: Scalars['Int']['output'];
  isRevoked: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['Any']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  ticketId: Scalars['UUID']['output'];
  ticketTypeId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  zonedScans: Array<TicketInformationZoneScan>;
};

export type TicketInformationZoneScan = {
  __typename?: 'TicketInformationZoneScan';
  scanCount: Scalars['Int']['output'];
  zoneId: Scalars['UUID']['output'];
};

export enum TicketStatus {
  Default = 'DEFAULT',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
  Shared = 'SHARED',
  Sharing = 'SHARING',
  Transferred = 'TRANSFERRED'
}

export type TicketSummary = {
  __typename?: 'TicketSummary';
  dailyScans: Array<DailyScanCount>;
  event: FullEvent;
  eventId: Scalars['UUID']['output'];
  ticketSummaries: Array<TicketSummaryRow>;
  totalCheckedInTickets: Scalars['Int']['output'];
  totalIssuedTickets: Scalars['Int']['output'];
  totalScans: Scalars['Int']['output'];
};

export type TicketSummaryRow = {
  __typename?: 'TicketSummaryRow';
  eventId: Scalars['UUID']['output'];
  eventTicket?: Maybe<EventTicket>;
  eventTicketId: Scalars['UUID']['output'];
  totalCheckedInTickets: Scalars['Int']['output'];
  totalIssuedTickets: Scalars['Int']['output'];
  totalScans: Scalars['Int']['output'];
  zoneSummaries: Array<TicketZoneSummaryRow>;
};

export enum TicketType {
  AttendeeRoleTicket = 'ATTENDEE_ROLE_TICKET',
  ExtraTicket = 'EXTRA_TICKET',
  None = 'NONE'
}

export type TicketVerifyResult = {
  __typename?: 'TicketVerifyResult';
  /** The actual user this ticket is associated with */
  associatedUser?: Maybe<User>;
  /** The attendee role, such as VIP or Promoter, etc... */
  attendeeRole?: Maybe<EventAttendeeRole>;
  /** The first time this ticket was scanned */
  firstSeen: Scalars['DateTime']['output'];
  /** The message to display to the user, if any */
  message?: Maybe<Scalars['String']['output']>;
  /** The number of times this ticket has been scanned */
  scanCount: Scalars['Int']['output'];
  /** The ticket status, such as Valid or TestCode */
  status: TicketVerifyStatus;
  /** The ticket that was scanned */
  ticketId: Scalars['String']['output'];
  /** The ticket names, such as VIP or Paid, etc... */
  ticketName?: Maybe<Scalars['String']['output']>;
};

export enum TicketVerifyStatus {
  Invalid = 'INVALID',
  PrimaryCheckInRequired = 'PRIMARY_CHECK_IN_REQUIRED',
  Test = 'TEST',
  Valid = 'VALID'
}

export type TicketWithIdEdgeX = {
  __typename?: 'TicketWithIdEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<TicketWithIdOfStoredTicket>;
};

export type TicketWithIdOfStoredTicket = {
  __typename?: 'TicketWithIdOfStoredTicket';
  associatedUser?: Maybe<CompleteUser>;
  count: Scalars['Int']['output'];
  displayEventTicket?: Maybe<EventTicket>;
  eventTicket?: Maybe<EventTicket>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  firstSeen?: Maybe<Scalars['DateTime']['output']>;
  /** For guest tickets, the user who holds the parent ticket */
  guestOf?: Maybe<CompleteUser>;
  /** For primary tickets, the user who invited this attendee */
  invitedBy?: Maybe<CompleteUser>;
  isExpired: Scalars['Boolean']['output'];
  isGuestTicket?: Maybe<Scalars['Boolean']['output']>;
  isShareable?: Maybe<Scalars['Boolean']['output']>;
  isStaffTicket?: Maybe<Scalars['Boolean']['output']>;
  /** For a +1 that resets after each event, the user it returns to when its event ends */
  plusOneHolder?: Maybe<CompleteUser>;
  /** All scanning zones this ticket type is allowed in, with scan history and limits. For a series season pass (a ticket on the series' hidden parent event) pass the member event it is being viewed from as eventId: the zones, limits and scan history are then that member event's. */
  scanZones?: Maybe<Array<Maybe<ScanningZoneInfo>>>;
  /** The user who last scanned this ticket in */
  scannedBy?: Maybe<CompleteUser>;
  /** For a holder's own pass whose +1s reset after each event: who currently has each +1 shared, and for which event */
  sharedAdditionalGuests?: Maybe<Array<SharedAdditionalGuest>>;
  status: TicketStatus;
  ticketId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['UUID']['output']>;
  /** For a +1 that resets after each event, the series member event it is good for */
  validForEvent?: Maybe<Event>;
};


export type TicketWithIdOfStoredTicketScanZonesArgs = {
  eventId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents a slice or page */
export type TicketWithIdPageX = {
  __typename?: 'TicketWithIdPageX';
  /** A list of edges */
  edges: Array<TicketWithIdEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<TicketWithIdOfStoredTicket>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type TicketZoneSummaryRow = {
  __typename?: 'TicketZoneSummaryRow';
  dailyScans: Array<DailyScanCount>;
  eventTicketZoneId: Scalars['UUID']['output'];
  totalCheckedInTickets: Scalars['Int']['output'];
  totalScans: Scalars['Int']['output'];
  zoneName?: Maybe<Scalars['String']['output']>;
};

export type TimeFrameConstraint = {
  __typename?: 'TimeFrameConstraint';
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  expiresDateTime?: Maybe<Scalars['DateTime']['output']>;
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  timeFrameType: RewardTimeFrameType;
  timeZoneId?: Maybe<Scalars['String']['output']>;
};

export type TimeFrameConstraintPayloadInput = {
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  expiresDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  startDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
  type: RewardTimeFrameType;
};

export enum TradingContext {
  Market = 'MARKET',
  Slices = 'SLICES'
}

export type TradingTransaction = {
  __typename?: 'TradingTransaction';
  acceptedBy?: Maybe<User>;
  /** Information of attendee status of transaction user */
  attendeeInfo?: Maybe<EventAttendeeInfo>;
  authorizationTransactionId?: Maybe<Scalars['String']['output']>;
  authorizationTransactionMessage?: Maybe<Scalars['String']['output']>;
  authorizationTransactionStatus?: Maybe<Scalars['String']['output']>;
  captureOrderId?: Maybe<Scalars['String']['output']>;
  captureTransactionId?: Maybe<Scalars['String']['output']>;
  captureTransactionMessage?: Maybe<Scalars['String']['output']>;
  captureTransactionStatus?: Maybe<Scalars['String']['output']>;
  cardbrand?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['DateTime']['output'];
  event?: Maybe<Event>;
  /** Even tickets that user has purchased */
  eventTickets?: Maybe<Array<Maybe<EventTicketPurchaseInfo>>>;
  hostBalance: Scalars['Decimal']['output'];
  isAllInPricing: Scalars['Boolean']['output'];
  orderId?: Maybe<Scalars['UUID']['output']>;
  originalTransactionId?: Maybe<Scalars['UUID']['output']>;
  paidDateUtc?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentSource?: Maybe<Scalars['String']['output']>;
  pie?: Maybe<CompletePieWithBalance>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceCurrency?: Maybe<Scalars['String']['output']>;
  processingFee: Scalars['Decimal']['output'];
  referralUser?: Maybe<User>;
  serviceFee: Scalars['Decimal']['output'];
  status?: Maybe<PaymentStatus>;
  subTotal: Scalars['Decimal']['output'];
  totalGratuity: Scalars['Decimal']['output'];
  totalPrice?: Maybe<Scalars['Decimal']['output']>;
  totalTaxes: Scalars['Decimal']['output'];
  tradeSlices?: Maybe<Scalars['Decimal']['output']>;
  transactionFee?: Maybe<Scalars['Decimal']['output']>;
  transactionId: Scalars['UUID']['output'];
  transactionStatus: TransactionStatus;
  /** Transaction type */
  type?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UserWithGeneralLocation>;
};

export type TradingTransactionEdgeX = {
  __typename?: 'TradingTransactionEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<TradingTransaction>;
};

/** Represents a slice or page */
export type TradingTransactionGrainPageX = {
  __typename?: 'TradingTransactionGrainPageX';
  /** A list of edges */
  edges: Array<TradingTransactionEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<TradingTransaction>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

/** Represents a slice or page of TradingTransaction */
export type TradingTransactionOffsetPage = {
  __typename?: 'TradingTransactionOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<TradingTransaction>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export enum TradingTransactionSortingType {
  CreatedAt = 'CREATED_AT',
  Price = 'PRICE',
  TotalValue = 'TOTAL_VALUE',
  TradeSlices = 'TRADE_SLICES'
}

export type TransactionFees = {
  __typename?: 'TransactionFees';
  amount: Scalars['Decimal']['output'];
  percentage: Scalars['Decimal']['output'];
};

export type TransactionOperationResult = {
  __typename?: 'TransactionOperationResult';
  exMessage?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  transactionStatus: TransactionStatus;
};

export enum TransactionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Crashed = 'CRASHED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  RefundPending = 'REFUND_PENDING'
}

export type TransactionTransferOutTicketArgs = {
  __typename?: 'TransactionTransferOutTicketArgs';
  eventTicketId: Scalars['UUID']['output'];
  ticketId: Scalars['UUID']['output'];
  transferOutTransactionId: Scalars['UUID']['output'];
};

export enum TransactionType {
  AwardPie = 'AWARD_PIE',
  BuyEventTicket = 'BUY_EVENT_TICKET',
  BuyPie = 'BUY_PIE',
  BuyPointsOffer = 'BUY_POINTS_OFFER',
  CreatePie = 'CREATE_PIE',
  DepositPie = 'DEPOSIT_PIE',
  ExtraEventTicket = 'EXTRA_EVENT_TICKET',
  GiftEventTicket = 'GIFT_EVENT_TICKET',
  Payout = 'PAYOUT',
  PurchaseOffer = 'PURCHASE_OFFER',
  Rsvp = 'RSVP',
  SelfTransfer = 'SELF_TRANSFER',
  SellPie = 'SELL_PIE',
  TransferInEventTicket = 'TRANSFER_IN_EVENT_TICKET',
  TransferOutEventTicket = 'TRANSFER_OUT_EVENT_TICKET',
  UpgradePie = 'UPGRADE_PIE',
  WithdrawPie = 'WITHDRAW_PIE'
}

/** A connection to a list of items. */
export type TransactionsConnection = {
  __typename?: 'TransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<UserTransactionInfo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TransactionsEdge = {
  __typename?: 'TransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserTransactionInfo>;
};

export type UpdateAchievementPayloadInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  triggers?: InputMaybe<Array<AchievementTriggerPayloadInput>>;
  type?: InputMaybe<ClubAchievementType>;
};

export type UpdateClubPayloadInput = {
  access?: InputMaybe<ClubAccess>;
  colors?: InputMaybe<ClubColorsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  visibleRequirements?: InputMaybe<ClubRequirementInput>;
};

export type UpdateClubResult = {
  __typename?: 'UpdateClubResult';
  clubId: Scalars['UUID']['output'];
  prepareUpload?: Maybe<PrepareUploadResponse>;
  resolveClubId: Scalars['UUID']['output'];
};


export type UpdateClubResultPrepareUploadArgs = {
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
  type: ClubUploadAsset;
};

export type UpdateClubRolePayloadInput = {
  permissions: Array<ClubPermissionId>;
  roleId: Scalars['UUID']['input'];
  roleName: Scalars['String']['input'];
};

export type UpdateEventSeriesRolePayloadInput = {
  permissions: Array<EventSeriesPermissionId>;
  roleId: Scalars['UUID']['input'];
  roleName: Scalars['String']['input'];
};

export type UpdateOfferPayloadInput = {
  access?: InputMaybe<ClubOfferAccess>;
  accessRequirements?: InputMaybe<ClubOfferRequirementInput>;
  configuration?: InputMaybe<OfferConfigurationPayloadInput>;
  offerFlow?: InputMaybe<OfferFlowPayloadInput>;
  published?: InputMaybe<ClubOfferPublished>;
  rewards?: InputMaybe<Array<RewardOfferFlowPayloadInput>>;
  visibilityRequirements?: InputMaybe<ClubOfferRequirementInput>;
};

export type UpdateTaxConfigurationArgInput = {
  /** Enable or disable tax collection */
  isCollect: Scalars['Boolean']['input'];
  /** Display name of the tax (e.g., VAT) */
  name: Scalars['String']['input'];
  /** Tax rate as a percentage (e.g., 15 for 15%) */
  percent: Scalars['Decimal']['input'];
  /** Use automated tax (e.g. Stripe Tax) instead of the manual rate. Honored by processors that support it; ignored by PayPal. */
  useAutomaticTax?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadedAsset = {
  __typename?: 'UploadedAsset';
  createdUtc: Scalars['DateTime']['output'];
  pie?: Maybe<CompletePieWithBalance>;
  status: UploadedAssetStatus;
  target: UploadedAssetTarget;
  uploadedAssetId: Scalars['UUID']['output'];
  url: Scalars['String']['output'];
};

export type UploadedAssetEdgeX = {
  __typename?: 'UploadedAssetEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<UploadedAsset>;
};

/** Represents a slice or page */
export type UploadedAssetGrainPageX = {
  __typename?: 'UploadedAssetGrainPageX';
  /** A list of edges */
  edges: Array<UploadedAssetEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<UploadedAsset>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type UploadedAssetIndexDocument = {
  __typename?: 'UploadedAssetIndexDocument';
  createdUtc: Scalars['DateTime']['output'];
  pieId?: Maybe<Scalars['UUID']['output']>;
  status: UploadedAssetStatus;
  target: UploadedAssetTarget;
  uploadedAssetId: Scalars['UUID']['output'];
  url: Scalars['String']['output'];
};

export type UploadedAssetModel = {
  __typename?: 'UploadedAssetModel';
  createdUtc: Scalars['DateTime']['output'];
  pie?: Maybe<CompletePieWithBalance>;
  status: UploadedAssetStatus;
  target: UploadedAssetTarget;
  url: Scalars['String']['output'];
};

export type UploadedAssetMutationApi = {
  __typename?: 'UploadedAssetMutationApi';
  /** PLACEHOLDER: Create or update an uploaded asset */
  createOrUpdate: PublicUploadedAssetModel;
  delete: Scalars['Boolean']['output'];
  /** Presign an URL for upload asset */
  presignUploadUrl: Scalars['String']['output'];
};


export type UploadedAssetMutationApiCreateOrUpdateArgs = {
  adminUpdate?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  pieId?: InputMaybe<Scalars['UUID']['input']>;
  target: UploadedAssetTarget;
  url: Scalars['String']['input'];
};


export type UploadedAssetMutationApiDeleteArgs = {
  id: Scalars['UUID']['input'];
};


export type UploadedAssetMutationApiPresignUploadUrlArgs = {
  adminUpdate?: Scalars['Boolean']['input'];
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
  pieId?: InputMaybe<Scalars['UUID']['input']>;
  target: UploadedAssetTarget;
};

/** Represents a slice or page */
export type UploadedAssetPageX = {
  __typename?: 'UploadedAssetPageX';
  /** A list of edges */
  edges: Array<UploadedAssetEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<UploadedAsset>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type UploadedAssetQueryApi = {
  __typename?: 'UploadedAssetQueryApi';
  /** @deprecated To be removed soon */
  list?: Maybe<Array<Maybe<UploadedAsset>>>;
  /** @deprecated To be removed soon */
  listByPieId?: Maybe<UploadedAssetPageX>;
  listByPieId2?: Maybe<UploadedAssetGrainPageX>;
};


export type UploadedAssetQueryApiListByPieIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  pieId: Scalars['UUID']['input'];
};


export type UploadedAssetQueryApiListByPieId2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  pieId: Scalars['UUID']['input'];
  target?: InputMaybe<UploadedAssetTarget>;
};

export enum UploadedAssetStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  None = 'NONE'
}

export enum UploadedAssetTarget {
  AchievementAvatar = 'ACHIEVEMENT_AVATAR',
  Document = 'DOCUMENT',
  EventArtifact = 'EVENT_ARTIFACT',
  EventAvatar = 'EVENT_AVATAR',
  EventGuestAvatar = 'EVENT_GUEST_AVATAR',
  PartnerLogo = 'PARTNER_LOGO',
  RewardAvatar = 'REWARD_AVATAR'
}

export type User = BasicUser & {
  __typename?: 'User';
  age?: Maybe<Scalars['Int']['output']>;
  ageRange?: Maybe<Scalars['String']['output']>;
  avatarSource: AvatarSource;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  brandedUrl?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  displayNameSource: DisplayNameSource;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Number of users following this user */
  followersCount?: Maybe<Scalars['Long']['output']>;
  gender?: Maybe<UserGender>;
  instagramAvatarUrl?: Maybe<Scalars['String']['output']>;
  instagramDisplayName?: Maybe<Scalars['String']['output']>;
  instagramFollowsCount?: Maybe<Scalars['Long']['output']>;
  /** Whether the current signed-in user follows this user */
  isFollowedByCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  isVerified: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  repScore: Scalars['Int']['output'];
  /** List social media connections */
  socialMediaConnections?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  /**
   * List social media connections
   * @deprecated Use socialMediaConnections instead
   */
  socialMedias?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  tier: UserTier;
  tikTokAvatarUrl?: Maybe<Scalars['String']['output']>;
  tikTokDisplayName?: Maybe<Scalars['String']['output']>;
  tikTokFollowsCount?: Maybe<Scalars['Long']['output']>;
  twitchAvatarUrl?: Maybe<Scalars['String']['output']>;
  twitchDisplayName?: Maybe<Scalars['String']['output']>;
  twitchFollowsCount?: Maybe<Scalars['Long']['output']>;
  userId: Scalars['UUID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type UserAchievement = {
  __typename?: 'UserAchievement';
  achievementUserInfo?: Maybe<AchievementUserInfo>;
  userInfo?: Maybe<User>;
};

export type UserAchievementArgsInput = {
  achievementId: Scalars['UUID']['input'];
  claimedByRewardId?: InputMaybe<Scalars['UUID']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive: Scalars['Boolean']['input'];
};

export type UserAddressModel = {
  __typename?: 'UserAddressModel';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type UserAuthenticationRecord = {
  __typename?: 'UserAuthenticationRecord';
  key: Scalars['String']['output'];
  payload?: Maybe<Scalars['String']['output']>;
  scheme: Scalars['String']['output'];
};

export type UserCustomerInformationRedemption = UserRewardRedemption & {
  __typename?: 'UserCustomerInformationRedemption';
  address?: Maybe<AddressModel>;
  connectedSocialAccounts?: Maybe<Array<UserSocialMediaConnectionInfo>>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  isSubmitted: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  redemptionType: RewardRedemptionType;
  requiredScope?: Maybe<CustomerInformationScope>;
  submittedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type UserEdgeX = {
  __typename?: 'UserEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<User>;
};

/** A connection to a list of items. */
export type UserEventsByRoleConnection = {
  __typename?: 'UserEventsByRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserEventsByRoleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEventsByRoleEdge = {
  __typename?: 'UserEventsByRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Event>;
};

/** A connection to a list of items. */
export type UserEventsConnection = {
  __typename?: 'UserEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEventsEdge = {
  __typename?: 'UserEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Event>;
};

export enum UserGender {
  Female = 'FEMALE',
  Male = 'MALE',
  NotDisclosed = 'NOT_DISCLOSED',
  Other = 'OTHER',
  Unknown = 'UNKNOWN'
}

export type UserGeoFenceModel = {
  __typename?: 'UserGeoFenceModel';
  address?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  locationUnitLengthType: LocationUnitLengthType;
  longitude: Scalars['Float']['output'];
  radius: Scalars['Float']['output'];
  rewardId: Scalars['UUID']['output'];
};

/** Represents a slice or page */
export type UserGrainPageX = {
  __typename?: 'UserGrainPageX';
  /** A list of edges */
  edges: Array<UserEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<User>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type UserIndexDocument = {
  __typename?: 'UserIndexDocument';
  address?: Maybe<AddressModel>;
  age?: Maybe<Scalars['Int']['output']>;
  ageRange?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  deletedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  deletedByAdmin?: Maybe<Scalars['Boolean']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<UserGender>;
  instagramUsername?: Maybe<Scalars['String']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rewardUnlockDate?: Maybe<Scalars['DateTime']['output']>;
  tier: UserTier;
  userId: Scalars['UUID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type UserInviteLinkRedemption = UserRewardRedemption & {
  __typename?: 'UserInviteLinkRedemption';
  createdAtUtc: Scalars['DateTime']['output'];
  inviteLink: Scalars['String']['output'];
  redemptionType: RewardRedemptionType;
};

export type UserInvites = {
  __typename?: 'UserInvites';
  remainingInviteCount: Scalars['Int']['output'];
};

export type UserLocationArgsInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type UserMutationApi = {
  __typename?: 'UserMutationApi';
  /** @deprecated Use acceptInvite2 instead */
  acceptInvite: Scalars['Boolean']['output'];
  acceptInvite2: AcceptInviteResult;
  /** Accepts an invite sent to another email address, using the code from sendInviteeEmailVerification as proof of owning it. */
  acceptInviteWithEmailVerification: AcceptInviteWithEmailVerificationResult;
  /** Activate a deactivated account */
  activate: Scalars['Boolean']['output'];
  /** Agree to terms and conditions */
  agreeTermsAndConditions: Scalars['Boolean']['output'];
  assignToBrandedUrl: Scalars['String']['output'];
  avatar: AvatarType;
  /** Deactivate account */
  deactivate: Scalars['Boolean']['output'];
  declineInvite: Scalars['Boolean']['output'];
  /** Admin delete an account */
  delete: Scalars['Boolean']['output'];
  /** Follow another user */
  followUser: Scalars['Boolean']['output'];
  /** Invite a user by email */
  inviteUserByEmail: CreatedInvite;
  /** Invite an existing user by Id */
  inviteUserById: Scalars['Boolean']['output'];
  /** Invite a user by link */
  inviteUserByLink: CreatedInvite;
  /** Invite a user by text message */
  inviteUserByTextMessage: CreatedInvite;
  /** Invite a user by user name */
  inviteUserByUserName: CreatedInvite;
  joinPieWaitingList: Scalars['Boolean']['output'];
  payoutAccount: PayoutAccountType;
  queryInvite: QueryInviteResult;
  /** Admin recover an account */
  recover: Scalars['Boolean']['output'];
  /** Re-fetches the user's Instagram profile (avatar, username, follower count) and updates the stored social media connection. Returns false if no Instagram connection exists. */
  refreshInstagramConnection: Scalars['Boolean']['output'];
  /** Sends an approval request to support so the user can be cleared to create events. Returns false if the account is not currently restricted. */
  requestCreateEventApproval: Scalars['Boolean']['output'];
  /** Sends an approval request to support so the user can be cleared to create events of the given type. Returns false if the account is already approved for that event type. */
  requestCreateEventTypeApproval: Scalars['Boolean']['output'];
  /** Request a verified email address change. Sends a verification link to the new address; the change is applied only after the user clicks it. */
  requestEmailChange: UserUpdateStatus;
  /** Revoke a pending invite */
  revokePendingInvite: Scalars['Boolean']['output'];
  /** Emails a code to the address an invite was sent to, when acceptInvite2 failed because it differs from the signed-in user's email. Finish with acceptInviteWithEmailVerification. */
  sendInviteeEmailVerification: InviteeEmailVerificationResult;
  /** Set the preferred avatar source. Instagram uses the avatar fetched during DM verification (or last sync). */
  setAvatarSource: Scalars['Boolean']['output'];
  /** Set the preferred display name source. Instagram uses the username fetched during DM verification (or last sync). */
  setDisplayNameSource: Scalars['Boolean']['output'];
  /** Admin set user's verified status */
  setIsVerified: Scalars['Boolean']['output'];
  /**
   * Admin set user's tier
   * @deprecated Use mutation.admin.userById.setTier instead
   */
  setTier: Scalars['Boolean']['output'];
  socialMedia: SocialMediaType;
  unassignFromBrandedUrl: Scalars['Boolean']['output'];
  /** Unfollow a user */
  unfollowUser: Scalars['Boolean']['output'];
  /** Remove pie from wish list */
  unwishPie: Scalars['Boolean']['output'];
  /** Update the current users email address. This call will start a verification process */
  updateAddress: UserUpdateStatus;
  /** Update the current users email address. This call will start a verification process */
  updateEmailAddress: UserUpdateStatus;
  /** Update email subscription with specific types */
  updateEmailSubscription: Scalars['Boolean']['output'];
  /** Update the current users phone number. This call will start a verification process */
  updatePhoneNumber: UserUpdateStatus;
  /** Update the SkipMultiFactorAuthentication. Disabling starts an OTP verification step; the setting is applied only after the code is verified. */
  updateSkipMultiFactorAuthentication: UserUpdateStatus;
  /** Update the SkipPasskeyRegistration */
  updateSkipPasskeyRegistration: UserUpdateStatus;
  updateTaxConfiguration: Scalars['Boolean']['output'];
  /** Update walkthrough with specific types */
  updateWalkthrough: Array<UserWalkthrough>;
  /** Update the UseBiometric */
  useBiometric: UserUpdateStatus;
  /** Add pie to wish list */
  wishPie: Scalars['Boolean']['output'];
};


export type UserMutationApiAcceptInviteArgs = {
  inviteId: Scalars['String']['input'];
};


export type UserMutationApiAcceptInvite2Args = {
  didAcceptAllDisclosures?: Scalars['Boolean']['input'];
  inviteId: Scalars['String']['input'];
};


export type UserMutationApiAcceptInviteWithEmailVerificationArgs = {
  code: Scalars['String']['input'];
  didAcceptAllDisclosures?: Scalars['Boolean']['input'];
  inviteId: Scalars['String']['input'];
};


export type UserMutationApiAgreeTermsAndConditionsArgs = {
  version: Scalars['Int']['input'];
};


export type UserMutationApiAssignToBrandedUrlArgs = {
  eventId: Scalars['UUID']['input'];
};


export type UserMutationApiDeclineInviteArgs = {
  inviteId: Scalars['String']['input'];
};


export type UserMutationApiDeleteArgs = {
  userId: Scalars['UUID']['input'];
};


export type UserMutationApiFollowUserArgs = {
  userId: Scalars['UUID']['input'];
};


export type UserMutationApiInviteUserByEmailArgs = {
  emailAddress: Scalars['String']['input'];
};


export type UserMutationApiInviteUserByIdArgs = {
  invitedUserId: Scalars['UUID']['input'];
};


export type UserMutationApiInviteUserByLinkArgs = {
  memo: Scalars['String']['input'];
};


export type UserMutationApiInviteUserByTextMessageArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type UserMutationApiInviteUserByUserNameArgs = {
  userName: Scalars['String']['input'];
};


export type UserMutationApiQueryInviteArgs = {
  deliveryId?: InputMaybe<Scalars['UUID']['input']>;
  inviteId: Scalars['String']['input'];
  viewSource?: InputMaybe<AttributionChannel>;
};


export type UserMutationApiRecoverArgs = {
  userId: Scalars['UUID']['input'];
};


export type UserMutationApiRequestCreateEventTypeApprovalArgs = {
  type: AllowCreateEventType;
};


export type UserMutationApiRequestEmailChangeArgs = {
  newEmailAddress: Scalars['String']['input'];
};


export type UserMutationApiRevokePendingInviteArgs = {
  inviteId: Scalars['String']['input'];
};


export type UserMutationApiSendInviteeEmailVerificationArgs = {
  inviteId: Scalars['String']['input'];
};


export type UserMutationApiSetAvatarSourceArgs = {
  source: AvatarSource;
};


export type UserMutationApiSetDisplayNameSourceArgs = {
  source: DisplayNameSource;
};


export type UserMutationApiSetIsVerifiedArgs = {
  isVerified: Scalars['Boolean']['input'];
  userId: Scalars['UUID']['input'];
};


export type UserMutationApiSetTierArgs = {
  tier: UserTier;
  userId: Scalars['UUID']['input'];
};


export type UserMutationApiUnfollowUserArgs = {
  userId: Scalars['UUID']['input'];
};


export type UserMutationApiUnwishPieArgs = {
  pieId: Scalars['UUID']['input'];
};


export type UserMutationApiUpdateAddressArgs = {
  address: AddressModelInput;
};


export type UserMutationApiUpdateEmailAddressArgs = {
  emailAddress: Scalars['String']['input'];
  sendVerificationEmail?: Scalars['Boolean']['input'];
};


export type UserMutationApiUpdateEmailSubscriptionArgs = {
  args: Array<EmailSubscriptionArgsInput>;
};


export type UserMutationApiUpdatePhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
  sendVerificationMessage?: Scalars['Boolean']['input'];
};


export type UserMutationApiUpdateSkipMultiFactorAuthenticationArgs = {
  skipMultiFactorAuthentication?: Scalars['Boolean']['input'];
};


export type UserMutationApiUpdateSkipPasskeyRegistrationArgs = {
  skipPasskeyRegistration?: Scalars['Boolean']['input'];
};


export type UserMutationApiUpdateTaxConfigurationArgs = {
  args: UpdateTaxConfigurationArgInput;
};


export type UserMutationApiUpdateWalkthroughArgs = {
  args: Array<WalkthroughArgsInput>;
};


export type UserMutationApiUseBiometricArgs = {
  use: Scalars['Boolean']['input'];
};


export type UserMutationApiWishPieArgs = {
  pieId: Scalars['UUID']['input'];
};

export enum UserOfferRelationshipType {
  Owner = 'OWNER',
  Participated = 'PARTICIPATED',
  Unknown = 'UNKNOWN'
}

export enum UserOfferSortingField {
  EndDateTime = 'END_DATE_TIME',
  None = 'NONE',
  StartDateTime = 'START_DATE_TIME'
}

/** A connection to a list of items. */
export type UserOffersConnection = {
  __typename?: 'UserOffersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserOffersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PublicClubOfferState>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserOffersEdge = {
  __typename?: 'UserOffersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PublicClubOfferState>;
};

/** Represents a slice or page of User */
export type UserOffsetPage = {
  __typename?: 'UserOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<CurrentUser>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

/** Represents a slice or page */
export type UserPageX = {
  __typename?: 'UserPageX';
  /** A list of edges */
  edges: Array<UserEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<User>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type UserPortfolio = {
  __typename?: 'UserPortfolio';
  /** Users value % change described in the currency under TotalValue */
  last24hourChange: Scalars['Decimal']['output'];
  totalValue: Amount;
};

export type UserRelationship = {
  __typename?: 'UserRelationship';
  createdAt: Scalars['DateTime']['output'];
  relationshipType: UserRelationshipType;
  user: User;
};

export enum UserRelationshipType {
  FollowedBy = 'FOLLOWED_BY',
  Follows = 'FOLLOWS',
  Friend = 'FRIEND',
  Invited = 'INVITED',
  InvitedBy = 'INVITED_BY',
  None = 'NONE'
}

export type UserReward = {
  __typename?: 'UserReward';
  holdingSlices: Scalars['Decimal']['output'];
  userInfo?: Maybe<UserWithAddress>;
  userRewardInfo?: Maybe<RewardUserInfoType>;
};

export type UserRewardArgsInput = {
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive: Scalars['Boolean']['input'];
  ordinalWinner?: InputMaybe<Scalars['Int']['input']>;
  participateReason?: InputMaybe<ParticipateReason>;
  participateState: ParticipateState;
  rewardId: Scalars['UUID']['input'];
};

export type UserRewardEdgeX = {
  __typename?: 'UserRewardEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<UserReward>;
};

/** Represents a slice or page of UserReward */
export type UserRewardOffsetPage = {
  __typename?: 'UserRewardOffsetPage';
  /** A flattened list of the nodes */
  nodes: Array<UserReward>;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

/** Represents a slice or page */
export type UserRewardPageX = {
  __typename?: 'UserRewardPageX';
  /** A list of edges */
  edges: Array<UserRewardEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<UserReward>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export type UserRewardRedemption = {
  redemptionType: RewardRedemptionType;
};

export type UserRewardRedemptionGqlType = UserCustomerInformationRedemption | UserInviteLinkRedemption;

export enum UserRewardSortType {
  CreatedDate = 'CREATED_DATE'
}

export type UserSocialMediaConnectionInfo = {
  __typename?: 'UserSocialMediaConnectionInfo';
  displayName?: Maybe<Scalars['String']['output']>;
  followsCount?: Maybe<Scalars['Long']['output']>;
  scheme: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserStripeAccountType = {
  __typename?: 'UserStripeAccountType';
  accountStatus?: Maybe<PaymentAccountStatus>;
  hasConnectAccount: Scalars['Boolean']['output'];
  /** Jurisdiction-aware tax-collection posture: whether any active Stripe Tax registration exists, the seller's home (head-office) state, and whether they're registered there. Used to warn a seller on automatic tax that no tax is being collected where they have nexus. */
  taxCollection?: Maybe<StripeTaxCollectionStatus>;
  /** US states hosting this seller's live events whose admission is taxed at the venue (Stripe-processed, still selling a priced admission ticket, venue address normalized). Compare against taxCollection.registeredStates to show which jurisdictions are collecting no tax. Null means unknown (not the owner, or the scan could not complete) and must not be read as 'no gaps'. */
  taxableVenueStates?: Maybe<Array<Scalars['String']['output']>>;
};

/** Tax settings applied to purchases by the user */
export type UserTaxConfiguration = {
  __typename?: 'UserTaxConfiguration';
  isCollect: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Decimal']['output']>;
  useAutomaticTax?: Maybe<Scalars['Boolean']['output']>;
};

export type UserTicket = {
  __typename?: 'UserTicket';
  /** When the ticket was associated with the current user */
  associatedAt: Scalars['DateTime']['output'];
  /** The original ticket id */
  originalTicketId?: Maybe<Scalars['UUID']['output']>;
  /** The entity that owns the ticket */
  owningEntityId: Scalars['UUID']['output'];
  /** Ticket Id */
  ticketId?: Maybe<Scalars['String']['output']>;
};

export type UserTicketEdgeX = {
  __typename?: 'UserTicketEdgeX';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<UserTicket>;
};

/** Represents a slice or page */
export type UserTicketPageX = {
  __typename?: 'UserTicketPageX';
  /** A list of edges */
  edges: Array<UserTicketEdgeX>;
  /** A flattened list of the nodes */
  nodes: Array<UserTicket>;
  /** Information about the page */
  pageInfo: PageInfoX;
  /** Information about the total page count */
  totalCount: Scalars['Long']['output'];
};

export enum UserTier {
  Premium = 'PREMIUM',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export type UserTierOperationFilterInput = {
  eq?: InputMaybe<UserTier>;
  in?: InputMaybe<Array<UserTier>>;
  neq?: InputMaybe<UserTier>;
  nin?: InputMaybe<Array<UserTier>>;
};

export type UserTransactionInfo = {
  __typename?: 'UserTransactionInfo';
  in: Amount;
  out: Amount;
  relatedPie?: Maybe<Pie>;
  remarks?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTime']['output'];
  transactionId: Scalars['UUID']['output'];
  wasSuccessful: Scalars['Boolean']['output'];
};

export enum UserUpdateStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Started = 'STARTED',
  Unknown = 'UNKNOWN'
}

export type UserWalkthrough = {
  __typename?: 'UserWalkthrough';
  status: WalkthroughStatus;
  type: WalkthroughType;
};

export type UserWithAddress = BasicUser & {
  __typename?: 'UserWithAddress';
  address?: Maybe<UserAddressModel>;
  age?: Maybe<Scalars['Int']['output']>;
  ageRange?: Maybe<Scalars['String']['output']>;
  avatarSource: AvatarSource;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  brandedUrl?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  displayNameSource: DisplayNameSource;
  emailAddress?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<UserGender>;
  instagramAvatarUrl?: Maybe<Scalars['String']['output']>;
  instagramDisplayName?: Maybe<Scalars['String']['output']>;
  instagramFollowsCount?: Maybe<Scalars['Long']['output']>;
  isVerified: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  repScore: Scalars['Int']['output'];
  /** List social media connections */
  socialMediaConnections?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  /**
   * List social media connections
   * @deprecated Use socialMediaConnections instead
   */
  socialMedias?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  tier: UserTier;
  tikTokAvatarUrl?: Maybe<Scalars['String']['output']>;
  tikTokDisplayName?: Maybe<Scalars['String']['output']>;
  tikTokFollowsCount?: Maybe<Scalars['Long']['output']>;
  twitchAvatarUrl?: Maybe<Scalars['String']['output']>;
  twitchDisplayName?: Maybe<Scalars['String']['output']>;
  twitchFollowsCount?: Maybe<Scalars['Long']['output']>;
  userId: Scalars['UUID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type UserWithGeneralLocation = BasicUser & {
  __typename?: 'UserWithGeneralLocation';
  age?: Maybe<Scalars['Int']['output']>;
  ageRange?: Maybe<Scalars['String']['output']>;
  avatarSource: AvatarSource;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  brandedUrl?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  displayNameSource: DisplayNameSource;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Number of users following this user */
  followersCount?: Maybe<Scalars['Long']['output']>;
  gender?: Maybe<UserGender>;
  generalLocation?: Maybe<Scalars['String']['output']>;
  instagramAvatarUrl?: Maybe<Scalars['String']['output']>;
  instagramDisplayName?: Maybe<Scalars['String']['output']>;
  instagramFollowsCount?: Maybe<Scalars['Long']['output']>;
  /** Whether the current signed-in user follows this user */
  isFollowedByCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  isVerified: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  repScore: Scalars['Int']['output'];
  /** List social media connections */
  socialMediaConnections?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  /**
   * List social media connections
   * @deprecated Use socialMediaConnections instead
   */
  socialMedias?: Maybe<Array<Maybe<SocialMediaConnection>>>;
  tier: UserTier;
  tikTokAvatarUrl?: Maybe<Scalars['String']['output']>;
  tikTokDisplayName?: Maybe<Scalars['String']['output']>;
  tikTokFollowsCount?: Maybe<Scalars['Long']['output']>;
  twitchAvatarUrl?: Maybe<Scalars['String']['output']>;
  twitchDisplayName?: Maybe<Scalars['String']['output']>;
  twitchFollowsCount?: Maybe<Scalars['Long']['output']>;
  userId: Scalars['UUID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type VerificationMethod = {
  __typename?: 'VerificationMethod';
  hint: Scalars['String']['output'];
  kind: VerificationMethodKind;
};

export enum VerificationMethodKind {
  EmailCode = 'EMAIL_CODE',
  SignInWith = 'SIGN_IN_WITH',
  SmsCode = 'SMS_CODE'
}

export type WaitingListEntry = {
  __typename?: 'WaitingListEntry';
  addedAt: Scalars['DateTime']['output'];
  user?: Maybe<CompleteUser>;
};

export type WalkthroughArgsInput = {
  status: WalkthroughStatus;
  type: WalkthroughType;
};

export enum WalkthroughStatus {
  Complete = 'COMPLETE',
  None = 'NONE',
  Pending = 'PENDING',
  Skip = 'SKIP'
}

export enum WalkthroughType {
  Achievement = 'ACHIEVEMENT',
  HomePage = 'HOME_PAGE',
  None = 'NONE',
  Pies = 'PIES',
  PieDetail = 'PIE_DETAIL',
  PieHub = 'PIE_HUB',
  RewardDetail = 'REWARD_DETAIL'
}

export type WalletBalance = {
  __typename?: 'WalletBalance';
  balance: Scalars['Decimal']['output'];
  symbol: Scalars['String']['output'];
  type: WalletBalanceType;
};

export enum WalletBalanceType {
  Fiat = 'FIAT',
  Pie = 'PIE',
  Token = 'TOKEN'
}

export type WalletMutationApi = {
  __typename?: 'WalletMutationApi';
  /**
   * JUST FOR TEST: Deposit any amount to wallet
   * @deprecated Deposit deprecated
   */
  deposit: Scalars['Boolean']['output'];
  /**
   * JUST FOR TEST: Withdraw any amount to wallet
   * @deprecated Withdraw asset deprecated
   */
  withdraw: Scalars['Boolean']['output'];
};


export type WalletMutationApiDepositArgs = {
  amount: AmountInput;
  ref: Scalars['String']['input'];
};


export type WalletMutationApiWithdrawArgs = {
  amount: AmountInput;
  ref: Scalars['String']['input'];
};

export type WalletQueryApi = {
  __typename?: 'WalletQueryApi';
  /** PLACEHOLDER: List available balances of my wallet */
  listBalance: Array<WalletBalance>;
  /**
   * PLACEHOLDER: List holding pies of my wallet
   * @deprecated Use listHoldingPies2 instead
   */
  listHoldingPies?: Maybe<PieOffsetPage>;
  /** PLACEHOLDER: List holding pies of my wallet */
  listHoldingPies2?: Maybe<PieGrainPageX>;
  /**
   * PLACEHOLDER: List trading pie transactions
   * @deprecated Use listTradingTransactions2 instead
   */
  listTradingTransactions?: Maybe<TradingTransactionOffsetPage>;
  /** PLACEHOLDER: List trading pie transactions */
  listTradingTransactions2?: Maybe<TradingTransactionGrainPageX>;
};


export type WalletQueryApiListHoldingPiesArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sortingOrder?: PageSortOrder;
  sortingType?: PieSortingType;
};


export type WalletQueryApiListHoldingPies2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  sortingOrder?: PageSortOrder;
  sortingType?: PieSortingType;
};


export type WalletQueryApiListTradingTransactionsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  onlyMyTransaction?: Scalars['Boolean']['input'];
  pieId?: InputMaybe<Scalars['UUID']['input']>;
  pieName?: InputMaybe<Scalars['String']['input']>;
};


export type WalletQueryApiListTradingTransactions2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyMyTransaction?: Scalars['Boolean']['input'];
  pieId?: InputMaybe<Scalars['UUID']['input']>;
  pieName?: InputMaybe<Scalars['String']['input']>;
};

export type WatermarkValidationResult = {
  __typename?: 'WatermarkValidationResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileExists: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
};

export enum WinnersChosenOption {
  AfterEndDate = 'AFTER_END_DATE',
  AfterStartDate = 'AFTER_START_DATE'
}

export type WinningBoostArgsInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  key: Scalars['String']['input'];
  score: Scalars['Decimal']['input'];
  type: WinningBoostType;
};

export enum WinningBoostType {
  None = 'NONE',
  SocialConnection = 'SOCIAL_CONNECTION'
}

export enum WithdrawSource {
  AvailableSalesSlices = 'AVAILABLE_SALES_SLICES',
  HoldingPieSlices = 'HOLDING_PIE_SLICES'
}

export type ZoneDeletability = {
  __typename?: 'ZoneDeletability';
  canDelete: Scalars['Boolean']['output'];
  zoneId: Scalars['UUID']['output'];
};

export type CreateOrUpdateAchievementMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
  pieId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  bio: Scalars['String']['input'];
  avatarUrl: Scalars['String']['input'];
  uploadedAssetId?: InputMaybe<Scalars['UUID']['input']>;
  maxSupply?: InputMaybe<Scalars['Int']['input']>;
  activeFromUtc?: InputMaybe<Scalars['DateTime']['input']>;
  activeToUtc?: InputMaybe<Scalars['DateTime']['input']>;
  claimByRewardId?: InputMaybe<Scalars['UUID']['input']>;
  category: AchievementCategory;
}>;


export type CreateOrUpdateAchievementMutation = { __typename?: 'Mutation', achievement: { __typename?: 'AchievementMutationApi', createOrUpdate: { __typename?: 'PublicAchievementModel', achievementId: any, displayName: string, bio: string, slug: string, createdUtc: any, avatarUrl: string, maxSupply?: number | null, activeFromUtc?: any | null, activeToUtc?: any | null } } };

export type AchievementPresignUploadUrlMutationVariables = Exact<{
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
  contentLength: Scalars['Long']['input'];
}>;


export type AchievementPresignUploadUrlMutation = { __typename?: 'Mutation', achievement: { __typename?: 'AchievementMutationApi', achievementAvatar: { __typename?: 'AchievementAvatarType', presignUploadUrl: string } } };

export type UpdateAchievementAvatarMutationVariables = Exact<{
  achievementId: Scalars['UUID']['input'];
  avatarUrl: Scalars['String']['input'];
}>;


export type UpdateAchievementAvatarMutation = { __typename?: 'Mutation', achievement: { __typename?: 'AchievementMutationApi', achievementAvatar: { __typename?: 'AchievementAvatarType', completeUpload: boolean } } };

export type DeleteAchievementMutationVariables = Exact<{
  achievementId: Scalars['UUID']['input'];
}>;


export type DeleteAchievementMutation = { __typename?: 'Mutation', achievement: { __typename?: 'AchievementMutationApi', delete: boolean } };

export type AwardAchievementMutationVariables = Exact<{
  achievementId: Scalars['UUID']['input'];
  pieId?: InputMaybe<Scalars['UUID']['input']>;
  userName: Scalars['String']['input'];
}>;


export type AwardAchievementMutation = { __typename?: 'Mutation', achievement: { __typename?: 'AchievementMutationApi', award: boolean } };

export type CompleteClubImageUploadMutationVariables = Exact<{
  clubId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
  type: ClubUploadAsset;
}>;


export type CompleteClubImageUploadMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', completeUpload: boolean } };

export type ShareContactsMutationVariables = Exact<{
  targetUserId: Scalars['UUID']['input'];
  contactIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ShareContactsMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', shareContacts: { __typename?: 'ContactShareResult', inviteId: any, inviteToken: string } } };

export type AcceptContactShareMutationVariables = Exact<{
  inviteToken: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
}>;


export type AcceptContactShareMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', acceptContactShare: { __typename?: 'AcceptContactShareResult', jobId: string } } };

export type AddContactsToGroupMutationVariables = Exact<{
  groupId: Scalars['UUID']['input'];
  filter?: InputMaybe<ContactPageFilterArgsInput>;
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type AddContactsToGroupMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', addContactsToGroup: boolean } };

export type DeleteContactsFromGroupMutationVariables = Exact<{
  groupId: Scalars['UUID']['input'];
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  filter?: InputMaybe<ContactPageFilterArgsInput>;
}>;


export type DeleteContactsFromGroupMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', deleteContactsFromGroup: boolean } };

export type CreateOrUpdateGroupMutationVariables = Exact<{
  args: GroupModelArgsInput;
}>;


export type CreateOrUpdateGroupMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', createOrUpdateGroup?: { __typename?: 'ContactGroup', groupName: string, groupId: any } | null } };

export type CreateOrUpdateContactMutationVariables = Exact<{
  args: ContactModelArgsInput;
}>;


export type CreateOrUpdateContactMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', createOrUpdateContact?: { __typename?: 'Contact', contactId: any, emailAddress?: string | null, name?: string | null, phoneNumber?: string | null, userId?: any | null } | null } };

export type CreateOrUpdateContactsMutationVariables = Exact<{
  contacts: Array<ContactModelArgsInput> | ContactModelArgsInput;
}>;


export type CreateOrUpdateContactsMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', createOrUpdateContacts?: Array<{ __typename?: 'ContactMutation', contactId?: any | null, emailAddress?: string | null, name?: string | null, phoneNumber?: string | null, gender?: UserGender | null, dateOfBirth?: any | null, customFields?: Array<{ __typename?: 'ContactCustomField', key: string, label: string, value: string }> | null, mutationResult: { __typename?: 'MutationResult', reason?: string | null, status: MutationStatus } } | null> | null } };

export type DeleteContactsMutationVariables = Exact<{
  filter?: InputMaybe<ContactPageFilterArgsInput>;
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type DeleteContactsMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', deleteContacts: boolean } };

export type DeleteContactGroupMutationVariables = Exact<{
  groupId: Scalars['UUID']['input'];
}>;


export type DeleteContactGroupMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', deleteGroup: boolean } };

export type BulkDeleteContactsMutationVariables = Exact<{
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  filter?: InputMaybe<ContactPageFilterArgsInput>;
}>;


export type BulkDeleteContactsMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', bulkDeleteContacts: { __typename?: 'ContactBulkDeleteJobResult', jobId: string, totalCount: number } } };

export type SendMessageToContactsMutationVariables = Exact<{
  message: Scalars['String']['input'];
  isViaEmail: Scalars['Boolean']['input'];
  isViaSms: Scalars['Boolean']['input'];
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  filter?: InputMaybe<ContactPageFilterArgsInput>;
  smsMessage?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendMessageToContactsMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', sendMessageToContacts: { __typename?: 'ContactMessageJobResult', jobId: string, totalCount: number } } };

export type ImportContactsCsvMutationVariables = Exact<{
  csvContent: Scalars['String']['input'];
  mappings: ContactFieldMappingDtoInput;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImportContactsCsvMutation = { __typename?: 'Mutation', contactList: { __typename?: 'ContactListMutationApi', importContactsCsv: { __typename?: 'ContactImportJobResult', jobId: string, totalRows: number } } };

export type CreateOrUpdateEventMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
  eventType: EventType;
  slug: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  terms?: InputMaybe<Scalars['String']['input']>;
  faqs?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  avatarUrl: Scalars['String']['input'];
  exclusiveAvatarUrl?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  coHostUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  promoterUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  sponsorUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  doorUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  coordinatorUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  talentUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  talentOrder?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  location?: InputMaybe<EventLocationInput>;
  eventTickets?: InputMaybe<Array<EventTicketArgsInput> | EventTicketArgsInput>;
  invitations?: InputMaybe<Array<EventInvitationSourceArgsInput> | EventInvitationSourceArgsInput>;
  minimumRepScore?: InputMaybe<Scalars['Decimal']['input']>;
  optInShowGuestList: Scalars['Boolean']['input'];
  optInShowGuestCount: Scalars['Boolean']['input'];
  optInAllowPublicEventPagePreview: Scalars['Boolean']['input'];
  optInDisplayRepScore: Scalars['Boolean']['input'];
  optInAllowGuestInviteOthers: Scalars['Boolean']['input'];
  optInLocationRadius: Scalars['Boolean']['input'];
  locationRadius?: InputMaybe<EventLocationInput>;
  optInAgeLimit: Scalars['Boolean']['input'];
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  optInDisclosureOrPrivacyPolicy: Scalars['Boolean']['input'];
  disclosureOrPrivacyPolicyTitle?: InputMaybe<Scalars['String']['input']>;
  disclosureOrPrivacyPolicyFileUrl?: InputMaybe<Scalars['String']['input']>;
  optInSocialAccountRequirements: Scalars['Boolean']['input'];
  socialAccountRequirements?: InputMaybe<Array<SocialAccountRequirementInput> | SocialAccountRequirementInput>;
  requireSocialAccountConnection: Scalars['Boolean']['input'];
  optInQuestionRequirements: Scalars['Boolean']['input'];
  questionRequirements?: InputMaybe<Array<QuestionRequirementInput> | QuestionRequirementInput>;
  uploadedAssetId?: InputMaybe<Scalars['UUID']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  eventTimeZoneId?: InputMaybe<Scalars['String']['input']>;
  isAllInPricing: Scalars['Boolean']['input'];
  scanningZones?: InputMaybe<Array<ScanningZoneInput> | ScanningZoneInput>;
  optInShowMusicEmbed: Scalars['Boolean']['input'];
  musicEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  isListed?: InputMaybe<Scalars['Boolean']['input']>;
  ticketTermsPurchasePolicy?: InputMaybe<Scalars['String']['input']>;
  pendingRoleDeleteArgs?: InputMaybe<Array<EventAttendeeRoleDeleteArgsInput> | EventAttendeeRoleDeleteArgsInput>;
  clubSlugOrId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  eligibilityCriteria?: InputMaybe<EventEligibilityCriteriaInput>;
  faqEntries?: InputMaybe<Array<FaqEntryInput> | FaqEntryInput>;
  eventSeriesId?: InputMaybe<Scalars['UUID']['input']>;
  copiedFromEventSlugOrId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrUpdateEventMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', createOrUpdate: { __typename?: 'PublicEventModel', eventId: any, eventType: EventType, displayName: string, expiresAt?: any | null, status: EventStatus, isPrivate: boolean, uploadedAssetId?: any | null, avatarUrl: string, exclusiveAvatarUrl?: string | null, minimumRepScore?: any | null, optInShowGuestList: boolean, optInShowGuestCount: boolean, slug: string, optInDisplayRepScore: boolean, optInAllowGuestInviteOthers: boolean, optInLocationRadius: boolean, optInAgeLimit: boolean, ageLimit?: number | null, optInDisclosureOrPrivacyPolicy: boolean, disclosureOrPrivacyPolicyTitle?: string | null, disclosureOrPrivacyPolicyFileUrl?: string | null, optInSocialAccountRequirements: boolean, requireSocialAccountConnection: boolean, optInQuestionRequirements: boolean, isFeatured: boolean, description: string, note: string, startDate: any, endDate: any, timeZone?: string | null, isAllInPricing?: boolean | null, clubId?: any | null, location?: { __typename?: 'EventLocation', locationName?: string | null, longitude?: number | null, latitude?: number | null, address?: string | null, region?: string | null, city?: string | null, postalCode?: string | null, countryCode?: string | null, isOnlyVisibleToApprovedAttendees?: boolean | null } | null, locationRadius?: { __typename?: 'EventLocation', address?: string | null, isActive?: boolean | null, latitude?: number | null, longitude?: number | null, radius?: number | null, unitLengthType?: EventLocationUnitLengthType | null } | null, socialAccountRequirements?: Array<{ __typename?: 'SocialAccountRequirement', scheme: string, isRequired: boolean }> | null, questionRequirements?: Array<{ __typename?: 'QuestionRequirement', question: string, isRequired: boolean }> | null } } };

export type CreateRecurringEventMutationVariables = Exact<{
  eventType: EventType;
  slug: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  note: Scalars['String']['input'];
  avatarUrl: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  coHostUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  promoterUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  sponsorUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  doorUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  coordinatorUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  talentUserIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  talentOrder?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  location?: InputMaybe<EventLocationInput>;
  eventTickets?: InputMaybe<Array<EventTicketArgsInput> | EventTicketArgsInput>;
  invitations?: InputMaybe<Array<EventInvitationSourceArgsInput> | EventInvitationSourceArgsInput>;
  minimumRepScore?: InputMaybe<Scalars['Decimal']['input']>;
  optInShowGuestList: Scalars['Boolean']['input'];
  optInShowGuestCount: Scalars['Boolean']['input'];
  optInAllowPublicEventPagePreview: Scalars['Boolean']['input'];
  optInDisplayRepScore: Scalars['Boolean']['input'];
  optInAllowGuestInviteOthers: Scalars['Boolean']['input'];
  optInLocationRadius: Scalars['Boolean']['input'];
  locationRadius?: InputMaybe<EventLocationInput>;
  optInAgeLimit: Scalars['Boolean']['input'];
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  optInDisclosureOrPrivacyPolicy: Scalars['Boolean']['input'];
  disclosureOrPrivacyPolicyTitle?: InputMaybe<Scalars['String']['input']>;
  disclosureOrPrivacyPolicyFileUrl?: InputMaybe<Scalars['String']['input']>;
  optInSocialAccountRequirements: Scalars['Boolean']['input'];
  socialAccountRequirements?: InputMaybe<Array<SocialAccountRequirementInput> | SocialAccountRequirementInput>;
  requireSocialAccountConnection: Scalars['Boolean']['input'];
  optInQuestionRequirements: Scalars['Boolean']['input'];
  questionRequirements?: InputMaybe<Array<QuestionRequirementInput> | QuestionRequirementInput>;
  uploadedAssetId?: InputMaybe<Scalars['UUID']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  eventTimeZoneId?: InputMaybe<Scalars['String']['input']>;
  isAllInPricing: Scalars['Boolean']['input'];
  recurringInfo: RecurringEventInfoArgsInput;
  scanningZones?: InputMaybe<Array<ScanningZoneInput> | ScanningZoneInput>;
  optInShowMusicEmbed: Scalars['Boolean']['input'];
  musicEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  isListed?: InputMaybe<Scalars['Boolean']['input']>;
  ticketTermsPurchasePolicy?: InputMaybe<Scalars['String']['input']>;
  clubSlugOrId?: InputMaybe<Scalars['String']['input']>;
  eventSeriesId?: InputMaybe<Scalars['UUID']['input']>;
  copiedFromEventSlugOrId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateRecurringEventMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', createRecurringEvent: { __typename?: 'PublicEventModel', eventId: any, eventType: EventType, displayName: string, expiresAt?: any | null, status: EventStatus, isPrivate: boolean, uploadedAssetId?: any | null, avatarUrl: string, minimumRepScore?: any | null, optInShowGuestList: boolean, optInShowGuestCount: boolean, slug: string, optInDisplayRepScore: boolean, optInAllowGuestInviteOthers: boolean, optInLocationRadius: boolean, optInAgeLimit: boolean, ageLimit?: number | null, optInDisclosureOrPrivacyPolicy: boolean, disclosureOrPrivacyPolicyTitle?: string | null, disclosureOrPrivacyPolicyFileUrl?: string | null, optInSocialAccountRequirements: boolean, requireSocialAccountConnection: boolean, optInQuestionRequirements: boolean, isFeatured: boolean, description: string, note: string, startDate: any, endDate: any, timeZone?: string | null, isAllInPricing?: boolean | null, clubId?: any | null, location?: { __typename?: 'EventLocation', locationName?: string | null, longitude?: number | null, latitude?: number | null, address?: string | null, region?: string | null, city?: string | null, postalCode?: string | null, countryCode?: string | null, isOnlyVisibleToApprovedAttendees?: boolean | null } | null, locationRadius?: { __typename?: 'EventLocation', address?: string | null, isActive?: boolean | null, latitude?: number | null, longitude?: number | null, radius?: number | null, unitLengthType?: EventLocationUnitLengthType | null } | null, socialAccountRequirements?: Array<{ __typename?: 'SocialAccountRequirement', scheme: string, isRequired: boolean }> | null, questionRequirements?: Array<{ __typename?: 'QuestionRequirement', question: string, isRequired: boolean }> | null } } };

export type RsvpForEventMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  accept: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  questionRequirementAnswers?: InputMaybe<Array<QuestionRequirementAnswerInput> | QuestionRequirementAnswerInput>;
}>;


export type RsvpForEventMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', rsvpForEvent: EventAttendeeState } };

export type AnswerQuestionRequirementsMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  questionRequirementAnswers: Array<QuestionRequirementAnswerInput> | QuestionRequirementAnswerInput;
}>;


export type AnswerQuestionRequirementsMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', answerQuestionRequirements: boolean } };

export type ApproveBookingMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  transactionId?: InputMaybe<Scalars['UUID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  forceRelease: Scalars['Boolean']['input'];
  filterArgs?: InputMaybe<DetailsAttendeeFilterArgsInput>;
}>;


export type ApproveBookingMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', approve: number } };

export type DeclineBookingMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  transactionId?: InputMaybe<Scalars['UUID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeclineBookingMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', decline: number } };

export type PurchaseTicketMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  eventId: Scalars['UUID']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
  contestEntry?: InputMaybe<Scalars['Boolean']['input']>;
  orderReferenceId?: InputMaybe<Scalars['String']['input']>;
  memberEventId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type PurchaseTicketMutation = { __typename?: 'Mutation', eventTicket: { __typename?: 'EventTicketMutationApi', purchaseTicket: { __typename?: 'TransactionOperationResult', message: string, success: boolean } } };

export type SaveGuestListMutationVariables = Exact<{
  guestList: SaveGuestListArgsInput;
}>;


export type SaveGuestListMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', saveGuestList: string } };

export type RemoveSavedListMutationVariables = Exact<{
  listName: Scalars['String']['input'];
}>;


export type RemoveSavedListMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', removeGuestList: boolean } };

export type ConfirmEventPrivacyPolicyMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  privacyPolicyState: EventPrivacyPolicyState;
  disclosureType?: InputMaybe<DisclosureType>;
  signatoryName?: InputMaybe<Scalars['String']['input']>;
  signatureData?: InputMaybe<Scalars['String']['input']>;
  memberEventId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ConfirmEventPrivacyPolicyMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', confirmEventPrivacyPolicy: { __typename?: 'ConfirmEventPrivacyPolicyResult', referenceId: string, signedDisclosureFileUrl?: string | null } } };

export type SendEventMessageGroupMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  isViaEmail: Scalars['Boolean']['input'];
  isViaSms: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  smsMessage?: InputMaybe<Scalars['String']['input']>;
  filterArgs?: InputMaybe<EventMessageFilterArgsInput>;
}>;


export type SendEventMessageGroupMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', sendMessageGroup: boolean } };

export type ScheduleEventMessageMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  input: ScheduleEventMessageInput;
}>;


export type ScheduleEventMessageMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', scheduleEventMessage: { __typename?: 'ScheduledMessageModel', id: any, message: string, smsMessage?: string | null, sendAt: any, isViaEmail: boolean, isViaSms: boolean, status: ScheduledMessageStatus, createdBy: any, createdAt: any, sentAt?: any | null, canceledAt?: any | null, canceledBy?: any | null, updatedAt?: any | null, updatedBy?: any | null, filterArgs: { __typename?: 'EventMessageFilterArgs', eventMessageType: EventMessageType, eventTicketIds?: Array<any> | null, eventAttendeeRoles?: Array<EventAttendeeRole> | null, attendeeStatuses?: Array<SendMessageGroupAttendeeStatus> | null } } } };

export type UpdateScheduledEventMessageMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  scheduledMessageId: Scalars['UUID']['input'];
  input: ScheduleEventMessageInput;
}>;


export type UpdateScheduledEventMessageMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', updateScheduledEventMessage: { __typename?: 'ScheduledMessageModel', id: any, message: string, smsMessage?: string | null, sendAt: any, isViaEmail: boolean, isViaSms: boolean, status: ScheduledMessageStatus, createdBy: any, createdAt: any, sentAt?: any | null, canceledAt?: any | null, canceledBy?: any | null, updatedAt?: any | null, updatedBy?: any | null, filterArgs: { __typename?: 'EventMessageFilterArgs', eventMessageType: EventMessageType, eventTicketIds?: Array<any> | null, eventAttendeeRoles?: Array<EventAttendeeRole> | null, attendeeStatuses?: Array<SendMessageGroupAttendeeStatus> | null } } } };

export type CancelScheduledEventMessageMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  scheduledMessageId: Scalars['UUID']['input'];
}>;


export type CancelScheduledEventMessageMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', cancelScheduledEventMessage: boolean } };

export type IncreaseMaxTicketsAmountMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  args: Array<IncreaseTicketsAmountArgsInput> | IncreaseTicketsAmountArgsInput;
}>;


export type IncreaseMaxTicketsAmountMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', increaseMaxTicketsAmount: boolean } };

export type DeleteEventMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', delete: boolean } };

export type DeleteEventTicketMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  eventTicketId: Scalars['UUID']['input'];
}>;


export type DeleteEventTicketMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', deleteEventTicket: boolean } };

export type CommentEventMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  content: Scalars['String']['input'];
  parentCommentId?: InputMaybe<Scalars['UUID']['input']>;
  medias?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CommentEventMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', comment?: { __typename?: 'EventComment', commentId: any, createdAt: any } | null } };

export type ReactEventCommentMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  commentId: Scalars['UUID']['input'];
  reaction: Scalars['String']['input'];
}>;


export type ReactEventCommentMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', reactComment?: { __typename?: 'EventCommentReaction', reactionId: any } | null } };

export type RemoveCommentReactionMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  commentId: Scalars['UUID']['input'];
  reactionId: Scalars['UUID']['input'];
}>;


export type RemoveCommentReactionMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', removeCommentReaction: boolean } };

export type InviteFromContactsMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  inviteAll: Scalars['Boolean']['input'];
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  giftTicketsArgs?: InputMaybe<GiftTicketsArgsInput>;
  privateTicketsArgs?: InputMaybe<PrivateTicketsArgsInput>;
  contactPageFilterArgs?: InputMaybe<ContactPageFilterArgsInput>;
  invitationMessage?: InputMaybe<Scalars['String']['input']>;
  confirmedDoNotResendContactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  confirmedResendContactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  ignoreExistingAttendees: Scalars['Boolean']['input'];
  isViaSms: Scalars['Boolean']['input'];
}>;


export type InviteFromContactsMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', inviteFromContacts2: { __typename?: 'InviteFromContactResult', submittedContacts: number, sentContacts: number, resentContacts: number, success: boolean, confirmingContacts?: Array<{ __typename?: 'ConfirmingContact', invitee: { __typename?: 'Contact', contactId: any, emailAddress?: string | null, name?: string | null, phoneNumber?: string | null, userId?: any | null, userInfo?: { __typename?: 'UserWithAddress', name?: string | null, userName?: string | null } | null }, inviter?: { __typename?: 'UserWithAddress', name?: string | null, userId: any, userName?: string | null } | null }> | null } } };

export type StartBulkInviteMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  inviteAll: Scalars['Boolean']['input'];
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  giftTicketsArgs?: InputMaybe<GiftTicketsArgsInput>;
  privateTicketsArgs?: InputMaybe<PrivateTicketsArgsInput>;
  contactPageFilterArgs?: InputMaybe<ContactPageFilterArgsInput>;
  invitationMessage?: InputMaybe<Scalars['String']['input']>;
  smsMessage?: InputMaybe<Scalars['String']['input']>;
  includeAlreadyInvited: Scalars['Boolean']['input'];
  isViaSms: Scalars['Boolean']['input'];
}>;


export type StartBulkInviteMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', startBulkInvite: string } };

export type ConnectSocialNetworkToEventMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  scheme: Scalars['String']['input'];
}>;


export type ConnectSocialNetworkToEventMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', connectSocialAccount: boolean } };

export type UndoFreeTicketApprovalMutationVariables = Exact<{
  transactionId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
}>;


export type UndoFreeTicketApprovalMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', undoFreeTicketApproval: boolean } };

export type AddDoorRoleMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type AddDoorRoleMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', addDoorRole: boolean } };

export type RemoveDoorRoleMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
}>;


export type RemoveDoorRoleMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', removeDoorRole: boolean } };

export type VerifyTicketMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  ticketId: Scalars['String']['input'];
  scanningZoneId: Scalars['UUID']['input'];
}>;


export type VerifyTicketMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', verifyTicket?: { __typename?: 'TicketVerifyResult', status: TicketVerifyStatus, scanCount: number, firstSeen: any, ticketId: string, message?: string | null } | null } };

export type AddAttendeeRoleMutationVariables = Exact<{
  attendeeRole: EventAttendeeRole;
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type AddAttendeeRoleMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', addAttendeeRole: boolean } };

export type AddCoHostMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type AddCoHostMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', addCoHost: boolean } };

export type AddPromoterMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type AddPromoterMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', addPromoter: boolean } };

export type RemoveAttendeeRoleMutationVariables = Exact<{
  attendeeRole: EventAttendeeRole;
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type RemoveAttendeeRoleMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', removeAttendeeRole: boolean } };

export type RemoveCoHostMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type RemoveCoHostMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', removeCoHost: boolean } };

export type RemovePromoterMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type RemovePromoterMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', removePromoter: boolean } };

export type GrantTicketsMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  receiverId: Scalars['UUID']['input'];
  totalRequestTickets: Scalars['Int']['input'];
  ticketId: Scalars['UUID']['input'];
}>;


export type GrantTicketsMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', grantTickets: boolean } };

export type ApproveAttendeeMutationVariables = Exact<{
  attendeeId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  forceRelease: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApproveAttendeeMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', approveAttendee: { __typename?: 'AttendeeApprovalResponse', failedReasons: Array<string>, result: AttendeeApprovalResult, totalFailedBookings: number, totalProcessedBookings: number, totalProcessingBookings: number, totalSkippedBookings: number } } };

export type DeclineAttendeeMutationVariables = Exact<{
  attendeeId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeclineAttendeeMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', declineAttendee: { __typename?: 'AttendeeApprovalResponse', failedReasons: Array<string>, result: AttendeeApprovalResult, totalFailedBookings: number, totalProcessedBookings: number, totalProcessingBookings: number, totalSkippedBookings: number } } };

export type UndoAttendeeMutationVariables = Exact<{
  attendeeId: Scalars['UUID']['input'];
  eventId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type UndoAttendeeMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', undoAttendee: { __typename?: 'AttendeeApprovalResponse', failedReasons: Array<string>, result: AttendeeApprovalResult, totalFailedBookings: number, totalProcessedBookings: number, totalProcessingBookings: number, totalSkippedBookings: number } } };

export type DeleteFreeTicketMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  transactionId: Scalars['UUID']['input'];
  ticketId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type DeleteFreeTicketMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', deleteFreeTicket: boolean } };

export type ShareTicketMutationVariables = Exact<{
  shareTicketArgs: ShareTicketArgsInput;
}>;


export type ShareTicketMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', shareTicket: boolean } };

export type RequestEventPayout2MutationVariables = Exact<{
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestEventPayout2Mutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', requestEventPayout2: boolean } };

export type AddEventGuestMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  guest: EventGuestInfoArgsInput;
  tickets: Array<AddEventGuestTicketArgsInput> | AddEventGuestTicketArgsInput;
}>;


export type AddEventGuestMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', addEventGuest: any } };

export type AddEventGuestsMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  guests: Array<AddEventGuestRowArgsInput> | AddEventGuestRowArgsInput;
}>;


export type AddEventGuestsMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', addEventGuests: { __typename?: 'AddGuestsResult', sucessfulRefs: Array<string>, failedRefs: Array<string> } } };

export type DeleteEventGuestMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
}>;


export type DeleteEventGuestMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', deleteEventGuest: boolean } };

export type AddEventGuestTicketMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  ticket: AddEventGuestTicketArgsInput;
}>;


export type AddEventGuestTicketMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', addEventGuestTicket: boolean } };

export type DeleteEventGuestTicketMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
}>;


export type DeleteEventGuestTicketMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', deleteEventGuestTicket: boolean } };

export type AddGuestQrPassMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  args: AddGuestQrPassArgsInput;
}>;


export type AddGuestQrPassMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', addGuestQrPass: any } };

export type ShareGuestQrMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  sendEmail: Scalars['Boolean']['input'];
  sendText: Scalars['Boolean']['input'];
}>;


export type ShareGuestQrMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', shareGuestQr: boolean } };

export type CheckInEventGuestTicketMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
}>;


export type CheckInEventGuestTicketMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', checkInEventGuestTicket: boolean } };

export type CreatePaymentOrderMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
}>;


export type CreatePaymentOrderMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', createPaymentOrder: string } };

export type UpdateEventGuestMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  guestInfo: EventGuestInfoArgsInput;
  ticket?: InputMaybe<AddEventGuestTicketArgsInput>;
}>;


export type UpdateEventGuestMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', updateEventGuest: boolean } };

export type UpdateEventGuestTicketMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
  ticket: EventGuestTicketArgsInput;
}>;


export type UpdateEventGuestTicketMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', updateEventGuestTicket: boolean } };

export type UndoCheckInEventGuestTicketMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
}>;


export type UndoCheckInEventGuestTicketMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', undoCheckInEventGuestTicket: boolean } };

export type JoinEventTicketWaitingListMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  eventTicketId: Scalars['UUID']['input'];
}>;


export type JoinEventTicketWaitingListMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', joinEventTicketWaitingList: boolean } };

export type GenerateInviteLinkMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  privateTicketsArgs?: InputMaybe<PrivateTicketsArgsInput>;
}>;


export type GenerateInviteLinkMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', generateInviteLink: any } };

export type ChangeDisplayTicketsMutationVariables = Exact<{
  changes: Array<ChangeDisplayTicketIdInput> | ChangeDisplayTicketIdInput;
  eventId: Scalars['UUID']['input'];
}>;


export type ChangeDisplayTicketsMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', changeDisplayTickets: boolean } };

export type ChangeTicketToSeriesPassMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  ticketId: Scalars['UUID']['input'];
  seriesPassTicketId: Scalars['UUID']['input'];
}>;


export type ChangeTicketToSeriesPassMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', changeTicketToSeriesPass: boolean } };

export type SendSignedDisclosureCopyMutationVariables = Exact<{
  emailAddresses: Array<Scalars['String']['input']> | Scalars['String']['input'];
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type SendSignedDisclosureCopyMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', sendSignedDisclosureCopy: boolean } };

export type GenerateTicketQrCodeMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  ticketId: Scalars['String']['input'];
}>;


export type GenerateTicketQrCodeMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', generateTicketQrCode: { __typename?: 'QrCodeModel', id: any, qrCode: string, userTicketId: any, eventTicketId?: any | null, expiresAt: any, firstSeen?: any | null, count: number, ticketId: string } } };

export type RemoveInviteMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  userKey: Scalars['String']['input'];
  attendeeRole: EventAttendeeRole;
}>;


export type RemoveInviteMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', removePendingRole: boolean } };

export type GenerateSharableTicketLinkMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  ticketId: Scalars['String']['input'];
  landingEventId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GenerateSharableTicketLinkMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', generateShareTicketLink: string } };

export type LinkClubOffersMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  clubId: Scalars['UUID']['input'];
  offerIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type LinkClubOffersMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', linkClubOffers: { __typename?: 'LinkClubOfferResult', success: boolean } } };

export type GetAppleWalletPassDownloadTokenMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  ticketId: Scalars['String']['input'];
}>;


export type GetAppleWalletPassDownloadTokenMutation = { __typename?: 'Mutation', eventTicket: { __typename?: 'EventTicketMutationApi', appleWalletDownloadToken?: string | null } };

export type TrackShareLinkViewMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  refCode: Scalars['String']['input'];
  viewSource?: InputMaybe<AttributionChannel>;
}>;


export type TrackShareLinkViewMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', trackShareLinkView: boolean } };

export type EnterContestMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type EnterContestMutation = { __typename?: 'Mutation', eventTicket: { __typename?: 'EventTicketMutationApi', enterContest: { __typename?: 'TransactionOperationResult', message: string, success: boolean } } };

export type SendHostMessageMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  body: Scalars['String']['input'];
}>;


export type SendHostMessageMutation = { __typename?: 'Mutation', hostMessage: { __typename?: 'HostMessageMutationApi', send: { __typename?: 'SendHostMessageResult', messageId: any, threadId: any, sentAt: any } } };

export type MarkHostMessageReadMutationVariables = Exact<{
  messageId: Scalars['UUID']['input'];
}>;


export type MarkHostMessageReadMutation = { __typename?: 'Mutation', hostMessage: { __typename?: 'HostMessageMutationApi', markRead: boolean } };

export type MarkHostMessageUnreadMutationVariables = Exact<{
  messageId: Scalars['UUID']['input'];
}>;


export type MarkHostMessageUnreadMutation = { __typename?: 'Mutation', hostMessage: { __typename?: 'HostMessageMutationApi', markUnread: boolean } };

export type ReplyHostMessageMutationVariables = Exact<{
  messageId: Scalars['UUID']['input'];
  body: Scalars['String']['input'];
}>;


export type ReplyHostMessageMutation = { __typename?: 'Mutation', hostMessage: { __typename?: 'HostMessageMutationApi', reply: { __typename?: 'SendHostMessageResult', messageId: any, threadId: any, sentAt: any } } };

export type ReadNotificationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', notification: { __typename?: 'NotificationApi', read: boolean } };

export type ReadAllNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllNotificationMutation = { __typename?: 'Mutation', notification: { __typename?: 'NotificationApi', readAll: boolean } };

export type ClubBySlugCreateOfferMutationVariables = Exact<{
  payload: CreateOfferPayloadInput;
  slug: Scalars['String']['input'];
}>;


export type ClubBySlugCreateOfferMutation = { __typename?: 'Mutation', clubBySlug: { __typename?: 'ClubMutation', createOffer: { __typename?: 'CreateOfferResult', offerId: any, rewardIds: Array<any> } } };

export type ClubBySlugUpdateOfferMutationVariables = Exact<{
  payload: UpdateOfferPayloadInput;
  offerId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
}>;


export type ClubBySlugUpdateOfferMutation = { __typename?: 'Mutation', clubBySlug: { __typename?: 'ClubMutation', offerById: { __typename?: 'OfferMutator', updateOffer: boolean } } };

export type CreateAchievementMutationVariables = Exact<{
  payload: CreateAchievementPayloadInput;
  clubId: Scalars['UUID']['input'];
}>;


export type CreateAchievementMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', createAchievement: { __typename?: 'CreateAchievementResult', achievementId: any } } };

export type UpdateAchievementMutationVariables = Exact<{
  payload: UpdateAchievementPayloadInput;
  clubId: Scalars['UUID']['input'];
  achievementId: Scalars['UUID']['input'];
}>;


export type UpdateAchievementMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', achievementById: { __typename?: 'AchievementMutator', updateAchievement: boolean } } };

export type PurchaseOfferMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  offerId: Scalars['UUID']['input'];
  clubId: Scalars['UUID']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
}>;


export type PurchaseOfferMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', offerById: { __typename?: 'OfferMutator', purchaseOffer: { __typename?: 'TransactionOperationResult', transactionStatus: TransactionStatus, success: boolean, message: string, exMessage?: string | null } } } };

export type PurchaseOfferCreatePaymentOrderMutationVariables = Exact<{
  offerId: Scalars['UUID']['input'];
  clubId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
}>;


export type PurchaseOfferCreatePaymentOrderMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', offerById: { __typename?: 'OfferMutator', createPaymentOrder: string } } };

export type OfferGenerateWinnersMutationVariables = Exact<{
  offerId: Scalars['UUID']['input'];
  clubId: Scalars['UUID']['input'];
}>;


export type OfferGenerateWinnersMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', offerById: { __typename?: 'OfferMutator', generateWinners: Array<any> } } };

export type SubmitRedeemContactInfoMutationVariables = Exact<{
  args: SubmitRedeemOfferContactInfoArgsInput;
  offerId: Scalars['UUID']['input'];
  clubId: Scalars['UUID']['input'];
}>;


export type SubmitRedeemContactInfoMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', offerById: { __typename?: 'OfferMutator', submitRedeemContactInfo: boolean } } };

export type RedeemClubOfferMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type RedeemClubOfferMutation = { __typename?: 'Mutation', redeemClubOffer?: { __typename?: 'RedeemOfferResult', isValid: boolean, redeemedCount: number, rejectionReason: RewardOfferRedemptionRejectionReason, redemption?: { __typename?: 'AccessPassRewardRedemption', code: string, guide?: string | null, isGenerated: boolean, note?: string | null, redemptionType: RewardRedemptionType } | { __typename?: 'CustomerInformationRewardRedemption', guide?: string | null, note?: string | null, redemptionType: RewardRedemptionType } | { __typename?: 'InviteLinkRewardRedemption', code: string, guide?: string | null, isGenerated: boolean, link: string, note?: string | null, redemptionType: RewardRedemptionType } | { __typename?: 'LocationInformationRewardRedemption', code: string, guide?: string | null, isGenerated: boolean, note?: string | null, redemptionType: RewardRedemptionType } | { __typename?: 'PromoCodeRewardRedemption', code: string, guide?: string | null, isGenerated: boolean, note?: string | null, redemptionType: RewardRedemptionType } | null, club?: { __typename?: 'ClubState', clubId: any } | null, offer?: { __typename?: 'ClubOfferState', offerId: any } | null } | null };

export type OfferInviteFromContactsMutationVariables = Exact<{
  inviteAll: Scalars['Boolean']['input'];
  offerId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
  confirmedDoNotResendContactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  confirmedResendContactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  contactIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  contactPageFilterArgs?: InputMaybe<ContactPageFilterArgsInput>;
  invitationMessage?: InputMaybe<Scalars['String']['input']>;
  isViaSms: Scalars['Boolean']['input'];
}>;


export type OfferInviteFromContactsMutation = { __typename?: 'Mutation', clubBySlug: { __typename?: 'ClubMutation', offerById: { __typename?: 'OfferMutator', inviteFromContacts: { __typename?: 'InviteFromContactResult', resentContacts: number, sentContacts: number, submittedContacts: number, success: boolean, confirmingContacts?: Array<{ __typename?: 'ConfirmingContact', invitee: { __typename?: 'Contact', contactId: any, emailAddress?: string | null, name?: string | null, phoneNumber?: string | null, userId?: any | null, userInfo?: { __typename?: 'UserWithAddress', name?: string | null, userName?: string | null } | null }, inviter?: { __typename?: 'UserWithAddress', name?: string | null, userId: any, userName?: string | null } | null }> | null } } } };

export type ProcessCreatePieMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type ProcessCreatePieMutation = { __typename?: 'Mutation', paypal: { __typename?: 'PaypalMutationApi', processCreatePie: { __typename?: 'OperationResult', success: boolean, message: string } } };

export type ProcessPurchasePieMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProcessPurchasePieMutation = { __typename?: 'Mutation', paypal: { __typename?: 'PaypalMutationApi', processPurchasePie: { __typename?: 'OperationResult', success: boolean, message: string } } };

export type UpgradePieOrderMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  slices: Scalars['Decimal']['input'];
}>;


export type UpgradePieOrderMutation = { __typename?: 'Mutation', paypal: { __typename?: 'PaypalMutationApi', upgradePieOrder: string } };

export type UpgradePieMutationVariables = Exact<{
  paypalOrderId: Scalars['String']['input'];
}>;


export type UpgradePieMutation = { __typename?: 'Mutation', paypal: { __typename?: 'PaypalMutationApi', processUpgradePie: { __typename?: 'OperationResult', success: boolean, message: string } } };

export type CreateOrUpdatePieMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
  displayName: Scalars['String']['input'];
  individualAssetIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
  bio: Scalars['String']['input'];
  issuedSlices: Scalars['Decimal']['input'];
  socialMedia: Array<SocialMediaPairInput> | SocialMediaPairInput;
  slicePrice: AmountInput;
  availableSlices: Scalars['Decimal']['input'];
}>;


export type CreateOrUpdatePieMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', createOrUpdate: { __typename?: 'PublicPieModel', pieId: any, displayName: string, slug: string, bio?: string | null, isVerified: boolean, issuedSlices: any, holdingSlices: any, slicesHeld: any, individualAssets?: Array<any> | null, pieAvatarUrl: string, canBuy: boolean, canSell: boolean, createdUtc: any, floatPercentage: any, socialMedia: Array<{ __typename?: 'SocialMediaPair', value: string, scheme: string }>, slicePrice: { __typename?: 'Amount', symbol: string, value: any }, initialOffer?: { __typename?: 'PublicPieInitialOfferModel', maximumPurchaseVolume: any, minimumPurchaseVolume: any, purchaseMultiple: any } | null, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, isVerified: boolean, tier: UserTier } | null, totalValue: { __typename?: 'Amount', symbol: string, value: any } } } };

export type UpdateBasicPieInfoMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  displayName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  bio: Scalars['String']['input'];
}>;


export type UpdateBasicPieInfoMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', updateBasicInfo: { __typename?: 'PublicPieModel', pieId: any, displayName: string, slug: string, bio?: string | null, isVerified: boolean, issuedSlices: any, holdingSlices: any, slicesHeld: any, individualAssets?: Array<any> | null, pieAvatarUrl: string, canBuy: boolean, canSell: boolean, createdUtc: any, floatPercentage: any, socialMedia: Array<{ __typename?: 'SocialMediaPair', value: string, scheme: string }>, slicePrice: { __typename?: 'Amount', symbol: string, value: any }, initialOffer?: { __typename?: 'PublicPieInitialOfferModel', maximumPurchaseVolume: any, minimumPurchaseVolume: any, purchaseMultiple: any } | null, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, isVerified: boolean, tier: UserTier } | null, totalValue: { __typename?: 'Amount', symbol: string, value: any } } } };

export type UpdateAppearanceMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  individualAssetIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type UpdateAppearanceMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', updateAppearance: boolean } };

export type ReleaseSlicesMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  availableSlices: Scalars['Decimal']['input'];
  slicePrice: AmountInput;
}>;


export type ReleaseSlicesMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', releaseSlices: boolean } };

export type TransferSlicesMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  slices: Scalars['Int']['input'];
  targetUserName: Scalars['String']['input'];
  source: WithdrawSource;
}>;


export type TransferSlicesMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', transferSlices: boolean } };

export type TransferSlicesToPieMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  slices: Scalars['Int']['input'];
}>;


export type TransferSlicesToPieMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', transferSlicesToPie: boolean } };

export type ActivateOnboardingProcessMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
}>;


export type ActivateOnboardingProcessMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', activateOnboardingProcess: boolean } };

export type CompletePieActivationProcessMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  displayName: Scalars['String']['input'];
  bio: Scalars['String']['input'];
  socialMedia: Array<SocialMediaPairInput> | SocialMediaPairInput;
  individualAssetIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  slicePrice: AmountInput;
  availableSlices: Scalars['Decimal']['input'];
  slug: Scalars['String']['input'];
}>;


export type CompletePieActivationProcessMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', completePieActivationProcess: OnboardingProcess } };

export type GrantModeratorMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  userName: Scalars['String']['input'];
  pieRole: PieRole;
}>;


export type GrantModeratorMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', grantModerator: boolean } };

export type DeleteModeratorMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type DeleteModeratorMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', deleteModerator: boolean } };

export type TransferPieMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  userName: Scalars['String']['input'];
}>;


export type TransferPieMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', transferPie: boolean } };

export type AcceptPieOwnershipMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  accept: Scalars['Boolean']['input'];
}>;


export type AcceptPieOwnershipMutation = { __typename?: 'Mutation', pie: { __typename?: 'PieMutationApi', acceptPieOwnership: boolean } };

export type PublicUpdateEmailSubscriptionMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  emailSubscriptionOptions: Array<EmailSubscriptionArgsInput> | EmailSubscriptionArgsInput;
}>;


export type PublicUpdateEmailSubscriptionMutation = { __typename?: 'Mutation', public: { __typename?: 'PublicMutationApi', userByEmail: { __typename?: 'PublicUser', updateEmailSubscription: boolean } } };

export type GetReferralLinkMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
}>;


export type GetReferralLinkMutation = { __typename?: 'Mutation', referral: { __typename?: 'ReferralMutationApi', getLink: string } };

export type RecordReferralPageViewMutationVariables = Exact<{
  token: Scalars['String']['input'];
  anonymousSessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordReferralPageViewMutation = { __typename?: 'Mutation', referral: { __typename?: 'ReferralMutationApi', recordPageView: boolean } };

export type RecordReferralSignupMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type RecordReferralSignupMutation = { __typename?: 'Mutation', referral: { __typename?: 'ReferralMutationApi', recordSignup: boolean } };

export type CreateClubMutationVariables = Exact<{
  payload: CreateClubPayloadInput;
  type: ClubUploadAsset;
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
}>;


export type CreateClubMutation = { __typename?: 'Mutation', createClub: { __typename?: 'CreateClubResult', clubId: any, prepareUpload?: { __typename?: 'PrepareUploadResponse', method: string, token: string, uploadUrl: any } | null } };

export type UpdateClubMutationVariables = Exact<{
  clubId: Scalars['UUID']['input'];
  payload: UpdateClubPayloadInput;
  type: ClubUploadAsset;
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
}>;


export type UpdateClubMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', updateClub: { __typename?: 'UpdateClubResult', prepareUpload?: { __typename?: 'PrepareUploadResponse', method: string, token: string, uploadUrl: any } | null } } };

export type InviteTeamCollaboratorMutationVariables = Exact<{
  clubId: Scalars['UUID']['input'];
  memo: Scalars['String']['input'];
  role: TeamCollaboratorRole;
  clubByIdClubId2: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  usesPerInvite: Scalars['Int']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type InviteTeamCollaboratorMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', inviteTeamCollaborator: { __typename?: 'InvitedResult', formattedInviteId: string, inviteId: any } } };

export type InviteTeamMemberMutationVariables = Exact<{
  clubId: Scalars['UUID']['input'];
  memo: Scalars['String']['input'];
  roleId: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  usesPerInvite: Scalars['Int']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type InviteTeamMemberMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', inviteTeamMember: { __typename?: 'InvitedResult', formattedInviteId: string, inviteId: any } } };

export type DeleteTeamCollaboratorMutationVariables = Exact<{
  clubId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type DeleteTeamCollaboratorMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', deleteTeamCollaborator: boolean } };

export type DeleteTeamMemberMutationVariables = Exact<{
  clubId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type DeleteTeamMemberMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', deleteTeamMember: boolean } };

export type UpdateTeamCollaboratorMutationVariables = Exact<{
  clubId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  role: TeamCollaboratorRole;
}>;


export type UpdateTeamCollaboratorMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', updateTeamCollaborator: boolean } };

export type UpdateTeamMemberMutationVariables = Exact<{
  clubId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  roleId: Scalars['UUID']['input'];
}>;


export type UpdateTeamMemberMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', updateTeamMember: boolean } };

export type TransferClubOwnershipMutationVariables = Exact<{
  clubId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type TransferClubOwnershipMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', transferOwnership: boolean } };

export type UpdateClubSlugMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  clubId: Scalars['UUID']['input'];
}>;


export type UpdateClubSlugMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', updateSlug: boolean } };

export type CreateOrUpdateTiersMutationVariables = Exact<{
  tiers: Array<ClubTierPayloadInput> | ClubTierPayloadInput;
  clubId: Scalars['UUID']['input'];
}>;


export type CreateOrUpdateTiersMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', createOrUpdateTiers: boolean } };

export type PrepareTierUploadMutationVariables = Exact<{
  contentLength: Scalars['Long']['input'];
  contentType: Scalars['String']['input'];
  tier: Scalars['Int']['input'];
  type: ClubTierUploadAsset;
  clubId: Scalars['UUID']['input'];
}>;


export type PrepareTierUploadMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', prepareTierUpload: { __typename?: 'PrepareUploadResponse', method: string, token: string, uploadUrl: any } } };

export type CompleteTierUploadMutationVariables = Exact<{
  token: Scalars['String']['input'];
  type: ClubTierUploadAsset;
  clubId: Scalars['UUID']['input'];
}>;


export type CompleteTierUploadMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', completeTierUpload: boolean } };

export type JoinClubMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type JoinClubMutation = { __typename?: 'Mutation', clubBySlug: { __typename?: 'ClubMutation', join: boolean } };

export type CreateOrUpdateRewardMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
  pieId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  bio: Scalars['String']['input'];
  avatarUrl: Scalars['String']['input'];
  uploadedAssetId?: InputMaybe<Scalars['UUID']['input']>;
  individualApiUrl: Scalars['String']['input'];
  type: RewardType;
  category: RewardCategory;
  notes: Scalars['String']['input'];
  redeemDescription: Scalars['String']['input'];
  redeemCode: Scalars['String']['input'];
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  maxWinners?: InputMaybe<Scalars['Int']['input']>;
  redeemType?: InputMaybe<RedeemType>;
  redeemPromoCodeArgs?: InputMaybe<RedeemPromoCodeArgsInput>;
  redeemQRCodeArgs?: InputMaybe<RedeemQrCodeArgsInput>;
  redeemInviteLinkArgs?: InputMaybe<RedeemInviteLinkArgsInput>;
  redeemLocationInfoArgs?: InputMaybe<RedeemLocationInfoArgsInput>;
  redeemUserContactInfoArgs?: InputMaybe<RedeemUserContactInfoArgsInput>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  ownSlicesConditions: Array<OwnSlicesConditionArgsInput> | OwnSlicesConditionArgsInput;
  achievementBadgeConditions: Array<AchievementBadgeConditionArgsInput> | AchievementBadgeConditionArgsInput;
  winningBoosts?: InputMaybe<Array<WinningBoostArgsInput> | WinningBoostArgsInput>;
  winnersChosenOption?: InputMaybe<WinnersChosenOption>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate: Scalars['DateTime']['input'];
  needNewSlices: Scalars['Boolean']['input'];
  canShareByParticipants: Scalars['Boolean']['input'];
  optInParticipantPrivacyPolicy: Scalars['Boolean']['input'];
  participantPrivacyPolicyTitle?: InputMaybe<Scalars['String']['input']>;
  participantPrivacyPolicyContent?: InputMaybe<Scalars['String']['input']>;
  doRewardToUser?: InputMaybe<Scalars['Boolean']['input']>;
  policyFileUrl?: InputMaybe<Scalars['String']['input']>;
  rewardGeoRangeConditionArg?: InputMaybe<RewardGeoRangeConditionArgInput>;
  requireAllAchievements: Scalars['Boolean']['input'];
}>;


export type CreateOrUpdateRewardMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', createOrUpdate: { __typename?: 'PublicRewardModel', rewardId: any, displayName: string, bio?: string | null, slug: string, createdUtc: any, avatarUrl: string, status: RewardStatus, isHidden: boolean, notes?: string | null, redeemCode?: string | null, redeemDescription?: string | null, redeemType?: RedeemType | null, ageLimit?: number | null, maxWinners?: number | null, type: RewardType, category?: RewardCategory | null, expiresAt?: any | null, startDate?: any | null, endDate: any, canShareByParticipants: boolean, needNewSlices: boolean, optInParticipantPrivacyPolicy: boolean, participantPrivacyPolicyTitle?: string | null, participantPrivacyPolicyContent?: string | null, policyFileUrl?: string | null, requireAllAchievements: boolean, pie?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, createdBy?: { __typename?: 'User', userId: any, name?: string | null } | null } | null, geoRangeCondition?: { __typename?: 'RewardGeoRangeCondition', address?: string | null, latitude: number, longitude: number, isActive: boolean, radius: number, locationUnitLengthType: LocationUnitLengthType } | null } } };

export type RewardPresignUploadUrlMutationVariables = Exact<{
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
  contentLength: Scalars['Long']['input'];
}>;


export type RewardPresignUploadUrlMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', rewardAvatar: { __typename?: 'RewardAvatarType', presignUploadUrl: string } } };

export type UpdateRewardAvatarMutationVariables = Exact<{
  rewardId: Scalars['UUID']['input'];
  avatarUrl: Scalars['String']['input'];
}>;


export type UpdateRewardAvatarMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', rewardAvatar: { __typename?: 'RewardAvatarType', completeUpload: boolean } } };

export type SetBonusAchivementsMutationVariables = Exact<{
  achievementIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  rewardId: Scalars['UUID']['input'];
  doRewardToUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetBonusAchivementsMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', setBonusAchievements: { __typename?: 'PublicRewardModel', rewardId: any } } };

export type DeleteRewardMutationVariables = Exact<{
  rewardId: Scalars['UUID']['input'];
}>;


export type DeleteRewardMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', delete: boolean } };

export type AwardRewardMutationVariables = Exact<{
  rewardId: Scalars['UUID']['input'];
  userName: Scalars['String']['input'];
}>;


export type AwardRewardMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', award: boolean } };

export type GenerateRewardWinnersMutationVariables = Exact<{
  rewardId: Scalars['UUID']['input'];
}>;


export type GenerateRewardWinnersMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', generateWinners: boolean } };

export type SendSmsRedeemCodeMutationVariables = Exact<{
  rewardId: Scalars['UUID']['input'];
}>;


export type SendSmsRedeemCodeMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', sendSmsRedeemCode: boolean } };

export type OptOutRewardMutationVariables = Exact<{
  rewardId: Scalars['UUID']['input'];
}>;


export type OptOutRewardMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', optOut: boolean } };

export type SaveWinnerSharedAddressMutationVariables = Exact<{
  rewardId: Scalars['UUID']['input'];
  sharedAddress?: InputMaybe<AddressModelInput>;
  sharedPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  sharedEmailAddress?: InputMaybe<Scalars['String']['input']>;
  sharedName?: InputMaybe<Scalars['String']['input']>;
  socialMediaAccounts?: InputMaybe<Array<SocialMediaAccountInput> | SocialMediaAccountInput>;
}>;


export type SaveWinnerSharedAddressMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', saveWinnerSharedAddress: boolean } };

export type ConfirmParticipantPrivacyPolicyMutationVariables = Exact<{
  rewardId: Scalars['UUID']['input'];
  participantPrivacyPolicyState: ParticipantPrivacyPolicyState;
}>;


export type ConfirmParticipantPrivacyPolicyMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', confirmParticipantPrivacyPolicy: boolean } };

export type GetTestTicketMutationVariables = Exact<{ [key: string]: never; }>;


export type GetTestTicketMutation = { __typename?: 'Mutation', reward: { __typename?: 'RewardMutationApi', ticketGetTestTicket2: { __typename?: 'TicketGrantResult', ticketId: string, associatedUser?: { __typename?: 'User', userId: any } | null } } };

export type CreateTermsConditionsAndPrivacyMutationVariables = Exact<{
  privacyPath: Scalars['String']['input'];
  termsConditionsPath: Scalars['String']['input'];
}>;


export type CreateTermsConditionsAndPrivacyMutation = { __typename?: 'Mutation', termsAndConditions: { __typename?: 'TermsAndConditionsMutationApi', createTermsAndConditions: boolean } };

export type CreateOrUpdateUploadedAssetMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
  pieId?: InputMaybe<Scalars['UUID']['input']>;
  target: UploadedAssetTarget;
  url: Scalars['String']['input'];
}>;


export type CreateOrUpdateUploadedAssetMutation = { __typename?: 'Mutation', uploaded_asset: { __typename?: 'UploadedAssetMutationApi', createOrUpdate: { __typename?: 'PublicUploadedAssetModel', uploadedAssetId: any, url: string, target: UploadedAssetTarget, createdUtc: any, status: UploadedAssetStatus } } };

export type DeleteUploadedAssetMutationVariables = Exact<{
  assetId: Scalars['UUID']['input'];
}>;


export type DeleteUploadedAssetMutation = { __typename?: 'Mutation', uploaded_asset: { __typename?: 'UploadedAssetMutationApi', delete: boolean } };

export type TargetPresignUploadUrlMutationVariables = Exact<{
  pieId?: InputMaybe<Scalars['UUID']['input']>;
  target: UploadedAssetTarget;
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
  contentLength: Scalars['Long']['input'];
}>;


export type TargetPresignUploadUrlMutation = { __typename?: 'Mutation', uploaded_asset: { __typename?: 'UploadedAssetMutationApi', presignUploadUrl: string } };

export type UpdateMeMutationVariables = Exact<{
  args: MutationUserUpdateArgsInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', me?: { __typename?: 'CompleteUser', name?: string | null, gender?: UserGender | null, dateOfBirth?: any | null, phoneNumber?: string | null, userName?: string | null, brandedUrl?: string | null } | null };

export type CompleteProfileMutationVariables = Exact<{
  args: MutationCompleteProfileArgsInput;
}>;


export type CompleteProfileMutation = { __typename?: 'Mutation', completeProfile?: { __typename?: 'CurrentUser', userId: any, profileCompletionRequired: boolean } | null };

export type UpdatePhoneNumberMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type UpdatePhoneNumberMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', updatePhoneNumber: UserUpdateStatus } };

export type UpdateEmailAddressMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
}>;


export type UpdateEmailAddressMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', updateEmailAddress: UserUpdateStatus } };

export type RequestEmailChangeMutationVariables = Exact<{
  newEmailAddress: Scalars['String']['input'];
}>;


export type RequestEmailChangeMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', requestEmailChange: UserUpdateStatus } };

export type UpdateLocationMutationVariables = Exact<{
  address: AddressModelInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', updateAddress: UserUpdateStatus } };

export type ConnectSocialMutationVariables = Exact<{
  accessKey: Scalars['String']['input'];
  scheme: Scalars['String']['input'];
}>;


export type ConnectSocialMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', socialMedia: { __typename?: 'SocialMediaType', connect: boolean } } };

export type DisconnectSocialMutationVariables = Exact<{
  scheme: Scalars['String']['input'];
}>;


export type DisconnectSocialMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', socialMedia: { __typename?: 'SocialMediaType', disconnect: boolean } } };

export type StartInstagramVerificationMutationVariables = Exact<{ [key: string]: never; }>;


export type StartInstagramVerificationMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', socialMedia: { __typename?: 'SocialMediaType', startInstagramVerification: { __typename?: 'StartInstagramVerificationResult', code: string, expiresAt: any, dmDeepLink?: string | null } } } };

export type RefreshInstagramConnectionMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshInstagramConnectionMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', refreshInstagramConnection: boolean } };

export type SetAvatarSourceMutationVariables = Exact<{
  source: AvatarSource;
}>;


export type SetAvatarSourceMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', setAvatarSource: boolean } };

export type SetDisplayNameSourceMutationVariables = Exact<{
  source: DisplayNameSource;
}>;


export type SetDisplayNameSourceMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', setDisplayNameSource: boolean } };

export type PresignUploadUrlMutationVariables = Exact<{
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
  contentLength: Scalars['Long']['input'];
}>;


export type PresignUploadUrlMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', avatar: { __typename?: 'AvatarType', presignUploadUrl: string } } };

export type UpdateAvatarMutationVariables = Exact<{
  avatarUrl: Scalars['String']['input'];
}>;


export type UpdateAvatarMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', avatar: { __typename?: 'AvatarType', completeUpload: boolean } } };

export type UpdateMeAndAgreeToTermsAndConditionsMutationVariables = Exact<{
  args: MutationUserUpdateArgsInput;
  version: Scalars['Int']['input'];
}>;


export type UpdateMeAndAgreeToTermsAndConditionsMutation = { __typename?: 'Mutation', me?: { __typename?: 'CompleteUser', name?: string | null, gender?: UserGender | null, dateOfBirth?: any | null, phoneNumber?: string | null, userName?: string | null, brandedUrl?: string | null } | null, user: { __typename?: 'UserMutationApi', agreeTermsAndConditions: boolean } };

export type AgreeToTermsAndConditionsMutationVariables = Exact<{
  version: Scalars['Int']['input'];
}>;


export type AgreeToTermsAndConditionsMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', agreeTermsAndConditions: boolean } };

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', deactivate: boolean } };

export type RecoverAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type RecoverAccountMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', activate: boolean } };

export type ConnectPayoutMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  isPrimary: Scalars['Boolean']['input'];
}>;


export type ConnectPayoutMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', payoutAccount: { __typename?: 'PayoutAccountType', connect: boolean } } };

export type ConnectPayoutViaOidcMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ConnectPayoutViaOidcMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', payoutAccount: { __typename?: 'PayoutAccountType', connectViaOidc?: string | null } } };

export type DisconnectPayoutMutationVariables = Exact<{
  provider: Scalars['String']['input'];
}>;


export type DisconnectPayoutMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', payoutAccount: { __typename?: 'PayoutAccountType', disconnect: boolean } } };

export type JoinWaitingListMutationVariables = Exact<{ [key: string]: never; }>;


export type JoinWaitingListMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', joinPieWaitingList: boolean } };

export type DeletePendingInviteMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;


export type DeletePendingInviteMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', revokePendingInvite: boolean } };

export type InviteUserByEmailMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
}>;


export type InviteUserByEmailMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', inviteUserByEmail: { __typename?: 'CreatedInvite', inviteAcceptLink: any, inviteId: string } } };

export type InviteUserByUserNameMutationVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type InviteUserByUserNameMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', inviteUserByUserName: { __typename?: 'CreatedInvite', inviteId: string, inviteAcceptLink: any } } };

export type AcceptInvite2MutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
  didAcceptAllDisclosures: Scalars['Boolean']['input'];
}>;


export type AcceptInvite2Mutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', acceptInvite2: { __typename?: 'AcceptInviteResult', success: boolean, redirectUrl?: string | null, errorMessage?: string | null } } };

export type SendInviteeEmailVerificationMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;


export type SendInviteeEmailVerificationMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', sendInviteeEmailVerification: { __typename?: 'InviteeEmailVerificationResult', success: boolean, maskedEmail?: string | null, nextResend?: any | null, expiresAt?: any | null, blockedUntil?: any | null } } };

export type AcceptInviteWithEmailVerificationMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  didAcceptAllDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AcceptInviteWithEmailVerificationMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', acceptInviteWithEmailVerification: { __typename?: 'AcceptInviteWithEmailVerificationResult', success: boolean, redirectUrl?: string | null, errorMessage?: string | null, verificationResult: OtpVerificationResult, maxAttempts: number, failedAttempts: number, blockedUntil?: any | null } } };

export type DeclineInviteMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;


export type DeclineInviteMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', declineInvite: boolean } };

export type UpdateSkipMultiFactorAuthenticationMutationVariables = Exact<{
  skipMultiFactorAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateSkipMultiFactorAuthenticationMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', updateSkipMultiFactorAuthentication: UserUpdateStatus } };

export type UpdateEmailSubscriptionMutationVariables = Exact<{
  emailSubscriptionOptions: Array<EmailSubscriptionArgsInput> | EmailSubscriptionArgsInput;
}>;


export type UpdateEmailSubscriptionMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', updateEmailSubscription: boolean } };

export type UpdateWalkthroughMutationVariables = Exact<{
  walkthrough: Array<WalkthroughArgsInput> | WalkthroughArgsInput;
}>;


export type UpdateWalkthroughMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', updateWalkthrough: Array<{ __typename?: 'UserWalkthrough', status: WalkthroughStatus, type: WalkthroughType }> } };

export type WishPieMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
}>;


export type WishPieMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', wishPie: boolean } };

export type UnwishPieMutationVariables = Exact<{
  pieId: Scalars['UUID']['input'];
}>;


export type UnwishPieMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', unwishPie: boolean } };

export type FollowUserMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type FollowUserMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', followUser: boolean } };

export type UnfollowUserMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type UnfollowUserMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', unfollowUser: boolean } };

export type QueryInviteMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
  viewSource?: InputMaybe<AttributionChannel>;
  deliveryId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type QueryInviteMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', queryInvite: { __typename?: 'QueryInviteResult', acceptedAt?: any | null, expiresAt?: any | null, validInvitesRemaining: number, isInviteUsed: boolean, isUsedByMe: boolean, isInvited: boolean, isPrivateToAnotherPerson: boolean, redirectUrl?: string | null, actions: Array<{ __typename?: 'AcceptInviteResultAction', disclosure?: { __typename?: 'AcceptInviteResultActionDisclosure', acceptButtonTitle?: string | null, description?: string | null, documentUrl?: string | null, title?: string | null } | null, acceptAction?: { __typename?: 'InviteAcceptActionBase', inviteActionName: string, inviteActionData: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> } | null }>, additionalProperties: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }>, sharedTicket?: { __typename?: 'EventTicket', isEnabledWishList: boolean, color?: string | null, eventTicketId: any, isActive: boolean, price?: any | null, ticketType?: string | null, isPrivate?: boolean | null, optInShowTicketAmount: boolean, additionalGuests?: number | null, transactionStatus?: TransactionStatus | null, note?: string | null, isRequiredApproval: boolean, sortOrder?: number | null, actionLabel?: string | null, requiresDisclosureSignature: boolean, balance?: { __typename?: 'EventTicketBalance', availableAmount?: number | null } | null, fulfillmentMethods?: { __typename?: 'FulfillmentMethods', electronic: boolean, ship: boolean, pickup: boolean } | null } | null } } };

export type DeletePasskeyCredentialMutationVariables = Exact<{
  credentialId: Scalars['String']['input'];
}>;


export type DeletePasskeyCredentialMutation = { __typename?: 'Mutation', deletePasskeyCredential: boolean };

export type AttachExistingStripeAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type AttachExistingStripeAccountMutation = { __typename?: 'Mutation', stripeAccount: { __typename?: 'StripeAccountMutationApi', attachExistingAccount: { __typename?: 'AttachAccountPayload', authorizationUrl: string } } };

export type DisconnectStripeAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectStripeAccountMutation = { __typename?: 'Mutation', stripeAccount: { __typename?: 'StripeAccountMutationApi', disconnect: { __typename?: 'SuccessPayload', success: boolean } } };

export type StartStripeManagementSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type StartStripeManagementSessionMutation = { __typename?: 'Mutation', stripeAccount: { __typename?: 'StripeAccountMutationApi', startManagementSession: { __typename?: 'EmbeddedSessionPayload', clientSecret: string } } };

export type StartStripeOnboardingSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type StartStripeOnboardingSessionMutation = { __typename?: 'Mutation', stripeAccount: { __typename?: 'StripeAccountMutationApi', startOnboardingSession: { __typename?: 'EmbeddedSessionPayload', clientSecret: string } } };

export type UpdateSkipPasskeyRegistrationMutationVariables = Exact<{
  skipPasskeyRegistration: Scalars['Boolean']['input'];
}>;


export type UpdateSkipPasskeyRegistrationMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', updateSkipPasskeyRegistration: UserUpdateStatus } };

export type AssignToBrandedUrlMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
}>;


export type AssignToBrandedUrlMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', assignToBrandedUrl: string } };

export type UnassignFromBrandedUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type UnassignFromBrandedUrlMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', unassignFromBrandedUrl: boolean } };

export type RequestCreateEventApprovalMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestCreateEventApprovalMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', requestCreateEventApproval: boolean } };

export type RequestCreateEventTypeApprovalMutationVariables = Exact<{
  type: AllowCreateEventType;
}>;


export type RequestCreateEventTypeApprovalMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', requestCreateEventTypeApproval: boolean } };

export type UpdateTaxConfigurationMutationVariables = Exact<{
  args: UpdateTaxConfigurationArgInput;
}>;


export type UpdateTaxConfigurationMutation = { __typename?: 'Mutation', user: { __typename?: 'UserMutationApi', updateTaxConfiguration: boolean } };

export type DepositMutationVariables = Exact<{
  value: Scalars['Decimal']['input'];
  symbol: Scalars['String']['input'];
  ref: Scalars['String']['input'];
}>;


export type DepositMutation = { __typename?: 'Mutation', wallet: { __typename?: 'WalletMutationApi', deposit: boolean } };

export type WithdrawMutationVariables = Exact<{
  value: Scalars['Decimal']['input'];
  symbol: Scalars['String']['input'];
  ref: Scalars['String']['input'];
}>;


export type WithdrawMutation = { __typename?: 'Mutation', wallet: { __typename?: 'WalletMutationApi', withdraw: boolean } };

export type GetAchievementByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetAchievementByIdQuery = { __typename?: 'Query', achievement: { __typename?: 'AchievementQueryApi', byId?: { __typename?: 'Achievement', achievementId: any, slug: string, displayName: string, bio: string, avatarUrl: string, createdUtc: any, status: AchievementStatus, category?: AchievementCategory | null, isHidden: boolean, activeFromUtc?: any | null, activeToUtc?: any | null, maxSupply?: number | null, claimedByRewards2?: Array<{ __typename?: 'Reward', rewardId: any, mustOwnSlicesStartDate?: any | null, achievementBadgeConditions?: { __typename?: 'StoredAchievementBadgeConditionPageX', nodes: Array<{ __typename?: 'StoredAchievementBadgeCondition', startDate?: any | null, endDate: any, achievement?: { __typename?: 'PublicAchievementModel', achievementId: any, avatarUrl: string, displayName: string } | null }> } | null, ownSlicesConditions?: { __typename?: 'StoredOwnSlicesConditionPageX', nodes: Array<{ __typename?: 'StoredOwnSlicesCondition', id?: any | null, amount: any, startDate?: any | null, pie?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string } | null }> } | null } | null> | null, statisticsByRewards?: { __typename?: 'GroupedUserAchievement', userAchievements?: Array<{ __typename?: 'UserAchievement', userInfo?: { __typename?: 'User', userId: any, isVerified: boolean, name?: string | null, gender?: UserGender | null, ageRange?: string | null, dateOfBirth?: any | null, userName?: string | null } | null, achievementUserInfo?: { __typename?: 'AchievementUserInfo', createdUtc: any } | null } | null> | null } | null, fromReward?: { __typename?: 'Reward', category?: RewardCategory | null, userRewardInfo?: { __typename?: 'UserReward', userRewardInfo?: { __typename?: 'RewardUserInfoType', ordinalWinner?: number | null, totalWinner?: number | null, participateState: ParticipateState } | null } | null } | null } | null } };

export type GetAchievementPublicByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetAchievementPublicByIdQuery = { __typename?: 'Query', achievementPublic: { __typename?: 'AchievementPublicQueryApi', byId?: { __typename?: 'Achievement', achievementId: any, slug: string, displayName: string, bio: string, avatarUrl: string, createdUtc: any, status: AchievementStatus, category?: AchievementCategory | null, isHidden: boolean, claimedByRewards2?: Array<{ __typename?: 'Reward', rewardId: any, mustOwnSlicesStartDate?: any | null, achievementBadgeConditions?: { __typename?: 'StoredAchievementBadgeConditionPageX', nodes: Array<{ __typename?: 'StoredAchievementBadgeCondition', startDate?: any | null, endDate: any, achievement?: { __typename?: 'PublicAchievementModel', achievementId: any, avatarUrl: string, displayName: string } | null }> } | null, ownSlicesConditions?: { __typename?: 'StoredOwnSlicesConditionPageX', nodes: Array<{ __typename?: 'StoredOwnSlicesCondition', id?: any | null, amount: any, startDate?: any | null, pie?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string } | null }> } | null } | null> | null } | null } };

export type GetAchievementBySlugOrIdQueryVariables = Exact<{
  pieSlugOrId: Scalars['String']['input'];
  achievementSlugOrId: Scalars['String']['input'];
  triggeredRewardIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type GetAchievementBySlugOrIdQuery = { __typename?: 'Query', achievement: { __typename?: 'AchievementQueryApi', bySlugOrId?: { __typename?: 'Achievement', achievementId: any, slug: string, displayName: string, bio: string, avatarUrl: string, createdUtc: any, status: AchievementStatus, category?: AchievementCategory | null, isHidden: boolean, activeFromUtc?: any | null, activeToUtc?: any | null, maxSupply?: number | null, fromReward?: { __typename?: 'Reward', rewardId: any, displayName: string } | null, claimedByRewards2?: Array<{ __typename?: 'Reward', rewardId: any, mustOwnSlicesStartDate?: any | null, achievementBadgeConditions?: { __typename?: 'StoredAchievementBadgeConditionPageX', nodes: Array<{ __typename?: 'StoredAchievementBadgeCondition', startDate?: any | null, endDate: any, achievement?: { __typename?: 'PublicAchievementModel', achievementId: any, avatarUrl: string, displayName: string } | null }> } | null, ownSlicesConditions?: { __typename?: 'StoredOwnSlicesConditionPageX', nodes: Array<{ __typename?: 'StoredOwnSlicesCondition', id?: any | null, amount: any, startDate?: any | null, pie?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string } | null }> } | null } | null> | null, statisticsByRewards?: { __typename?: 'GroupedUserAchievement', triggeredByRewards?: Array<{ __typename?: 'Reward', rewardId: any, displayName: string, avatarUrl: string, achievementBadgeConditions?: { __typename?: 'StoredAchievementBadgeConditionPageX', nodes: Array<{ __typename?: 'StoredAchievementBadgeCondition', startDate?: any | null, endDate: any, achievement?: { __typename?: 'PublicAchievementModel', achievementId: any, avatarUrl: string, displayName: string } | null }> } | null, ownSlicesConditions?: { __typename?: 'StoredOwnSlicesConditionPageX', nodes: Array<{ __typename?: 'StoredOwnSlicesCondition', id?: any | null, amount: any, startDate?: any | null, pie?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string } | null }> } | null } | null> | null, userAchievements?: Array<{ __typename?: 'UserAchievement', userInfo?: { __typename?: 'User', userId: any, isVerified: boolean, name?: string | null, gender?: UserGender | null, ageRange?: string | null, dateOfBirth?: any | null, userName?: string | null } | null, achievementUserInfo?: { __typename?: 'AchievementUserInfo', createdUtc: any } | null } | null> | null, ageRangeStatistic?: { __typename?: 'ActivatedUserAgeRangeStatistic', totalFemaleAmount: number, totalFemaleAmountPercentage: number, totalMaleAmount: number, totalMaleAmountPercentage: number, totalOtherAmount: number, totalOtherAmountPercentage: number, ageRangeFrom18To24: { __typename?: 'ActivatedUserAgeRange', totalFemaleAmount: number, totalFemaleAmountPercentage: number, totalMaleAmount: number, totalMaleAmountPercentage: number, totalOtherAmount: number, totalOtherAmountPercentage: number }, ageRangeFrom25To34: { __typename?: 'ActivatedUserAgeRange', totalFemaleAmount: number, totalFemaleAmountPercentage: number, totalMaleAmount: number, totalMaleAmountPercentage: number, totalOtherAmount: number, totalOtherAmountPercentage: number }, ageRangeFrom35To44: { __typename?: 'ActivatedUserAgeRange', totalFemaleAmount: number, totalFemaleAmountPercentage: number, totalMaleAmount: number, totalMaleAmountPercentage: number, totalOtherAmount: number, totalOtherAmountPercentage: number }, ageOver44: { __typename?: 'ActivatedUserAgeRange', totalFemaleAmount: number, totalFemaleAmountPercentage: number, totalMaleAmount: number, totalMaleAmountPercentage: number, totalOtherAmount: number, totalOtherAmountPercentage: number } } | null } | null } | null } };

export type GetAchievementsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sortingType?: InputMaybe<AchievementSortType>;
  sortingOrder?: InputMaybe<PageSortOrder>;
}>;


export type GetAchievementsQuery = { __typename?: 'Query', achievement: { __typename?: 'AchievementQueryApi', listAchievements2?: { __typename?: 'AchievementStatisticV2', totalUnlockAchievementAmount: number, achievementList?: { __typename?: 'AchievementGrainPageX', nodes: Array<{ __typename?: 'Achievement', achievementId: any, slug: string, displayName: string, bio: string, avatarUrl: string, createdUtc: any, status: AchievementStatus, category?: AchievementCategory | null, isHidden: boolean, activeFromUtc?: any | null, activeToUtc?: any | null, maxSupply?: number | null, owner?: { __typename?: 'User', userId: any, userName?: string | null, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null } | null }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null } | null } };

export type GetAchievementsByPieIdQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  pieId: Scalars['UUID']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  sortingType?: InputMaybe<AchievementSortType>;
  sortingOrder?: InputMaybe<PageSortOrder>;
}>;


export type GetAchievementsByPieIdQuery = { __typename?: 'Query', achievement: { __typename?: 'AchievementQueryApi', listByPieId2?: { __typename?: 'AchievementStatisticV2', totalUnlockAchievementAmount: number, achievementList?: { __typename?: 'AchievementGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Achievement', achievementId: any, slug: string, displayName: string, bio: string, avatarUrl: string, createdUtc: any, status: AchievementStatus, category?: AchievementCategory | null, isHidden: boolean, activeFromUtc?: any | null, activeToUtc?: any | null, maxSupply?: number | null, owner?: { __typename?: 'User', userId: any, userName?: string | null, name?: string | null, avatarUrl?: string | null } | null }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null } | null } };

export type GetUserAchievementsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  sortingType: PageSortOrder;
}>;


export type GetUserAchievementsQuery = { __typename?: 'Query', achievement: { __typename?: 'AchievementQueryApi', userAchievements?: { __typename?: 'AchievementGrainPageX', nodes: Array<{ __typename?: 'Achievement', achievementId: any, activeFromUtc?: any | null, displayName: string, bio: string, createdUtc: any, status: AchievementStatus, slug: string, avatarUrl: string }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null } };

export type GetClubAchievementsQueryVariables = Exact<{
  clubId: Scalars['UUID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClubAchievementsQuery = { __typename?: 'Query', clubAchievements?: { __typename?: 'ClubAchievementsConnection', nodes?: Array<{ __typename?: 'AchievementState', achievementId: any, avatarUrl: string, description: string, name: string, type: ClubAchievementType } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges?: Array<{ __typename?: 'ClubAchievementsEdge', cursor: string }> | null } | null };

export type GetClubAchivementQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  achievementId: Scalars['UUID']['input'];
}>;


export type GetClubAchivementQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', clubId: any, name: string, achievements?: { __typename?: 'AchievementsConnection', nodes?: Array<{ __typename?: 'AchievementState', achievementId: any, avatarUrl: string, description: string, name: string, type: ClubAchievementType } | null> | null } | null } | null };

export type GeneralGetMyEventsQueryVariables = Exact<{
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GeneralGetMyEventsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', myEvents?: { __typename?: 'MyEventsConnection', nodes?: Array<{ __typename?: 'FullEvent', slug: string, eventId: any } | null> | null } | null } };

export type ContactSharePreviewQueryVariables = Exact<{
  inviteToken: Scalars['String']['input'];
}>;


export type ContactSharePreviewQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', contactSharePreview: { __typename?: 'ContactSharePreviewResult', sharerUserId: any, sharerUserName?: string | null, sharerUserAvatarUrl?: string | null, contactCount: number, isAlreadyAccepted: boolean, acceptedAt?: any | null } } };

export type ShareCopyStatusQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type ShareCopyStatusQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', shareCopyStatus?: { __typename?: 'ContactCopyStatusModel', status: JobStatus, totalContacts: number, processedContacts: number, copiedContactCount: number, skippedContactCount: number, failContactCount: number, groupName?: string | null, startedAt: any, completedAt?: any | null } | null } };

export type ContactNodeFieldsFragment = { __typename?: 'Contact', contactId: any, createdAt: any, emailAddress?: string | null, invitationStatus: InvitationStatus, name?: string | null, phoneNumber?: string | null, userId?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, events?: { __typename?: 'LimitedEventConnection', nodes?: Array<{ __typename?: 'LimitedEvent', avatarUrl: string, displayName: string } | null> | null } | null, inviteInfo?: { __typename?: 'InvitationInfo', giftTicketName?: string | null, giftTicketQuantity?: number | null, privateTicketName?: string | null, privateTicketQuantity?: number | null } | null, inviter?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, name?: string | null, userId: any, tier: UserTier, repScore: number } | null, customFields?: Array<{ __typename?: 'ContactCustomField', key: string, label: string, value: string }> | null, userInfo?: { __typename?: 'UserWithAddress', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, userId: any, tier: UserTier, gender?: UserGender | null, dateOfBirth?: any | null, ageRange?: string | null, age?: number | null, name?: string | null, address?: { __typename?: 'UserAddressModel', address?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null, region?: string | null } | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', displayName?: string | null, scheme: string, avatarUrl?: string | null, profileLink?: string | null, userId: string, username?: string | null } | null> | null } | null, groups?: { __typename?: 'ContactGroupConnection', nodes?: Array<{ __typename?: 'ContactGroup', groupId: any, groupName: string } | null> | null } | null };

export type SearchContactsQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  filterArgs: ContactPageFilterArgsInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchContactsQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', contacts?: { __typename?: 'ContactsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes?: Array<{ __typename?: 'Contact', contactId: any, createdAt: any, emailAddress?: string | null, invitationStatus: InvitationStatus, name?: string | null, phoneNumber?: string | null, userId?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, events?: { __typename?: 'LimitedEventConnection', nodes?: Array<{ __typename?: 'LimitedEvent', avatarUrl: string, displayName: string } | null> | null } | null, inviteInfo?: { __typename?: 'InvitationInfo', giftTicketName?: string | null, giftTicketQuantity?: number | null, privateTicketName?: string | null, privateTicketQuantity?: number | null } | null, inviter?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, name?: string | null, userId: any, tier: UserTier, repScore: number } | null, customFields?: Array<{ __typename?: 'ContactCustomField', key: string, label: string, value: string }> | null, userInfo?: { __typename?: 'UserWithAddress', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, userId: any, tier: UserTier, gender?: UserGender | null, dateOfBirth?: any | null, ageRange?: string | null, age?: number | null, name?: string | null, address?: { __typename?: 'UserAddressModel', address?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null, region?: string | null } | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', displayName?: string | null, scheme: string, avatarUrl?: string | null, profileLink?: string | null, userId: string, username?: string | null } | null> | null } | null, groups?: { __typename?: 'ContactGroupConnection', nodes?: Array<{ __typename?: 'ContactGroup', groupId: any, groupName: string } | null> | null } | null } | null> | null } | null } };

export type SearchContactsOffsetQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  filterArgs: ContactPageFilterArgsInput;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type SearchContactsOffsetQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', contactsOffset?: { __typename?: 'ContactModelOffsetPage', totalCount: any, nodes: Array<{ __typename?: 'Contact', contactId: any, createdAt: any, emailAddress?: string | null, invitationStatus: InvitationStatus, name?: string | null, phoneNumber?: string | null, userId?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, events?: { __typename?: 'LimitedEventConnection', nodes?: Array<{ __typename?: 'LimitedEvent', avatarUrl: string, displayName: string } | null> | null } | null, inviteInfo?: { __typename?: 'InvitationInfo', giftTicketName?: string | null, giftTicketQuantity?: number | null, privateTicketName?: string | null, privateTicketQuantity?: number | null } | null, inviter?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, name?: string | null, userId: any, tier: UserTier, repScore: number } | null, customFields?: Array<{ __typename?: 'ContactCustomField', key: string, label: string, value: string }> | null, userInfo?: { __typename?: 'UserWithAddress', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, userId: any, tier: UserTier, gender?: UserGender | null, dateOfBirth?: any | null, ageRange?: string | null, age?: number | null, name?: string | null, address?: { __typename?: 'UserAddressModel', address?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null, region?: string | null } | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', displayName?: string | null, scheme: string, avatarUrl?: string | null, profileLink?: string | null, userId: string, username?: string | null } | null> | null } | null, groups?: { __typename?: 'ContactGroupConnection', nodes?: Array<{ __typename?: 'ContactGroup', groupId: any, groupName: string } | null> | null } | null }> } | null } };

export type ExportContactsQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  filterArgs: ContactPageFilterArgsInput;
}>;


export type ExportContactsQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', exportContacts: Array<{ __typename?: 'ContactExportRow', contactId: any, name?: string | null, emailAddress?: string | null, phoneNumber?: string | null, createdAt: any, city?: string | null, eventCount: number }> } };

export type GetContactGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactGroupsQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', groups?: { __typename?: 'GroupsConnection', nodes?: Array<{ __typename?: 'ContactGroup', groupName: string, groupId: any, contactCount?: number | null } | null> | null } | null } };

export type GetBulkDeleteStatusQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetBulkDeleteStatusQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', bulkDeleteStatus?: { __typename?: 'ContactBulkDeleteStatusModel', jobId: string, status: JobStatus, totalCount: number, processedCount: number } | null } };

export type GetContactMessageStatusQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetContactMessageStatusQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', messageStatus?: { __typename?: 'ContactMessageStatusModel', jobId: string, status: JobStatus, totalCount: number, processedCount: number, sentCount: number, failCount: number, suppressedCount: number, suppressedByListCount: number, suppressedUnsubscribedCount: number, suppressedWhitelistCount: number, failureListTruncated: boolean, failures?: Array<{ __typename?: 'ContactMessageFailureDto', emailAddress?: string | null, phoneNumber?: string | null, reason: string, channel: string }> | null } | null } };

export type GetContactImportStatusQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetContactImportStatusQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', bulkImportStatus?: { __typename?: 'ContactImportStatusModel', jobId: string, status: JobStatus, totalRows: number, processedRows: number, successCount: number, failCount: number, failures?: Array<{ __typename?: 'ContactImportFailureDto', row: number, email?: string | null, reason: string }> | null } | null } };

export type CountContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountContactsQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', count: any } };

export type GetContactCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactCitiesQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', cities?: Array<{ __typename?: 'ContactCountryCity', city: string, country: string } | null> | null } };

export type ContactsFilterGetEventTicketTypesQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactsFilterGetEventTicketTypesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, sortOrder?: number | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, seriesPassTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, sortOrder?: number | null } | null> | null } | null } | null } };

export type GetPublicSeriesEventsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SearchEventStatus>;
  sortBy?: InputMaybe<SeriesEventsSortBy>;
  sortOrder?: InputMaybe<PageSortOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPublicSeriesEventsQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', publicSeriesEvents?: { __typename?: 'PublicSeriesEventsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'LimitedEvent', eventId: any, slug: string, displayName: string, startDate: any, timeZone?: string | null, avatarUrl: string, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null } | null } | null> | null } | null } };

export type GetEventSeriesViewAllQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SearchEventStatus>;
  sortBy?: InputMaybe<SeriesEventsSortBy>;
  sortOrder?: InputMaybe<PageSortOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEventSeriesViewAllQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', bySlugOrId?: { __typename?: 'EventSeries', eventSeriesId: any, name: string, slug: string, publicEvents?: { __typename?: 'PublicEventsConnection', nodes?: Array<{ __typename?: 'LimitedEvent', eventId: any, slug: string, displayName: string, startDate: any, timeZone?: string | null, avatarUrl: string, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null } | null } | null> | null } | null } | null } };

export type GetRelatedSeriesEventsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  slugOrId: Scalars['String']['input'];
  status?: InputMaybe<SearchEventStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRelatedSeriesEventsQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', bySlugOrId?: { __typename?: 'EventSeries', eventSeriesId: any, name: string, slug: string, parentEventId: any } | null, publicSeriesEvents?: { __typename?: 'PublicSeriesEventsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'LimitedEvent', eventId: any, slug: string, displayName: string, startDate: any, timeZone?: string | null, avatarUrl: string, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null } | null } | null> | null } | null } };

export type PublicEventSeriesBySlugOrIdQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type PublicEventSeriesBySlugOrIdQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', bySlugOrId?: { __typename?: 'EventSeries', eventSeriesId: any, name: string, slug: string } | null } };

export type EventsManageGetSeriesTicketTypesQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventsManageGetSeriesTicketTypesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, isActive: boolean, optInQrCodePass: boolean, sortOrder?: number | null, price?: any | null, color?: string | null, additionalGuests?: number | null } | null> | null } | null } | null } };

export type SeriesEntriesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SeriesEntriesQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', series?: { __typename?: 'EventSeries', eventSeriesId: any, entries?: { __typename?: 'SeriesEntries', unmappedScanRows: number, asOfUtc?: any | null, events: Array<{ __typename?: 'EventEntryStats', eventId: any, entries: number, checkedIn: number, capacity?: number | null, own: { __typename?: 'EntryCount', entries: number, checkedIn: number, scans?: number | null }, passHolders: { __typename?: 'EntryCount', entries: number, checkedIn: number, scans?: number | null }, passGuests: { __typename?: 'EntryCount', entries: number, checkedIn: number, scans?: number | null }, plusOnes?: { __typename?: 'PlusOneBreakdown', shared: number, live: number, everyEvent: number } | null }> } | null } | null } };

export type SeriesPassesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SeriesPassesQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', series?: { __typename?: 'EventSeries', eventSeriesId: any, passes?: { __typename?: 'SeriesPasses', passesSold: number, guestTickets: number, capacity?: number | null, capacityTickets?: number | null, hasTicketsForSale: boolean, asOfUtc?: any | null, plusOnes?: { __typename?: 'SeriesPlusOneSummary', validNow: number, validForEventId?: any | null, shared: number, expired: number, everyEventActive: number, legacyUnstamped: number } | null, passTypes: Array<{ __typename?: 'SeriesPassType', eventTicketId: any, ticketType: string, price: any, isActive: boolean, additionalGuests: number, resetAdditionalGuestsAfterEachEvent: boolean, optInQrCodePass: boolean, passesSold: number, guestTickets: number, capacity?: number | null }> } | null } | null } };

export type SeriesHasTicketsForSaleQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SeriesHasTicketsForSaleQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', series?: { __typename?: 'EventSeries', eventSeriesId: any, hasTicketsForSale: boolean } | null } };

export type SeriesAudienceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  attendeeFilterStatus?: InputMaybe<AttendeeFilterStatus>;
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SeriesAudienceQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', series?: { __typename?: 'EventSeries', eventSeriesId: any, audience?: { __typename?: 'AttendeeAgeRangeStatistic', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalUserAmount: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number, totalTicketAmount: number, ageRangeUnder18: { __typename?: 'AttendeeAgeRange', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number }, ageRangeFrom18To24: { __typename?: 'AttendeeAgeRange', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number }, ageRangeFrom25To34: { __typename?: 'AttendeeAgeRange', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number }, ageRangeFrom35To44: { __typename?: 'AttendeeAgeRange', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number }, ageOver44: { __typename?: 'AttendeeAgeRange', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number } } | null } | null } };

export type SeriesEarningsQueryVariables = Exact<{
  filter: EventEarningsFilterInput;
}>;


export type SeriesEarningsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', getEventEarnings?: { __typename?: 'EventEarningsStatistics', totalFees: any, totalPrice: any, totalQuantity: number, totalGratuity: any, totalTaxes: any, serviceFee: any, processingFee: any, hostBalance: any, ticketBreakdown: Array<{ __typename?: 'TicketEarningsBreakdown', eventTicketId: any, ticketType: string, unitPrice: any, totalQuantity: number, totalPrice: any, event?: { __typename?: 'Event', eventId: any } | null }> } | null } };

export type SeriesWorkspaceEventsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SeriesEventsSortBy>;
  sortOrder?: InputMaybe<PageSortOrder>;
}>;


export type SeriesWorkspaceEventsQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', seriesEvents?: { __typename?: 'SeriesEventsConnection', totalCount: number, nodes?: Array<{ __typename?: 'FullEvent', eventId: any, slug: string, displayName: string, avatarUrl: string, startDate: any, endDate: any, timeZone?: string | null, isEnded?: boolean | null, isListed?: boolean | null, isPrivate: boolean, currency?: string | null, eventType: EventType, createdBy?: { __typename?: 'User', userId: any } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeRole?: EventAttendeeRole | null, permissions?: Array<EventPermissionId> | null } | null } | null } | null> | null } | null } };

export type GetEventRolePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventRolePermissionsQuery = { __typename?: 'Query', eventRolePermissions: Array<{ __typename?: 'EventRolePermissions', role: EventAttendeeRole, roleName: string, groups: Array<{ __typename?: 'EventPermissionGroup', category: string, permissions: Array<{ __typename?: 'EventPermissionInfo', id: EventPermissionId, name: string }> }> }> };

export type GetEventBySlugOrIdQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type GetEventBySlugOrIdQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', bySlugOrId?: { __typename?: 'Event', eventType: EventType, ageLimit?: number | null, avatarUrl: string, createdDate: any, description: string, terms?: string | null, faqs?: string | null, disclosureOrPrivacyPolicyTitle?: string | null, disclosureOrPrivacyPolicyFileUrl?: string | null, displayName: string, endDate: any, eventId: any, expiresAt?: any | null, isDeleted: boolean, isFeatured: boolean, isPrivate: boolean, minimumRepScore?: any | null, note: string, optInAgeLimit: boolean, optInAllowGuestInviteOthers: boolean, optInDisclosureOrPrivacyPolicy: boolean, optInDisplayRepScore: boolean, optInLocationRadius: boolean, ticketTermsPurchasePolicy?: string | null, optInQuestionRequirements: boolean, optInShowGuestCount: boolean, optInShowGuestList: boolean, optInSocialAccountRequirements: boolean, requireSocialAccountConnection: boolean, optInAllowPublicEventPagePreview?: boolean | null, slug: string, startDate: any, status: EventStatus, updatedDate?: any | null, uploadedAssetId?: any | null, waitingTickets?: Array<any | null> | null, isListFull?: boolean | null, isStarted?: boolean | null, approvedTickets: any, approvedAttendees?: any | null, pendingAttendees?: any | null, totalAttendees?: any | null, isExpired?: boolean | null, connectedSocialNetworks?: Array<string> | null, totalEventTickets?: any | null, timeZone?: string | null, isAllInPricing?: boolean | null, isInvited: boolean, isSpecialGuest: boolean, optInShowMusicEmbed: boolean, musicEmbedUrl?: string | null, pendingRoleInvites: Array<string>, locationRadius?: { __typename?: 'EventLocation', address?: string | null, isActive?: boolean | null, latitude?: number | null, longitude?: number | null, radius?: number | null, unitLengthType?: EventLocationUnitLengthType | null } | null, tickets?: Array<{ __typename?: 'TicketWithIdOfStoredTicket', count: number, firstSeen?: any | null, status: TicketStatus, ticketId?: string | null, isShareable?: boolean | null, isStaffTicket?: boolean | null, eventTicket?: { __typename?: 'EventTicket', color?: string | null, ticketType?: string | null, eventTicketId: any, isPrivate?: boolean | null, note?: string | null, price?: any | null, optInQrCodePass: boolean } | null, displayEventTicket?: { __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, color?: string | null } | null, scanZones?: Array<{ __typename?: 'ScanningZoneInfo', id: any, name: string, scanCount: number, scannedAtUtc?: any | null, scanTimes?: Array<any> | null, maxScans?: number | null, isUnlimitedScans?: boolean | null } | null> | null } | null> | null, eventTickets2?: Array<{ __typename?: 'EventTicket', isEnabledWishList: boolean, color?: string | null, isFull?: boolean | null, eventTicketId: any, isActive: boolean, price?: any | null, repPoints?: any | null, ticketType?: string | null, isSpecialGuest?: boolean | null, isPrivate?: boolean | null, optInShowTicketAmount: boolean, visibleStartAt?: any | null, visibleEndAt?: any | null, additionalGuests?: number | null, transactionStatus?: TransactionStatus | null, note?: string | null, actionLabel?: string | null, balance?: { __typename?: 'EventTicketBalance', limitedAmount?: number | null, availableAmount?: number | null, releasedAmount: number } | null, specialGuestInfo?: { __typename?: 'SpecialGuestInfo', limitAmount: number, purchasedAmount: number, remainingAmount: number } | null } | null> | null, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null, isOnlyVisibleToApprovedAttendees?: boolean | null, latitude?: number | null, longitude?: number | null } | null, questionRequirements?: Array<{ __typename?: 'QuestionRequirement', isRequired: boolean, question: string, showPublicTickets?: boolean | null, showPrivateTickets?: boolean | null, optInSpecificTicketTypes: boolean, ticketTypeIds?: Array<any> | null }> | null, socialAccountRequirements?: Array<{ __typename?: 'SocialAccountRequirement', isRequired: boolean, scheme: string }> | null, createdBy?: { __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, coordinators?: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> | null, talents?: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeRole?: EventAttendeeRole | null, attendeeState: EventAttendeeState, contestEntryType: ContestEntryType, isContestWinner: boolean, isActive: boolean, note?: string | null, stateChangedUtc?: any | null, privacyPolicyState: EventPrivacyPolicyState, questionRequirementAnswers?: Array<{ __typename?: 'QuestionRequirementAnswer', answer: string, question: string }> | null } | null } | null, achievements?: { __typename?: 'AchievementPageX', nodes: Array<{ __typename?: 'Achievement', avatarUrl: string, achievementId: any, activeFromUtc?: any | null, activeToUtc?: any | null, category?: AchievementCategory | null, bio: string, displayName: string, slug: string, status: AchievementStatus, totalUnlockedUsers?: number | null }> } | null, myAchievements?: Array<{ __typename?: 'Achievement', avatarUrl: string, displayName: string }> | null, userEventBookings?: Array<{ __typename?: 'EventAttendeesBookingInfo', transactionId: any, totalPrice: any, transactionStatus: TransactionStatus, status?: PaymentStatus | null, paymentMethod?: PaymentMethod | null, paidDateUtc?: any | null, createdAtUtc: any, eventTickets?: Array<{ __typename?: 'EventTicketPurchaseInfo', ticketType?: string | null, eventTicketId: any, purchaseAmount: number, eventTicket?: { __typename?: 'EventTicket', isPrivate?: boolean | null } | null } | null> | null } | null> | null } | null } };

export type GetEventTicketsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type GetEventTicketsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', bySlugOrId?: { __typename?: 'Event', eventTickets2?: Array<{ __typename?: 'EventTicket', isFull?: boolean | null, eventTicketId: any, isActive: boolean, price?: any | null, repPoints?: any | null, ticketType?: string | null } | null> | null } | null } };

export type SearchEventsQueryVariables = Exact<{
  criteria?: InputMaybe<SearchEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchEventsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', search?: { __typename?: 'EventGrainPageX', totalCount: any, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean }, nodes: Array<{ __typename?: 'Event', avatarUrl: string, displayName: string, slug: string, eventId: any, startDate: any, status: EventStatus, ageLimit?: number | null, endDate: any, expiresAt?: any | null, minimumRepScore?: any | null, timeZone?: string | null, clubId?: any | null, createdBy?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, name?: string | null, tier: UserTier, userId: any, userName?: string | null, isVerified: boolean } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeState: EventAttendeeState, isActive: boolean, note?: string | null, stateChangedUtc?: any | null, permissions?: Array<EventPermissionId> | null, attendeeRole?: EventAttendeeRole | null, questionRequirementAnswers?: Array<{ __typename?: 'QuestionRequirementAnswer', answer: string, question: string }> | null } | null } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', isFull?: boolean | null, eventTicketId: any, isActive: boolean, price?: any | null, repPoints?: any | null, ticketType?: string | null, isPrivate?: boolean | null, balance?: { __typename?: 'EventTicketBalance', limitedAmount?: number | null } | null } | null> | null } | null }> } | null } };

export type GetMyEventsQueryVariables = Exact<{
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyEventsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', myEvents?: { __typename?: 'MyEventsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'FullEvent', eventType: EventType, avatarUrl: string, displayName: string, slug: string, eventId: any, startDate: any, status: EventStatus, ageLimit?: number | null, endDate: any, expiresAt?: any | null, minimumRepScore?: any | null, approvedAttendees?: any | null, pendingAttendees?: any | null, totalAttendees?: any | null, approvedTickets: any, timeZone?: string | null, scannedTickets: any, clubId?: any | null, createdBy?: { __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any, userName?: string | null }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any, userName?: string | null }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any, userName?: string | null }> } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeRole?: EventAttendeeRole | null } | null } | null } | null> | null } | null } };

export type GetMyCreatedEventsQueryVariables = Exact<{
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMyCreatedEventsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', myCreatedEvents?: { __typename?: 'MyCreatedEventsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'FullEvent', avatarUrl: string, displayName: string, slug: string, eventId: any, startDate: any, status: EventStatus, ageLimit?: number | null, endDate: any, expiresAt?: any | null, minimumRepScore?: any | null, approvedAttendees?: any | null, pendingAttendees?: any | null, totalAttendees?: any | null, timeZone?: string | null, clubId?: any | null, currency?: string | null, isSeriesParentEvent: boolean, createdBy?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, name?: string | null, tier: UserTier, userId: any, userName?: string | null, isVerified: boolean } | null } | null> | null } | null } };

export type FullEventBySlugOrIdQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type FullEventBySlugOrIdQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventType: EventType, ageLimit?: number | null, avatarUrl: string, createdDate: any, currency?: string | null, description: string, terms?: string | null, faqs?: string | null, disclosureOrPrivacyPolicyTitle?: string | null, disclosureOrPrivacyPolicyFileUrl?: string | null, displayName: string, endDate: any, eventId: any, expiresAt?: any | null, isDeleted: boolean, isFeatured: boolean, isPrivate: boolean, minimumRepScore?: any | null, note: string, optInAgeLimit: boolean, optInAllowGuestInviteOthers: boolean, optInDisclosureOrPrivacyPolicy: boolean, optInDisplayRepScore: boolean, optInLocationRadius: boolean, ticketTermsPurchasePolicy?: string | null, optInQuestionRequirements: boolean, optInShowGuestCount: boolean, optInAllowPublicEventPagePreview?: boolean | null, optInShowGuestList: boolean, optInSocialAccountRequirements: boolean, requireSocialAccountConnection: boolean, slug: string, startDate: any, status: EventStatus, updatedDate?: any | null, uploadedAssetId?: any | null, totalEarnings?: any | null, isListFull?: boolean | null, isStarted?: boolean | null, approvedAttendees?: any | null, pendingAttendees?: any | null, totalAttendees?: any | null, isExpired?: boolean | null, isEnded?: boolean | null, canDelete?: boolean | null, timeZone?: string | null, pendingAttendees2: any, approvedTickets: any, scannedTickets: any, totalAvailableTickets: number, invitedAttendees: any, isAllInPricing?: boolean | null, waitingTickets?: Array<any | null> | null, optInShowMusicEmbed: boolean, musicEmbedUrl?: string | null, isListed?: boolean | null, clubId?: any | null, socialReaches?: Array<{ __typename?: 'EventSocialNetworkReaches', reaches: any, socialNetworkScheme: string } | null> | null, locationRadius?: { __typename?: 'EventLocation', address?: string | null, isActive?: boolean | null, latitude?: number | null, longitude?: number | null, radius?: number | null, unitLengthType?: EventLocationUnitLengthType | null } | null, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', isEnabledWishList: boolean, color?: string | null, earning?: any | null, isFull?: boolean | null, eventTicketId: any, isActive: boolean, price?: any | null, repPoints?: any | null, ticketType?: string | null, additionalGuests?: number | null, isRequiredApproval: boolean, isPrivate?: boolean | null, optInShowTicketAmount: boolean, visibleStartAt?: any | null, visibleEndAt?: any | null, gratuityPercentage?: any | null, note?: string | null, createdDate?: any | null, actionLabel?: string | null, optInQrCodePass: boolean, balance?: { __typename?: 'EventTicketBalance', availableAmount?: number | null, lockedAmount: number, releasedAmount: number, limitedAmount?: number | null } | null } | null> | null } | null, inviterEarnings?: Array<{ __typename?: 'InviterEarningMetric', inviterId: any, earnings: any, earningsByTickets: Array<{ __typename?: 'InviterEarningByTicketMetric', inviterId: any, ticketId: any, earning: any }> } | null> | null, eventTickets2?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, earning?: any | null, isPrivate?: boolean | null } | null> | null, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null, isOnlyVisibleToApprovedAttendees?: boolean | null, latitude?: number | null, longitude?: number | null } | null, questionRequirements?: Array<{ __typename?: 'QuestionRequirement', isRequired: boolean, question: string, showPublicTickets?: boolean | null, showPrivateTickets?: boolean | null, optInSpecificTicketTypes: boolean, ticketTypeIds?: Array<any> | null }> | null, socialAccountRequirements?: Array<{ __typename?: 'SocialAccountRequirement', isRequired: boolean, scheme: string }> | null, createdBy?: { __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, repScore: number, emailAddress?: string | null } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, emailAddress?: string | null }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, emailAddress?: string | null }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, emailAddress?: string | null }> } | null, doors?: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, emailAddress?: string | null }> | null, coordinators?: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, emailAddress?: string | null }> | null, talents?: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, emailAddress?: string | null }> | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeState: EventAttendeeState, isActive: boolean, note?: string | null, stateChangedUtc?: any | null, permissions?: Array<EventPermissionId> | null, questionRequirementAnswers?: Array<{ __typename?: 'QuestionRequirementAnswer', answer: string, question: string }> | null } | null } | null, achievements?: { __typename?: 'AchievementPageX', nodes: Array<{ __typename?: 'Achievement', avatarUrl: string, achievementId: any, activeFromUtc?: any | null, activeToUtc?: any | null, category?: AchievementCategory | null, bio: string, displayName: string, slug: string, status: AchievementStatus, totalUnlockedUsers?: number | null }> } | null, invitations?: Array<{ __typename?: 'EventInvitation', invitationSource: EventInvitationSource, invitationSourceKey: string, event?: { __typename?: 'FullEvent', eventId: any, avatarUrl: string, displayName: string } | null } | null> | null, waitingTicketsUsersCount?: Array<{ __typename?: 'EventTicketWaitingUsersCount', count: any, eventTicketId: any } | null> | null, usersRoles?: Array<{ __typename?: 'EventUserRole', role: EventAttendeeRole, user?: { __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, emailAddress?: string | null } | null }> | null, pendingUsersRoles?: Array<{ __typename?: 'PendingEventUserRole', email?: string | null, role: EventAttendeeRole, user?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, emailAddress?: string | null } | null }> | null, scanningZones?: Array<{ __typename?: 'ScanningZone', eventTicketIds?: Array<any> | null, id?: any | null, isPrimary?: boolean | null, name: string, resetScansDaily?: boolean | null, eventTicketSettings?: Array<{ __typename?: 'ScanningZoneEventTicketSetting', eventTicketId?: any | null, maxScans?: number | null, isUnlimitedScans?: boolean | null }> | null }> | null } | null } };

export type GetSocialReachesQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetSocialReachesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', socialReaches?: Array<{ __typename?: 'EventSocialNetworkReaches', socialNetworkScheme: string, reaches: any } | null> | null } | null } };

export type GetEventAttendeesQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type GetEventAttendeesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', bySlugOrId?: { __typename?: 'Event', approvedAttendeeTickets?: Array<{ __typename?: 'EventAttendeeTicket', userInfo?: { __typename?: 'User', avatarUrl?: string | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null, purchasedTicketInfo: { __typename?: 'EventTicketPurchaseInfoLite', purchasedQuantity: any, ticketType: string }, eventTicketInfo: { __typename?: 'EventTicket', additionalGuests?: number | null } } | null> | null } | null } };

export type GetEventBookingsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EventBookingFilterArgsInput>;
}>;


export type GetEventBookingsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, displayName: string, avatarUrl: string, isListFull?: boolean | null, isCoHost?: boolean | null, isPromoter?: boolean | null, pendingAttendees2: any, approvedTickets: any, scannedTickets: any, totalAvailableTickets: number, invitedAttendees: any, createdBy?: { __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', isFull?: boolean | null, eventTicketId: any, isActive: boolean, price?: any | null, repPoints?: any | null, ticketType?: string | null, isPrivate?: boolean | null, balance?: { __typename?: 'EventTicketBalance', limitedAmount?: number | null } | null } | null> | null } | null, eventBookings2?: { __typename?: 'EventAttendeesBookingInfoPageX', totalCount: any, pageInfo: { __typename?: 'PageInfoX', hasNextPage: boolean, endCursor?: string | null }, nodes: Array<{ __typename?: 'EventAttendeesBookingInfo', transactionId: any, totalPrice: any, transactionStatus: TransactionStatus, type: TransactionType, status?: PaymentStatus | null, paymentMethod?: PaymentMethod | null, paidDateUtc?: any | null, createdAtUtc: any, user?: { __typename?: 'UserWithGeneralLocation', userName?: string | null, userId: any, tier: UserTier, name?: string | null, isVerified: boolean, gender?: UserGender | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, age?: number | null, ageRange?: string | null, dateOfBirth?: any | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', scheme: string, userId: string, displayName?: string | null, avatarUrl?: string | null, profileLink?: string | null, username?: string | null } | null> | null } | null, eventTickets?: Array<{ __typename?: 'EventTicketPurchaseInfo', ticketType?: string | null, eventTicketId: any, purchaseAmount: number, price?: any | null } | null> | null, tickets?: Array<{ __typename?: 'TicketWithIdOfStoredTicket', firstSeen?: any | null, status: TicketStatus, ticketId?: string | null, transactionId?: any | null, eventTicket?: { __typename?: 'EventTicket', ticketType?: string | null } | null } | null> | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', permissions?: Array<EventPermissionId> | null, attendeeRole?: EventAttendeeRole | null, attendeeState: EventAttendeeState, questionRequirementAnswers?: Array<{ __typename?: 'QuestionRequirementAnswer', question: string, answer: string }> | null } | null, userInfo?: { __typename?: 'UserWithAddress', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, address?: { __typename?: 'UserAddressModel', address?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null, region?: string | null } | null } | null } | null }> } | null } | null } };

export type GetAllSavedListNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSavedListNameQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', listSaveGuestListNames?: Array<string | null> | null } };

export type GetSavedListDetailsQueryVariables = Exact<{
  listName: Scalars['String']['input'];
}>;


export type GetSavedListDetailsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', getSavedGuestList?: { __typename?: 'SavedGuestList', name: string, lastUpdatedUtc: any, guestInvitations: Array<{ __typename?: 'GuestInvitationInfo', fullName?: string | null, phoneNumber?: string | null, email: string, plus1?: string | null }> } | null } };

export type CountUniqueInviteesQueryVariables = Exact<{
  includeSources?: InputMaybe<Array<EventInvitationSourceArgsInput> | EventInvitationSourceArgsInput>;
}>;


export type CountUniqueInviteesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', countUniqueInvitees: number } };

export type GetTicketsAmountRequiredForApprovalQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
}>;


export type GetTicketsAmountRequiredForApprovalQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', getTicketsAmountRequiredForApproval?: Array<{ __typename?: 'IncreaseTicketsAmountInfo', requiredAmount: number, eventTicket: { __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null } } | null> | null } };

export type GetEventTicketBalancesQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type GetEventTicketBalancesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, price?: any | null, balance?: { __typename?: 'EventTicketBalance', availableAmount?: number | null, limitedAmount?: number | null } | null } | null> | null } | null } | null } };

export type GetEventCommentsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type GetEventCommentsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', bySlugOrId?: { __typename?: 'Event', comments?: { __typename?: 'EventCommentModelPageX', totalCount: any, nodes: Array<{ __typename?: 'EventComment', comment: string, commentId: any, createdAt: any, eventId: any, medias: Array<string>, parentCommentId?: any | null, reactions?: Array<{ __typename?: 'EventCommentReaction', reaction: string, reactionId: any, user: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } } | null> | null, replies?: { __typename?: 'EventCommentModelPageX', totalCount: any, nodes: Array<{ __typename?: 'EventComment', comment: string, commentId: any, createdAt: any, eventId: any, medias: Array<string>, parentCommentId?: any | null, reactions?: Array<{ __typename?: 'EventCommentReaction', reaction: string, reactionId: any, user: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, userName?: string | null, userId: any, tier: UserTier } } | null> | null, user: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, userName?: string | null, userId: any, tier: UserTier }, replies?: { __typename?: 'EventCommentModelPageX', totalCount: any, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean }, nodes: Array<{ __typename?: 'EventComment', comment: string, commentId: any, createdAt: any, eventId: any, medias: Array<string>, parentCommentId?: any | null, user: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, userName?: string | null, userId: any, tier: UserTier }, reactions?: Array<{ __typename?: 'EventCommentReaction', reaction: string, reactionId: any, user: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } } | null> | null }> } | null }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null, user: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, userName?: string | null, userId: any, tier: UserTier } }>, pageInfo: { __typename?: 'PageInfoX', hasNextPage: boolean, endCursor?: string | null } } | null } | null } };

export type GetBillInfoQueryVariables = Exact<{
  subTotal: Scalars['Decimal']['input'];
}>;


export type GetBillInfoQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', getBillInfo?: { __typename?: 'EventBillInfo', serviceFee: any, processingFee: any, subTotal: any, total: any } | null } };

export type GetEventTicketFeesQueryVariables = Exact<{
  items: Array<PaymentItemInput> | PaymentItemInput;
}>;


export type GetEventTicketFeesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', calculateFees?: { __typename?: 'FeeCalculationResult', partnerFeeAmount: any, processingFeeAmount: any, serviceFeeAmount: any, subTotalAmount: any, totalAmount: any, totalTaxFeeAmount: any, taxes: Array<{ __typename?: 'TaxItem', taxCode: string, amount: any }> } | null } };

export type GetApprovedAttendeesListQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetApprovedAttendeesListQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', bySlugOrId?: { __typename?: 'Event', attendeesPage?: { __typename?: 'EventAttendeeInfoPageX', totalCount: any, nodes: Array<{ __typename?: 'EventAttendeeInfo', userInfo?: { __typename?: 'UserWithAddress', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfoX', hasNextPage: boolean, endCursor?: string | null } } | null } | null } };

export type GetAttendeeBookingsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<DetailsAttendeeFilterArgsInput>;
}>;


export type GetAttendeeBookingsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, displayName: string, startDate: any, endDate: any, avatarUrl: string, isListFull?: boolean | null, pendingAttendees2: any, approvedTickets: any, scannedTickets: any, totalAvailableTickets: number, invitedAttendees: any, isExpired?: boolean | null, isEnded?: boolean | null, waitingTickets?: Array<any | null> | null, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null } | null, scanningZones?: Array<{ __typename?: 'ScanningZone', id?: any | null, isPrimary?: boolean | null, name: string, resetScansDaily?: boolean | null, eventTicketSettings?: Array<{ __typename?: 'ScanningZoneEventTicketSetting', eventTicketId?: any | null, maxScans?: number | null, isUnlimitedScans?: boolean | null }> | null }> | null, waitingTicketsUsersCount?: Array<{ __typename?: 'EventTicketWaitingUsersCount', count: any, eventTicketId: any } | null> | null, usersRoles?: Array<{ __typename?: 'EventUserRole', role: EventAttendeeRole, user?: { __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, repScore: number } | null }> | null, createdBy?: { __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeState: EventAttendeeState, isActive: boolean, note?: string | null, stateChangedUtc?: any | null, permissions?: Array<EventPermissionId> | null, questionRequirementAnswers?: Array<{ __typename?: 'QuestionRequirementAnswer', answer: string, question: string }> | null } | null } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', age?: number | null, ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, dateOfBirth?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, eventTickets?: { __typename?: 'EventTicketConnection', totalCount: number, nodes?: Array<{ __typename?: 'EventTicket', isFull?: boolean | null, eventTicketId: any, isActive: boolean, price?: any | null, repPoints?: any | null, ticketType?: string | null, isPrivate?: boolean | null, isEnabledWishList: boolean, isRequiredApproval: boolean, eventId: any, creatorId: any, optInShowTicketAmount: boolean, visibleStartAt?: any | null, visibleEndAt?: any | null, optInQrCodePass: boolean, balance?: { __typename?: 'EventTicketBalance', releasedAmount: number, lockedAmount: number, limitedAmount?: number | null, availableAmount?: number | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, detailsAttendees?: { __typename?: 'DetailsAttendeeConnection', totalCount: number, ticketCount?: number | null, invitedCount?: number | null, checkedInCount?: number | null, pendingAttendeesCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes?: Array<{ __typename?: 'DetailsAttendee', attendeeRoles?: Array<EventAttendeeRole | null> | null, waiverStatus: AttendeeWaiverStatus, checkedInCount: number, status: AttendeeFilterStatus, approvalUser?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, gender?: UserGender | null, isVerified: boolean, tier: UserTier, userId: any, userName?: string | null, name?: string | null, repScore: number } | null, inviter?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, name?: string | null, userId: any, tier: UserTier, repScore: number } | null, attendeeInfo: { __typename?: 'EventUserInfo', attendeeRole?: EventAttendeeRole | null, attendeeState: EventAttendeeState, isActive: boolean, privacyPolicyState: EventPrivacyPolicyState, permissions?: Array<EventPermissionId> | null, approvalAt?: any | null, privacyPolicyStateUpdatedAt?: any | null, questionRequirementAnswers?: Array<{ __typename?: 'QuestionRequirementAnswer', question: string, answer: string }> | null }, tickets: Array<{ __typename?: 'DetailsAttendeeTicket', ticketId: any, ticketInfo: { __typename?: 'StoredTicket', ticketName?: string | null, firstSeen: any, originalTicketId?: any | null, transactionId?: any | null, ticketType?: TicketType | null, count: number, associatedUserId: any, status: TicketStatus, parentTicketId?: any | null, displayEventTicketId?: any | null, displayEventTicket?: { __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null } | null }, bookingInfo?: { __typename?: 'EventAttendeesBookingInfo', captureOrderId?: string | null, createdAtUtc: any, eventId: any, giftSenderId?: any | null, paidDateUtc?: any | null, paymentMethod?: PaymentMethod | null, quantity: any, status?: PaymentStatus | null, totalPrice: any, transactionId: any, transactionStatus: TransactionStatus, type: TransactionType, updateAtUtc: any, userId: any, items?: Array<{ __typename?: 'PaymentItems', entityId: any, eventId?: any | null, isFree: boolean, name?: string | null, price: any, productType?: ProductType | null, quantity: any, taxCode?: string | null, ticketType?: string | null }> | null } | null }>, user?: { __typename?: 'UserWithAddress', ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, gender?: UserGender | null, isVerified: boolean, tier: UserTier, userId: any, userName?: string | null, age?: number | null, dateOfBirth?: any | null, name?: string | null, repScore: number, address?: { __typename?: 'UserAddressModel', address?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null, region?: string | null } | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', avatarUrl?: string | null, displayName?: string | null, profileLink?: string | null, scheme: string, userId: string, username?: string | null } | null> | null } | null, bookings?: Array<{ __typename?: 'EventAttendeesBookingInfo', transactionId: any, totalPrice: any, transactionStatus: TransactionStatus, status?: PaymentStatus | null, paymentMethod?: PaymentMethod | null, paidDateUtc?: any | null, createdAtUtc: any, eventId: any, quantity: any, type: TransactionType, updateAtUtc: any, userId: any, eventTickets?: Array<{ __typename?: 'EventTicketPurchaseInfo', ticketType?: string | null, eventTicketId: any, purchaseAmount: number, price?: any | null, eventId: any, eventTicket?: { __typename?: 'EventTicket', additionalGuests?: number | null } | null } | null> | null } | null> | null } | null> | null } | null } | null } };

export type GetDetailsAttendeeQueryVariables = Exact<{
  attendeeId: Scalars['UUID']['input'];
  slugOrId: Scalars['String']['input'];
}>;


export type GetDetailsAttendeeQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', detailsAttendee?: { __typename?: 'DetailsAttendee', attendeeRoles?: Array<EventAttendeeRole | null> | null, waiverStatus: AttendeeWaiverStatus, checkedInCount: number, status: AttendeeFilterStatus, approvalUser?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, gender?: UserGender | null, isVerified: boolean, tier: UserTier, userId: any, userName?: string | null, name?: string | null, repScore: number } | null, attendeeInfo: { __typename?: 'EventUserInfo', attendeeRole?: EventAttendeeRole | null, attendeeState: EventAttendeeState, isActive: boolean, privacyPolicyState: EventPrivacyPolicyState, permissions?: Array<EventPermissionId> | null, approvalAt?: any | null, privacyPolicyStateUpdatedAt?: any | null, questionRequirementAnswers?: Array<{ __typename?: 'QuestionRequirementAnswer', question: string, answer: string }> | null }, tickets: Array<{ __typename?: 'DetailsAttendeeTicket', ticketId: any, ticketInfo: { __typename?: 'StoredTicket', firstSeen: any, originalTicketId?: any | null, transactionId?: any | null, ticketType?: TicketType | null, count: number, associatedUserId: any, status: TicketStatus, parentTicketId?: any | null, displayEventTicketId?: any | null, displayEventTicket?: { __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null } | null }, bookingInfo?: { __typename?: 'EventAttendeesBookingInfo', captureOrderId?: string | null, createdAtUtc: any, eventId: any, giftSenderId?: any | null, paidDateUtc?: any | null, paymentMethod?: PaymentMethod | null, quantity: any, status?: PaymentStatus | null, totalPrice: any, transactionId: any, transactionStatus: TransactionStatus, type: TransactionType, updateAtUtc: any, userId: any, items?: Array<{ __typename?: 'PaymentItems', entityId: any, eventId?: any | null, isFree: boolean, name?: string | null, price: any, productType?: ProductType | null, quantity: any, taxCode?: string | null, ticketType?: string | null }> | null } | null }>, user?: { __typename?: 'UserWithAddress', ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, gender?: UserGender | null, isVerified: boolean, tier: UserTier, userId: any, userName?: string | null, age?: number | null, dateOfBirth?: any | null, name?: string | null, repScore: number, address?: { __typename?: 'UserAddressModel', address?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null, region?: string | null } | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', avatarUrl?: string | null, displayName?: string | null, profileLink?: string | null, scheme: string, userId: string, username?: string | null } | null> | null } | null, eligibility: { __typename?: 'AttendeeEligibilityInfo', hasProfilePicture: boolean, hasConnectedInstagram: boolean, instagramHandle?: string | null, instagramConnectedAt?: any | null, hasDownloadedApp: boolean }, shareStats: { __typename?: 'AttendeeShareStats', clicks: number, logins: number, ticketAcquisitions: number }, bookings?: Array<{ __typename?: 'EventAttendeesBookingInfo', transactionId: any, totalPrice: any, transactionStatus: TransactionStatus, status?: PaymentStatus | null, paymentMethod?: PaymentMethod | null, paidDateUtc?: any | null, createdAtUtc: any, eventId: any, quantity: any, type: TransactionType, updateAtUtc: any, userId: any, eventTickets?: Array<{ __typename?: 'EventTicketPurchaseInfo', ticketType?: string | null, eventTicketId: any, purchaseAmount: number, price?: any | null, eventId: any } | null> | null } | null> | null } | null } | null } };

export type ExportAttendeesQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type ExportAttendeesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', attendeesExport?: { __typename?: 'AttendeeExportedMaster', eventTickets: Array<{ __typename?: 'AttendeeExportedTicket', id: any, name: string, additionalGuests: number }>, guestList?: Array<{ __typename?: 'GuestInfoWithEventAndMatch', emailAddress?: string | null, quantity: number, phoneNumber?: string | null, fullName: string, guestId: any, checkedInQuantity?: number | null, eventTicket?: { __typename?: 'EventTicket', ticketType?: string | null, eventTicketId: any } | null }> | null, attendees: Array<{ __typename?: 'AttendeeExportedInfo', userId: any, name: string, gender: string, emailAddress: string, ageRange: string, answers: Array<string>, tickets: string, additionalGuests: number, ticketPrices: Array<any | null>, totalSpent: any, questions: Array<string>, repScore: any, status: string, acceptedPolicyTime?: any | null, transactionTime?: any | null, approvedTime?: any | null, checkedInCount: number, totalAmountWithoutFees: any, paypalOrderId?: string | null, paypalPaymentId?: string | null, paypalTransactionFee?: any | null, paypalTotalPrice?: any | null, approvedBy?: string | null, purchasedItems?: Array<{ __typename?: 'PaymentItems', ticketType?: string | null, eventId?: any | null, quantity: any, price: any }> | null, displayEventTickets?: Array<{ __typename?: 'DisplayEventTicketInfo', ticketType: string, eventTicketId: any, checkedInCount: number, count: number, price: any, totalPrice: any, additionalGuests: number, gratuityPercentage?: any | null, createdDate?: any | null, tickets?: Array<{ __typename?: 'DetailsAttendeeTicket', ticketId: any, ticketInfo: { __typename?: 'StoredTicket', count: number, ticketType?: TicketType | null }, bookingInfo?: { __typename?: 'EventAttendeesBookingInfo', type: TransactionType } | null }> | null }> | null }> } | null } | null } };

export type GetEventAttendeeStatisticsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  filter?: InputMaybe<DetailsAttendeeFilterArgsInput>;
}>;


export type GetEventAttendeeStatisticsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, displayName: string, avatarUrl: string, isListFull?: boolean | null, pendingAttendees2: any, approvedTickets: any, scannedTickets: any, totalAvailableTickets: number, invitedAttendees: any, detailsAttendees?: { __typename?: 'DetailsAttendeeConnection', totalCount: number, ticketCount?: number | null, invitedCount?: number | null, checkedInCount?: number | null, pendingAttendeesCount?: number | null } | null } | null } };

export type CalculateTicketCostQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  items: Array<TicketCostItemArgsInput> | TicketCostItemArgsInput;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<AddressModelInput>;
}>;


export type CalculateTicketCostQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', calculateTicketCost?: { __typename?: 'TicketCostInfo', hostBalance: any, isAllInPricing: boolean, processingFee: any, serviceFee: any, subTotal: any, total: any, paymentAuthCode: string, totalGratuity: any, totalTaxes: any, taxName?: string | null, taxPercentage?: any | null, useAutomaticTax: boolean, items: Array<{ __typename?: 'TicketCostItem', price: any, originalPrice: any, quantity: number, eventTicketId: any, gratuityPercentage?: any | null }> } | null } };

export type SimulateTicketCostQueryVariables = Exact<{
  items: Array<TicketCostSimulationItemInput> | TicketCostSimulationItemInput;
  isAllInPricing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SimulateTicketCostQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', simulateTicketCost?: { __typename?: 'TicketCostInfo', hostBalance: any, isAllInPricing: boolean, processingFee: any, serviceFee: any, subTotal: any, total: any, totalGratuity: any, totalTaxes: any, items: Array<{ __typename?: 'TicketCostItem', price: any, originalPrice: any, quantity: number }> } | null } };

export type GetRequestedPayoutInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequestedPayoutInfoQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', requestedPayoutInfo: { __typename?: 'RequestedPayoutResult', canRequestPayout: boolean, lastRequestedTime?: any | null, totalBalance: any, totalAmount: any, totalReleasedAmount: any } } };

export type GetRequestedPayoutInfoByCurrencyQueryVariables = Exact<{
  currency: Scalars['String']['input'];
}>;


export type GetRequestedPayoutInfoByCurrencyQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', requestedPayoutInfoByCurrency: { __typename?: 'RequestedPayoutResult', canRequestPayout: boolean, lastRequestedTime?: any | null, totalBalance: any, totalAmount: any, totalReleasedAmount: any } } };

export type MyReferralCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type MyReferralCodeQuery = { __typename?: 'Query', myReferralCode: string };

export type SearchEventGuestsQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchEventGuestsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', searchEventGuests?: { __typename?: 'SearchEventGuestsConnection', totalCount: number, edges?: Array<{ __typename?: 'SearchEventGuestsEdge', node?: { __typename?: 'EventGuest', eventId: any, guestId: any, eventTicketIds?: Array<any> | null, fullName: string, emailAddress?: string | null, phoneNumber?: string | null, avatarUrl?: string | null, note?: string | null, createdAt: any, createdBy: any, customFields: Array<{ __typename?: 'GuestCustomField', key: string, label: string, value: string }>, tickets?: Array<{ __typename?: 'EventGuestTicket', ticketId: any, ticketNo: number, eventTicketId: any, guestName: string, createdAt: any, createdBy: any, checkedInAt?: any | null, guestId: any, avatarUrl?: string | null, eventTicket?: { __typename?: 'EventTicket', ticketType?: string | null } | null } | null> | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } };

export type CheckContactEmailExistsQueryVariables = Exact<{
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CheckContactEmailExistsQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', emailsExist?: Array<string | null> | null } };

export type CheckContactPhoneNumbersExistQueryVariables = Exact<{
  phones: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CheckContactPhoneNumbersExistQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', phonesExist?: Array<string | null> | null } };

export type GetUserEventPolicyReactionsQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type GetUserEventPolicyReactionsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', getUserEventPolicyReactions?: Array<{ __typename?: 'StoredUserReactionEventPolicy', policyFileUrl?: string | null, policyTitle?: string | null, reaction: EventPolicyReaction, reactionTime: any, signedDisclosureFileUrl?: string | null, disclosureReferenceId?: string | null, signedWaiverFileUrl?: string | null, signedEventId?: any | null, signedEventName?: string | null }> | null } };

export type GetScheduledEventMessagesQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  status?: InputMaybe<ScheduledMessageStatus>;
}>;


export type GetScheduledEventMessagesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', scheduledEventMessages: Array<{ __typename?: 'ScheduledMessageModel', id: any, message: string, smsMessage?: string | null, sendAt: any, isViaEmail: boolean, isViaSms: boolean, status: ScheduledMessageStatus, createdBy: any, createdAt: any, sentAt?: any | null, canceledAt?: any | null, canceledBy?: any | null, updatedAt?: any | null, updatedBy?: any | null, filterArgs: { __typename?: 'EventMessageFilterArgs', eventMessageType: EventMessageType, eventTicketIds?: Array<any> | null, eventAttendeeRoles?: Array<EventAttendeeRole> | null, attendeeStatuses?: Array<SendMessageGroupAttendeeStatus> | null } }> } };

export type CheckedInTicketSummaryQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
}>;


export type CheckedInTicketSummaryQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', ticketSummary?: { __typename?: 'TicketSummary', eventId: any, totalIssuedTickets: number, totalCheckedInTickets: number, totalScans: number, event: { __typename?: 'FullEvent', displayName: string }, dailyScans: Array<{ __typename?: 'DailyScanCount', date: any, totalScans: number }>, ticketSummaries: Array<{ __typename?: 'TicketSummaryRow', eventTicketId: any, totalIssuedTickets: number, totalCheckedInTickets: number, totalScans: number, eventTicket?: { __typename?: 'EventTicket', ticketType?: string | null, isPrivate?: boolean | null } | null, zoneSummaries: Array<{ __typename?: 'TicketZoneSummaryRow', eventTicketZoneId: any, totalCheckedInTickets: number, totalScans: number, zoneName?: string | null, dailyScans: Array<{ __typename?: 'DailyScanCount', date: any, totalScans: number }> }> }> } | null } };

export type EventScanRecordsQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sortType?: InputMaybe<ScanRecordSortType>;
  sortOrder?: InputMaybe<PageSortOrder>;
  filterArgs?: InputMaybe<ScanRecordFilterArgsInput>;
}>;


export type EventScanRecordsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', eventScanRecords?: { __typename?: 'EventScanRecordsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'EventScanRecordsEdge', cursor: string, node?: { __typename?: 'ScanRecord', scanTime: any, zoneId: any, zoneName?: string | null, ticketId: any, eventTicketId: any, associatedUserId?: any | null, isSeriesPass: boolean, memberEventId?: any | null, ticketType?: { __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null } | null, attendee?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, emailAddress?: string | null } | null, scanner?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null } | null } | null }> | null } | null } };

export type GetEventEarningsQueryVariables = Exact<{
  filter: EventEarningsFilterInput;
}>;


export type GetEventEarningsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', getEventEarnings?: { __typename?: 'EventEarningsStatistics', hostBalance: any, processingFee: any, serviceFee: any, totalFees: any, subTotal: any, totalQuantity: number, totalPrice: any, totalTaxes: any, totalGratuity: any, ticketBreakdown: Array<{ __typename?: 'TicketEarningsBreakdown', eventTicketId: any, ticketType: string, unitPrice: any, totalQuantity: number, totalPrice: any, event?: { __typename?: 'Event', eventId: any, displayName: string } | null }> } | null } };

export type EventPayoutRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type EventPayoutRequestsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', listPayoutRequests: Array<{ __typename?: 'PayoutRequestAdmin', amount: any, lastRequestedTime?: any | null, paidDate?: any | null, requestId: any, status: PayoutRequestStatus, userId: any }> } };

export type EventPayoutRequestsByCurrencyQueryVariables = Exact<{
  currency: Scalars['String']['input'];
}>;


export type EventPayoutRequestsByCurrencyQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', listPayoutRequestsByCurrency: Array<{ __typename?: 'PayoutRequestAdmin', amount: any, lastRequestedTime?: any | null, paidDate?: any | null, requestId: any, status: PayoutRequestStatus, userId: any }> } };

export type ValidatePdfWatermarkQueryVariables = Exact<{
  fileUrl: Scalars['String']['input'];
}>;


export type ValidatePdfWatermarkQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', validatePdfWatermark?: { __typename?: 'WatermarkValidationResult', errorMessage?: string | null, fileExists: boolean, isValid: boolean } | null } };

export type GetBulkInviteStatusQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  jobId: Scalars['String']['input'];
}>;


export type GetBulkInviteStatusQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', bulkInviteStatus?: { __typename?: 'BulkInviteStatusModel', status: JobStatus, totalCount: number, processedCount: number, sentCount: number, skippedCount: number, failCount: number, startedAt: any, completedAt?: any | null } | null } };

export type CheckoutStatusQueryVariables = Exact<{
  paymentReferenceId: Scalars['String']['input'];
}>;


export type CheckoutStatusQuery = { __typename?: 'Query', eventTicket: { __typename?: 'EventTicketQueryApi', checkoutStatus: TicketCheckoutStatus } };

export type GetHostMessageInboxQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetHostMessageInboxQuery = { __typename?: 'Query', hostMessage: { __typename?: 'HostMessageQueryApi', inbox: { __typename?: 'HostInboxResponse', total: any, endCursor?: string | null, messages: Array<{ __typename?: 'HostMessageResponse', messageId: any, body: string, sentAt: any, isRead: boolean, senderId: any, eventId: any, hostId: any, readAt?: any | null, senderAvatar?: string | null, senderAvatarSource?: AvatarSource | null, senderInstagramAvatarUrl?: string | null, senderTikTokAvatarUrl?: string | null, senderTwitchAvatarUrl?: string | null, senderName?: string | null, parentMessageId?: any | null, threadId: any, eventSlug?: string | null, eventName?: string | null, eventAvatar?: string | null, kind: HostMessageKind, isViaEmail?: boolean | null, isViaSms?: boolean | null, recipientCount: number, delivery?: { __typename?: 'HostMessageDeliveryResponse', sentCount: number, failCount: number, suppressedCount: number, completedAt: any } | null }> } } };

export type GetHostMessageQueryVariables = Exact<{
  messageId: Scalars['UUID']['input'];
}>;


export type GetHostMessageQuery = { __typename?: 'Query', hostMessage: { __typename?: 'HostMessageQueryApi', get?: { __typename?: 'HostMessageResponse', messageId: any, threadId: any, body: string, sentAt: any, isRead: boolean, senderId: any, eventId: any, kind: HostMessageKind, isViaEmail?: boolean | null, isViaSms?: boolean | null, recipientCount: number, delivery?: { __typename?: 'HostMessageDeliveryResponse', sentCount: number, failCount: number, suppressedCount: number, completedAt: any } | null } | null } };

export type GetIndividualAssetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndividualAssetQuery = { __typename?: 'Query', individual_asset: { __typename?: 'IndividualAssetQueryApi', list?: Array<{ __typename?: 'IndividualAsset', individualAssetId: any, imageUrl: string, name: string, category: IndividualAssetCategory, createdUtc: any, maxSupply: any, currentSupply: any, priority: number, status: IndividualAssetStatus, isHidden: boolean, price: { __typename?: 'Amount', symbol: string, value: any } } | null> | null } };

export type GetNotificationsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  notificationTypes?: InputMaybe<Array<NotificationType> | NotificationType>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notification: { __typename?: 'NotificationQueryApi', countUnreadNotifications: any, listNotifications2?: { __typename?: 'NotificationGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Notification', notificationId: any, isRead: boolean, readAt?: any | null, createdAt: any, receiver?: { __typename?: 'User', userId: any } | null, content: { __typename?: 'NotificationContent', defaultMessage: string, defaultPayload: { __typename?: 'NotificationPayload', notificationType: NotificationType, createdAt: any, customProperties: Array<{ __typename?: 'CustomProperty', key: string, value?: string | null }> } } }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null, activeJobs?: Array<{ __typename?: 'ActiveJobSummary', jobId: string, type: ActiveJobType, status: JobStatus, totalCount: number, processedCount: number, eventId?: any | null, startedAt: any }> | null } };

export type GetClubOfferBySlugQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  filter?: InputMaybe<FilterOfferCriteriaInput>;
}>;


export type GetClubOfferBySlugQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', clubId: any, offers?: { __typename?: 'OffersConnection', edges?: Array<{ __typename?: 'OffersEdge', cursor: string, node?: { __typename?: 'ClubOfferState', access: ClubOfferAccess, published: ClubOfferPublished, type: OfferType } | null }> | null, nodes?: Array<{ __typename?: 'ClubOfferState', offerId: any, access: ClubOfferAccess, published: ClubOfferPublished, type: OfferType, rewards: Array<{ __typename?: 'RewardState', avatarUrl: string, coverUrl: string, description: string, name: string, quantity: number, rewardId: any, type: OfferRewardType, timeFrameConstraint?: { __typename?: 'TimeFrameConstraint', endDateTime?: any | null, expiresDateTime?: any | null, startDateTime?: any | null, timeFrameType: RewardTimeFrameType, timeZoneId?: string | null } | null, conditions: Array<{ __typename?: 'AchievementsRewardCondition', type: RewardConditionType, achievements: Array<{ __typename?: 'AchievementState', achievementId: any, avatarUrl: string, description: string, name: string, type: ClubAchievementType } | null> } | { __typename?: 'LoyaltyTierRewardCondition', type: RewardConditionType, loyaltyTiersByClub: Array<{ __typename?: 'LoyaltyTierByClubCondition', level: number, club?: { __typename?: 'ClubState', clubId: any, name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', backgroundImageUrl?: string | null, description?: string | null, level: number, name: string, title?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null>, membership?: { __typename?: 'ClubMembership', tier?: { __typename?: 'ClubTier', level: number, name: string, title?: string | null } | null } | null } | null } | null> } | { __typename?: 'PriceRewardCondition', price: any, repPoints: any, type: RewardConditionType } | { __typename?: 'RepPointsRewardCondition', type: RewardConditionType, repPointsByClub: Array<{ __typename?: 'RepPointsByClubCondition', repPoints: any, club?: { __typename?: 'ClubState', clubId: any, name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', backgroundImageUrl?: string | null, description?: string | null, level: number, name: string, title?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null> } | null } | null> } | { __typename?: 'RepScoreRewardCondition', repScore: any, type: RewardConditionType } | null> } | null> } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } | null };

export type GetClubOfferByIdQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  offerId: Scalars['UUID']['input'];
}>;


export type GetClubOfferByIdQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', clubId: any, name: string, offers?: { __typename?: 'OffersConnection', nodes?: Array<{ __typename?: 'ClubOfferState', access: ClubOfferAccess, offerId: any, published: ClubOfferPublished, type: OfferType, configuration?: { __typename?: 'OfferConfigurationPayload', pointsPurchase?: { __typename?: 'OfferPointsPurchaseConfigurationPayload', isDefault: boolean, strategy?: { __typename?: 'BucketPointsPurchaseStrategyPayload', percentageDiscountStrategy?: { __typename?: 'PercentageBucketPointsPurchaseStrategy', baseCostPerPoint: any, discountBuckets: Array<{ __typename?: 'PercentageDiscountBucketPoints', discountPercentage: any, points: any }> } | null } | null } | null } | null, requirements?: { __typename?: 'ClubOfferRequirement', age?: { __typename?: 'ClubOfferRequirementAge', minimumAge: number } | null, membershipAge?: { __typename?: 'ClubOfferRequirementMembershipAge', age: any } | null, minimumPoints?: { __typename?: 'ClubOfferRequirementMinimumPoints', amount: any, class?: number | null } | null, notAfter?: { __typename?: 'BasicRequirementNotAfterDateOfClubOfferRequirementEvalContext', notAfter: any } | null, notBefore?: { __typename?: 'BasicRequirementNotBeforeDateOfClubOfferRequirementEvalContext', notBefore: any } | null, clubMembership?: { __typename?: 'ClubOfferRequirementOtherClubMembership', minimumMembershipAge?: any | null } | null } | null, rewards: Array<{ __typename?: 'RewardState', avatarUrl: string, coverUrl: string, description: string, name: string, quantity: number, rewardId: any, type: OfferRewardType, conditions: Array<{ __typename?: 'AchievementsRewardCondition', type: RewardConditionType, achievements: Array<{ __typename?: 'AchievementState', achievementId: any, avatarUrl: string, description: string, name: string, type: ClubAchievementType } | null> } | { __typename?: 'LoyaltyTierRewardCondition', type: RewardConditionType, loyaltyTiersByClub: Array<{ __typename?: 'LoyaltyTierByClubCondition', level: number, club?: { __typename?: 'ClubState', clubId: any, name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', backgroundImageUrl?: string | null, description?: string | null, level: number, name: string, title?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null>, membership?: { __typename?: 'ClubMembership', tier?: { __typename?: 'ClubTier', level: number, name: string, title?: string | null } | null } | null } | null } | null> } | { __typename?: 'PriceRewardCondition', price: any, repPoints: any, type: RewardConditionType } | { __typename?: 'RepPointsRewardCondition', type: RewardConditionType, repPointsByClub: Array<{ __typename?: 'RepPointsByClubCondition', repPoints: any, club?: { __typename?: 'ClubState', clubId: any, name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', backgroundImageUrl?: string | null, description?: string | null, level: number, name: string, title?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null> } | null } | null> } | { __typename?: 'RepScoreRewardCondition', repScore: any, type: RewardConditionType } | null>, redemption?: { __typename?: 'AccessPassRewardRedemption', code: string, guide?: string | null, isGenerated: boolean, note?: string | null, redemptionType: RewardRedemptionType } | { __typename?: 'CustomerInformationRewardRedemption', guide?: string | null, note?: string | null, redemptionType: RewardRedemptionType, customerInformationScope: { __typename?: 'CustomerInformationScope', isAddressEnabled: boolean, isEmailEnabled: boolean, isNameEnabled: boolean, isPhoneNumberEnabled: boolean, isSocialMediaAccountEnabled: boolean, isUserNameEnabled: boolean, socialMediaAccountScope: { __typename?: 'SocialMediaAccountScope', apple: boolean, facebook: boolean, instagram: boolean, linkedIn: boolean, tikTok: boolean, twitch: boolean, x: boolean, youTube: boolean } } } | { __typename?: 'InviteLinkRewardRedemption', guide?: string | null, code: string, isGenerated: boolean, link: string, note?: string | null, redemptionType: RewardRedemptionType } | { __typename?: 'LocationInformationRewardRedemption', guide?: string | null, note?: string | null, redemptionType: RewardRedemptionType, code: string, isGenerated: boolean, addressDetails: { __typename?: 'AddressDetails', city: string, countryCode: string, phoneNumber: string, postalCode: string, state: string, streetAddress: string } } | { __typename?: 'PromoCodeRewardRedemption', guide?: string | null, code: string, isGenerated: boolean, note?: string | null, redemptionType: RewardRedemptionType } | null, timeFrameConstraint?: { __typename?: 'TimeFrameConstraint', endDateTime?: any | null, expiresDateTime?: any | null, startDateTime?: any | null, timeFrameType: RewardTimeFrameType, timeZoneId?: string | null } | null, ageConstraint?: { __typename?: 'AgeConstraint', maximumAge?: number | null, minimumAge?: number | null } | null } | null> } | null> | null } | null, teamMemberRoles?: Array<{ __typename?: 'ClubTeamMemberRoleState', roleId: any, user?: { __typename?: 'User', userId: any } | null } | null> | null } | null };

export type GetTransactionFeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransactionFeesQuery = { __typename?: 'Query', paypal: { __typename?: 'PaypalQueryApi', options: { __typename?: 'PaypalOptions', clientId: string, transactionFees: { __typename?: 'TransactionFees', amount: any, percentage: any }, payoutFees: { __typename?: 'PayoutFees', percentageSplit: any } } } };

export type GetPieByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetPieByIdQuery = { __typename?: 'Query', pie: { __typename?: 'PieQueryApi', byId?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, bio?: string | null, rank?: number | null, isVerified: boolean, issuedSlices: any, holdingSlices: any, slicesHeld: any, pieAvatarUrl?: string | null, canBuy?: boolean | null, canSell?: boolean | null, canTransfer?: boolean | null, canBeForSale?: boolean | null, createdUtc: any, balance?: any | null, floatPercentage: any, totalMembers: any, hasPurchasedPiePreviously?: boolean | null, maxSlices?: any | null, userPermissions?: Array<string | null> | null, socialMedia: Array<{ __typename?: 'SocialMediaPair', value: string, scheme: string }>, individualAssets?: { __typename?: 'IndividualAssetGrainPageX', nodes: Array<{ __typename?: 'IndividualAsset', individualAssetId: any, imageUrl: string, category: IndividualAssetCategory, price: { __typename?: 'Amount', symbol: string, value: any } }> } | null, uploadedAssets?: { __typename?: 'UploadedAssetGrainPageX', nodes: Array<{ __typename?: 'UploadedAsset', uploadedAssetId: any, url: string, target: UploadedAssetTarget }> } | null, rewardList2?: { __typename?: 'RewardGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Reward', rewardId: any, displayName: string, status: RewardStatus, avatarUrl: string, bio?: string | null, type: RewardType, slug: string }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null, slicePrice: { __typename?: 'Amount', symbol: string, value: any }, initialOffer?: { __typename?: 'PublicPieInitialOfferModel', maximumPurchaseVolume: any, minimumPurchaseVolume: any, purchaseMultiple: any } | null, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null, moderators?: { __typename?: 'StoredModeratorPageX', nodes: Array<{ __typename?: 'StoredModerator', assignDate: any, pieRole: PieRole, user?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null }> } | null, totalValue: { __typename?: 'Amount', symbol: string, value: any }, pieBalance?: { __typename?: 'PieBalance', availableSlices: any, soldSlices: any, sentSlices: any, receivedSlices: any, slicesOwnedByUsers: any } | null } | null } };

export type GetPieBySlugOrIdQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type GetPieBySlugOrIdQuery = { __typename?: 'Query', pie: { __typename?: 'PieQueryApi', bySlugOrId?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, bio?: string | null, rank?: number | null, isVerified: boolean, issuedSlices: any, holdingSlices: any, slicesHeld: any, pieAvatarUrl?: string | null, canBuy?: boolean | null, canSell?: boolean | null, canTransfer?: boolean | null, canBeForSale?: boolean | null, createdUtc: any, balance?: any | null, floatPercentage: any, totalMembers: any, hasPurchasedPiePreviously?: boolean | null, wished?: boolean | null, wishersCount?: number | null, maxSlices?: any | null, userPermissions?: Array<string | null> | null, socialMedia: Array<{ __typename?: 'SocialMediaPair', value: string, scheme: string }>, individualAssets?: { __typename?: 'IndividualAssetGrainPageX', nodes: Array<{ __typename?: 'IndividualAsset', individualAssetId: any, imageUrl: string, category: IndividualAssetCategory, price: { __typename?: 'Amount', symbol: string, value: any } }> } | null, uploadedAssets?: { __typename?: 'UploadedAssetGrainPageX', nodes: Array<{ __typename?: 'UploadedAsset', uploadedAssetId: any, url: string, target: UploadedAssetTarget }> } | null, rewardList2?: { __typename?: 'RewardGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Reward', rewardId: any, displayName: string, status: RewardStatus, avatarUrl: string, bio?: string | null, type: RewardType, slug: string }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null, slicePrice: { __typename?: 'Amount', symbol: string, value: any }, initialOffer?: { __typename?: 'PublicPieInitialOfferModel', maximumPurchaseVolume: any, minimumPurchaseVolume: any, purchaseMultiple: any } | null, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null, totalValue: { __typename?: 'Amount', symbol: string, value: any }, pieBalance?: { __typename?: 'PieBalance', availableSlices: any, soldSlices: any, sentSlices: any, receivedSlices: any, slicesOwnedByUsers: any } | null } | null } };

export type GetPiePublicBySlugOrIdQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type GetPiePublicBySlugOrIdQuery = { __typename?: 'Query', piePublic: { __typename?: 'PiePublicQueryApi', bySlugOrId?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string } | null } };

export type GetPiesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PieType>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  repbetsPieFirst?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPiesQuery = { __typename?: 'Query', pie: { __typename?: 'PieQueryApi', search2?: { __typename?: 'PieGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, rank?: number | null, bio?: string | null, pieAvatarUrl?: string | null, canBeForSale?: boolean | null, issuedSlices: any, holdingSlices: any, totalUniqueSubscribers: number, createdUtc: any, slicesHeld: any, totalMembers: any, wished?: boolean | null, wishersCount?: number | null, slicePrice: { __typename?: 'Amount', value: any }, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null, rewardList2?: { __typename?: 'RewardGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Reward', rewardId: any, displayName: string, status: RewardStatus, avatarUrl: string, bio?: string | null, type: RewardType }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null, pieBalance?: { __typename?: 'PieBalance', availableSlices: any, soldSlices: any, sentSlices: any, receivedSlices: any, slicesOwnedByUsers: any } | null }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null } };

export type GetSliderPiesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
}>;


export type GetSliderPiesQuery = { __typename?: 'Query', pie: { __typename?: 'PieQueryApi', searchRandom?: { __typename?: 'PieGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, rank?: number | null, bio?: string | null, pieAvatarUrl?: string | null, canBeForSale?: boolean | null, issuedSlices: any, holdingSlices: any, totalUniqueSubscribers: number, createdUtc: any, slicesHeld: any, totalMembers: any, wished?: boolean | null, wishersCount?: number | null, slicePrice: { __typename?: 'Amount', value: any }, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null, rewardList2?: { __typename?: 'RewardGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Reward', rewardId: any, displayName: string, status: RewardStatus, avatarUrl: string, bio?: string | null, type: RewardType }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null, pieBalance?: { __typename?: 'PieBalance', availableSlices: any, soldSlices: any, sentSlices: any, receivedSlices: any, slicesOwnedByUsers: any } | null }> } | null } };

export type GetRepbetsPieQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRepbetsPieQuery = { __typename?: 'Query', pie: { __typename?: 'PieQueryApi', repbets?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, rank?: number | null, bio?: string | null, pieAvatarUrl?: string | null, canBeForSale?: boolean | null, issuedSlices: any, holdingSlices: any, totalUniqueSubscribers: number, createdUtc: any, slicesHeld: any, totalMembers: any, slicePrice: { __typename?: 'Amount', value: any }, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null, rewardList2?: { __typename?: 'RewardGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Reward', rewardId: any, displayName: string, status: RewardStatus, avatarUrl: string, bio?: string | null, type: RewardType }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null, pieBalance?: { __typename?: 'PieBalance', availableSlices: any, soldSlices: any, sentSlices: any, receivedSlices: any, slicesOwnedByUsers: any } | null } | null } };

export type GetMyPiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyPiesQuery = { __typename?: 'Query', pie: { __typename?: 'PieQueryApi', myPies?: { __typename?: 'PieGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, rank?: number | null, bio?: string | null, pieAvatarUrl?: string | null, truePieAvatarUrl?: string | null, canBuy?: boolean | null, canSell?: boolean | null, canTransfer?: boolean | null, canBeForSale?: boolean | null, onBoardingProcess?: OnboardingProcess | null, issuedSlices: any, holdingSlices: any, totalUniqueSubscribers: number, createdUtc: any, slicesHeld: any, floatPercentage: any, operationalState: PieOperationalState, totalMembers: any, maxSlices?: any | null, userPermissions?: Array<string | null> | null, isTransfering?: boolean | null, slicePrice: { __typename?: 'Amount', value: any }, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null, rewardList2?: { __typename?: 'RewardGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Reward', rewardId: any, displayName: string, status: RewardStatus, avatarUrl: string, bio?: string | null, type: RewardType }> } | null, totalValue: { __typename?: 'Amount', symbol: string, value: any }, individualAssets?: { __typename?: 'IndividualAssetGrainPageX', nodes: Array<{ __typename?: 'IndividualAsset', individualAssetId: any, imageUrl: string, category: IndividualAssetCategory, price: { __typename?: 'Amount', symbol: string, value: any } }> } | null, pieBalance?: { __typename?: 'PieBalance', availableSlices: any, soldSlices: any, sentSlices: any, receivedSlices: any, slicesOwnedByUsers: any } | null, uploadedAssets?: { __typename?: 'UploadedAssetGrainPageX', nodes: Array<{ __typename?: 'UploadedAsset', uploadedAssetId: any, url: string, target: UploadedAssetTarget }> } | null }> } | null, myModeratorPies?: { __typename?: 'PieGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, rank?: number | null, bio?: string | null, pieAvatarUrl?: string | null, truePieAvatarUrl?: string | null, canBuy?: boolean | null, canSell?: boolean | null, canTransfer?: boolean | null, canBeForSale?: boolean | null, onBoardingProcess?: OnboardingProcess | null, issuedSlices: any, holdingSlices: any, totalUniqueSubscribers: number, createdUtc: any, slicesHeld: any, floatPercentage: any, operationalState: PieOperationalState, totalMembers: any, maxSlices?: any | null, userPermissions?: Array<string | null> | null, slicePrice: { __typename?: 'Amount', value: any }, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null, rewardList2?: { __typename?: 'RewardGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Reward', rewardId: any, displayName: string, status: RewardStatus, avatarUrl: string, bio?: string | null, type: RewardType }> } | null, totalValue: { __typename?: 'Amount', symbol: string, value: any }, individualAssets?: { __typename?: 'IndividualAssetGrainPageX', nodes: Array<{ __typename?: 'IndividualAsset', individualAssetId: any, imageUrl: string, category: IndividualAssetCategory, price: { __typename?: 'Amount', symbol: string, value: any } }> } | null, pieBalance?: { __typename?: 'PieBalance', availableSlices: any, soldSlices: any, sentSlices: any, receivedSlices: any, slicesOwnedByUsers: any } | null, uploadedAssets?: { __typename?: 'UploadedAssetGrainPageX', nodes: Array<{ __typename?: 'UploadedAsset', uploadedAssetId: any, url: string, target: UploadedAssetTarget }> } | null }> } | null } };

export type GetPieSalesQueryVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  sortingType?: InputMaybe<TradingTransactionSortingType>;
  sortingOrder?: InputMaybe<PageSortOrder>;
}>;


export type GetPieSalesQuery = { __typename?: 'Query', pie: { __typename?: 'PieQueryApi', listSales2?: { __typename?: 'TradingTransactionGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'TradingTransaction', transactionId: any, type?: string | null, price?: any | null, status?: PaymentStatus | null, tradeSlices?: any | null, totalPrice?: any | null, paymentMethod?: PaymentMethod | null, createdAtUtc: any, user?: { __typename?: 'UserWithGeneralLocation', name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, userId: any, userName?: string | null } | null, pie?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string } | null }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null } };

export type GetNumberOfSlicesOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNumberOfSlicesOptionsQuery = { __typename?: 'Query', pie: { __typename?: 'PieQueryApi', numberOfSlicesOptions: Array<{ __typename?: 'NumberOfSlicesOption', slice: any, price: any }> } };

export type GetPieSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPieSettingsQuery = { __typename?: 'Query', pie: { __typename?: 'PieQueryApi', pieSettings: { __typename?: 'PieSetting', maxNumberOfSlicesForFreePie: number } } };

export type GetDefaultMaxSlicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultMaxSlicesQuery = { __typename?: 'Query', pie: { __typename?: 'PieQueryApi', defaultMaxSlices: any } };

export type PublicGetEmailSubscriptionsQueryVariables = Exact<{
  emailAddress: Scalars['String']['input'];
}>;


export type PublicGetEmailSubscriptionsQuery = { __typename?: 'Query', public: { __typename?: 'PublicQueryApi', userByEmail: { __typename?: 'QueryPublicUser', emailSubscriptions?: Array<{ __typename?: 'EmailSubscription', status: EmailSubscriptionStatus, type: EmailSubscriptionType }> | null } } };

export type GetPublicConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublicConfigurationQuery = { __typename?: 'Query', publicConfiguration: { __typename?: 'PublicConfigurationModel', paymentProcessor: PaymentMethod, defaultTaxName: string, defaultTaxPercentage: any } };

export type GetSupportedCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupportedCurrenciesQuery = { __typename?: 'Query', supportedCurrencies: Array<{ __typename?: 'SupportedCurrencyType', code: string, isZeroDecimal: boolean, name: string, symbol: string }> };

export type GetListOfRepClubsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetListOfRepClubsQuery = { __typename?: 'Query', clubs?: { __typename?: 'ClubsConnection', nodes?: Array<{ __typename?: 'ClubInformationCondensed', access: ClubAccess, canJoin: boolean, clubId: any, createdAt: any, description: string, isMember: boolean, isVerified: boolean, name: string, published: ClubPublished, memberCount?: any | null, slug?: string | null, colors?: { __typename?: 'ClubColors', background: string, border: string, dropShadow?: string | null, foreground: string } | null, images?: { __typename?: 'ClubImages', background?: string | null, icon?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', description?: string | null, level: number, name: string, backgroundImageUrl?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null> } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetSingleClubQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSingleClubQuery = { __typename?: 'Query', club?: { __typename?: 'ClubState', name: string, access: ClubAccess, published: ClubPublished, description: string, tiers: Array<{ __typename?: 'ClubTier', level: number, name: string, backgroundImageUrl?: string | null } | null>, membership?: { __typename?: 'ClubMembership', joinedAt: any, tier?: { __typename?: 'ClubTier', level: number, name: string, backgroundImageUrl?: string | null } | null } | null } | null };

export type GetSingleRepClubBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetSingleRepClubBySlugQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', access: ClubAccess, canJoin: boolean, clubId: any, createdAt: any, description: string, isMember: boolean, isVerified: boolean, name: string, published: ClubPublished, memberCount?: any | null, slug?: string | null, colors?: { __typename?: 'ClubColors', background: string, border: string, dropShadow?: string | null, foreground: string } | null, images?: { __typename?: 'ClubImages', background?: string | null, icon?: string | null } | null, membership?: { __typename?: 'ClubMembership', joinedAt: any, tier?: { __typename?: 'ClubTier', description?: string | null, level: number, name: string, backgroundImageUrl?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null } | null, tiers: Array<{ __typename?: 'ClubTier', description?: string | null, level: number, name: string, backgroundImageUrl?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null>, permissions: Array<{ __typename?: 'ClubPermission', name?: string | null, description?: string | null } | null> } | null };

export type SearchClubsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  keyword: Scalars['String']['input'];
}>;


export type SearchClubsQuery = { __typename?: 'Query', searchClubs?: { __typename?: 'SearchClubsConnection', nodes?: Array<{ __typename?: 'ClubInformationCondensed', access: ClubAccess, canJoin: boolean, clubId: any, createdAt: any, description: string, isMember: boolean, isVerified: boolean, name: string, published: ClubPublished, memberCount?: any | null, slug?: string | null, colors?: { __typename?: 'ClubColors', background: string, border: string, dropShadow?: string | null, foreground: string } | null, images?: { __typename?: 'ClubImages', background?: string | null, icon?: string | null } | null, membership?: { __typename?: 'ClubMembership', joinedAt: any, tier?: { __typename?: 'ClubTier', description?: string | null, level: number, name: string, backgroundImageUrl?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null, balances: Array<{ __typename?: 'ClubMembershipBalance', balance: any, isTransferable: boolean, class: number, name: string, symbol: string } | null> } | null, tiers: Array<{ __typename?: 'ClubTier', description?: string | null, level: number, name: string, backgroundImageUrl?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null> } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetUserClubsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserClubsQuery = { __typename?: 'Query', me?: { __typename?: 'CurrentUser', memberships?: { __typename?: 'ClubMembershipWithUserConnection', nodes?: Array<{ __typename?: 'ClubMembershipWithUser', balances: Array<{ __typename?: 'ClubMembershipBalance', balance: any, isTransferable: boolean, class: number, name: string, symbol: string } | null>, club?: { __typename?: 'ClubInformationCondensed', clubId: any, name: string, slug?: string | null, published: ClubPublished, description: string, isVerified: boolean, images?: { __typename?: 'ClubImages', icon?: string | null, background?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', description?: string | null, level: number, name: string, backgroundImageUrl?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } | null };

export type GetManagedClubsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagedClubsQuery = { __typename?: 'Query', me?: { __typename?: 'CurrentUser', managedClubs: Array<{ __typename?: 'ClubState', clubId: any, createdAt: any, description: string, isVerified: boolean, access: ClubAccess, name: string, published: ClubPublished, slug?: string | null, isMember: boolean, colors?: { __typename?: 'ClubColors', foreground: string, dropShadow?: string | null, border: string, background: string } | null, images?: { __typename?: 'ClubImages', icon?: string | null, background?: string | null } | null, owner?: { __typename?: 'User', userId: any, userName?: string | null } | null, teamCollaborators?: Array<{ __typename?: 'ClubTeamCollaboratorState', assignDate: any, role: TeamCollaboratorRole, user?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null } | null> | null, teamMemberRoles?: Array<{ __typename?: 'ClubTeamMemberRoleState', roleId: any, user?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null } | null> | null, tiers: Array<{ __typename?: 'ClubTier', description?: string | null, level: number, name: string, backgroundImageUrl?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null>, permissions: Array<{ __typename?: 'ClubPermission', name?: string | null, description?: string | null } | null> }> } | null };

export type GetClubBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetClubBySlugQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', clubId: any, memberCount?: any | null, createdAt: any, description: string, isVerified: boolean, access: ClubAccess, name: string, published: ClubPublished, slug?: string | null, colors?: { __typename?: 'ClubColors', foreground: string, dropShadow?: string | null, border: string, background: string } | null, images?: { __typename?: 'ClubImages', icon?: string | null, background?: string | null } | null, owner?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null, teamCollaborators?: Array<{ __typename?: 'ClubTeamCollaboratorState', assignDate: any, role: TeamCollaboratorRole, user?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null } | null> | null, teamMemberRoles?: Array<{ __typename?: 'ClubTeamMemberRoleState', roleId: any, user?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null, role?: { __typename?: 'ClubRolePermissionState', roleName: string, permissions?: Array<ClubPermissionId> | null } | null } | null> | null, tiers: Array<{ __typename?: 'ClubTier', description?: string | null, level: number, name: string, backgroundImageUrl?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null, requirements?: { __typename?: 'ClubTierRequirement', minimumPoints?: { __typename?: 'ClubTierMinimumPointsRequirement', amount: any } | null } | null } | null>, permissions: Array<{ __typename?: 'ClubPermission', name?: string | null, description?: string | null } | null>, visibleRequirements?: { __typename?: 'ClubRequirement', age?: { __typename?: 'ClubRequirementAge', minimumAge: number } | null } | null } | null };

export type GetClubAchievementsBySlugQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
}>;


export type GetClubAchievementsBySlugQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', clubId: any, achievements?: { __typename?: 'AchievementsConnection', nodes?: Array<{ __typename?: 'AchievementState', achievementId: any, avatarUrl: string, description: string, name: string, type: ClubAchievementType } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges?: Array<{ __typename?: 'AchievementsEdge', cursor: string }> | null } | null } | null };

export type GetDefaultBuyPointsOfferQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetDefaultBuyPointsOfferQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', defaultBuyPointsOffer?: { __typename?: 'ClubOfferState', access: ClubOfferAccess, offerId: any, published: ClubOfferPublished, type: OfferType, configuration?: { __typename?: 'OfferConfigurationPayload', pointsPurchase?: { __typename?: 'OfferPointsPurchaseConfigurationPayload', isDefault: boolean, strategy?: { __typename?: 'BucketPointsPurchaseStrategyPayload', percentageDiscountStrategy?: { __typename?: 'PercentageBucketPointsPurchaseStrategy', baseCostPerPoint: any, discountBuckets: Array<{ __typename?: 'PercentageDiscountBucketPoints', discountPercentage: any, points: any }> } | null } | null } | null } | null } | null } | null };

export type GetRewardByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetRewardByIdQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', byId?: { __typename?: 'Reward', rewardId: any, displayName: string, bio?: string | null, slug: string, createdUtc: any, avatarUrl: string, individualApiUrl: string, mustOwnSlicesAmount?: any | null, mustOwnSlicesStartDate?: any | null, mustOwnSlicesEndDate?: any | null, notes?: string | null, redeemCode?: string | null, redeemDescription?: string | null, redeemType?: RedeemType | null, ageLimit?: number | null, maxWinners?: number | null, status: RewardStatus, type: RewardType, category?: RewardCategory | null, isHidden: boolean, winnersChosenOption?: WinnersChosenOption | null, expiresAt?: any | null, startDate?: any | null, endDate: any, isStarted?: boolean | null, canShareByParticipants: boolean, needNewSlices: boolean, optInParticipantPrivacyPolicy: boolean, participantPrivacyPolicyTitle?: string | null, participantPrivacyPolicyContent?: string | null, policyFileUrl?: string | null, requireAllAchievements: boolean, listPolicyInfo?: { __typename?: 'RewardPolicyInfoPageX', nodes: Array<{ __typename?: 'RewardPolicyInfo', policyInfo: { __typename?: 'StoredRewardPolicyInfo', url: string, createdUtc: any } }> } | null, geoRangeCondition?: { __typename?: 'RewardGeoRangeCondition', address?: string | null, latitude: number, longitude: number, isActive: boolean, radius: number, locationUnitLengthType: LocationUnitLengthType } | null, pie?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, balance?: any | null, userPermissions?: Array<string | null> | null, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null, pieBalance?: { __typename?: 'PieBalance', availableSlices: any } | null } | null, ownSlicesConditions?: { __typename?: 'StoredOwnSlicesConditionPageX', nodes: Array<{ __typename?: 'StoredOwnSlicesCondition', id?: any | null, pieId: any, amount: any, startDate?: any | null, endDate: any }> } | null, achievementBadgeConditions?: { __typename?: 'StoredAchievementBadgeConditionPageX', nodes: Array<{ __typename?: 'StoredAchievementBadgeCondition', id?: any | null, achievementId: any, startDate?: any | null, endDate: any, achievement?: { __typename?: 'PublicAchievementModel', achievementId: any, bio: string, displayName: string, avatarUrl: string, createdUtc: any, status: AchievementStatus, category?: AchievementCategory | null, isHidden: boolean, slug: string } | null }> } | null, winningBoosts?: { __typename?: 'StoredWinningBoostPageX', nodes: Array<{ __typename?: 'StoredWinningBoost', id?: any | null, key?: string | null, score: any, type: WinningBoostType }> } | null, bonusAchievements?: { __typename?: 'AchievementGrainPageX', nodes: Array<{ __typename?: 'Achievement', achievementId: any, bio: string, displayName: string, avatarUrl: string, createdUtc: any, status: AchievementStatus, category?: AchievementCategory | null, isHidden: boolean, slug: string }> } | null, tickets?: { __typename?: 'UserTicketPageX', nodes: Array<{ __typename?: 'UserTicket', ticketId?: string | null }> } | null, userRewardInfo?: { __typename?: 'UserReward', userInfo?: { __typename?: 'UserWithAddress', userId: any, userName?: string | null } | null, userRewardInfo?: { __typename?: 'RewardUserInfoType', createdUtc: any, participateState: ParticipateState, participateReason: ParticipateReason, ordinalWinner?: number | null, sharedPhoneNumber?: string | null, sharedEmailAddress?: string | null, sharedName?: string | null, confirmSharedUserInfo?: boolean | null, participantPrivacyPolicyState: ParticipantPrivacyPolicyState, sharedAddress?: { __typename?: 'AddressModel', address: string, city: string, region?: string | null, postalCode?: string | null, countryCode: string } | null, socialMediaAccounts?: Array<{ __typename?: 'SocialMediaAccount', isRequired: boolean, scheme: string, avatarUrl?: string | null, displayName?: string | null, profileLink?: string | null }> | null } | null } | null } | null } };

export type GetRewardBySlugOrIdQueryVariables = Exact<{
  pieSlugOrId: Scalars['String']['input'];
  rewardSlugOrId: Scalars['String']['input'];
}>;


export type GetRewardBySlugOrIdQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', bySlugOrId?: { __typename?: 'Reward', rewardId: any, displayName: string, bio?: string | null, slug: string, createdUtc: any, avatarUrl: string, individualApiUrl: string, mustOwnSlicesAmount?: any | null, mustOwnSlicesStartDate?: any | null, mustOwnSlicesEndDate?: any | null, notes?: string | null, redeemCode?: string | null, redeemDescription?: string | null, redeemType?: RedeemType | null, ageLimit?: number | null, maxWinners?: number | null, status: RewardStatus, type: RewardType, category?: RewardCategory | null, isHidden: boolean, winnersChosenOption?: WinnersChosenOption | null, expiresAt?: any | null, startDate?: any | null, endDate: any, isStarted?: boolean | null, canShareByParticipants: boolean, needNewSlices: boolean, optInParticipantPrivacyPolicy: boolean, participantPrivacyPolicyTitle?: string | null, participantPrivacyPolicyContent?: string | null, policyFileUrl?: string | null, requireAllAchievements: boolean, listPolicyInfo?: { __typename?: 'RewardPolicyInfoPageX', nodes: Array<{ __typename?: 'RewardPolicyInfo', policyInfo: { __typename?: 'StoredRewardPolicyInfo', url: string, createdUtc: any } }> } | null, geoRangeCondition?: { __typename?: 'RewardGeoRangeCondition', address?: string | null, latitude: number, longitude: number, isActive: boolean, radius: number, locationUnitLengthType: LocationUnitLengthType } | null, pie?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, balance?: any | null, userPermissions?: Array<string | null> | null, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null, pieBalance?: { __typename?: 'PieBalance', availableSlices: any } | null } | null, ownSlicesConditions?: { __typename?: 'StoredOwnSlicesConditionPageX', nodes: Array<{ __typename?: 'StoredOwnSlicesCondition', id?: any | null, pieId: any, amount: any, startDate?: any | null, endDate: any }> } | null, achievementBadgeConditions?: { __typename?: 'StoredAchievementBadgeConditionPageX', nodes: Array<{ __typename?: 'StoredAchievementBadgeCondition', id?: any | null, achievementId: any, startDate?: any | null, endDate: any, achievement?: { __typename?: 'PublicAchievementModel', achievementId: any, bio: string, displayName: string, avatarUrl: string, createdUtc: any, status: AchievementStatus, category?: AchievementCategory | null, isHidden: boolean, slug: string } | null }> } | null, winningBoosts?: { __typename?: 'StoredWinningBoostPageX', nodes: Array<{ __typename?: 'StoredWinningBoost', id?: any | null, key?: string | null, score: any, type: WinningBoostType }> } | null, bonusAchievements?: { __typename?: 'AchievementGrainPageX', nodes: Array<{ __typename?: 'Achievement', achievementId: any, bio: string, displayName: string, avatarUrl: string, createdUtc: any, status: AchievementStatus, category?: AchievementCategory | null, isHidden: boolean, slug: string }> } | null, tickets?: { __typename?: 'UserTicketPageX', nodes: Array<{ __typename?: 'UserTicket', ticketId?: string | null }> } | null, userRewardInfo?: { __typename?: 'UserReward', userInfo?: { __typename?: 'UserWithAddress', userId: any, userName?: string | null } | null, userRewardInfo?: { __typename?: 'RewardUserInfoType', createdUtc: any, participateState: ParticipateState, participateReason: ParticipateReason, ordinalWinner?: number | null, sharedPhoneNumber?: string | null, sharedEmailAddress?: string | null, sharedName?: string | null, confirmSharedUserInfo?: boolean | null, participantPrivacyPolicyState: ParticipantPrivacyPolicyState, sharedAddress?: { __typename?: 'AddressModel', address: string, city: string, region?: string | null, postalCode?: string | null, countryCode: string } | null, socialMediaAccounts?: Array<{ __typename?: 'SocialMediaAccount', isRequired: boolean, scheme: string, avatarUrl?: string | null, displayName?: string | null, profileLink?: string | null }> | null } | null } | null } | null } };

export type GetRewardListPolicyReactionBySlugOrIdQueryVariables = Exact<{
  pieSlugOrId: Scalars['String']['input'];
  rewardSlugOrId: Scalars['String']['input'];
}>;


export type GetRewardListPolicyReactionBySlugOrIdQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', bySlugOrId?: { __typename?: 'Reward', listPolicyReaction?: { __typename?: 'RewardPolicyReactionInfoPageX', nodes: Array<{ __typename?: 'RewardPolicyReactionInfo', userInfo?: { __typename?: 'User', userId: any, name?: string | null } | null, reactionInfo: { __typename?: 'StoredUserReactionRewardPolicy', userId: any, reaction: RewardPolicyReaction, reactionTime: any } }> } | null } | null } };

export type GetRewardsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  participateState?: InputMaybe<ParticipateState>;
  participateReason?: InputMaybe<ParticipateReason>;
  sortingType?: InputMaybe<UserRewardSortType>;
  sortingOrder?: InputMaybe<PageSortOrder>;
}>;


export type GetRewardsQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', search2?: { __typename?: 'RewardGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Reward', rewardId: any, displayName: string, createdUtc: any, bio?: string | null, slug: string, avatarUrl: string, status: RewardStatus, type: RewardType, category?: RewardCategory | null, winnersChosenOption?: WinnersChosenOption | null, expiresAt?: any | null, mustOwnSlicesAmount?: any | null, mustOwnSlicesStartDate?: any | null, mustOwnSlicesEndDate?: any | null, startDate?: any | null, endDate: any, userRewardInfo?: { __typename?: 'UserReward', userRewardInfo?: { __typename?: 'RewardUserInfoType', participateReason: ParticipateReason, participateState: ParticipateState } | null } | null, pie?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null } | null }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null } };

export type GetRewardsByPieIdQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  pieId: Scalars['UUID']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  rewardLaunchStatus?: InputMaybe<RewardLaunchStatus>;
}>;


export type GetRewardsByPieIdQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', listByPieId2?: { __typename?: 'RewardStatisticV2', totalUnlockRewardAmount: number, rewardList?: { __typename?: 'RewardGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Reward', rewardId: any, displayName: string, createdUtc: any, bio?: string | null, slug: string, avatarUrl: string, status: RewardStatus, type: RewardType, category?: RewardCategory | null, winnersChosenOption?: WinnersChosenOption | null, expiresAt?: any | null, mustOwnSlicesAmount?: any | null, mustOwnSlicesStartDate?: any | null, mustOwnSlicesEndDate?: any | null, startDate?: any | null, endDate: any, totalActivatedUserAmount?: number | null, totalParticipants?: number | null, pie?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null } | null }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null } | null } };

export type GetRewardUsersStatisticByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  participateStates?: InputMaybe<Array<ParticipateState> | ParticipateState>;
}>;


export type GetRewardUsersStatisticByIdQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', byId?: { __typename?: 'Reward', activatedUserAgeRangeStatistic?: { __typename?: 'ActivatedUserAgeRangeStatistic', totalFemaleAmount: number, totalFemaleAmountPercentage: number, totalMaleAmount: number, totalMaleAmountPercentage: number, totalOtherAmount: number, totalOtherAmountPercentage: number, ageRangeFrom18To24: { __typename?: 'ActivatedUserAgeRange', totalFemaleAmount: number, totalFemaleAmountPercentage: number, totalMaleAmount: number, totalMaleAmountPercentage: number, totalOtherAmount: number, totalOtherAmountPercentage: number }, ageRangeFrom25To34: { __typename?: 'ActivatedUserAgeRange', totalFemaleAmount: number, totalFemaleAmountPercentage: number, totalMaleAmount: number, totalMaleAmountPercentage: number, totalOtherAmount: number, totalOtherAmountPercentage: number }, ageRangeFrom35To44: { __typename?: 'ActivatedUserAgeRange', totalFemaleAmount: number, totalFemaleAmountPercentage: number, totalMaleAmount: number, totalMaleAmountPercentage: number, totalOtherAmount: number, totalOtherAmountPercentage: number }, ageOver44: { __typename?: 'ActivatedUserAgeRange', totalFemaleAmount: number, totalFemaleAmountPercentage: number, totalMaleAmount: number, totalMaleAmountPercentage: number, totalOtherAmount: number, totalOtherAmountPercentage: number } } | null } | null } };

export type GetRewardUsersByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  sortingType?: InputMaybe<RewardSortingType>;
  sortingOrder?: InputMaybe<PageSortOrder>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  participateStates?: InputMaybe<Array<ParticipateState> | ParticipateState>;
}>;


export type GetRewardUsersByIdQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', byId?: { __typename?: 'Reward', rewardUsers2?: { __typename?: 'UserRewardPageX', totalCount: any, nodes: Array<{ __typename?: 'UserReward', holdingSlices: any, userInfo?: { __typename?: 'UserWithAddress', userId: any, isVerified: boolean, name?: string | null, gender?: UserGender | null, ageRange?: string | null, dateOfBirth?: any | null, userName?: string | null, address?: { __typename?: 'UserAddressModel', address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null } | null } | null, userRewardInfo?: { __typename?: 'RewardUserInfoType', createdUtc: any, participateState: ParticipateState, participateReason: ParticipateReason, ordinalWinner?: number | null, sharedPhoneNumber?: string | null, sharedEmailAddress?: string | null, sharedName?: string | null, confirmSharedUserInfo?: boolean | null, sharedAddress?: { __typename?: 'AddressModel', address: string, city: string, region?: string | null, postalCode?: string | null, countryCode: string } | null, socialMediaAccounts?: Array<{ __typename?: 'SocialMediaAccount', isRequired: boolean, scheme: string, avatarUrl?: string | null, displayName?: string | null, profileLink?: string | null }> | null } | null }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null } | null } };

export type GetRewardParticipantsQueryVariables = Exact<{
  rewardId: Scalars['UUID']['input'];
  participateStates?: InputMaybe<Array<ParticipateState> | ParticipateState>;
}>;


export type GetRewardParticipantsQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', byId?: { __typename?: 'Reward', participants?: Array<{ __typename?: 'RewardParticipant', achievementEarned: string, ageRange: string, dateUsed?: string | null, gender: string, isWinner: string, location: string, slicePurchaseDate: string, unlockDate: string, userId: string } | null> | null } | null } };

export type GetHighestSlicesOfParticipatingRewardsQueryVariables = Exact<{
  pieId: Scalars['UUID']['input'];
}>;


export type GetHighestSlicesOfParticipatingRewardsQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', getHighestSlicesOfParticipatingRewards: any } };

export type GetHighestSlicesOfParticipateRewardsQueryVariables = Exact<{
  pieId: Scalars['UUID']['input'];
}>;


export type GetHighestSlicesOfParticipateRewardsQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', getHighestSlicesOfParticipateRewards?: { __typename?: 'HighestSlicesOfParticipateRewards', slicesOfParticipating: any, slicesOfAwarded: any } | null } };

export type CheckRewardSlugAvailabilityQueryVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  rewardSlug: Scalars['String']['input'];
}>;


export type CheckRewardSlugAvailabilityQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', slugAvailable: boolean } };

export type GetNeededSlicesQueryVariables = Exact<{
  rewardId: Scalars['UUID']['input'];
}>;


export type GetNeededSlicesQuery = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', getNeededSlices?: Array<{ __typename?: 'NeededSlicesPerPie', pieId: any, amount: any } | null> | null } };

export type CheckRewardSlugAvailability2QueryVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  rewardSlug: Scalars['String']['input'];
}>;


export type CheckRewardSlugAvailability2Query = { __typename?: 'Query', reward: { __typename?: 'RewardQueryApi', slugAvailable2: { __typename?: 'AvailableCheckingResult', isAvailable: boolean, objectId?: any | null } } };

export type SeriesMemberEventsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SeriesMemberEventsQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', seriesEvents?: { __typename?: 'SeriesEventsConnection', nodes?: Array<{ __typename?: 'FullEvent', eventId: any, displayName: string, startDate: any, endDate: any, timeZone?: string | null, avatarUrl: string, currency?: string | null } | null> | null } | null } };

export type RevenueSeriesScopeQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RevenueSeriesScopeQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', series?: { __typename?: 'EventSeries', eventSeriesId: any, name: string, parentEventId: any } | null, seriesEvents?: { __typename?: 'SeriesEventsConnection', nodes?: Array<{ __typename?: 'FullEvent', eventId: any, displayName: string, startDate: any, endDate: any, timeZone?: string | null, avatarUrl: string, currency?: string | null } | null> | null } | null } };

export type GetTermsConditionsAndPrivacyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTermsConditionsAndPrivacyQuery = { __typename?: 'Query', termsAndConditions: { __typename?: 'TermsAndConditionsQueryApi', current?: { __typename?: 'TermsAndConditions', version: number, termsAndConditionsUrl: string, privacyPolicyUrl: string, marketingTermsUrl?: string | null, createdAtUtc: any } | null } };

export type GetUploadedAssetsQueryVariables = Exact<{
  pieId: Scalars['UUID']['input'];
  target?: InputMaybe<UploadedAssetTarget>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUploadedAssetsQuery = { __typename?: 'Query', uploadedAsset: { __typename?: 'UploadedAssetQueryApi', listByPieId2?: { __typename?: 'UploadedAssetGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'UploadedAsset', uploadedAssetId: any, url: string, target: UploadedAssetTarget, status: UploadedAssetStatus, createdUtc: any }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', me?: { __typename?: 'CurrentUser', userId: any, gender?: UserGender | null, bio?: string | null, isVerified: boolean, tier: UserTier, userName?: string | null, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchAvatarUrl?: string | null, twitchFollowsCount?: any | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, emailAddress?: string | null, verifiedEmailAddress?: string | null, phoneNumber?: string | null, verifiedPhoneNumber?: string | null, dateOfBirth?: any | null, countryCode?: string | null, agreeToTermsAndConditions: boolean, isDeleted?: boolean | null, profileCompletionRequired: boolean, canCreatePies: boolean, isInWaitingList: boolean, userInvitesRemaining: number, isSkipMultiFactorAuthentication: boolean, disableSendSms: boolean, enableCreateEvent: boolean, enableCreateContestEvent: boolean, brandedEventId?: any | null, brandedUrl?: string | null, canProcessPayment: boolean, address?: { __typename?: 'AddressModel', address: string, city: string, region?: string | null, postalCode?: string | null, countryCode: string } | null, socialMedias?: Array<{ __typename?: 'SocialMediaConnection', scheme: string, userId: string, displayName?: string | null, avatarUrl?: string | null, profileLink?: string | null, username?: string | null } | null> | null, payoutAccounts?: Array<{ __typename?: 'PayoutAccount', provider: string, accountId: string, isPrimary: boolean } | null> | null, stripeAccount?: { __typename?: 'UserStripeAccountType', accountStatus?: PaymentAccountStatus | null, hasConnectAccount: boolean } | null, emailSubscriptions?: Array<{ __typename?: 'EmailSubscription', status: EmailSubscriptionStatus, type: EmailSubscriptionType } | null> | null, walkthrough?: Array<{ __typename?: 'UserWalkthrough', status: WalkthroughStatus, type: WalkthroughType } | null> | null } | null };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', userId: any, isVerified: boolean, tier: UserTier, name?: string | null, avatarUrl?: string | null, userName?: string | null, socialMedias?: Array<{ __typename?: 'SocialMediaConnection', scheme: string, userId: string, displayName?: string | null, avatarUrl?: string | null, profileLink?: string | null, username?: string | null } | null> | null } | null };

export type SearchUsersQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UserOffsetPage', totalCount: any, nodes: Array<{ __typename?: 'CurrentUser', userId: any, isVerified: boolean, tier: UserTier, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, userName?: string | null, emailAddress?: string | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', scheme: string, userId: string, displayName?: string | null, avatarUrl?: string | null, profileLink?: string | null, username?: string | null } | null> | null }> } | null };

export type GetMySocialMediaConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMySocialMediaConnectionsQuery = { __typename?: 'Query', me?: { __typename?: 'CurrentUser', socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', scheme: string, displayName?: string | null, avatarUrl?: string | null, followsCount?: any | null, profileLink?: string | null, username?: string | null } | null> | null } | null };

export type MyPasskeyCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPasskeyCredentialsQuery = { __typename?: 'Query', myPasskeyCredentials?: Array<{ __typename?: 'StoredPasskeyCredential', userId: any, publicKey?: string | null, aaGuid: any, displayName?: string | null, lastUsedDate: any, regDate: any, credType?: string | null, credentialId: string, signatureCounter: number, userHandle?: string | null, userName?: string | null, publicKeyCredential?: { __typename?: 'PublicKeyCredential', id: string } | null } | null> | null };

export type GetHoldingPiesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  sortingOrder: PageSortOrder;
  sortingType: PieSortingType;
  keyword?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHoldingPiesQuery = { __typename?: 'Query', wallet: { __typename?: 'WalletQueryApi', listHoldingPies2?: { __typename?: 'PieGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'CompletePieWithBalance', pieId: any, slug: string, displayName: string, createdUtc: any, rank?: number | null, totalUniqueSubscribers: number, balance?: any | null, pieAvatarUrl?: string | null, slicePrice: { __typename?: 'Amount', symbol: string, value: any }, rewardList2?: { __typename?: 'RewardGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'Reward', rewardId: any, displayName: string, status: RewardStatus, avatarUrl: string, bio?: string | null, type: RewardType }> } | null, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, isVerified: boolean, userName?: string | null, tier: UserTier } | null }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null } };

export type GetBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBalanceQuery = { __typename?: 'Query', wallet: { __typename?: 'WalletQueryApi', listBalance: Array<{ __typename?: 'WalletBalance', symbol: string, balance: any, type: WalletBalanceType }> } };

export type GetTradingTransactionsByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  onlyMyTransaction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTradingTransactionsByIdQuery = { __typename?: 'Query', wallet: { __typename?: 'WalletQueryApi', listTradingTransactions2?: { __typename?: 'TradingTransactionGrainPageX', totalCount: any, nodes: Array<{ __typename?: 'TradingTransaction', type?: string | null, price?: any | null, tradeSlices?: any | null, createdAtUtc: any, pie?: { __typename?: 'CompletePieWithBalance', pieId: any, slug: string } | null, user?: { __typename?: 'UserWithGeneralLocation', userId: any } | null }>, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean } } | null } };

export type EventsPageSearchEventsQueryVariables = Exact<{
  criteria?: InputMaybe<SearchEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventsPageSearchEventsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', search?: { __typename?: 'EventGrainPageX', totalCount: any, pageInfo: { __typename?: 'PageInfoX', endCursor?: string | null, hasNextPage: boolean }, nodes: Array<{ __typename?: 'Event', avatarUrl: string, exclusiveAvatarUrl?: string | null, displayName: string, slug: string, eventId: any, startDate: any, mySeriesRoles: Array<string>, seriesPassAttendeeState?: EventAttendeeState | null, timeZone?: string | null, clubId?: any | null, currency?: string | null, eventType: EventType, createdBy?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, tier: UserTier, userId: any, userName?: string | null, isVerified: boolean } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeState: EventAttendeeState, attendeeRole?: EventAttendeeRole | null, permissions?: Array<EventPermissionId> | null } | null } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', price?: any | null, repPoints?: any | null } | null> | null } | null }> } | null } };

export type EventsPageGetEventDetailsPublicQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventsPageGetEventDetailsPublicQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', bySlugOrId?: { __typename?: 'Event', eventType: EventType, avatarUrl: string, exclusiveAvatarUrl?: string | null, description: string, terms?: string | null, faqs?: string | null, displayName: string, endDate: any, eventId: any, eventSeriesId?: any | null, isSeriesParentEvent: boolean, isPrivate: boolean, ticketTermsPurchasePolicy?: string | null, optInShowGuestCount: boolean, slug: string, startDate: any, waitingTickets?: Array<any | null> | null, approvedTickets: any, optInAllowPublicEventPagePreview?: boolean | null, isExpired?: boolean | null, isEnded?: boolean | null, canProcessPayment: boolean, paymentProcessor: PaymentMethod, totalEventTickets?: any | null, timeZone?: string | null, optInShowMusicEmbed: boolean, musicEmbedUrl?: string | null, currency?: string | null, faqEntries?: Array<{ __typename?: 'FaqEntry', question?: string | null, answer?: string | null }> | null, eventTickets2?: Array<{ __typename?: 'EventTicket', isEnabledWishList: boolean, color?: string | null, eventTicketId: any, isActive: boolean, price?: any | null, ticketType?: string | null, isPrivate?: boolean | null, optInShowTicketAmount: boolean, additionalGuests?: number | null, transactionStatus?: TransactionStatus | null, note?: string | null, isRequiredApproval: boolean, sortOrder?: number | null, actionLabel?: string | null, requiresDisclosureSignature: boolean, balance?: { __typename?: 'EventTicketBalance', availableAmount?: number | null } | null, fulfillmentMethods?: { __typename?: 'FulfillmentMethods', electronic: boolean, ship: boolean, pickup: boolean } | null } | null> | null, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null, isOnlyVisibleToApprovedAttendees?: boolean | null, latitude?: number | null, longitude?: number | null } | null, createdBy?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, coordinators?: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> | null, talents?: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> | null, talentLineup: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }>, seriesTeam: Array<{ __typename?: 'EventSeriesTeamMember', role: EventSeriesTeamRole, user: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null } }>, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeState: EventAttendeeState, contestEntryType: ContestEntryType } | null } | null } | null } };

export type EventsPageGetEventDetailsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  scanEventId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EventsPageGetEventDetailsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', bySlugOrId?: { __typename?: 'Event', eventType: EventType, ageLimit?: number | null, avatarUrl: string, exclusiveAvatarUrl?: string | null, description: string, terms?: string | null, faqs?: string | null, disclosureOrPrivacyPolicyTitle?: string | null, disclosureOrPrivacyPolicyFileUrl?: string | null, displayName: string, endDate: any, eventId: any, isPrivate: boolean, note: string, optInAgeLimit: boolean, optInAllowGuestInviteOthers: boolean, optInDisclosureOrPrivacyPolicy: boolean, requiresDisclosureSignature: boolean, ticketTermsPurchasePolicy?: string | null, optInQuestionRequirements: boolean, optInShowGuestCount: boolean, optInShowGuestList: boolean, optInSocialAccountRequirements: boolean, requireSocialAccountConnection: boolean, optInAllowPublicEventPagePreview?: boolean | null, optInLocationRadius: boolean, slug: string, startDate: any, waitingTickets?: Array<any | null> | null, approvedTickets: any, isExpired?: boolean | null, isEnded?: boolean | null, canProcessPayment: boolean, paymentProcessor: PaymentMethod, connectedSocialNetworks?: Array<string> | null, totalEventTickets?: any | null, timeZone?: string | null, isInvited: boolean, isSpecialGuest: boolean, optInShowMusicEmbed: boolean, musicEmbedUrl?: string | null, pendingRoleInvites: Array<string>, currency?: string | null, eventSeriesId?: any | null, isSeriesParentEvent: boolean, seriesPassAttendeeState?: EventAttendeeState | null, faqEntries?: Array<{ __typename?: 'FaqEntry', question?: string | null, answer?: string | null }> | null, locationRadius?: { __typename?: 'EventLocation', address?: string | null, isActive?: boolean | null, latitude?: number | null, longitude?: number | null, radius?: number | null, unitLengthType?: EventLocationUnitLengthType | null } | null, tickets?: Array<{ __typename?: 'TicketWithIdOfStoredTicket', firstSeen?: any | null, status: TicketStatus, ticketId?: string | null, isShareable?: boolean | null, isStaffTicket?: boolean | null, isGuestTicket?: boolean | null, isExpired: boolean, expiredAt?: any | null, eventTicket?: { __typename?: 'EventTicket', color?: string | null, ticketType?: string | null, eventTicketId: any, isPrivate?: boolean | null, note?: string | null, price?: any | null, additionalGuests?: number | null, resetAdditionalGuestsAfterEachEvent?: boolean | null, optInQrCodePass: boolean, requiresDisclosureSignature: boolean } | null, guestOf?: { __typename?: 'CompleteUser', name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, userId: any } | null, invitedBy?: { __typename?: 'CompleteUser', name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, userId: any } | null, displayEventTicket?: { __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, color?: string | null, optInQrCodePass: boolean, requiresDisclosureSignature: boolean } | null, scanZones?: Array<{ __typename?: 'ScanningZoneInfo', id: any, name: string, scanCount: number, scannedAtUtc?: any | null, scanTimes?: Array<any> | null, maxScans?: number | null, isUnlimitedScans?: boolean | null } | null> | null, validForEvent?: { __typename?: 'Event', eventId: any, displayName: string, startDate: any, endDate: any, timeZone?: string | null, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null, latitude?: number | null, longitude?: number | null } | null } | null, associatedUser?: { __typename?: 'CompleteUser', userId: any } | null, plusOneHolder?: { __typename?: 'CompleteUser', name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, instagramFollowsCount?: any | null, userId: any } | null, sharedAdditionalGuests?: Array<{ __typename?: 'SharedAdditionalGuest', guest: { __typename?: 'CompleteUser', name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, instagramFollowsCount?: any | null, userId: any }, validForEvent: { __typename?: 'Event', eventId: any, displayName: string, startDate: any, endDate: any, timeZone?: string | null } }> | null } | null> | null, eventTickets2?: Array<{ __typename?: 'EventTicket', isEnabledWishList: boolean, color?: string | null, isFull?: boolean | null, eventTicketId: any, isActive: boolean, price?: any | null, ticketType?: string | null, isPrivate?: boolean | null, optInShowTicketAmount: boolean, transactionStatus?: TransactionStatus | null, note?: string | null, additionalGuests?: number | null, isRequiredApproval: boolean, sortOrder?: number | null, actionLabel?: string | null, requiresDisclosureSignature: boolean, balance?: { __typename?: 'EventTicketBalance', availableAmount?: number | null } | null, specialGuestInfo?: { __typename?: 'SpecialGuestInfo', remainingAmount: number } | null, fulfillmentMethods?: { __typename?: 'FulfillmentMethods', electronic: boolean, ship: boolean, pickup: boolean } | null } | null> | null, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null, isOnlyVisibleToApprovedAttendees?: boolean | null, latitude?: number | null, longitude?: number | null } | null, questionRequirements?: Array<{ __typename?: 'QuestionRequirement', isRequired: boolean, question: string, showPublicTickets?: boolean | null, showPrivateTickets?: boolean | null, optInSpecificTicketTypes: boolean, ticketTypeIds?: Array<any> | null }> | null, socialAccountRequirements?: Array<{ __typename?: 'SocialAccountRequirement', isRequired: boolean, scheme: string }> | null, createdBy?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, isFollowedByCurrentUser?: boolean | null } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, isFollowedByCurrentUser?: boolean | null }> } | null, coordinators?: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, isFollowedByCurrentUser?: boolean | null }> | null, talents?: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, isFollowedByCurrentUser?: boolean | null }> | null, talentLineup: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, isFollowedByCurrentUser?: boolean | null }>, seriesTeam: Array<{ __typename?: 'EventSeriesTeamMember', role: EventSeriesTeamRole, user: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, isFollowedByCurrentUser?: boolean | null } }>, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeState: EventAttendeeState, contestEntryType: ContestEntryType, isContestWinner: boolean, privacyPolicyState: EventPrivacyPolicyState, signedDisclosureFileUrl?: string | null, signedWaiverFileUrl?: string | null, questionRequirementAnswers?: Array<{ __typename?: 'QuestionRequirementAnswer', answer: string, question: string }> | null } | null } | null, myAchievements?: Array<{ __typename?: 'Achievement', avatarUrl: string, displayName: string }> | null, userEventBookings?: Array<{ __typename?: 'EventAttendeesBookingInfo', eventTickets?: Array<{ __typename?: 'EventTicketPurchaseInfo', eventTicket?: { __typename?: 'EventTicket', isPrivate?: boolean | null } | null } | null> | null } | null> | null } | null } };

export type EventsPageGetEventTicketsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventsPageGetEventTicketsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', bySlugOrId?: { __typename?: 'Event', tickets?: Array<{ __typename?: 'TicketWithIdOfStoredTicket', firstSeen?: any | null, status: TicketStatus, ticketId?: string | null, isShareable?: boolean | null, isStaffTicket?: boolean | null, eventTicket?: { __typename?: 'EventTicket', color?: string | null, ticketType?: string | null, eventTicketId: any, isPrivate?: boolean | null, note?: string | null } | null, displayEventTicket?: { __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, color?: string | null } | null } | null> | null, eventTickets2?: Array<{ __typename?: 'EventTicket', isFull?: boolean | null, eventTicketId: any, isActive: boolean, price?: any | null, repPoints?: any | null, ticketType?: string | null } | null> | null } | null } };

export type EventsPageGetApprovedAttendeesListQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventsPageGetApprovedAttendeesListQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', bySlugOrId?: { __typename?: 'Event', attendeesPage?: { __typename?: 'EventAttendeeInfoPageX', nodes: Array<{ __typename?: 'EventAttendeeInfo', userInfo?: { __typename?: 'UserWithAddress', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfoX', hasNextPage: boolean, endCursor?: string | null } } | null } | null } };

export type EventsPageGetEventCommentsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventsPageGetEventCommentsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', bySlugOrId?: { __typename?: 'Event', comments?: { __typename?: 'EventCommentModelPageX', nodes: Array<{ __typename?: 'EventComment', comment: string, commentId: any, createdAt: any, medias: Array<string>, reactions?: Array<{ __typename?: 'EventCommentReaction', reaction: string, reactionId: any, user: { __typename?: 'User', userId: any } } | null> | null, replies?: { __typename?: 'EventCommentModelPageX', nodes: Array<{ __typename?: 'EventComment', comment: string, commentId: any, createdAt: any, medias: Array<string>, reactions?: Array<{ __typename?: 'EventCommentReaction', reaction: string, reactionId: any, user: { __typename?: 'User', userId: any } } | null> | null, user: { __typename?: 'User', userId: any, name?: string | null }, replies?: { __typename?: 'EventCommentModelPageX', nodes: Array<{ __typename?: 'EventComment', comment: string, commentId: any, createdAt: any, medias: Array<string>, user: { __typename?: 'User', userId: any, name?: string | null }, reactions?: Array<{ __typename?: 'EventCommentReaction', reaction: string, reactionId: any, user: { __typename?: 'User', userId: any } } | null> | null }> } | null }> } | null, user: { __typename?: 'User', userId: any, name?: string | null } }> } | null } | null } };

export type ContactsInviteGetEventDetailsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type ContactsInviteGetEventDetailsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, displayName: string, slug: string, avatarUrl: string, isExpired?: boolean | null, isEnded?: boolean | null, createdBy?: { __typename?: 'User', userId: any } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', permissions?: Array<EventPermissionId> | null } | null } | null, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, isPrivate?: boolean | null, isActive: boolean } | null> | null } | null, seriesPassTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, isPrivate?: boolean | null, isActive: boolean } | null> | null } | null } | null } };

export type ContactsInviteEventSearchContactsQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  clubId?: InputMaybe<Scalars['UUID']['input']>;
  filterArgs: ContactPageFilterArgsInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactsInviteEventSearchContactsQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', contacts?: { __typename?: 'ContactsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes?: Array<{ __typename?: 'Contact', contactId: any, emailAddress?: string | null, invitationStatus: InvitationStatus, name?: string | null, phoneNumber?: string | null, userId?: any | null, gender?: UserGender | null, dateOfBirth?: any | null, events?: { __typename?: 'LimitedEventConnection', nodes?: Array<{ __typename?: 'LimitedEvent', avatarUrl: string, displayName: string } | null> | null } | null, inviteInfo?: { __typename?: 'InvitationInfo', giftTicketName?: string | null, giftTicketQuantity?: number | null, privateTicketName?: string | null, privateTicketQuantity?: number | null } | null, inviter?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, userName?: string | null, name?: string | null } | null, invitedTickets: Array<{ __typename?: 'InvitedTicket', invitedAt: any, giftEventTicketId?: any | null, giftEventTicketName?: string | null, giftEventTicketAmount?: number | null, privateEventTicketId?: any | null, privateEventTicketName?: string | null, privateEventTicketAmount?: number | null }>, userInfo?: { __typename?: 'UserWithAddress', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, gender?: UserGender | null, ageRange?: string | null, name?: string | null, address?: { __typename?: 'UserAddressModel', city?: string | null, countryCode?: string | null } | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', displayName?: string | null, scheme: string, avatarUrl?: string | null, profileLink?: string | null, username?: string | null } | null> | null } | null } | null> | null } | null } };

export type ContactsInviteOfferSearchContactsQueryVariables = Exact<{
  offerId: Scalars['UUID']['input'];
  clubId: Scalars['UUID']['input'];
  filterArgs: ContactPageFilterArgsInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactsInviteOfferSearchContactsQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', contacts?: { __typename?: 'ContactsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes?: Array<{ __typename?: 'Contact', contactId: any, emailAddress?: string | null, offerInvitationStatus: InvitationStatus, name?: string | null, phoneNumber?: string | null, userId?: any | null, events?: { __typename?: 'LimitedEventConnection', nodes?: Array<{ __typename?: 'LimitedEvent', avatarUrl: string, displayName: string } | null> | null } | null, offerInviter?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, userName?: string | null, name?: string | null } | null, userInfo?: { __typename?: 'UserWithAddress', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, userName?: string | null, gender?: UserGender | null, ageRange?: string | null, name?: string | null, address?: { __typename?: 'UserAddressModel', city?: string | null, countryCode?: string | null } | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', displayName?: string | null, scheme: string, avatarUrl?: string | null, profileLink?: string | null, username?: string | null } | null> | null } | null } | null> | null } | null } };

export type ContactsInviteOfferGetClubDetailsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ContactsInviteOfferGetClubDetailsQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', clubId: any } | null };

export type ContactsInviteOfferGetOfferDetailsQueryVariables = Exact<{
  clubSlug: Scalars['String']['input'];
  offerId: Scalars['UUID']['input'];
}>;


export type ContactsInviteOfferGetOfferDetailsQuery = { __typename?: 'Query', clubOffer?: { __typename?: 'ClubOfferState', rewardOffer?: { __typename?: 'RewardOfferFlow', state?: { __typename?: 'RewardState', avatarUrl: string, name: string } | null } | null } | null };

export type ContactsInviteOfferGetMyClubEventsDropdownQueryVariables = Exact<{
  clubSlugOrId: Scalars['String']['input'];
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
}>;


export type ContactsInviteOfferGetMyClubEventsDropdownQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', myClubEvents?: { __typename?: 'MyClubEventsConnection', nodes?: Array<{ __typename?: 'Event', avatarUrl: string, eventId: any, displayName: string } | null> | null } | null } };

export type ContactsInviteOfferGetOffersDropdownQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  filter?: InputMaybe<FilterOfferCriteriaInput>;
}>;


export type ContactsInviteOfferGetOffersDropdownQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', offers?: { __typename?: 'OffersConnection', nodes?: Array<{ __typename?: 'ClubOfferState', offerId: any, rewardOffer?: { __typename?: 'RewardOfferFlow', state?: { __typename?: 'RewardState', avatarUrl: string, name: string } | null } | null } | null> | null } | null } | null };

export type EventSeriesRolesCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type EventSeriesRolesCatalogQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', roles?: Array<{ __typename?: 'EventSeriesRolePermissionState', roleId: any, roleName: string, permissions?: Array<EventSeriesPermissionId> | null }> | null } };

export type SeriesMemberRolesQueryVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
}>;


export type SeriesMemberRolesQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', seriesMemberRoles?: Array<{ __typename?: 'EventSeriesMemberRole', userId: any, roleId: any, user?: { __typename?: 'User', userId: any, userName?: string | null, name?: string | null, avatarUrl?: string | null } | null, role?: { __typename?: 'EventSeriesRolePermissionState', roleId: any, roleName: string } | null }> | null } };

export type PendingSeriesRolesQueryVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
}>;


export type PendingSeriesRolesQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', pendingSeriesRoles?: Array<{ __typename?: 'EventSeriesPendingMemberRole', userId?: any | null, email?: string | null, roleId: any, user?: { __typename?: 'User', userId: any, userName?: string | null, name?: string | null, avatarUrl?: string | null } | null, role?: { __typename?: 'EventSeriesRolePermissionState', roleId: any, roleName: string } | null }> | null } };

export type CreateSeriesMutationVariables = Exact<{
  name: Scalars['String']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSeriesMutation = { __typename?: 'Mutation', eventSeries: { __typename?: 'EventSeriesMutationApi', createSeries?: { __typename?: 'EventSeries', eventSeriesId: any, name: string, slug: string, memberCount: number } | null } };

export type UpdateSeriesMutationVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSeriesMutation = { __typename?: 'Mutation', eventSeries: { __typename?: 'EventSeriesMutationApi', updateSeries?: { __typename?: 'EventSeries', eventSeriesId: any, name: string, avatarUrl?: string | null } | null } };

export type AddEventToSeriesMutationVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
  eventIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type AddEventToSeriesMutation = { __typename?: 'Mutation', eventSeries: { __typename?: 'EventSeriesMutationApi', addEventToSeries?: { __typename?: 'EventSeries', eventSeriesId: any, memberCount: number } | null } };

export type RemoveEventFromSeriesMutationVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
  eventIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type RemoveEventFromSeriesMutation = { __typename?: 'Mutation', eventSeries: { __typename?: 'EventSeriesMutationApi', removeEventFromSeries?: { __typename?: 'EventSeries', eventSeriesId: any, memberCount: number } | null } };

export type MoveEventMutationVariables = Exact<{
  eventIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  toSeriesId: Scalars['UUID']['input'];
}>;


export type MoveEventMutation = { __typename?: 'Mutation', eventSeries: { __typename?: 'EventSeriesMutationApi', moveEvent?: { __typename?: 'EventSeries', eventSeriesId: any, memberCount: number } | null } };

export type DeleteSeriesMutationVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
}>;


export type DeleteSeriesMutation = { __typename?: 'Mutation', eventSeries: { __typename?: 'EventSeriesMutationApi', deleteSeries: boolean } };

export type AssignSeriesRoleMutationVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  roleId: Scalars['UUID']['input'];
}>;


export type AssignSeriesRoleMutation = { __typename?: 'Mutation', eventSeries: { __typename?: 'EventSeriesMutationApi', assignSeriesRole?: { __typename?: 'EventSeries', eventSeriesId: any } | null } };

export type RemoveSeriesRoleMutationVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  roleId: Scalars['UUID']['input'];
}>;


export type RemoveSeriesRoleMutation = { __typename?: 'Mutation', eventSeries: { __typename?: 'EventSeriesMutationApi', removeSeriesRole?: { __typename?: 'EventSeries', eventSeriesId: any } | null } };

export type InviteSeriesRoleMutationVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
  roleId: Scalars['UUID']['input'];
  invitees: Array<SeriesRoleInviteeInput> | SeriesRoleInviteeInput;
}>;


export type InviteSeriesRoleMutation = { __typename?: 'Mutation', eventSeries: { __typename?: 'EventSeriesMutationApi', inviteSeriesRole?: { __typename?: 'EventSeries', eventSeriesId: any } | null } };

export type RemovePendingSeriesRoleMutationVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
  userKey: Scalars['String']['input'];
  roleId: Scalars['UUID']['input'];
}>;


export type RemovePendingSeriesRoleMutation = { __typename?: 'Mutation', eventSeries: { __typename?: 'EventSeriesMutationApi', removePendingSeriesRole?: { __typename?: 'EventSeries', eventSeriesId: any } | null } };

export type AttendeeTicketInfoFieldsFragment = { __typename?: 'StoredTicket', eventId?: any | null, isExpired: boolean, expiredAtUtc?: any | null, validForEvent?: { __typename?: 'Event', eventId: any, displayName: string, startDate: any, endDate: any, timeZone?: string | null, isEnded?: boolean | null } | null, plusOneHolder?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null } | null, transferredTo?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null } | null, sharedBy?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null } | null };

export type AttendeeTicketPersonFieldsFragment = { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null };

export type EventsManageGetMyEventsQueryVariables = Exact<{
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventsManageGetMyEventsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', myEvents?: { __typename?: 'MyEventsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'FullEvent', eventType: EventType, avatarUrl: string, displayName: string, slug: string, eventId: any, startDate: any, endDate: any, isEnded?: boolean | null, approvedTickets: any, timeZone?: string | null, scannedTickets: any, clubId?: any | null, eventSeriesId?: any | null, createdBy?: { __typename?: 'User', userId: any } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeRole?: EventAttendeeRole | null } | null } | null } | null> | null } | null } };

export type EventsManageGetMySeriesQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventsManageGetMySeriesQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', mySeries?: { __typename?: 'MySeriesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'EventSeries', eventSeriesId: any, name: string, slug: string, avatarUrl?: string | null, memberCount: number, myEventsCount: number, isOwner: boolean, createdDate: any, updatedDate?: any | null, owner?: { __typename?: 'User', userId: any, name?: string | null } | null } | null> | null } | null } };

export type EventsManageGetSeriesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type EventsManageGetSeriesQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', series?: { __typename?: 'EventSeries', eventSeriesId: any, name: string, slug: string, avatarUrl?: string | null, memberCount: number, isOwner: boolean, mySeriesPermissions: Array<EventSeriesPermissionId>, parentEventId: any, owner?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null, isVerified: boolean, tier: UserTier } | null } | null } };

export type EventsManageGetSeriesPassCapacityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type EventsManageGetSeriesPassCapacityQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', series?: { __typename?: 'EventSeries', eventSeriesId: any, passes?: { __typename?: 'SeriesPasses', capacityTickets?: number | null, passTypes: Array<{ __typename?: 'SeriesPassType', eventTicketId: any, capacity?: number | null, additionalGuests: number }> } | null } | null } };

export type EventsManageGetSeriesEventsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SearchEventStatus>;
  sortBy?: InputMaybe<SeriesEventsSortBy>;
  sortOrder?: InputMaybe<PageSortOrder>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventsManageGetSeriesEventsQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', seriesEvents?: { __typename?: 'SeriesEventsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'FullEvent', eventType: EventType, avatarUrl: string, displayName: string, slug: string, eventId: any, startDate: any, endDate: any, isEnded?: boolean | null, isPrivate: boolean, isListed?: boolean | null, approvedTickets: any, timeZone?: string | null, scannedTickets: any, clubId?: any | null, eventSeriesId?: any | null, createdBy?: { __typename?: 'User', userId: any } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeRole?: EventAttendeeRole | null, permissions?: Array<EventPermissionId> | null } | null } | null } | null> | null } | null } };

export type EventsManageGetEventDetailsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventsManageGetEventDetailsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventType: EventType, hasTicketsForSale?: boolean | null, isSeriesParentEvent: boolean, paymentProcessor: PaymentMethod, avatarUrl: string, exclusiveAvatarUrl?: string | null, description: string, displayName: string, endDate: any, eventId: any, isPrivate: boolean, slug: string, startDate: any, talentOrder: Array<any>, isExpired?: boolean | null, isEnded?: boolean | null, canDelete?: boolean | null, cannotDeleteReason?: string | null, timeZone?: string | null, pendingAttendees2: any, approvedAttendees?: any | null, approvedTickets: any, scannedTickets: any, totalAvailableTickets: number, invitedAttendees: any, clubId?: any | null, currency?: string | null, eventSeriesId?: any | null, entryStats?: { __typename?: 'EventEntryStats', eventId: any, entries: number, checkedIn: number, capacity?: number | null, own: { __typename?: 'EntryCount', entries: number, checkedIn: number, scans?: number | null }, passHolders: { __typename?: 'EntryCount', entries: number, checkedIn: number, scans?: number | null }, passGuests: { __typename?: 'EntryCount', entries: number, checkedIn: number, scans?: number | null }, plusOnes?: { __typename?: 'PlusOneBreakdown', shared: number, live: number, everyEvent: number } | null } | null, taxCollection?: { __typename?: 'StripeTaxCollectionStatus', hasActiveRegistration: boolean, homeState?: string | null, registeredStates: Array<string> } | null, taxConfiguration?: { __typename?: 'UserTaxConfiguration', name?: string | null, percent?: any | null, isCollect: boolean, useAutomaticTax?: boolean | null } | null, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, isPrivate?: boolean | null, isActive: boolean, price?: any | null, isRsvpOnly: boolean, sortOrder?: number | null, additionalGuests?: number | null, balance?: { __typename?: 'EventTicketBalance', availableAmount?: number | null, limitedAmount?: number | null, releasedAmount: number, isUnlimitedAvailableAmount: boolean } | null } | null> | null } | null, seriesPassTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, isPrivate?: boolean | null, isActive: boolean } | null> | null } | null, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, region?: string | null, city?: string | null, postalCode?: string | null, countryCode?: string | null, latitude?: number | null, longitude?: number | null } | null, createdBy?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any }> } | null, doors?: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any }> | null, coordinators?: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any }> | null, talents?: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any }> | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', permissions?: Array<EventPermissionId> | null } | null } | null, achievements?: { __typename?: 'AchievementPageX', nodes: Array<{ __typename?: 'Achievement', avatarUrl: string, displayName: string }> } | null, seriesPassAttendeeCounts: { __typename?: 'SeriesPassAttendeeCounts', approvedPeople: number, pendingPeople: number }, declinedAttendees?: { __typename?: 'DetailsAttendeeConnection', totalCount: number } | null, waitingTicketsUsersCount?: Array<{ __typename?: 'EventTicketWaitingUsersCount', count: any, eventTicketId: any } | null> | null, usersRoles?: Array<{ __typename?: 'EventUserRole', role: EventAttendeeRole, user?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any } | null }> | null, pendingUsersRoles?: Array<{ __typename?: 'PendingEventUserRole', email?: string | null, role: EventAttendeeRole, user?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, emailAddress?: string | null } | null }> | null, linkedOffers?: { __typename?: 'LinkOfferStateConnection', totalCount: number, nodes?: Array<{ __typename?: 'LinkOfferState', status: LinkOfferStatus, offer: { __typename?: 'ClubOfferState', offerId: any, access: ClubOfferAccess, published: ClubOfferPublished, type: OfferType, rewardOffer?: { __typename?: 'RewardOfferFlow', state?: { __typename?: 'RewardState', avatarUrl: string, coverUrl: string, description: string, name: string, quantity: number, limitedQty: number, rewardId: any, type: OfferRewardType, timeFrameConstraint?: { __typename?: 'TimeFrameConstraint', endDateTime?: any | null, expiresDateTime?: any | null, startDateTime?: any | null, timeFrameType: RewardTimeFrameType, timeZoneId?: string | null } | null, redemptionMethod?: { __typename?: 'NoneRewardRedemptionMethod', redemptionMethodType: RewardRedemptionMethodType } | { __typename?: 'PriceRewardRedemptionMethod', price?: any | null, redemptionMethodType: RewardRedemptionMethodType } | { __typename?: 'RepPointsRewardRedemptionMethod', redemptionMethodType: RewardRedemptionMethodType, repPoints?: any | null } | null } | null } | null } } | null> | null } | null, scanningZones?: Array<{ __typename?: 'ScanningZone', id?: any | null, isPrimary?: boolean | null, name: string, resetScansDaily?: boolean | null, eventTicketSettings?: Array<{ __typename?: 'ScanningZoneEventTicketSetting', eventTicketId?: any | null, maxScans?: number | null, isUnlimitedScans?: boolean | null }> | null }> | null } | null } };

export type EventsManageGetAttendeeAgeRangeStatisticQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
  attendeeFilterStatus?: InputMaybe<AttendeeFilterStatus>;
}>;


export type EventsManageGetAttendeeAgeRangeStatisticQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', attendeeAgeRangeStatistic?: { __typename?: 'AttendeeAgeRangeStatistic', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalUserAmount: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number, totalTicketAmount: number, ageRangeUnder18: { __typename?: 'AttendeeAgeRange', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number }, ageRangeFrom18To24: { __typename?: 'AttendeeAgeRange', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number }, ageRangeFrom25To34: { __typename?: 'AttendeeAgeRange', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number }, ageRangeFrom35To44: { __typename?: 'AttendeeAgeRange', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number }, ageOver44: { __typename?: 'AttendeeAgeRange', totalFemaleAmount: number, totalMaleAmount: number, totalOtherAmount: number, totalFemaleAmountPercentage: number, totalMaleAmountPercentage: number, totalOtherAmountPercentage: number, totalFemaleTicketAmount: number, totalMaleTicketAmount: number, totalOtherTicketAmount: number } } | null } | null } };

export type EventsManageGetSocialReachesQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  inviterId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EventsManageGetSocialReachesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', socialReaches?: Array<{ __typename?: 'EventSocialNetworkReaches', socialNetworkScheme: string, reaches: any } | null> | null } | null } };

export type EventsManageGetEventEarningsQueryVariables = Exact<{
  filter: EventEarningsFilterInput;
}>;


export type EventsManageGetEventEarningsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', getEventEarnings?: { __typename?: 'EventEarningsStatistics', totalFees: any, totalPrice: any, totalQuantity: number, totalGratuity: any, totalTaxes: any, serviceFee: any, processingFee: any, hostBalance: any, ticketBreakdown: Array<{ __typename?: 'TicketEarningsBreakdown', eventTicketId: any, ticketType: string, unitPrice: any, totalQuantity: number, totalPrice: any }> } | null } };

export type EventsManageGetEventForEditQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventsManageGetEventForEditQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', paymentProcessor: PaymentMethod, eventType: EventType, ageLimit?: number | null, avatarUrl: string, exclusiveAvatarUrl?: string | null, description: string, terms?: string | null, faqs?: string | null, disclosureOrPrivacyPolicyTitle?: string | null, disclosureOrPrivacyPolicyFileUrl?: string | null, disclosureOrPrivacyPolicyChecksum?: string | null, displayName: string, endDate: any, eventId: any, eventSeriesId?: any | null, isSeriesParentEvent: boolean, isPrivate: boolean, minimumRepScore?: any | null, note: string, optInAgeLimit: boolean, optInAllowGuestInviteOthers: boolean, optInDisclosureOrPrivacyPolicy: boolean, optInDisplayRepScore: boolean, optInLocationRadius: boolean, ticketTermsPurchasePolicy?: string | null, optInQuestionRequirements: boolean, optInShowGuestCount: boolean, optInAllowPublicEventPagePreview?: boolean | null, optInShowGuestList: boolean, optInSocialAccountRequirements: boolean, requireSocialAccountConnection: boolean, slug: string, startDate: any, talentOrder: Array<any>, timeZone?: string | null, isAllInPricing?: boolean | null, optInShowMusicEmbed: boolean, musicEmbedUrl?: string | null, isListed?: boolean | null, isStarted?: boolean | null, isExpired?: boolean | null, isEnded?: boolean | null, canProcessPayment: boolean, currency?: string | null, totalEarnings?: any | null, taxCollection?: { __typename?: 'StripeTaxCollectionStatus', hasActiveRegistration: boolean, homeState?: string | null, registeredStates: Array<string> } | null, taxConfiguration?: { __typename?: 'UserTaxConfiguration', name?: string | null, percent?: any | null, isCollect: boolean, useAutomaticTax?: boolean | null } | null, faqEntries?: Array<{ __typename?: 'FaqEntry', question?: string | null, answer?: string | null }> | null, socialReaches?: Array<{ __typename?: 'EventSocialNetworkReaches', reaches: any, socialNetworkScheme: string } | null> | null, locationRadius?: { __typename?: 'EventLocation', address?: string | null, isActive?: boolean | null, latitude?: number | null, longitude?: number | null, radius?: number | null, unitLengthType?: EventLocationUnitLengthType | null } | null, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', isEnabledWishList: boolean, color?: string | null, eventTicketId: any, isActive: boolean, price?: any | null, repPoints?: any | null, ticketType?: string | null, additionalGuests?: number | null, isRequiredApproval: boolean, isPrivate?: boolean | null, isShareable?: boolean | null, resetAdditionalGuestsAfterEachEvent?: boolean | null, requiresDisclosureSignature: boolean, optInShowTicketAmount: boolean, visibleStartAt?: any | null, visibleEndAt?: any | null, gratuityPercentage?: any | null, note?: string | null, createdDate?: any | null, sortOrder?: number | null, actionLabel?: string | null, optInQrCodePass: boolean, balance?: { __typename?: 'EventTicketBalance', availableAmount?: number | null, limitedAmount?: number | null, releasedAmount: number } | null } | null> | null } | null, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, region?: string | null, city?: string | null, postalCode?: string | null, countryCode?: string | null, isOnlyVisibleToApprovedAttendees?: boolean | null, latitude?: number | null, longitude?: number | null } | null, questionRequirements?: Array<{ __typename?: 'QuestionRequirement', isRequired: boolean, question: string, showPublicTickets?: boolean | null, showPrivateTickets?: boolean | null, optInSpecificTicketTypes: boolean, ticketTypeIds?: Array<any> | null }> | null, socialAccountRequirements?: Array<{ __typename?: 'SocialAccountRequirement', isRequired: boolean, scheme: string }> | null, createdBy?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, emailAddress?: string | null, userName?: string | null } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, emailAddress?: string | null, userName?: string | null }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, emailAddress?: string | null, userName?: string | null }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, emailAddress?: string | null, userName?: string | null }> } | null, doors?: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, emailAddress?: string | null, userName?: string | null }> | null, coordinators?: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, emailAddress?: string | null }> | null, talents?: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, emailAddress?: string | null, userName?: string | null }> | null, seriesTeam: Array<{ __typename?: 'EventSeriesTeamMember', role: EventSeriesTeamRole, user: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, emailAddress?: string | null, userName?: string | null } }>, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', permissions?: Array<EventPermissionId> | null } | null } | null, usersRoles?: Array<{ __typename?: 'EventUserRole', role: EventAttendeeRole, user?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, emailAddress?: string | null } | null }> | null, pendingUsersRoles?: Array<{ __typename?: 'PendingEventUserRole', email?: string | null, role: EventAttendeeRole, user?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, emailAddress?: string | null } | null }> | null, scanningZones?: Array<{ __typename?: 'ScanningZone', eventTicketIds?: Array<any> | null, id?: any | null, isPrimary?: boolean | null, name: string, resetScansDaily?: boolean | null, eventTicketSettings?: Array<{ __typename?: 'ScanningZoneEventTicketSetting', eventTicketId?: any | null, maxScans?: number | null, isUnlimitedScans?: boolean | null }> | null }> | null, zoneDeletability: Array<{ __typename?: 'ZoneDeletability', zoneId: any, canDelete: boolean }> } | null } };

export type EventsManageGetAttendeeBookingsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<DetailsAttendeeFilterArgsInput>;
}>;


export type EventsManageGetAttendeeBookingsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, displayName: string, startDate: any, endDate: any, avatarUrl: string, isListFull?: boolean | null, approvedTickets: any, scannedTickets: any, totalAvailableTickets: number, invitedAttendees: any, pendingAttendees2: any, approvedAttendees?: any | null, isExpired?: boolean | null, isEnded?: boolean | null, eventType: EventType, isSeriesParentEvent: boolean, optInDisclosureOrPrivacyPolicy: boolean, location?: { __typename?: 'EventLocation', locationName?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null } | null, entryStats?: { __typename?: 'EventEntryStats', entries: number, checkedIn: number, capacity?: number | null } | null, seriesPassAttendeeCounts: { __typename?: 'SeriesPassAttendeeCounts', approvedPeople: number, pendingPeople: number }, waitingTicketsUsersCount?: Array<{ __typename?: 'EventTicketWaitingUsersCount', count: any, eventTicketId: any } | null> | null, waitingTicketsUsers?: Array<{ __typename?: 'EventTicketWaitingUsers', eventTicketId: any, users?: Array<{ __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, emailAddress?: string | null } | null> | null } | null> | null, seriesPassTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, isActive: boolean, price?: any | null } | null> | null } | null, scanningZones?: Array<{ __typename?: 'ScanningZone', id?: any | null, isPrimary?: boolean | null, name: string, eventTicketSettings?: Array<{ __typename?: 'ScanningZoneEventTicketSetting', eventTicketId?: any | null }> | null }> | null, usersRoles?: Array<{ __typename?: 'EventUserRole', role: EventAttendeeRole, user?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any } | null }> | null, createdBy?: { __typename?: 'User', avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', permissions?: Array<EventPermissionId> | null } | null } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any, isVerified: boolean, tier: UserTier }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any, isVerified: boolean, tier: UserTier }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any, isVerified: boolean, tier: UserTier }> } | null, eventTickets?: { __typename?: 'EventTicketConnection', totalCount: number, nodes?: Array<{ __typename?: 'EventTicket', isFull?: boolean | null, eventTicketId: any, price?: any | null, ticketType?: string | null, isPrivate?: boolean | null, creatorId: any, eventId: any, isActive: boolean, isEnabledWishList: boolean, isRequiredApproval: boolean, optInShowTicketAmount: boolean, balance?: { __typename?: 'EventTicketBalance', availableAmount?: number | null, limitedAmount?: number | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, detailsAttendees?: { __typename?: 'DetailsAttendeeConnection', totalCount: number, ticketCount?: number | null, invitedCount?: number | null, checkedInCount?: number | null, totalCheckedInCount?: number | null, pendingAttendeesCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes?: Array<{ __typename?: 'DetailsAttendee', attendeeRoles?: Array<EventAttendeeRole | null> | null, waiverStatus: AttendeeWaiverStatus, checkedInCount: number, status: AttendeeFilterStatus, approvalUser?: { __typename?: 'User', name?: string | null } | null, inviter?: { __typename?: 'User', name?: string | null, userName?: string | null } | null, attendeeInfo: { __typename?: 'EventUserInfo', attendeeRole?: EventAttendeeRole | null, attendeeState: EventAttendeeState, contestEntryType: ContestEntryType, permissions?: Array<EventPermissionId> | null, approvalAt?: any | null, privacyPolicyState: EventPrivacyPolicyState, privacyPolicyStateUpdatedAt?: any | null, questionRequirementAnswers?: Array<{ __typename?: 'QuestionRequirementAnswer', question: string, answer: string }> | null }, tickets: Array<{ __typename?: 'DetailsAttendeeTicket', ticketId: any, isSeriesPass: boolean, ticketInfo: { __typename?: 'StoredTicket', firstSeen: any, originalTicketId?: any | null, ticketType?: TicketType | null, count: number, parentTicketId?: any | null, displayEventTicketId?: any | null, status: TicketStatus, eventId?: any | null, isExpired: boolean, expiredAtUtc?: any | null, validForEvent?: { __typename?: 'Event', eventId: any, displayName: string, startDate: any, endDate: any, timeZone?: string | null, isEnded?: boolean | null } | null, plusOneHolder?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null } | null, transferredTo?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null } | null, sharedBy?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null } | null }, bookingInfo?: { __typename?: 'EventAttendeesBookingInfo', totalPrice: any, transactionId: any, type: TransactionType, shippingAddress?: { __typename?: 'AddressModel', address: string, city: string, region?: string | null, postalCode?: string | null, countryCode: string } | null } | null }>, user?: { __typename?: 'UserWithAddress', ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, gender?: UserGender | null, isVerified: boolean, tier: UserTier, userId: any, name?: string | null, userName?: string | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', scheme: string, userId: string, displayName?: string | null, avatarUrl?: string | null, profileLink?: string | null, username?: string | null } | null> | null, address?: { __typename?: 'UserAddressModel', address?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null, region?: string | null } | null } | null, eligibility: { __typename?: 'AttendeeEligibilityInfo', hasProfilePicture: boolean, hasConnectedInstagram: boolean, instagramHandle?: string | null, instagramConnectedAt?: any | null, hasDownloadedApp: boolean }, shareStats: { __typename?: 'AttendeeShareStats', clicks: number, logins: number, ticketAcquisitions: number }, bookings?: Array<{ __typename?: 'EventAttendeesBookingInfo', transactionId: any, transactionStatus: TransactionStatus, eventId: any, eventTickets?: Array<{ __typename?: 'EventTicketPurchaseInfo', ticketType?: string | null, purchaseAmount: number, eventTicket?: { __typename?: 'EventTicket', additionalGuests?: number | null } | null } | null> | null } | null> | null } | null> | null } | null } | null } };

export type EventsManageGetDetailsAttendeeQueryVariables = Exact<{
  attendeeId: Scalars['UUID']['input'];
  slugOrId: Scalars['String']['input'];
}>;


export type EventsManageGetDetailsAttendeeQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', detailsAttendee?: { __typename?: 'DetailsAttendee', attendeeRoles?: Array<EventAttendeeRole | null> | null, checkedInCount: number, status: AttendeeFilterStatus, approvalUser?: { __typename?: 'User', name?: string | null } | null, inviter?: { __typename?: 'User', name?: string | null, userName?: string | null } | null, attendeeInfo: { __typename?: 'EventUserInfo', attendeeRole?: EventAttendeeRole | null, attendeeState: EventAttendeeState, permissions?: Array<EventPermissionId> | null, approvalAt?: any | null, privacyPolicyStateUpdatedAt?: any | null, questionRequirementAnswers?: Array<{ __typename?: 'QuestionRequirementAnswer', question: string, answer: string }> | null }, tickets: Array<{ __typename?: 'DetailsAttendeeTicket', ticketId: any, isSeriesPass: boolean, ticketInfo: { __typename?: 'StoredTicket', firstSeen: any, originalTicketId?: any | null, ticketType?: TicketType | null, count: number, parentTicketId?: any | null, displayEventTicketId?: any | null, status: TicketStatus, eventId?: any | null, isExpired: boolean, expiredAtUtc?: any | null, validForEvent?: { __typename?: 'Event', eventId: any, displayName: string, startDate: any, endDate: any, timeZone?: string | null, isEnded?: boolean | null } | null, plusOneHolder?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null } | null, transferredTo?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null } | null, sharedBy?: { __typename?: 'CompleteUser', userId: any, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null } | null }, bookingInfo?: { __typename?: 'EventAttendeesBookingInfo', totalPrice: any, transactionId: any, type: TransactionType, shippingAddress?: { __typename?: 'AddressModel', address: string, city: string, region?: string | null, postalCode?: string | null, countryCode: string } | null } | null }>, user?: { __typename?: 'UserWithAddress', ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, gender?: UserGender | null, isVerified: boolean, tier: UserTier, userId: any, name?: string | null, userName?: string | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', scheme: string, userId: string, displayName?: string | null, avatarUrl?: string | null, profileLink?: string | null, username?: string | null } | null> | null, address?: { __typename?: 'UserAddressModel', address?: string | null, city?: string | null, countryCode?: string | null, postalCode?: string | null, region?: string | null } | null } | null, eligibility: { __typename?: 'AttendeeEligibilityInfo', hasProfilePicture: boolean, hasConnectedInstagram: boolean, instagramHandle?: string | null, instagramConnectedAt?: any | null, hasDownloadedApp: boolean }, shareStats: { __typename?: 'AttendeeShareStats', clicks: number, logins: number, ticketAcquisitions: number }, bookings?: Array<{ __typename?: 'EventAttendeesBookingInfo', transactionId: any, transactionStatus: TransactionStatus, eventId: any, eventTickets?: Array<{ __typename?: 'EventTicketPurchaseInfo', ticketType?: string | null, purchaseAmount: number, eventTicket?: { __typename?: 'EventTicket', additionalGuests?: number | null } | null } | null> | null } | null> | null } | null } | null } };

export type EventsManageExportAttendeesQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventsManageExportAttendeesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', attendeesExport?: { __typename?: 'AttendeeExportedMaster', eventTickets: Array<{ __typename?: 'AttendeeExportedTicket', id: any, name: string, additionalGuests: number }>, guestList?: Array<{ __typename?: 'GuestInfoWithEventAndMatch', emailAddress?: string | null, fullName: string, checkedInQuantity?: number | null, eventTicket?: { __typename?: 'EventTicket', ticketType?: string | null } | null }> | null, attendees: Array<{ __typename?: 'AttendeeExportedInfo', userId: any, name: string, gender: string, emailAddress: string, ageRange: string, answers: Array<string>, tickets: string, totalSpent: any, questions: Array<string>, repScore: any, status: string, acceptedPolicyTime?: any | null, waiverStatus: AttendeeWaiverStatus, transactionTime?: any | null, approvedTime?: any | null, checkedInCount: number, totalAmountWithoutFees: any, paypalOrderId?: string | null, paypalPaymentId?: string | null, paypalTransactionFee?: any | null, paypalTotalPrice?: any | null, approvedBy?: string | null, purchasedItems?: Array<{ __typename?: 'PaymentItems', ticketType?: string | null, eventId?: any | null, quantity: any, price: any }> | null, displayEventTickets?: Array<{ __typename?: 'DisplayEventTicketInfo', ticketType: string, checkedInCount: number, count: number, additionalGuests: number, tickets?: Array<{ __typename?: 'DetailsAttendeeTicket', ticketId: any, ticketInfo: { __typename?: 'StoredTicket', count: number, ticketType?: TicketType | null } }> | null }> | null }> } | null } | null } };

export type EventsManageGetEventAttendeeStatisticsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  filter?: InputMaybe<DetailsAttendeeFilterArgsInput>;
}>;


export type EventsManageGetEventAttendeeStatisticsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', approvedTickets: any, scannedTickets: any, totalAvailableTickets: number, invitedAttendees: any, pendingAttendees2: any, approvedAttendees?: any | null, entryStats?: { __typename?: 'EventEntryStats', entries: number, checkedIn: number, capacity?: number | null } | null, seriesPassAttendeeCounts: { __typename?: 'SeriesPassAttendeeCounts', approvedPeople: number, pendingPeople: number }, detailsAttendees?: { __typename?: 'DetailsAttendeeConnection', ticketCount?: number | null, invitedCount?: number | null, checkedInCount?: number | null, totalCheckedInCount?: number | null, pendingAttendeesCount?: number | null } | null } | null } };

export type EventsInviteGetEventDetailsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventsInviteGetEventDetailsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, displayName: string, slug: string, avatarUrl: string, isExpired?: boolean | null, isEnded?: boolean | null, createdBy?: { __typename?: 'User', userId: any } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', permissions?: Array<EventPermissionId> | null } | null } | null, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, isPrivate?: boolean | null, isActive: boolean } | null> | null } | null } | null } };

export type EventsInviteSearchContactsQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  filterArgs: ContactPageFilterArgsInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventsInviteSearchContactsQuery = { __typename?: 'Query', contactList: { __typename?: 'ContactListQueryApi', contacts?: { __typename?: 'ContactsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes?: Array<{ __typename?: 'Contact', contactId: any, emailAddress?: string | null, invitationStatus: InvitationStatus, name?: string | null, phoneNumber?: string | null, userId?: any | null, events?: { __typename?: 'LimitedEventConnection', nodes?: Array<{ __typename?: 'LimitedEvent', avatarUrl: string, displayName: string } | null> | null } | null, inviteInfo?: { __typename?: 'InvitationInfo', giftTicketName?: string | null, giftTicketQuantity?: number | null, privateTicketName?: string | null, privateTicketQuantity?: number | null } | null, inviter?: { __typename?: 'User', avatarUrl?: string | null, userName?: string | null, name?: string | null } | null, userInfo?: { __typename?: 'UserWithAddress', avatarUrl?: string | null, isVerified: boolean, userName?: string | null, gender?: UserGender | null, ageRange?: string | null, name?: string | null, address?: { __typename?: 'UserAddressModel', city?: string | null, countryCode?: string | null } | null, socialMediaConnections?: Array<{ __typename?: 'SocialMediaConnection', displayName?: string | null, scheme: string, avatarUrl?: string | null, profileLink?: string | null, username?: string | null } | null> | null } | null } | null> | null } | null } };

export type EventsGuestGetEventDetailsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventsGuestGetEventDetailsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', eventTicketId: any, ticketType?: string | null, isPrivate?: boolean | null, isActive: boolean } | null> | null } | null, createdBy?: { __typename?: 'User', userId: any } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', permissions?: Array<EventPermissionId> | null } | null } | null } | null } };

export type EventsGuestSearchGuestsQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filterArgs?: InputMaybe<SearchEventGuestFilterArgsInput>;
}>;


export type EventsGuestSearchGuestsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', searchEventGuests?: { __typename?: 'SearchEventGuestsConnection', guestCount?: number | null, ticketCount?: number | null, checkedInCount?: number | null, totalCount: number, edges?: Array<{ __typename?: 'SearchEventGuestsEdge', node?: { __typename?: 'EventGuest', guestId: any, eventTicketIds?: Array<any> | null, fullName: string, emailAddress?: string | null, phoneNumber?: string | null, avatarUrl?: string | null, note?: string | null, qrPassQuantity?: number | null, qrPassCheckedInQuantity?: number | null, qrPassEmailSentAt?: any | null, qrPassTextSentAt?: any | null, customFields: Array<{ __typename?: 'GuestCustomField', key: string, label: string, value: string }>, tickets?: Array<{ __typename?: 'EventGuestTicket', ticketId: any, eventTicketId: any, guestName: string, checkedInAt?: any | null, guestId: any, avatarUrl?: string | null, eventTicket?: { __typename?: 'EventTicket', ticketType?: string | null, isPrivate?: boolean | null } | null } | null> | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } };

export type GuestQrLinkQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  guestId: Scalars['UUID']['input'];
}>;


export type GuestQrLinkQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', guestQrLink?: string | null } };

export type EventLinkOfferGetEventDetailsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventLinkOfferGetEventDetailsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', avatarUrl: string, slug: string, eventId: any } | null } };

export type EventLinkOfferGetAvailableClubsQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
}>;


export type EventLinkOfferGetAvailableClubsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', availableClubsForOfferLink?: Array<{ __typename?: 'PublicClubState', name: string, clubId: any, slug?: string | null, createdBy: any, images?: { __typename?: 'ClubImages', background?: string | null } | null } | null> | null } };

export type EventLinkOfferGetLinkedOffersQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventLinkOfferGetLinkedOffersQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', linkedClubOffers: Array<{ __typename?: 'LinkClubState', clubId: any, images?: { __typename?: 'ClubImages', background?: string | null } | null, offers: Array<{ __typename?: 'LinkOfferState', status: LinkOfferStatus, linkedAt: any, linkedBy: any, offer: { __typename?: 'ClubOfferState', offerId: any, rewards: Array<{ __typename?: 'RewardState', avatarUrl: string, name: string } | null> } }> }> } | null } };

export type EventLinkOfferGetClubOffersByIdQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  filter?: InputMaybe<FilterOfferCriteriaInput>;
}>;


export type EventLinkOfferGetClubOffersByIdQuery = { __typename?: 'Query', club?: { __typename?: 'ClubState', offers?: { __typename?: 'OffersConnection', nodes?: Array<{ __typename?: 'ClubOfferState', offerId: any, rewards: Array<{ __typename?: 'RewardState', avatarUrl: string, name: string } | null> } | null> | null } | null } | null };

export type EventInviteesGetEventDetailsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventInviteesGetEventDetailsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, slug: string, displayName: string, isExpired?: boolean | null, isEnded?: boolean | null, createdBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null }> } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null }> } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeRole?: EventAttendeeRole | null, permissions?: Array<EventPermissionId> | null } | null } | null } | null } };

export type EventInviteesSearchInviteesQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  filter?: InputMaybe<SearchInviteesFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventInviteesSearchInviteesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, searchInvitees?: { __typename?: 'InviteeConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'Invitee', eventId: any, contactId?: any | null, inviteeUserId?: any | null, name?: string | null, emailAddress?: string | null, phoneNumber?: string | null, source: InvitationSource, methodOfEntry?: MethodOfEntry | null, deliveryStatus: DeliveryStatus, actionTaken?: ActionTaken | null, sends?: Array<{ __typename?: 'SendRecord', sendId: any, sentAt?: any | null, lastDeliveryAt?: any | null, invitationMessage?: string | null, status: InvitationStatus, source: InvitationSource, acceptedAt?: any | null, acceptanceSource?: AttributionChannel | null, acceptedDeliveryId?: any | null, sentBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null } | null, giftTickets?: { __typename?: 'GiftTicketsArgs', eventTicketId: any, amount: number } | null, privateTickets?: { __typename?: 'PrivateTicketsArgs', eventTicketId: any, amount: number } | null, deliveries?: Array<{ __typename?: 'DeliveryAttempt', deliveryId: any, sentAt: any, channels: Array<DeliveryChannel>, reminderTemplateKey?: string | null, firstViewedAt?: any | null, lastViewedAt?: any | null, viewSource?: AttributionChannel | null, bouncedAt?: any | null, triggeredBy?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null } | null }> | null }> | null, invitee?: { __typename?: 'User', userId: any, name?: string | null, avatarUrl?: string | null } | null } | null> | null } | null } | null } };

export type EventInviteesResendInvitationMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  sendId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EventInviteesResendInvitationMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', resendInvitation?: { __typename?: 'ResendInvitationResult', resentAt: any, invitationMessage?: string | null, giftTickets?: { __typename?: 'GiftTicketsArgs', eventTicketId: any, amount: number } | null, privateTickets?: { __typename?: 'PrivateTicketsArgs', eventTicketId: any, amount: number } | null } | null } };

export type EventInviteesGetStatisticsQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
}>;


export type EventInviteesGetStatisticsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, areInvitationsIndexed: boolean, inviteeStatistics?: { __typename?: 'InviteeStatisticsResult', invited: any, sharedLinkOrQr: any, viewed: any, bounced: any, notOpened: any, opened: any, emailNotOpened: any, emailOpenedOnly: any, emailLinkOpened: any, emailBounced: any, emailCount: any, textCount: any, linkCount: any } | null, actionTakenStatistics: { __typename?: 'ActionTakenStatisticsResult', approved: any, pending: any, denied: any } } | null } };

export type EventInviteesCountResendCandidatesQueryVariables = Exact<{
  slugOrId: Scalars['String']['input'];
  filter?: InputMaybe<SearchInviteesFilterArgs>;
  includeBounced: Scalars['Boolean']['input'];
}>;


export type EventInviteesCountResendCandidatesQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', fullEventBySlugOrId?: { __typename?: 'FullEvent', eventId: any, countResendCandidates: { __typename?: 'BulkResendCountResult', resendable: number, skippedAccepted: number, skippedNoContact: number, skippedBounced: number, totalMatched: number, bounced: number } } | null } };

export type EventInviteesStartBulkResendMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  filter?: InputMaybe<SearchInviteesFilterArgs>;
  includeBounced: Scalars['Boolean']['input'];
  reminderMessage?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventInviteesStartBulkResendMutation = { __typename?: 'Mutation', event: { __typename?: 'EventMutationApi', startBulkResend: string } };

export type PlusOneReturnHealthFieldsFragment = { __typename?: 'PlusOneReturnHealth', seriesId: any, isEnabled: boolean, status: PlusOneReturnStatus, checkedAtUtc: any, reasons: Array<{ __typename?: 'PlusOneReturnReason', code: PlusOneReturnReasonCode, severity: PlusOneReturnSeverity, count: number, eventId?: any | null, eventName?: string | null }>, events: Array<{ __typename?: 'PlusOneReturnEventRow', eventId: any, name?: string | null, startDate: any, endDate: any, isOver: boolean, activeCount: number, expiredCount: number, transferredCount: number, state: PlusOneReturnEventState }> };

export type SeriesPlusOneReturnHealthQueryVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
}>;


export type SeriesPlusOneReturnHealthQuery = { __typename?: 'Query', eventSeries: { __typename?: 'EventSeriesQueryApi', series?: { __typename?: 'EventSeries', eventSeriesId: any, plusOneReturnHealth: { __typename?: 'PlusOneReturnHealth', seriesId: any, isEnabled: boolean, status: PlusOneReturnStatus, checkedAtUtc: any, reasons: Array<{ __typename?: 'PlusOneReturnReason', code: PlusOneReturnReasonCode, severity: PlusOneReturnSeverity, count: number, eventId?: any | null, eventName?: string | null }>, events: Array<{ __typename?: 'PlusOneReturnEventRow', eventId: any, name?: string | null, startDate: any, endDate: any, isOver: boolean, activeCount: number, expiredCount: number, transferredCount: number, state: PlusOneReturnEventState }> } } | null } };

export type CheckSeriesPlusOneReturnsMutationVariables = Exact<{
  seriesId: Scalars['UUID']['input'];
  dryRun: Scalars['Boolean']['input'];
}>;


export type CheckSeriesPlusOneReturnsMutation = { __typename?: 'Mutation', eventSeries: { __typename?: 'EventSeriesMutationApi', fixPlusOneReturns: { __typename?: 'FixPlusOneReturnsReport', dryRun: boolean, plusOnesToReturn: number, holdersGetNewPlusOne: number, holdersWithoutPass: number, waitingForNextEvent: number, eventsToRepair: number, moreRemain: boolean, health: { __typename?: 'PlusOneReturnHealth', seriesId: any, isEnabled: boolean, status: PlusOneReturnStatus, checkedAtUtc: any, reasons: Array<{ __typename?: 'PlusOneReturnReason', code: PlusOneReturnReasonCode, severity: PlusOneReturnSeverity, count: number, eventId?: any | null, eventName?: string | null }>, events: Array<{ __typename?: 'PlusOneReturnEventRow', eventId: any, name?: string | null, startDate: any, endDate: any, isOver: boolean, activeCount: number, expiredCount: number, transferredCount: number, state: PlusOneReturnEventState }> } } } };

export type CreateOfferMutationVariables = Exact<{
  payload: CreateOfferPayloadInput;
  clubId: Scalars['UUID']['input'];
}>;


export type CreateOfferMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', createOffer: { __typename?: 'CreateOfferResult', offerId: any, rewardIds: Array<any> } } };

export type UpdateOfferMutationVariables = Exact<{
  payload: UpdateOfferPayloadInput;
  offerId: Scalars['UUID']['input'];
  clubId: Scalars['UUID']['input'];
}>;


export type UpdateOfferMutation = { __typename?: 'Mutation', clubById: { __typename?: 'ClubMutation', offerById: { __typename?: 'OfferMutator', updateOffer: boolean } } };

export type OwnerOfferGetAttendeesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  offerId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DetailsOfferUserFilterArgsInput>;
}>;


export type OwnerOfferGetAttendeesQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', clubId: any, offers?: { __typename?: 'OffersConnection', nodes?: Array<{ __typename?: 'ClubOfferState', listOfferUser?: { __typename?: 'DetailsOfferUserConnection', nodes?: Array<{ __typename?: 'DetailsOfferUser', userId: any, isWinner?: boolean | null, user?: { __typename?: 'User', ageRange?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, instagramFollowsCount?: any | null, tikTokFollowsCount?: any | null, twitchFollowsCount?: any | null, gender?: UserGender | null, isVerified: boolean, name?: string | null, tier: UserTier, userId: any, userName?: string | null, repScore: number } | null, offerUserState?: { __typename?: 'OfferUserState', status: OfferUserStatus, approvalAt?: any | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasPreviousPage: boolean, endCursor?: string | null, hasNextPage: boolean } } | null } | null> | null } | null } | null };

export type GetManageClubOfferByIdQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  offerId: Scalars['UUID']['input'];
}>;


export type GetManageClubOfferByIdQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', clubId: any, name: string, offers?: { __typename?: 'OffersConnection', nodes?: Array<{ __typename?: 'ClubOfferState', access: ClubOfferAccess, offerId: any, published: ClubOfferPublished, type: OfferType, isWinnerGenerated?: boolean | null, totalWinnerCount?: number | null, isStarted?: boolean | null, isCurrentUserEditable?: boolean | null, isTimeFrameTypeEditable?: boolean | null, isCurrentUserCanInvite?: { __typename?: 'CanInviteOfferResultType', canNotInviteReason: CannotInviteReason, result: boolean } | null, configuration?: { __typename?: 'OfferConfigurationPayload', pointsPurchase?: { __typename?: 'OfferPointsPurchaseConfigurationPayload', isDefault: boolean, strategy?: { __typename?: 'BucketPointsPurchaseStrategyPayload', percentageDiscountStrategy?: { __typename?: 'PercentageBucketPointsPurchaseStrategy', baseCostPerPoint: any, discountBuckets: Array<{ __typename?: 'PercentageDiscountBucketPoints', discountPercentage: any, points: any }> } | null } | null } | null } | null, requirements?: { __typename?: 'ClubOfferRequirement', age?: { __typename?: 'ClubOfferRequirementAge', minimumAge: number } | null, membershipAge?: { __typename?: 'ClubOfferRequirementMembershipAge', age: any } | null, minimumPoints?: { __typename?: 'ClubOfferRequirementMinimumPoints', amount: any, class?: number | null } | null, notAfter?: { __typename?: 'BasicRequirementNotAfterDateOfClubOfferRequirementEvalContext', notAfter: any } | null, notBefore?: { __typename?: 'BasicRequirementNotBeforeDateOfClubOfferRequirementEvalContext', notBefore: any } | null, clubMembership?: { __typename?: 'ClubOfferRequirementOtherClubMembership', minimumMembershipAge?: any | null } | null } | null, rewardOffer?: { __typename?: 'RewardOfferFlow', state?: { __typename?: 'RewardState', avatarUrl: string, coverUrl: string, description: string, name: string, quantity: number, limitedQty: number, rewardId: any, type: OfferRewardType, settings: Array<{ __typename?: 'CanShareSetting', enabled: boolean, settingType: RewardSettingType } | { __typename?: 'LocationRadiusSetting', address: string, enabled: boolean, latitude: any, longitude: any, radius: any, settingType: RewardSettingType, unit: LocationUnit } | { __typename?: 'OptInPrivacyPolicySetting', content: string, enabled: boolean, link: string, settingType: RewardSettingType, title: string } | { __typename?: 'OptInPublicPagePreviewSetting', enabled: boolean, settingType: RewardSettingType } | { __typename?: 'RequireSocialMediaToEarnBonusSetting', enabled: boolean, settingType: RewardSettingType, socialMediaAccountBonusSetting: { __typename?: 'SocialMediaAccountBonusSetting', instagram: boolean, instagramBonus?: any | null, tikTok: boolean, tikTokBonus?: any | null, x: boolean, xBonus?: any | null, facebook: boolean, facebookBonus?: any | null, youTube: boolean, youTubeBonus?: any | null, apple: boolean, appleBonus?: any | null, linkedIn: boolean, linkedInBonus?: any | null, twitch: boolean, twitchBonus?: any | null } } | null>, conditions: Array<{ __typename?: 'AchievementsRewardCondition', type: RewardConditionType, achievements: Array<{ __typename?: 'AchievementState', achievementId: any, avatarUrl: string, description: string, name: string, type: ClubAchievementType } | null> } | { __typename?: 'LoyaltyTierRewardCondition', type: RewardConditionType, loyaltyTiersByClub: Array<{ __typename?: 'LoyaltyTierByClubCondition', level: number, club?: { __typename?: 'ClubState', clubId: any, name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', backgroundImageUrl?: string | null, description?: string | null, level: number, name: string, title?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null>, membership?: { __typename?: 'ClubMembership', tier?: { __typename?: 'ClubTier', level: number, name: string, title?: string | null } | null } | null } | null } | null> } | { __typename?: 'PriceRewardCondition', price: any, repPoints: any, type: RewardConditionType } | { __typename?: 'RepPointsRewardCondition', type: RewardConditionType, repPointsByClub: Array<{ __typename?: 'RepPointsByClubCondition', repPoints: any, club?: { __typename?: 'ClubState', clubId: any, name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', backgroundImageUrl?: string | null, description?: string | null, level: number, name: string, title?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null> } | null } | null> } | { __typename?: 'RepScoreRewardCondition', repScore: any, type: RewardConditionType } | null>, redemption?: { __typename?: 'AccessPassRewardRedemption', code: string, guide?: string | null, isGenerated: boolean, note?: string | null, redemptionType: RewardRedemptionType } | { __typename?: 'CustomerInformationRewardRedemption', guide?: string | null, note?: string | null, redemptionType: RewardRedemptionType, customerInformationScope: { __typename?: 'CustomerInformationScope', isAddressEnabled: boolean, isEmailEnabled: boolean, isNameEnabled: boolean, isPhoneNumberEnabled: boolean, isSocialMediaAccountEnabled: boolean, isUserNameEnabled: boolean, socialMediaAccountScope: { __typename?: 'SocialMediaAccountScope', apple: boolean, facebook: boolean, instagram: boolean, linkedIn: boolean, tikTok: boolean, twitch: boolean, x: boolean, youTube: boolean } } } | { __typename?: 'InviteLinkRewardRedemption', guide?: string | null, code: string, isGenerated: boolean, link: string, note?: string | null, redemptionType: RewardRedemptionType } | { __typename?: 'LocationInformationRewardRedemption', guide?: string | null, note?: string | null, redemptionType: RewardRedemptionType, code: string, isGenerated: boolean, addressDetails: { __typename?: 'AddressDetails', city: string, countryCode: string, phoneNumber: string, postalCode: string, state: string, streetAddress: string } } | { __typename?: 'PromoCodeRewardRedemption', guide?: string | null, code: string, isGenerated: boolean, note?: string | null, redemptionType: RewardRedemptionType } | null, timeFrameConstraint?: { __typename?: 'TimeFrameConstraint', endDateTime?: any | null, expiresDateTime?: any | null, startDateTime?: any | null, timeFrameType: RewardTimeFrameType, timeZoneId?: string | null } | null, ageConstraint?: { __typename?: 'AgeConstraint', maximumAge?: number | null, minimumAge?: number | null } | null } | null } | null } | null> | null } | null, teamMemberRoles?: Array<{ __typename?: 'ClubTeamMemberRoleState', roleId: any, user?: { __typename?: 'User', userId: any } | null } | null> | null } | null };

export type GetManageClubOfferBySlugQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
}>;


export type GetManageClubOfferBySlugQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', clubId: any, offers?: { __typename?: 'OffersConnection', edges?: Array<{ __typename?: 'OffersEdge', cursor: string, node?: { __typename?: 'ClubOfferState', access: ClubOfferAccess, published: ClubOfferPublished, type: OfferType } | null }> | null, nodes?: Array<{ __typename?: 'ClubOfferState', offerId: any, access: ClubOfferAccess, published: ClubOfferPublished, type: OfferType, rewardOffer?: { __typename?: 'RewardOfferFlow', state?: { __typename?: 'RewardState', avatarUrl: string, coverUrl: string, description: string, name: string, quantity: number, limitedQty: number, rewardId: any, type: OfferRewardType, timeFrameConstraint?: { __typename?: 'TimeFrameConstraint', endDateTime?: any | null, expiresDateTime?: any | null, startDateTime?: any | null, timeFrameType: RewardTimeFrameType, timeZoneId?: string | null } | null, settings: Array<{ __typename?: 'CanShareSetting', enabled: boolean, settingType: RewardSettingType } | { __typename?: 'LocationRadiusSetting', address: string, enabled: boolean, latitude: any, longitude: any, radius: any, settingType: RewardSettingType, unit: LocationUnit } | { __typename?: 'OptInPrivacyPolicySetting', content: string, enabled: boolean, link: string, settingType: RewardSettingType, title: string } | { __typename?: 'OptInPublicPagePreviewSetting' } | { __typename?: 'RequireSocialMediaToEarnBonusSetting' } | null>, conditions: Array<{ __typename?: 'AchievementsRewardCondition', type: RewardConditionType, achievements: Array<{ __typename?: 'AchievementState', achievementId: any, avatarUrl: string, description: string, name: string, type: ClubAchievementType } | null> } | { __typename?: 'LoyaltyTierRewardCondition', type: RewardConditionType, loyaltyTiersByClub: Array<{ __typename?: 'LoyaltyTierByClubCondition', level: number, club?: { __typename?: 'ClubState', clubId: any, name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', backgroundImageUrl?: string | null, description?: string | null, level: number, name: string, title?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null>, membership?: { __typename?: 'ClubMembership', tier?: { __typename?: 'ClubTier', level: number, name: string, title?: string | null } | null } | null } | null } | null> } | { __typename?: 'PriceRewardCondition', price: any, repPoints: any, type: RewardConditionType } | { __typename?: 'RepPointsRewardCondition', type: RewardConditionType, repPointsByClub: Array<{ __typename?: 'RepPointsByClubCondition', repPoints: any, club?: { __typename?: 'ClubState', clubId: any, name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', backgroundImageUrl?: string | null, description?: string | null, level: number, name: string, title?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null> } | null } | null> } | { __typename?: 'RepScoreRewardCondition', repScore: any, type: RewardConditionType } | null> } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } | null };

export type SearchOffersQueryVariables = Exact<{
  pageArgs: PageArgsInput;
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  criteria?: InputMaybe<SearchOfferCriteriaInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchOffersQuery = { __typename?: 'Query', searchOffers?: { __typename?: 'SearchOffersConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'PublicClubOfferState', offerId: any, club?: { __typename?: 'ClubState', clubId: any, slug?: string | null, permissions: Array<{ __typename?: 'ClubPermission', name?: string | null } | null> } | null, rewardOffer?: { __typename?: 'RewardOfferFlow', state?: { __typename?: 'RewardState', avatarUrl: string, coverUrl: string, description: string, name: string, quantity: number, rewardId: any, type: OfferRewardType, timeFrameConstraint?: { __typename?: 'TimeFrameConstraint', expiresDateTime?: any | null, timeZoneId?: string | null } | null, redemptionMethod?: { __typename?: 'NoneRewardRedemptionMethod', redemptionMethodType: RewardRedemptionMethodType } | { __typename?: 'PriceRewardRedemptionMethod', price?: any | null, redemptionMethodType: RewardRedemptionMethodType } | { __typename?: 'RepPointsRewardRedemptionMethod', redemptionMethodType: RewardRedemptionMethodType, repPoints?: any | null } | null } | null } | null } | null> | null } | null };

export type GetMyOffersQueryVariables = Exact<{
  pageArgs: PageArgsInput;
  criteria?: InputMaybe<SearchMyOfferCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMyOffersQuery = { __typename?: 'Query', myOffers?: { __typename?: 'MyOffersConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'PublicClubOfferState', offerId: any, club?: { __typename?: 'ClubState', clubId: any, slug?: string | null, permissions: Array<{ __typename?: 'ClubPermission', name?: string | null } | null> } | null, rewardOffer?: { __typename?: 'RewardOfferFlow', state?: { __typename?: 'RewardState', avatarUrl: string, coverUrl: string, description: string, name: string, quantity: number, rewardId: any, type: OfferRewardType, timeFrameConstraint?: { __typename?: 'TimeFrameConstraint', expiresDateTime?: any | null, timeZoneId?: string | null } | null, redemptionMethod?: { __typename?: 'NoneRewardRedemptionMethod', redemptionMethodType: RewardRedemptionMethodType } | { __typename?: 'PriceRewardRedemptionMethod', price?: any | null, redemptionMethodType: RewardRedemptionMethodType } | { __typename?: 'RepPointsRewardRedemptionMethod', redemptionMethodType: RewardRedemptionMethodType, repPoints?: any | null } | null } | null } | null } | null> | null } | null };

export type GetClubRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClubRolesQuery = { __typename?: 'Query', clubRoles?: Array<{ __typename?: 'ClubRolePermissionState', roleId: any, roleName: string }> | null };

export type GetClubEventsQueryVariables = Exact<{
  clubSlugOrId: Scalars['String']['input'];
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClubEventsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', clubEvents?: { __typename?: 'ClubEventsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Event', eventType: EventType, avatarUrl: string, displayName: string, slug: string, eventId: any, startDate: any, timeZone?: string | null, createdBy?: { __typename?: 'User', userId: any } | null, promoters?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, coHosts?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, sponsors?: { __typename?: 'UserPageX', nodes: Array<{ __typename?: 'User', userId: any }> } | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeRole?: EventAttendeeRole | null } | null } | null } | null> | null } | null } };

export type GetUserProfileQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetUserProfileQuery = { __typename?: 'Query', user?: { __typename?: 'User', userId: any, userName?: string | null, name?: string | null, avatarUrl?: string | null, avatarSource: AvatarSource, instagramAvatarUrl?: string | null, tikTokAvatarUrl?: string | null, twitchAvatarUrl?: string | null, displayNameSource: DisplayNameSource, instagramDisplayName?: string | null, tikTokDisplayName?: string | null, twitchDisplayName?: string | null, followersCount?: any | null, isVerified: boolean, tier: UserTier, isFollowedByCurrentUser?: boolean | null } | null };

export type GetUserEventsTotalCountQueryVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type GetUserEventsTotalCountQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', userEvents?: { __typename?: 'UserEventsConnection', totalCount: number } | null } };

export type GetUserEventsQueryVariables = Exact<{
  userName: Scalars['String']['input'];
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserEventsQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', userEvents?: { __typename?: 'UserEventsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'Event', slug: string, eventId: any, avatarUrl: string, exclusiveAvatarUrl?: string | null, displayName: string, startDate: any, timeZone?: string | null, status: EventStatus, isPrivate: boolean, currency?: string | null, mySeriesRoles: Array<string>, seriesPassAttendeeState?: EventAttendeeState | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeState: EventAttendeeState, permissions?: Array<EventPermissionId> | null } | null } | null, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', price?: any | null, repPoints?: any | null } | null> | null } | null, createdBy?: { __typename?: 'User', userId: any, avatarUrl?: string | null, userName?: string | null, isVerified: boolean, tier: UserTier } | null } | null> | null } | null } };

export type GetUserEventsByRoleTotalCountQueryVariables = Exact<{
  userName: Scalars['String']['input'];
  role: EventAttendeeRole;
}>;


export type GetUserEventsByRoleTotalCountQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', userEventsByRole?: { __typename?: 'UserEventsByRoleConnection', totalCount: number } | null } };

export type GetUserEventsByRoleQueryVariables = Exact<{
  userName: Scalars['String']['input'];
  role: EventAttendeeRole;
  criteria?: InputMaybe<SearchMyCreatedEventCriteriaInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserEventsByRoleQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', userEventsByRole?: { __typename?: 'UserEventsByRoleConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'Event', slug: string, eventId: any, avatarUrl: string, exclusiveAvatarUrl?: string | null, displayName: string, startDate: any, timeZone?: string | null, status: EventStatus, isPrivate: boolean, currency?: string | null, mySeriesRoles: Array<string>, seriesPassAttendeeState?: EventAttendeeState | null, attendeeInfo?: { __typename?: 'EventAttendeeInfo', attendeeInfo?: { __typename?: 'EventUserInfo', attendeeState: EventAttendeeState, permissions?: Array<EventPermissionId> | null } | null } | null, eventTickets?: { __typename?: 'EventTicketConnection', nodes?: Array<{ __typename?: 'EventTicket', price?: any | null, repPoints?: any | null } | null> | null } | null, createdBy?: { __typename?: 'User', userId: any, avatarUrl?: string | null, userName?: string | null, isVerified: boolean, tier: UserTier } | null } | null> | null } | null } };

export type CertificateGetFileUrlQueryVariables = Exact<{
  certificateReferenceId: Scalars['String']['input'];
}>;


export type CertificateGetFileUrlQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', certificateFileUrl?: string | null } };

export type GenerateGuestQrCodeMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
}>;


export type GenerateGuestQrCodeMutation = { __typename?: 'Mutation', public: { __typename?: 'PublicMutationApi', generateGuestQrCode: { __typename?: 'GuestQrCodeModel', id: any, guestId: any, expiresAt: any, qrCode: string, firstSeen?: any | null, count: number } } };

export type GuestQrPassQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
}>;


export type GuestQrPassQuery = { __typename?: 'Query', event: { __typename?: 'EventQueryApi', guestQrPass?: { __typename?: 'GuestQrPassInfo', guestName: string, eventName: string, eventImageUrl?: string | null, qrValue: string, fullyRedeemed: boolean, ticketType: string, startDate: any, endDate: any, timeZone?: string | null, walletDownloadToken?: string | null } | null } };

export type MemberOfferGetClubOfferQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  offerId: Scalars['UUID']['input'];
}>;


export type MemberOfferGetClubOfferQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', clubId: any, name: string, offers?: { __typename?: 'OffersConnection', nodes?: Array<{ __typename?: 'ClubOfferState', offerId: any, isWinnerGenerated?: boolean | null, isCurrentUserRedeemable?: boolean | null, isCurrentUserWinner?: boolean | null, isFree?: boolean | null, canProcessPayment: boolean, userOffer?: { __typename?: 'OfferUserState', status: OfferUserStatus, redemption?: { __typename?: 'UserCustomerInformationRedemption' } | { __typename?: 'UserInviteLinkRedemption', inviteLink: string } | null } | null, rewardOffer?: { __typename?: 'RewardOfferFlow', state?: { __typename?: 'RewardState', avatarUrl: string, coverUrl: string, description: string, name: string, quantity: number, limitedQty: number, ageConstraint?: { __typename?: 'AgeConstraint', minimumAge?: number | null, maximumAge?: number | null } | null, settings: Array<{ __typename?: 'CanShareSetting', enabled: boolean, settingType: RewardSettingType } | { __typename?: 'LocationRadiusSetting', address: string, enabled: boolean, latitude: any, longitude: any, radius: any, settingType: RewardSettingType, unit: LocationUnit } | { __typename?: 'OptInPrivacyPolicySetting', content: string, enabled: boolean, link: string, settingType: RewardSettingType, title: string } | { __typename?: 'OptInPublicPagePreviewSetting' } | { __typename?: 'RequireSocialMediaToEarnBonusSetting' } | null>, conditions: Array<{ __typename?: 'AchievementsRewardCondition', type: RewardConditionType, achievements: Array<{ __typename?: 'AchievementState', avatarUrl: string, name: string } | null> } | { __typename?: 'LoyaltyTierRewardCondition', type: RewardConditionType, loyaltyTiersByClub: Array<{ __typename?: 'LoyaltyTierByClubCondition', level: number, club?: { __typename?: 'ClubState', name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', backgroundImageUrl?: string | null, description?: string | null, level: number, name: string, title?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null> } | null } | null> } | { __typename?: 'PriceRewardCondition', price: any, type: RewardConditionType } | { __typename?: 'RepPointsRewardCondition', type: RewardConditionType, repPointsByClub: Array<{ __typename?: 'RepPointsByClubCondition', repPoints: any, club?: { __typename?: 'ClubState', clubId: any, name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null } | null } | null> } | { __typename?: 'RepScoreRewardCondition' } | null>, redemption?: { __typename?: 'AccessPassRewardRedemption', code: string, guide?: string | null, note?: string | null, isGenerated: boolean, redemptionType: RewardRedemptionType } | { __typename?: 'CustomerInformationRewardRedemption', guide?: string | null, note?: string | null, redemptionType: RewardRedemptionType, customerInformationScope: { __typename?: 'CustomerInformationScope', isAddressEnabled: boolean, isEmailEnabled: boolean, isNameEnabled: boolean, isPhoneNumberEnabled: boolean, isSocialMediaAccountEnabled: boolean, isUserNameEnabled: boolean, socialMediaAccountScope: { __typename?: 'SocialMediaAccountScope', apple: boolean, facebook: boolean, instagram: boolean, linkedIn: boolean, tikTok: boolean, twitch: boolean, x: boolean, youTube: boolean } } } | { __typename?: 'InviteLinkRewardRedemption', guide?: string | null, code: string, link: string, note?: string | null, isGenerated: boolean, redemptionType: RewardRedemptionType } | { __typename?: 'LocationInformationRewardRedemption', guide?: string | null, note?: string | null, code: string, isGenerated: boolean, redemptionType: RewardRedemptionType, addressDetails: { __typename?: 'AddressDetails', city: string, countryCode: string, phoneNumber: string, postalCode: string, state: string, streetAddress: string } } | { __typename?: 'PromoCodeRewardRedemption', guide?: string | null, code: string, note?: string | null, isGenerated: boolean, redemptionType: RewardRedemptionType } | null, timeFrameConstraint?: { __typename?: 'TimeFrameConstraint', expiresDateTime?: any | null, timeFrameType: RewardTimeFrameType, timeZoneId?: string | null } | null } | null } | null } | null> | null } | null } | null };

export type MemberOfferCalculateCostQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  offerId: Scalars['UUID']['input'];
  items: Array<OfferCostItemArgsInput> | OfferCostItemArgsInput;
}>;


export type MemberOfferCalculateCostQuery = { __typename?: 'Query', clubBySlug?: { __typename?: 'ClubState', offers?: { __typename?: 'OffersConnection', nodes?: Array<{ __typename?: 'ClubOfferState', calculateOfferCost?: { __typename?: 'OfferCostInfo', hostBalance: any, isAllInPricing: boolean, processingFee: any, serviceFee: any, totalFees: any, subTotal: any, total: any, totalTaxes: any, taxName?: string | null, taxPercentage?: any | null, totalGratuity: any, referralUserId?: any | null, paymentAuthCode: string, expiresAt: any, items: Array<{ __typename?: 'OfferCostItem', offerId: any, price: any, quantity: number, taxCode?: string | null, gratuityPercentage?: any | null, originalPrice: any }> } | null } | null> | null } | null } | null };

export type PublicOfferGetOfferDetailsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  offerId: Scalars['UUID']['input'];
}>;


export type PublicOfferGetOfferDetailsQuery = { __typename?: 'Query', clubOffer?: { __typename?: 'ClubOfferState', access: ClubOfferAccess, isFree?: boolean | null, isStarted?: boolean | null, offerId: any, published: ClubOfferPublished, type: OfferType, isPublicUserRedeemable?: boolean | null, rewardOffer?: { __typename?: 'RewardOfferFlow', state?: { __typename?: 'RewardState', avatarUrl: string, coverUrl: string, description: string, name: string, quantity: number, limitedQty: number, ageConstraint?: { __typename?: 'AgeConstraint', minimumAge?: number | null, maximumAge?: number | null } | null, settings: Array<{ __typename?: 'CanShareSetting', enabled: boolean, settingType: RewardSettingType } | { __typename?: 'LocationRadiusSetting' } | { __typename?: 'OptInPrivacyPolicySetting' } | { __typename?: 'OptInPublicPagePreviewSetting', enabled: boolean, settingType: RewardSettingType } | { __typename?: 'RequireSocialMediaToEarnBonusSetting' } | null>, conditions: Array<{ __typename?: 'AchievementsRewardCondition', type: RewardConditionType, achievements: Array<{ __typename?: 'AchievementState', avatarUrl: string, name: string } | null> } | { __typename?: 'LoyaltyTierRewardCondition', type: RewardConditionType, loyaltyTiersByClub: Array<{ __typename?: 'LoyaltyTierByClubCondition', level: number, club?: { __typename?: 'ClubState', name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null, tiers: Array<{ __typename?: 'ClubTier', backgroundImageUrl?: string | null, description?: string | null, level: number, name: string, title?: string | null, colors?: { __typename?: 'ClubTierColors', background: string, border: string, foreground: string } | null } | null> } | null } | null> } | { __typename?: 'PriceRewardCondition', price: any, type: RewardConditionType } | { __typename?: 'RepPointsRewardCondition', type: RewardConditionType, repPointsByClub: Array<{ __typename?: 'RepPointsByClubCondition', repPoints: any, club?: { __typename?: 'ClubState', clubId: any, name: string, images?: { __typename?: 'ClubImages', background?: string | null } | null } | null } | null> } | { __typename?: 'RepScoreRewardCondition' } | null>, timeFrameConstraint?: { __typename?: 'TimeFrameConstraint', expiresDateTime?: any | null, timeFrameType: RewardTimeFrameType, timeZoneId?: string | null } | null, redemption?: { __typename?: 'AccessPassRewardRedemption', note?: string | null, redemptionType: RewardRedemptionType } | { __typename?: 'CustomerInformationRewardRedemption' } | { __typename?: 'InviteLinkRewardRedemption', note?: string | null, redemptionType: RewardRedemptionType } | { __typename?: 'LocationInformationRewardRedemption', note?: string | null, redemptionType: RewardRedemptionType } | { __typename?: 'PromoCodeRewardRedemption', note?: string | null, redemptionType: RewardRedemptionType } | null } | null } | null } | null };

export type ProfileGetCurrentUserInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileGetCurrentUserInvitesQuery = { __typename?: 'Query', me?: { __typename?: 'CurrentUser', pendingInvites?: Array<{ __typename?: 'PendingInvite', inviteId: string, inviteAcceptLink: any, memo: string, createdAt: any } | null> | null, acceptedInvites?: Array<{ __typename?: 'AcceptedInvite', acceptedAt: any, inviteId: string, memo: string, acceptedBy: { __typename?: 'UserWithAddress', userId: any, avatarUrl?: string | null, userName?: string | null, isVerified: boolean, tier: UserTier, name?: string | null, address?: { __typename?: 'UserAddressModel', city?: string | null, region?: string | null } | null } } | null> | null } | null };

export type GetTaxConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxConfigurationQuery = { __typename?: 'Query', me?: { __typename?: 'CurrentUser', stripeAccount?: { __typename?: 'UserStripeAccountType', taxableVenueStates?: Array<string> | null, taxCollection?: { __typename?: 'StripeTaxCollectionStatus', hasActiveRegistration: boolean, homeState?: string | null, registeredStates: Array<string> } | null } | null, taxConfiguration?: { __typename?: 'UserTaxConfiguration', name?: string | null, percent?: any | null, isCollect: boolean, useAutomaticTax?: boolean | null } | null } | null };

export const ContactNodeFieldsFragmentDoc = gql`
    fragment ContactNodeFields on Contact {
  contactId
  createdAt
  emailAddress
  events {
    nodes {
      avatarUrl
      displayName
    }
  }
  invitationStatus(eventId: $eventId)
  inviteInfo(eventId: $eventId) {
    giftTicketName
    giftTicketQuantity
    privateTicketName
    privateTicketQuantity
  }
  inviter(eventId: $eventId) {
    avatarUrl
    avatarSource
    instagramAvatarUrl
    tikTokAvatarUrl
    twitchAvatarUrl
    displayNameSource
    instagramDisplayName
    tikTokDisplayName
    twitchDisplayName
    instagramFollowsCount
    tikTokFollowsCount
    twitchFollowsCount
    isVerified
    userName
    name
    userId
    tier
    repScore
  }
  name
  phoneNumber
  userId
  dateOfBirth
  gender
  customFields {
    key
    label
    value
  }
  userInfo {
    address {
      address
      city
      countryCode
      postalCode
      region
    }
    avatarUrl
    avatarSource
    instagramAvatarUrl
    tikTokAvatarUrl
    twitchAvatarUrl
    displayNameSource
    instagramDisplayName
    tikTokDisplayName
    twitchDisplayName
    instagramFollowsCount
    tikTokFollowsCount
    twitchFollowsCount
    isVerified
    userName
    userId
    tier
    socialMediaConnections {
      displayName
      scheme
      avatarUrl
      profileLink
      userId
      username
    }
    gender
    dateOfBirth
    ageRange
    age
    name
  }
  groups {
    nodes {
      groupId
      groupName
    }
  }
}
    `;
export const AttendeeTicketPersonFieldsFragmentDoc = gql`
    fragment AttendeeTicketPersonFields on CompleteUser {
  userId
  name
  avatarUrl
  avatarSource
  instagramAvatarUrl
  tikTokAvatarUrl
  displayNameSource
  instagramDisplayName
  tikTokDisplayName
}
    `;
export const AttendeeTicketInfoFieldsFragmentDoc = gql`
    fragment AttendeeTicketInfoFields on StoredTicket {
  eventId
  isExpired
  expiredAtUtc
  validForEvent {
    eventId
    displayName
    startDate
    endDate
    timeZone
    isEnded
  }
  plusOneHolder {
    ...AttendeeTicketPersonFields
  }
  transferredTo {
    ...AttendeeTicketPersonFields
  }
  sharedBy {
    ...AttendeeTicketPersonFields
  }
}
    ${AttendeeTicketPersonFieldsFragmentDoc}`;
export const PlusOneReturnHealthFieldsFragmentDoc = gql`
    fragment PlusOneReturnHealthFields on PlusOneReturnHealth {
  seriesId
  isEnabled
  status
  checkedAtUtc
  reasons {
    code
    severity
    count
    eventId
    eventName
  }
  events {
    eventId
    name
    startDate
    endDate
    isOver
    activeCount
    expiredCount
    transferredCount
    state
  }
}
    `;
export const CreateOrUpdateAchievementDocument = gql`
    mutation CreateOrUpdateAchievement($id: UUID, $pieId: UUID!, $slug: String!, $displayName: String!, $bio: String!, $avatarUrl: String!, $uploadedAssetId: UUID, $maxSupply: Int, $activeFromUtc: DateTime, $activeToUtc: DateTime, $claimByRewardId: UUID, $category: AchievementCategory!) {
  achievement {
    createOrUpdate(
      id: $id
      pieId: $pieId
      slug: $slug
      displayName: $displayName
      bio: $bio
      avatarUrl: $avatarUrl
      uploadedAssetId: $uploadedAssetId
      maxSupply: $maxSupply
      activeFromUtc: $activeFromUtc
      activeToUtc: $activeToUtc
      claimByRewardId: $claimByRewardId
      category: $category
    ) {
      achievementId
      displayName
      bio
      slug
      createdUtc
      avatarUrl
      maxSupply
      activeFromUtc
      activeToUtc
    }
  }
}
    `;
export type CreateOrUpdateAchievementMutationFn = Apollo.MutationFunction<CreateOrUpdateAchievementMutation, CreateOrUpdateAchievementMutationVariables>;

/**
 * __useCreateOrUpdateAchievementMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAchievementMutation, { data, loading, error }] = useCreateOrUpdateAchievementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pieId: // value for 'pieId'
 *      slug: // value for 'slug'
 *      displayName: // value for 'displayName'
 *      bio: // value for 'bio'
 *      avatarUrl: // value for 'avatarUrl'
 *      uploadedAssetId: // value for 'uploadedAssetId'
 *      maxSupply: // value for 'maxSupply'
 *      activeFromUtc: // value for 'activeFromUtc'
 *      activeToUtc: // value for 'activeToUtc'
 *      claimByRewardId: // value for 'claimByRewardId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCreateOrUpdateAchievementMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateAchievementMutation, CreateOrUpdateAchievementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateAchievementMutation, CreateOrUpdateAchievementMutationVariables>(CreateOrUpdateAchievementDocument, options);
      }
export type CreateOrUpdateAchievementMutationHookResult = ReturnType<typeof useCreateOrUpdateAchievementMutation>;
export type CreateOrUpdateAchievementMutationResult = Apollo.MutationResult<CreateOrUpdateAchievementMutation>;
export type CreateOrUpdateAchievementMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateAchievementMutation, CreateOrUpdateAchievementMutationVariables>;
export const AchievementPresignUploadUrlDocument = gql`
    mutation AchievementPresignUploadUrl($contentType: String!, $extension: String!, $contentLength: Long!) {
  achievement {
    achievementAvatar {
      presignUploadUrl(
        contentType: $contentType
        extension: $extension
        contentLength: $contentLength
      )
    }
  }
}
    `;
export type AchievementPresignUploadUrlMutationFn = Apollo.MutationFunction<AchievementPresignUploadUrlMutation, AchievementPresignUploadUrlMutationVariables>;

/**
 * __useAchievementPresignUploadUrlMutation__
 *
 * To run a mutation, you first call `useAchievementPresignUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAchievementPresignUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [achievementPresignUploadUrlMutation, { data, loading, error }] = useAchievementPresignUploadUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      extension: // value for 'extension'
 *      contentLength: // value for 'contentLength'
 *   },
 * });
 */
export function useAchievementPresignUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<AchievementPresignUploadUrlMutation, AchievementPresignUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AchievementPresignUploadUrlMutation, AchievementPresignUploadUrlMutationVariables>(AchievementPresignUploadUrlDocument, options);
      }
export type AchievementPresignUploadUrlMutationHookResult = ReturnType<typeof useAchievementPresignUploadUrlMutation>;
export type AchievementPresignUploadUrlMutationResult = Apollo.MutationResult<AchievementPresignUploadUrlMutation>;
export type AchievementPresignUploadUrlMutationOptions = Apollo.BaseMutationOptions<AchievementPresignUploadUrlMutation, AchievementPresignUploadUrlMutationVariables>;
export const UpdateAchievementAvatarDocument = gql`
    mutation UpdateAchievementAvatar($achievementId: UUID!, $avatarUrl: String!) {
  achievement {
    achievementAvatar {
      completeUpload(achievementId: $achievementId, avatarUrl: $avatarUrl)
    }
  }
}
    `;
export type UpdateAchievementAvatarMutationFn = Apollo.MutationFunction<UpdateAchievementAvatarMutation, UpdateAchievementAvatarMutationVariables>;

/**
 * __useUpdateAchievementAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateAchievementAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAchievementAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAchievementAvatarMutation, { data, loading, error }] = useUpdateAchievementAvatarMutation({
 *   variables: {
 *      achievementId: // value for 'achievementId'
 *      avatarUrl: // value for 'avatarUrl'
 *   },
 * });
 */
export function useUpdateAchievementAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAchievementAvatarMutation, UpdateAchievementAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAchievementAvatarMutation, UpdateAchievementAvatarMutationVariables>(UpdateAchievementAvatarDocument, options);
      }
export type UpdateAchievementAvatarMutationHookResult = ReturnType<typeof useUpdateAchievementAvatarMutation>;
export type UpdateAchievementAvatarMutationResult = Apollo.MutationResult<UpdateAchievementAvatarMutation>;
export type UpdateAchievementAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateAchievementAvatarMutation, UpdateAchievementAvatarMutationVariables>;
export const DeleteAchievementDocument = gql`
    mutation DeleteAchievement($achievementId: UUID!) {
  achievement {
    delete(achievementId: $achievementId)
  }
}
    `;
export type DeleteAchievementMutationFn = Apollo.MutationFunction<DeleteAchievementMutation, DeleteAchievementMutationVariables>;

/**
 * __useDeleteAchievementMutation__
 *
 * To run a mutation, you first call `useDeleteAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAchievementMutation, { data, loading, error }] = useDeleteAchievementMutation({
 *   variables: {
 *      achievementId: // value for 'achievementId'
 *   },
 * });
 */
export function useDeleteAchievementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAchievementMutation, DeleteAchievementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAchievementMutation, DeleteAchievementMutationVariables>(DeleteAchievementDocument, options);
      }
export type DeleteAchievementMutationHookResult = ReturnType<typeof useDeleteAchievementMutation>;
export type DeleteAchievementMutationResult = Apollo.MutationResult<DeleteAchievementMutation>;
export type DeleteAchievementMutationOptions = Apollo.BaseMutationOptions<DeleteAchievementMutation, DeleteAchievementMutationVariables>;
export const AwardAchievementDocument = gql`
    mutation AwardAchievement($achievementId: UUID!, $pieId: UUID, $userName: String!) {
  achievement {
    award(achievementId: $achievementId, pieId: $pieId, userName: $userName)
  }
}
    `;
export type AwardAchievementMutationFn = Apollo.MutationFunction<AwardAchievementMutation, AwardAchievementMutationVariables>;

/**
 * __useAwardAchievementMutation__
 *
 * To run a mutation, you first call `useAwardAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAwardAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [awardAchievementMutation, { data, loading, error }] = useAwardAchievementMutation({
 *   variables: {
 *      achievementId: // value for 'achievementId'
 *      pieId: // value for 'pieId'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useAwardAchievementMutation(baseOptions?: Apollo.MutationHookOptions<AwardAchievementMutation, AwardAchievementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AwardAchievementMutation, AwardAchievementMutationVariables>(AwardAchievementDocument, options);
      }
export type AwardAchievementMutationHookResult = ReturnType<typeof useAwardAchievementMutation>;
export type AwardAchievementMutationResult = Apollo.MutationResult<AwardAchievementMutation>;
export type AwardAchievementMutationOptions = Apollo.BaseMutationOptions<AwardAchievementMutation, AwardAchievementMutationVariables>;
export const CompleteClubImageUploadDocument = gql`
    mutation CompleteClubImageUpload($clubId: UUID!, $token: String!, $type: ClubUploadAsset!) {
  clubById(clubId: $clubId) {
    completeUpload(token: $token, type: $type)
  }
}
    `;
export type CompleteClubImageUploadMutationFn = Apollo.MutationFunction<CompleteClubImageUploadMutation, CompleteClubImageUploadMutationVariables>;

/**
 * __useCompleteClubImageUploadMutation__
 *
 * To run a mutation, you first call `useCompleteClubImageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteClubImageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeClubImageUploadMutation, { data, loading, error }] = useCompleteClubImageUploadMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      token: // value for 'token'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCompleteClubImageUploadMutation(baseOptions?: Apollo.MutationHookOptions<CompleteClubImageUploadMutation, CompleteClubImageUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteClubImageUploadMutation, CompleteClubImageUploadMutationVariables>(CompleteClubImageUploadDocument, options);
      }
export type CompleteClubImageUploadMutationHookResult = ReturnType<typeof useCompleteClubImageUploadMutation>;
export type CompleteClubImageUploadMutationResult = Apollo.MutationResult<CompleteClubImageUploadMutation>;
export type CompleteClubImageUploadMutationOptions = Apollo.BaseMutationOptions<CompleteClubImageUploadMutation, CompleteClubImageUploadMutationVariables>;
export const ShareContactsDocument = gql`
    mutation ShareContacts($targetUserId: UUID!, $contactIds: [UUID!]!) {
  contactList {
    shareContacts(targetUserId: $targetUserId, contactIds: $contactIds) {
      inviteId
      inviteToken
    }
  }
}
    `;
export type ShareContactsMutationFn = Apollo.MutationFunction<ShareContactsMutation, ShareContactsMutationVariables>;

/**
 * __useShareContactsMutation__
 *
 * To run a mutation, you first call `useShareContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareContactsMutation, { data, loading, error }] = useShareContactsMutation({
 *   variables: {
 *      targetUserId: // value for 'targetUserId'
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useShareContactsMutation(baseOptions?: Apollo.MutationHookOptions<ShareContactsMutation, ShareContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareContactsMutation, ShareContactsMutationVariables>(ShareContactsDocument, options);
      }
export type ShareContactsMutationHookResult = ReturnType<typeof useShareContactsMutation>;
export type ShareContactsMutationResult = Apollo.MutationResult<ShareContactsMutation>;
export type ShareContactsMutationOptions = Apollo.BaseMutationOptions<ShareContactsMutation, ShareContactsMutationVariables>;
export const AcceptContactShareDocument = gql`
    mutation AcceptContactShare($inviteToken: String!, $groupName: String) {
  contactList {
    acceptContactShare(inviteToken: $inviteToken, groupName: $groupName) {
      jobId
    }
  }
}
    `;
export type AcceptContactShareMutationFn = Apollo.MutationFunction<AcceptContactShareMutation, AcceptContactShareMutationVariables>;

/**
 * __useAcceptContactShareMutation__
 *
 * To run a mutation, you first call `useAcceptContactShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptContactShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptContactShareMutation, { data, loading, error }] = useAcceptContactShareMutation({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *      groupName: // value for 'groupName'
 *   },
 * });
 */
export function useAcceptContactShareMutation(baseOptions?: Apollo.MutationHookOptions<AcceptContactShareMutation, AcceptContactShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptContactShareMutation, AcceptContactShareMutationVariables>(AcceptContactShareDocument, options);
      }
export type AcceptContactShareMutationHookResult = ReturnType<typeof useAcceptContactShareMutation>;
export type AcceptContactShareMutationResult = Apollo.MutationResult<AcceptContactShareMutation>;
export type AcceptContactShareMutationOptions = Apollo.BaseMutationOptions<AcceptContactShareMutation, AcceptContactShareMutationVariables>;
export const AddContactsToGroupDocument = gql`
    mutation AddContactsToGroup($groupId: UUID!, $filter: ContactPageFilterArgsInput, $contactIds: [UUID!]) {
  contactList {
    addContactsToGroup(groupId: $groupId, filter: $filter, contactIds: $contactIds)
  }
}
    `;
export type AddContactsToGroupMutationFn = Apollo.MutationFunction<AddContactsToGroupMutation, AddContactsToGroupMutationVariables>;

/**
 * __useAddContactsToGroupMutation__
 *
 * To run a mutation, you first call `useAddContactsToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactsToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactsToGroupMutation, { data, loading, error }] = useAddContactsToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      filter: // value for 'filter'
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useAddContactsToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddContactsToGroupMutation, AddContactsToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactsToGroupMutation, AddContactsToGroupMutationVariables>(AddContactsToGroupDocument, options);
      }
export type AddContactsToGroupMutationHookResult = ReturnType<typeof useAddContactsToGroupMutation>;
export type AddContactsToGroupMutationResult = Apollo.MutationResult<AddContactsToGroupMutation>;
export type AddContactsToGroupMutationOptions = Apollo.BaseMutationOptions<AddContactsToGroupMutation, AddContactsToGroupMutationVariables>;
export const DeleteContactsFromGroupDocument = gql`
    mutation DeleteContactsFromGroup($groupId: UUID!, $contactIds: [UUID!], $filter: ContactPageFilterArgsInput) {
  contactList {
    deleteContactsFromGroup(
      groupId: $groupId
      contactIds: $contactIds
      filter: $filter
    )
  }
}
    `;
export type DeleteContactsFromGroupMutationFn = Apollo.MutationFunction<DeleteContactsFromGroupMutation, DeleteContactsFromGroupMutationVariables>;

/**
 * __useDeleteContactsFromGroupMutation__
 *
 * To run a mutation, you first call `useDeleteContactsFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsFromGroupMutation, { data, loading, error }] = useDeleteContactsFromGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      contactIds: // value for 'contactIds'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeleteContactsFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactsFromGroupMutation, DeleteContactsFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactsFromGroupMutation, DeleteContactsFromGroupMutationVariables>(DeleteContactsFromGroupDocument, options);
      }
export type DeleteContactsFromGroupMutationHookResult = ReturnType<typeof useDeleteContactsFromGroupMutation>;
export type DeleteContactsFromGroupMutationResult = Apollo.MutationResult<DeleteContactsFromGroupMutation>;
export type DeleteContactsFromGroupMutationOptions = Apollo.BaseMutationOptions<DeleteContactsFromGroupMutation, DeleteContactsFromGroupMutationVariables>;
export const CreateOrUpdateGroupDocument = gql`
    mutation CreateOrUpdateGroup($args: GroupModelArgsInput!) {
  contactList {
    createOrUpdateGroup(args: $args) {
      groupName
      groupId
    }
  }
}
    `;
export type CreateOrUpdateGroupMutationFn = Apollo.MutationFunction<CreateOrUpdateGroupMutation, CreateOrUpdateGroupMutationVariables>;

/**
 * __useCreateOrUpdateGroupMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateGroupMutation, { data, loading, error }] = useCreateOrUpdateGroupMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCreateOrUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateGroupMutation, CreateOrUpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateGroupMutation, CreateOrUpdateGroupMutationVariables>(CreateOrUpdateGroupDocument, options);
      }
export type CreateOrUpdateGroupMutationHookResult = ReturnType<typeof useCreateOrUpdateGroupMutation>;
export type CreateOrUpdateGroupMutationResult = Apollo.MutationResult<CreateOrUpdateGroupMutation>;
export type CreateOrUpdateGroupMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateGroupMutation, CreateOrUpdateGroupMutationVariables>;
export const CreateOrUpdateContactDocument = gql`
    mutation CreateOrUpdateContact($args: ContactModelArgsInput!) {
  contactList {
    createOrUpdateContact(args: $args) {
      contactId
      emailAddress
      name
      phoneNumber
      userId
    }
  }
}
    `;
export type CreateOrUpdateContactMutationFn = Apollo.MutationFunction<CreateOrUpdateContactMutation, CreateOrUpdateContactMutationVariables>;

/**
 * __useCreateOrUpdateContactMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateContactMutation, { data, loading, error }] = useCreateOrUpdateContactMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCreateOrUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateContactMutation, CreateOrUpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateContactMutation, CreateOrUpdateContactMutationVariables>(CreateOrUpdateContactDocument, options);
      }
export type CreateOrUpdateContactMutationHookResult = ReturnType<typeof useCreateOrUpdateContactMutation>;
export type CreateOrUpdateContactMutationResult = Apollo.MutationResult<CreateOrUpdateContactMutation>;
export type CreateOrUpdateContactMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateContactMutation, CreateOrUpdateContactMutationVariables>;
export const CreateOrUpdateContactsDocument = gql`
    mutation CreateOrUpdateContacts($contacts: [ContactModelArgsInput!]!) {
  contactList {
    createOrUpdateContacts(contacts: $contacts) {
      contactId
      emailAddress
      name
      phoneNumber
      gender
      dateOfBirth
      customFields {
        key
        label
        value
      }
      mutationResult {
        reason
        status
      }
    }
  }
}
    `;
export type CreateOrUpdateContactsMutationFn = Apollo.MutationFunction<CreateOrUpdateContactsMutation, CreateOrUpdateContactsMutationVariables>;

/**
 * __useCreateOrUpdateContactsMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateContactsMutation, { data, loading, error }] = useCreateOrUpdateContactsMutation({
 *   variables: {
 *      contacts: // value for 'contacts'
 *   },
 * });
 */
export function useCreateOrUpdateContactsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateContactsMutation, CreateOrUpdateContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateContactsMutation, CreateOrUpdateContactsMutationVariables>(CreateOrUpdateContactsDocument, options);
      }
export type CreateOrUpdateContactsMutationHookResult = ReturnType<typeof useCreateOrUpdateContactsMutation>;
export type CreateOrUpdateContactsMutationResult = Apollo.MutationResult<CreateOrUpdateContactsMutation>;
export type CreateOrUpdateContactsMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateContactsMutation, CreateOrUpdateContactsMutationVariables>;
export const DeleteContactsDocument = gql`
    mutation DeleteContacts($filter: ContactPageFilterArgsInput, $contactIds: [UUID!]) {
  contactList {
    deleteContacts(filter: $filter, contactIds: $contactIds)
  }
}
    `;
export type DeleteContactsMutationFn = Apollo.MutationFunction<DeleteContactsMutation, DeleteContactsMutationVariables>;

/**
 * __useDeleteContactsMutation__
 *
 * To run a mutation, you first call `useDeleteContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsMutation, { data, loading, error }] = useDeleteContactsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useDeleteContactsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactsMutation, DeleteContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactsMutation, DeleteContactsMutationVariables>(DeleteContactsDocument, options);
      }
export type DeleteContactsMutationHookResult = ReturnType<typeof useDeleteContactsMutation>;
export type DeleteContactsMutationResult = Apollo.MutationResult<DeleteContactsMutation>;
export type DeleteContactsMutationOptions = Apollo.BaseMutationOptions<DeleteContactsMutation, DeleteContactsMutationVariables>;
export const DeleteContactGroupDocument = gql`
    mutation DeleteContactGroup($groupId: UUID!) {
  contactList {
    deleteGroup(groupId: $groupId)
  }
}
    `;
export type DeleteContactGroupMutationFn = Apollo.MutationFunction<DeleteContactGroupMutation, DeleteContactGroupMutationVariables>;

/**
 * __useDeleteContactGroupMutation__
 *
 * To run a mutation, you first call `useDeleteContactGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactGroupMutation, { data, loading, error }] = useDeleteContactGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteContactGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactGroupMutation, DeleteContactGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactGroupMutation, DeleteContactGroupMutationVariables>(DeleteContactGroupDocument, options);
      }
export type DeleteContactGroupMutationHookResult = ReturnType<typeof useDeleteContactGroupMutation>;
export type DeleteContactGroupMutationResult = Apollo.MutationResult<DeleteContactGroupMutation>;
export type DeleteContactGroupMutationOptions = Apollo.BaseMutationOptions<DeleteContactGroupMutation, DeleteContactGroupMutationVariables>;
export const BulkDeleteContactsDocument = gql`
    mutation BulkDeleteContacts($contactIds: [UUID!], $filter: ContactPageFilterArgsInput) {
  contactList {
    bulkDeleteContacts(contactIds: $contactIds, filter: $filter) {
      jobId
      totalCount
    }
  }
}
    `;
export type BulkDeleteContactsMutationFn = Apollo.MutationFunction<BulkDeleteContactsMutation, BulkDeleteContactsMutationVariables>;

/**
 * __useBulkDeleteContactsMutation__
 *
 * To run a mutation, you first call `useBulkDeleteContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteContactsMutation, { data, loading, error }] = useBulkDeleteContactsMutation({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBulkDeleteContactsMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteContactsMutation, BulkDeleteContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteContactsMutation, BulkDeleteContactsMutationVariables>(BulkDeleteContactsDocument, options);
      }
export type BulkDeleteContactsMutationHookResult = ReturnType<typeof useBulkDeleteContactsMutation>;
export type BulkDeleteContactsMutationResult = Apollo.MutationResult<BulkDeleteContactsMutation>;
export type BulkDeleteContactsMutationOptions = Apollo.BaseMutationOptions<BulkDeleteContactsMutation, BulkDeleteContactsMutationVariables>;
export const SendMessageToContactsDocument = gql`
    mutation SendMessageToContacts($message: String!, $isViaEmail: Boolean!, $isViaSms: Boolean!, $contactIds: [UUID!], $filter: ContactPageFilterArgsInput, $smsMessage: String) {
  contactList {
    sendMessageToContacts(
      message: $message
      isViaEmail: $isViaEmail
      isViaSms: $isViaSms
      contactIds: $contactIds
      filter: $filter
      smsMessage: $smsMessage
    ) {
      jobId
      totalCount
    }
  }
}
    `;
export type SendMessageToContactsMutationFn = Apollo.MutationFunction<SendMessageToContactsMutation, SendMessageToContactsMutationVariables>;

/**
 * __useSendMessageToContactsMutation__
 *
 * To run a mutation, you first call `useSendMessageToContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageToContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageToContactsMutation, { data, loading, error }] = useSendMessageToContactsMutation({
 *   variables: {
 *      message: // value for 'message'
 *      isViaEmail: // value for 'isViaEmail'
 *      isViaSms: // value for 'isViaSms'
 *      contactIds: // value for 'contactIds'
 *      filter: // value for 'filter'
 *      smsMessage: // value for 'smsMessage'
 *   },
 * });
 */
export function useSendMessageToContactsMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageToContactsMutation, SendMessageToContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageToContactsMutation, SendMessageToContactsMutationVariables>(SendMessageToContactsDocument, options);
      }
export type SendMessageToContactsMutationHookResult = ReturnType<typeof useSendMessageToContactsMutation>;
export type SendMessageToContactsMutationResult = Apollo.MutationResult<SendMessageToContactsMutation>;
export type SendMessageToContactsMutationOptions = Apollo.BaseMutationOptions<SendMessageToContactsMutation, SendMessageToContactsMutationVariables>;
export const ImportContactsCsvDocument = gql`
    mutation ImportContactsCsv($csvContent: String!, $mappings: ContactFieldMappingDtoInput!, $groupId: UUID, $groupName: String) {
  contactList {
    importContactsCsv(
      csvContent: $csvContent
      mappings: $mappings
      groupId: $groupId
      groupName: $groupName
    ) {
      jobId
      totalRows
    }
  }
}
    `;
export type ImportContactsCsvMutationFn = Apollo.MutationFunction<ImportContactsCsvMutation, ImportContactsCsvMutationVariables>;

/**
 * __useImportContactsCsvMutation__
 *
 * To run a mutation, you first call `useImportContactsCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportContactsCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importContactsCsvMutation, { data, loading, error }] = useImportContactsCsvMutation({
 *   variables: {
 *      csvContent: // value for 'csvContent'
 *      mappings: // value for 'mappings'
 *      groupId: // value for 'groupId'
 *      groupName: // value for 'groupName'
 *   },
 * });
 */
export function useImportContactsCsvMutation(baseOptions?: Apollo.MutationHookOptions<ImportContactsCsvMutation, ImportContactsCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportContactsCsvMutation, ImportContactsCsvMutationVariables>(ImportContactsCsvDocument, options);
      }
export type ImportContactsCsvMutationHookResult = ReturnType<typeof useImportContactsCsvMutation>;
export type ImportContactsCsvMutationResult = Apollo.MutationResult<ImportContactsCsvMutation>;
export type ImportContactsCsvMutationOptions = Apollo.BaseMutationOptions<ImportContactsCsvMutation, ImportContactsCsvMutationVariables>;
export const CreateOrUpdateEventDocument = gql`
    mutation CreateOrUpdateEvent($id: UUID, $eventType: EventType!, $slug: String!, $displayName: String!, $description: String!, $terms: String, $faqs: String, $note: String!, $avatarUrl: String!, $exclusiveAvatarUrl: String, $startDate: DateTime!, $endDate: DateTime!, $coHostUserIds: [UUID!], $promoterUserIds: [UUID!], $sponsorUserIds: [UUID!], $doorUserIds: [UUID!], $coordinatorUserIds: [UUID!], $talentUserIds: [UUID!], $talentOrder: [UUID!], $location: EventLocationInput, $eventTickets: [EventTicketArgsInput!], $invitations: [EventInvitationSourceArgsInput!], $minimumRepScore: Decimal, $optInShowGuestList: Boolean!, $optInShowGuestCount: Boolean!, $optInAllowPublicEventPagePreview: Boolean!, $optInDisplayRepScore: Boolean!, $optInAllowGuestInviteOthers: Boolean!, $optInLocationRadius: Boolean!, $locationRadius: EventLocationInput, $optInAgeLimit: Boolean!, $ageLimit: Int, $optInDisclosureOrPrivacyPolicy: Boolean!, $disclosureOrPrivacyPolicyTitle: String, $disclosureOrPrivacyPolicyFileUrl: String, $optInSocialAccountRequirements: Boolean!, $socialAccountRequirements: [SocialAccountRequirementInput!], $requireSocialAccountConnection: Boolean!, $optInQuestionRequirements: Boolean!, $questionRequirements: [QuestionRequirementInput!], $uploadedAssetId: UUID, $isPrivate: Boolean, $eventTimeZoneId: String, $isAllInPricing: Boolean!, $scanningZones: [ScanningZoneInput!], $optInShowMusicEmbed: Boolean!, $musicEmbedUrl: String, $isListed: Boolean, $ticketTermsPurchasePolicy: String, $pendingRoleDeleteArgs: [EventAttendeeRoleDeleteArgsInput!], $clubSlugOrId: String, $currency: String, $eligibilityCriteria: EventEligibilityCriteriaInput, $faqEntries: [FaqEntryInput!], $eventSeriesId: UUID, $copiedFromEventSlugOrId: String) {
  event {
    createOrUpdate(
      id: $id
      eventType: $eventType
      slug: $slug
      displayName: $displayName
      description: $description
      terms: $terms
      faqs: $faqs
      note: $note
      avatarUrl: $avatarUrl
      exclusiveAvatarUrl: $exclusiveAvatarUrl
      startDate: $startDate
      endDate: $endDate
      coHostUserIds: $coHostUserIds
      promoterUserIds: $promoterUserIds
      sponsorUserIds: $sponsorUserIds
      doorUserIds: $doorUserIds
      coordinatorUserIds: $coordinatorUserIds
      talentUserIds: $talentUserIds
      talentOrder: $talentOrder
      location: $location
      eventTickets: $eventTickets
      invitations: $invitations
      minimumRepScore: $minimumRepScore
      optInShowGuestList: $optInShowGuestList
      optInShowGuestCount: $optInShowGuestCount
      optInAllowPublicEventPagePreview: $optInAllowPublicEventPagePreview
      optInDisplayRepScore: $optInDisplayRepScore
      optInAllowGuestInviteOthers: $optInAllowGuestInviteOthers
      optInLocationRadius: $optInLocationRadius
      locationRadius: $locationRadius
      optInAgeLimit: $optInAgeLimit
      ageLimit: $ageLimit
      optInDisclosureOrPrivacyPolicy: $optInDisclosureOrPrivacyPolicy
      disclosureOrPrivacyPolicyTitle: $disclosureOrPrivacyPolicyTitle
      disclosureOrPrivacyPolicyFileUrl: $disclosureOrPrivacyPolicyFileUrl
      optInSocialAccountRequirements: $optInSocialAccountRequirements
      socialAccountRequirements: $socialAccountRequirements
      requireSocialAccountConnection: $requireSocialAccountConnection
      optInQuestionRequirements: $optInQuestionRequirements
      questionRequirements: $questionRequirements
      uploadedAssetId: $uploadedAssetId
      isPrivate: $isPrivate
      eventTimeZoneId: $eventTimeZoneId
      isAllInPricing: $isAllInPricing
      scanningZones: $scanningZones
      optInShowMusicEmbed: $optInShowMusicEmbed
      musicEmbedUrl: $musicEmbedUrl
      isListed: $isListed
      ticketTermsPurchasePolicy: $ticketTermsPurchasePolicy
      pendingRoleDeleteArgs: $pendingRoleDeleteArgs
      clubSlugOrId: $clubSlugOrId
      currency: $currency
      eligibilityCriteria: $eligibilityCriteria
      faqEntries: $faqEntries
      eventSeriesId: $eventSeriesId
      copiedFromEventSlugOrId: $copiedFromEventSlugOrId
    ) {
      eventId
      eventType
      displayName
      expiresAt
      status
      location {
        locationName
        longitude
        latitude
        address
        region
        city
        postalCode
        countryCode
        isOnlyVisibleToApprovedAttendees
      }
      isPrivate
      uploadedAssetId
      avatarUrl
      exclusiveAvatarUrl
      minimumRepScore
      optInShowGuestList
      optInShowGuestCount
      slug
      optInDisplayRepScore
      optInAllowGuestInviteOthers
      optInLocationRadius
      locationRadius {
        address
        isActive
        latitude
        longitude
        radius
        unitLengthType
      }
      optInAgeLimit
      ageLimit
      optInDisclosureOrPrivacyPolicy
      disclosureOrPrivacyPolicyTitle
      disclosureOrPrivacyPolicyFileUrl
      optInSocialAccountRequirements
      socialAccountRequirements {
        scheme
        isRequired
      }
      requireSocialAccountConnection
      optInQuestionRequirements
      questionRequirements {
        question
        isRequired
      }
      isFeatured
      description
      note
      startDate
      endDate
      timeZone
      isAllInPricing
      clubId
    }
  }
}
    `;
export type CreateOrUpdateEventMutationFn = Apollo.MutationFunction<CreateOrUpdateEventMutation, CreateOrUpdateEventMutationVariables>;

/**
 * __useCreateOrUpdateEventMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateEventMutation, { data, loading, error }] = useCreateOrUpdateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      eventType: // value for 'eventType'
 *      slug: // value for 'slug'
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      terms: // value for 'terms'
 *      faqs: // value for 'faqs'
 *      note: // value for 'note'
 *      avatarUrl: // value for 'avatarUrl'
 *      exclusiveAvatarUrl: // value for 'exclusiveAvatarUrl'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      coHostUserIds: // value for 'coHostUserIds'
 *      promoterUserIds: // value for 'promoterUserIds'
 *      sponsorUserIds: // value for 'sponsorUserIds'
 *      doorUserIds: // value for 'doorUserIds'
 *      coordinatorUserIds: // value for 'coordinatorUserIds'
 *      talentUserIds: // value for 'talentUserIds'
 *      talentOrder: // value for 'talentOrder'
 *      location: // value for 'location'
 *      eventTickets: // value for 'eventTickets'
 *      invitations: // value for 'invitations'
 *      minimumRepScore: // value for 'minimumRepScore'
 *      optInShowGuestList: // value for 'optInShowGuestList'
 *      optInShowGuestCount: // value for 'optInShowGuestCount'
 *      optInAllowPublicEventPagePreview: // value for 'optInAllowPublicEventPagePreview'
 *      optInDisplayRepScore: // value for 'optInDisplayRepScore'
 *      optInAllowGuestInviteOthers: // value for 'optInAllowGuestInviteOthers'
 *      optInLocationRadius: // value for 'optInLocationRadius'
 *      locationRadius: // value for 'locationRadius'
 *      optInAgeLimit: // value for 'optInAgeLimit'
 *      ageLimit: // value for 'ageLimit'
 *      optInDisclosureOrPrivacyPolicy: // value for 'optInDisclosureOrPrivacyPolicy'
 *      disclosureOrPrivacyPolicyTitle: // value for 'disclosureOrPrivacyPolicyTitle'
 *      disclosureOrPrivacyPolicyFileUrl: // value for 'disclosureOrPrivacyPolicyFileUrl'
 *      optInSocialAccountRequirements: // value for 'optInSocialAccountRequirements'
 *      socialAccountRequirements: // value for 'socialAccountRequirements'
 *      requireSocialAccountConnection: // value for 'requireSocialAccountConnection'
 *      optInQuestionRequirements: // value for 'optInQuestionRequirements'
 *      questionRequirements: // value for 'questionRequirements'
 *      uploadedAssetId: // value for 'uploadedAssetId'
 *      isPrivate: // value for 'isPrivate'
 *      eventTimeZoneId: // value for 'eventTimeZoneId'
 *      isAllInPricing: // value for 'isAllInPricing'
 *      scanningZones: // value for 'scanningZones'
 *      optInShowMusicEmbed: // value for 'optInShowMusicEmbed'
 *      musicEmbedUrl: // value for 'musicEmbedUrl'
 *      isListed: // value for 'isListed'
 *      ticketTermsPurchasePolicy: // value for 'ticketTermsPurchasePolicy'
 *      pendingRoleDeleteArgs: // value for 'pendingRoleDeleteArgs'
 *      clubSlugOrId: // value for 'clubSlugOrId'
 *      currency: // value for 'currency'
 *      eligibilityCriteria: // value for 'eligibilityCriteria'
 *      faqEntries: // value for 'faqEntries'
 *      eventSeriesId: // value for 'eventSeriesId'
 *      copiedFromEventSlugOrId: // value for 'copiedFromEventSlugOrId'
 *   },
 * });
 */
export function useCreateOrUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateEventMutation, CreateOrUpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateEventMutation, CreateOrUpdateEventMutationVariables>(CreateOrUpdateEventDocument, options);
      }
export type CreateOrUpdateEventMutationHookResult = ReturnType<typeof useCreateOrUpdateEventMutation>;
export type CreateOrUpdateEventMutationResult = Apollo.MutationResult<CreateOrUpdateEventMutation>;
export type CreateOrUpdateEventMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateEventMutation, CreateOrUpdateEventMutationVariables>;
export const CreateRecurringEventDocument = gql`
    mutation CreateRecurringEvent($eventType: EventType!, $slug: String!, $displayName: String!, $description: String!, $note: String!, $avatarUrl: String!, $startDate: DateTime!, $endDate: DateTime!, $coHostUserIds: [UUID!], $promoterUserIds: [UUID!], $sponsorUserIds: [UUID!], $doorUserIds: [UUID!], $coordinatorUserIds: [UUID!], $talentUserIds: [UUID!], $talentOrder: [UUID!], $location: EventLocationInput, $eventTickets: [EventTicketArgsInput!], $invitations: [EventInvitationSourceArgsInput!], $minimumRepScore: Decimal, $optInShowGuestList: Boolean!, $optInShowGuestCount: Boolean!, $optInAllowPublicEventPagePreview: Boolean!, $optInDisplayRepScore: Boolean!, $optInAllowGuestInviteOthers: Boolean!, $optInLocationRadius: Boolean!, $locationRadius: EventLocationInput, $optInAgeLimit: Boolean!, $ageLimit: Int, $optInDisclosureOrPrivacyPolicy: Boolean!, $disclosureOrPrivacyPolicyTitle: String, $disclosureOrPrivacyPolicyFileUrl: String, $optInSocialAccountRequirements: Boolean!, $socialAccountRequirements: [SocialAccountRequirementInput!], $requireSocialAccountConnection: Boolean!, $optInQuestionRequirements: Boolean!, $questionRequirements: [QuestionRequirementInput!], $uploadedAssetId: UUID, $isPrivate: Boolean, $eventTimeZoneId: String, $isAllInPricing: Boolean!, $recurringInfo: RecurringEventInfoArgsInput!, $scanningZones: [ScanningZoneInput!], $optInShowMusicEmbed: Boolean!, $musicEmbedUrl: String, $isListed: Boolean, $ticketTermsPurchasePolicy: String, $clubSlugOrId: String, $eventSeriesId: UUID, $copiedFromEventSlugOrId: String) {
  event {
    createRecurringEvent(
      recurringInfo: $recurringInfo
      eventType: $eventType
      slug: $slug
      displayName: $displayName
      description: $description
      note: $note
      avatarUrl: $avatarUrl
      startDate: $startDate
      endDate: $endDate
      coHostUserIds: $coHostUserIds
      promoterUserIds: $promoterUserIds
      sponsorUserIds: $sponsorUserIds
      doorUserIds: $doorUserIds
      coordinatorUserIds: $coordinatorUserIds
      talentUserIds: $talentUserIds
      talentOrder: $talentOrder
      location: $location
      eventTickets: $eventTickets
      invitations: $invitations
      minimumRepScore: $minimumRepScore
      optInShowGuestList: $optInShowGuestList
      optInShowGuestCount: $optInShowGuestCount
      optInAllowPublicEventPagePreview: $optInAllowPublicEventPagePreview
      optInDisplayRepScore: $optInDisplayRepScore
      optInAllowGuestInviteOthers: $optInAllowGuestInviteOthers
      optInLocationRadius: $optInLocationRadius
      locationRadius: $locationRadius
      optInAgeLimit: $optInAgeLimit
      ageLimit: $ageLimit
      optInDisclosureOrPrivacyPolicy: $optInDisclosureOrPrivacyPolicy
      disclosureOrPrivacyPolicyTitle: $disclosureOrPrivacyPolicyTitle
      disclosureOrPrivacyPolicyFileUrl: $disclosureOrPrivacyPolicyFileUrl
      optInSocialAccountRequirements: $optInSocialAccountRequirements
      socialAccountRequirements: $socialAccountRequirements
      requireSocialAccountConnection: $requireSocialAccountConnection
      optInQuestionRequirements: $optInQuestionRequirements
      questionRequirements: $questionRequirements
      uploadedAssetId: $uploadedAssetId
      isPrivate: $isPrivate
      eventTimeZoneId: $eventTimeZoneId
      isAllInPricing: $isAllInPricing
      scanningZones: $scanningZones
      optInShowMusicEmbed: $optInShowMusicEmbed
      musicEmbedUrl: $musicEmbedUrl
      isListed: $isListed
      ticketTermsPurchasePolicy: $ticketTermsPurchasePolicy
      clubSlugOrId: $clubSlugOrId
      eventSeriesId: $eventSeriesId
      copiedFromEventSlugOrId: $copiedFromEventSlugOrId
    ) {
      eventId
      eventType
      displayName
      expiresAt
      status
      location {
        locationName
        longitude
        latitude
        address
        region
        city
        postalCode
        countryCode
        isOnlyVisibleToApprovedAttendees
      }
      isPrivate
      uploadedAssetId
      avatarUrl
      minimumRepScore
      optInShowGuestList
      optInShowGuestCount
      slug
      optInDisplayRepScore
      optInAllowGuestInviteOthers
      optInLocationRadius
      locationRadius {
        address
        isActive
        latitude
        longitude
        radius
        unitLengthType
      }
      optInAgeLimit
      ageLimit
      optInDisclosureOrPrivacyPolicy
      disclosureOrPrivacyPolicyTitle
      disclosureOrPrivacyPolicyFileUrl
      optInSocialAccountRequirements
      socialAccountRequirements {
        scheme
        isRequired
      }
      requireSocialAccountConnection
      optInQuestionRequirements
      questionRequirements {
        question
        isRequired
      }
      isFeatured
      description
      note
      startDate
      endDate
      timeZone
      isAllInPricing
      clubId
    }
  }
}
    `;
export type CreateRecurringEventMutationFn = Apollo.MutationFunction<CreateRecurringEventMutation, CreateRecurringEventMutationVariables>;

/**
 * __useCreateRecurringEventMutation__
 *
 * To run a mutation, you first call `useCreateRecurringEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringEventMutation, { data, loading, error }] = useCreateRecurringEventMutation({
 *   variables: {
 *      eventType: // value for 'eventType'
 *      slug: // value for 'slug'
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      note: // value for 'note'
 *      avatarUrl: // value for 'avatarUrl'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      coHostUserIds: // value for 'coHostUserIds'
 *      promoterUserIds: // value for 'promoterUserIds'
 *      sponsorUserIds: // value for 'sponsorUserIds'
 *      doorUserIds: // value for 'doorUserIds'
 *      coordinatorUserIds: // value for 'coordinatorUserIds'
 *      talentUserIds: // value for 'talentUserIds'
 *      talentOrder: // value for 'talentOrder'
 *      location: // value for 'location'
 *      eventTickets: // value for 'eventTickets'
 *      invitations: // value for 'invitations'
 *      minimumRepScore: // value for 'minimumRepScore'
 *      optInShowGuestList: // value for 'optInShowGuestList'
 *      optInShowGuestCount: // value for 'optInShowGuestCount'
 *      optInAllowPublicEventPagePreview: // value for 'optInAllowPublicEventPagePreview'
 *      optInDisplayRepScore: // value for 'optInDisplayRepScore'
 *      optInAllowGuestInviteOthers: // value for 'optInAllowGuestInviteOthers'
 *      optInLocationRadius: // value for 'optInLocationRadius'
 *      locationRadius: // value for 'locationRadius'
 *      optInAgeLimit: // value for 'optInAgeLimit'
 *      ageLimit: // value for 'ageLimit'
 *      optInDisclosureOrPrivacyPolicy: // value for 'optInDisclosureOrPrivacyPolicy'
 *      disclosureOrPrivacyPolicyTitle: // value for 'disclosureOrPrivacyPolicyTitle'
 *      disclosureOrPrivacyPolicyFileUrl: // value for 'disclosureOrPrivacyPolicyFileUrl'
 *      optInSocialAccountRequirements: // value for 'optInSocialAccountRequirements'
 *      socialAccountRequirements: // value for 'socialAccountRequirements'
 *      requireSocialAccountConnection: // value for 'requireSocialAccountConnection'
 *      optInQuestionRequirements: // value for 'optInQuestionRequirements'
 *      questionRequirements: // value for 'questionRequirements'
 *      uploadedAssetId: // value for 'uploadedAssetId'
 *      isPrivate: // value for 'isPrivate'
 *      eventTimeZoneId: // value for 'eventTimeZoneId'
 *      isAllInPricing: // value for 'isAllInPricing'
 *      recurringInfo: // value for 'recurringInfo'
 *      scanningZones: // value for 'scanningZones'
 *      optInShowMusicEmbed: // value for 'optInShowMusicEmbed'
 *      musicEmbedUrl: // value for 'musicEmbedUrl'
 *      isListed: // value for 'isListed'
 *      ticketTermsPurchasePolicy: // value for 'ticketTermsPurchasePolicy'
 *      clubSlugOrId: // value for 'clubSlugOrId'
 *      eventSeriesId: // value for 'eventSeriesId'
 *      copiedFromEventSlugOrId: // value for 'copiedFromEventSlugOrId'
 *   },
 * });
 */
export function useCreateRecurringEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringEventMutation, CreateRecurringEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringEventMutation, CreateRecurringEventMutationVariables>(CreateRecurringEventDocument, options);
      }
export type CreateRecurringEventMutationHookResult = ReturnType<typeof useCreateRecurringEventMutation>;
export type CreateRecurringEventMutationResult = Apollo.MutationResult<CreateRecurringEventMutation>;
export type CreateRecurringEventMutationOptions = Apollo.BaseMutationOptions<CreateRecurringEventMutation, CreateRecurringEventMutationVariables>;
export const RsvpForEventDocument = gql`
    mutation RsvpForEvent($eventId: UUID!, $accept: Boolean!, $note: String, $questionRequirementAnswers: [QuestionRequirementAnswerInput!]) {
  event {
    rsvpForEvent(
      eventId: $eventId
      accept: $accept
      note: $note
      questionRequirementAnswers: $questionRequirementAnswers
    )
  }
}
    `;
export type RsvpForEventMutationFn = Apollo.MutationFunction<RsvpForEventMutation, RsvpForEventMutationVariables>;

/**
 * __useRsvpForEventMutation__
 *
 * To run a mutation, you first call `useRsvpForEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRsvpForEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rsvpForEventMutation, { data, loading, error }] = useRsvpForEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      accept: // value for 'accept'
 *      note: // value for 'note'
 *      questionRequirementAnswers: // value for 'questionRequirementAnswers'
 *   },
 * });
 */
export function useRsvpForEventMutation(baseOptions?: Apollo.MutationHookOptions<RsvpForEventMutation, RsvpForEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RsvpForEventMutation, RsvpForEventMutationVariables>(RsvpForEventDocument, options);
      }
export type RsvpForEventMutationHookResult = ReturnType<typeof useRsvpForEventMutation>;
export type RsvpForEventMutationResult = Apollo.MutationResult<RsvpForEventMutation>;
export type RsvpForEventMutationOptions = Apollo.BaseMutationOptions<RsvpForEventMutation, RsvpForEventMutationVariables>;
export const AnswerQuestionRequirementsDocument = gql`
    mutation AnswerQuestionRequirements($eventId: UUID!, $questionRequirementAnswers: [QuestionRequirementAnswerInput!]!) {
  event {
    answerQuestionRequirements(
      eventId: $eventId
      questionRequirementAnswers: $questionRequirementAnswers
    )
  }
}
    `;
export type AnswerQuestionRequirementsMutationFn = Apollo.MutationFunction<AnswerQuestionRequirementsMutation, AnswerQuestionRequirementsMutationVariables>;

/**
 * __useAnswerQuestionRequirementsMutation__
 *
 * To run a mutation, you first call `useAnswerQuestionRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerQuestionRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerQuestionRequirementsMutation, { data, loading, error }] = useAnswerQuestionRequirementsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      questionRequirementAnswers: // value for 'questionRequirementAnswers'
 *   },
 * });
 */
export function useAnswerQuestionRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<AnswerQuestionRequirementsMutation, AnswerQuestionRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerQuestionRequirementsMutation, AnswerQuestionRequirementsMutationVariables>(AnswerQuestionRequirementsDocument, options);
      }
export type AnswerQuestionRequirementsMutationHookResult = ReturnType<typeof useAnswerQuestionRequirementsMutation>;
export type AnswerQuestionRequirementsMutationResult = Apollo.MutationResult<AnswerQuestionRequirementsMutation>;
export type AnswerQuestionRequirementsMutationOptions = Apollo.BaseMutationOptions<AnswerQuestionRequirementsMutation, AnswerQuestionRequirementsMutationVariables>;
export const ApproveBookingDocument = gql`
    mutation ApproveBooking($eventId: UUID!, $transactionId: UUID, $note: String, $forceRelease: Boolean!, $filterArgs: DetailsAttendeeFilterArgsInput) {
  event {
    approve(
      eventId: $eventId
      transactionId: $transactionId
      note: $note
      forceRelease: $forceRelease
      filterArgs: $filterArgs
    )
  }
}
    `;
export type ApproveBookingMutationFn = Apollo.MutationFunction<ApproveBookingMutation, ApproveBookingMutationVariables>;

/**
 * __useApproveBookingMutation__
 *
 * To run a mutation, you first call `useApproveBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveBookingMutation, { data, loading, error }] = useApproveBookingMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      transactionId: // value for 'transactionId'
 *      note: // value for 'note'
 *      forceRelease: // value for 'forceRelease'
 *      filterArgs: // value for 'filterArgs'
 *   },
 * });
 */
export function useApproveBookingMutation(baseOptions?: Apollo.MutationHookOptions<ApproveBookingMutation, ApproveBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveBookingMutation, ApproveBookingMutationVariables>(ApproveBookingDocument, options);
      }
export type ApproveBookingMutationHookResult = ReturnType<typeof useApproveBookingMutation>;
export type ApproveBookingMutationResult = Apollo.MutationResult<ApproveBookingMutation>;
export type ApproveBookingMutationOptions = Apollo.BaseMutationOptions<ApproveBookingMutation, ApproveBookingMutationVariables>;
export const DeclineBookingDocument = gql`
    mutation DeclineBooking($eventId: UUID!, $transactionId: UUID, $note: String) {
  event {
    decline(eventId: $eventId, transactionId: $transactionId, note: $note)
  }
}
    `;
export type DeclineBookingMutationFn = Apollo.MutationFunction<DeclineBookingMutation, DeclineBookingMutationVariables>;

/**
 * __useDeclineBookingMutation__
 *
 * To run a mutation, you first call `useDeclineBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineBookingMutation, { data, loading, error }] = useDeclineBookingMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      transactionId: // value for 'transactionId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useDeclineBookingMutation(baseOptions?: Apollo.MutationHookOptions<DeclineBookingMutation, DeclineBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineBookingMutation, DeclineBookingMutationVariables>(DeclineBookingDocument, options);
      }
export type DeclineBookingMutationHookResult = ReturnType<typeof useDeclineBookingMutation>;
export type DeclineBookingMutationResult = Apollo.MutationResult<DeclineBookingMutation>;
export type DeclineBookingMutationOptions = Apollo.BaseMutationOptions<DeclineBookingMutation, DeclineBookingMutationVariables>;
export const PurchaseTicketDocument = gql`
    mutation PurchaseTicket($orderId: String!, $eventId: UUID!, $context: String, $contestEntry: Boolean, $orderReferenceId: String, $memberEventId: UUID) {
  eventTicket {
    purchaseTicket(
      orderId: $orderId
      eventId: $eventId
      context: $context
      contestEntry: $contestEntry
      orderReferenceId: $orderReferenceId
      memberEventId: $memberEventId
    ) {
      message
      success
    }
  }
}
    `;
export type PurchaseTicketMutationFn = Apollo.MutationFunction<PurchaseTicketMutation, PurchaseTicketMutationVariables>;

/**
 * __usePurchaseTicketMutation__
 *
 * To run a mutation, you first call `usePurchaseTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseTicketMutation, { data, loading, error }] = usePurchaseTicketMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      eventId: // value for 'eventId'
 *      context: // value for 'context'
 *      contestEntry: // value for 'contestEntry'
 *      orderReferenceId: // value for 'orderReferenceId'
 *      memberEventId: // value for 'memberEventId'
 *   },
 * });
 */
export function usePurchaseTicketMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseTicketMutation, PurchaseTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseTicketMutation, PurchaseTicketMutationVariables>(PurchaseTicketDocument, options);
      }
export type PurchaseTicketMutationHookResult = ReturnType<typeof usePurchaseTicketMutation>;
export type PurchaseTicketMutationResult = Apollo.MutationResult<PurchaseTicketMutation>;
export type PurchaseTicketMutationOptions = Apollo.BaseMutationOptions<PurchaseTicketMutation, PurchaseTicketMutationVariables>;
export const SaveGuestListDocument = gql`
    mutation SaveGuestList($guestList: SaveGuestListArgsInput!) {
  event {
    saveGuestList(guestList: $guestList)
  }
}
    `;
export type SaveGuestListMutationFn = Apollo.MutationFunction<SaveGuestListMutation, SaveGuestListMutationVariables>;

/**
 * __useSaveGuestListMutation__
 *
 * To run a mutation, you first call `useSaveGuestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGuestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGuestListMutation, { data, loading, error }] = useSaveGuestListMutation({
 *   variables: {
 *      guestList: // value for 'guestList'
 *   },
 * });
 */
export function useSaveGuestListMutation(baseOptions?: Apollo.MutationHookOptions<SaveGuestListMutation, SaveGuestListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGuestListMutation, SaveGuestListMutationVariables>(SaveGuestListDocument, options);
      }
export type SaveGuestListMutationHookResult = ReturnType<typeof useSaveGuestListMutation>;
export type SaveGuestListMutationResult = Apollo.MutationResult<SaveGuestListMutation>;
export type SaveGuestListMutationOptions = Apollo.BaseMutationOptions<SaveGuestListMutation, SaveGuestListMutationVariables>;
export const RemoveSavedListDocument = gql`
    mutation RemoveSavedList($listName: String!) {
  event {
    removeGuestList(listName: $listName)
  }
}
    `;
export type RemoveSavedListMutationFn = Apollo.MutationFunction<RemoveSavedListMutation, RemoveSavedListMutationVariables>;

/**
 * __useRemoveSavedListMutation__
 *
 * To run a mutation, you first call `useRemoveSavedListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSavedListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSavedListMutation, { data, loading, error }] = useRemoveSavedListMutation({
 *   variables: {
 *      listName: // value for 'listName'
 *   },
 * });
 */
export function useRemoveSavedListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSavedListMutation, RemoveSavedListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSavedListMutation, RemoveSavedListMutationVariables>(RemoveSavedListDocument, options);
      }
export type RemoveSavedListMutationHookResult = ReturnType<typeof useRemoveSavedListMutation>;
export type RemoveSavedListMutationResult = Apollo.MutationResult<RemoveSavedListMutation>;
export type RemoveSavedListMutationOptions = Apollo.BaseMutationOptions<RemoveSavedListMutation, RemoveSavedListMutationVariables>;
export const ConfirmEventPrivacyPolicyDocument = gql`
    mutation ConfirmEventPrivacyPolicy($eventId: UUID!, $privacyPolicyState: EventPrivacyPolicyState!, $disclosureType: DisclosureType, $signatoryName: String, $signatureData: String, $memberEventId: UUID) {
  event {
    confirmEventPrivacyPolicy(
      eventId: $eventId
      privacyPolicyState: $privacyPolicyState
      disclosureType: $disclosureType
      signatoryName: $signatoryName
      signatureData: $signatureData
      memberEventId: $memberEventId
    ) {
      referenceId
      signedDisclosureFileUrl
    }
  }
}
    `;
export type ConfirmEventPrivacyPolicyMutationFn = Apollo.MutationFunction<ConfirmEventPrivacyPolicyMutation, ConfirmEventPrivacyPolicyMutationVariables>;

/**
 * __useConfirmEventPrivacyPolicyMutation__
 *
 * To run a mutation, you first call `useConfirmEventPrivacyPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEventPrivacyPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEventPrivacyPolicyMutation, { data, loading, error }] = useConfirmEventPrivacyPolicyMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      privacyPolicyState: // value for 'privacyPolicyState'
 *      disclosureType: // value for 'disclosureType'
 *      signatoryName: // value for 'signatoryName'
 *      signatureData: // value for 'signatureData'
 *      memberEventId: // value for 'memberEventId'
 *   },
 * });
 */
export function useConfirmEventPrivacyPolicyMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmEventPrivacyPolicyMutation, ConfirmEventPrivacyPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmEventPrivacyPolicyMutation, ConfirmEventPrivacyPolicyMutationVariables>(ConfirmEventPrivacyPolicyDocument, options);
      }
export type ConfirmEventPrivacyPolicyMutationHookResult = ReturnType<typeof useConfirmEventPrivacyPolicyMutation>;
export type ConfirmEventPrivacyPolicyMutationResult = Apollo.MutationResult<ConfirmEventPrivacyPolicyMutation>;
export type ConfirmEventPrivacyPolicyMutationOptions = Apollo.BaseMutationOptions<ConfirmEventPrivacyPolicyMutation, ConfirmEventPrivacyPolicyMutationVariables>;
export const SendEventMessageGroupDocument = gql`
    mutation SendEventMessageGroup($eventId: UUID!, $isViaEmail: Boolean!, $isViaSms: Boolean!, $message: String!, $smsMessage: String, $filterArgs: EventMessageFilterArgsInput) {
  event {
    sendMessageGroup(
      eventId: $eventId
      isViaEmail: $isViaEmail
      isViaSms: $isViaSms
      message: $message
      smsMessage: $smsMessage
      filterArgs: $filterArgs
    )
  }
}
    `;
export type SendEventMessageGroupMutationFn = Apollo.MutationFunction<SendEventMessageGroupMutation, SendEventMessageGroupMutationVariables>;

/**
 * __useSendEventMessageGroupMutation__
 *
 * To run a mutation, you first call `useSendEventMessageGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEventMessageGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEventMessageGroupMutation, { data, loading, error }] = useSendEventMessageGroupMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      isViaEmail: // value for 'isViaEmail'
 *      isViaSms: // value for 'isViaSms'
 *      message: // value for 'message'
 *      smsMessage: // value for 'smsMessage'
 *      filterArgs: // value for 'filterArgs'
 *   },
 * });
 */
export function useSendEventMessageGroupMutation(baseOptions?: Apollo.MutationHookOptions<SendEventMessageGroupMutation, SendEventMessageGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEventMessageGroupMutation, SendEventMessageGroupMutationVariables>(SendEventMessageGroupDocument, options);
      }
export type SendEventMessageGroupMutationHookResult = ReturnType<typeof useSendEventMessageGroupMutation>;
export type SendEventMessageGroupMutationResult = Apollo.MutationResult<SendEventMessageGroupMutation>;
export type SendEventMessageGroupMutationOptions = Apollo.BaseMutationOptions<SendEventMessageGroupMutation, SendEventMessageGroupMutationVariables>;
export const ScheduleEventMessageDocument = gql`
    mutation ScheduleEventMessage($eventId: UUID!, $input: ScheduleEventMessageInput!) {
  event {
    scheduleEventMessage(eventId: $eventId, input: $input) {
      id
      message
      smsMessage
      sendAt
      isViaEmail
      isViaSms
      filterArgs {
        eventMessageType
        eventTicketIds
        eventAttendeeRoles
        attendeeStatuses
      }
      status
      createdBy
      createdAt
      sentAt
      canceledAt
      canceledBy
      updatedAt
      updatedBy
    }
  }
}
    `;
export type ScheduleEventMessageMutationFn = Apollo.MutationFunction<ScheduleEventMessageMutation, ScheduleEventMessageMutationVariables>;

/**
 * __useScheduleEventMessageMutation__
 *
 * To run a mutation, you first call `useScheduleEventMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleEventMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleEventMessageMutation, { data, loading, error }] = useScheduleEventMessageMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleEventMessageMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleEventMessageMutation, ScheduleEventMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleEventMessageMutation, ScheduleEventMessageMutationVariables>(ScheduleEventMessageDocument, options);
      }
export type ScheduleEventMessageMutationHookResult = ReturnType<typeof useScheduleEventMessageMutation>;
export type ScheduleEventMessageMutationResult = Apollo.MutationResult<ScheduleEventMessageMutation>;
export type ScheduleEventMessageMutationOptions = Apollo.BaseMutationOptions<ScheduleEventMessageMutation, ScheduleEventMessageMutationVariables>;
export const UpdateScheduledEventMessageDocument = gql`
    mutation UpdateScheduledEventMessage($eventId: UUID!, $scheduledMessageId: UUID!, $input: ScheduleEventMessageInput!) {
  event {
    updateScheduledEventMessage(
      eventId: $eventId
      scheduledMessageId: $scheduledMessageId
      input: $input
    ) {
      id
      message
      smsMessage
      sendAt
      isViaEmail
      isViaSms
      filterArgs {
        eventMessageType
        eventTicketIds
        eventAttendeeRoles
        attendeeStatuses
      }
      status
      createdBy
      createdAt
      sentAt
      canceledAt
      canceledBy
      updatedAt
      updatedBy
    }
  }
}
    `;
export type UpdateScheduledEventMessageMutationFn = Apollo.MutationFunction<UpdateScheduledEventMessageMutation, UpdateScheduledEventMessageMutationVariables>;

/**
 * __useUpdateScheduledEventMessageMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledEventMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledEventMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledEventMessageMutation, { data, loading, error }] = useUpdateScheduledEventMessageMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      scheduledMessageId: // value for 'scheduledMessageId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduledEventMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledEventMessageMutation, UpdateScheduledEventMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledEventMessageMutation, UpdateScheduledEventMessageMutationVariables>(UpdateScheduledEventMessageDocument, options);
      }
export type UpdateScheduledEventMessageMutationHookResult = ReturnType<typeof useUpdateScheduledEventMessageMutation>;
export type UpdateScheduledEventMessageMutationResult = Apollo.MutationResult<UpdateScheduledEventMessageMutation>;
export type UpdateScheduledEventMessageMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledEventMessageMutation, UpdateScheduledEventMessageMutationVariables>;
export const CancelScheduledEventMessageDocument = gql`
    mutation CancelScheduledEventMessage($eventId: UUID!, $scheduledMessageId: UUID!) {
  event {
    cancelScheduledEventMessage(
      eventId: $eventId
      scheduledMessageId: $scheduledMessageId
    )
  }
}
    `;
export type CancelScheduledEventMessageMutationFn = Apollo.MutationFunction<CancelScheduledEventMessageMutation, CancelScheduledEventMessageMutationVariables>;

/**
 * __useCancelScheduledEventMessageMutation__
 *
 * To run a mutation, you first call `useCancelScheduledEventMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledEventMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledEventMessageMutation, { data, loading, error }] = useCancelScheduledEventMessageMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      scheduledMessageId: // value for 'scheduledMessageId'
 *   },
 * });
 */
export function useCancelScheduledEventMessageMutation(baseOptions?: Apollo.MutationHookOptions<CancelScheduledEventMessageMutation, CancelScheduledEventMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelScheduledEventMessageMutation, CancelScheduledEventMessageMutationVariables>(CancelScheduledEventMessageDocument, options);
      }
export type CancelScheduledEventMessageMutationHookResult = ReturnType<typeof useCancelScheduledEventMessageMutation>;
export type CancelScheduledEventMessageMutationResult = Apollo.MutationResult<CancelScheduledEventMessageMutation>;
export type CancelScheduledEventMessageMutationOptions = Apollo.BaseMutationOptions<CancelScheduledEventMessageMutation, CancelScheduledEventMessageMutationVariables>;
export const IncreaseMaxTicketsAmountDocument = gql`
    mutation IncreaseMaxTicketsAmount($eventId: UUID!, $args: [IncreaseTicketsAmountArgsInput!]!) {
  event {
    increaseMaxTicketsAmount(eventId: $eventId, args: $args)
  }
}
    `;
export type IncreaseMaxTicketsAmountMutationFn = Apollo.MutationFunction<IncreaseMaxTicketsAmountMutation, IncreaseMaxTicketsAmountMutationVariables>;

/**
 * __useIncreaseMaxTicketsAmountMutation__
 *
 * To run a mutation, you first call `useIncreaseMaxTicketsAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncreaseMaxTicketsAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [increaseMaxTicketsAmountMutation, { data, loading, error }] = useIncreaseMaxTicketsAmountMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      args: // value for 'args'
 *   },
 * });
 */
export function useIncreaseMaxTicketsAmountMutation(baseOptions?: Apollo.MutationHookOptions<IncreaseMaxTicketsAmountMutation, IncreaseMaxTicketsAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IncreaseMaxTicketsAmountMutation, IncreaseMaxTicketsAmountMutationVariables>(IncreaseMaxTicketsAmountDocument, options);
      }
export type IncreaseMaxTicketsAmountMutationHookResult = ReturnType<typeof useIncreaseMaxTicketsAmountMutation>;
export type IncreaseMaxTicketsAmountMutationResult = Apollo.MutationResult<IncreaseMaxTicketsAmountMutation>;
export type IncreaseMaxTicketsAmountMutationOptions = Apollo.BaseMutationOptions<IncreaseMaxTicketsAmountMutation, IncreaseMaxTicketsAmountMutationVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($eventId: UUID!) {
  event {
    delete(eventId: $eventId)
  }
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const DeleteEventTicketDocument = gql`
    mutation DeleteEventTicket($eventId: UUID!, $eventTicketId: UUID!) {
  event {
    deleteEventTicket(eventId: $eventId, eventTicketId: $eventTicketId)
  }
}
    `;
export type DeleteEventTicketMutationFn = Apollo.MutationFunction<DeleteEventTicketMutation, DeleteEventTicketMutationVariables>;

/**
 * __useDeleteEventTicketMutation__
 *
 * To run a mutation, you first call `useDeleteEventTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventTicketMutation, { data, loading, error }] = useDeleteEventTicketMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventTicketId: // value for 'eventTicketId'
 *   },
 * });
 */
export function useDeleteEventTicketMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventTicketMutation, DeleteEventTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventTicketMutation, DeleteEventTicketMutationVariables>(DeleteEventTicketDocument, options);
      }
export type DeleteEventTicketMutationHookResult = ReturnType<typeof useDeleteEventTicketMutation>;
export type DeleteEventTicketMutationResult = Apollo.MutationResult<DeleteEventTicketMutation>;
export type DeleteEventTicketMutationOptions = Apollo.BaseMutationOptions<DeleteEventTicketMutation, DeleteEventTicketMutationVariables>;
export const CommentEventDocument = gql`
    mutation CommentEvent($eventId: UUID!, $content: String!, $parentCommentId: UUID, $medias: [String!]) {
  event {
    comment(
      eventId: $eventId
      content: $content
      parentCommentId: $parentCommentId
      medias: $medias
    ) {
      commentId
      createdAt
    }
  }
}
    `;
export type CommentEventMutationFn = Apollo.MutationFunction<CommentEventMutation, CommentEventMutationVariables>;

/**
 * __useCommentEventMutation__
 *
 * To run a mutation, you first call `useCommentEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentEventMutation, { data, loading, error }] = useCommentEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      content: // value for 'content'
 *      parentCommentId: // value for 'parentCommentId'
 *      medias: // value for 'medias'
 *   },
 * });
 */
export function useCommentEventMutation(baseOptions?: Apollo.MutationHookOptions<CommentEventMutation, CommentEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommentEventMutation, CommentEventMutationVariables>(CommentEventDocument, options);
      }
export type CommentEventMutationHookResult = ReturnType<typeof useCommentEventMutation>;
export type CommentEventMutationResult = Apollo.MutationResult<CommentEventMutation>;
export type CommentEventMutationOptions = Apollo.BaseMutationOptions<CommentEventMutation, CommentEventMutationVariables>;
export const ReactEventCommentDocument = gql`
    mutation ReactEventComment($eventId: UUID!, $commentId: UUID!, $reaction: String!) {
  event {
    reactComment(eventId: $eventId, commentId: $commentId, reaction: $reaction) {
      reactionId
    }
  }
}
    `;
export type ReactEventCommentMutationFn = Apollo.MutationFunction<ReactEventCommentMutation, ReactEventCommentMutationVariables>;

/**
 * __useReactEventCommentMutation__
 *
 * To run a mutation, you first call `useReactEventCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactEventCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactEventCommentMutation, { data, loading, error }] = useReactEventCommentMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      commentId: // value for 'commentId'
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useReactEventCommentMutation(baseOptions?: Apollo.MutationHookOptions<ReactEventCommentMutation, ReactEventCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactEventCommentMutation, ReactEventCommentMutationVariables>(ReactEventCommentDocument, options);
      }
export type ReactEventCommentMutationHookResult = ReturnType<typeof useReactEventCommentMutation>;
export type ReactEventCommentMutationResult = Apollo.MutationResult<ReactEventCommentMutation>;
export type ReactEventCommentMutationOptions = Apollo.BaseMutationOptions<ReactEventCommentMutation, ReactEventCommentMutationVariables>;
export const RemoveCommentReactionDocument = gql`
    mutation RemoveCommentReaction($eventId: UUID!, $commentId: UUID!, $reactionId: UUID!) {
  event {
    removeCommentReaction(
      eventId: $eventId
      commentId: $commentId
      reactionId: $reactionId
    )
  }
}
    `;
export type RemoveCommentReactionMutationFn = Apollo.MutationFunction<RemoveCommentReactionMutation, RemoveCommentReactionMutationVariables>;

/**
 * __useRemoveCommentReactionMutation__
 *
 * To run a mutation, you first call `useRemoveCommentReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommentReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommentReactionMutation, { data, loading, error }] = useRemoveCommentReactionMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      commentId: // value for 'commentId'
 *      reactionId: // value for 'reactionId'
 *   },
 * });
 */
export function useRemoveCommentReactionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCommentReactionMutation, RemoveCommentReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCommentReactionMutation, RemoveCommentReactionMutationVariables>(RemoveCommentReactionDocument, options);
      }
export type RemoveCommentReactionMutationHookResult = ReturnType<typeof useRemoveCommentReactionMutation>;
export type RemoveCommentReactionMutationResult = Apollo.MutationResult<RemoveCommentReactionMutation>;
export type RemoveCommentReactionMutationOptions = Apollo.BaseMutationOptions<RemoveCommentReactionMutation, RemoveCommentReactionMutationVariables>;
export const InviteFromContactsDocument = gql`
    mutation InviteFromContacts($eventId: UUID!, $inviteAll: Boolean!, $contactIds: [UUID!], $giftTicketsArgs: GiftTicketsArgsInput, $privateTicketsArgs: PrivateTicketsArgsInput, $contactPageFilterArgs: ContactPageFilterArgsInput, $invitationMessage: String, $confirmedDoNotResendContactIds: [UUID!], $confirmedResendContactIds: [UUID!], $ignoreExistingAttendees: Boolean!, $isViaSms: Boolean!) {
  event {
    inviteFromContacts2(
      eventId: $eventId
      inviteAll: $inviteAll
      contactIds: $contactIds
      giftTicketsArgs: $giftTicketsArgs
      privateTicketsArgs: $privateTicketsArgs
      contactPageFilterArgs: $contactPageFilterArgs
      invitationMessage: $invitationMessage
      confirmedDoNotResendContactIds: $confirmedDoNotResendContactIds
      confirmedResendContactIds: $confirmedResendContactIds
      ignoreExistingAttendees: $ignoreExistingAttendees
      isViaSms: $isViaSms
    ) {
      submittedContacts
      sentContacts
      resentContacts
      confirmingContacts {
        invitee {
          contactId
          emailAddress
          name
          phoneNumber
          userId
          userInfo {
            name
            userName
          }
        }
        inviter {
          name
          userId
          userName
        }
      }
      success
    }
  }
}
    `;
export type InviteFromContactsMutationFn = Apollo.MutationFunction<InviteFromContactsMutation, InviteFromContactsMutationVariables>;

/**
 * __useInviteFromContactsMutation__
 *
 * To run a mutation, you first call `useInviteFromContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteFromContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteFromContactsMutation, { data, loading, error }] = useInviteFromContactsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      inviteAll: // value for 'inviteAll'
 *      contactIds: // value for 'contactIds'
 *      giftTicketsArgs: // value for 'giftTicketsArgs'
 *      privateTicketsArgs: // value for 'privateTicketsArgs'
 *      contactPageFilterArgs: // value for 'contactPageFilterArgs'
 *      invitationMessage: // value for 'invitationMessage'
 *      confirmedDoNotResendContactIds: // value for 'confirmedDoNotResendContactIds'
 *      confirmedResendContactIds: // value for 'confirmedResendContactIds'
 *      ignoreExistingAttendees: // value for 'ignoreExistingAttendees'
 *      isViaSms: // value for 'isViaSms'
 *   },
 * });
 */
export function useInviteFromContactsMutation(baseOptions?: Apollo.MutationHookOptions<InviteFromContactsMutation, InviteFromContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteFromContactsMutation, InviteFromContactsMutationVariables>(InviteFromContactsDocument, options);
      }
export type InviteFromContactsMutationHookResult = ReturnType<typeof useInviteFromContactsMutation>;
export type InviteFromContactsMutationResult = Apollo.MutationResult<InviteFromContactsMutation>;
export type InviteFromContactsMutationOptions = Apollo.BaseMutationOptions<InviteFromContactsMutation, InviteFromContactsMutationVariables>;
export const StartBulkInviteDocument = gql`
    mutation StartBulkInvite($eventId: UUID!, $inviteAll: Boolean!, $contactIds: [UUID!], $giftTicketsArgs: GiftTicketsArgsInput, $privateTicketsArgs: PrivateTicketsArgsInput, $contactPageFilterArgs: ContactPageFilterArgsInput, $invitationMessage: String, $smsMessage: String, $includeAlreadyInvited: Boolean!, $isViaSms: Boolean!) {
  event {
    startBulkInvite(
      eventId: $eventId
      inviteAll: $inviteAll
      contactIds: $contactIds
      giftTicketsArgs: $giftTicketsArgs
      privateTicketsArgs: $privateTicketsArgs
      contactPageFilterArgs: $contactPageFilterArgs
      invitationMessage: $invitationMessage
      smsMessage: $smsMessage
      includeAlreadyInvited: $includeAlreadyInvited
      isViaSms: $isViaSms
    )
  }
}
    `;
export type StartBulkInviteMutationFn = Apollo.MutationFunction<StartBulkInviteMutation, StartBulkInviteMutationVariables>;

/**
 * __useStartBulkInviteMutation__
 *
 * To run a mutation, you first call `useStartBulkInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBulkInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBulkInviteMutation, { data, loading, error }] = useStartBulkInviteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      inviteAll: // value for 'inviteAll'
 *      contactIds: // value for 'contactIds'
 *      giftTicketsArgs: // value for 'giftTicketsArgs'
 *      privateTicketsArgs: // value for 'privateTicketsArgs'
 *      contactPageFilterArgs: // value for 'contactPageFilterArgs'
 *      invitationMessage: // value for 'invitationMessage'
 *      smsMessage: // value for 'smsMessage'
 *      includeAlreadyInvited: // value for 'includeAlreadyInvited'
 *      isViaSms: // value for 'isViaSms'
 *   },
 * });
 */
export function useStartBulkInviteMutation(baseOptions?: Apollo.MutationHookOptions<StartBulkInviteMutation, StartBulkInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartBulkInviteMutation, StartBulkInviteMutationVariables>(StartBulkInviteDocument, options);
      }
export type StartBulkInviteMutationHookResult = ReturnType<typeof useStartBulkInviteMutation>;
export type StartBulkInviteMutationResult = Apollo.MutationResult<StartBulkInviteMutation>;
export type StartBulkInviteMutationOptions = Apollo.BaseMutationOptions<StartBulkInviteMutation, StartBulkInviteMutationVariables>;
export const ConnectSocialNetworkToEventDocument = gql`
    mutation ConnectSocialNetworkToEvent($eventId: UUID!, $scheme: String!) {
  event {
    connectSocialAccount(eventId: $eventId, scheme: $scheme)
  }
}
    `;
export type ConnectSocialNetworkToEventMutationFn = Apollo.MutationFunction<ConnectSocialNetworkToEventMutation, ConnectSocialNetworkToEventMutationVariables>;

/**
 * __useConnectSocialNetworkToEventMutation__
 *
 * To run a mutation, you first call `useConnectSocialNetworkToEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectSocialNetworkToEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectSocialNetworkToEventMutation, { data, loading, error }] = useConnectSocialNetworkToEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      scheme: // value for 'scheme'
 *   },
 * });
 */
export function useConnectSocialNetworkToEventMutation(baseOptions?: Apollo.MutationHookOptions<ConnectSocialNetworkToEventMutation, ConnectSocialNetworkToEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectSocialNetworkToEventMutation, ConnectSocialNetworkToEventMutationVariables>(ConnectSocialNetworkToEventDocument, options);
      }
export type ConnectSocialNetworkToEventMutationHookResult = ReturnType<typeof useConnectSocialNetworkToEventMutation>;
export type ConnectSocialNetworkToEventMutationResult = Apollo.MutationResult<ConnectSocialNetworkToEventMutation>;
export type ConnectSocialNetworkToEventMutationOptions = Apollo.BaseMutationOptions<ConnectSocialNetworkToEventMutation, ConnectSocialNetworkToEventMutationVariables>;
export const UndoFreeTicketApprovalDocument = gql`
    mutation UndoFreeTicketApproval($transactionId: UUID!, $eventId: UUID!) {
  event {
    undoFreeTicketApproval(transactionId: $transactionId, eventId: $eventId)
  }
}
    `;
export type UndoFreeTicketApprovalMutationFn = Apollo.MutationFunction<UndoFreeTicketApprovalMutation, UndoFreeTicketApprovalMutationVariables>;

/**
 * __useUndoFreeTicketApprovalMutation__
 *
 * To run a mutation, you first call `useUndoFreeTicketApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoFreeTicketApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoFreeTicketApprovalMutation, { data, loading, error }] = useUndoFreeTicketApprovalMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useUndoFreeTicketApprovalMutation(baseOptions?: Apollo.MutationHookOptions<UndoFreeTicketApprovalMutation, UndoFreeTicketApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndoFreeTicketApprovalMutation, UndoFreeTicketApprovalMutationVariables>(UndoFreeTicketApprovalDocument, options);
      }
export type UndoFreeTicketApprovalMutationHookResult = ReturnType<typeof useUndoFreeTicketApprovalMutation>;
export type UndoFreeTicketApprovalMutationResult = Apollo.MutationResult<UndoFreeTicketApprovalMutation>;
export type UndoFreeTicketApprovalMutationOptions = Apollo.BaseMutationOptions<UndoFreeTicketApprovalMutation, UndoFreeTicketApprovalMutationVariables>;
export const AddDoorRoleDocument = gql`
    mutation AddDoorRole($eventId: UUID!, $userId: UUID!) {
  event {
    addDoorRole(eventId: $eventId, userId: $userId)
  }
}
    `;
export type AddDoorRoleMutationFn = Apollo.MutationFunction<AddDoorRoleMutation, AddDoorRoleMutationVariables>;

/**
 * __useAddDoorRoleMutation__
 *
 * To run a mutation, you first call `useAddDoorRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDoorRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDoorRoleMutation, { data, loading, error }] = useAddDoorRoleMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddDoorRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddDoorRoleMutation, AddDoorRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDoorRoleMutation, AddDoorRoleMutationVariables>(AddDoorRoleDocument, options);
      }
export type AddDoorRoleMutationHookResult = ReturnType<typeof useAddDoorRoleMutation>;
export type AddDoorRoleMutationResult = Apollo.MutationResult<AddDoorRoleMutation>;
export type AddDoorRoleMutationOptions = Apollo.BaseMutationOptions<AddDoorRoleMutation, AddDoorRoleMutationVariables>;
export const RemoveDoorRoleDocument = gql`
    mutation RemoveDoorRole($userId: UUID!, $eventId: UUID!) {
  event {
    removeDoorRole(userId: $userId, eventId: $eventId)
  }
}
    `;
export type RemoveDoorRoleMutationFn = Apollo.MutationFunction<RemoveDoorRoleMutation, RemoveDoorRoleMutationVariables>;

/**
 * __useRemoveDoorRoleMutation__
 *
 * To run a mutation, you first call `useRemoveDoorRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDoorRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDoorRoleMutation, { data, loading, error }] = useRemoveDoorRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useRemoveDoorRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDoorRoleMutation, RemoveDoorRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDoorRoleMutation, RemoveDoorRoleMutationVariables>(RemoveDoorRoleDocument, options);
      }
export type RemoveDoorRoleMutationHookResult = ReturnType<typeof useRemoveDoorRoleMutation>;
export type RemoveDoorRoleMutationResult = Apollo.MutationResult<RemoveDoorRoleMutation>;
export type RemoveDoorRoleMutationOptions = Apollo.BaseMutationOptions<RemoveDoorRoleMutation, RemoveDoorRoleMutationVariables>;
export const VerifyTicketDocument = gql`
    mutation VerifyTicket($eventId: UUID!, $ticketId: String!, $scanningZoneId: UUID!) {
  event {
    verifyTicket(
      eventId: $eventId
      ticketId: $ticketId
      scanningZoneId: $scanningZoneId
    ) {
      status
      scanCount
      firstSeen
      ticketId
      message
    }
  }
}
    `;
export type VerifyTicketMutationFn = Apollo.MutationFunction<VerifyTicketMutation, VerifyTicketMutationVariables>;

/**
 * __useVerifyTicketMutation__
 *
 * To run a mutation, you first call `useVerifyTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTicketMutation, { data, loading, error }] = useVerifyTicketMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      ticketId: // value for 'ticketId'
 *      scanningZoneId: // value for 'scanningZoneId'
 *   },
 * });
 */
export function useVerifyTicketMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTicketMutation, VerifyTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyTicketMutation, VerifyTicketMutationVariables>(VerifyTicketDocument, options);
      }
export type VerifyTicketMutationHookResult = ReturnType<typeof useVerifyTicketMutation>;
export type VerifyTicketMutationResult = Apollo.MutationResult<VerifyTicketMutation>;
export type VerifyTicketMutationOptions = Apollo.BaseMutationOptions<VerifyTicketMutation, VerifyTicketMutationVariables>;
export const AddAttendeeRoleDocument = gql`
    mutation AddAttendeeRole($attendeeRole: EventAttendeeRole!, $eventId: UUID!, $userId: UUID!) {
  event {
    addAttendeeRole(attendeeRole: $attendeeRole, eventId: $eventId, userId: $userId)
  }
}
    `;
export type AddAttendeeRoleMutationFn = Apollo.MutationFunction<AddAttendeeRoleMutation, AddAttendeeRoleMutationVariables>;

/**
 * __useAddAttendeeRoleMutation__
 *
 * To run a mutation, you first call `useAddAttendeeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttendeeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttendeeRoleMutation, { data, loading, error }] = useAddAttendeeRoleMutation({
 *   variables: {
 *      attendeeRole: // value for 'attendeeRole'
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddAttendeeRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddAttendeeRoleMutation, AddAttendeeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAttendeeRoleMutation, AddAttendeeRoleMutationVariables>(AddAttendeeRoleDocument, options);
      }
export type AddAttendeeRoleMutationHookResult = ReturnType<typeof useAddAttendeeRoleMutation>;
export type AddAttendeeRoleMutationResult = Apollo.MutationResult<AddAttendeeRoleMutation>;
export type AddAttendeeRoleMutationOptions = Apollo.BaseMutationOptions<AddAttendeeRoleMutation, AddAttendeeRoleMutationVariables>;
export const AddCoHostDocument = gql`
    mutation AddCoHost($eventId: UUID!, $userId: UUID!) {
  event {
    addCoHost(eventId: $eventId, userId: $userId)
  }
}
    `;
export type AddCoHostMutationFn = Apollo.MutationFunction<AddCoHostMutation, AddCoHostMutationVariables>;

/**
 * __useAddCoHostMutation__
 *
 * To run a mutation, you first call `useAddCoHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCoHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCoHostMutation, { data, loading, error }] = useAddCoHostMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddCoHostMutation(baseOptions?: Apollo.MutationHookOptions<AddCoHostMutation, AddCoHostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCoHostMutation, AddCoHostMutationVariables>(AddCoHostDocument, options);
      }
export type AddCoHostMutationHookResult = ReturnType<typeof useAddCoHostMutation>;
export type AddCoHostMutationResult = Apollo.MutationResult<AddCoHostMutation>;
export type AddCoHostMutationOptions = Apollo.BaseMutationOptions<AddCoHostMutation, AddCoHostMutationVariables>;
export const AddPromoterDocument = gql`
    mutation AddPromoter($eventId: UUID!, $userId: UUID!) {
  event {
    addPromoter(eventId: $eventId, userId: $userId)
  }
}
    `;
export type AddPromoterMutationFn = Apollo.MutationFunction<AddPromoterMutation, AddPromoterMutationVariables>;

/**
 * __useAddPromoterMutation__
 *
 * To run a mutation, you first call `useAddPromoterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPromoterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPromoterMutation, { data, loading, error }] = useAddPromoterMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddPromoterMutation(baseOptions?: Apollo.MutationHookOptions<AddPromoterMutation, AddPromoterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPromoterMutation, AddPromoterMutationVariables>(AddPromoterDocument, options);
      }
export type AddPromoterMutationHookResult = ReturnType<typeof useAddPromoterMutation>;
export type AddPromoterMutationResult = Apollo.MutationResult<AddPromoterMutation>;
export type AddPromoterMutationOptions = Apollo.BaseMutationOptions<AddPromoterMutation, AddPromoterMutationVariables>;
export const RemoveAttendeeRoleDocument = gql`
    mutation RemoveAttendeeRole($attendeeRole: EventAttendeeRole!, $eventId: UUID!, $userId: UUID!) {
  event {
    removeAttendeeRole(
      attendeeRole: $attendeeRole
      eventId: $eventId
      userId: $userId
    )
  }
}
    `;
export type RemoveAttendeeRoleMutationFn = Apollo.MutationFunction<RemoveAttendeeRoleMutation, RemoveAttendeeRoleMutationVariables>;

/**
 * __useRemoveAttendeeRoleMutation__
 *
 * To run a mutation, you first call `useRemoveAttendeeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttendeeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAttendeeRoleMutation, { data, loading, error }] = useRemoveAttendeeRoleMutation({
 *   variables: {
 *      attendeeRole: // value for 'attendeeRole'
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveAttendeeRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAttendeeRoleMutation, RemoveAttendeeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAttendeeRoleMutation, RemoveAttendeeRoleMutationVariables>(RemoveAttendeeRoleDocument, options);
      }
export type RemoveAttendeeRoleMutationHookResult = ReturnType<typeof useRemoveAttendeeRoleMutation>;
export type RemoveAttendeeRoleMutationResult = Apollo.MutationResult<RemoveAttendeeRoleMutation>;
export type RemoveAttendeeRoleMutationOptions = Apollo.BaseMutationOptions<RemoveAttendeeRoleMutation, RemoveAttendeeRoleMutationVariables>;
export const RemoveCoHostDocument = gql`
    mutation RemoveCoHost($eventId: UUID!, $userId: UUID!) {
  event {
    removeCoHost(eventId: $eventId, userId: $userId)
  }
}
    `;
export type RemoveCoHostMutationFn = Apollo.MutationFunction<RemoveCoHostMutation, RemoveCoHostMutationVariables>;

/**
 * __useRemoveCoHostMutation__
 *
 * To run a mutation, you first call `useRemoveCoHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCoHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCoHostMutation, { data, loading, error }] = useRemoveCoHostMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveCoHostMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCoHostMutation, RemoveCoHostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCoHostMutation, RemoveCoHostMutationVariables>(RemoveCoHostDocument, options);
      }
export type RemoveCoHostMutationHookResult = ReturnType<typeof useRemoveCoHostMutation>;
export type RemoveCoHostMutationResult = Apollo.MutationResult<RemoveCoHostMutation>;
export type RemoveCoHostMutationOptions = Apollo.BaseMutationOptions<RemoveCoHostMutation, RemoveCoHostMutationVariables>;
export const RemovePromoterDocument = gql`
    mutation RemovePromoter($eventId: UUID!, $userId: UUID!) {
  event {
    removePromoter(eventId: $eventId, userId: $userId)
  }
}
    `;
export type RemovePromoterMutationFn = Apollo.MutationFunction<RemovePromoterMutation, RemovePromoterMutationVariables>;

/**
 * __useRemovePromoterMutation__
 *
 * To run a mutation, you first call `useRemovePromoterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePromoterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePromoterMutation, { data, loading, error }] = useRemovePromoterMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemovePromoterMutation(baseOptions?: Apollo.MutationHookOptions<RemovePromoterMutation, RemovePromoterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePromoterMutation, RemovePromoterMutationVariables>(RemovePromoterDocument, options);
      }
export type RemovePromoterMutationHookResult = ReturnType<typeof useRemovePromoterMutation>;
export type RemovePromoterMutationResult = Apollo.MutationResult<RemovePromoterMutation>;
export type RemovePromoterMutationOptions = Apollo.BaseMutationOptions<RemovePromoterMutation, RemovePromoterMutationVariables>;
export const GrantTicketsDocument = gql`
    mutation GrantTickets($eventId: UUID!, $receiverId: UUID!, $totalRequestTickets: Int!, $ticketId: UUID!) {
  event {
    grantTickets(
      eventId: $eventId
      receiverId: $receiverId
      totalRequestTickets: $totalRequestTickets
      ticketId: $ticketId
    )
  }
}
    `;
export type GrantTicketsMutationFn = Apollo.MutationFunction<GrantTicketsMutation, GrantTicketsMutationVariables>;

/**
 * __useGrantTicketsMutation__
 *
 * To run a mutation, you first call `useGrantTicketsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantTicketsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantTicketsMutation, { data, loading, error }] = useGrantTicketsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      receiverId: // value for 'receiverId'
 *      totalRequestTickets: // value for 'totalRequestTickets'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGrantTicketsMutation(baseOptions?: Apollo.MutationHookOptions<GrantTicketsMutation, GrantTicketsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantTicketsMutation, GrantTicketsMutationVariables>(GrantTicketsDocument, options);
      }
export type GrantTicketsMutationHookResult = ReturnType<typeof useGrantTicketsMutation>;
export type GrantTicketsMutationResult = Apollo.MutationResult<GrantTicketsMutation>;
export type GrantTicketsMutationOptions = Apollo.BaseMutationOptions<GrantTicketsMutation, GrantTicketsMutationVariables>;
export const ApproveAttendeeDocument = gql`
    mutation ApproveAttendee($attendeeId: UUID!, $eventId: UUID!, $forceRelease: Boolean!, $note: String) {
  event {
    approveAttendee(
      attendeeId: $attendeeId
      eventId: $eventId
      forceRelease: $forceRelease
      note: $note
    ) {
      failedReasons
      result
      totalFailedBookings
      totalProcessedBookings
      totalProcessingBookings
      totalSkippedBookings
    }
  }
}
    `;
export type ApproveAttendeeMutationFn = Apollo.MutationFunction<ApproveAttendeeMutation, ApproveAttendeeMutationVariables>;

/**
 * __useApproveAttendeeMutation__
 *
 * To run a mutation, you first call `useApproveAttendeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAttendeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAttendeeMutation, { data, loading, error }] = useApproveAttendeeMutation({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      eventId: // value for 'eventId'
 *      forceRelease: // value for 'forceRelease'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useApproveAttendeeMutation(baseOptions?: Apollo.MutationHookOptions<ApproveAttendeeMutation, ApproveAttendeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveAttendeeMutation, ApproveAttendeeMutationVariables>(ApproveAttendeeDocument, options);
      }
export type ApproveAttendeeMutationHookResult = ReturnType<typeof useApproveAttendeeMutation>;
export type ApproveAttendeeMutationResult = Apollo.MutationResult<ApproveAttendeeMutation>;
export type ApproveAttendeeMutationOptions = Apollo.BaseMutationOptions<ApproveAttendeeMutation, ApproveAttendeeMutationVariables>;
export const DeclineAttendeeDocument = gql`
    mutation DeclineAttendee($attendeeId: UUID!, $eventId: UUID!, $note: String) {
  event {
    declineAttendee(attendeeId: $attendeeId, eventId: $eventId, note: $note) {
      failedReasons
      result
      totalFailedBookings
      totalProcessedBookings
      totalProcessingBookings
      totalSkippedBookings
    }
  }
}
    `;
export type DeclineAttendeeMutationFn = Apollo.MutationFunction<DeclineAttendeeMutation, DeclineAttendeeMutationVariables>;

/**
 * __useDeclineAttendeeMutation__
 *
 * To run a mutation, you first call `useDeclineAttendeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineAttendeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineAttendeeMutation, { data, loading, error }] = useDeclineAttendeeMutation({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      eventId: // value for 'eventId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useDeclineAttendeeMutation(baseOptions?: Apollo.MutationHookOptions<DeclineAttendeeMutation, DeclineAttendeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineAttendeeMutation, DeclineAttendeeMutationVariables>(DeclineAttendeeDocument, options);
      }
export type DeclineAttendeeMutationHookResult = ReturnType<typeof useDeclineAttendeeMutation>;
export type DeclineAttendeeMutationResult = Apollo.MutationResult<DeclineAttendeeMutation>;
export type DeclineAttendeeMutationOptions = Apollo.BaseMutationOptions<DeclineAttendeeMutation, DeclineAttendeeMutationVariables>;
export const UndoAttendeeDocument = gql`
    mutation UndoAttendee($attendeeId: UUID!, $eventId: UUID!, $note: String) {
  event {
    undoAttendee(attendeeId: $attendeeId, eventId: $eventId, note: $note) {
      failedReasons
      result
      totalFailedBookings
      totalProcessedBookings
      totalProcessingBookings
      totalSkippedBookings
    }
  }
}
    `;
export type UndoAttendeeMutationFn = Apollo.MutationFunction<UndoAttendeeMutation, UndoAttendeeMutationVariables>;

/**
 * __useUndoAttendeeMutation__
 *
 * To run a mutation, you first call `useUndoAttendeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoAttendeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoAttendeeMutation, { data, loading, error }] = useUndoAttendeeMutation({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      eventId: // value for 'eventId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUndoAttendeeMutation(baseOptions?: Apollo.MutationHookOptions<UndoAttendeeMutation, UndoAttendeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndoAttendeeMutation, UndoAttendeeMutationVariables>(UndoAttendeeDocument, options);
      }
export type UndoAttendeeMutationHookResult = ReturnType<typeof useUndoAttendeeMutation>;
export type UndoAttendeeMutationResult = Apollo.MutationResult<UndoAttendeeMutation>;
export type UndoAttendeeMutationOptions = Apollo.BaseMutationOptions<UndoAttendeeMutation, UndoAttendeeMutationVariables>;
export const DeleteFreeTicketDocument = gql`
    mutation DeleteFreeTicket($eventId: UUID!, $transactionId: UUID!, $ticketId: UUID) {
  event {
    deleteFreeTicket(
      eventId: $eventId
      transactionId: $transactionId
      ticketId: $ticketId
    )
  }
}
    `;
export type DeleteFreeTicketMutationFn = Apollo.MutationFunction<DeleteFreeTicketMutation, DeleteFreeTicketMutationVariables>;

/**
 * __useDeleteFreeTicketMutation__
 *
 * To run a mutation, you first call `useDeleteFreeTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFreeTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFreeTicketMutation, { data, loading, error }] = useDeleteFreeTicketMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      transactionId: // value for 'transactionId'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useDeleteFreeTicketMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFreeTicketMutation, DeleteFreeTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFreeTicketMutation, DeleteFreeTicketMutationVariables>(DeleteFreeTicketDocument, options);
      }
export type DeleteFreeTicketMutationHookResult = ReturnType<typeof useDeleteFreeTicketMutation>;
export type DeleteFreeTicketMutationResult = Apollo.MutationResult<DeleteFreeTicketMutation>;
export type DeleteFreeTicketMutationOptions = Apollo.BaseMutationOptions<DeleteFreeTicketMutation, DeleteFreeTicketMutationVariables>;
export const ShareTicketDocument = gql`
    mutation ShareTicket($shareTicketArgs: ShareTicketArgsInput!) {
  event {
    shareTicket(shareTicketArgs: $shareTicketArgs)
  }
}
    `;
export type ShareTicketMutationFn = Apollo.MutationFunction<ShareTicketMutation, ShareTicketMutationVariables>;

/**
 * __useShareTicketMutation__
 *
 * To run a mutation, you first call `useShareTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareTicketMutation, { data, loading, error }] = useShareTicketMutation({
 *   variables: {
 *      shareTicketArgs: // value for 'shareTicketArgs'
 *   },
 * });
 */
export function useShareTicketMutation(baseOptions?: Apollo.MutationHookOptions<ShareTicketMutation, ShareTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareTicketMutation, ShareTicketMutationVariables>(ShareTicketDocument, options);
      }
export type ShareTicketMutationHookResult = ReturnType<typeof useShareTicketMutation>;
export type ShareTicketMutationResult = Apollo.MutationResult<ShareTicketMutation>;
export type ShareTicketMutationOptions = Apollo.BaseMutationOptions<ShareTicketMutation, ShareTicketMutationVariables>;
export const RequestEventPayout2Document = gql`
    mutation RequestEventPayout2($amount: Decimal!, $currency: String) {
  event {
    requestEventPayout2(amount: $amount, currency: $currency)
  }
}
    `;
export type RequestEventPayout2MutationFn = Apollo.MutationFunction<RequestEventPayout2Mutation, RequestEventPayout2MutationVariables>;

/**
 * __useRequestEventPayout2Mutation__
 *
 * To run a mutation, you first call `useRequestEventPayout2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEventPayout2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEventPayout2Mutation, { data, loading, error }] = useRequestEventPayout2Mutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useRequestEventPayout2Mutation(baseOptions?: Apollo.MutationHookOptions<RequestEventPayout2Mutation, RequestEventPayout2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEventPayout2Mutation, RequestEventPayout2MutationVariables>(RequestEventPayout2Document, options);
      }
export type RequestEventPayout2MutationHookResult = ReturnType<typeof useRequestEventPayout2Mutation>;
export type RequestEventPayout2MutationResult = Apollo.MutationResult<RequestEventPayout2Mutation>;
export type RequestEventPayout2MutationOptions = Apollo.BaseMutationOptions<RequestEventPayout2Mutation, RequestEventPayout2MutationVariables>;
export const AddEventGuestDocument = gql`
    mutation AddEventGuest($eventId: UUID!, $guest: EventGuestInfoArgsInput!, $tickets: [AddEventGuestTicketArgsInput!]!) {
  event {
    addEventGuest(eventId: $eventId, guest: $guest, tickets: $tickets)
  }
}
    `;
export type AddEventGuestMutationFn = Apollo.MutationFunction<AddEventGuestMutation, AddEventGuestMutationVariables>;

/**
 * __useAddEventGuestMutation__
 *
 * To run a mutation, you first call `useAddEventGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventGuestMutation, { data, loading, error }] = useAddEventGuestMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guest: // value for 'guest'
 *      tickets: // value for 'tickets'
 *   },
 * });
 */
export function useAddEventGuestMutation(baseOptions?: Apollo.MutationHookOptions<AddEventGuestMutation, AddEventGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventGuestMutation, AddEventGuestMutationVariables>(AddEventGuestDocument, options);
      }
export type AddEventGuestMutationHookResult = ReturnType<typeof useAddEventGuestMutation>;
export type AddEventGuestMutationResult = Apollo.MutationResult<AddEventGuestMutation>;
export type AddEventGuestMutationOptions = Apollo.BaseMutationOptions<AddEventGuestMutation, AddEventGuestMutationVariables>;
export const AddEventGuestsDocument = gql`
    mutation AddEventGuests($eventId: UUID!, $guests: [AddEventGuestRowArgsInput!]!) {
  event {
    addEventGuests(eventId: $eventId, guests: $guests) {
      sucessfulRefs
      failedRefs
    }
  }
}
    `;
export type AddEventGuestsMutationFn = Apollo.MutationFunction<AddEventGuestsMutation, AddEventGuestsMutationVariables>;

/**
 * __useAddEventGuestsMutation__
 *
 * To run a mutation, you first call `useAddEventGuestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventGuestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventGuestsMutation, { data, loading, error }] = useAddEventGuestsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guests: // value for 'guests'
 *   },
 * });
 */
export function useAddEventGuestsMutation(baseOptions?: Apollo.MutationHookOptions<AddEventGuestsMutation, AddEventGuestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventGuestsMutation, AddEventGuestsMutationVariables>(AddEventGuestsDocument, options);
      }
export type AddEventGuestsMutationHookResult = ReturnType<typeof useAddEventGuestsMutation>;
export type AddEventGuestsMutationResult = Apollo.MutationResult<AddEventGuestsMutation>;
export type AddEventGuestsMutationOptions = Apollo.BaseMutationOptions<AddEventGuestsMutation, AddEventGuestsMutationVariables>;
export const DeleteEventGuestDocument = gql`
    mutation DeleteEventGuest($eventId: UUID!, $guestId: UUID!) {
  event {
    deleteEventGuest(eventId: $eventId, guestId: $guestId)
  }
}
    `;
export type DeleteEventGuestMutationFn = Apollo.MutationFunction<DeleteEventGuestMutation, DeleteEventGuestMutationVariables>;

/**
 * __useDeleteEventGuestMutation__
 *
 * To run a mutation, you first call `useDeleteEventGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventGuestMutation, { data, loading, error }] = useDeleteEventGuestMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestId: // value for 'guestId'
 *   },
 * });
 */
export function useDeleteEventGuestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventGuestMutation, DeleteEventGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventGuestMutation, DeleteEventGuestMutationVariables>(DeleteEventGuestDocument, options);
      }
export type DeleteEventGuestMutationHookResult = ReturnType<typeof useDeleteEventGuestMutation>;
export type DeleteEventGuestMutationResult = Apollo.MutationResult<DeleteEventGuestMutation>;
export type DeleteEventGuestMutationOptions = Apollo.BaseMutationOptions<DeleteEventGuestMutation, DeleteEventGuestMutationVariables>;
export const AddEventGuestTicketDocument = gql`
    mutation AddEventGuestTicket($eventId: UUID!, $guestId: UUID!, $ticket: AddEventGuestTicketArgsInput!) {
  event {
    addEventGuestTicket(eventId: $eventId, guestId: $guestId, ticket: $ticket)
  }
}
    `;
export type AddEventGuestTicketMutationFn = Apollo.MutationFunction<AddEventGuestTicketMutation, AddEventGuestTicketMutationVariables>;

/**
 * __useAddEventGuestTicketMutation__
 *
 * To run a mutation, you first call `useAddEventGuestTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventGuestTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventGuestTicketMutation, { data, loading, error }] = useAddEventGuestTicketMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestId: // value for 'guestId'
 *      ticket: // value for 'ticket'
 *   },
 * });
 */
export function useAddEventGuestTicketMutation(baseOptions?: Apollo.MutationHookOptions<AddEventGuestTicketMutation, AddEventGuestTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventGuestTicketMutation, AddEventGuestTicketMutationVariables>(AddEventGuestTicketDocument, options);
      }
export type AddEventGuestTicketMutationHookResult = ReturnType<typeof useAddEventGuestTicketMutation>;
export type AddEventGuestTicketMutationResult = Apollo.MutationResult<AddEventGuestTicketMutation>;
export type AddEventGuestTicketMutationOptions = Apollo.BaseMutationOptions<AddEventGuestTicketMutation, AddEventGuestTicketMutationVariables>;
export const DeleteEventGuestTicketDocument = gql`
    mutation DeleteEventGuestTicket($eventId: UUID!, $guestId: UUID!, $ticketId: UUID!) {
  event {
    deleteEventGuestTicket(
      eventId: $eventId
      guestId: $guestId
      ticketId: $ticketId
    )
  }
}
    `;
export type DeleteEventGuestTicketMutationFn = Apollo.MutationFunction<DeleteEventGuestTicketMutation, DeleteEventGuestTicketMutationVariables>;

/**
 * __useDeleteEventGuestTicketMutation__
 *
 * To run a mutation, you first call `useDeleteEventGuestTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventGuestTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventGuestTicketMutation, { data, loading, error }] = useDeleteEventGuestTicketMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestId: // value for 'guestId'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useDeleteEventGuestTicketMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventGuestTicketMutation, DeleteEventGuestTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventGuestTicketMutation, DeleteEventGuestTicketMutationVariables>(DeleteEventGuestTicketDocument, options);
      }
export type DeleteEventGuestTicketMutationHookResult = ReturnType<typeof useDeleteEventGuestTicketMutation>;
export type DeleteEventGuestTicketMutationResult = Apollo.MutationResult<DeleteEventGuestTicketMutation>;
export type DeleteEventGuestTicketMutationOptions = Apollo.BaseMutationOptions<DeleteEventGuestTicketMutation, DeleteEventGuestTicketMutationVariables>;
export const AddGuestQrPassDocument = gql`
    mutation AddGuestQrPass($eventId: UUID!, $args: AddGuestQrPassArgsInput!) {
  event {
    addGuestQrPass(eventId: $eventId, args: $args)
  }
}
    `;
export type AddGuestQrPassMutationFn = Apollo.MutationFunction<AddGuestQrPassMutation, AddGuestQrPassMutationVariables>;

/**
 * __useAddGuestQrPassMutation__
 *
 * To run a mutation, you first call `useAddGuestQrPassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGuestQrPassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGuestQrPassMutation, { data, loading, error }] = useAddGuestQrPassMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAddGuestQrPassMutation(baseOptions?: Apollo.MutationHookOptions<AddGuestQrPassMutation, AddGuestQrPassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGuestQrPassMutation, AddGuestQrPassMutationVariables>(AddGuestQrPassDocument, options);
      }
export type AddGuestQrPassMutationHookResult = ReturnType<typeof useAddGuestQrPassMutation>;
export type AddGuestQrPassMutationResult = Apollo.MutationResult<AddGuestQrPassMutation>;
export type AddGuestQrPassMutationOptions = Apollo.BaseMutationOptions<AddGuestQrPassMutation, AddGuestQrPassMutationVariables>;
export const ShareGuestQrDocument = gql`
    mutation ShareGuestQr($eventId: UUID!, $guestId: UUID!, $sendEmail: Boolean!, $sendText: Boolean!) {
  event {
    shareGuestQr(
      eventId: $eventId
      guestId: $guestId
      sendEmail: $sendEmail
      sendText: $sendText
    )
  }
}
    `;
export type ShareGuestQrMutationFn = Apollo.MutationFunction<ShareGuestQrMutation, ShareGuestQrMutationVariables>;

/**
 * __useShareGuestQrMutation__
 *
 * To run a mutation, you first call `useShareGuestQrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareGuestQrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareGuestQrMutation, { data, loading, error }] = useShareGuestQrMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestId: // value for 'guestId'
 *      sendEmail: // value for 'sendEmail'
 *      sendText: // value for 'sendText'
 *   },
 * });
 */
export function useShareGuestQrMutation(baseOptions?: Apollo.MutationHookOptions<ShareGuestQrMutation, ShareGuestQrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareGuestQrMutation, ShareGuestQrMutationVariables>(ShareGuestQrDocument, options);
      }
export type ShareGuestQrMutationHookResult = ReturnType<typeof useShareGuestQrMutation>;
export type ShareGuestQrMutationResult = Apollo.MutationResult<ShareGuestQrMutation>;
export type ShareGuestQrMutationOptions = Apollo.BaseMutationOptions<ShareGuestQrMutation, ShareGuestQrMutationVariables>;
export const CheckInEventGuestTicketDocument = gql`
    mutation CheckInEventGuestTicket($eventId: UUID!, $guestId: UUID!, $ticketId: UUID!) {
  event {
    checkInEventGuestTicket(
      eventId: $eventId
      guestId: $guestId
      ticketId: $ticketId
    )
  }
}
    `;
export type CheckInEventGuestTicketMutationFn = Apollo.MutationFunction<CheckInEventGuestTicketMutation, CheckInEventGuestTicketMutationVariables>;

/**
 * __useCheckInEventGuestTicketMutation__
 *
 * To run a mutation, you first call `useCheckInEventGuestTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInEventGuestTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInEventGuestTicketMutation, { data, loading, error }] = useCheckInEventGuestTicketMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestId: // value for 'guestId'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useCheckInEventGuestTicketMutation(baseOptions?: Apollo.MutationHookOptions<CheckInEventGuestTicketMutation, CheckInEventGuestTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckInEventGuestTicketMutation, CheckInEventGuestTicketMutationVariables>(CheckInEventGuestTicketDocument, options);
      }
export type CheckInEventGuestTicketMutationHookResult = ReturnType<typeof useCheckInEventGuestTicketMutation>;
export type CheckInEventGuestTicketMutationResult = Apollo.MutationResult<CheckInEventGuestTicketMutation>;
export type CheckInEventGuestTicketMutationOptions = Apollo.BaseMutationOptions<CheckInEventGuestTicketMutation, CheckInEventGuestTicketMutationVariables>;
export const CreatePaymentOrderDocument = gql`
    mutation CreatePaymentOrder($eventId: UUID!, $token: String!) {
  event {
    createPaymentOrder(eventId: $eventId, token: $token)
  }
}
    `;
export type CreatePaymentOrderMutationFn = Apollo.MutationFunction<CreatePaymentOrderMutation, CreatePaymentOrderMutationVariables>;

/**
 * __useCreatePaymentOrderMutation__
 *
 * To run a mutation, you first call `useCreatePaymentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentOrderMutation, { data, loading, error }] = useCreatePaymentOrderMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCreatePaymentOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentOrderMutation, CreatePaymentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentOrderMutation, CreatePaymentOrderMutationVariables>(CreatePaymentOrderDocument, options);
      }
export type CreatePaymentOrderMutationHookResult = ReturnType<typeof useCreatePaymentOrderMutation>;
export type CreatePaymentOrderMutationResult = Apollo.MutationResult<CreatePaymentOrderMutation>;
export type CreatePaymentOrderMutationOptions = Apollo.BaseMutationOptions<CreatePaymentOrderMutation, CreatePaymentOrderMutationVariables>;
export const UpdateEventGuestDocument = gql`
    mutation UpdateEventGuest($eventId: UUID!, $guestId: UUID!, $guestInfo: EventGuestInfoArgsInput!, $ticket: AddEventGuestTicketArgsInput) {
  event {
    updateEventGuest(
      eventId: $eventId
      guestId: $guestId
      guestInfo: $guestInfo
      ticket: $ticket
    )
  }
}
    `;
export type UpdateEventGuestMutationFn = Apollo.MutationFunction<UpdateEventGuestMutation, UpdateEventGuestMutationVariables>;

/**
 * __useUpdateEventGuestMutation__
 *
 * To run a mutation, you first call `useUpdateEventGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventGuestMutation, { data, loading, error }] = useUpdateEventGuestMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestId: // value for 'guestId'
 *      guestInfo: // value for 'guestInfo'
 *      ticket: // value for 'ticket'
 *   },
 * });
 */
export function useUpdateEventGuestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventGuestMutation, UpdateEventGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventGuestMutation, UpdateEventGuestMutationVariables>(UpdateEventGuestDocument, options);
      }
export type UpdateEventGuestMutationHookResult = ReturnType<typeof useUpdateEventGuestMutation>;
export type UpdateEventGuestMutationResult = Apollo.MutationResult<UpdateEventGuestMutation>;
export type UpdateEventGuestMutationOptions = Apollo.BaseMutationOptions<UpdateEventGuestMutation, UpdateEventGuestMutationVariables>;
export const UpdateEventGuestTicketDocument = gql`
    mutation UpdateEventGuestTicket($eventId: UUID!, $guestId: UUID!, $ticketId: UUID!, $ticket: EventGuestTicketArgsInput!) {
  event {
    updateEventGuestTicket(
      eventId: $eventId
      guestId: $guestId
      ticketId: $ticketId
      ticket: $ticket
    )
  }
}
    `;
export type UpdateEventGuestTicketMutationFn = Apollo.MutationFunction<UpdateEventGuestTicketMutation, UpdateEventGuestTicketMutationVariables>;

/**
 * __useUpdateEventGuestTicketMutation__
 *
 * To run a mutation, you first call `useUpdateEventGuestTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventGuestTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventGuestTicketMutation, { data, loading, error }] = useUpdateEventGuestTicketMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestId: // value for 'guestId'
 *      ticketId: // value for 'ticketId'
 *      ticket: // value for 'ticket'
 *   },
 * });
 */
export function useUpdateEventGuestTicketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventGuestTicketMutation, UpdateEventGuestTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventGuestTicketMutation, UpdateEventGuestTicketMutationVariables>(UpdateEventGuestTicketDocument, options);
      }
export type UpdateEventGuestTicketMutationHookResult = ReturnType<typeof useUpdateEventGuestTicketMutation>;
export type UpdateEventGuestTicketMutationResult = Apollo.MutationResult<UpdateEventGuestTicketMutation>;
export type UpdateEventGuestTicketMutationOptions = Apollo.BaseMutationOptions<UpdateEventGuestTicketMutation, UpdateEventGuestTicketMutationVariables>;
export const UndoCheckInEventGuestTicketDocument = gql`
    mutation UndoCheckInEventGuestTicket($eventId: UUID!, $guestId: UUID!, $ticketId: UUID!) {
  event {
    undoCheckInEventGuestTicket(
      eventId: $eventId
      guestId: $guestId
      ticketId: $ticketId
    )
  }
}
    `;
export type UndoCheckInEventGuestTicketMutationFn = Apollo.MutationFunction<UndoCheckInEventGuestTicketMutation, UndoCheckInEventGuestTicketMutationVariables>;

/**
 * __useUndoCheckInEventGuestTicketMutation__
 *
 * To run a mutation, you first call `useUndoCheckInEventGuestTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoCheckInEventGuestTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoCheckInEventGuestTicketMutation, { data, loading, error }] = useUndoCheckInEventGuestTicketMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestId: // value for 'guestId'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useUndoCheckInEventGuestTicketMutation(baseOptions?: Apollo.MutationHookOptions<UndoCheckInEventGuestTicketMutation, UndoCheckInEventGuestTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndoCheckInEventGuestTicketMutation, UndoCheckInEventGuestTicketMutationVariables>(UndoCheckInEventGuestTicketDocument, options);
      }
export type UndoCheckInEventGuestTicketMutationHookResult = ReturnType<typeof useUndoCheckInEventGuestTicketMutation>;
export type UndoCheckInEventGuestTicketMutationResult = Apollo.MutationResult<UndoCheckInEventGuestTicketMutation>;
export type UndoCheckInEventGuestTicketMutationOptions = Apollo.BaseMutationOptions<UndoCheckInEventGuestTicketMutation, UndoCheckInEventGuestTicketMutationVariables>;
export const JoinEventTicketWaitingListDocument = gql`
    mutation JoinEventTicketWaitingList($eventId: UUID!, $eventTicketId: UUID!) {
  event {
    joinEventTicketWaitingList(eventId: $eventId, eventTicketId: $eventTicketId)
  }
}
    `;
export type JoinEventTicketWaitingListMutationFn = Apollo.MutationFunction<JoinEventTicketWaitingListMutation, JoinEventTicketWaitingListMutationVariables>;

/**
 * __useJoinEventTicketWaitingListMutation__
 *
 * To run a mutation, you first call `useJoinEventTicketWaitingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinEventTicketWaitingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinEventTicketWaitingListMutation, { data, loading, error }] = useJoinEventTicketWaitingListMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventTicketId: // value for 'eventTicketId'
 *   },
 * });
 */
export function useJoinEventTicketWaitingListMutation(baseOptions?: Apollo.MutationHookOptions<JoinEventTicketWaitingListMutation, JoinEventTicketWaitingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinEventTicketWaitingListMutation, JoinEventTicketWaitingListMutationVariables>(JoinEventTicketWaitingListDocument, options);
      }
export type JoinEventTicketWaitingListMutationHookResult = ReturnType<typeof useJoinEventTicketWaitingListMutation>;
export type JoinEventTicketWaitingListMutationResult = Apollo.MutationResult<JoinEventTicketWaitingListMutation>;
export type JoinEventTicketWaitingListMutationOptions = Apollo.BaseMutationOptions<JoinEventTicketWaitingListMutation, JoinEventTicketWaitingListMutationVariables>;
export const GenerateInviteLinkDocument = gql`
    mutation GenerateInviteLink($eventId: UUID!, $privateTicketsArgs: PrivateTicketsArgsInput) {
  event {
    generateInviteLink(eventId: $eventId, privateTicketsArgs: $privateTicketsArgs)
  }
}
    `;
export type GenerateInviteLinkMutationFn = Apollo.MutationFunction<GenerateInviteLinkMutation, GenerateInviteLinkMutationVariables>;

/**
 * __useGenerateInviteLinkMutation__
 *
 * To run a mutation, you first call `useGenerateInviteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInviteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInviteLinkMutation, { data, loading, error }] = useGenerateInviteLinkMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      privateTicketsArgs: // value for 'privateTicketsArgs'
 *   },
 * });
 */
export function useGenerateInviteLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateInviteLinkMutation, GenerateInviteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateInviteLinkMutation, GenerateInviteLinkMutationVariables>(GenerateInviteLinkDocument, options);
      }
export type GenerateInviteLinkMutationHookResult = ReturnType<typeof useGenerateInviteLinkMutation>;
export type GenerateInviteLinkMutationResult = Apollo.MutationResult<GenerateInviteLinkMutation>;
export type GenerateInviteLinkMutationOptions = Apollo.BaseMutationOptions<GenerateInviteLinkMutation, GenerateInviteLinkMutationVariables>;
export const ChangeDisplayTicketsDocument = gql`
    mutation ChangeDisplayTickets($changes: [ChangeDisplayTicketIdInput!]!, $eventId: UUID!) {
  event {
    changeDisplayTickets(changes: $changes, eventId: $eventId)
  }
}
    `;
export type ChangeDisplayTicketsMutationFn = Apollo.MutationFunction<ChangeDisplayTicketsMutation, ChangeDisplayTicketsMutationVariables>;

/**
 * __useChangeDisplayTicketsMutation__
 *
 * To run a mutation, you first call `useChangeDisplayTicketsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeDisplayTicketsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDisplayTicketsMutation, { data, loading, error }] = useChangeDisplayTicketsMutation({
 *   variables: {
 *      changes: // value for 'changes'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useChangeDisplayTicketsMutation(baseOptions?: Apollo.MutationHookOptions<ChangeDisplayTicketsMutation, ChangeDisplayTicketsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeDisplayTicketsMutation, ChangeDisplayTicketsMutationVariables>(ChangeDisplayTicketsDocument, options);
      }
export type ChangeDisplayTicketsMutationHookResult = ReturnType<typeof useChangeDisplayTicketsMutation>;
export type ChangeDisplayTicketsMutationResult = Apollo.MutationResult<ChangeDisplayTicketsMutation>;
export type ChangeDisplayTicketsMutationOptions = Apollo.BaseMutationOptions<ChangeDisplayTicketsMutation, ChangeDisplayTicketsMutationVariables>;
export const ChangeTicketToSeriesPassDocument = gql`
    mutation ChangeTicketToSeriesPass($eventId: UUID!, $ticketId: UUID!, $seriesPassTicketId: UUID!) {
  event {
    changeTicketToSeriesPass(
      eventId: $eventId
      ticketId: $ticketId
      seriesPassTicketId: $seriesPassTicketId
    )
  }
}
    `;
export type ChangeTicketToSeriesPassMutationFn = Apollo.MutationFunction<ChangeTicketToSeriesPassMutation, ChangeTicketToSeriesPassMutationVariables>;

/**
 * __useChangeTicketToSeriesPassMutation__
 *
 * To run a mutation, you first call `useChangeTicketToSeriesPassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTicketToSeriesPassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTicketToSeriesPassMutation, { data, loading, error }] = useChangeTicketToSeriesPassMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      ticketId: // value for 'ticketId'
 *      seriesPassTicketId: // value for 'seriesPassTicketId'
 *   },
 * });
 */
export function useChangeTicketToSeriesPassMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTicketToSeriesPassMutation, ChangeTicketToSeriesPassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTicketToSeriesPassMutation, ChangeTicketToSeriesPassMutationVariables>(ChangeTicketToSeriesPassDocument, options);
      }
export type ChangeTicketToSeriesPassMutationHookResult = ReturnType<typeof useChangeTicketToSeriesPassMutation>;
export type ChangeTicketToSeriesPassMutationResult = Apollo.MutationResult<ChangeTicketToSeriesPassMutation>;
export type ChangeTicketToSeriesPassMutationOptions = Apollo.BaseMutationOptions<ChangeTicketToSeriesPassMutation, ChangeTicketToSeriesPassMutationVariables>;
export const SendSignedDisclosureCopyDocument = gql`
    mutation SendSignedDisclosureCopy($emailAddresses: [String!]!, $eventId: UUID!, $userId: UUID!) {
  event {
    sendSignedDisclosureCopy(
      emailAddresses: $emailAddresses
      eventId: $eventId
      userId: $userId
    )
  }
}
    `;
export type SendSignedDisclosureCopyMutationFn = Apollo.MutationFunction<SendSignedDisclosureCopyMutation, SendSignedDisclosureCopyMutationVariables>;

/**
 * __useSendSignedDisclosureCopyMutation__
 *
 * To run a mutation, you first call `useSendSignedDisclosureCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSignedDisclosureCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSignedDisclosureCopyMutation, { data, loading, error }] = useSendSignedDisclosureCopyMutation({
 *   variables: {
 *      emailAddresses: // value for 'emailAddresses'
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendSignedDisclosureCopyMutation(baseOptions?: Apollo.MutationHookOptions<SendSignedDisclosureCopyMutation, SendSignedDisclosureCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSignedDisclosureCopyMutation, SendSignedDisclosureCopyMutationVariables>(SendSignedDisclosureCopyDocument, options);
      }
export type SendSignedDisclosureCopyMutationHookResult = ReturnType<typeof useSendSignedDisclosureCopyMutation>;
export type SendSignedDisclosureCopyMutationResult = Apollo.MutationResult<SendSignedDisclosureCopyMutation>;
export type SendSignedDisclosureCopyMutationOptions = Apollo.BaseMutationOptions<SendSignedDisclosureCopyMutation, SendSignedDisclosureCopyMutationVariables>;
export const GenerateTicketQrCodeDocument = gql`
    mutation GenerateTicketQrCode($eventId: UUID!, $ticketId: String!) {
  event {
    generateTicketQrCode(eventId: $eventId, ticketId: $ticketId) {
      id
      qrCode
      userTicketId
      eventTicketId
      expiresAt
      firstSeen
      count
      ticketId
    }
  }
}
    `;
export type GenerateTicketQrCodeMutationFn = Apollo.MutationFunction<GenerateTicketQrCodeMutation, GenerateTicketQrCodeMutationVariables>;

/**
 * __useGenerateTicketQrCodeMutation__
 *
 * To run a mutation, you first call `useGenerateTicketQrCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTicketQrCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTicketQrCodeMutation, { data, loading, error }] = useGenerateTicketQrCodeMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGenerateTicketQrCodeMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTicketQrCodeMutation, GenerateTicketQrCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTicketQrCodeMutation, GenerateTicketQrCodeMutationVariables>(GenerateTicketQrCodeDocument, options);
      }
export type GenerateTicketQrCodeMutationHookResult = ReturnType<typeof useGenerateTicketQrCodeMutation>;
export type GenerateTicketQrCodeMutationResult = Apollo.MutationResult<GenerateTicketQrCodeMutation>;
export type GenerateTicketQrCodeMutationOptions = Apollo.BaseMutationOptions<GenerateTicketQrCodeMutation, GenerateTicketQrCodeMutationVariables>;
export const RemoveInviteDocument = gql`
    mutation RemoveInvite($eventId: UUID!, $userKey: String!, $attendeeRole: EventAttendeeRole!) {
  event {
    removePendingRole(
      eventId: $eventId
      userKey: $userKey
      attendeeRole: $attendeeRole
    )
  }
}
    `;
export type RemoveInviteMutationFn = Apollo.MutationFunction<RemoveInviteMutation, RemoveInviteMutationVariables>;

/**
 * __useRemoveInviteMutation__
 *
 * To run a mutation, you first call `useRemoveInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInviteMutation, { data, loading, error }] = useRemoveInviteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userKey: // value for 'userKey'
 *      attendeeRole: // value for 'attendeeRole'
 *   },
 * });
 */
export function useRemoveInviteMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInviteMutation, RemoveInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInviteMutation, RemoveInviteMutationVariables>(RemoveInviteDocument, options);
      }
export type RemoveInviteMutationHookResult = ReturnType<typeof useRemoveInviteMutation>;
export type RemoveInviteMutationResult = Apollo.MutationResult<RemoveInviteMutation>;
export type RemoveInviteMutationOptions = Apollo.BaseMutationOptions<RemoveInviteMutation, RemoveInviteMutationVariables>;
export const GenerateSharableTicketLinkDocument = gql`
    mutation GenerateSharableTicketLink($eventId: UUID!, $ticketId: String!, $landingEventId: UUID) {
  event {
    generateShareTicketLink(
      eventId: $eventId
      ticketId: $ticketId
      landingEventId: $landingEventId
    )
  }
}
    `;
export type GenerateSharableTicketLinkMutationFn = Apollo.MutationFunction<GenerateSharableTicketLinkMutation, GenerateSharableTicketLinkMutationVariables>;

/**
 * __useGenerateSharableTicketLinkMutation__
 *
 * To run a mutation, you first call `useGenerateSharableTicketLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSharableTicketLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSharableTicketLinkMutation, { data, loading, error }] = useGenerateSharableTicketLinkMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      ticketId: // value for 'ticketId'
 *      landingEventId: // value for 'landingEventId'
 *   },
 * });
 */
export function useGenerateSharableTicketLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSharableTicketLinkMutation, GenerateSharableTicketLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSharableTicketLinkMutation, GenerateSharableTicketLinkMutationVariables>(GenerateSharableTicketLinkDocument, options);
      }
export type GenerateSharableTicketLinkMutationHookResult = ReturnType<typeof useGenerateSharableTicketLinkMutation>;
export type GenerateSharableTicketLinkMutationResult = Apollo.MutationResult<GenerateSharableTicketLinkMutation>;
export type GenerateSharableTicketLinkMutationOptions = Apollo.BaseMutationOptions<GenerateSharableTicketLinkMutation, GenerateSharableTicketLinkMutationVariables>;
export const LinkClubOffersDocument = gql`
    mutation LinkClubOffers($eventId: UUID!, $clubId: UUID!, $offerIds: [UUID!]!) {
  event {
    linkClubOffers(eventId: $eventId, clubId: $clubId, offerIds: $offerIds) {
      success
    }
  }
}
    `;
export type LinkClubOffersMutationFn = Apollo.MutationFunction<LinkClubOffersMutation, LinkClubOffersMutationVariables>;

/**
 * __useLinkClubOffersMutation__
 *
 * To run a mutation, you first call `useLinkClubOffersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkClubOffersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkClubOffersMutation, { data, loading, error }] = useLinkClubOffersMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      clubId: // value for 'clubId'
 *      offerIds: // value for 'offerIds'
 *   },
 * });
 */
export function useLinkClubOffersMutation(baseOptions?: Apollo.MutationHookOptions<LinkClubOffersMutation, LinkClubOffersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkClubOffersMutation, LinkClubOffersMutationVariables>(LinkClubOffersDocument, options);
      }
export type LinkClubOffersMutationHookResult = ReturnType<typeof useLinkClubOffersMutation>;
export type LinkClubOffersMutationResult = Apollo.MutationResult<LinkClubOffersMutation>;
export type LinkClubOffersMutationOptions = Apollo.BaseMutationOptions<LinkClubOffersMutation, LinkClubOffersMutationVariables>;
export const GetAppleWalletPassDownloadTokenDocument = gql`
    mutation GetAppleWalletPassDownloadToken($eventId: UUID!, $ticketId: String!) {
  eventTicket {
    appleWalletDownloadToken(eventId: $eventId, ticketId: $ticketId)
  }
}
    `;
export type GetAppleWalletPassDownloadTokenMutationFn = Apollo.MutationFunction<GetAppleWalletPassDownloadTokenMutation, GetAppleWalletPassDownloadTokenMutationVariables>;

/**
 * __useGetAppleWalletPassDownloadTokenMutation__
 *
 * To run a mutation, you first call `useGetAppleWalletPassDownloadTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAppleWalletPassDownloadTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAppleWalletPassDownloadTokenMutation, { data, loading, error }] = useGetAppleWalletPassDownloadTokenMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGetAppleWalletPassDownloadTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetAppleWalletPassDownloadTokenMutation, GetAppleWalletPassDownloadTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAppleWalletPassDownloadTokenMutation, GetAppleWalletPassDownloadTokenMutationVariables>(GetAppleWalletPassDownloadTokenDocument, options);
      }
export type GetAppleWalletPassDownloadTokenMutationHookResult = ReturnType<typeof useGetAppleWalletPassDownloadTokenMutation>;
export type GetAppleWalletPassDownloadTokenMutationResult = Apollo.MutationResult<GetAppleWalletPassDownloadTokenMutation>;
export type GetAppleWalletPassDownloadTokenMutationOptions = Apollo.BaseMutationOptions<GetAppleWalletPassDownloadTokenMutation, GetAppleWalletPassDownloadTokenMutationVariables>;
export const TrackShareLinkViewDocument = gql`
    mutation TrackShareLinkView($eventId: UUID!, $refCode: String!, $viewSource: AttributionChannel) {
  event {
    trackShareLinkView(
      eventId: $eventId
      refCode: $refCode
      viewSource: $viewSource
    )
  }
}
    `;
export type TrackShareLinkViewMutationFn = Apollo.MutationFunction<TrackShareLinkViewMutation, TrackShareLinkViewMutationVariables>;

/**
 * __useTrackShareLinkViewMutation__
 *
 * To run a mutation, you first call `useTrackShareLinkViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackShareLinkViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackShareLinkViewMutation, { data, loading, error }] = useTrackShareLinkViewMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      refCode: // value for 'refCode'
 *      viewSource: // value for 'viewSource'
 *   },
 * });
 */
export function useTrackShareLinkViewMutation(baseOptions?: Apollo.MutationHookOptions<TrackShareLinkViewMutation, TrackShareLinkViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackShareLinkViewMutation, TrackShareLinkViewMutationVariables>(TrackShareLinkViewDocument, options);
      }
export type TrackShareLinkViewMutationHookResult = ReturnType<typeof useTrackShareLinkViewMutation>;
export type TrackShareLinkViewMutationResult = Apollo.MutationResult<TrackShareLinkViewMutation>;
export type TrackShareLinkViewMutationOptions = Apollo.BaseMutationOptions<TrackShareLinkViewMutation, TrackShareLinkViewMutationVariables>;
export const EnterContestDocument = gql`
    mutation EnterContest($eventId: UUID!, $token: String) {
  eventTicket {
    enterContest(eventId: $eventId, token: $token) {
      message
      success
    }
  }
}
    `;
export type EnterContestMutationFn = Apollo.MutationFunction<EnterContestMutation, EnterContestMutationVariables>;

/**
 * __useEnterContestMutation__
 *
 * To run a mutation, you first call `useEnterContestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterContestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterContestMutation, { data, loading, error }] = useEnterContestMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEnterContestMutation(baseOptions?: Apollo.MutationHookOptions<EnterContestMutation, EnterContestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnterContestMutation, EnterContestMutationVariables>(EnterContestDocument, options);
      }
export type EnterContestMutationHookResult = ReturnType<typeof useEnterContestMutation>;
export type EnterContestMutationResult = Apollo.MutationResult<EnterContestMutation>;
export type EnterContestMutationOptions = Apollo.BaseMutationOptions<EnterContestMutation, EnterContestMutationVariables>;
export const SendHostMessageDocument = gql`
    mutation SendHostMessage($eventId: UUID!, $body: String!) {
  hostMessage {
    send(eventId: $eventId, body: $body) {
      messageId
      threadId
      sentAt
    }
  }
}
    `;
export type SendHostMessageMutationFn = Apollo.MutationFunction<SendHostMessageMutation, SendHostMessageMutationVariables>;

/**
 * __useSendHostMessageMutation__
 *
 * To run a mutation, you first call `useSendHostMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendHostMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendHostMessageMutation, { data, loading, error }] = useSendHostMessageMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSendHostMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendHostMessageMutation, SendHostMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendHostMessageMutation, SendHostMessageMutationVariables>(SendHostMessageDocument, options);
      }
export type SendHostMessageMutationHookResult = ReturnType<typeof useSendHostMessageMutation>;
export type SendHostMessageMutationResult = Apollo.MutationResult<SendHostMessageMutation>;
export type SendHostMessageMutationOptions = Apollo.BaseMutationOptions<SendHostMessageMutation, SendHostMessageMutationVariables>;
export const MarkHostMessageReadDocument = gql`
    mutation MarkHostMessageRead($messageId: UUID!) {
  hostMessage {
    markRead(messageId: $messageId)
  }
}
    `;
export type MarkHostMessageReadMutationFn = Apollo.MutationFunction<MarkHostMessageReadMutation, MarkHostMessageReadMutationVariables>;

/**
 * __useMarkHostMessageReadMutation__
 *
 * To run a mutation, you first call `useMarkHostMessageReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkHostMessageReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markHostMessageReadMutation, { data, loading, error }] = useMarkHostMessageReadMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useMarkHostMessageReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkHostMessageReadMutation, MarkHostMessageReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkHostMessageReadMutation, MarkHostMessageReadMutationVariables>(MarkHostMessageReadDocument, options);
      }
export type MarkHostMessageReadMutationHookResult = ReturnType<typeof useMarkHostMessageReadMutation>;
export type MarkHostMessageReadMutationResult = Apollo.MutationResult<MarkHostMessageReadMutation>;
export type MarkHostMessageReadMutationOptions = Apollo.BaseMutationOptions<MarkHostMessageReadMutation, MarkHostMessageReadMutationVariables>;
export const MarkHostMessageUnreadDocument = gql`
    mutation MarkHostMessageUnread($messageId: UUID!) {
  hostMessage {
    markUnread(messageId: $messageId)
  }
}
    `;
export type MarkHostMessageUnreadMutationFn = Apollo.MutationFunction<MarkHostMessageUnreadMutation, MarkHostMessageUnreadMutationVariables>;

/**
 * __useMarkHostMessageUnreadMutation__
 *
 * To run a mutation, you first call `useMarkHostMessageUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkHostMessageUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markHostMessageUnreadMutation, { data, loading, error }] = useMarkHostMessageUnreadMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useMarkHostMessageUnreadMutation(baseOptions?: Apollo.MutationHookOptions<MarkHostMessageUnreadMutation, MarkHostMessageUnreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkHostMessageUnreadMutation, MarkHostMessageUnreadMutationVariables>(MarkHostMessageUnreadDocument, options);
      }
export type MarkHostMessageUnreadMutationHookResult = ReturnType<typeof useMarkHostMessageUnreadMutation>;
export type MarkHostMessageUnreadMutationResult = Apollo.MutationResult<MarkHostMessageUnreadMutation>;
export type MarkHostMessageUnreadMutationOptions = Apollo.BaseMutationOptions<MarkHostMessageUnreadMutation, MarkHostMessageUnreadMutationVariables>;
export const ReplyHostMessageDocument = gql`
    mutation ReplyHostMessage($messageId: UUID!, $body: String!) {
  hostMessage {
    reply(messageId: $messageId, body: $body) {
      messageId
      threadId
      sentAt
    }
  }
}
    `;
export type ReplyHostMessageMutationFn = Apollo.MutationFunction<ReplyHostMessageMutation, ReplyHostMessageMutationVariables>;

/**
 * __useReplyHostMessageMutation__
 *
 * To run a mutation, you first call `useReplyHostMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyHostMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyHostMessageMutation, { data, loading, error }] = useReplyHostMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useReplyHostMessageMutation(baseOptions?: Apollo.MutationHookOptions<ReplyHostMessageMutation, ReplyHostMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplyHostMessageMutation, ReplyHostMessageMutationVariables>(ReplyHostMessageDocument, options);
      }
export type ReplyHostMessageMutationHookResult = ReturnType<typeof useReplyHostMessageMutation>;
export type ReplyHostMessageMutationResult = Apollo.MutationResult<ReplyHostMessageMutation>;
export type ReplyHostMessageMutationOptions = Apollo.BaseMutationOptions<ReplyHostMessageMutation, ReplyHostMessageMutationVariables>;
export const ReadNotificationDocument = gql`
    mutation ReadNotification($id: UUID!) {
  notification {
    read(isRead: true, notificationId: $id)
  }
}
    `;
export type ReadNotificationMutationFn = Apollo.MutationFunction<ReadNotificationMutation, ReadNotificationMutationVariables>;

/**
 * __useReadNotificationMutation__
 *
 * To run a mutation, you first call `useReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationMutation, { data, loading, error }] = useReadNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationMutation, ReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, options);
      }
export type ReadNotificationMutationHookResult = ReturnType<typeof useReadNotificationMutation>;
export type ReadNotificationMutationResult = Apollo.MutationResult<ReadNotificationMutation>;
export type ReadNotificationMutationOptions = Apollo.BaseMutationOptions<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const ReadAllNotificationDocument = gql`
    mutation ReadAllNotification {
  notification {
    readAll
  }
}
    `;
export type ReadAllNotificationMutationFn = Apollo.MutationFunction<ReadAllNotificationMutation, ReadAllNotificationMutationVariables>;

/**
 * __useReadAllNotificationMutation__
 *
 * To run a mutation, you first call `useReadAllNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllNotificationMutation, { data, loading, error }] = useReadAllNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadAllNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllNotificationMutation, ReadAllNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllNotificationMutation, ReadAllNotificationMutationVariables>(ReadAllNotificationDocument, options);
      }
export type ReadAllNotificationMutationHookResult = ReturnType<typeof useReadAllNotificationMutation>;
export type ReadAllNotificationMutationResult = Apollo.MutationResult<ReadAllNotificationMutation>;
export type ReadAllNotificationMutationOptions = Apollo.BaseMutationOptions<ReadAllNotificationMutation, ReadAllNotificationMutationVariables>;
export const ClubBySlugCreateOfferDocument = gql`
    mutation ClubBySlugCreateOffer($payload: CreateOfferPayloadInput!, $slug: String!) {
  clubBySlug(slug: $slug) {
    createOffer(payload: $payload) {
      offerId
      rewardIds
    }
  }
}
    `;
export type ClubBySlugCreateOfferMutationFn = Apollo.MutationFunction<ClubBySlugCreateOfferMutation, ClubBySlugCreateOfferMutationVariables>;

/**
 * __useClubBySlugCreateOfferMutation__
 *
 * To run a mutation, you first call `useClubBySlugCreateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClubBySlugCreateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clubBySlugCreateOfferMutation, { data, loading, error }] = useClubBySlugCreateOfferMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useClubBySlugCreateOfferMutation(baseOptions?: Apollo.MutationHookOptions<ClubBySlugCreateOfferMutation, ClubBySlugCreateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClubBySlugCreateOfferMutation, ClubBySlugCreateOfferMutationVariables>(ClubBySlugCreateOfferDocument, options);
      }
export type ClubBySlugCreateOfferMutationHookResult = ReturnType<typeof useClubBySlugCreateOfferMutation>;
export type ClubBySlugCreateOfferMutationResult = Apollo.MutationResult<ClubBySlugCreateOfferMutation>;
export type ClubBySlugCreateOfferMutationOptions = Apollo.BaseMutationOptions<ClubBySlugCreateOfferMutation, ClubBySlugCreateOfferMutationVariables>;
export const ClubBySlugUpdateOfferDocument = gql`
    mutation ClubBySlugUpdateOffer($payload: UpdateOfferPayloadInput!, $offerId: UUID!, $slug: String!) {
  clubBySlug(slug: $slug) {
    offerById(offerId: $offerId) {
      updateOffer(payload: $payload)
    }
  }
}
    `;
export type ClubBySlugUpdateOfferMutationFn = Apollo.MutationFunction<ClubBySlugUpdateOfferMutation, ClubBySlugUpdateOfferMutationVariables>;

/**
 * __useClubBySlugUpdateOfferMutation__
 *
 * To run a mutation, you first call `useClubBySlugUpdateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClubBySlugUpdateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clubBySlugUpdateOfferMutation, { data, loading, error }] = useClubBySlugUpdateOfferMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      offerId: // value for 'offerId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useClubBySlugUpdateOfferMutation(baseOptions?: Apollo.MutationHookOptions<ClubBySlugUpdateOfferMutation, ClubBySlugUpdateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClubBySlugUpdateOfferMutation, ClubBySlugUpdateOfferMutationVariables>(ClubBySlugUpdateOfferDocument, options);
      }
export type ClubBySlugUpdateOfferMutationHookResult = ReturnType<typeof useClubBySlugUpdateOfferMutation>;
export type ClubBySlugUpdateOfferMutationResult = Apollo.MutationResult<ClubBySlugUpdateOfferMutation>;
export type ClubBySlugUpdateOfferMutationOptions = Apollo.BaseMutationOptions<ClubBySlugUpdateOfferMutation, ClubBySlugUpdateOfferMutationVariables>;
export const CreateAchievementDocument = gql`
    mutation CreateAchievement($payload: CreateAchievementPayloadInput!, $clubId: UUID!) {
  clubById(clubId: $clubId) {
    createAchievement(payload: $payload) {
      achievementId
    }
  }
}
    `;
export type CreateAchievementMutationFn = Apollo.MutationFunction<CreateAchievementMutation, CreateAchievementMutationVariables>;

/**
 * __useCreateAchievementMutation__
 *
 * To run a mutation, you first call `useCreateAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAchievementMutation, { data, loading, error }] = useCreateAchievementMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useCreateAchievementMutation(baseOptions?: Apollo.MutationHookOptions<CreateAchievementMutation, CreateAchievementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAchievementMutation, CreateAchievementMutationVariables>(CreateAchievementDocument, options);
      }
export type CreateAchievementMutationHookResult = ReturnType<typeof useCreateAchievementMutation>;
export type CreateAchievementMutationResult = Apollo.MutationResult<CreateAchievementMutation>;
export type CreateAchievementMutationOptions = Apollo.BaseMutationOptions<CreateAchievementMutation, CreateAchievementMutationVariables>;
export const UpdateAchievementDocument = gql`
    mutation UpdateAchievement($payload: UpdateAchievementPayloadInput!, $clubId: UUID!, $achievementId: UUID!) {
  clubById(clubId: $clubId) {
    achievementById(achievementId: $achievementId) {
      updateAchievement(payload: $payload)
    }
  }
}
    `;
export type UpdateAchievementMutationFn = Apollo.MutationFunction<UpdateAchievementMutation, UpdateAchievementMutationVariables>;

/**
 * __useUpdateAchievementMutation__
 *
 * To run a mutation, you first call `useUpdateAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAchievementMutation, { data, loading, error }] = useUpdateAchievementMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      clubId: // value for 'clubId'
 *      achievementId: // value for 'achievementId'
 *   },
 * });
 */
export function useUpdateAchievementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAchievementMutation, UpdateAchievementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAchievementMutation, UpdateAchievementMutationVariables>(UpdateAchievementDocument, options);
      }
export type UpdateAchievementMutationHookResult = ReturnType<typeof useUpdateAchievementMutation>;
export type UpdateAchievementMutationResult = Apollo.MutationResult<UpdateAchievementMutation>;
export type UpdateAchievementMutationOptions = Apollo.BaseMutationOptions<UpdateAchievementMutation, UpdateAchievementMutationVariables>;
export const PurchaseOfferDocument = gql`
    mutation PurchaseOffer($orderId: String!, $offerId: UUID!, $clubId: UUID!, $context: String) {
  clubById(clubId: $clubId) {
    offerById(offerId: $offerId) {
      purchaseOffer(orderId: $orderId, context: $context) {
        transactionStatus
        success
        message
        exMessage
      }
    }
  }
}
    `;
export type PurchaseOfferMutationFn = Apollo.MutationFunction<PurchaseOfferMutation, PurchaseOfferMutationVariables>;

/**
 * __usePurchaseOfferMutation__
 *
 * To run a mutation, you first call `usePurchaseOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseOfferMutation, { data, loading, error }] = usePurchaseOfferMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      offerId: // value for 'offerId'
 *      clubId: // value for 'clubId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function usePurchaseOfferMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseOfferMutation, PurchaseOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseOfferMutation, PurchaseOfferMutationVariables>(PurchaseOfferDocument, options);
      }
export type PurchaseOfferMutationHookResult = ReturnType<typeof usePurchaseOfferMutation>;
export type PurchaseOfferMutationResult = Apollo.MutationResult<PurchaseOfferMutation>;
export type PurchaseOfferMutationOptions = Apollo.BaseMutationOptions<PurchaseOfferMutation, PurchaseOfferMutationVariables>;
export const PurchaseOfferCreatePaymentOrderDocument = gql`
    mutation PurchaseOfferCreatePaymentOrder($offerId: UUID!, $clubId: UUID!, $token: String!) {
  clubById(clubId: $clubId) {
    offerById(offerId: $offerId) {
      createPaymentOrder(token: $token)
    }
  }
}
    `;
export type PurchaseOfferCreatePaymentOrderMutationFn = Apollo.MutationFunction<PurchaseOfferCreatePaymentOrderMutation, PurchaseOfferCreatePaymentOrderMutationVariables>;

/**
 * __usePurchaseOfferCreatePaymentOrderMutation__
 *
 * To run a mutation, you first call `usePurchaseOfferCreatePaymentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOfferCreatePaymentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseOfferCreatePaymentOrderMutation, { data, loading, error }] = usePurchaseOfferCreatePaymentOrderMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      clubId: // value for 'clubId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePurchaseOfferCreatePaymentOrderMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseOfferCreatePaymentOrderMutation, PurchaseOfferCreatePaymentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseOfferCreatePaymentOrderMutation, PurchaseOfferCreatePaymentOrderMutationVariables>(PurchaseOfferCreatePaymentOrderDocument, options);
      }
export type PurchaseOfferCreatePaymentOrderMutationHookResult = ReturnType<typeof usePurchaseOfferCreatePaymentOrderMutation>;
export type PurchaseOfferCreatePaymentOrderMutationResult = Apollo.MutationResult<PurchaseOfferCreatePaymentOrderMutation>;
export type PurchaseOfferCreatePaymentOrderMutationOptions = Apollo.BaseMutationOptions<PurchaseOfferCreatePaymentOrderMutation, PurchaseOfferCreatePaymentOrderMutationVariables>;
export const OfferGenerateWinnersDocument = gql`
    mutation OfferGenerateWinners($offerId: UUID!, $clubId: UUID!) {
  clubById(clubId: $clubId) {
    offerById(offerId: $offerId) {
      generateWinners
    }
  }
}
    `;
export type OfferGenerateWinnersMutationFn = Apollo.MutationFunction<OfferGenerateWinnersMutation, OfferGenerateWinnersMutationVariables>;

/**
 * __useOfferGenerateWinnersMutation__
 *
 * To run a mutation, you first call `useOfferGenerateWinnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferGenerateWinnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerGenerateWinnersMutation, { data, loading, error }] = useOfferGenerateWinnersMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useOfferGenerateWinnersMutation(baseOptions?: Apollo.MutationHookOptions<OfferGenerateWinnersMutation, OfferGenerateWinnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferGenerateWinnersMutation, OfferGenerateWinnersMutationVariables>(OfferGenerateWinnersDocument, options);
      }
export type OfferGenerateWinnersMutationHookResult = ReturnType<typeof useOfferGenerateWinnersMutation>;
export type OfferGenerateWinnersMutationResult = Apollo.MutationResult<OfferGenerateWinnersMutation>;
export type OfferGenerateWinnersMutationOptions = Apollo.BaseMutationOptions<OfferGenerateWinnersMutation, OfferGenerateWinnersMutationVariables>;
export const SubmitRedeemContactInfoDocument = gql`
    mutation SubmitRedeemContactInfo($args: SubmitRedeemOfferContactInfoArgsInput!, $offerId: UUID!, $clubId: UUID!) {
  clubById(clubId: $clubId) {
    offerById(offerId: $offerId) {
      submitRedeemContactInfo(args: $args)
    }
  }
}
    `;
export type SubmitRedeemContactInfoMutationFn = Apollo.MutationFunction<SubmitRedeemContactInfoMutation, SubmitRedeemContactInfoMutationVariables>;

/**
 * __useSubmitRedeemContactInfoMutation__
 *
 * To run a mutation, you first call `useSubmitRedeemContactInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRedeemContactInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRedeemContactInfoMutation, { data, loading, error }] = useSubmitRedeemContactInfoMutation({
 *   variables: {
 *      args: // value for 'args'
 *      offerId: // value for 'offerId'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useSubmitRedeemContactInfoMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRedeemContactInfoMutation, SubmitRedeemContactInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRedeemContactInfoMutation, SubmitRedeemContactInfoMutationVariables>(SubmitRedeemContactInfoDocument, options);
      }
export type SubmitRedeemContactInfoMutationHookResult = ReturnType<typeof useSubmitRedeemContactInfoMutation>;
export type SubmitRedeemContactInfoMutationResult = Apollo.MutationResult<SubmitRedeemContactInfoMutation>;
export type SubmitRedeemContactInfoMutationOptions = Apollo.BaseMutationOptions<SubmitRedeemContactInfoMutation, SubmitRedeemContactInfoMutationVariables>;
export const RedeemClubOfferDocument = gql`
    mutation RedeemClubOffer($token: String!) {
  redeemClubOffer(token: $token) {
    isValid
    redeemedCount
    rejectionReason
    redemption {
      ... on AccessPassRewardRedemption {
        code
        guide
        isGenerated
        note
        redemptionType
      }
      ... on CustomerInformationRewardRedemption {
        guide
        note
        redemptionType
      }
      ... on InviteLinkRewardRedemption {
        code
        guide
        isGenerated
        link
        note
        redemptionType
      }
      ... on LocationInformationRewardRedemption {
        code
        guide
        isGenerated
        note
        redemptionType
      }
      ... on PromoCodeRewardRedemption {
        code
        guide
        isGenerated
        note
        redemptionType
      }
    }
    club {
      clubId
    }
    offer {
      offerId
    }
  }
}
    `;
export type RedeemClubOfferMutationFn = Apollo.MutationFunction<RedeemClubOfferMutation, RedeemClubOfferMutationVariables>;

/**
 * __useRedeemClubOfferMutation__
 *
 * To run a mutation, you first call `useRedeemClubOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemClubOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemClubOfferMutation, { data, loading, error }] = useRedeemClubOfferMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRedeemClubOfferMutation(baseOptions?: Apollo.MutationHookOptions<RedeemClubOfferMutation, RedeemClubOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemClubOfferMutation, RedeemClubOfferMutationVariables>(RedeemClubOfferDocument, options);
      }
export type RedeemClubOfferMutationHookResult = ReturnType<typeof useRedeemClubOfferMutation>;
export type RedeemClubOfferMutationResult = Apollo.MutationResult<RedeemClubOfferMutation>;
export type RedeemClubOfferMutationOptions = Apollo.BaseMutationOptions<RedeemClubOfferMutation, RedeemClubOfferMutationVariables>;
export const OfferInviteFromContactsDocument = gql`
    mutation OfferInviteFromContacts($inviteAll: Boolean!, $offerId: UUID!, $slug: String!, $confirmedDoNotResendContactIds: [UUID!], $confirmedResendContactIds: [UUID!], $contactIds: [UUID!], $contactPageFilterArgs: ContactPageFilterArgsInput, $invitationMessage: String, $isViaSms: Boolean!) {
  clubBySlug(slug: $slug) {
    offerById(offerId: $offerId) {
      inviteFromContacts(
        inviteAll: $inviteAll
        confirmedDoNotResendContactIds: $confirmedDoNotResendContactIds
        confirmedResendContactIds: $confirmedResendContactIds
        contactIds: $contactIds
        contactPageFilterArgs: $contactPageFilterArgs
        invitationMessage: $invitationMessage
        isViaSms: $isViaSms
      ) {
        confirmingContacts {
          invitee {
            contactId
            emailAddress
            name
            phoneNumber
            userId
            userInfo {
              name
              userName
            }
          }
          inviter {
            name
            userId
            userName
          }
        }
        resentContacts
        sentContacts
        submittedContacts
        success
      }
    }
  }
}
    `;
export type OfferInviteFromContactsMutationFn = Apollo.MutationFunction<OfferInviteFromContactsMutation, OfferInviteFromContactsMutationVariables>;

/**
 * __useOfferInviteFromContactsMutation__
 *
 * To run a mutation, you first call `useOfferInviteFromContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferInviteFromContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerInviteFromContactsMutation, { data, loading, error }] = useOfferInviteFromContactsMutation({
 *   variables: {
 *      inviteAll: // value for 'inviteAll'
 *      offerId: // value for 'offerId'
 *      slug: // value for 'slug'
 *      confirmedDoNotResendContactIds: // value for 'confirmedDoNotResendContactIds'
 *      confirmedResendContactIds: // value for 'confirmedResendContactIds'
 *      contactIds: // value for 'contactIds'
 *      contactPageFilterArgs: // value for 'contactPageFilterArgs'
 *      invitationMessage: // value for 'invitationMessage'
 *      isViaSms: // value for 'isViaSms'
 *   },
 * });
 */
export function useOfferInviteFromContactsMutation(baseOptions?: Apollo.MutationHookOptions<OfferInviteFromContactsMutation, OfferInviteFromContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferInviteFromContactsMutation, OfferInviteFromContactsMutationVariables>(OfferInviteFromContactsDocument, options);
      }
export type OfferInviteFromContactsMutationHookResult = ReturnType<typeof useOfferInviteFromContactsMutation>;
export type OfferInviteFromContactsMutationResult = Apollo.MutationResult<OfferInviteFromContactsMutation>;
export type OfferInviteFromContactsMutationOptions = Apollo.BaseMutationOptions<OfferInviteFromContactsMutation, OfferInviteFromContactsMutationVariables>;
export const ProcessCreatePieDocument = gql`
    mutation ProcessCreatePie($orderId: String!) {
  paypal {
    processCreatePie(orderId: $orderId) {
      success
      message
    }
  }
}
    `;
export type ProcessCreatePieMutationFn = Apollo.MutationFunction<ProcessCreatePieMutation, ProcessCreatePieMutationVariables>;

/**
 * __useProcessCreatePieMutation__
 *
 * To run a mutation, you first call `useProcessCreatePieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessCreatePieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processCreatePieMutation, { data, loading, error }] = useProcessCreatePieMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useProcessCreatePieMutation(baseOptions?: Apollo.MutationHookOptions<ProcessCreatePieMutation, ProcessCreatePieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessCreatePieMutation, ProcessCreatePieMutationVariables>(ProcessCreatePieDocument, options);
      }
export type ProcessCreatePieMutationHookResult = ReturnType<typeof useProcessCreatePieMutation>;
export type ProcessCreatePieMutationResult = Apollo.MutationResult<ProcessCreatePieMutation>;
export type ProcessCreatePieMutationOptions = Apollo.BaseMutationOptions<ProcessCreatePieMutation, ProcessCreatePieMutationVariables>;
export const ProcessPurchasePieDocument = gql`
    mutation ProcessPurchasePie($orderId: String!, $context: String) {
  paypal {
    processPurchasePie(orderId: $orderId, context: $context) {
      success
      message
    }
  }
}
    `;
export type ProcessPurchasePieMutationFn = Apollo.MutationFunction<ProcessPurchasePieMutation, ProcessPurchasePieMutationVariables>;

/**
 * __useProcessPurchasePieMutation__
 *
 * To run a mutation, you first call `useProcessPurchasePieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessPurchasePieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processPurchasePieMutation, { data, loading, error }] = useProcessPurchasePieMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useProcessPurchasePieMutation(baseOptions?: Apollo.MutationHookOptions<ProcessPurchasePieMutation, ProcessPurchasePieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessPurchasePieMutation, ProcessPurchasePieMutationVariables>(ProcessPurchasePieDocument, options);
      }
export type ProcessPurchasePieMutationHookResult = ReturnType<typeof useProcessPurchasePieMutation>;
export type ProcessPurchasePieMutationResult = Apollo.MutationResult<ProcessPurchasePieMutation>;
export type ProcessPurchasePieMutationOptions = Apollo.BaseMutationOptions<ProcessPurchasePieMutation, ProcessPurchasePieMutationVariables>;
export const UpgradePieOrderDocument = gql`
    mutation UpgradePieOrder($pieId: UUID!, $slices: Decimal!) {
  paypal {
    upgradePieOrder(pieId: $pieId, slices: $slices)
  }
}
    `;
export type UpgradePieOrderMutationFn = Apollo.MutationFunction<UpgradePieOrderMutation, UpgradePieOrderMutationVariables>;

/**
 * __useUpgradePieOrderMutation__
 *
 * To run a mutation, you first call `useUpgradePieOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradePieOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradePieOrderMutation, { data, loading, error }] = useUpgradePieOrderMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      slices: // value for 'slices'
 *   },
 * });
 */
export function useUpgradePieOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpgradePieOrderMutation, UpgradePieOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradePieOrderMutation, UpgradePieOrderMutationVariables>(UpgradePieOrderDocument, options);
      }
export type UpgradePieOrderMutationHookResult = ReturnType<typeof useUpgradePieOrderMutation>;
export type UpgradePieOrderMutationResult = Apollo.MutationResult<UpgradePieOrderMutation>;
export type UpgradePieOrderMutationOptions = Apollo.BaseMutationOptions<UpgradePieOrderMutation, UpgradePieOrderMutationVariables>;
export const UpgradePieDocument = gql`
    mutation UpgradePie($paypalOrderId: String!) {
  paypal {
    processUpgradePie(paypalOrderId: $paypalOrderId) {
      success
      message
    }
  }
}
    `;
export type UpgradePieMutationFn = Apollo.MutationFunction<UpgradePieMutation, UpgradePieMutationVariables>;

/**
 * __useUpgradePieMutation__
 *
 * To run a mutation, you first call `useUpgradePieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradePieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradePieMutation, { data, loading, error }] = useUpgradePieMutation({
 *   variables: {
 *      paypalOrderId: // value for 'paypalOrderId'
 *   },
 * });
 */
export function useUpgradePieMutation(baseOptions?: Apollo.MutationHookOptions<UpgradePieMutation, UpgradePieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradePieMutation, UpgradePieMutationVariables>(UpgradePieDocument, options);
      }
export type UpgradePieMutationHookResult = ReturnType<typeof useUpgradePieMutation>;
export type UpgradePieMutationResult = Apollo.MutationResult<UpgradePieMutation>;
export type UpgradePieMutationOptions = Apollo.BaseMutationOptions<UpgradePieMutation, UpgradePieMutationVariables>;
export const CreateOrUpdatePieDocument = gql`
    mutation CreateOrUpdatePie($id: UUID, $displayName: String!, $individualAssetIds: [UUID!]!, $slug: String!, $bio: String!, $issuedSlices: Decimal!, $socialMedia: [SocialMediaPairInput!]!, $slicePrice: AmountInput!, $availableSlices: Decimal!) {
  pie {
    createOrUpdate(
      id: $id
      displayName: $displayName
      slug: $slug
      bio: $bio
      individualAssetIds: $individualAssetIds
      issuedSlices: $issuedSlices
      socialMedia: $socialMedia
      slicePrice: $slicePrice
      availableSlices: $availableSlices
    ) {
      pieId
      displayName
      slug
      bio
      socialMedia {
        value
        scheme
      }
      isVerified
      issuedSlices
      holdingSlices
      slicesHeld
      individualAssets
      pieAvatarUrl
      slicePrice {
        symbol
        value
      }
      canBuy
      canSell
      createdUtc
      initialOffer {
        maximumPurchaseVolume
        minimumPurchaseVolume
        purchaseMultiple
      }
      createdBy {
        userId
        name
        avatarUrl
        isVerified
        tier
      }
      totalValue {
        symbol
        value
      }
      floatPercentage
    }
  }
}
    `;
export type CreateOrUpdatePieMutationFn = Apollo.MutationFunction<CreateOrUpdatePieMutation, CreateOrUpdatePieMutationVariables>;

/**
 * __useCreateOrUpdatePieMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdatePieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdatePieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdatePieMutation, { data, loading, error }] = useCreateOrUpdatePieMutation({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *      individualAssetIds: // value for 'individualAssetIds'
 *      slug: // value for 'slug'
 *      bio: // value for 'bio'
 *      issuedSlices: // value for 'issuedSlices'
 *      socialMedia: // value for 'socialMedia'
 *      slicePrice: // value for 'slicePrice'
 *      availableSlices: // value for 'availableSlices'
 *   },
 * });
 */
export function useCreateOrUpdatePieMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdatePieMutation, CreateOrUpdatePieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdatePieMutation, CreateOrUpdatePieMutationVariables>(CreateOrUpdatePieDocument, options);
      }
export type CreateOrUpdatePieMutationHookResult = ReturnType<typeof useCreateOrUpdatePieMutation>;
export type CreateOrUpdatePieMutationResult = Apollo.MutationResult<CreateOrUpdatePieMutation>;
export type CreateOrUpdatePieMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdatePieMutation, CreateOrUpdatePieMutationVariables>;
export const UpdateBasicPieInfoDocument = gql`
    mutation UpdateBasicPieInfo($id: UUID!, $displayName: String!, $slug: String!, $bio: String!) {
  pie {
    updateBasicInfo(id: $id, displayName: $displayName, slug: $slug, bio: $bio) {
      pieId
      displayName
      slug
      bio
      socialMedia {
        value
        scheme
      }
      isVerified
      issuedSlices
      holdingSlices
      slicesHeld
      individualAssets
      pieAvatarUrl
      slicePrice {
        symbol
        value
      }
      canBuy
      canSell
      createdUtc
      initialOffer {
        maximumPurchaseVolume
        minimumPurchaseVolume
        purchaseMultiple
      }
      createdBy {
        userId
        name
        avatarUrl
        isVerified
        tier
      }
      totalValue {
        symbol
        value
      }
      floatPercentage
    }
  }
}
    `;
export type UpdateBasicPieInfoMutationFn = Apollo.MutationFunction<UpdateBasicPieInfoMutation, UpdateBasicPieInfoMutationVariables>;

/**
 * __useUpdateBasicPieInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBasicPieInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasicPieInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBasicPieInfoMutation, { data, loading, error }] = useUpdateBasicPieInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *      slug: // value for 'slug'
 *      bio: // value for 'bio'
 *   },
 * });
 */
export function useUpdateBasicPieInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBasicPieInfoMutation, UpdateBasicPieInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBasicPieInfoMutation, UpdateBasicPieInfoMutationVariables>(UpdateBasicPieInfoDocument, options);
      }
export type UpdateBasicPieInfoMutationHookResult = ReturnType<typeof useUpdateBasicPieInfoMutation>;
export type UpdateBasicPieInfoMutationResult = Apollo.MutationResult<UpdateBasicPieInfoMutation>;
export type UpdateBasicPieInfoMutationOptions = Apollo.BaseMutationOptions<UpdateBasicPieInfoMutation, UpdateBasicPieInfoMutationVariables>;
export const UpdateAppearanceDocument = gql`
    mutation UpdateAppearance($pieId: UUID!, $individualAssetIds: [UUID!]!) {
  pie {
    updateAppearance(id: $pieId, individualAssetIds: $individualAssetIds)
  }
}
    `;
export type UpdateAppearanceMutationFn = Apollo.MutationFunction<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>;

/**
 * __useUpdateAppearanceMutation__
 *
 * To run a mutation, you first call `useUpdateAppearanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppearanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppearanceMutation, { data, loading, error }] = useUpdateAppearanceMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      individualAssetIds: // value for 'individualAssetIds'
 *   },
 * });
 */
export function useUpdateAppearanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>(UpdateAppearanceDocument, options);
      }
export type UpdateAppearanceMutationHookResult = ReturnType<typeof useUpdateAppearanceMutation>;
export type UpdateAppearanceMutationResult = Apollo.MutationResult<UpdateAppearanceMutation>;
export type UpdateAppearanceMutationOptions = Apollo.BaseMutationOptions<UpdateAppearanceMutation, UpdateAppearanceMutationVariables>;
export const ReleaseSlicesDocument = gql`
    mutation ReleaseSlices($pieId: UUID!, $availableSlices: Decimal!, $slicePrice: AmountInput!) {
  pie {
    releaseSlices(
      pieId: $pieId
      availableSlices: $availableSlices
      slicePrice: $slicePrice
    )
  }
}
    `;
export type ReleaseSlicesMutationFn = Apollo.MutationFunction<ReleaseSlicesMutation, ReleaseSlicesMutationVariables>;

/**
 * __useReleaseSlicesMutation__
 *
 * To run a mutation, you first call `useReleaseSlicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseSlicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseSlicesMutation, { data, loading, error }] = useReleaseSlicesMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      availableSlices: // value for 'availableSlices'
 *      slicePrice: // value for 'slicePrice'
 *   },
 * });
 */
export function useReleaseSlicesMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseSlicesMutation, ReleaseSlicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseSlicesMutation, ReleaseSlicesMutationVariables>(ReleaseSlicesDocument, options);
      }
export type ReleaseSlicesMutationHookResult = ReturnType<typeof useReleaseSlicesMutation>;
export type ReleaseSlicesMutationResult = Apollo.MutationResult<ReleaseSlicesMutation>;
export type ReleaseSlicesMutationOptions = Apollo.BaseMutationOptions<ReleaseSlicesMutation, ReleaseSlicesMutationVariables>;
export const TransferSlicesDocument = gql`
    mutation TransferSlices($pieId: UUID!, $slices: Int!, $targetUserName: String!, $source: WithdrawSource!) {
  pie {
    transferSlices(
      pieId: $pieId
      slices: $slices
      targetUserName: $targetUserName
      source: $source
    )
  }
}
    `;
export type TransferSlicesMutationFn = Apollo.MutationFunction<TransferSlicesMutation, TransferSlicesMutationVariables>;

/**
 * __useTransferSlicesMutation__
 *
 * To run a mutation, you first call `useTransferSlicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferSlicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferSlicesMutation, { data, loading, error }] = useTransferSlicesMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      slices: // value for 'slices'
 *      targetUserName: // value for 'targetUserName'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useTransferSlicesMutation(baseOptions?: Apollo.MutationHookOptions<TransferSlicesMutation, TransferSlicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferSlicesMutation, TransferSlicesMutationVariables>(TransferSlicesDocument, options);
      }
export type TransferSlicesMutationHookResult = ReturnType<typeof useTransferSlicesMutation>;
export type TransferSlicesMutationResult = Apollo.MutationResult<TransferSlicesMutation>;
export type TransferSlicesMutationOptions = Apollo.BaseMutationOptions<TransferSlicesMutation, TransferSlicesMutationVariables>;
export const TransferSlicesToPieDocument = gql`
    mutation TransferSlicesToPie($pieId: UUID!, $slices: Int!) {
  pie {
    transferSlicesToPie(pieId: $pieId, slices: $slices)
  }
}
    `;
export type TransferSlicesToPieMutationFn = Apollo.MutationFunction<TransferSlicesToPieMutation, TransferSlicesToPieMutationVariables>;

/**
 * __useTransferSlicesToPieMutation__
 *
 * To run a mutation, you first call `useTransferSlicesToPieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferSlicesToPieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferSlicesToPieMutation, { data, loading, error }] = useTransferSlicesToPieMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      slices: // value for 'slices'
 *   },
 * });
 */
export function useTransferSlicesToPieMutation(baseOptions?: Apollo.MutationHookOptions<TransferSlicesToPieMutation, TransferSlicesToPieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferSlicesToPieMutation, TransferSlicesToPieMutationVariables>(TransferSlicesToPieDocument, options);
      }
export type TransferSlicesToPieMutationHookResult = ReturnType<typeof useTransferSlicesToPieMutation>;
export type TransferSlicesToPieMutationResult = Apollo.MutationResult<TransferSlicesToPieMutation>;
export type TransferSlicesToPieMutationOptions = Apollo.BaseMutationOptions<TransferSlicesToPieMutation, TransferSlicesToPieMutationVariables>;
export const ActivateOnboardingProcessDocument = gql`
    mutation ActivateOnboardingProcess($pieId: UUID!) {
  pie {
    activateOnboardingProcess(pieId: $pieId)
  }
}
    `;
export type ActivateOnboardingProcessMutationFn = Apollo.MutationFunction<ActivateOnboardingProcessMutation, ActivateOnboardingProcessMutationVariables>;

/**
 * __useActivateOnboardingProcessMutation__
 *
 * To run a mutation, you first call `useActivateOnboardingProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateOnboardingProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateOnboardingProcessMutation, { data, loading, error }] = useActivateOnboardingProcessMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *   },
 * });
 */
export function useActivateOnboardingProcessMutation(baseOptions?: Apollo.MutationHookOptions<ActivateOnboardingProcessMutation, ActivateOnboardingProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateOnboardingProcessMutation, ActivateOnboardingProcessMutationVariables>(ActivateOnboardingProcessDocument, options);
      }
export type ActivateOnboardingProcessMutationHookResult = ReturnType<typeof useActivateOnboardingProcessMutation>;
export type ActivateOnboardingProcessMutationResult = Apollo.MutationResult<ActivateOnboardingProcessMutation>;
export type ActivateOnboardingProcessMutationOptions = Apollo.BaseMutationOptions<ActivateOnboardingProcessMutation, ActivateOnboardingProcessMutationVariables>;
export const CompletePieActivationProcessDocument = gql`
    mutation CompletePieActivationProcess($id: UUID!, $displayName: String!, $bio: String!, $socialMedia: [SocialMediaPairInput!]!, $individualAssetIds: [UUID!]!, $slicePrice: AmountInput!, $availableSlices: Decimal!, $slug: String!) {
  pie {
    completePieActivationProcess(
      id: $id
      displayName: $displayName
      bio: $bio
      socialMedia: $socialMedia
      individualAssetIds: $individualAssetIds
      slicePrice: $slicePrice
      availableSlices: $availableSlices
      slug: $slug
    )
  }
}
    `;
export type CompletePieActivationProcessMutationFn = Apollo.MutationFunction<CompletePieActivationProcessMutation, CompletePieActivationProcessMutationVariables>;

/**
 * __useCompletePieActivationProcessMutation__
 *
 * To run a mutation, you first call `useCompletePieActivationProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePieActivationProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePieActivationProcessMutation, { data, loading, error }] = useCompletePieActivationProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *      bio: // value for 'bio'
 *      socialMedia: // value for 'socialMedia'
 *      individualAssetIds: // value for 'individualAssetIds'
 *      slicePrice: // value for 'slicePrice'
 *      availableSlices: // value for 'availableSlices'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCompletePieActivationProcessMutation(baseOptions?: Apollo.MutationHookOptions<CompletePieActivationProcessMutation, CompletePieActivationProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompletePieActivationProcessMutation, CompletePieActivationProcessMutationVariables>(CompletePieActivationProcessDocument, options);
      }
export type CompletePieActivationProcessMutationHookResult = ReturnType<typeof useCompletePieActivationProcessMutation>;
export type CompletePieActivationProcessMutationResult = Apollo.MutationResult<CompletePieActivationProcessMutation>;
export type CompletePieActivationProcessMutationOptions = Apollo.BaseMutationOptions<CompletePieActivationProcessMutation, CompletePieActivationProcessMutationVariables>;
export const GrantModeratorDocument = gql`
    mutation GrantModerator($pieId: UUID!, $userName: String!, $pieRole: PieRole!) {
  pie {
    grantModerator(pieId: $pieId, userName: $userName, pieRole: $pieRole)
  }
}
    `;
export type GrantModeratorMutationFn = Apollo.MutationFunction<GrantModeratorMutation, GrantModeratorMutationVariables>;

/**
 * __useGrantModeratorMutation__
 *
 * To run a mutation, you first call `useGrantModeratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantModeratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantModeratorMutation, { data, loading, error }] = useGrantModeratorMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      userName: // value for 'userName'
 *      pieRole: // value for 'pieRole'
 *   },
 * });
 */
export function useGrantModeratorMutation(baseOptions?: Apollo.MutationHookOptions<GrantModeratorMutation, GrantModeratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantModeratorMutation, GrantModeratorMutationVariables>(GrantModeratorDocument, options);
      }
export type GrantModeratorMutationHookResult = ReturnType<typeof useGrantModeratorMutation>;
export type GrantModeratorMutationResult = Apollo.MutationResult<GrantModeratorMutation>;
export type GrantModeratorMutationOptions = Apollo.BaseMutationOptions<GrantModeratorMutation, GrantModeratorMutationVariables>;
export const DeleteModeratorDocument = gql`
    mutation DeleteModerator($pieId: UUID!, $userId: UUID!) {
  pie {
    deleteModerator(pieId: $pieId, userId: $userId)
  }
}
    `;
export type DeleteModeratorMutationFn = Apollo.MutationFunction<DeleteModeratorMutation, DeleteModeratorMutationVariables>;

/**
 * __useDeleteModeratorMutation__
 *
 * To run a mutation, you first call `useDeleteModeratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModeratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModeratorMutation, { data, loading, error }] = useDeleteModeratorMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteModeratorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModeratorMutation, DeleteModeratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModeratorMutation, DeleteModeratorMutationVariables>(DeleteModeratorDocument, options);
      }
export type DeleteModeratorMutationHookResult = ReturnType<typeof useDeleteModeratorMutation>;
export type DeleteModeratorMutationResult = Apollo.MutationResult<DeleteModeratorMutation>;
export type DeleteModeratorMutationOptions = Apollo.BaseMutationOptions<DeleteModeratorMutation, DeleteModeratorMutationVariables>;
export const TransferPieDocument = gql`
    mutation TransferPie($pieId: UUID!, $userName: String!) {
  pie {
    transferPie(pieId: $pieId, userName: $userName)
  }
}
    `;
export type TransferPieMutationFn = Apollo.MutationFunction<TransferPieMutation, TransferPieMutationVariables>;

/**
 * __useTransferPieMutation__
 *
 * To run a mutation, you first call `useTransferPieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferPieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferPieMutation, { data, loading, error }] = useTransferPieMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useTransferPieMutation(baseOptions?: Apollo.MutationHookOptions<TransferPieMutation, TransferPieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferPieMutation, TransferPieMutationVariables>(TransferPieDocument, options);
      }
export type TransferPieMutationHookResult = ReturnType<typeof useTransferPieMutation>;
export type TransferPieMutationResult = Apollo.MutationResult<TransferPieMutation>;
export type TransferPieMutationOptions = Apollo.BaseMutationOptions<TransferPieMutation, TransferPieMutationVariables>;
export const AcceptPieOwnershipDocument = gql`
    mutation AcceptPieOwnership($pieId: UUID!, $accept: Boolean!) {
  pie {
    acceptPieOwnership(pieId: $pieId, accept: $accept)
  }
}
    `;
export type AcceptPieOwnershipMutationFn = Apollo.MutationFunction<AcceptPieOwnershipMutation, AcceptPieOwnershipMutationVariables>;

/**
 * __useAcceptPieOwnershipMutation__
 *
 * To run a mutation, you first call `useAcceptPieOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPieOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPieOwnershipMutation, { data, loading, error }] = useAcceptPieOwnershipMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      accept: // value for 'accept'
 *   },
 * });
 */
export function useAcceptPieOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<AcceptPieOwnershipMutation, AcceptPieOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptPieOwnershipMutation, AcceptPieOwnershipMutationVariables>(AcceptPieOwnershipDocument, options);
      }
export type AcceptPieOwnershipMutationHookResult = ReturnType<typeof useAcceptPieOwnershipMutation>;
export type AcceptPieOwnershipMutationResult = Apollo.MutationResult<AcceptPieOwnershipMutation>;
export type AcceptPieOwnershipMutationOptions = Apollo.BaseMutationOptions<AcceptPieOwnershipMutation, AcceptPieOwnershipMutationVariables>;
export const PublicUpdateEmailSubscriptionDocument = gql`
    mutation PublicUpdateEmailSubscription($emailAddress: String!, $emailSubscriptionOptions: [EmailSubscriptionArgsInput!]!) {
  public {
    userByEmail(emailAddress: $emailAddress) {
      updateEmailSubscription(args: $emailSubscriptionOptions)
    }
  }
}
    `;
export type PublicUpdateEmailSubscriptionMutationFn = Apollo.MutationFunction<PublicUpdateEmailSubscriptionMutation, PublicUpdateEmailSubscriptionMutationVariables>;

/**
 * __usePublicUpdateEmailSubscriptionMutation__
 *
 * To run a mutation, you first call `usePublicUpdateEmailSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicUpdateEmailSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicUpdateEmailSubscriptionMutation, { data, loading, error }] = usePublicUpdateEmailSubscriptionMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      emailSubscriptionOptions: // value for 'emailSubscriptionOptions'
 *   },
 * });
 */
export function usePublicUpdateEmailSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<PublicUpdateEmailSubscriptionMutation, PublicUpdateEmailSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicUpdateEmailSubscriptionMutation, PublicUpdateEmailSubscriptionMutationVariables>(PublicUpdateEmailSubscriptionDocument, options);
      }
export type PublicUpdateEmailSubscriptionMutationHookResult = ReturnType<typeof usePublicUpdateEmailSubscriptionMutation>;
export type PublicUpdateEmailSubscriptionMutationResult = Apollo.MutationResult<PublicUpdateEmailSubscriptionMutation>;
export type PublicUpdateEmailSubscriptionMutationOptions = Apollo.BaseMutationOptions<PublicUpdateEmailSubscriptionMutation, PublicUpdateEmailSubscriptionMutationVariables>;
export const GetReferralLinkDocument = gql`
    mutation GetReferralLink($eventId: UUID!) {
  referral {
    getLink(eventId: $eventId)
  }
}
    `;
export type GetReferralLinkMutationFn = Apollo.MutationFunction<GetReferralLinkMutation, GetReferralLinkMutationVariables>;

/**
 * __useGetReferralLinkMutation__
 *
 * To run a mutation, you first call `useGetReferralLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetReferralLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getReferralLinkMutation, { data, loading, error }] = useGetReferralLinkMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetReferralLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetReferralLinkMutation, GetReferralLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetReferralLinkMutation, GetReferralLinkMutationVariables>(GetReferralLinkDocument, options);
      }
export type GetReferralLinkMutationHookResult = ReturnType<typeof useGetReferralLinkMutation>;
export type GetReferralLinkMutationResult = Apollo.MutationResult<GetReferralLinkMutation>;
export type GetReferralLinkMutationOptions = Apollo.BaseMutationOptions<GetReferralLinkMutation, GetReferralLinkMutationVariables>;
export const RecordReferralPageViewDocument = gql`
    mutation RecordReferralPageView($token: String!, $anonymousSessionId: String) {
  referral {
    recordPageView(token: $token, anonymousSessionId: $anonymousSessionId)
  }
}
    `;
export type RecordReferralPageViewMutationFn = Apollo.MutationFunction<RecordReferralPageViewMutation, RecordReferralPageViewMutationVariables>;

/**
 * __useRecordReferralPageViewMutation__
 *
 * To run a mutation, you first call `useRecordReferralPageViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordReferralPageViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordReferralPageViewMutation, { data, loading, error }] = useRecordReferralPageViewMutation({
 *   variables: {
 *      token: // value for 'token'
 *      anonymousSessionId: // value for 'anonymousSessionId'
 *   },
 * });
 */
export function useRecordReferralPageViewMutation(baseOptions?: Apollo.MutationHookOptions<RecordReferralPageViewMutation, RecordReferralPageViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordReferralPageViewMutation, RecordReferralPageViewMutationVariables>(RecordReferralPageViewDocument, options);
      }
export type RecordReferralPageViewMutationHookResult = ReturnType<typeof useRecordReferralPageViewMutation>;
export type RecordReferralPageViewMutationResult = Apollo.MutationResult<RecordReferralPageViewMutation>;
export type RecordReferralPageViewMutationOptions = Apollo.BaseMutationOptions<RecordReferralPageViewMutation, RecordReferralPageViewMutationVariables>;
export const RecordReferralSignupDocument = gql`
    mutation RecordReferralSignup($token: String!) {
  referral {
    recordSignup(token: $token)
  }
}
    `;
export type RecordReferralSignupMutationFn = Apollo.MutationFunction<RecordReferralSignupMutation, RecordReferralSignupMutationVariables>;

/**
 * __useRecordReferralSignupMutation__
 *
 * To run a mutation, you first call `useRecordReferralSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordReferralSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordReferralSignupMutation, { data, loading, error }] = useRecordReferralSignupMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRecordReferralSignupMutation(baseOptions?: Apollo.MutationHookOptions<RecordReferralSignupMutation, RecordReferralSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordReferralSignupMutation, RecordReferralSignupMutationVariables>(RecordReferralSignupDocument, options);
      }
export type RecordReferralSignupMutationHookResult = ReturnType<typeof useRecordReferralSignupMutation>;
export type RecordReferralSignupMutationResult = Apollo.MutationResult<RecordReferralSignupMutation>;
export type RecordReferralSignupMutationOptions = Apollo.BaseMutationOptions<RecordReferralSignupMutation, RecordReferralSignupMutationVariables>;
export const CreateClubDocument = gql`
    mutation CreateClub($payload: CreateClubPayloadInput!, $type: ClubUploadAsset!, $contentLength: Long!, $contentType: String!) {
  createClub(payload: $payload) {
    clubId
    prepareUpload(
      type: $type
      contentLength: $contentLength
      contentType: $contentType
    ) {
      method
      token
      uploadUrl
    }
  }
}
    `;
export type CreateClubMutationFn = Apollo.MutationFunction<CreateClubMutation, CreateClubMutationVariables>;

/**
 * __useCreateClubMutation__
 *
 * To run a mutation, you first call `useCreateClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClubMutation, { data, loading, error }] = useCreateClubMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      type: // value for 'type'
 *      contentLength: // value for 'contentLength'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useCreateClubMutation(baseOptions?: Apollo.MutationHookOptions<CreateClubMutation, CreateClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClubMutation, CreateClubMutationVariables>(CreateClubDocument, options);
      }
export type CreateClubMutationHookResult = ReturnType<typeof useCreateClubMutation>;
export type CreateClubMutationResult = Apollo.MutationResult<CreateClubMutation>;
export type CreateClubMutationOptions = Apollo.BaseMutationOptions<CreateClubMutation, CreateClubMutationVariables>;
export const UpdateClubDocument = gql`
    mutation UpdateClub($clubId: UUID!, $payload: UpdateClubPayloadInput!, $type: ClubUploadAsset!, $contentLength: Long!, $contentType: String!) {
  clubById(clubId: $clubId) {
    updateClub(payload: $payload) {
      prepareUpload(
        type: $type
        contentLength: $contentLength
        contentType: $contentType
      ) {
        method
        token
        uploadUrl
      }
    }
  }
}
    `;
export type UpdateClubMutationFn = Apollo.MutationFunction<UpdateClubMutation, UpdateClubMutationVariables>;

/**
 * __useUpdateClubMutation__
 *
 * To run a mutation, you first call `useUpdateClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClubMutation, { data, loading, error }] = useUpdateClubMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      payload: // value for 'payload'
 *      type: // value for 'type'
 *      contentLength: // value for 'contentLength'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useUpdateClubMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClubMutation, UpdateClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClubMutation, UpdateClubMutationVariables>(UpdateClubDocument, options);
      }
export type UpdateClubMutationHookResult = ReturnType<typeof useUpdateClubMutation>;
export type UpdateClubMutationResult = Apollo.MutationResult<UpdateClubMutation>;
export type UpdateClubMutationOptions = Apollo.BaseMutationOptions<UpdateClubMutation, UpdateClubMutationVariables>;
export const InviteTeamCollaboratorDocument = gql`
    mutation InviteTeamCollaborator($clubId: UUID!, $memo: String!, $role: TeamCollaboratorRole!, $clubByIdClubId2: UUID!, $userId: UUID, $emailAddress: String, $expiredAt: DateTime, $usesPerInvite: Int!, $redirectUrl: String) {
  clubById(clubId: $clubByIdClubId2) {
    inviteTeamCollaborator(
      memo: $memo
      role: $role
      userId: $userId
      emailAddress: $emailAddress
      expiredAt: $expiredAt
      usesPerInvite: $usesPerInvite
      redirectUrl: $redirectUrl
    ) {
      formattedInviteId
      inviteId
    }
  }
}
    `;
export type InviteTeamCollaboratorMutationFn = Apollo.MutationFunction<InviteTeamCollaboratorMutation, InviteTeamCollaboratorMutationVariables>;

/**
 * __useInviteTeamCollaboratorMutation__
 *
 * To run a mutation, you first call `useInviteTeamCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteTeamCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteTeamCollaboratorMutation, { data, loading, error }] = useInviteTeamCollaboratorMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      memo: // value for 'memo'
 *      role: // value for 'role'
 *      clubByIdClubId2: // value for 'clubByIdClubId2'
 *      userId: // value for 'userId'
 *      emailAddress: // value for 'emailAddress'
 *      expiredAt: // value for 'expiredAt'
 *      usesPerInvite: // value for 'usesPerInvite'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useInviteTeamCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<InviteTeamCollaboratorMutation, InviteTeamCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteTeamCollaboratorMutation, InviteTeamCollaboratorMutationVariables>(InviteTeamCollaboratorDocument, options);
      }
export type InviteTeamCollaboratorMutationHookResult = ReturnType<typeof useInviteTeamCollaboratorMutation>;
export type InviteTeamCollaboratorMutationResult = Apollo.MutationResult<InviteTeamCollaboratorMutation>;
export type InviteTeamCollaboratorMutationOptions = Apollo.BaseMutationOptions<InviteTeamCollaboratorMutation, InviteTeamCollaboratorMutationVariables>;
export const InviteTeamMemberDocument = gql`
    mutation InviteTeamMember($clubId: UUID!, $memo: String!, $roleId: UUID!, $userId: UUID, $emailAddress: String, $expiredAt: DateTime, $usesPerInvite: Int!, $redirectUrl: String) {
  clubById(clubId: $clubId) {
    inviteTeamMember(
      memo: $memo
      roleId: $roleId
      userId: $userId
      emailAddress: $emailAddress
      expiredAt: $expiredAt
      usesPerInvite: $usesPerInvite
      redirectUrl: $redirectUrl
    ) {
      formattedInviteId
      inviteId
    }
  }
}
    `;
export type InviteTeamMemberMutationFn = Apollo.MutationFunction<InviteTeamMemberMutation, InviteTeamMemberMutationVariables>;

/**
 * __useInviteTeamMemberMutation__
 *
 * To run a mutation, you first call `useInviteTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteTeamMemberMutation, { data, loading, error }] = useInviteTeamMemberMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      memo: // value for 'memo'
 *      roleId: // value for 'roleId'
 *      userId: // value for 'userId'
 *      emailAddress: // value for 'emailAddress'
 *      expiredAt: // value for 'expiredAt'
 *      usesPerInvite: // value for 'usesPerInvite'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useInviteTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<InviteTeamMemberMutation, InviteTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteTeamMemberMutation, InviteTeamMemberMutationVariables>(InviteTeamMemberDocument, options);
      }
export type InviteTeamMemberMutationHookResult = ReturnType<typeof useInviteTeamMemberMutation>;
export type InviteTeamMemberMutationResult = Apollo.MutationResult<InviteTeamMemberMutation>;
export type InviteTeamMemberMutationOptions = Apollo.BaseMutationOptions<InviteTeamMemberMutation, InviteTeamMemberMutationVariables>;
export const DeleteTeamCollaboratorDocument = gql`
    mutation DeleteTeamCollaborator($clubId: UUID!, $userId: UUID!) {
  clubById(clubId: $clubId) {
    deleteTeamCollaborator(userId: $userId)
  }
}
    `;
export type DeleteTeamCollaboratorMutationFn = Apollo.MutationFunction<DeleteTeamCollaboratorMutation, DeleteTeamCollaboratorMutationVariables>;

/**
 * __useDeleteTeamCollaboratorMutation__
 *
 * To run a mutation, you first call `useDeleteTeamCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamCollaboratorMutation, { data, loading, error }] = useDeleteTeamCollaboratorMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteTeamCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamCollaboratorMutation, DeleteTeamCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamCollaboratorMutation, DeleteTeamCollaboratorMutationVariables>(DeleteTeamCollaboratorDocument, options);
      }
export type DeleteTeamCollaboratorMutationHookResult = ReturnType<typeof useDeleteTeamCollaboratorMutation>;
export type DeleteTeamCollaboratorMutationResult = Apollo.MutationResult<DeleteTeamCollaboratorMutation>;
export type DeleteTeamCollaboratorMutationOptions = Apollo.BaseMutationOptions<DeleteTeamCollaboratorMutation, DeleteTeamCollaboratorMutationVariables>;
export const DeleteTeamMemberDocument = gql`
    mutation DeleteTeamMember($clubId: UUID!, $userId: UUID!) {
  clubById(clubId: $clubId) {
    deleteTeamMember(userId: $userId)
  }
}
    `;
export type DeleteTeamMemberMutationFn = Apollo.MutationFunction<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>;

/**
 * __useDeleteTeamMemberMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMemberMutation, { data, loading, error }] = useDeleteTeamMemberMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>(DeleteTeamMemberDocument, options);
      }
export type DeleteTeamMemberMutationHookResult = ReturnType<typeof useDeleteTeamMemberMutation>;
export type DeleteTeamMemberMutationResult = Apollo.MutationResult<DeleteTeamMemberMutation>;
export type DeleteTeamMemberMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>;
export const UpdateTeamCollaboratorDocument = gql`
    mutation UpdateTeamCollaborator($clubId: UUID!, $userId: UUID!, $role: TeamCollaboratorRole!) {
  clubById(clubId: $clubId) {
    updateTeamCollaborator(userId: $userId, role: $role)
  }
}
    `;
export type UpdateTeamCollaboratorMutationFn = Apollo.MutationFunction<UpdateTeamCollaboratorMutation, UpdateTeamCollaboratorMutationVariables>;

/**
 * __useUpdateTeamCollaboratorMutation__
 *
 * To run a mutation, you first call `useUpdateTeamCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamCollaboratorMutation, { data, loading, error }] = useUpdateTeamCollaboratorMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateTeamCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamCollaboratorMutation, UpdateTeamCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamCollaboratorMutation, UpdateTeamCollaboratorMutationVariables>(UpdateTeamCollaboratorDocument, options);
      }
export type UpdateTeamCollaboratorMutationHookResult = ReturnType<typeof useUpdateTeamCollaboratorMutation>;
export type UpdateTeamCollaboratorMutationResult = Apollo.MutationResult<UpdateTeamCollaboratorMutation>;
export type UpdateTeamCollaboratorMutationOptions = Apollo.BaseMutationOptions<UpdateTeamCollaboratorMutation, UpdateTeamCollaboratorMutationVariables>;
export const UpdateTeamMemberDocument = gql`
    mutation UpdateTeamMember($clubId: UUID!, $userId: UUID!, $roleId: UUID!) {
  clubById(clubId: $clubId) {
    updateTeamMember(userId: $userId, roleId: $roleId)
  }
}
    `;
export type UpdateTeamMemberMutationFn = Apollo.MutationFunction<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>;

/**
 * __useUpdateTeamMemberMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMemberMutation, { data, loading, error }] = useUpdateTeamMemberMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useUpdateTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>(UpdateTeamMemberDocument, options);
      }
export type UpdateTeamMemberMutationHookResult = ReturnType<typeof useUpdateTeamMemberMutation>;
export type UpdateTeamMemberMutationResult = Apollo.MutationResult<UpdateTeamMemberMutation>;
export type UpdateTeamMemberMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>;
export const TransferClubOwnershipDocument = gql`
    mutation TransferClubOwnership($clubId: UUID!, $userId: UUID!) {
  clubById(clubId: $clubId) {
    transferOwnership(userId: $userId)
  }
}
    `;
export type TransferClubOwnershipMutationFn = Apollo.MutationFunction<TransferClubOwnershipMutation, TransferClubOwnershipMutationVariables>;

/**
 * __useTransferClubOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferClubOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferClubOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferClubOwnershipMutation, { data, loading, error }] = useTransferClubOwnershipMutation({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTransferClubOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<TransferClubOwnershipMutation, TransferClubOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferClubOwnershipMutation, TransferClubOwnershipMutationVariables>(TransferClubOwnershipDocument, options);
      }
export type TransferClubOwnershipMutationHookResult = ReturnType<typeof useTransferClubOwnershipMutation>;
export type TransferClubOwnershipMutationResult = Apollo.MutationResult<TransferClubOwnershipMutation>;
export type TransferClubOwnershipMutationOptions = Apollo.BaseMutationOptions<TransferClubOwnershipMutation, TransferClubOwnershipMutationVariables>;
export const UpdateClubSlugDocument = gql`
    mutation UpdateClubSlug($slug: String!, $clubId: UUID!) {
  clubById(clubId: $clubId) {
    updateSlug(slug: $slug)
  }
}
    `;
export type UpdateClubSlugMutationFn = Apollo.MutationFunction<UpdateClubSlugMutation, UpdateClubSlugMutationVariables>;

/**
 * __useUpdateClubSlugMutation__
 *
 * To run a mutation, you first call `useUpdateClubSlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClubSlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClubSlugMutation, { data, loading, error }] = useUpdateClubSlugMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useUpdateClubSlugMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClubSlugMutation, UpdateClubSlugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClubSlugMutation, UpdateClubSlugMutationVariables>(UpdateClubSlugDocument, options);
      }
export type UpdateClubSlugMutationHookResult = ReturnType<typeof useUpdateClubSlugMutation>;
export type UpdateClubSlugMutationResult = Apollo.MutationResult<UpdateClubSlugMutation>;
export type UpdateClubSlugMutationOptions = Apollo.BaseMutationOptions<UpdateClubSlugMutation, UpdateClubSlugMutationVariables>;
export const CreateOrUpdateTiersDocument = gql`
    mutation CreateOrUpdateTiers($tiers: [ClubTierPayloadInput!]!, $clubId: UUID!) {
  clubById(clubId: $clubId) {
    createOrUpdateTiers(tiers: $tiers)
  }
}
    `;
export type CreateOrUpdateTiersMutationFn = Apollo.MutationFunction<CreateOrUpdateTiersMutation, CreateOrUpdateTiersMutationVariables>;

/**
 * __useCreateOrUpdateTiersMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateTiersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateTiersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateTiersMutation, { data, loading, error }] = useCreateOrUpdateTiersMutation({
 *   variables: {
 *      tiers: // value for 'tiers'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useCreateOrUpdateTiersMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateTiersMutation, CreateOrUpdateTiersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateTiersMutation, CreateOrUpdateTiersMutationVariables>(CreateOrUpdateTiersDocument, options);
      }
export type CreateOrUpdateTiersMutationHookResult = ReturnType<typeof useCreateOrUpdateTiersMutation>;
export type CreateOrUpdateTiersMutationResult = Apollo.MutationResult<CreateOrUpdateTiersMutation>;
export type CreateOrUpdateTiersMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateTiersMutation, CreateOrUpdateTiersMutationVariables>;
export const PrepareTierUploadDocument = gql`
    mutation PrepareTierUpload($contentLength: Long!, $contentType: String!, $tier: Int!, $type: ClubTierUploadAsset!, $clubId: UUID!) {
  clubById(clubId: $clubId) {
    prepareTierUpload(
      contentLength: $contentLength
      contentType: $contentType
      tier: $tier
      type: $type
    ) {
      method
      token
      uploadUrl
    }
  }
}
    `;
export type PrepareTierUploadMutationFn = Apollo.MutationFunction<PrepareTierUploadMutation, PrepareTierUploadMutationVariables>;

/**
 * __usePrepareTierUploadMutation__
 *
 * To run a mutation, you first call `usePrepareTierUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareTierUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareTierUploadMutation, { data, loading, error }] = usePrepareTierUploadMutation({
 *   variables: {
 *      contentLength: // value for 'contentLength'
 *      contentType: // value for 'contentType'
 *      tier: // value for 'tier'
 *      type: // value for 'type'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function usePrepareTierUploadMutation(baseOptions?: Apollo.MutationHookOptions<PrepareTierUploadMutation, PrepareTierUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareTierUploadMutation, PrepareTierUploadMutationVariables>(PrepareTierUploadDocument, options);
      }
export type PrepareTierUploadMutationHookResult = ReturnType<typeof usePrepareTierUploadMutation>;
export type PrepareTierUploadMutationResult = Apollo.MutationResult<PrepareTierUploadMutation>;
export type PrepareTierUploadMutationOptions = Apollo.BaseMutationOptions<PrepareTierUploadMutation, PrepareTierUploadMutationVariables>;
export const CompleteTierUploadDocument = gql`
    mutation CompleteTierUpload($token: String!, $type: ClubTierUploadAsset!, $clubId: UUID!) {
  clubById(clubId: $clubId) {
    completeTierUpload(token: $token, type: $type)
  }
}
    `;
export type CompleteTierUploadMutationFn = Apollo.MutationFunction<CompleteTierUploadMutation, CompleteTierUploadMutationVariables>;

/**
 * __useCompleteTierUploadMutation__
 *
 * To run a mutation, you first call `useCompleteTierUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTierUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTierUploadMutation, { data, loading, error }] = useCompleteTierUploadMutation({
 *   variables: {
 *      token: // value for 'token'
 *      type: // value for 'type'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useCompleteTierUploadMutation(baseOptions?: Apollo.MutationHookOptions<CompleteTierUploadMutation, CompleteTierUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteTierUploadMutation, CompleteTierUploadMutationVariables>(CompleteTierUploadDocument, options);
      }
export type CompleteTierUploadMutationHookResult = ReturnType<typeof useCompleteTierUploadMutation>;
export type CompleteTierUploadMutationResult = Apollo.MutationResult<CompleteTierUploadMutation>;
export type CompleteTierUploadMutationOptions = Apollo.BaseMutationOptions<CompleteTierUploadMutation, CompleteTierUploadMutationVariables>;
export const JoinClubDocument = gql`
    mutation JoinClub($slug: String!) {
  clubBySlug(slug: $slug) {
    join
  }
}
    `;
export type JoinClubMutationFn = Apollo.MutationFunction<JoinClubMutation, JoinClubMutationVariables>;

/**
 * __useJoinClubMutation__
 *
 * To run a mutation, you first call `useJoinClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinClubMutation, { data, loading, error }] = useJoinClubMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useJoinClubMutation(baseOptions?: Apollo.MutationHookOptions<JoinClubMutation, JoinClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinClubMutation, JoinClubMutationVariables>(JoinClubDocument, options);
      }
export type JoinClubMutationHookResult = ReturnType<typeof useJoinClubMutation>;
export type JoinClubMutationResult = Apollo.MutationResult<JoinClubMutation>;
export type JoinClubMutationOptions = Apollo.BaseMutationOptions<JoinClubMutation, JoinClubMutationVariables>;
export const CreateOrUpdateRewardDocument = gql`
    mutation CreateOrUpdateReward($id: UUID, $pieId: UUID!, $slug: String!, $displayName: String!, $bio: String!, $avatarUrl: String!, $uploadedAssetId: UUID, $individualApiUrl: String!, $type: RewardType!, $category: RewardCategory!, $notes: String!, $redeemDescription: String!, $redeemCode: String!, $ageLimit: Int, $maxWinners: Int, $redeemType: RedeemType, $redeemPromoCodeArgs: RedeemPromoCodeArgsInput, $redeemQRCodeArgs: RedeemQRCodeArgsInput, $redeemInviteLinkArgs: RedeemInviteLinkArgsInput, $redeemLocationInfoArgs: RedeemLocationInfoArgsInput, $redeemUserContactInfoArgs: RedeemUserContactInfoArgsInput, $expiresAt: DateTime, $ownSlicesConditions: [OwnSlicesConditionArgsInput!]!, $achievementBadgeConditions: [AchievementBadgeConditionArgsInput!]!, $winningBoosts: [WinningBoostArgsInput!], $winnersChosenOption: WinnersChosenOption, $startDate: DateTime, $endDate: DateTime!, $needNewSlices: Boolean!, $canShareByParticipants: Boolean!, $optInParticipantPrivacyPolicy: Boolean!, $participantPrivacyPolicyTitle: String, $participantPrivacyPolicyContent: String, $doRewardToUser: Boolean, $policyFileUrl: String, $rewardGeoRangeConditionArg: RewardGeoRangeConditionArgInput, $requireAllAchievements: Boolean!) {
  reward {
    createOrUpdate(
      id: $id
      pieId: $pieId
      slug: $slug
      displayName: $displayName
      bio: $bio
      avatarUrl: $avatarUrl
      uploadedAssetId: $uploadedAssetId
      individualApiUrl: $individualApiUrl
      type: $type
      expiresAt: $expiresAt
      category: $category
      notes: $notes
      redeemDescription: $redeemDescription
      redeemCode: $redeemCode
      ageLimit: $ageLimit
      maxWinners: $maxWinners
      redeemType: $redeemType
      redeemPromoCodeArgs: $redeemPromoCodeArgs
      redeemQRCodeArgs: $redeemQRCodeArgs
      redeemInviteLinkArgs: $redeemInviteLinkArgs
      redeemLocationInfoArgs: $redeemLocationInfoArgs
      redeemUserContactInfoArgs: $redeemUserContactInfoArgs
      ownSlicesConditions: $ownSlicesConditions
      achievementBadgeConditions: $achievementBadgeConditions
      winningBoosts: $winningBoosts
      winnersChosenOption: $winnersChosenOption
      startDate: $startDate
      endDate: $endDate
      needNewSlices: $needNewSlices
      canShareByParticipants: $canShareByParticipants
      optInParticipantPrivacyPolicy: $optInParticipantPrivacyPolicy
      participantPrivacyPolicyTitle: $participantPrivacyPolicyTitle
      participantPrivacyPolicyContent: $participantPrivacyPolicyContent
      doRewardToUser: $doRewardToUser
      policyFileUrl: $policyFileUrl
      rewardGeoRangeConditionArg: $rewardGeoRangeConditionArg
      requireAllAchievements: $requireAllAchievements
    ) {
      rewardId
      displayName
      bio
      slug
      createdUtc
      avatarUrl
      status
      isHidden
      notes
      redeemCode
      redeemDescription
      redeemType
      ageLimit
      maxWinners
      type
      category
      expiresAt
      startDate
      endDate
      pie {
        pieId
        slug
        displayName
        createdBy {
          userId
          name
        }
      }
      canShareByParticipants
      needNewSlices
      optInParticipantPrivacyPolicy
      participantPrivacyPolicyTitle
      participantPrivacyPolicyContent
      policyFileUrl
      geoRangeCondition {
        address
        latitude
        longitude
        isActive
        radius
        locationUnitLengthType
      }
      requireAllAchievements
    }
  }
}
    `;
export type CreateOrUpdateRewardMutationFn = Apollo.MutationFunction<CreateOrUpdateRewardMutation, CreateOrUpdateRewardMutationVariables>;

/**
 * __useCreateOrUpdateRewardMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateRewardMutation, { data, loading, error }] = useCreateOrUpdateRewardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pieId: // value for 'pieId'
 *      slug: // value for 'slug'
 *      displayName: // value for 'displayName'
 *      bio: // value for 'bio'
 *      avatarUrl: // value for 'avatarUrl'
 *      uploadedAssetId: // value for 'uploadedAssetId'
 *      individualApiUrl: // value for 'individualApiUrl'
 *      type: // value for 'type'
 *      category: // value for 'category'
 *      notes: // value for 'notes'
 *      redeemDescription: // value for 'redeemDescription'
 *      redeemCode: // value for 'redeemCode'
 *      ageLimit: // value for 'ageLimit'
 *      maxWinners: // value for 'maxWinners'
 *      redeemType: // value for 'redeemType'
 *      redeemPromoCodeArgs: // value for 'redeemPromoCodeArgs'
 *      redeemQRCodeArgs: // value for 'redeemQRCodeArgs'
 *      redeemInviteLinkArgs: // value for 'redeemInviteLinkArgs'
 *      redeemLocationInfoArgs: // value for 'redeemLocationInfoArgs'
 *      redeemUserContactInfoArgs: // value for 'redeemUserContactInfoArgs'
 *      expiresAt: // value for 'expiresAt'
 *      ownSlicesConditions: // value for 'ownSlicesConditions'
 *      achievementBadgeConditions: // value for 'achievementBadgeConditions'
 *      winningBoosts: // value for 'winningBoosts'
 *      winnersChosenOption: // value for 'winnersChosenOption'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      needNewSlices: // value for 'needNewSlices'
 *      canShareByParticipants: // value for 'canShareByParticipants'
 *      optInParticipantPrivacyPolicy: // value for 'optInParticipantPrivacyPolicy'
 *      participantPrivacyPolicyTitle: // value for 'participantPrivacyPolicyTitle'
 *      participantPrivacyPolicyContent: // value for 'participantPrivacyPolicyContent'
 *      doRewardToUser: // value for 'doRewardToUser'
 *      policyFileUrl: // value for 'policyFileUrl'
 *      rewardGeoRangeConditionArg: // value for 'rewardGeoRangeConditionArg'
 *      requireAllAchievements: // value for 'requireAllAchievements'
 *   },
 * });
 */
export function useCreateOrUpdateRewardMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateRewardMutation, CreateOrUpdateRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateRewardMutation, CreateOrUpdateRewardMutationVariables>(CreateOrUpdateRewardDocument, options);
      }
export type CreateOrUpdateRewardMutationHookResult = ReturnType<typeof useCreateOrUpdateRewardMutation>;
export type CreateOrUpdateRewardMutationResult = Apollo.MutationResult<CreateOrUpdateRewardMutation>;
export type CreateOrUpdateRewardMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateRewardMutation, CreateOrUpdateRewardMutationVariables>;
export const RewardPresignUploadUrlDocument = gql`
    mutation RewardPresignUploadUrl($contentType: String!, $extension: String!, $contentLength: Long!) {
  reward {
    rewardAvatar {
      presignUploadUrl(
        contentType: $contentType
        extension: $extension
        contentLength: $contentLength
      )
    }
  }
}
    `;
export type RewardPresignUploadUrlMutationFn = Apollo.MutationFunction<RewardPresignUploadUrlMutation, RewardPresignUploadUrlMutationVariables>;

/**
 * __useRewardPresignUploadUrlMutation__
 *
 * To run a mutation, you first call `useRewardPresignUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRewardPresignUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rewardPresignUploadUrlMutation, { data, loading, error }] = useRewardPresignUploadUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      extension: // value for 'extension'
 *      contentLength: // value for 'contentLength'
 *   },
 * });
 */
export function useRewardPresignUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<RewardPresignUploadUrlMutation, RewardPresignUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RewardPresignUploadUrlMutation, RewardPresignUploadUrlMutationVariables>(RewardPresignUploadUrlDocument, options);
      }
export type RewardPresignUploadUrlMutationHookResult = ReturnType<typeof useRewardPresignUploadUrlMutation>;
export type RewardPresignUploadUrlMutationResult = Apollo.MutationResult<RewardPresignUploadUrlMutation>;
export type RewardPresignUploadUrlMutationOptions = Apollo.BaseMutationOptions<RewardPresignUploadUrlMutation, RewardPresignUploadUrlMutationVariables>;
export const UpdateRewardAvatarDocument = gql`
    mutation UpdateRewardAvatar($rewardId: UUID!, $avatarUrl: String!) {
  reward {
    rewardAvatar {
      completeUpload(rewardId: $rewardId, avatarUrl: $avatarUrl)
    }
  }
}
    `;
export type UpdateRewardAvatarMutationFn = Apollo.MutationFunction<UpdateRewardAvatarMutation, UpdateRewardAvatarMutationVariables>;

/**
 * __useUpdateRewardAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateRewardAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRewardAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRewardAvatarMutation, { data, loading, error }] = useUpdateRewardAvatarMutation({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *      avatarUrl: // value for 'avatarUrl'
 *   },
 * });
 */
export function useUpdateRewardAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRewardAvatarMutation, UpdateRewardAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRewardAvatarMutation, UpdateRewardAvatarMutationVariables>(UpdateRewardAvatarDocument, options);
      }
export type UpdateRewardAvatarMutationHookResult = ReturnType<typeof useUpdateRewardAvatarMutation>;
export type UpdateRewardAvatarMutationResult = Apollo.MutationResult<UpdateRewardAvatarMutation>;
export type UpdateRewardAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateRewardAvatarMutation, UpdateRewardAvatarMutationVariables>;
export const SetBonusAchivementsDocument = gql`
    mutation SetBonusAchivements($achievementIds: [UUID!]!, $rewardId: UUID!, $doRewardToUser: Boolean) {
  reward {
    setBonusAchievements(
      achievementIds: $achievementIds
      rewardId: $rewardId
      doRewardToUser: $doRewardToUser
    ) {
      rewardId
    }
  }
}
    `;
export type SetBonusAchivementsMutationFn = Apollo.MutationFunction<SetBonusAchivementsMutation, SetBonusAchivementsMutationVariables>;

/**
 * __useSetBonusAchivementsMutation__
 *
 * To run a mutation, you first call `useSetBonusAchivementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBonusAchivementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBonusAchivementsMutation, { data, loading, error }] = useSetBonusAchivementsMutation({
 *   variables: {
 *      achievementIds: // value for 'achievementIds'
 *      rewardId: // value for 'rewardId'
 *      doRewardToUser: // value for 'doRewardToUser'
 *   },
 * });
 */
export function useSetBonusAchivementsMutation(baseOptions?: Apollo.MutationHookOptions<SetBonusAchivementsMutation, SetBonusAchivementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBonusAchivementsMutation, SetBonusAchivementsMutationVariables>(SetBonusAchivementsDocument, options);
      }
export type SetBonusAchivementsMutationHookResult = ReturnType<typeof useSetBonusAchivementsMutation>;
export type SetBonusAchivementsMutationResult = Apollo.MutationResult<SetBonusAchivementsMutation>;
export type SetBonusAchivementsMutationOptions = Apollo.BaseMutationOptions<SetBonusAchivementsMutation, SetBonusAchivementsMutationVariables>;
export const DeleteRewardDocument = gql`
    mutation DeleteReward($rewardId: UUID!) {
  reward {
    delete(rewardId: $rewardId)
  }
}
    `;
export type DeleteRewardMutationFn = Apollo.MutationFunction<DeleteRewardMutation, DeleteRewardMutationVariables>;

/**
 * __useDeleteRewardMutation__
 *
 * To run a mutation, you first call `useDeleteRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRewardMutation, { data, loading, error }] = useDeleteRewardMutation({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *   },
 * });
 */
export function useDeleteRewardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRewardMutation, DeleteRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRewardMutation, DeleteRewardMutationVariables>(DeleteRewardDocument, options);
      }
export type DeleteRewardMutationHookResult = ReturnType<typeof useDeleteRewardMutation>;
export type DeleteRewardMutationResult = Apollo.MutationResult<DeleteRewardMutation>;
export type DeleteRewardMutationOptions = Apollo.BaseMutationOptions<DeleteRewardMutation, DeleteRewardMutationVariables>;
export const AwardRewardDocument = gql`
    mutation AwardReward($rewardId: UUID!, $userName: String!) {
  reward {
    award(rewardId: $rewardId, userName: $userName)
  }
}
    `;
export type AwardRewardMutationFn = Apollo.MutationFunction<AwardRewardMutation, AwardRewardMutationVariables>;

/**
 * __useAwardRewardMutation__
 *
 * To run a mutation, you first call `useAwardRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAwardRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [awardRewardMutation, { data, loading, error }] = useAwardRewardMutation({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useAwardRewardMutation(baseOptions?: Apollo.MutationHookOptions<AwardRewardMutation, AwardRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AwardRewardMutation, AwardRewardMutationVariables>(AwardRewardDocument, options);
      }
export type AwardRewardMutationHookResult = ReturnType<typeof useAwardRewardMutation>;
export type AwardRewardMutationResult = Apollo.MutationResult<AwardRewardMutation>;
export type AwardRewardMutationOptions = Apollo.BaseMutationOptions<AwardRewardMutation, AwardRewardMutationVariables>;
export const GenerateRewardWinnersDocument = gql`
    mutation GenerateRewardWinners($rewardId: UUID!) {
  reward {
    generateWinners(rewardId: $rewardId)
  }
}
    `;
export type GenerateRewardWinnersMutationFn = Apollo.MutationFunction<GenerateRewardWinnersMutation, GenerateRewardWinnersMutationVariables>;

/**
 * __useGenerateRewardWinnersMutation__
 *
 * To run a mutation, you first call `useGenerateRewardWinnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRewardWinnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRewardWinnersMutation, { data, loading, error }] = useGenerateRewardWinnersMutation({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *   },
 * });
 */
export function useGenerateRewardWinnersMutation(baseOptions?: Apollo.MutationHookOptions<GenerateRewardWinnersMutation, GenerateRewardWinnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateRewardWinnersMutation, GenerateRewardWinnersMutationVariables>(GenerateRewardWinnersDocument, options);
      }
export type GenerateRewardWinnersMutationHookResult = ReturnType<typeof useGenerateRewardWinnersMutation>;
export type GenerateRewardWinnersMutationResult = Apollo.MutationResult<GenerateRewardWinnersMutation>;
export type GenerateRewardWinnersMutationOptions = Apollo.BaseMutationOptions<GenerateRewardWinnersMutation, GenerateRewardWinnersMutationVariables>;
export const SendSmsRedeemCodeDocument = gql`
    mutation SendSmsRedeemCode($rewardId: UUID!) {
  reward {
    sendSmsRedeemCode(rewardId: $rewardId)
  }
}
    `;
export type SendSmsRedeemCodeMutationFn = Apollo.MutationFunction<SendSmsRedeemCodeMutation, SendSmsRedeemCodeMutationVariables>;

/**
 * __useSendSmsRedeemCodeMutation__
 *
 * To run a mutation, you first call `useSendSmsRedeemCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSmsRedeemCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSmsRedeemCodeMutation, { data, loading, error }] = useSendSmsRedeemCodeMutation({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *   },
 * });
 */
export function useSendSmsRedeemCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendSmsRedeemCodeMutation, SendSmsRedeemCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSmsRedeemCodeMutation, SendSmsRedeemCodeMutationVariables>(SendSmsRedeemCodeDocument, options);
      }
export type SendSmsRedeemCodeMutationHookResult = ReturnType<typeof useSendSmsRedeemCodeMutation>;
export type SendSmsRedeemCodeMutationResult = Apollo.MutationResult<SendSmsRedeemCodeMutation>;
export type SendSmsRedeemCodeMutationOptions = Apollo.BaseMutationOptions<SendSmsRedeemCodeMutation, SendSmsRedeemCodeMutationVariables>;
export const OptOutRewardDocument = gql`
    mutation OptOutReward($rewardId: UUID!) {
  reward {
    optOut(rewardId: $rewardId)
  }
}
    `;
export type OptOutRewardMutationFn = Apollo.MutationFunction<OptOutRewardMutation, OptOutRewardMutationVariables>;

/**
 * __useOptOutRewardMutation__
 *
 * To run a mutation, you first call `useOptOutRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptOutRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optOutRewardMutation, { data, loading, error }] = useOptOutRewardMutation({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *   },
 * });
 */
export function useOptOutRewardMutation(baseOptions?: Apollo.MutationHookOptions<OptOutRewardMutation, OptOutRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptOutRewardMutation, OptOutRewardMutationVariables>(OptOutRewardDocument, options);
      }
export type OptOutRewardMutationHookResult = ReturnType<typeof useOptOutRewardMutation>;
export type OptOutRewardMutationResult = Apollo.MutationResult<OptOutRewardMutation>;
export type OptOutRewardMutationOptions = Apollo.BaseMutationOptions<OptOutRewardMutation, OptOutRewardMutationVariables>;
export const SaveWinnerSharedAddressDocument = gql`
    mutation SaveWinnerSharedAddress($rewardId: UUID!, $sharedAddress: AddressModelInput, $sharedPhoneNumber: String, $sharedEmailAddress: String, $sharedName: String, $socialMediaAccounts: [SocialMediaAccountInput!]) {
  reward {
    saveWinnerSharedAddress(
      rewardId: $rewardId
      sharedAddress: $sharedAddress
      sharedPhoneNumber: $sharedPhoneNumber
      sharedEmailAddress: $sharedEmailAddress
      sharedName: $sharedName
      socialMediaAccounts: $socialMediaAccounts
    )
  }
}
    `;
export type SaveWinnerSharedAddressMutationFn = Apollo.MutationFunction<SaveWinnerSharedAddressMutation, SaveWinnerSharedAddressMutationVariables>;

/**
 * __useSaveWinnerSharedAddressMutation__
 *
 * To run a mutation, you first call `useSaveWinnerSharedAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWinnerSharedAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWinnerSharedAddressMutation, { data, loading, error }] = useSaveWinnerSharedAddressMutation({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *      sharedAddress: // value for 'sharedAddress'
 *      sharedPhoneNumber: // value for 'sharedPhoneNumber'
 *      sharedEmailAddress: // value for 'sharedEmailAddress'
 *      sharedName: // value for 'sharedName'
 *      socialMediaAccounts: // value for 'socialMediaAccounts'
 *   },
 * });
 */
export function useSaveWinnerSharedAddressMutation(baseOptions?: Apollo.MutationHookOptions<SaveWinnerSharedAddressMutation, SaveWinnerSharedAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWinnerSharedAddressMutation, SaveWinnerSharedAddressMutationVariables>(SaveWinnerSharedAddressDocument, options);
      }
export type SaveWinnerSharedAddressMutationHookResult = ReturnType<typeof useSaveWinnerSharedAddressMutation>;
export type SaveWinnerSharedAddressMutationResult = Apollo.MutationResult<SaveWinnerSharedAddressMutation>;
export type SaveWinnerSharedAddressMutationOptions = Apollo.BaseMutationOptions<SaveWinnerSharedAddressMutation, SaveWinnerSharedAddressMutationVariables>;
export const ConfirmParticipantPrivacyPolicyDocument = gql`
    mutation ConfirmParticipantPrivacyPolicy($rewardId: UUID!, $participantPrivacyPolicyState: ParticipantPrivacyPolicyState!) {
  reward {
    confirmParticipantPrivacyPolicy(
      rewardId: $rewardId
      participantPrivacyPolicyState: $participantPrivacyPolicyState
    )
  }
}
    `;
export type ConfirmParticipantPrivacyPolicyMutationFn = Apollo.MutationFunction<ConfirmParticipantPrivacyPolicyMutation, ConfirmParticipantPrivacyPolicyMutationVariables>;

/**
 * __useConfirmParticipantPrivacyPolicyMutation__
 *
 * To run a mutation, you first call `useConfirmParticipantPrivacyPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmParticipantPrivacyPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmParticipantPrivacyPolicyMutation, { data, loading, error }] = useConfirmParticipantPrivacyPolicyMutation({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *      participantPrivacyPolicyState: // value for 'participantPrivacyPolicyState'
 *   },
 * });
 */
export function useConfirmParticipantPrivacyPolicyMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmParticipantPrivacyPolicyMutation, ConfirmParticipantPrivacyPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmParticipantPrivacyPolicyMutation, ConfirmParticipantPrivacyPolicyMutationVariables>(ConfirmParticipantPrivacyPolicyDocument, options);
      }
export type ConfirmParticipantPrivacyPolicyMutationHookResult = ReturnType<typeof useConfirmParticipantPrivacyPolicyMutation>;
export type ConfirmParticipantPrivacyPolicyMutationResult = Apollo.MutationResult<ConfirmParticipantPrivacyPolicyMutation>;
export type ConfirmParticipantPrivacyPolicyMutationOptions = Apollo.BaseMutationOptions<ConfirmParticipantPrivacyPolicyMutation, ConfirmParticipantPrivacyPolicyMutationVariables>;
export const GetTestTicketDocument = gql`
    mutation GetTestTicket {
  reward {
    ticketGetTestTicket2 {
      ticketId
      associatedUser {
        userId
      }
    }
  }
}
    `;
export type GetTestTicketMutationFn = Apollo.MutationFunction<GetTestTicketMutation, GetTestTicketMutationVariables>;

/**
 * __useGetTestTicketMutation__
 *
 * To run a mutation, you first call `useGetTestTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetTestTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getTestTicketMutation, { data, loading, error }] = useGetTestTicketMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetTestTicketMutation(baseOptions?: Apollo.MutationHookOptions<GetTestTicketMutation, GetTestTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetTestTicketMutation, GetTestTicketMutationVariables>(GetTestTicketDocument, options);
      }
export type GetTestTicketMutationHookResult = ReturnType<typeof useGetTestTicketMutation>;
export type GetTestTicketMutationResult = Apollo.MutationResult<GetTestTicketMutation>;
export type GetTestTicketMutationOptions = Apollo.BaseMutationOptions<GetTestTicketMutation, GetTestTicketMutationVariables>;
export const CreateTermsConditionsAndPrivacyDocument = gql`
    mutation CreateTermsConditionsAndPrivacy($privacyPath: String!, $termsConditionsPath: String!) {
  termsAndConditions {
    createTermsAndConditions(
      args: {privacyPolicyUrl: $privacyPath, termsAndConditionsUrl: $termsConditionsPath}
    )
  }
}
    `;
export type CreateTermsConditionsAndPrivacyMutationFn = Apollo.MutationFunction<CreateTermsConditionsAndPrivacyMutation, CreateTermsConditionsAndPrivacyMutationVariables>;

/**
 * __useCreateTermsConditionsAndPrivacyMutation__
 *
 * To run a mutation, you first call `useCreateTermsConditionsAndPrivacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTermsConditionsAndPrivacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTermsConditionsAndPrivacyMutation, { data, loading, error }] = useCreateTermsConditionsAndPrivacyMutation({
 *   variables: {
 *      privacyPath: // value for 'privacyPath'
 *      termsConditionsPath: // value for 'termsConditionsPath'
 *   },
 * });
 */
export function useCreateTermsConditionsAndPrivacyMutation(baseOptions?: Apollo.MutationHookOptions<CreateTermsConditionsAndPrivacyMutation, CreateTermsConditionsAndPrivacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTermsConditionsAndPrivacyMutation, CreateTermsConditionsAndPrivacyMutationVariables>(CreateTermsConditionsAndPrivacyDocument, options);
      }
export type CreateTermsConditionsAndPrivacyMutationHookResult = ReturnType<typeof useCreateTermsConditionsAndPrivacyMutation>;
export type CreateTermsConditionsAndPrivacyMutationResult = Apollo.MutationResult<CreateTermsConditionsAndPrivacyMutation>;
export type CreateTermsConditionsAndPrivacyMutationOptions = Apollo.BaseMutationOptions<CreateTermsConditionsAndPrivacyMutation, CreateTermsConditionsAndPrivacyMutationVariables>;
export const CreateOrUpdateUploadedAssetDocument = gql`
    mutation CreateOrUpdateUploadedAsset($id: UUID, $pieId: UUID, $target: UploadedAssetTarget!, $url: String!) {
  uploaded_asset {
    createOrUpdate(id: $id, pieId: $pieId, target: $target, url: $url) {
      uploadedAssetId
      url
      target
      createdUtc
      status
    }
  }
}
    `;
export type CreateOrUpdateUploadedAssetMutationFn = Apollo.MutationFunction<CreateOrUpdateUploadedAssetMutation, CreateOrUpdateUploadedAssetMutationVariables>;

/**
 * __useCreateOrUpdateUploadedAssetMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateUploadedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateUploadedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateUploadedAssetMutation, { data, loading, error }] = useCreateOrUpdateUploadedAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pieId: // value for 'pieId'
 *      target: // value for 'target'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCreateOrUpdateUploadedAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateUploadedAssetMutation, CreateOrUpdateUploadedAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateUploadedAssetMutation, CreateOrUpdateUploadedAssetMutationVariables>(CreateOrUpdateUploadedAssetDocument, options);
      }
export type CreateOrUpdateUploadedAssetMutationHookResult = ReturnType<typeof useCreateOrUpdateUploadedAssetMutation>;
export type CreateOrUpdateUploadedAssetMutationResult = Apollo.MutationResult<CreateOrUpdateUploadedAssetMutation>;
export type CreateOrUpdateUploadedAssetMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateUploadedAssetMutation, CreateOrUpdateUploadedAssetMutationVariables>;
export const DeleteUploadedAssetDocument = gql`
    mutation DeleteUploadedAsset($assetId: UUID!) {
  uploaded_asset {
    delete(id: $assetId)
  }
}
    `;
export type DeleteUploadedAssetMutationFn = Apollo.MutationFunction<DeleteUploadedAssetMutation, DeleteUploadedAssetMutationVariables>;

/**
 * __useDeleteUploadedAssetMutation__
 *
 * To run a mutation, you first call `useDeleteUploadedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUploadedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUploadedAssetMutation, { data, loading, error }] = useDeleteUploadedAssetMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useDeleteUploadedAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUploadedAssetMutation, DeleteUploadedAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUploadedAssetMutation, DeleteUploadedAssetMutationVariables>(DeleteUploadedAssetDocument, options);
      }
export type DeleteUploadedAssetMutationHookResult = ReturnType<typeof useDeleteUploadedAssetMutation>;
export type DeleteUploadedAssetMutationResult = Apollo.MutationResult<DeleteUploadedAssetMutation>;
export type DeleteUploadedAssetMutationOptions = Apollo.BaseMutationOptions<DeleteUploadedAssetMutation, DeleteUploadedAssetMutationVariables>;
export const TargetPresignUploadUrlDocument = gql`
    mutation TargetPresignUploadUrl($pieId: UUID, $target: UploadedAssetTarget!, $contentType: String!, $extension: String!, $contentLength: Long!) {
  uploaded_asset {
    presignUploadUrl(
      contentLength: $contentLength
      contentType: $contentType
      extension: $extension
      pieId: $pieId
      target: $target
    )
  }
}
    `;
export type TargetPresignUploadUrlMutationFn = Apollo.MutationFunction<TargetPresignUploadUrlMutation, TargetPresignUploadUrlMutationVariables>;

/**
 * __useTargetPresignUploadUrlMutation__
 *
 * To run a mutation, you first call `useTargetPresignUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTargetPresignUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [targetPresignUploadUrlMutation, { data, loading, error }] = useTargetPresignUploadUrlMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      target: // value for 'target'
 *      contentType: // value for 'contentType'
 *      extension: // value for 'extension'
 *      contentLength: // value for 'contentLength'
 *   },
 * });
 */
export function useTargetPresignUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<TargetPresignUploadUrlMutation, TargetPresignUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TargetPresignUploadUrlMutation, TargetPresignUploadUrlMutationVariables>(TargetPresignUploadUrlDocument, options);
      }
export type TargetPresignUploadUrlMutationHookResult = ReturnType<typeof useTargetPresignUploadUrlMutation>;
export type TargetPresignUploadUrlMutationResult = Apollo.MutationResult<TargetPresignUploadUrlMutation>;
export type TargetPresignUploadUrlMutationOptions = Apollo.BaseMutationOptions<TargetPresignUploadUrlMutation, TargetPresignUploadUrlMutationVariables>;
export const UpdateMeDocument = gql`
    mutation UpdateMe($args: MutationUserUpdateArgsInput!) {
  me(args: $args) {
    name
    gender
    dateOfBirth
    phoneNumber
    userName
    brandedUrl
  }
}
    `;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const CompleteProfileDocument = gql`
    mutation CompleteProfile($args: MutationCompleteProfileArgsInput!) {
  completeProfile(args: $args) {
    userId
    profileCompletionRequired
  }
}
    `;
export type CompleteProfileMutationFn = Apollo.MutationFunction<CompleteProfileMutation, CompleteProfileMutationVariables>;

/**
 * __useCompleteProfileMutation__
 *
 * To run a mutation, you first call `useCompleteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeProfileMutation, { data, loading, error }] = useCompleteProfileMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCompleteProfileMutation(baseOptions?: Apollo.MutationHookOptions<CompleteProfileMutation, CompleteProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteProfileMutation, CompleteProfileMutationVariables>(CompleteProfileDocument, options);
      }
export type CompleteProfileMutationHookResult = ReturnType<typeof useCompleteProfileMutation>;
export type CompleteProfileMutationResult = Apollo.MutationResult<CompleteProfileMutation>;
export type CompleteProfileMutationOptions = Apollo.BaseMutationOptions<CompleteProfileMutation, CompleteProfileMutationVariables>;
export const UpdatePhoneNumberDocument = gql`
    mutation UpdatePhoneNumber($phoneNumber: String!) {
  user {
    updatePhoneNumber(phoneNumber: $phoneNumber)
  }
}
    `;
export type UpdatePhoneNumberMutationFn = Apollo.MutationFunction<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;

/**
 * __useUpdatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneNumberMutation, { data, loading, error }] = useUpdatePhoneNumberMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdatePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>(UpdatePhoneNumberDocument, options);
      }
export type UpdatePhoneNumberMutationHookResult = ReturnType<typeof useUpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationResult = Apollo.MutationResult<UpdatePhoneNumberMutation>;
export type UpdatePhoneNumberMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;
export const UpdateEmailAddressDocument = gql`
    mutation UpdateEmailAddress($emailAddress: String!) {
  user {
    updateEmailAddress(emailAddress: $emailAddress)
  }
}
    `;
export type UpdateEmailAddressMutationFn = Apollo.MutationFunction<UpdateEmailAddressMutation, UpdateEmailAddressMutationVariables>;

/**
 * __useUpdateEmailAddressMutation__
 *
 * To run a mutation, you first call `useUpdateEmailAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailAddressMutation, { data, loading, error }] = useUpdateEmailAddressMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useUpdateEmailAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailAddressMutation, UpdateEmailAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailAddressMutation, UpdateEmailAddressMutationVariables>(UpdateEmailAddressDocument, options);
      }
export type UpdateEmailAddressMutationHookResult = ReturnType<typeof useUpdateEmailAddressMutation>;
export type UpdateEmailAddressMutationResult = Apollo.MutationResult<UpdateEmailAddressMutation>;
export type UpdateEmailAddressMutationOptions = Apollo.BaseMutationOptions<UpdateEmailAddressMutation, UpdateEmailAddressMutationVariables>;
export const RequestEmailChangeDocument = gql`
    mutation RequestEmailChange($newEmailAddress: String!) {
  user {
    requestEmailChange(newEmailAddress: $newEmailAddress)
  }
}
    `;
export type RequestEmailChangeMutationFn = Apollo.MutationFunction<RequestEmailChangeMutation, RequestEmailChangeMutationVariables>;

/**
 * __useRequestEmailChangeMutation__
 *
 * To run a mutation, you first call `useRequestEmailChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailChangeMutation, { data, loading, error }] = useRequestEmailChangeMutation({
 *   variables: {
 *      newEmailAddress: // value for 'newEmailAddress'
 *   },
 * });
 */
export function useRequestEmailChangeMutation(baseOptions?: Apollo.MutationHookOptions<RequestEmailChangeMutation, RequestEmailChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEmailChangeMutation, RequestEmailChangeMutationVariables>(RequestEmailChangeDocument, options);
      }
export type RequestEmailChangeMutationHookResult = ReturnType<typeof useRequestEmailChangeMutation>;
export type RequestEmailChangeMutationResult = Apollo.MutationResult<RequestEmailChangeMutation>;
export type RequestEmailChangeMutationOptions = Apollo.BaseMutationOptions<RequestEmailChangeMutation, RequestEmailChangeMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($address: AddressModelInput!) {
  user {
    updateAddress(address: $address)
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const ConnectSocialDocument = gql`
    mutation ConnectSocial($accessKey: String!, $scheme: String!) {
  user {
    socialMedia {
      connect(accessKey: $accessKey, scheme: $scheme)
    }
  }
}
    `;
export type ConnectSocialMutationFn = Apollo.MutationFunction<ConnectSocialMutation, ConnectSocialMutationVariables>;

/**
 * __useConnectSocialMutation__
 *
 * To run a mutation, you first call `useConnectSocialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectSocialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectSocialMutation, { data, loading, error }] = useConnectSocialMutation({
 *   variables: {
 *      accessKey: // value for 'accessKey'
 *      scheme: // value for 'scheme'
 *   },
 * });
 */
export function useConnectSocialMutation(baseOptions?: Apollo.MutationHookOptions<ConnectSocialMutation, ConnectSocialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectSocialMutation, ConnectSocialMutationVariables>(ConnectSocialDocument, options);
      }
export type ConnectSocialMutationHookResult = ReturnType<typeof useConnectSocialMutation>;
export type ConnectSocialMutationResult = Apollo.MutationResult<ConnectSocialMutation>;
export type ConnectSocialMutationOptions = Apollo.BaseMutationOptions<ConnectSocialMutation, ConnectSocialMutationVariables>;
export const DisconnectSocialDocument = gql`
    mutation DisconnectSocial($scheme: String!) {
  user {
    socialMedia {
      disconnect(scheme: $scheme)
    }
  }
}
    `;
export type DisconnectSocialMutationFn = Apollo.MutationFunction<DisconnectSocialMutation, DisconnectSocialMutationVariables>;

/**
 * __useDisconnectSocialMutation__
 *
 * To run a mutation, you first call `useDisconnectSocialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectSocialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectSocialMutation, { data, loading, error }] = useDisconnectSocialMutation({
 *   variables: {
 *      scheme: // value for 'scheme'
 *   },
 * });
 */
export function useDisconnectSocialMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectSocialMutation, DisconnectSocialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectSocialMutation, DisconnectSocialMutationVariables>(DisconnectSocialDocument, options);
      }
export type DisconnectSocialMutationHookResult = ReturnType<typeof useDisconnectSocialMutation>;
export type DisconnectSocialMutationResult = Apollo.MutationResult<DisconnectSocialMutation>;
export type DisconnectSocialMutationOptions = Apollo.BaseMutationOptions<DisconnectSocialMutation, DisconnectSocialMutationVariables>;
export const StartInstagramVerificationDocument = gql`
    mutation StartInstagramVerification {
  user {
    socialMedia {
      startInstagramVerification {
        code
        expiresAt
        dmDeepLink
      }
    }
  }
}
    `;
export type StartInstagramVerificationMutationFn = Apollo.MutationFunction<StartInstagramVerificationMutation, StartInstagramVerificationMutationVariables>;

/**
 * __useStartInstagramVerificationMutation__
 *
 * To run a mutation, you first call `useStartInstagramVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartInstagramVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startInstagramVerificationMutation, { data, loading, error }] = useStartInstagramVerificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartInstagramVerificationMutation(baseOptions?: Apollo.MutationHookOptions<StartInstagramVerificationMutation, StartInstagramVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartInstagramVerificationMutation, StartInstagramVerificationMutationVariables>(StartInstagramVerificationDocument, options);
      }
export type StartInstagramVerificationMutationHookResult = ReturnType<typeof useStartInstagramVerificationMutation>;
export type StartInstagramVerificationMutationResult = Apollo.MutationResult<StartInstagramVerificationMutation>;
export type StartInstagramVerificationMutationOptions = Apollo.BaseMutationOptions<StartInstagramVerificationMutation, StartInstagramVerificationMutationVariables>;
export const RefreshInstagramConnectionDocument = gql`
    mutation RefreshInstagramConnection {
  user {
    refreshInstagramConnection
  }
}
    `;
export type RefreshInstagramConnectionMutationFn = Apollo.MutationFunction<RefreshInstagramConnectionMutation, RefreshInstagramConnectionMutationVariables>;

/**
 * __useRefreshInstagramConnectionMutation__
 *
 * To run a mutation, you first call `useRefreshInstagramConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshInstagramConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshInstagramConnectionMutation, { data, loading, error }] = useRefreshInstagramConnectionMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshInstagramConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RefreshInstagramConnectionMutation, RefreshInstagramConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshInstagramConnectionMutation, RefreshInstagramConnectionMutationVariables>(RefreshInstagramConnectionDocument, options);
      }
export type RefreshInstagramConnectionMutationHookResult = ReturnType<typeof useRefreshInstagramConnectionMutation>;
export type RefreshInstagramConnectionMutationResult = Apollo.MutationResult<RefreshInstagramConnectionMutation>;
export type RefreshInstagramConnectionMutationOptions = Apollo.BaseMutationOptions<RefreshInstagramConnectionMutation, RefreshInstagramConnectionMutationVariables>;
export const SetAvatarSourceDocument = gql`
    mutation SetAvatarSource($source: AvatarSource!) {
  user {
    setAvatarSource(source: $source)
  }
}
    `;
export type SetAvatarSourceMutationFn = Apollo.MutationFunction<SetAvatarSourceMutation, SetAvatarSourceMutationVariables>;

/**
 * __useSetAvatarSourceMutation__
 *
 * To run a mutation, you first call `useSetAvatarSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAvatarSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAvatarSourceMutation, { data, loading, error }] = useSetAvatarSourceMutation({
 *   variables: {
 *      source: // value for 'source'
 *   },
 * });
 */
export function useSetAvatarSourceMutation(baseOptions?: Apollo.MutationHookOptions<SetAvatarSourceMutation, SetAvatarSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAvatarSourceMutation, SetAvatarSourceMutationVariables>(SetAvatarSourceDocument, options);
      }
export type SetAvatarSourceMutationHookResult = ReturnType<typeof useSetAvatarSourceMutation>;
export type SetAvatarSourceMutationResult = Apollo.MutationResult<SetAvatarSourceMutation>;
export type SetAvatarSourceMutationOptions = Apollo.BaseMutationOptions<SetAvatarSourceMutation, SetAvatarSourceMutationVariables>;
export const SetDisplayNameSourceDocument = gql`
    mutation SetDisplayNameSource($source: DisplayNameSource!) {
  user {
    setDisplayNameSource(source: $source)
  }
}
    `;
export type SetDisplayNameSourceMutationFn = Apollo.MutationFunction<SetDisplayNameSourceMutation, SetDisplayNameSourceMutationVariables>;

/**
 * __useSetDisplayNameSourceMutation__
 *
 * To run a mutation, you first call `useSetDisplayNameSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDisplayNameSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDisplayNameSourceMutation, { data, loading, error }] = useSetDisplayNameSourceMutation({
 *   variables: {
 *      source: // value for 'source'
 *   },
 * });
 */
export function useSetDisplayNameSourceMutation(baseOptions?: Apollo.MutationHookOptions<SetDisplayNameSourceMutation, SetDisplayNameSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDisplayNameSourceMutation, SetDisplayNameSourceMutationVariables>(SetDisplayNameSourceDocument, options);
      }
export type SetDisplayNameSourceMutationHookResult = ReturnType<typeof useSetDisplayNameSourceMutation>;
export type SetDisplayNameSourceMutationResult = Apollo.MutationResult<SetDisplayNameSourceMutation>;
export type SetDisplayNameSourceMutationOptions = Apollo.BaseMutationOptions<SetDisplayNameSourceMutation, SetDisplayNameSourceMutationVariables>;
export const PresignUploadUrlDocument = gql`
    mutation PresignUploadUrl($contentType: String!, $extension: String!, $contentLength: Long!) {
  user {
    avatar {
      presignUploadUrl(
        contentType: $contentType
        extension: $extension
        contentLength: $contentLength
      )
    }
  }
}
    `;
export type PresignUploadUrlMutationFn = Apollo.MutationFunction<PresignUploadUrlMutation, PresignUploadUrlMutationVariables>;

/**
 * __usePresignUploadUrlMutation__
 *
 * To run a mutation, you first call `usePresignUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePresignUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [presignUploadUrlMutation, { data, loading, error }] = usePresignUploadUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      extension: // value for 'extension'
 *      contentLength: // value for 'contentLength'
 *   },
 * });
 */
export function usePresignUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<PresignUploadUrlMutation, PresignUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PresignUploadUrlMutation, PresignUploadUrlMutationVariables>(PresignUploadUrlDocument, options);
      }
export type PresignUploadUrlMutationHookResult = ReturnType<typeof usePresignUploadUrlMutation>;
export type PresignUploadUrlMutationResult = Apollo.MutationResult<PresignUploadUrlMutation>;
export type PresignUploadUrlMutationOptions = Apollo.BaseMutationOptions<PresignUploadUrlMutation, PresignUploadUrlMutationVariables>;
export const UpdateAvatarDocument = gql`
    mutation UpdateAvatar($avatarUrl: String!) {
  user {
    avatar {
      completeUpload(avatarUrl: $avatarUrl)
    }
  }
}
    `;
export type UpdateAvatarMutationFn = Apollo.MutationFunction<UpdateAvatarMutation, UpdateAvatarMutationVariables>;

/**
 * __useUpdateAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvatarMutation, { data, loading, error }] = useUpdateAvatarMutation({
 *   variables: {
 *      avatarUrl: // value for 'avatarUrl'
 *   },
 * });
 */
export function useUpdateAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvatarMutation, UpdateAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvatarMutation, UpdateAvatarMutationVariables>(UpdateAvatarDocument, options);
      }
export type UpdateAvatarMutationHookResult = ReturnType<typeof useUpdateAvatarMutation>;
export type UpdateAvatarMutationResult = Apollo.MutationResult<UpdateAvatarMutation>;
export type UpdateAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateAvatarMutation, UpdateAvatarMutationVariables>;
export const UpdateMeAndAgreeToTermsAndConditionsDocument = gql`
    mutation UpdateMeAndAgreeToTermsAndConditions($args: MutationUserUpdateArgsInput!, $version: Int!) {
  me(args: $args) {
    name
    gender
    dateOfBirth
    phoneNumber
    userName
    brandedUrl
  }
  user {
    agreeTermsAndConditions(version: $version)
  }
}
    `;
export type UpdateMeAndAgreeToTermsAndConditionsMutationFn = Apollo.MutationFunction<UpdateMeAndAgreeToTermsAndConditionsMutation, UpdateMeAndAgreeToTermsAndConditionsMutationVariables>;

/**
 * __useUpdateMeAndAgreeToTermsAndConditionsMutation__
 *
 * To run a mutation, you first call `useUpdateMeAndAgreeToTermsAndConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeAndAgreeToTermsAndConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeAndAgreeToTermsAndConditionsMutation, { data, loading, error }] = useUpdateMeAndAgreeToTermsAndConditionsMutation({
 *   variables: {
 *      args: // value for 'args'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useUpdateMeAndAgreeToTermsAndConditionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeAndAgreeToTermsAndConditionsMutation, UpdateMeAndAgreeToTermsAndConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeAndAgreeToTermsAndConditionsMutation, UpdateMeAndAgreeToTermsAndConditionsMutationVariables>(UpdateMeAndAgreeToTermsAndConditionsDocument, options);
      }
export type UpdateMeAndAgreeToTermsAndConditionsMutationHookResult = ReturnType<typeof useUpdateMeAndAgreeToTermsAndConditionsMutation>;
export type UpdateMeAndAgreeToTermsAndConditionsMutationResult = Apollo.MutationResult<UpdateMeAndAgreeToTermsAndConditionsMutation>;
export type UpdateMeAndAgreeToTermsAndConditionsMutationOptions = Apollo.BaseMutationOptions<UpdateMeAndAgreeToTermsAndConditionsMutation, UpdateMeAndAgreeToTermsAndConditionsMutationVariables>;
export const AgreeToTermsAndConditionsDocument = gql`
    mutation AgreeToTermsAndConditions($version: Int!) {
  user {
    agreeTermsAndConditions(version: $version)
  }
}
    `;
export type AgreeToTermsAndConditionsMutationFn = Apollo.MutationFunction<AgreeToTermsAndConditionsMutation, AgreeToTermsAndConditionsMutationVariables>;

/**
 * __useAgreeToTermsAndConditionsMutation__
 *
 * To run a mutation, you first call `useAgreeToTermsAndConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreeToTermsAndConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreeToTermsAndConditionsMutation, { data, loading, error }] = useAgreeToTermsAndConditionsMutation({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useAgreeToTermsAndConditionsMutation(baseOptions?: Apollo.MutationHookOptions<AgreeToTermsAndConditionsMutation, AgreeToTermsAndConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AgreeToTermsAndConditionsMutation, AgreeToTermsAndConditionsMutationVariables>(AgreeToTermsAndConditionsDocument, options);
      }
export type AgreeToTermsAndConditionsMutationHookResult = ReturnType<typeof useAgreeToTermsAndConditionsMutation>;
export type AgreeToTermsAndConditionsMutationResult = Apollo.MutationResult<AgreeToTermsAndConditionsMutation>;
export type AgreeToTermsAndConditionsMutationOptions = Apollo.BaseMutationOptions<AgreeToTermsAndConditionsMutation, AgreeToTermsAndConditionsMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount {
  user {
    deactivate
  }
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const RecoverAccountDocument = gql`
    mutation RecoverAccount {
  user {
    activate
  }
}
    `;
export type RecoverAccountMutationFn = Apollo.MutationFunction<RecoverAccountMutation, RecoverAccountMutationVariables>;

/**
 * __useRecoverAccountMutation__
 *
 * To run a mutation, you first call `useRecoverAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverAccountMutation, { data, loading, error }] = useRecoverAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useRecoverAccountMutation(baseOptions?: Apollo.MutationHookOptions<RecoverAccountMutation, RecoverAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecoverAccountMutation, RecoverAccountMutationVariables>(RecoverAccountDocument, options);
      }
export type RecoverAccountMutationHookResult = ReturnType<typeof useRecoverAccountMutation>;
export type RecoverAccountMutationResult = Apollo.MutationResult<RecoverAccountMutation>;
export type RecoverAccountMutationOptions = Apollo.BaseMutationOptions<RecoverAccountMutation, RecoverAccountMutationVariables>;
export const ConnectPayoutDocument = gql`
    mutation ConnectPayout($accountId: String!, $provider: String!, $isPrimary: Boolean!) {
  user {
    payoutAccount {
      connect(accountId: $accountId, provider: $provider, isPrimary: $isPrimary)
    }
  }
}
    `;
export type ConnectPayoutMutationFn = Apollo.MutationFunction<ConnectPayoutMutation, ConnectPayoutMutationVariables>;

/**
 * __useConnectPayoutMutation__
 *
 * To run a mutation, you first call `useConnectPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectPayoutMutation, { data, loading, error }] = useConnectPayoutMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      provider: // value for 'provider'
 *      isPrimary: // value for 'isPrimary'
 *   },
 * });
 */
export function useConnectPayoutMutation(baseOptions?: Apollo.MutationHookOptions<ConnectPayoutMutation, ConnectPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectPayoutMutation, ConnectPayoutMutationVariables>(ConnectPayoutDocument, options);
      }
export type ConnectPayoutMutationHookResult = ReturnType<typeof useConnectPayoutMutation>;
export type ConnectPayoutMutationResult = Apollo.MutationResult<ConnectPayoutMutation>;
export type ConnectPayoutMutationOptions = Apollo.BaseMutationOptions<ConnectPayoutMutation, ConnectPayoutMutationVariables>;
export const ConnectPayoutViaOidcDocument = gql`
    mutation ConnectPayoutViaOidc($code: String!) {
  user {
    payoutAccount {
      connectViaOidc(code: $code)
    }
  }
}
    `;
export type ConnectPayoutViaOidcMutationFn = Apollo.MutationFunction<ConnectPayoutViaOidcMutation, ConnectPayoutViaOidcMutationVariables>;

/**
 * __useConnectPayoutViaOidcMutation__
 *
 * To run a mutation, you first call `useConnectPayoutViaOidcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectPayoutViaOidcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectPayoutViaOidcMutation, { data, loading, error }] = useConnectPayoutViaOidcMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConnectPayoutViaOidcMutation(baseOptions?: Apollo.MutationHookOptions<ConnectPayoutViaOidcMutation, ConnectPayoutViaOidcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectPayoutViaOidcMutation, ConnectPayoutViaOidcMutationVariables>(ConnectPayoutViaOidcDocument, options);
      }
export type ConnectPayoutViaOidcMutationHookResult = ReturnType<typeof useConnectPayoutViaOidcMutation>;
export type ConnectPayoutViaOidcMutationResult = Apollo.MutationResult<ConnectPayoutViaOidcMutation>;
export type ConnectPayoutViaOidcMutationOptions = Apollo.BaseMutationOptions<ConnectPayoutViaOidcMutation, ConnectPayoutViaOidcMutationVariables>;
export const DisconnectPayoutDocument = gql`
    mutation DisconnectPayout($provider: String!) {
  user {
    payoutAccount {
      disconnect(provider: $provider)
    }
  }
}
    `;
export type DisconnectPayoutMutationFn = Apollo.MutationFunction<DisconnectPayoutMutation, DisconnectPayoutMutationVariables>;

/**
 * __useDisconnectPayoutMutation__
 *
 * To run a mutation, you first call `useDisconnectPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectPayoutMutation, { data, loading, error }] = useDisconnectPayoutMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useDisconnectPayoutMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectPayoutMutation, DisconnectPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectPayoutMutation, DisconnectPayoutMutationVariables>(DisconnectPayoutDocument, options);
      }
export type DisconnectPayoutMutationHookResult = ReturnType<typeof useDisconnectPayoutMutation>;
export type DisconnectPayoutMutationResult = Apollo.MutationResult<DisconnectPayoutMutation>;
export type DisconnectPayoutMutationOptions = Apollo.BaseMutationOptions<DisconnectPayoutMutation, DisconnectPayoutMutationVariables>;
export const JoinWaitingListDocument = gql`
    mutation JoinWaitingList {
  user {
    joinPieWaitingList
  }
}
    `;
export type JoinWaitingListMutationFn = Apollo.MutationFunction<JoinWaitingListMutation, JoinWaitingListMutationVariables>;

/**
 * __useJoinWaitingListMutation__
 *
 * To run a mutation, you first call `useJoinWaitingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinWaitingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinWaitingListMutation, { data, loading, error }] = useJoinWaitingListMutation({
 *   variables: {
 *   },
 * });
 */
export function useJoinWaitingListMutation(baseOptions?: Apollo.MutationHookOptions<JoinWaitingListMutation, JoinWaitingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinWaitingListMutation, JoinWaitingListMutationVariables>(JoinWaitingListDocument, options);
      }
export type JoinWaitingListMutationHookResult = ReturnType<typeof useJoinWaitingListMutation>;
export type JoinWaitingListMutationResult = Apollo.MutationResult<JoinWaitingListMutation>;
export type JoinWaitingListMutationOptions = Apollo.BaseMutationOptions<JoinWaitingListMutation, JoinWaitingListMutationVariables>;
export const DeletePendingInviteDocument = gql`
    mutation DeletePendingInvite($inviteId: String!) {
  user {
    revokePendingInvite(inviteId: $inviteId)
  }
}
    `;
export type DeletePendingInviteMutationFn = Apollo.MutationFunction<DeletePendingInviteMutation, DeletePendingInviteMutationVariables>;

/**
 * __useDeletePendingInviteMutation__
 *
 * To run a mutation, you first call `useDeletePendingInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePendingInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePendingInviteMutation, { data, loading, error }] = useDeletePendingInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useDeletePendingInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeletePendingInviteMutation, DeletePendingInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePendingInviteMutation, DeletePendingInviteMutationVariables>(DeletePendingInviteDocument, options);
      }
export type DeletePendingInviteMutationHookResult = ReturnType<typeof useDeletePendingInviteMutation>;
export type DeletePendingInviteMutationResult = Apollo.MutationResult<DeletePendingInviteMutation>;
export type DeletePendingInviteMutationOptions = Apollo.BaseMutationOptions<DeletePendingInviteMutation, DeletePendingInviteMutationVariables>;
export const InviteUserByEmailDocument = gql`
    mutation InviteUserByEmail($emailAddress: String!) {
  user {
    inviteUserByEmail(emailAddress: $emailAddress) {
      inviteAcceptLink
      inviteId
    }
  }
}
    `;
export type InviteUserByEmailMutationFn = Apollo.MutationFunction<InviteUserByEmailMutation, InviteUserByEmailMutationVariables>;

/**
 * __useInviteUserByEmailMutation__
 *
 * To run a mutation, you first call `useInviteUserByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserByEmailMutation, { data, loading, error }] = useInviteUserByEmailMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useInviteUserByEmailMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserByEmailMutation, InviteUserByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserByEmailMutation, InviteUserByEmailMutationVariables>(InviteUserByEmailDocument, options);
      }
export type InviteUserByEmailMutationHookResult = ReturnType<typeof useInviteUserByEmailMutation>;
export type InviteUserByEmailMutationResult = Apollo.MutationResult<InviteUserByEmailMutation>;
export type InviteUserByEmailMutationOptions = Apollo.BaseMutationOptions<InviteUserByEmailMutation, InviteUserByEmailMutationVariables>;
export const InviteUserByUserNameDocument = gql`
    mutation InviteUserByUserName($userName: String!) {
  user {
    inviteUserByUserName(userName: $userName) {
      inviteId
      inviteAcceptLink
    }
  }
}
    `;
export type InviteUserByUserNameMutationFn = Apollo.MutationFunction<InviteUserByUserNameMutation, InviteUserByUserNameMutationVariables>;

/**
 * __useInviteUserByUserNameMutation__
 *
 * To run a mutation, you first call `useInviteUserByUserNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserByUserNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserByUserNameMutation, { data, loading, error }] = useInviteUserByUserNameMutation({
 *   variables: {
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useInviteUserByUserNameMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserByUserNameMutation, InviteUserByUserNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserByUserNameMutation, InviteUserByUserNameMutationVariables>(InviteUserByUserNameDocument, options);
      }
export type InviteUserByUserNameMutationHookResult = ReturnType<typeof useInviteUserByUserNameMutation>;
export type InviteUserByUserNameMutationResult = Apollo.MutationResult<InviteUserByUserNameMutation>;
export type InviteUserByUserNameMutationOptions = Apollo.BaseMutationOptions<InviteUserByUserNameMutation, InviteUserByUserNameMutationVariables>;
export const AcceptInvite2Document = gql`
    mutation AcceptInvite2($inviteId: String!, $didAcceptAllDisclosures: Boolean!) {
  user {
    acceptInvite2(
      inviteId: $inviteId
      didAcceptAllDisclosures: $didAcceptAllDisclosures
    ) {
      success
      redirectUrl
      errorMessage
    }
  }
}
    `;
export type AcceptInvite2MutationFn = Apollo.MutationFunction<AcceptInvite2Mutation, AcceptInvite2MutationVariables>;

/**
 * __useAcceptInvite2Mutation__
 *
 * To run a mutation, you first call `useAcceptInvite2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvite2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvite2Mutation, { data, loading, error }] = useAcceptInvite2Mutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      didAcceptAllDisclosures: // value for 'didAcceptAllDisclosures'
 *   },
 * });
 */
export function useAcceptInvite2Mutation(baseOptions?: Apollo.MutationHookOptions<AcceptInvite2Mutation, AcceptInvite2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInvite2Mutation, AcceptInvite2MutationVariables>(AcceptInvite2Document, options);
      }
export type AcceptInvite2MutationHookResult = ReturnType<typeof useAcceptInvite2Mutation>;
export type AcceptInvite2MutationResult = Apollo.MutationResult<AcceptInvite2Mutation>;
export type AcceptInvite2MutationOptions = Apollo.BaseMutationOptions<AcceptInvite2Mutation, AcceptInvite2MutationVariables>;
export const SendInviteeEmailVerificationDocument = gql`
    mutation SendInviteeEmailVerification($inviteId: String!) {
  user {
    sendInviteeEmailVerification(inviteId: $inviteId) {
      success
      maskedEmail
      nextResend
      expiresAt
      blockedUntil
    }
  }
}
    `;
export type SendInviteeEmailVerificationMutationFn = Apollo.MutationFunction<SendInviteeEmailVerificationMutation, SendInviteeEmailVerificationMutationVariables>;

/**
 * __useSendInviteeEmailVerificationMutation__
 *
 * To run a mutation, you first call `useSendInviteeEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteeEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteeEmailVerificationMutation, { data, loading, error }] = useSendInviteeEmailVerificationMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useSendInviteeEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<SendInviteeEmailVerificationMutation, SendInviteeEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInviteeEmailVerificationMutation, SendInviteeEmailVerificationMutationVariables>(SendInviteeEmailVerificationDocument, options);
      }
export type SendInviteeEmailVerificationMutationHookResult = ReturnType<typeof useSendInviteeEmailVerificationMutation>;
export type SendInviteeEmailVerificationMutationResult = Apollo.MutationResult<SendInviteeEmailVerificationMutation>;
export type SendInviteeEmailVerificationMutationOptions = Apollo.BaseMutationOptions<SendInviteeEmailVerificationMutation, SendInviteeEmailVerificationMutationVariables>;
export const AcceptInviteWithEmailVerificationDocument = gql`
    mutation AcceptInviteWithEmailVerification($inviteId: String!, $code: String!, $didAcceptAllDisclosures: Boolean) {
  user {
    acceptInviteWithEmailVerification(
      inviteId: $inviteId
      code: $code
      didAcceptAllDisclosures: $didAcceptAllDisclosures
    ) {
      success
      redirectUrl
      errorMessage
      verificationResult
      maxAttempts
      failedAttempts
      blockedUntil
    }
  }
}
    `;
export type AcceptInviteWithEmailVerificationMutationFn = Apollo.MutationFunction<AcceptInviteWithEmailVerificationMutation, AcceptInviteWithEmailVerificationMutationVariables>;

/**
 * __useAcceptInviteWithEmailVerificationMutation__
 *
 * To run a mutation, you first call `useAcceptInviteWithEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteWithEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteWithEmailVerificationMutation, { data, loading, error }] = useAcceptInviteWithEmailVerificationMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      code: // value for 'code'
 *      didAcceptAllDisclosures: // value for 'didAcceptAllDisclosures'
 *   },
 * });
 */
export function useAcceptInviteWithEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteWithEmailVerificationMutation, AcceptInviteWithEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteWithEmailVerificationMutation, AcceptInviteWithEmailVerificationMutationVariables>(AcceptInviteWithEmailVerificationDocument, options);
      }
export type AcceptInviteWithEmailVerificationMutationHookResult = ReturnType<typeof useAcceptInviteWithEmailVerificationMutation>;
export type AcceptInviteWithEmailVerificationMutationResult = Apollo.MutationResult<AcceptInviteWithEmailVerificationMutation>;
export type AcceptInviteWithEmailVerificationMutationOptions = Apollo.BaseMutationOptions<AcceptInviteWithEmailVerificationMutation, AcceptInviteWithEmailVerificationMutationVariables>;
export const DeclineInviteDocument = gql`
    mutation DeclineInvite($inviteId: String!) {
  user {
    declineInvite(inviteId: $inviteId)
  }
}
    `;
export type DeclineInviteMutationFn = Apollo.MutationFunction<DeclineInviteMutation, DeclineInviteMutationVariables>;

/**
 * __useDeclineInviteMutation__
 *
 * To run a mutation, you first call `useDeclineInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineInviteMutation, { data, loading, error }] = useDeclineInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useDeclineInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeclineInviteMutation, DeclineInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineInviteMutation, DeclineInviteMutationVariables>(DeclineInviteDocument, options);
      }
export type DeclineInviteMutationHookResult = ReturnType<typeof useDeclineInviteMutation>;
export type DeclineInviteMutationResult = Apollo.MutationResult<DeclineInviteMutation>;
export type DeclineInviteMutationOptions = Apollo.BaseMutationOptions<DeclineInviteMutation, DeclineInviteMutationVariables>;
export const UpdateSkipMultiFactorAuthenticationDocument = gql`
    mutation UpdateSkipMultiFactorAuthentication($skipMultiFactorAuthentication: Boolean) {
  user {
    updateSkipMultiFactorAuthentication(
      skipMultiFactorAuthentication: $skipMultiFactorAuthentication
    )
  }
}
    `;
export type UpdateSkipMultiFactorAuthenticationMutationFn = Apollo.MutationFunction<UpdateSkipMultiFactorAuthenticationMutation, UpdateSkipMultiFactorAuthenticationMutationVariables>;

/**
 * __useUpdateSkipMultiFactorAuthenticationMutation__
 *
 * To run a mutation, you first call `useUpdateSkipMultiFactorAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkipMultiFactorAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSkipMultiFactorAuthenticationMutation, { data, loading, error }] = useUpdateSkipMultiFactorAuthenticationMutation({
 *   variables: {
 *      skipMultiFactorAuthentication: // value for 'skipMultiFactorAuthentication'
 *   },
 * });
 */
export function useUpdateSkipMultiFactorAuthenticationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSkipMultiFactorAuthenticationMutation, UpdateSkipMultiFactorAuthenticationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSkipMultiFactorAuthenticationMutation, UpdateSkipMultiFactorAuthenticationMutationVariables>(UpdateSkipMultiFactorAuthenticationDocument, options);
      }
export type UpdateSkipMultiFactorAuthenticationMutationHookResult = ReturnType<typeof useUpdateSkipMultiFactorAuthenticationMutation>;
export type UpdateSkipMultiFactorAuthenticationMutationResult = Apollo.MutationResult<UpdateSkipMultiFactorAuthenticationMutation>;
export type UpdateSkipMultiFactorAuthenticationMutationOptions = Apollo.BaseMutationOptions<UpdateSkipMultiFactorAuthenticationMutation, UpdateSkipMultiFactorAuthenticationMutationVariables>;
export const UpdateEmailSubscriptionDocument = gql`
    mutation UpdateEmailSubscription($emailSubscriptionOptions: [EmailSubscriptionArgsInput!]!) {
  user {
    updateEmailSubscription(args: $emailSubscriptionOptions)
  }
}
    `;
export type UpdateEmailSubscriptionMutationFn = Apollo.MutationFunction<UpdateEmailSubscriptionMutation, UpdateEmailSubscriptionMutationVariables>;

/**
 * __useUpdateEmailSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateEmailSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailSubscriptionMutation, { data, loading, error }] = useUpdateEmailSubscriptionMutation({
 *   variables: {
 *      emailSubscriptionOptions: // value for 'emailSubscriptionOptions'
 *   },
 * });
 */
export function useUpdateEmailSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailSubscriptionMutation, UpdateEmailSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailSubscriptionMutation, UpdateEmailSubscriptionMutationVariables>(UpdateEmailSubscriptionDocument, options);
      }
export type UpdateEmailSubscriptionMutationHookResult = ReturnType<typeof useUpdateEmailSubscriptionMutation>;
export type UpdateEmailSubscriptionMutationResult = Apollo.MutationResult<UpdateEmailSubscriptionMutation>;
export type UpdateEmailSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateEmailSubscriptionMutation, UpdateEmailSubscriptionMutationVariables>;
export const UpdateWalkthroughDocument = gql`
    mutation UpdateWalkthrough($walkthrough: [WalkthroughArgsInput!]!) {
  user {
    updateWalkthrough(args: $walkthrough) {
      status
      type
    }
  }
}
    `;
export type UpdateWalkthroughMutationFn = Apollo.MutationFunction<UpdateWalkthroughMutation, UpdateWalkthroughMutationVariables>;

/**
 * __useUpdateWalkthroughMutation__
 *
 * To run a mutation, you first call `useUpdateWalkthroughMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWalkthroughMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWalkthroughMutation, { data, loading, error }] = useUpdateWalkthroughMutation({
 *   variables: {
 *      walkthrough: // value for 'walkthrough'
 *   },
 * });
 */
export function useUpdateWalkthroughMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWalkthroughMutation, UpdateWalkthroughMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWalkthroughMutation, UpdateWalkthroughMutationVariables>(UpdateWalkthroughDocument, options);
      }
export type UpdateWalkthroughMutationHookResult = ReturnType<typeof useUpdateWalkthroughMutation>;
export type UpdateWalkthroughMutationResult = Apollo.MutationResult<UpdateWalkthroughMutation>;
export type UpdateWalkthroughMutationOptions = Apollo.BaseMutationOptions<UpdateWalkthroughMutation, UpdateWalkthroughMutationVariables>;
export const WishPieDocument = gql`
    mutation WishPie($pieId: UUID!) {
  user {
    wishPie(pieId: $pieId)
  }
}
    `;
export type WishPieMutationFn = Apollo.MutationFunction<WishPieMutation, WishPieMutationVariables>;

/**
 * __useWishPieMutation__
 *
 * To run a mutation, you first call `useWishPieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWishPieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wishPieMutation, { data, loading, error }] = useWishPieMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *   },
 * });
 */
export function useWishPieMutation(baseOptions?: Apollo.MutationHookOptions<WishPieMutation, WishPieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WishPieMutation, WishPieMutationVariables>(WishPieDocument, options);
      }
export type WishPieMutationHookResult = ReturnType<typeof useWishPieMutation>;
export type WishPieMutationResult = Apollo.MutationResult<WishPieMutation>;
export type WishPieMutationOptions = Apollo.BaseMutationOptions<WishPieMutation, WishPieMutationVariables>;
export const UnwishPieDocument = gql`
    mutation UnwishPie($pieId: UUID!) {
  user {
    unwishPie(pieId: $pieId)
  }
}
    `;
export type UnwishPieMutationFn = Apollo.MutationFunction<UnwishPieMutation, UnwishPieMutationVariables>;

/**
 * __useUnwishPieMutation__
 *
 * To run a mutation, you first call `useUnwishPieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnwishPieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unwishPieMutation, { data, loading, error }] = useUnwishPieMutation({
 *   variables: {
 *      pieId: // value for 'pieId'
 *   },
 * });
 */
export function useUnwishPieMutation(baseOptions?: Apollo.MutationHookOptions<UnwishPieMutation, UnwishPieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnwishPieMutation, UnwishPieMutationVariables>(UnwishPieDocument, options);
      }
export type UnwishPieMutationHookResult = ReturnType<typeof useUnwishPieMutation>;
export type UnwishPieMutationResult = Apollo.MutationResult<UnwishPieMutation>;
export type UnwishPieMutationOptions = Apollo.BaseMutationOptions<UnwishPieMutation, UnwishPieMutationVariables>;
export const FollowUserDocument = gql`
    mutation FollowUser($userId: UUID!) {
  user {
    followUser(userId: $userId)
  }
}
    `;
export type FollowUserMutationFn = Apollo.MutationFunction<FollowUserMutation, FollowUserMutationVariables>;

/**
 * __useFollowUserMutation__
 *
 * To run a mutation, you first call `useFollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUserMutation, { data, loading, error }] = useFollowUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFollowUserMutation(baseOptions?: Apollo.MutationHookOptions<FollowUserMutation, FollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowUserMutation, FollowUserMutationVariables>(FollowUserDocument, options);
      }
export type FollowUserMutationHookResult = ReturnType<typeof useFollowUserMutation>;
export type FollowUserMutationResult = Apollo.MutationResult<FollowUserMutation>;
export type FollowUserMutationOptions = Apollo.BaseMutationOptions<FollowUserMutation, FollowUserMutationVariables>;
export const UnfollowUserDocument = gql`
    mutation UnfollowUser($userId: UUID!) {
  user {
    unfollowUser(userId: $userId)
  }
}
    `;
export type UnfollowUserMutationFn = Apollo.MutationFunction<UnfollowUserMutation, UnfollowUserMutationVariables>;

/**
 * __useUnfollowUserMutation__
 *
 * To run a mutation, you first call `useUnfollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowUserMutation, { data, loading, error }] = useUnfollowUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnfollowUserMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowUserMutation, UnfollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowUserMutation, UnfollowUserMutationVariables>(UnfollowUserDocument, options);
      }
export type UnfollowUserMutationHookResult = ReturnType<typeof useUnfollowUserMutation>;
export type UnfollowUserMutationResult = Apollo.MutationResult<UnfollowUserMutation>;
export type UnfollowUserMutationOptions = Apollo.BaseMutationOptions<UnfollowUserMutation, UnfollowUserMutationVariables>;
export const QueryInviteDocument = gql`
    mutation QueryInvite($inviteId: String!, $viewSource: AttributionChannel, $deliveryId: UUID) {
  user {
    queryInvite(
      inviteId: $inviteId
      viewSource: $viewSource
      deliveryId: $deliveryId
    ) {
      actions {
        disclosure {
          acceptButtonTitle
          description
          documentUrl
          title
        }
        acceptAction {
          inviteActionName
          inviteActionData {
            key
            value
          }
        }
      }
      acceptedAt
      expiresAt
      validInvitesRemaining
      isInviteUsed
      isUsedByMe
      isInvited
      isPrivateToAnotherPerson
      additionalProperties {
        key
        value
      }
      redirectUrl
      sharedTicket {
        isEnabledWishList
        color
        balance {
          availableAmount
        }
        eventTicketId
        isActive
        price
        ticketType
        isPrivate
        optInShowTicketAmount
        additionalGuests
        transactionStatus
        note
        isRequiredApproval
        sortOrder
        actionLabel
        requiresDisclosureSignature
        fulfillmentMethods {
          electronic
          ship
          pickup
        }
      }
    }
  }
}
    `;
export type QueryInviteMutationFn = Apollo.MutationFunction<QueryInviteMutation, QueryInviteMutationVariables>;

/**
 * __useQueryInviteMutation__
 *
 * To run a mutation, you first call `useQueryInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueryInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queryInviteMutation, { data, loading, error }] = useQueryInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      viewSource: // value for 'viewSource'
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
export function useQueryInviteMutation(baseOptions?: Apollo.MutationHookOptions<QueryInviteMutation, QueryInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QueryInviteMutation, QueryInviteMutationVariables>(QueryInviteDocument, options);
      }
export type QueryInviteMutationHookResult = ReturnType<typeof useQueryInviteMutation>;
export type QueryInviteMutationResult = Apollo.MutationResult<QueryInviteMutation>;
export type QueryInviteMutationOptions = Apollo.BaseMutationOptions<QueryInviteMutation, QueryInviteMutationVariables>;
export const DeletePasskeyCredentialDocument = gql`
    mutation DeletePasskeyCredential($credentialId: String!) {
  deletePasskeyCredential(credentialId: $credentialId)
}
    `;
export type DeletePasskeyCredentialMutationFn = Apollo.MutationFunction<DeletePasskeyCredentialMutation, DeletePasskeyCredentialMutationVariables>;

/**
 * __useDeletePasskeyCredentialMutation__
 *
 * To run a mutation, you first call `useDeletePasskeyCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePasskeyCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePasskeyCredentialMutation, { data, loading, error }] = useDeletePasskeyCredentialMutation({
 *   variables: {
 *      credentialId: // value for 'credentialId'
 *   },
 * });
 */
export function useDeletePasskeyCredentialMutation(baseOptions?: Apollo.MutationHookOptions<DeletePasskeyCredentialMutation, DeletePasskeyCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePasskeyCredentialMutation, DeletePasskeyCredentialMutationVariables>(DeletePasskeyCredentialDocument, options);
      }
export type DeletePasskeyCredentialMutationHookResult = ReturnType<typeof useDeletePasskeyCredentialMutation>;
export type DeletePasskeyCredentialMutationResult = Apollo.MutationResult<DeletePasskeyCredentialMutation>;
export type DeletePasskeyCredentialMutationOptions = Apollo.BaseMutationOptions<DeletePasskeyCredentialMutation, DeletePasskeyCredentialMutationVariables>;
export const AttachExistingStripeAccountDocument = gql`
    mutation AttachExistingStripeAccount {
  stripeAccount {
    attachExistingAccount {
      authorizationUrl
    }
  }
}
    `;
export type AttachExistingStripeAccountMutationFn = Apollo.MutationFunction<AttachExistingStripeAccountMutation, AttachExistingStripeAccountMutationVariables>;

/**
 * __useAttachExistingStripeAccountMutation__
 *
 * To run a mutation, you first call `useAttachExistingStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachExistingStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachExistingStripeAccountMutation, { data, loading, error }] = useAttachExistingStripeAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useAttachExistingStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<AttachExistingStripeAccountMutation, AttachExistingStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachExistingStripeAccountMutation, AttachExistingStripeAccountMutationVariables>(AttachExistingStripeAccountDocument, options);
      }
export type AttachExistingStripeAccountMutationHookResult = ReturnType<typeof useAttachExistingStripeAccountMutation>;
export type AttachExistingStripeAccountMutationResult = Apollo.MutationResult<AttachExistingStripeAccountMutation>;
export type AttachExistingStripeAccountMutationOptions = Apollo.BaseMutationOptions<AttachExistingStripeAccountMutation, AttachExistingStripeAccountMutationVariables>;
export const DisconnectStripeAccountDocument = gql`
    mutation DisconnectStripeAccount {
  stripeAccount {
    disconnect {
      success
    }
  }
}
    `;
export type DisconnectStripeAccountMutationFn = Apollo.MutationFunction<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>;

/**
 * __useDisconnectStripeAccountMutation__
 *
 * To run a mutation, you first call `useDisconnectStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectStripeAccountMutation, { data, loading, error }] = useDisconnectStripeAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>(DisconnectStripeAccountDocument, options);
      }
export type DisconnectStripeAccountMutationHookResult = ReturnType<typeof useDisconnectStripeAccountMutation>;
export type DisconnectStripeAccountMutationResult = Apollo.MutationResult<DisconnectStripeAccountMutation>;
export type DisconnectStripeAccountMutationOptions = Apollo.BaseMutationOptions<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>;
export const StartStripeManagementSessionDocument = gql`
    mutation StartStripeManagementSession {
  stripeAccount {
    startManagementSession {
      clientSecret
    }
  }
}
    `;
export type StartStripeManagementSessionMutationFn = Apollo.MutationFunction<StartStripeManagementSessionMutation, StartStripeManagementSessionMutationVariables>;

/**
 * __useStartStripeManagementSessionMutation__
 *
 * To run a mutation, you first call `useStartStripeManagementSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartStripeManagementSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startStripeManagementSessionMutation, { data, loading, error }] = useStartStripeManagementSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartStripeManagementSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartStripeManagementSessionMutation, StartStripeManagementSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartStripeManagementSessionMutation, StartStripeManagementSessionMutationVariables>(StartStripeManagementSessionDocument, options);
      }
export type StartStripeManagementSessionMutationHookResult = ReturnType<typeof useStartStripeManagementSessionMutation>;
export type StartStripeManagementSessionMutationResult = Apollo.MutationResult<StartStripeManagementSessionMutation>;
export type StartStripeManagementSessionMutationOptions = Apollo.BaseMutationOptions<StartStripeManagementSessionMutation, StartStripeManagementSessionMutationVariables>;
export const StartStripeOnboardingSessionDocument = gql`
    mutation StartStripeOnboardingSession {
  stripeAccount {
    startOnboardingSession {
      clientSecret
    }
  }
}
    `;
export type StartStripeOnboardingSessionMutationFn = Apollo.MutationFunction<StartStripeOnboardingSessionMutation, StartStripeOnboardingSessionMutationVariables>;

/**
 * __useStartStripeOnboardingSessionMutation__
 *
 * To run a mutation, you first call `useStartStripeOnboardingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartStripeOnboardingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startStripeOnboardingSessionMutation, { data, loading, error }] = useStartStripeOnboardingSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartStripeOnboardingSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartStripeOnboardingSessionMutation, StartStripeOnboardingSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartStripeOnboardingSessionMutation, StartStripeOnboardingSessionMutationVariables>(StartStripeOnboardingSessionDocument, options);
      }
export type StartStripeOnboardingSessionMutationHookResult = ReturnType<typeof useStartStripeOnboardingSessionMutation>;
export type StartStripeOnboardingSessionMutationResult = Apollo.MutationResult<StartStripeOnboardingSessionMutation>;
export type StartStripeOnboardingSessionMutationOptions = Apollo.BaseMutationOptions<StartStripeOnboardingSessionMutation, StartStripeOnboardingSessionMutationVariables>;
export const UpdateSkipPasskeyRegistrationDocument = gql`
    mutation UpdateSkipPasskeyRegistration($skipPasskeyRegistration: Boolean!) {
  user {
    updateSkipPasskeyRegistration(skipPasskeyRegistration: $skipPasskeyRegistration)
  }
}
    `;
export type UpdateSkipPasskeyRegistrationMutationFn = Apollo.MutationFunction<UpdateSkipPasskeyRegistrationMutation, UpdateSkipPasskeyRegistrationMutationVariables>;

/**
 * __useUpdateSkipPasskeyRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdateSkipPasskeyRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkipPasskeyRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSkipPasskeyRegistrationMutation, { data, loading, error }] = useUpdateSkipPasskeyRegistrationMutation({
 *   variables: {
 *      skipPasskeyRegistration: // value for 'skipPasskeyRegistration'
 *   },
 * });
 */
export function useUpdateSkipPasskeyRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSkipPasskeyRegistrationMutation, UpdateSkipPasskeyRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSkipPasskeyRegistrationMutation, UpdateSkipPasskeyRegistrationMutationVariables>(UpdateSkipPasskeyRegistrationDocument, options);
      }
export type UpdateSkipPasskeyRegistrationMutationHookResult = ReturnType<typeof useUpdateSkipPasskeyRegistrationMutation>;
export type UpdateSkipPasskeyRegistrationMutationResult = Apollo.MutationResult<UpdateSkipPasskeyRegistrationMutation>;
export type UpdateSkipPasskeyRegistrationMutationOptions = Apollo.BaseMutationOptions<UpdateSkipPasskeyRegistrationMutation, UpdateSkipPasskeyRegistrationMutationVariables>;
export const AssignToBrandedUrlDocument = gql`
    mutation AssignToBrandedUrl($eventId: UUID!) {
  user {
    assignToBrandedUrl(eventId: $eventId)
  }
}
    `;
export type AssignToBrandedUrlMutationFn = Apollo.MutationFunction<AssignToBrandedUrlMutation, AssignToBrandedUrlMutationVariables>;

/**
 * __useAssignToBrandedUrlMutation__
 *
 * To run a mutation, you first call `useAssignToBrandedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignToBrandedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignToBrandedUrlMutation, { data, loading, error }] = useAssignToBrandedUrlMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAssignToBrandedUrlMutation(baseOptions?: Apollo.MutationHookOptions<AssignToBrandedUrlMutation, AssignToBrandedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignToBrandedUrlMutation, AssignToBrandedUrlMutationVariables>(AssignToBrandedUrlDocument, options);
      }
export type AssignToBrandedUrlMutationHookResult = ReturnType<typeof useAssignToBrandedUrlMutation>;
export type AssignToBrandedUrlMutationResult = Apollo.MutationResult<AssignToBrandedUrlMutation>;
export type AssignToBrandedUrlMutationOptions = Apollo.BaseMutationOptions<AssignToBrandedUrlMutation, AssignToBrandedUrlMutationVariables>;
export const UnassignFromBrandedUrlDocument = gql`
    mutation UnassignFromBrandedUrl {
  user {
    unassignFromBrandedUrl
  }
}
    `;
export type UnassignFromBrandedUrlMutationFn = Apollo.MutationFunction<UnassignFromBrandedUrlMutation, UnassignFromBrandedUrlMutationVariables>;

/**
 * __useUnassignFromBrandedUrlMutation__
 *
 * To run a mutation, you first call `useUnassignFromBrandedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignFromBrandedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignFromBrandedUrlMutation, { data, loading, error }] = useUnassignFromBrandedUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnassignFromBrandedUrlMutation(baseOptions?: Apollo.MutationHookOptions<UnassignFromBrandedUrlMutation, UnassignFromBrandedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignFromBrandedUrlMutation, UnassignFromBrandedUrlMutationVariables>(UnassignFromBrandedUrlDocument, options);
      }
export type UnassignFromBrandedUrlMutationHookResult = ReturnType<typeof useUnassignFromBrandedUrlMutation>;
export type UnassignFromBrandedUrlMutationResult = Apollo.MutationResult<UnassignFromBrandedUrlMutation>;
export type UnassignFromBrandedUrlMutationOptions = Apollo.BaseMutationOptions<UnassignFromBrandedUrlMutation, UnassignFromBrandedUrlMutationVariables>;
export const RequestCreateEventApprovalDocument = gql`
    mutation RequestCreateEventApproval {
  user {
    requestCreateEventApproval
  }
}
    `;
export type RequestCreateEventApprovalMutationFn = Apollo.MutationFunction<RequestCreateEventApprovalMutation, RequestCreateEventApprovalMutationVariables>;

/**
 * __useRequestCreateEventApprovalMutation__
 *
 * To run a mutation, you first call `useRequestCreateEventApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCreateEventApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCreateEventApprovalMutation, { data, loading, error }] = useRequestCreateEventApprovalMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestCreateEventApprovalMutation(baseOptions?: Apollo.MutationHookOptions<RequestCreateEventApprovalMutation, RequestCreateEventApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCreateEventApprovalMutation, RequestCreateEventApprovalMutationVariables>(RequestCreateEventApprovalDocument, options);
      }
export type RequestCreateEventApprovalMutationHookResult = ReturnType<typeof useRequestCreateEventApprovalMutation>;
export type RequestCreateEventApprovalMutationResult = Apollo.MutationResult<RequestCreateEventApprovalMutation>;
export type RequestCreateEventApprovalMutationOptions = Apollo.BaseMutationOptions<RequestCreateEventApprovalMutation, RequestCreateEventApprovalMutationVariables>;
export const RequestCreateEventTypeApprovalDocument = gql`
    mutation RequestCreateEventTypeApproval($type: AllowCreateEventType!) {
  user {
    requestCreateEventTypeApproval(type: $type)
  }
}
    `;
export type RequestCreateEventTypeApprovalMutationFn = Apollo.MutationFunction<RequestCreateEventTypeApprovalMutation, RequestCreateEventTypeApprovalMutationVariables>;

/**
 * __useRequestCreateEventTypeApprovalMutation__
 *
 * To run a mutation, you first call `useRequestCreateEventTypeApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCreateEventTypeApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCreateEventTypeApprovalMutation, { data, loading, error }] = useRequestCreateEventTypeApprovalMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRequestCreateEventTypeApprovalMutation(baseOptions?: Apollo.MutationHookOptions<RequestCreateEventTypeApprovalMutation, RequestCreateEventTypeApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCreateEventTypeApprovalMutation, RequestCreateEventTypeApprovalMutationVariables>(RequestCreateEventTypeApprovalDocument, options);
      }
export type RequestCreateEventTypeApprovalMutationHookResult = ReturnType<typeof useRequestCreateEventTypeApprovalMutation>;
export type RequestCreateEventTypeApprovalMutationResult = Apollo.MutationResult<RequestCreateEventTypeApprovalMutation>;
export type RequestCreateEventTypeApprovalMutationOptions = Apollo.BaseMutationOptions<RequestCreateEventTypeApprovalMutation, RequestCreateEventTypeApprovalMutationVariables>;
export const UpdateTaxConfigurationDocument = gql`
    mutation UpdateTaxConfiguration($args: UpdateTaxConfigurationArgInput!) {
  user {
    updateTaxConfiguration(args: $args)
  }
}
    `;
export type UpdateTaxConfigurationMutationFn = Apollo.MutationFunction<UpdateTaxConfigurationMutation, UpdateTaxConfigurationMutationVariables>;

/**
 * __useUpdateTaxConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateTaxConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxConfigurationMutation, { data, loading, error }] = useUpdateTaxConfigurationMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useUpdateTaxConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxConfigurationMutation, UpdateTaxConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxConfigurationMutation, UpdateTaxConfigurationMutationVariables>(UpdateTaxConfigurationDocument, options);
      }
export type UpdateTaxConfigurationMutationHookResult = ReturnType<typeof useUpdateTaxConfigurationMutation>;
export type UpdateTaxConfigurationMutationResult = Apollo.MutationResult<UpdateTaxConfigurationMutation>;
export type UpdateTaxConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateTaxConfigurationMutation, UpdateTaxConfigurationMutationVariables>;
export const DepositDocument = gql`
    mutation Deposit($value: Decimal!, $symbol: String!, $ref: String!) {
  wallet {
    deposit(amount: {symbol: $symbol, value: $value}, ref: $ref)
  }
}
    `;
export type DepositMutationFn = Apollo.MutationFunction<DepositMutation, DepositMutationVariables>;

/**
 * __useDepositMutation__
 *
 * To run a mutation, you first call `useDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [depositMutation, { data, loading, error }] = useDepositMutation({
 *   variables: {
 *      value: // value for 'value'
 *      symbol: // value for 'symbol'
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useDepositMutation(baseOptions?: Apollo.MutationHookOptions<DepositMutation, DepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DepositMutation, DepositMutationVariables>(DepositDocument, options);
      }
export type DepositMutationHookResult = ReturnType<typeof useDepositMutation>;
export type DepositMutationResult = Apollo.MutationResult<DepositMutation>;
export type DepositMutationOptions = Apollo.BaseMutationOptions<DepositMutation, DepositMutationVariables>;
export const WithdrawDocument = gql`
    mutation Withdraw($value: Decimal!, $symbol: String!, $ref: String!) {
  wallet {
    withdraw(amount: {symbol: $symbol, value: $value}, ref: $ref)
  }
}
    `;
export type WithdrawMutationFn = Apollo.MutationFunction<WithdrawMutation, WithdrawMutationVariables>;

/**
 * __useWithdrawMutation__
 *
 * To run a mutation, you first call `useWithdrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawMutation, { data, loading, error }] = useWithdrawMutation({
 *   variables: {
 *      value: // value for 'value'
 *      symbol: // value for 'symbol'
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useWithdrawMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawMutation, WithdrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawMutation, WithdrawMutationVariables>(WithdrawDocument, options);
      }
export type WithdrawMutationHookResult = ReturnType<typeof useWithdrawMutation>;
export type WithdrawMutationResult = Apollo.MutationResult<WithdrawMutation>;
export type WithdrawMutationOptions = Apollo.BaseMutationOptions<WithdrawMutation, WithdrawMutationVariables>;
export const GetAchievementByIdDocument = gql`
    query GetAchievementById($id: UUID!) {
  achievement {
    byId(id: $id) {
      achievementId
      slug
      displayName
      bio
      avatarUrl
      createdUtc
      status
      category
      isHidden
      activeFromUtc
      activeToUtc
      maxSupply
      claimedByRewards2 {
        rewardId
        mustOwnSlicesStartDate
        achievementBadgeConditions {
          nodes {
            achievement {
              achievementId
              avatarUrl
              displayName
            }
            startDate
            endDate
          }
        }
        ownSlicesConditions {
          nodes {
            id
            amount
            startDate
            pie {
              pieId
              slug
              displayName
            }
          }
        }
      }
      statisticsByRewards {
        userAchievements {
          userInfo {
            userId
            isVerified
            name
            gender
            ageRange
            dateOfBirth
            userName
          }
          achievementUserInfo {
            createdUtc
          }
        }
      }
      fromReward {
        category
        userRewardInfo {
          userRewardInfo {
            ordinalWinner
            totalWinner
            participateState
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAchievementByIdQuery__
 *
 * To run a query within a React component, call `useGetAchievementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchievementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchievementByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAchievementByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAchievementByIdQuery, GetAchievementByIdQueryVariables> & ({ variables: GetAchievementByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAchievementByIdQuery, GetAchievementByIdQueryVariables>(GetAchievementByIdDocument, options);
      }
export function useGetAchievementByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAchievementByIdQuery, GetAchievementByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAchievementByIdQuery, GetAchievementByIdQueryVariables>(GetAchievementByIdDocument, options);
        }
export function useGetAchievementByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAchievementByIdQuery, GetAchievementByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAchievementByIdQuery, GetAchievementByIdQueryVariables>(GetAchievementByIdDocument, options);
        }
export type GetAchievementByIdQueryHookResult = ReturnType<typeof useGetAchievementByIdQuery>;
export type GetAchievementByIdLazyQueryHookResult = ReturnType<typeof useGetAchievementByIdLazyQuery>;
export type GetAchievementByIdSuspenseQueryHookResult = ReturnType<typeof useGetAchievementByIdSuspenseQuery>;
export type GetAchievementByIdQueryResult = Apollo.QueryResult<GetAchievementByIdQuery, GetAchievementByIdQueryVariables>;
export const GetAchievementPublicByIdDocument = gql`
    query GetAchievementPublicById($id: UUID!) {
  achievementPublic {
    byId(id: $id) {
      achievementId
      slug
      displayName
      bio
      avatarUrl
      createdUtc
      status
      category
      isHidden
      claimedByRewards2 {
        rewardId
        mustOwnSlicesStartDate
        achievementBadgeConditions {
          nodes {
            achievement {
              achievementId
              avatarUrl
              displayName
            }
            startDate
            endDate
          }
        }
        ownSlicesConditions {
          nodes {
            id
            amount
            startDate
            pie {
              pieId
              slug
              displayName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAchievementPublicByIdQuery__
 *
 * To run a query within a React component, call `useGetAchievementPublicByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchievementPublicByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchievementPublicByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAchievementPublicByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAchievementPublicByIdQuery, GetAchievementPublicByIdQueryVariables> & ({ variables: GetAchievementPublicByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAchievementPublicByIdQuery, GetAchievementPublicByIdQueryVariables>(GetAchievementPublicByIdDocument, options);
      }
export function useGetAchievementPublicByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAchievementPublicByIdQuery, GetAchievementPublicByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAchievementPublicByIdQuery, GetAchievementPublicByIdQueryVariables>(GetAchievementPublicByIdDocument, options);
        }
export function useGetAchievementPublicByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAchievementPublicByIdQuery, GetAchievementPublicByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAchievementPublicByIdQuery, GetAchievementPublicByIdQueryVariables>(GetAchievementPublicByIdDocument, options);
        }
export type GetAchievementPublicByIdQueryHookResult = ReturnType<typeof useGetAchievementPublicByIdQuery>;
export type GetAchievementPublicByIdLazyQueryHookResult = ReturnType<typeof useGetAchievementPublicByIdLazyQuery>;
export type GetAchievementPublicByIdSuspenseQueryHookResult = ReturnType<typeof useGetAchievementPublicByIdSuspenseQuery>;
export type GetAchievementPublicByIdQueryResult = Apollo.QueryResult<GetAchievementPublicByIdQuery, GetAchievementPublicByIdQueryVariables>;
export const GetAchievementBySlugOrIdDocument = gql`
    query GetAchievementBySlugOrId($pieSlugOrId: String!, $achievementSlugOrId: String!, $triggeredRewardIds: [UUID!]) {
  achievement {
    bySlugOrId(pieSlugOrId: $pieSlugOrId, achievementSlugOrId: $achievementSlugOrId) {
      achievementId
      slug
      displayName
      bio
      avatarUrl
      createdUtc
      status
      category
      isHidden
      activeFromUtc
      activeToUtc
      maxSupply
      fromReward {
        rewardId
        displayName
      }
      claimedByRewards2 {
        rewardId
        mustOwnSlicesStartDate
        achievementBadgeConditions {
          nodes {
            achievement {
              achievementId
              avatarUrl
              displayName
            }
            startDate
            endDate
          }
        }
        ownSlicesConditions {
          nodes {
            id
            amount
            startDate
            pie {
              pieId
              slug
              displayName
            }
          }
        }
      }
      statisticsByRewards(triggeredRewardIds: $triggeredRewardIds) {
        triggeredByRewards {
          rewardId
          displayName
          avatarUrl
          achievementBadgeConditions {
            nodes {
              achievement {
                achievementId
                avatarUrl
                displayName
              }
              startDate
              endDate
            }
          }
          ownSlicesConditions {
            nodes {
              id
              amount
              startDate
              pie {
                pieId
                slug
                displayName
              }
            }
          }
        }
        userAchievements {
          userInfo {
            userId
            isVerified
            name
            gender
            ageRange
            dateOfBirth
            userName
          }
          achievementUserInfo {
            createdUtc
          }
        }
        ageRangeStatistic {
          ageRangeFrom18To24 {
            totalFemaleAmount
            totalFemaleAmountPercentage
            totalMaleAmount
            totalMaleAmountPercentage
            totalOtherAmount
            totalOtherAmountPercentage
          }
          ageRangeFrom25To34 {
            totalFemaleAmount
            totalFemaleAmountPercentage
            totalMaleAmount
            totalMaleAmountPercentage
            totalOtherAmount
            totalOtherAmountPercentage
          }
          ageRangeFrom35To44 {
            totalFemaleAmount
            totalFemaleAmountPercentage
            totalMaleAmount
            totalMaleAmountPercentage
            totalOtherAmount
            totalOtherAmountPercentage
          }
          ageOver44 {
            totalFemaleAmount
            totalFemaleAmountPercentage
            totalMaleAmount
            totalMaleAmountPercentage
            totalOtherAmount
            totalOtherAmountPercentage
          }
          totalFemaleAmount
          totalFemaleAmountPercentage
          totalMaleAmount
          totalMaleAmountPercentage
          totalOtherAmount
          totalOtherAmountPercentage
        }
      }
    }
  }
}
    `;

/**
 * __useGetAchievementBySlugOrIdQuery__
 *
 * To run a query within a React component, call `useGetAchievementBySlugOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchievementBySlugOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchievementBySlugOrIdQuery({
 *   variables: {
 *      pieSlugOrId: // value for 'pieSlugOrId'
 *      achievementSlugOrId: // value for 'achievementSlugOrId'
 *      triggeredRewardIds: // value for 'triggeredRewardIds'
 *   },
 * });
 */
export function useGetAchievementBySlugOrIdQuery(baseOptions: Apollo.QueryHookOptions<GetAchievementBySlugOrIdQuery, GetAchievementBySlugOrIdQueryVariables> & ({ variables: GetAchievementBySlugOrIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAchievementBySlugOrIdQuery, GetAchievementBySlugOrIdQueryVariables>(GetAchievementBySlugOrIdDocument, options);
      }
export function useGetAchievementBySlugOrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAchievementBySlugOrIdQuery, GetAchievementBySlugOrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAchievementBySlugOrIdQuery, GetAchievementBySlugOrIdQueryVariables>(GetAchievementBySlugOrIdDocument, options);
        }
export function useGetAchievementBySlugOrIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAchievementBySlugOrIdQuery, GetAchievementBySlugOrIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAchievementBySlugOrIdQuery, GetAchievementBySlugOrIdQueryVariables>(GetAchievementBySlugOrIdDocument, options);
        }
export type GetAchievementBySlugOrIdQueryHookResult = ReturnType<typeof useGetAchievementBySlugOrIdQuery>;
export type GetAchievementBySlugOrIdLazyQueryHookResult = ReturnType<typeof useGetAchievementBySlugOrIdLazyQuery>;
export type GetAchievementBySlugOrIdSuspenseQueryHookResult = ReturnType<typeof useGetAchievementBySlugOrIdSuspenseQuery>;
export type GetAchievementBySlugOrIdQueryResult = Apollo.QueryResult<GetAchievementBySlugOrIdQuery, GetAchievementBySlugOrIdQueryVariables>;
export const GetAchievementsDocument = gql`
    query GetAchievements($first: Int!, $after: String, $name: String!, $sortingType: AchievementSortType, $sortingOrder: PageSortOrder) {
  achievement {
    listAchievements2(
      first: $first
      after: $after
      name: $name
      sortingType: $sortingType
      sortingOrder: $sortingOrder
    ) {
      achievementList {
        nodes {
          achievementId
          slug
          displayName
          bio
          avatarUrl
          createdUtc
          status
          category
          isHidden
          activeFromUtc
          activeToUtc
          maxSupply
          owner {
            userId
            userName
            name
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      totalUnlockAchievementAmount
    }
  }
}
    `;

/**
 * __useGetAchievementsQuery__
 *
 * To run a query within a React component, call `useGetAchievementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchievementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchievementsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      sortingType: // value for 'sortingType'
 *      sortingOrder: // value for 'sortingOrder'
 *   },
 * });
 */
export function useGetAchievementsQuery(baseOptions: Apollo.QueryHookOptions<GetAchievementsQuery, GetAchievementsQueryVariables> & ({ variables: GetAchievementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAchievementsQuery, GetAchievementsQueryVariables>(GetAchievementsDocument, options);
      }
export function useGetAchievementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAchievementsQuery, GetAchievementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAchievementsQuery, GetAchievementsQueryVariables>(GetAchievementsDocument, options);
        }
export function useGetAchievementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAchievementsQuery, GetAchievementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAchievementsQuery, GetAchievementsQueryVariables>(GetAchievementsDocument, options);
        }
export type GetAchievementsQueryHookResult = ReturnType<typeof useGetAchievementsQuery>;
export type GetAchievementsLazyQueryHookResult = ReturnType<typeof useGetAchievementsLazyQuery>;
export type GetAchievementsSuspenseQueryHookResult = ReturnType<typeof useGetAchievementsSuspenseQuery>;
export type GetAchievementsQueryResult = Apollo.QueryResult<GetAchievementsQuery, GetAchievementsQueryVariables>;
export const GetAchievementsByPieIdDocument = gql`
    query GetAchievementsByPieId($first: Int!, $after: String, $pieId: UUID!, $keyword: String, $sortingType: AchievementSortType, $sortingOrder: PageSortOrder) {
  achievement {
    listByPieId2(
      first: $first
      after: $after
      pieId: $pieId
      keyword: $keyword
      sortingType: $sortingType
      sortingOrder: $sortingOrder
    ) {
      achievementList {
        nodes {
          achievementId
          slug
          displayName
          bio
          avatarUrl
          createdUtc
          status
          category
          isHidden
          activeFromUtc
          activeToUtc
          maxSupply
          owner {
            userId
            userName
            name
            avatarUrl
          }
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      totalUnlockAchievementAmount
    }
  }
}
    `;

/**
 * __useGetAchievementsByPieIdQuery__
 *
 * To run a query within a React component, call `useGetAchievementsByPieIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchievementsByPieIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchievementsByPieIdQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      pieId: // value for 'pieId'
 *      keyword: // value for 'keyword'
 *      sortingType: // value for 'sortingType'
 *      sortingOrder: // value for 'sortingOrder'
 *   },
 * });
 */
export function useGetAchievementsByPieIdQuery(baseOptions: Apollo.QueryHookOptions<GetAchievementsByPieIdQuery, GetAchievementsByPieIdQueryVariables> & ({ variables: GetAchievementsByPieIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAchievementsByPieIdQuery, GetAchievementsByPieIdQueryVariables>(GetAchievementsByPieIdDocument, options);
      }
export function useGetAchievementsByPieIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAchievementsByPieIdQuery, GetAchievementsByPieIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAchievementsByPieIdQuery, GetAchievementsByPieIdQueryVariables>(GetAchievementsByPieIdDocument, options);
        }
export function useGetAchievementsByPieIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAchievementsByPieIdQuery, GetAchievementsByPieIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAchievementsByPieIdQuery, GetAchievementsByPieIdQueryVariables>(GetAchievementsByPieIdDocument, options);
        }
export type GetAchievementsByPieIdQueryHookResult = ReturnType<typeof useGetAchievementsByPieIdQuery>;
export type GetAchievementsByPieIdLazyQueryHookResult = ReturnType<typeof useGetAchievementsByPieIdLazyQuery>;
export type GetAchievementsByPieIdSuspenseQueryHookResult = ReturnType<typeof useGetAchievementsByPieIdSuspenseQuery>;
export type GetAchievementsByPieIdQueryResult = Apollo.QueryResult<GetAchievementsByPieIdQuery, GetAchievementsByPieIdQueryVariables>;
export const GetUserAchievementsDocument = gql`
    query GetUserAchievements($first: Int!, $after: String, $sortingType: PageSortOrder!) {
  achievement {
    userAchievements(first: $first, after: $after, sortingType: $sortingType) {
      nodes {
        achievementId
        activeFromUtc
        displayName
        bio
        createdUtc
        status
        slug
        avatarUrl
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useGetUserAchievementsQuery__
 *
 * To run a query within a React component, call `useGetUserAchievementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAchievementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAchievementsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortingType: // value for 'sortingType'
 *   },
 * });
 */
export function useGetUserAchievementsQuery(baseOptions: Apollo.QueryHookOptions<GetUserAchievementsQuery, GetUserAchievementsQueryVariables> & ({ variables: GetUserAchievementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAchievementsQuery, GetUserAchievementsQueryVariables>(GetUserAchievementsDocument, options);
      }
export function useGetUserAchievementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAchievementsQuery, GetUserAchievementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAchievementsQuery, GetUserAchievementsQueryVariables>(GetUserAchievementsDocument, options);
        }
export function useGetUserAchievementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAchievementsQuery, GetUserAchievementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAchievementsQuery, GetUserAchievementsQueryVariables>(GetUserAchievementsDocument, options);
        }
export type GetUserAchievementsQueryHookResult = ReturnType<typeof useGetUserAchievementsQuery>;
export type GetUserAchievementsLazyQueryHookResult = ReturnType<typeof useGetUserAchievementsLazyQuery>;
export type GetUserAchievementsSuspenseQueryHookResult = ReturnType<typeof useGetUserAchievementsSuspenseQuery>;
export type GetUserAchievementsQueryResult = Apollo.QueryResult<GetUserAchievementsQuery, GetUserAchievementsQueryVariables>;
export const GetClubAchievementsDocument = gql`
    query GetClubAchievements($clubId: UUID!, $first: Int!, $after: String) {
  clubAchievements(clubId: $clubId, first: $first, after: $after) {
    nodes {
      achievementId
      avatarUrl
      description
      name
      type
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
    }
  }
}
    `;

/**
 * __useGetClubAchievementsQuery__
 *
 * To run a query within a React component, call `useGetClubAchievementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubAchievementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubAchievementsQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetClubAchievementsQuery(baseOptions: Apollo.QueryHookOptions<GetClubAchievementsQuery, GetClubAchievementsQueryVariables> & ({ variables: GetClubAchievementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubAchievementsQuery, GetClubAchievementsQueryVariables>(GetClubAchievementsDocument, options);
      }
export function useGetClubAchievementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubAchievementsQuery, GetClubAchievementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubAchievementsQuery, GetClubAchievementsQueryVariables>(GetClubAchievementsDocument, options);
        }
export function useGetClubAchievementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubAchievementsQuery, GetClubAchievementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubAchievementsQuery, GetClubAchievementsQueryVariables>(GetClubAchievementsDocument, options);
        }
export type GetClubAchievementsQueryHookResult = ReturnType<typeof useGetClubAchievementsQuery>;
export type GetClubAchievementsLazyQueryHookResult = ReturnType<typeof useGetClubAchievementsLazyQuery>;
export type GetClubAchievementsSuspenseQueryHookResult = ReturnType<typeof useGetClubAchievementsSuspenseQuery>;
export type GetClubAchievementsQueryResult = Apollo.QueryResult<GetClubAchievementsQuery, GetClubAchievementsQueryVariables>;
export const GetClubAchivementDocument = gql`
    query GetClubAchivement($slug: String!, $achievementId: UUID!) {
  clubBySlug(slug: $slug) {
    achievements(filter: {achievementId: $achievementId}) {
      nodes {
        achievementId
        avatarUrl
        description
        name
        type
      }
    }
    clubId
    name
  }
}
    `;

/**
 * __useGetClubAchivementQuery__
 *
 * To run a query within a React component, call `useGetClubAchivementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubAchivementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubAchivementQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      achievementId: // value for 'achievementId'
 *   },
 * });
 */
export function useGetClubAchivementQuery(baseOptions: Apollo.QueryHookOptions<GetClubAchivementQuery, GetClubAchivementQueryVariables> & ({ variables: GetClubAchivementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubAchivementQuery, GetClubAchivementQueryVariables>(GetClubAchivementDocument, options);
      }
export function useGetClubAchivementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubAchivementQuery, GetClubAchivementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubAchivementQuery, GetClubAchivementQueryVariables>(GetClubAchivementDocument, options);
        }
export function useGetClubAchivementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubAchivementQuery, GetClubAchivementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubAchivementQuery, GetClubAchivementQueryVariables>(GetClubAchivementDocument, options);
        }
export type GetClubAchivementQueryHookResult = ReturnType<typeof useGetClubAchivementQuery>;
export type GetClubAchivementLazyQueryHookResult = ReturnType<typeof useGetClubAchivementLazyQuery>;
export type GetClubAchivementSuspenseQueryHookResult = ReturnType<typeof useGetClubAchivementSuspenseQuery>;
export type GetClubAchivementQueryResult = Apollo.QueryResult<GetClubAchivementQuery, GetClubAchivementQueryVariables>;
export const GeneralGetMyEventsDocument = gql`
    query GeneralGetMyEvents($criteria: SearchMyCreatedEventCriteriaInput, $first: Int, $after: String) {
  event {
    myEvents(criteria: $criteria, first: $first, after: $after) {
      nodes {
        slug
        eventId
      }
    }
  }
}
    `;

/**
 * __useGeneralGetMyEventsQuery__
 *
 * To run a query within a React component, call `useGeneralGetMyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralGetMyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralGetMyEventsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGeneralGetMyEventsQuery(baseOptions?: Apollo.QueryHookOptions<GeneralGetMyEventsQuery, GeneralGetMyEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralGetMyEventsQuery, GeneralGetMyEventsQueryVariables>(GeneralGetMyEventsDocument, options);
      }
export function useGeneralGetMyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralGetMyEventsQuery, GeneralGetMyEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralGetMyEventsQuery, GeneralGetMyEventsQueryVariables>(GeneralGetMyEventsDocument, options);
        }
export function useGeneralGetMyEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralGetMyEventsQuery, GeneralGetMyEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeneralGetMyEventsQuery, GeneralGetMyEventsQueryVariables>(GeneralGetMyEventsDocument, options);
        }
export type GeneralGetMyEventsQueryHookResult = ReturnType<typeof useGeneralGetMyEventsQuery>;
export type GeneralGetMyEventsLazyQueryHookResult = ReturnType<typeof useGeneralGetMyEventsLazyQuery>;
export type GeneralGetMyEventsSuspenseQueryHookResult = ReturnType<typeof useGeneralGetMyEventsSuspenseQuery>;
export type GeneralGetMyEventsQueryResult = Apollo.QueryResult<GeneralGetMyEventsQuery, GeneralGetMyEventsQueryVariables>;
export const ContactSharePreviewDocument = gql`
    query ContactSharePreview($inviteToken: String!) {
  contactList {
    contactSharePreview(inviteToken: $inviteToken) {
      sharerUserId
      sharerUserName
      sharerUserAvatarUrl
      contactCount
      isAlreadyAccepted
      acceptedAt
    }
  }
}
    `;

/**
 * __useContactSharePreviewQuery__
 *
 * To run a query within a React component, call `useContactSharePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactSharePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactSharePreviewQuery({
 *   variables: {
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useContactSharePreviewQuery(baseOptions: Apollo.QueryHookOptions<ContactSharePreviewQuery, ContactSharePreviewQueryVariables> & ({ variables: ContactSharePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactSharePreviewQuery, ContactSharePreviewQueryVariables>(ContactSharePreviewDocument, options);
      }
export function useContactSharePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactSharePreviewQuery, ContactSharePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactSharePreviewQuery, ContactSharePreviewQueryVariables>(ContactSharePreviewDocument, options);
        }
export function useContactSharePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactSharePreviewQuery, ContactSharePreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactSharePreviewQuery, ContactSharePreviewQueryVariables>(ContactSharePreviewDocument, options);
        }
export type ContactSharePreviewQueryHookResult = ReturnType<typeof useContactSharePreviewQuery>;
export type ContactSharePreviewLazyQueryHookResult = ReturnType<typeof useContactSharePreviewLazyQuery>;
export type ContactSharePreviewSuspenseQueryHookResult = ReturnType<typeof useContactSharePreviewSuspenseQuery>;
export type ContactSharePreviewQueryResult = Apollo.QueryResult<ContactSharePreviewQuery, ContactSharePreviewQueryVariables>;
export const ShareCopyStatusDocument = gql`
    query ShareCopyStatus($jobId: String!) {
  contactList {
    shareCopyStatus(jobId: $jobId) {
      status
      totalContacts
      processedContacts
      copiedContactCount
      skippedContactCount
      failContactCount
      groupName
      startedAt
      completedAt
    }
  }
}
    `;

/**
 * __useShareCopyStatusQuery__
 *
 * To run a query within a React component, call `useShareCopyStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareCopyStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareCopyStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useShareCopyStatusQuery(baseOptions: Apollo.QueryHookOptions<ShareCopyStatusQuery, ShareCopyStatusQueryVariables> & ({ variables: ShareCopyStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShareCopyStatusQuery, ShareCopyStatusQueryVariables>(ShareCopyStatusDocument, options);
      }
export function useShareCopyStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShareCopyStatusQuery, ShareCopyStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShareCopyStatusQuery, ShareCopyStatusQueryVariables>(ShareCopyStatusDocument, options);
        }
export function useShareCopyStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShareCopyStatusQuery, ShareCopyStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShareCopyStatusQuery, ShareCopyStatusQueryVariables>(ShareCopyStatusDocument, options);
        }
export type ShareCopyStatusQueryHookResult = ReturnType<typeof useShareCopyStatusQuery>;
export type ShareCopyStatusLazyQueryHookResult = ReturnType<typeof useShareCopyStatusLazyQuery>;
export type ShareCopyStatusSuspenseQueryHookResult = ReturnType<typeof useShareCopyStatusSuspenseQuery>;
export type ShareCopyStatusQueryResult = Apollo.QueryResult<ShareCopyStatusQuery, ShareCopyStatusQueryVariables>;
export const SearchContactsDocument = gql`
    query SearchContacts($eventId: UUID!, $filterArgs: ContactPageFilterArgsInput!, $first: Int, $after: String) {
  contactList {
    contacts(
      eventId: $eventId
      filterArgs: $filterArgs
      first: $first
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
      nodes {
        ...ContactNodeFields
      }
    }
  }
}
    ${ContactNodeFieldsFragmentDoc}`;

/**
 * __useSearchContactsQuery__
 *
 * To run a query within a React component, call `useSearchContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      filterArgs: // value for 'filterArgs'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchContactsQuery(baseOptions: Apollo.QueryHookOptions<SearchContactsQuery, SearchContactsQueryVariables> & ({ variables: SearchContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContactsQuery, SearchContactsQueryVariables>(SearchContactsDocument, options);
      }
export function useSearchContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContactsQuery, SearchContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContactsQuery, SearchContactsQueryVariables>(SearchContactsDocument, options);
        }
export function useSearchContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchContactsQuery, SearchContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchContactsQuery, SearchContactsQueryVariables>(SearchContactsDocument, options);
        }
export type SearchContactsQueryHookResult = ReturnType<typeof useSearchContactsQuery>;
export type SearchContactsLazyQueryHookResult = ReturnType<typeof useSearchContactsLazyQuery>;
export type SearchContactsSuspenseQueryHookResult = ReturnType<typeof useSearchContactsSuspenseQuery>;
export type SearchContactsQueryResult = Apollo.QueryResult<SearchContactsQuery, SearchContactsQueryVariables>;
export const SearchContactsOffsetDocument = gql`
    query SearchContactsOffset($eventId: UUID!, $filterArgs: ContactPageFilterArgsInput!, $offset: Int!, $limit: Int!) {
  contactList {
    contactsOffset(
      eventId: $eventId
      filterArgs: $filterArgs
      offset: $offset
      limit: $limit
    ) {
      totalCount
      nodes {
        ...ContactNodeFields
      }
    }
  }
}
    ${ContactNodeFieldsFragmentDoc}`;

/**
 * __useSearchContactsOffsetQuery__
 *
 * To run a query within a React component, call `useSearchContactsOffsetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactsOffsetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactsOffsetQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      filterArgs: // value for 'filterArgs'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchContactsOffsetQuery(baseOptions: Apollo.QueryHookOptions<SearchContactsOffsetQuery, SearchContactsOffsetQueryVariables> & ({ variables: SearchContactsOffsetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContactsOffsetQuery, SearchContactsOffsetQueryVariables>(SearchContactsOffsetDocument, options);
      }
export function useSearchContactsOffsetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContactsOffsetQuery, SearchContactsOffsetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContactsOffsetQuery, SearchContactsOffsetQueryVariables>(SearchContactsOffsetDocument, options);
        }
export function useSearchContactsOffsetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchContactsOffsetQuery, SearchContactsOffsetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchContactsOffsetQuery, SearchContactsOffsetQueryVariables>(SearchContactsOffsetDocument, options);
        }
export type SearchContactsOffsetQueryHookResult = ReturnType<typeof useSearchContactsOffsetQuery>;
export type SearchContactsOffsetLazyQueryHookResult = ReturnType<typeof useSearchContactsOffsetLazyQuery>;
export type SearchContactsOffsetSuspenseQueryHookResult = ReturnType<typeof useSearchContactsOffsetSuspenseQuery>;
export type SearchContactsOffsetQueryResult = Apollo.QueryResult<SearchContactsOffsetQuery, SearchContactsOffsetQueryVariables>;
export const ExportContactsDocument = gql`
    query ExportContacts($eventId: UUID!, $filterArgs: ContactPageFilterArgsInput!) {
  contactList {
    exportContacts(eventId: $eventId, filterArgs: $filterArgs) {
      contactId
      name
      emailAddress
      phoneNumber
      createdAt
      city
      eventCount
    }
  }
}
    `;

/**
 * __useExportContactsQuery__
 *
 * To run a query within a React component, call `useExportContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportContactsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      filterArgs: // value for 'filterArgs'
 *   },
 * });
 */
export function useExportContactsQuery(baseOptions: Apollo.QueryHookOptions<ExportContactsQuery, ExportContactsQueryVariables> & ({ variables: ExportContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportContactsQuery, ExportContactsQueryVariables>(ExportContactsDocument, options);
      }
export function useExportContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportContactsQuery, ExportContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportContactsQuery, ExportContactsQueryVariables>(ExportContactsDocument, options);
        }
export function useExportContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportContactsQuery, ExportContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportContactsQuery, ExportContactsQueryVariables>(ExportContactsDocument, options);
        }
export type ExportContactsQueryHookResult = ReturnType<typeof useExportContactsQuery>;
export type ExportContactsLazyQueryHookResult = ReturnType<typeof useExportContactsLazyQuery>;
export type ExportContactsSuspenseQueryHookResult = ReturnType<typeof useExportContactsSuspenseQuery>;
export type ExportContactsQueryResult = Apollo.QueryResult<ExportContactsQuery, ExportContactsQueryVariables>;
export const GetContactGroupsDocument = gql`
    query GetContactGroups {
  contactList {
    groups {
      nodes {
        groupName
        groupId
        contactCount
      }
    }
  }
}
    `;

/**
 * __useGetContactGroupsQuery__
 *
 * To run a query within a React component, call `useGetContactGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetContactGroupsQuery, GetContactGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactGroupsQuery, GetContactGroupsQueryVariables>(GetContactGroupsDocument, options);
      }
export function useGetContactGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactGroupsQuery, GetContactGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactGroupsQuery, GetContactGroupsQueryVariables>(GetContactGroupsDocument, options);
        }
export function useGetContactGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactGroupsQuery, GetContactGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactGroupsQuery, GetContactGroupsQueryVariables>(GetContactGroupsDocument, options);
        }
export type GetContactGroupsQueryHookResult = ReturnType<typeof useGetContactGroupsQuery>;
export type GetContactGroupsLazyQueryHookResult = ReturnType<typeof useGetContactGroupsLazyQuery>;
export type GetContactGroupsSuspenseQueryHookResult = ReturnType<typeof useGetContactGroupsSuspenseQuery>;
export type GetContactGroupsQueryResult = Apollo.QueryResult<GetContactGroupsQuery, GetContactGroupsQueryVariables>;
export const GetBulkDeleteStatusDocument = gql`
    query GetBulkDeleteStatus($jobId: String!) {
  contactList {
    bulkDeleteStatus(jobId: $jobId) {
      jobId
      status
      totalCount
      processedCount
    }
  }
}
    `;

/**
 * __useGetBulkDeleteStatusQuery__
 *
 * To run a query within a React component, call `useGetBulkDeleteStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkDeleteStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkDeleteStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetBulkDeleteStatusQuery(baseOptions: Apollo.QueryHookOptions<GetBulkDeleteStatusQuery, GetBulkDeleteStatusQueryVariables> & ({ variables: GetBulkDeleteStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkDeleteStatusQuery, GetBulkDeleteStatusQueryVariables>(GetBulkDeleteStatusDocument, options);
      }
export function useGetBulkDeleteStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkDeleteStatusQuery, GetBulkDeleteStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkDeleteStatusQuery, GetBulkDeleteStatusQueryVariables>(GetBulkDeleteStatusDocument, options);
        }
export function useGetBulkDeleteStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBulkDeleteStatusQuery, GetBulkDeleteStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBulkDeleteStatusQuery, GetBulkDeleteStatusQueryVariables>(GetBulkDeleteStatusDocument, options);
        }
export type GetBulkDeleteStatusQueryHookResult = ReturnType<typeof useGetBulkDeleteStatusQuery>;
export type GetBulkDeleteStatusLazyQueryHookResult = ReturnType<typeof useGetBulkDeleteStatusLazyQuery>;
export type GetBulkDeleteStatusSuspenseQueryHookResult = ReturnType<typeof useGetBulkDeleteStatusSuspenseQuery>;
export type GetBulkDeleteStatusQueryResult = Apollo.QueryResult<GetBulkDeleteStatusQuery, GetBulkDeleteStatusQueryVariables>;
export const GetContactMessageStatusDocument = gql`
    query GetContactMessageStatus($jobId: String!) {
  contactList {
    messageStatus(jobId: $jobId) {
      jobId
      status
      totalCount
      processedCount
      sentCount
      failCount
      suppressedCount
      suppressedByListCount
      suppressedUnsubscribedCount
      suppressedWhitelistCount
      failureListTruncated
      failures {
        emailAddress
        phoneNumber
        reason
        channel
      }
    }
  }
}
    `;

/**
 * __useGetContactMessageStatusQuery__
 *
 * To run a query within a React component, call `useGetContactMessageStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactMessageStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactMessageStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetContactMessageStatusQuery(baseOptions: Apollo.QueryHookOptions<GetContactMessageStatusQuery, GetContactMessageStatusQueryVariables> & ({ variables: GetContactMessageStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactMessageStatusQuery, GetContactMessageStatusQueryVariables>(GetContactMessageStatusDocument, options);
      }
export function useGetContactMessageStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactMessageStatusQuery, GetContactMessageStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactMessageStatusQuery, GetContactMessageStatusQueryVariables>(GetContactMessageStatusDocument, options);
        }
export function useGetContactMessageStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactMessageStatusQuery, GetContactMessageStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactMessageStatusQuery, GetContactMessageStatusQueryVariables>(GetContactMessageStatusDocument, options);
        }
export type GetContactMessageStatusQueryHookResult = ReturnType<typeof useGetContactMessageStatusQuery>;
export type GetContactMessageStatusLazyQueryHookResult = ReturnType<typeof useGetContactMessageStatusLazyQuery>;
export type GetContactMessageStatusSuspenseQueryHookResult = ReturnType<typeof useGetContactMessageStatusSuspenseQuery>;
export type GetContactMessageStatusQueryResult = Apollo.QueryResult<GetContactMessageStatusQuery, GetContactMessageStatusQueryVariables>;
export const GetContactImportStatusDocument = gql`
    query GetContactImportStatus($jobId: String!) {
  contactList {
    bulkImportStatus(jobId: $jobId) {
      jobId
      status
      totalRows
      processedRows
      successCount
      failCount
      failures {
        row
        email
        reason
      }
    }
  }
}
    `;

/**
 * __useGetContactImportStatusQuery__
 *
 * To run a query within a React component, call `useGetContactImportStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactImportStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactImportStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetContactImportStatusQuery(baseOptions: Apollo.QueryHookOptions<GetContactImportStatusQuery, GetContactImportStatusQueryVariables> & ({ variables: GetContactImportStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactImportStatusQuery, GetContactImportStatusQueryVariables>(GetContactImportStatusDocument, options);
      }
export function useGetContactImportStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactImportStatusQuery, GetContactImportStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactImportStatusQuery, GetContactImportStatusQueryVariables>(GetContactImportStatusDocument, options);
        }
export function useGetContactImportStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactImportStatusQuery, GetContactImportStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactImportStatusQuery, GetContactImportStatusQueryVariables>(GetContactImportStatusDocument, options);
        }
export type GetContactImportStatusQueryHookResult = ReturnType<typeof useGetContactImportStatusQuery>;
export type GetContactImportStatusLazyQueryHookResult = ReturnType<typeof useGetContactImportStatusLazyQuery>;
export type GetContactImportStatusSuspenseQueryHookResult = ReturnType<typeof useGetContactImportStatusSuspenseQuery>;
export type GetContactImportStatusQueryResult = Apollo.QueryResult<GetContactImportStatusQuery, GetContactImportStatusQueryVariables>;
export const CountContactsDocument = gql`
    query CountContacts {
  contactList {
    count
  }
}
    `;

/**
 * __useCountContactsQuery__
 *
 * To run a query within a React component, call `useCountContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountContactsQuery(baseOptions?: Apollo.QueryHookOptions<CountContactsQuery, CountContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountContactsQuery, CountContactsQueryVariables>(CountContactsDocument, options);
      }
export function useCountContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountContactsQuery, CountContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountContactsQuery, CountContactsQueryVariables>(CountContactsDocument, options);
        }
export function useCountContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountContactsQuery, CountContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountContactsQuery, CountContactsQueryVariables>(CountContactsDocument, options);
        }
export type CountContactsQueryHookResult = ReturnType<typeof useCountContactsQuery>;
export type CountContactsLazyQueryHookResult = ReturnType<typeof useCountContactsLazyQuery>;
export type CountContactsSuspenseQueryHookResult = ReturnType<typeof useCountContactsSuspenseQuery>;
export type CountContactsQueryResult = Apollo.QueryResult<CountContactsQuery, CountContactsQueryVariables>;
export const GetContactCitiesDocument = gql`
    query GetContactCities {
  contactList {
    cities {
      city
      country
    }
  }
}
    `;

/**
 * __useGetContactCitiesQuery__
 *
 * To run a query within a React component, call `useGetContactCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactCitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetContactCitiesQuery, GetContactCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactCitiesQuery, GetContactCitiesQueryVariables>(GetContactCitiesDocument, options);
      }
export function useGetContactCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactCitiesQuery, GetContactCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactCitiesQuery, GetContactCitiesQueryVariables>(GetContactCitiesDocument, options);
        }
export function useGetContactCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactCitiesQuery, GetContactCitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactCitiesQuery, GetContactCitiesQueryVariables>(GetContactCitiesDocument, options);
        }
export type GetContactCitiesQueryHookResult = ReturnType<typeof useGetContactCitiesQuery>;
export type GetContactCitiesLazyQueryHookResult = ReturnType<typeof useGetContactCitiesLazyQuery>;
export type GetContactCitiesSuspenseQueryHookResult = ReturnType<typeof useGetContactCitiesSuspenseQuery>;
export type GetContactCitiesQueryResult = Apollo.QueryResult<GetContactCitiesQuery, GetContactCitiesQueryVariables>;
export const ContactsFilterGetEventTicketTypesDocument = gql`
    query ContactsFilterGetEventTicketTypes($slugOrId: String!, $first: Int, $after: String) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      eventTickets(first: $first, after: $after) {
        nodes {
          eventTicketId
          ticketType
          sortOrder
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      seriesPassTickets(first: 100) {
        nodes {
          eventTicketId
          ticketType
          sortOrder
        }
      }
    }
  }
}
    `;

/**
 * __useContactsFilterGetEventTicketTypesQuery__
 *
 * To run a query within a React component, call `useContactsFilterGetEventTicketTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsFilterGetEventTicketTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsFilterGetEventTicketTypesQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useContactsFilterGetEventTicketTypesQuery(baseOptions: Apollo.QueryHookOptions<ContactsFilterGetEventTicketTypesQuery, ContactsFilterGetEventTicketTypesQueryVariables> & ({ variables: ContactsFilterGetEventTicketTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsFilterGetEventTicketTypesQuery, ContactsFilterGetEventTicketTypesQueryVariables>(ContactsFilterGetEventTicketTypesDocument, options);
      }
export function useContactsFilterGetEventTicketTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsFilterGetEventTicketTypesQuery, ContactsFilterGetEventTicketTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsFilterGetEventTicketTypesQuery, ContactsFilterGetEventTicketTypesQueryVariables>(ContactsFilterGetEventTicketTypesDocument, options);
        }
export function useContactsFilterGetEventTicketTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsFilterGetEventTicketTypesQuery, ContactsFilterGetEventTicketTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsFilterGetEventTicketTypesQuery, ContactsFilterGetEventTicketTypesQueryVariables>(ContactsFilterGetEventTicketTypesDocument, options);
        }
export type ContactsFilterGetEventTicketTypesQueryHookResult = ReturnType<typeof useContactsFilterGetEventTicketTypesQuery>;
export type ContactsFilterGetEventTicketTypesLazyQueryHookResult = ReturnType<typeof useContactsFilterGetEventTicketTypesLazyQuery>;
export type ContactsFilterGetEventTicketTypesSuspenseQueryHookResult = ReturnType<typeof useContactsFilterGetEventTicketTypesSuspenseQuery>;
export type ContactsFilterGetEventTicketTypesQueryResult = Apollo.QueryResult<ContactsFilterGetEventTicketTypesQuery, ContactsFilterGetEventTicketTypesQueryVariables>;
export const GetPublicSeriesEventsDocument = gql`
    query GetPublicSeriesEvents($id: UUID!, $keyword: String, $status: SearchEventStatus, $sortBy: SeriesEventsSortBy, $sortOrder: PageSortOrder, $first: Int, $after: String) {
  eventSeries {
    publicSeriesEvents(
      id: $id
      keyword: $keyword
      status: $status
      sortBy: $sortBy
      sortOrder: $sortOrder
      first: $first
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        eventId
        slug
        displayName
        startDate
        timeZone
        avatarUrl
        location {
          locationName
          address
          city
          region
          postalCode
          countryCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetPublicSeriesEventsQuery__
 *
 * To run a query within a React component, call `useGetPublicSeriesEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicSeriesEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicSeriesEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      keyword: // value for 'keyword'
 *      status: // value for 'status'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPublicSeriesEventsQuery(baseOptions: Apollo.QueryHookOptions<GetPublicSeriesEventsQuery, GetPublicSeriesEventsQueryVariables> & ({ variables: GetPublicSeriesEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicSeriesEventsQuery, GetPublicSeriesEventsQueryVariables>(GetPublicSeriesEventsDocument, options);
      }
export function useGetPublicSeriesEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicSeriesEventsQuery, GetPublicSeriesEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicSeriesEventsQuery, GetPublicSeriesEventsQueryVariables>(GetPublicSeriesEventsDocument, options);
        }
export function useGetPublicSeriesEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicSeriesEventsQuery, GetPublicSeriesEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicSeriesEventsQuery, GetPublicSeriesEventsQueryVariables>(GetPublicSeriesEventsDocument, options);
        }
export type GetPublicSeriesEventsQueryHookResult = ReturnType<typeof useGetPublicSeriesEventsQuery>;
export type GetPublicSeriesEventsLazyQueryHookResult = ReturnType<typeof useGetPublicSeriesEventsLazyQuery>;
export type GetPublicSeriesEventsSuspenseQueryHookResult = ReturnType<typeof useGetPublicSeriesEventsSuspenseQuery>;
export type GetPublicSeriesEventsQueryResult = Apollo.QueryResult<GetPublicSeriesEventsQuery, GetPublicSeriesEventsQueryVariables>;
export const GetEventSeriesViewAllDocument = gql`
    query GetEventSeriesViewAll($slugOrId: String!, $keyword: String, $status: SearchEventStatus, $sortBy: SeriesEventsSortBy, $sortOrder: PageSortOrder, $first: Int) {
  eventSeries {
    bySlugOrId(slugOrId: $slugOrId) {
      eventSeriesId
      name
      slug
      publicEvents(
        keyword: $keyword
        status: $status
        sortBy: $sortBy
        sortOrder: $sortOrder
        first: $first
      ) {
        nodes {
          eventId
          slug
          displayName
          startDate
          timeZone
          avatarUrl
          location {
            locationName
            address
            city
            region
            postalCode
            countryCode
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventSeriesViewAllQuery__
 *
 * To run a query within a React component, call `useGetEventSeriesViewAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventSeriesViewAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventSeriesViewAllQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      keyword: // value for 'keyword'
 *      status: // value for 'status'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetEventSeriesViewAllQuery(baseOptions: Apollo.QueryHookOptions<GetEventSeriesViewAllQuery, GetEventSeriesViewAllQueryVariables> & ({ variables: GetEventSeriesViewAllQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventSeriesViewAllQuery, GetEventSeriesViewAllQueryVariables>(GetEventSeriesViewAllDocument, options);
      }
export function useGetEventSeriesViewAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventSeriesViewAllQuery, GetEventSeriesViewAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventSeriesViewAllQuery, GetEventSeriesViewAllQueryVariables>(GetEventSeriesViewAllDocument, options);
        }
export function useGetEventSeriesViewAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventSeriesViewAllQuery, GetEventSeriesViewAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventSeriesViewAllQuery, GetEventSeriesViewAllQueryVariables>(GetEventSeriesViewAllDocument, options);
        }
export type GetEventSeriesViewAllQueryHookResult = ReturnType<typeof useGetEventSeriesViewAllQuery>;
export type GetEventSeriesViewAllLazyQueryHookResult = ReturnType<typeof useGetEventSeriesViewAllLazyQuery>;
export type GetEventSeriesViewAllSuspenseQueryHookResult = ReturnType<typeof useGetEventSeriesViewAllSuspenseQuery>;
export type GetEventSeriesViewAllQueryResult = Apollo.QueryResult<GetEventSeriesViewAllQuery, GetEventSeriesViewAllQueryVariables>;
export const GetRelatedSeriesEventsDocument = gql`
    query GetRelatedSeriesEvents($id: UUID!, $slugOrId: String!, $status: SearchEventStatus, $first: Int) {
  eventSeries {
    bySlugOrId(slugOrId: $slugOrId) {
      eventSeriesId
      name
      slug
      parentEventId
    }
    publicSeriesEvents(id: $id, status: $status, first: $first) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        eventId
        slug
        displayName
        startDate
        timeZone
        avatarUrl
        location {
          locationName
          address
          city
          region
          postalCode
          countryCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetRelatedSeriesEventsQuery__
 *
 * To run a query within a React component, call `useGetRelatedSeriesEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedSeriesEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedSeriesEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slugOrId: // value for 'slugOrId'
 *      status: // value for 'status'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetRelatedSeriesEventsQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedSeriesEventsQuery, GetRelatedSeriesEventsQueryVariables> & ({ variables: GetRelatedSeriesEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedSeriesEventsQuery, GetRelatedSeriesEventsQueryVariables>(GetRelatedSeriesEventsDocument, options);
      }
export function useGetRelatedSeriesEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedSeriesEventsQuery, GetRelatedSeriesEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedSeriesEventsQuery, GetRelatedSeriesEventsQueryVariables>(GetRelatedSeriesEventsDocument, options);
        }
export function useGetRelatedSeriesEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRelatedSeriesEventsQuery, GetRelatedSeriesEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRelatedSeriesEventsQuery, GetRelatedSeriesEventsQueryVariables>(GetRelatedSeriesEventsDocument, options);
        }
export type GetRelatedSeriesEventsQueryHookResult = ReturnType<typeof useGetRelatedSeriesEventsQuery>;
export type GetRelatedSeriesEventsLazyQueryHookResult = ReturnType<typeof useGetRelatedSeriesEventsLazyQuery>;
export type GetRelatedSeriesEventsSuspenseQueryHookResult = ReturnType<typeof useGetRelatedSeriesEventsSuspenseQuery>;
export type GetRelatedSeriesEventsQueryResult = Apollo.QueryResult<GetRelatedSeriesEventsQuery, GetRelatedSeriesEventsQueryVariables>;
export const PublicEventSeriesBySlugOrIdDocument = gql`
    query PublicEventSeriesBySlugOrId($slugOrId: String!) {
  eventSeries {
    bySlugOrId(slugOrId: $slugOrId) {
      eventSeriesId
      name
      slug
    }
  }
}
    `;

/**
 * __usePublicEventSeriesBySlugOrIdQuery__
 *
 * To run a query within a React component, call `usePublicEventSeriesBySlugOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicEventSeriesBySlugOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicEventSeriesBySlugOrIdQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function usePublicEventSeriesBySlugOrIdQuery(baseOptions: Apollo.QueryHookOptions<PublicEventSeriesBySlugOrIdQuery, PublicEventSeriesBySlugOrIdQueryVariables> & ({ variables: PublicEventSeriesBySlugOrIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicEventSeriesBySlugOrIdQuery, PublicEventSeriesBySlugOrIdQueryVariables>(PublicEventSeriesBySlugOrIdDocument, options);
      }
export function usePublicEventSeriesBySlugOrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicEventSeriesBySlugOrIdQuery, PublicEventSeriesBySlugOrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicEventSeriesBySlugOrIdQuery, PublicEventSeriesBySlugOrIdQueryVariables>(PublicEventSeriesBySlugOrIdDocument, options);
        }
export function usePublicEventSeriesBySlugOrIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicEventSeriesBySlugOrIdQuery, PublicEventSeriesBySlugOrIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicEventSeriesBySlugOrIdQuery, PublicEventSeriesBySlugOrIdQueryVariables>(PublicEventSeriesBySlugOrIdDocument, options);
        }
export type PublicEventSeriesBySlugOrIdQueryHookResult = ReturnType<typeof usePublicEventSeriesBySlugOrIdQuery>;
export type PublicEventSeriesBySlugOrIdLazyQueryHookResult = ReturnType<typeof usePublicEventSeriesBySlugOrIdLazyQuery>;
export type PublicEventSeriesBySlugOrIdSuspenseQueryHookResult = ReturnType<typeof usePublicEventSeriesBySlugOrIdSuspenseQuery>;
export type PublicEventSeriesBySlugOrIdQueryResult = Apollo.QueryResult<PublicEventSeriesBySlugOrIdQuery, PublicEventSeriesBySlugOrIdQueryVariables>;
export const EventsManageGetSeriesTicketTypesDocument = gql`
    query EventsManageGetSeriesTicketTypes($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      eventTickets {
        nodes {
          eventTicketId
          ticketType
          isActive
          optInQrCodePass
          sortOrder
          price
          color
          additionalGuests
        }
      }
    }
  }
}
    `;

/**
 * __useEventsManageGetSeriesTicketTypesQuery__
 *
 * To run a query within a React component, call `useEventsManageGetSeriesTicketTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetSeriesTicketTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetSeriesTicketTypesQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventsManageGetSeriesTicketTypesQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetSeriesTicketTypesQuery, EventsManageGetSeriesTicketTypesQueryVariables> & ({ variables: EventsManageGetSeriesTicketTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetSeriesTicketTypesQuery, EventsManageGetSeriesTicketTypesQueryVariables>(EventsManageGetSeriesTicketTypesDocument, options);
      }
export function useEventsManageGetSeriesTicketTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetSeriesTicketTypesQuery, EventsManageGetSeriesTicketTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetSeriesTicketTypesQuery, EventsManageGetSeriesTicketTypesQueryVariables>(EventsManageGetSeriesTicketTypesDocument, options);
        }
export function useEventsManageGetSeriesTicketTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetSeriesTicketTypesQuery, EventsManageGetSeriesTicketTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetSeriesTicketTypesQuery, EventsManageGetSeriesTicketTypesQueryVariables>(EventsManageGetSeriesTicketTypesDocument, options);
        }
export type EventsManageGetSeriesTicketTypesQueryHookResult = ReturnType<typeof useEventsManageGetSeriesTicketTypesQuery>;
export type EventsManageGetSeriesTicketTypesLazyQueryHookResult = ReturnType<typeof useEventsManageGetSeriesTicketTypesLazyQuery>;
export type EventsManageGetSeriesTicketTypesSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetSeriesTicketTypesSuspenseQuery>;
export type EventsManageGetSeriesTicketTypesQueryResult = Apollo.QueryResult<EventsManageGetSeriesTicketTypesQuery, EventsManageGetSeriesTicketTypesQueryVariables>;
export const SeriesEntriesDocument = gql`
    query SeriesEntries($id: UUID!) {
  eventSeries {
    series(id: $id) {
      eventSeriesId
      entries {
        unmappedScanRows
        asOfUtc
        events {
          eventId
          entries
          checkedIn
          capacity
          own {
            entries
            checkedIn
            scans
          }
          passHolders {
            entries
            checkedIn
            scans
          }
          passGuests {
            entries
            checkedIn
            scans
          }
          plusOnes {
            shared
            live
            everyEvent
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSeriesEntriesQuery__
 *
 * To run a query within a React component, call `useSeriesEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesEntriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSeriesEntriesQuery(baseOptions: Apollo.QueryHookOptions<SeriesEntriesQuery, SeriesEntriesQueryVariables> & ({ variables: SeriesEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeriesEntriesQuery, SeriesEntriesQueryVariables>(SeriesEntriesDocument, options);
      }
export function useSeriesEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeriesEntriesQuery, SeriesEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeriesEntriesQuery, SeriesEntriesQueryVariables>(SeriesEntriesDocument, options);
        }
export function useSeriesEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeriesEntriesQuery, SeriesEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeriesEntriesQuery, SeriesEntriesQueryVariables>(SeriesEntriesDocument, options);
        }
export type SeriesEntriesQueryHookResult = ReturnType<typeof useSeriesEntriesQuery>;
export type SeriesEntriesLazyQueryHookResult = ReturnType<typeof useSeriesEntriesLazyQuery>;
export type SeriesEntriesSuspenseQueryHookResult = ReturnType<typeof useSeriesEntriesSuspenseQuery>;
export type SeriesEntriesQueryResult = Apollo.QueryResult<SeriesEntriesQuery, SeriesEntriesQueryVariables>;
export const SeriesPassesDocument = gql`
    query SeriesPasses($id: UUID!) {
  eventSeries {
    series(id: $id) {
      eventSeriesId
      passes {
        passesSold
        guestTickets
        capacity
        capacityTickets
        hasTicketsForSale
        asOfUtc
        plusOnes {
          validNow
          validForEventId
          shared
          expired
          everyEventActive
          legacyUnstamped
        }
        passTypes {
          eventTicketId
          ticketType
          price
          isActive
          additionalGuests
          resetAdditionalGuestsAfterEachEvent
          optInQrCodePass
          passesSold
          guestTickets
          capacity
        }
      }
    }
  }
}
    `;

/**
 * __useSeriesPassesQuery__
 *
 * To run a query within a React component, call `useSeriesPassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesPassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesPassesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSeriesPassesQuery(baseOptions: Apollo.QueryHookOptions<SeriesPassesQuery, SeriesPassesQueryVariables> & ({ variables: SeriesPassesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeriesPassesQuery, SeriesPassesQueryVariables>(SeriesPassesDocument, options);
      }
export function useSeriesPassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeriesPassesQuery, SeriesPassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeriesPassesQuery, SeriesPassesQueryVariables>(SeriesPassesDocument, options);
        }
export function useSeriesPassesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeriesPassesQuery, SeriesPassesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeriesPassesQuery, SeriesPassesQueryVariables>(SeriesPassesDocument, options);
        }
export type SeriesPassesQueryHookResult = ReturnType<typeof useSeriesPassesQuery>;
export type SeriesPassesLazyQueryHookResult = ReturnType<typeof useSeriesPassesLazyQuery>;
export type SeriesPassesSuspenseQueryHookResult = ReturnType<typeof useSeriesPassesSuspenseQuery>;
export type SeriesPassesQueryResult = Apollo.QueryResult<SeriesPassesQuery, SeriesPassesQueryVariables>;
export const SeriesHasTicketsForSaleDocument = gql`
    query SeriesHasTicketsForSale($id: UUID!) {
  eventSeries {
    series(id: $id) {
      eventSeriesId
      hasTicketsForSale
    }
  }
}
    `;

/**
 * __useSeriesHasTicketsForSaleQuery__
 *
 * To run a query within a React component, call `useSeriesHasTicketsForSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesHasTicketsForSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesHasTicketsForSaleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSeriesHasTicketsForSaleQuery(baseOptions: Apollo.QueryHookOptions<SeriesHasTicketsForSaleQuery, SeriesHasTicketsForSaleQueryVariables> & ({ variables: SeriesHasTicketsForSaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeriesHasTicketsForSaleQuery, SeriesHasTicketsForSaleQueryVariables>(SeriesHasTicketsForSaleDocument, options);
      }
export function useSeriesHasTicketsForSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeriesHasTicketsForSaleQuery, SeriesHasTicketsForSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeriesHasTicketsForSaleQuery, SeriesHasTicketsForSaleQueryVariables>(SeriesHasTicketsForSaleDocument, options);
        }
export function useSeriesHasTicketsForSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeriesHasTicketsForSaleQuery, SeriesHasTicketsForSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeriesHasTicketsForSaleQuery, SeriesHasTicketsForSaleQueryVariables>(SeriesHasTicketsForSaleDocument, options);
        }
export type SeriesHasTicketsForSaleQueryHookResult = ReturnType<typeof useSeriesHasTicketsForSaleQuery>;
export type SeriesHasTicketsForSaleLazyQueryHookResult = ReturnType<typeof useSeriesHasTicketsForSaleLazyQuery>;
export type SeriesHasTicketsForSaleSuspenseQueryHookResult = ReturnType<typeof useSeriesHasTicketsForSaleSuspenseQuery>;
export type SeriesHasTicketsForSaleQueryResult = Apollo.QueryResult<SeriesHasTicketsForSaleQuery, SeriesHasTicketsForSaleQueryVariables>;
export const SeriesAudienceDocument = gql`
    query SeriesAudience($id: UUID!, $attendeeFilterStatus: AttendeeFilterStatus, $inviterId: UUID, $eventId: UUID) {
  eventSeries {
    series(id: $id) {
      eventSeriesId
      audience(
        attendeeFilterStatus: $attendeeFilterStatus
        inviterId: $inviterId
        eventId: $eventId
      ) {
        ageRangeUnder18 {
          totalFemaleAmount
          totalMaleAmount
          totalOtherAmount
          totalFemaleAmountPercentage
          totalMaleAmountPercentage
          totalOtherAmountPercentage
          totalFemaleTicketAmount
          totalMaleTicketAmount
          totalOtherTicketAmount
        }
        ageRangeFrom18To24 {
          totalFemaleAmount
          totalMaleAmount
          totalOtherAmount
          totalFemaleAmountPercentage
          totalMaleAmountPercentage
          totalOtherAmountPercentage
          totalFemaleTicketAmount
          totalMaleTicketAmount
          totalOtherTicketAmount
        }
        ageRangeFrom25To34 {
          totalFemaleAmount
          totalMaleAmount
          totalOtherAmount
          totalFemaleAmountPercentage
          totalMaleAmountPercentage
          totalOtherAmountPercentage
          totalFemaleTicketAmount
          totalMaleTicketAmount
          totalOtherTicketAmount
        }
        ageRangeFrom35To44 {
          totalFemaleAmount
          totalMaleAmount
          totalOtherAmount
          totalFemaleAmountPercentage
          totalMaleAmountPercentage
          totalOtherAmountPercentage
          totalFemaleTicketAmount
          totalMaleTicketAmount
          totalOtherTicketAmount
        }
        ageOver44 {
          totalFemaleAmount
          totalMaleAmount
          totalOtherAmount
          totalFemaleAmountPercentage
          totalMaleAmountPercentage
          totalOtherAmountPercentage
          totalFemaleTicketAmount
          totalMaleTicketAmount
          totalOtherTicketAmount
        }
        totalFemaleAmount
        totalMaleAmount
        totalOtherAmount
        totalFemaleAmountPercentage
        totalMaleAmountPercentage
        totalOtherAmountPercentage
        totalUserAmount
        totalFemaleTicketAmount
        totalMaleTicketAmount
        totalOtherTicketAmount
        totalTicketAmount
      }
    }
  }
}
    `;

/**
 * __useSeriesAudienceQuery__
 *
 * To run a query within a React component, call `useSeriesAudienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesAudienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesAudienceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      attendeeFilterStatus: // value for 'attendeeFilterStatus'
 *      inviterId: // value for 'inviterId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useSeriesAudienceQuery(baseOptions: Apollo.QueryHookOptions<SeriesAudienceQuery, SeriesAudienceQueryVariables> & ({ variables: SeriesAudienceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeriesAudienceQuery, SeriesAudienceQueryVariables>(SeriesAudienceDocument, options);
      }
export function useSeriesAudienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeriesAudienceQuery, SeriesAudienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeriesAudienceQuery, SeriesAudienceQueryVariables>(SeriesAudienceDocument, options);
        }
export function useSeriesAudienceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeriesAudienceQuery, SeriesAudienceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeriesAudienceQuery, SeriesAudienceQueryVariables>(SeriesAudienceDocument, options);
        }
export type SeriesAudienceQueryHookResult = ReturnType<typeof useSeriesAudienceQuery>;
export type SeriesAudienceLazyQueryHookResult = ReturnType<typeof useSeriesAudienceLazyQuery>;
export type SeriesAudienceSuspenseQueryHookResult = ReturnType<typeof useSeriesAudienceSuspenseQuery>;
export type SeriesAudienceQueryResult = Apollo.QueryResult<SeriesAudienceQuery, SeriesAudienceQueryVariables>;
export const SeriesEarningsDocument = gql`
    query SeriesEarnings($filter: EventEarningsFilterInput!) {
  event {
    getEventEarnings(filter: $filter) {
      totalFees
      totalPrice
      totalQuantity
      totalGratuity
      totalTaxes
      serviceFee
      processingFee
      hostBalance
      ticketBreakdown {
        eventTicketId
        ticketType
        unitPrice
        totalQuantity
        totalPrice
        event {
          eventId
        }
      }
    }
  }
}
    `;

/**
 * __useSeriesEarningsQuery__
 *
 * To run a query within a React component, call `useSeriesEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesEarningsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSeriesEarningsQuery(baseOptions: Apollo.QueryHookOptions<SeriesEarningsQuery, SeriesEarningsQueryVariables> & ({ variables: SeriesEarningsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeriesEarningsQuery, SeriesEarningsQueryVariables>(SeriesEarningsDocument, options);
      }
export function useSeriesEarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeriesEarningsQuery, SeriesEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeriesEarningsQuery, SeriesEarningsQueryVariables>(SeriesEarningsDocument, options);
        }
export function useSeriesEarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeriesEarningsQuery, SeriesEarningsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeriesEarningsQuery, SeriesEarningsQueryVariables>(SeriesEarningsDocument, options);
        }
export type SeriesEarningsQueryHookResult = ReturnType<typeof useSeriesEarningsQuery>;
export type SeriesEarningsLazyQueryHookResult = ReturnType<typeof useSeriesEarningsLazyQuery>;
export type SeriesEarningsSuspenseQueryHookResult = ReturnType<typeof useSeriesEarningsSuspenseQuery>;
export type SeriesEarningsQueryResult = Apollo.QueryResult<SeriesEarningsQuery, SeriesEarningsQueryVariables>;
export const SeriesWorkspaceEventsDocument = gql`
    query SeriesWorkspaceEvents($id: UUID!, $first: Int, $sortBy: SeriesEventsSortBy, $sortOrder: PageSortOrder) {
  eventSeries {
    seriesEvents(id: $id, first: $first, sortBy: $sortBy, sortOrder: $sortOrder) {
      totalCount
      nodes {
        eventId
        slug
        displayName
        avatarUrl
        startDate
        endDate
        timeZone
        isEnded
        isListed
        isPrivate
        currency
        eventType
        createdBy {
          userId
        }
        coHosts {
          nodes {
            userId
          }
        }
        promoters {
          nodes {
            userId
          }
        }
        attendeeInfo {
          attendeeInfo {
            attendeeRole
            permissions
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSeriesWorkspaceEventsQuery__
 *
 * To run a query within a React component, call `useSeriesWorkspaceEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesWorkspaceEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesWorkspaceEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSeriesWorkspaceEventsQuery(baseOptions: Apollo.QueryHookOptions<SeriesWorkspaceEventsQuery, SeriesWorkspaceEventsQueryVariables> & ({ variables: SeriesWorkspaceEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeriesWorkspaceEventsQuery, SeriesWorkspaceEventsQueryVariables>(SeriesWorkspaceEventsDocument, options);
      }
export function useSeriesWorkspaceEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeriesWorkspaceEventsQuery, SeriesWorkspaceEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeriesWorkspaceEventsQuery, SeriesWorkspaceEventsQueryVariables>(SeriesWorkspaceEventsDocument, options);
        }
export function useSeriesWorkspaceEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeriesWorkspaceEventsQuery, SeriesWorkspaceEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeriesWorkspaceEventsQuery, SeriesWorkspaceEventsQueryVariables>(SeriesWorkspaceEventsDocument, options);
        }
export type SeriesWorkspaceEventsQueryHookResult = ReturnType<typeof useSeriesWorkspaceEventsQuery>;
export type SeriesWorkspaceEventsLazyQueryHookResult = ReturnType<typeof useSeriesWorkspaceEventsLazyQuery>;
export type SeriesWorkspaceEventsSuspenseQueryHookResult = ReturnType<typeof useSeriesWorkspaceEventsSuspenseQuery>;
export type SeriesWorkspaceEventsQueryResult = Apollo.QueryResult<SeriesWorkspaceEventsQuery, SeriesWorkspaceEventsQueryVariables>;
export const GetEventRolePermissionsDocument = gql`
    query GetEventRolePermissions {
  eventRolePermissions {
    role
    roleName
    groups {
      category
      permissions {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetEventRolePermissionsQuery__
 *
 * To run a query within a React component, call `useGetEventRolePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventRolePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventRolePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEventRolePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventRolePermissionsQuery, GetEventRolePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventRolePermissionsQuery, GetEventRolePermissionsQueryVariables>(GetEventRolePermissionsDocument, options);
      }
export function useGetEventRolePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventRolePermissionsQuery, GetEventRolePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventRolePermissionsQuery, GetEventRolePermissionsQueryVariables>(GetEventRolePermissionsDocument, options);
        }
export function useGetEventRolePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventRolePermissionsQuery, GetEventRolePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventRolePermissionsQuery, GetEventRolePermissionsQueryVariables>(GetEventRolePermissionsDocument, options);
        }
export type GetEventRolePermissionsQueryHookResult = ReturnType<typeof useGetEventRolePermissionsQuery>;
export type GetEventRolePermissionsLazyQueryHookResult = ReturnType<typeof useGetEventRolePermissionsLazyQuery>;
export type GetEventRolePermissionsSuspenseQueryHookResult = ReturnType<typeof useGetEventRolePermissionsSuspenseQuery>;
export type GetEventRolePermissionsQueryResult = Apollo.QueryResult<GetEventRolePermissionsQuery, GetEventRolePermissionsQueryVariables>;
export const GetEventBySlugOrIdDocument = gql`
    query GetEventBySlugOrId($slugOrId: String!) {
  event {
    bySlugOrId(slugOrId: $slugOrId) {
      eventType
      ageLimit
      avatarUrl
      createdDate
      description
      terms
      faqs
      disclosureOrPrivacyPolicyTitle
      disclosureOrPrivacyPolicyFileUrl
      displayName
      endDate
      eventId
      expiresAt
      isDeleted
      isFeatured
      isPrivate
      minimumRepScore
      note
      optInAgeLimit
      optInAllowGuestInviteOthers
      optInDisclosureOrPrivacyPolicy
      optInDisplayRepScore
      optInLocationRadius
      ticketTermsPurchasePolicy
      locationRadius {
        address
        isActive
        latitude
        longitude
        radius
        unitLengthType
      }
      optInQuestionRequirements
      optInShowGuestCount
      optInShowGuestList
      optInSocialAccountRequirements
      requireSocialAccountConnection
      optInAllowPublicEventPagePreview
      slug
      startDate
      status
      updatedDate
      uploadedAssetId
      waitingTickets
      tickets {
        count
        firstSeen
        status
        ticketId
        eventTicket {
          color
          ticketType
          eventTicketId
          isPrivate
          note
          price
          optInQrCodePass
        }
        status
        isShareable
        isStaffTicket
        displayEventTicket {
          eventTicketId
          ticketType
          color
        }
        scanZones {
          id
          name
          scanCount
          scannedAtUtc
          scanTimes
          maxScans
          isUnlimitedScans
        }
      }
      eventTickets2 {
        isEnabledWishList
        color
        balance {
          limitedAmount
          availableAmount
          releasedAmount
        }
        isFull
        eventTicketId
        isActive
        price
        repPoints
        ticketType
        isSpecialGuest
        isPrivate
        specialGuestInfo {
          limitAmount
          purchasedAmount
          remainingAmount
        }
        optInShowTicketAmount
        visibleStartAt
        visibleEndAt
        additionalGuests
        transactionStatus
        note
        actionLabel
      }
      isListFull
      isStarted
      location {
        locationName
        address
        city
        region
        postalCode
        countryCode
        isOnlyVisibleToApprovedAttendees
        latitude
        longitude
      }
      questionRequirements {
        isRequired
        question
        showPublicTickets
        showPrivateTickets
        optInSpecificTicketTypes
        ticketTypeIds
      }
      socialAccountRequirements {
        isRequired
        scheme
      }
      createdBy {
        age
        ageRange
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        dateOfBirth
        gender
        isVerified
        name
        tier
        userId
        userName
      }
      promoters {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
        }
      }
      coHosts {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
        }
      }
      sponsors {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
        }
      }
      coordinators {
        age
        ageRange
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        dateOfBirth
        gender
        isVerified
        name
        tier
        userId
        userName
      }
      talents {
        age
        ageRange
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        dateOfBirth
        gender
        isVerified
        name
        tier
        userId
        userName
      }
      attendeeInfo {
        attendeeInfo {
          attendeeRole
          attendeeState
          contestEntryType
          isContestWinner
          isActive
          note
          stateChangedUtc
          questionRequirementAnswers {
            answer
            question
          }
          privacyPolicyState
          attendeeRole
        }
      }
      achievements {
        nodes {
          avatarUrl
          achievementId
          activeFromUtc
          activeToUtc
          category
          bio
          displayName
          slug
          status
          totalUnlockedUsers
        }
      }
      myAchievements {
        avatarUrl
        displayName
      }
      userEventBookings {
        transactionId
        totalPrice
        transactionStatus
        eventTickets {
          ticketType
          eventTicketId
          purchaseAmount
          eventTicket {
            isPrivate
          }
        }
        status
        paymentMethod
        paidDateUtc
        createdAtUtc
      }
      approvedTickets
      approvedAttendees
      pendingAttendees
      totalAttendees
      isExpired
      connectedSocialNetworks
      totalEventTickets
      timeZone
      isAllInPricing
      isInvited
      isSpecialGuest
      optInShowMusicEmbed
      musicEmbedUrl
      pendingRoleInvites
    }
  }
}
    `;

/**
 * __useGetEventBySlugOrIdQuery__
 *
 * To run a query within a React component, call `useGetEventBySlugOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventBySlugOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventBySlugOrIdQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useGetEventBySlugOrIdQuery(baseOptions: Apollo.QueryHookOptions<GetEventBySlugOrIdQuery, GetEventBySlugOrIdQueryVariables> & ({ variables: GetEventBySlugOrIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventBySlugOrIdQuery, GetEventBySlugOrIdQueryVariables>(GetEventBySlugOrIdDocument, options);
      }
export function useGetEventBySlugOrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventBySlugOrIdQuery, GetEventBySlugOrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventBySlugOrIdQuery, GetEventBySlugOrIdQueryVariables>(GetEventBySlugOrIdDocument, options);
        }
export function useGetEventBySlugOrIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventBySlugOrIdQuery, GetEventBySlugOrIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventBySlugOrIdQuery, GetEventBySlugOrIdQueryVariables>(GetEventBySlugOrIdDocument, options);
        }
export type GetEventBySlugOrIdQueryHookResult = ReturnType<typeof useGetEventBySlugOrIdQuery>;
export type GetEventBySlugOrIdLazyQueryHookResult = ReturnType<typeof useGetEventBySlugOrIdLazyQuery>;
export type GetEventBySlugOrIdSuspenseQueryHookResult = ReturnType<typeof useGetEventBySlugOrIdSuspenseQuery>;
export type GetEventBySlugOrIdQueryResult = Apollo.QueryResult<GetEventBySlugOrIdQuery, GetEventBySlugOrIdQueryVariables>;
export const GetEventTicketsDocument = gql`
    query GetEventTickets($slugOrId: String!) {
  event {
    bySlugOrId(slugOrId: $slugOrId) {
      eventTickets2 {
        isFull
        eventTicketId
        isActive
        price
        repPoints
        ticketType
      }
    }
  }
}
    `;

/**
 * __useGetEventTicketsQuery__
 *
 * To run a query within a React component, call `useGetEventTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTicketsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useGetEventTicketsQuery(baseOptions: Apollo.QueryHookOptions<GetEventTicketsQuery, GetEventTicketsQueryVariables> & ({ variables: GetEventTicketsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventTicketsQuery, GetEventTicketsQueryVariables>(GetEventTicketsDocument, options);
      }
export function useGetEventTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventTicketsQuery, GetEventTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventTicketsQuery, GetEventTicketsQueryVariables>(GetEventTicketsDocument, options);
        }
export function useGetEventTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventTicketsQuery, GetEventTicketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventTicketsQuery, GetEventTicketsQueryVariables>(GetEventTicketsDocument, options);
        }
export type GetEventTicketsQueryHookResult = ReturnType<typeof useGetEventTicketsQuery>;
export type GetEventTicketsLazyQueryHookResult = ReturnType<typeof useGetEventTicketsLazyQuery>;
export type GetEventTicketsSuspenseQueryHookResult = ReturnType<typeof useGetEventTicketsSuspenseQuery>;
export type GetEventTicketsQueryResult = Apollo.QueryResult<GetEventTicketsQuery, GetEventTicketsQueryVariables>;
export const SearchEventsDocument = gql`
    query SearchEvents($criteria: SearchEventCriteriaInput, $first: Int, $after: String) {
  event {
    search(criteria: $criteria, first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        avatarUrl
        displayName
        slug
        eventId
        startDate
        status
        ageLimit
        endDate
        expiresAt
        minimumRepScore
        createdBy {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          name
          tier
          userId
          userName
          isVerified
        }
        attendeeInfo {
          attendeeInfo {
            attendeeState
            isActive
            note
            stateChangedUtc
            questionRequirementAnswers {
              answer
              question
            }
            permissions
            attendeeRole
          }
        }
        promoters {
          nodes {
            age
            ageRange
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
            dateOfBirth
            gender
            isVerified
            name
            tier
            userId
            userName
          }
        }
        coHosts {
          nodes {
            age
            ageRange
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
            dateOfBirth
            gender
            isVerified
            name
            tier
            userId
            userName
          }
        }
        sponsors {
          nodes {
            age
            ageRange
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
            dateOfBirth
            gender
            isVerified
            name
            tier
            userId
            userName
          }
        }
        eventTickets {
          nodes {
            balance {
              limitedAmount
            }
            isFull
            eventTicketId
            isActive
            price
            repPoints
            ticketType
            isPrivate
          }
        }
        timeZone
        clubId
      }
    }
  }
}
    `;

/**
 * __useSearchEventsQuery__
 *
 * To run a query within a React component, call `useSearchEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEventsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchEventsQuery(baseOptions?: Apollo.QueryHookOptions<SearchEventsQuery, SearchEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEventsQuery, SearchEventsQueryVariables>(SearchEventsDocument, options);
      }
export function useSearchEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEventsQuery, SearchEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEventsQuery, SearchEventsQueryVariables>(SearchEventsDocument, options);
        }
export function useSearchEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchEventsQuery, SearchEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchEventsQuery, SearchEventsQueryVariables>(SearchEventsDocument, options);
        }
export type SearchEventsQueryHookResult = ReturnType<typeof useSearchEventsQuery>;
export type SearchEventsLazyQueryHookResult = ReturnType<typeof useSearchEventsLazyQuery>;
export type SearchEventsSuspenseQueryHookResult = ReturnType<typeof useSearchEventsSuspenseQuery>;
export type SearchEventsQueryResult = Apollo.QueryResult<SearchEventsQuery, SearchEventsQueryVariables>;
export const GetMyEventsDocument = gql`
    query GetMyEvents($criteria: SearchMyCreatedEventCriteriaInput, $first: Int, $after: String) {
  event {
    myEvents(criteria: $criteria, first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        eventType
        avatarUrl
        displayName
        slug
        eventId
        startDate
        status
        ageLimit
        endDate
        expiresAt
        minimumRepScore
        createdBy {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
        }
        promoters {
          nodes {
            userId
            userName
          }
        }
        coHosts {
          nodes {
            userId
            userName
          }
        }
        sponsors {
          nodes {
            userId
            userName
          }
        }
        attendeeInfo {
          attendeeInfo {
            attendeeRole
          }
        }
        approvedAttendees
        pendingAttendees
        totalAttendees
        approvedTickets
        timeZone
        scannedTickets
        clubId
      }
    }
  }
}
    `;

/**
 * __useGetMyEventsQuery__
 *
 * To run a query within a React component, call `useGetMyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEventsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMyEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyEventsQuery, GetMyEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEventsQuery, GetMyEventsQueryVariables>(GetMyEventsDocument, options);
      }
export function useGetMyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEventsQuery, GetMyEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEventsQuery, GetMyEventsQueryVariables>(GetMyEventsDocument, options);
        }
export function useGetMyEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyEventsQuery, GetMyEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyEventsQuery, GetMyEventsQueryVariables>(GetMyEventsDocument, options);
        }
export type GetMyEventsQueryHookResult = ReturnType<typeof useGetMyEventsQuery>;
export type GetMyEventsLazyQueryHookResult = ReturnType<typeof useGetMyEventsLazyQuery>;
export type GetMyEventsSuspenseQueryHookResult = ReturnType<typeof useGetMyEventsSuspenseQuery>;
export type GetMyEventsQueryResult = Apollo.QueryResult<GetMyEventsQuery, GetMyEventsQueryVariables>;
export const GetMyCreatedEventsDocument = gql`
    query GetMyCreatedEvents($criteria: SearchMyCreatedEventCriteriaInput, $first: Int, $after: String) {
  event {
    myCreatedEvents(criteria: $criteria, first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        avatarUrl
        displayName
        slug
        eventId
        startDate
        status
        ageLimit
        endDate
        expiresAt
        minimumRepScore
        createdBy {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          name
          tier
          userId
          userName
          isVerified
        }
        approvedAttendees
        pendingAttendees
        totalAttendees
        timeZone
        clubId
        currency
        isSeriesParentEvent
      }
    }
  }
}
    `;

/**
 * __useGetMyCreatedEventsQuery__
 *
 * To run a query within a React component, call `useGetMyCreatedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCreatedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCreatedEventsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMyCreatedEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCreatedEventsQuery, GetMyCreatedEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCreatedEventsQuery, GetMyCreatedEventsQueryVariables>(GetMyCreatedEventsDocument, options);
      }
export function useGetMyCreatedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCreatedEventsQuery, GetMyCreatedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCreatedEventsQuery, GetMyCreatedEventsQueryVariables>(GetMyCreatedEventsDocument, options);
        }
export function useGetMyCreatedEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCreatedEventsQuery, GetMyCreatedEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCreatedEventsQuery, GetMyCreatedEventsQueryVariables>(GetMyCreatedEventsDocument, options);
        }
export type GetMyCreatedEventsQueryHookResult = ReturnType<typeof useGetMyCreatedEventsQuery>;
export type GetMyCreatedEventsLazyQueryHookResult = ReturnType<typeof useGetMyCreatedEventsLazyQuery>;
export type GetMyCreatedEventsSuspenseQueryHookResult = ReturnType<typeof useGetMyCreatedEventsSuspenseQuery>;
export type GetMyCreatedEventsQueryResult = Apollo.QueryResult<GetMyCreatedEventsQuery, GetMyCreatedEventsQueryVariables>;
export const FullEventBySlugOrIdDocument = gql`
    query FullEventBySlugOrId($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventType
      ageLimit
      avatarUrl
      createdDate
      currency
      description
      terms
      faqs
      disclosureOrPrivacyPolicyTitle
      disclosureOrPrivacyPolicyFileUrl
      displayName
      endDate
      eventId
      expiresAt
      isDeleted
      isFeatured
      isPrivate
      minimumRepScore
      note
      optInAgeLimit
      optInAllowGuestInviteOthers
      optInDisclosureOrPrivacyPolicy
      optInDisplayRepScore
      optInLocationRadius
      ticketTermsPurchasePolicy
      socialReaches {
        reaches
        socialNetworkScheme
      }
      locationRadius {
        address
        isActive
        latitude
        longitude
        radius
        unitLengthType
      }
      optInQuestionRequirements
      optInShowGuestCount
      optInAllowPublicEventPagePreview
      optInShowGuestList
      optInSocialAccountRequirements
      requireSocialAccountConnection
      slug
      startDate
      status
      updatedDate
      uploadedAssetId
      eventTickets {
        nodes {
          isEnabledWishList
          color
          balance {
            availableAmount
            lockedAmount
            releasedAmount
            limitedAmount
          }
          earning
          isFull
          eventTicketId
          isActive
          price
          repPoints
          ticketType
          additionalGuests
          isRequiredApproval
          isPrivate
          optInShowTicketAmount
          visibleStartAt
          visibleEndAt
          gratuityPercentage
          note
          createdDate
          actionLabel
          optInQrCodePass
        }
      }
      totalEarnings
      inviterEarnings {
        inviterId
        earnings
        earningsByTickets {
          inviterId
          ticketId
          earning
        }
      }
      eventTickets2 {
        eventTicketId
        ticketType
        earning
        isPrivate
      }
      isListFull
      isStarted
      location {
        locationName
        address
        city
        region
        postalCode
        countryCode
        isOnlyVisibleToApprovedAttendees
        latitude
        longitude
      }
      questionRequirements {
        isRequired
        question
        showPublicTickets
        showPrivateTickets
        optInSpecificTicketTypes
        ticketTypeIds
      }
      socialAccountRequirements {
        isRequired
        scheme
      }
      createdBy {
        age
        ageRange
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        dateOfBirth
        gender
        isVerified
        name
        tier
        userId
        userName
        repScore
        emailAddress
      }
      promoters {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
          emailAddress
        }
      }
      coHosts {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
          emailAddress
        }
      }
      sponsors {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
          emailAddress
        }
      }
      doors {
        age
        ageRange
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        dateOfBirth
        gender
        isVerified
        name
        tier
        userId
        userName
        emailAddress
      }
      coordinators {
        age
        ageRange
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        dateOfBirth
        gender
        isVerified
        name
        tier
        userId
        userName
        emailAddress
      }
      talents {
        age
        ageRange
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        dateOfBirth
        gender
        isVerified
        name
        tier
        userId
        userName
        emailAddress
      }
      attendeeInfo {
        attendeeInfo {
          attendeeState
          isActive
          note
          stateChangedUtc
          questionRequirementAnswers {
            answer
            question
          }
          permissions
        }
      }
      achievements {
        nodes {
          avatarUrl
          achievementId
          activeFromUtc
          activeToUtc
          category
          bio
          displayName
          slug
          status
          totalUnlockedUsers
        }
      }
      approvedAttendees
      pendingAttendees
      totalAttendees
      invitations {
        invitationSource
        invitationSourceKey
        event {
          eventId
          avatarUrl
          displayName
        }
      }
      isStarted
      isExpired
      isEnded
      canDelete
      timeZone
      pendingAttendees2
      approvedTickets
      scannedTickets
      totalAvailableTickets
      invitedAttendees
      isAllInPricing
      waitingTickets
      waitingTicketsUsersCount {
        count
        eventTicketId
      }
      usersRoles {
        user {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
          emailAddress
        }
        role
      }
      pendingUsersRoles {
        user {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          gender
          isVerified
          name
          tier
          userId
          userName
          emailAddress
        }
        email
        role
      }
      scanningZones {
        eventTicketIds
        id
        isPrimary
        name
        resetScansDaily
        eventTicketSettings {
          eventTicketId
          maxScans
          isUnlimitedScans
        }
      }
      optInShowMusicEmbed
      musicEmbedUrl
      isListed
      clubId
    }
  }
}
    `;

/**
 * __useFullEventBySlugOrIdQuery__
 *
 * To run a query within a React component, call `useFullEventBySlugOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullEventBySlugOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullEventBySlugOrIdQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useFullEventBySlugOrIdQuery(baseOptions: Apollo.QueryHookOptions<FullEventBySlugOrIdQuery, FullEventBySlugOrIdQueryVariables> & ({ variables: FullEventBySlugOrIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullEventBySlugOrIdQuery, FullEventBySlugOrIdQueryVariables>(FullEventBySlugOrIdDocument, options);
      }
export function useFullEventBySlugOrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullEventBySlugOrIdQuery, FullEventBySlugOrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullEventBySlugOrIdQuery, FullEventBySlugOrIdQueryVariables>(FullEventBySlugOrIdDocument, options);
        }
export function useFullEventBySlugOrIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FullEventBySlugOrIdQuery, FullEventBySlugOrIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FullEventBySlugOrIdQuery, FullEventBySlugOrIdQueryVariables>(FullEventBySlugOrIdDocument, options);
        }
export type FullEventBySlugOrIdQueryHookResult = ReturnType<typeof useFullEventBySlugOrIdQuery>;
export type FullEventBySlugOrIdLazyQueryHookResult = ReturnType<typeof useFullEventBySlugOrIdLazyQuery>;
export type FullEventBySlugOrIdSuspenseQueryHookResult = ReturnType<typeof useFullEventBySlugOrIdSuspenseQuery>;
export type FullEventBySlugOrIdQueryResult = Apollo.QueryResult<FullEventBySlugOrIdQuery, FullEventBySlugOrIdQueryVariables>;
export const GetSocialReachesDocument = gql`
    query GetSocialReaches($slugOrId: String!, $inviterId: UUID) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      socialReaches(inviterId: $inviterId) {
        socialNetworkScheme
        reaches
      }
    }
  }
}
    `;

/**
 * __useGetSocialReachesQuery__
 *
 * To run a query within a React component, call `useGetSocialReachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialReachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialReachesQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      inviterId: // value for 'inviterId'
 *   },
 * });
 */
export function useGetSocialReachesQuery(baseOptions: Apollo.QueryHookOptions<GetSocialReachesQuery, GetSocialReachesQueryVariables> & ({ variables: GetSocialReachesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialReachesQuery, GetSocialReachesQueryVariables>(GetSocialReachesDocument, options);
      }
export function useGetSocialReachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialReachesQuery, GetSocialReachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialReachesQuery, GetSocialReachesQueryVariables>(GetSocialReachesDocument, options);
        }
export function useGetSocialReachesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSocialReachesQuery, GetSocialReachesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSocialReachesQuery, GetSocialReachesQueryVariables>(GetSocialReachesDocument, options);
        }
export type GetSocialReachesQueryHookResult = ReturnType<typeof useGetSocialReachesQuery>;
export type GetSocialReachesLazyQueryHookResult = ReturnType<typeof useGetSocialReachesLazyQuery>;
export type GetSocialReachesSuspenseQueryHookResult = ReturnType<typeof useGetSocialReachesSuspenseQuery>;
export type GetSocialReachesQueryResult = Apollo.QueryResult<GetSocialReachesQuery, GetSocialReachesQueryVariables>;
export const GetEventAttendeesDocument = gql`
    query GetEventAttendees($slugOrId: String!) {
  event {
    bySlugOrId(slugOrId: $slugOrId) {
      approvedAttendeeTickets {
        userInfo {
          avatarUrl
          isVerified
          name
          tier
          userId
          userName
        }
        purchasedTicketInfo {
          purchasedQuantity
          ticketType
        }
        eventTicketInfo {
          additionalGuests
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventAttendeesQuery__
 *
 * To run a query within a React component, call `useGetEventAttendeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAttendeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAttendeesQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useGetEventAttendeesQuery(baseOptions: Apollo.QueryHookOptions<GetEventAttendeesQuery, GetEventAttendeesQueryVariables> & ({ variables: GetEventAttendeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventAttendeesQuery, GetEventAttendeesQueryVariables>(GetEventAttendeesDocument, options);
      }
export function useGetEventAttendeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventAttendeesQuery, GetEventAttendeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventAttendeesQuery, GetEventAttendeesQueryVariables>(GetEventAttendeesDocument, options);
        }
export function useGetEventAttendeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventAttendeesQuery, GetEventAttendeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventAttendeesQuery, GetEventAttendeesQueryVariables>(GetEventAttendeesDocument, options);
        }
export type GetEventAttendeesQueryHookResult = ReturnType<typeof useGetEventAttendeesQuery>;
export type GetEventAttendeesLazyQueryHookResult = ReturnType<typeof useGetEventAttendeesLazyQuery>;
export type GetEventAttendeesSuspenseQueryHookResult = ReturnType<typeof useGetEventAttendeesSuspenseQuery>;
export type GetEventAttendeesQueryResult = Apollo.QueryResult<GetEventAttendeesQuery, GetEventAttendeesQueryVariables>;
export const GetEventBookingsDocument = gql`
    query GetEventBookings($slugOrId: String!, $first: Int, $after: String, $filter: EventBookingFilterArgsInput) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      displayName
      avatarUrl
      isListFull
      isCoHost
      isPromoter
      createdBy {
        age
        ageRange
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        dateOfBirth
        gender
        isVerified
        name
        tier
        userId
        userName
      }
      promoters {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
        }
      }
      coHosts {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
        }
      }
      sponsors {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
        }
      }
      eventTickets {
        nodes {
          balance {
            limitedAmount
          }
          isFull
          eventTicketId
          isActive
          price
          repPoints
          ticketType
          isPrivate
        }
      }
      eventBookings2(first: $first, after: $after, filter: $filter) {
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
        nodes {
          transactionId
          totalPrice
          transactionStatus
          type
          user {
            userName
            userId
            tier
            name
            isVerified
            gender
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
            age
            ageRange
            dateOfBirth
            socialMediaConnections {
              scheme
              userId
              displayName
              avatarUrl
              profileLink
              username
            }
          }
          eventTickets {
            ticketType
            eventTicketId
            purchaseAmount
            price
          }
          tickets {
            firstSeen
            status
            ticketId
            eventTicket {
              ticketType
            }
            transactionId
          }
          status
          paymentMethod
          paidDateUtc
          createdAtUtc
          attendeeInfo {
            attendeeInfo {
              questionRequirementAnswers {
                question
                answer
              }
              permissions
              attendeeRole
              attendeeState
            }
            userInfo {
              address {
                address
                city
                countryCode
                postalCode
                region
              }
              age
              ageRange
              avatarUrl
              dateOfBirth
              gender
              isVerified
              name
              tier
              userId
              userName
            }
          }
        }
      }
      pendingAttendees2
      approvedTickets
      scannedTickets
      totalAvailableTickets
      invitedAttendees
    }
  }
}
    `;

/**
 * __useGetEventBookingsQuery__
 *
 * To run a query within a React component, call `useGetEventBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventBookingsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEventBookingsQuery(baseOptions: Apollo.QueryHookOptions<GetEventBookingsQuery, GetEventBookingsQueryVariables> & ({ variables: GetEventBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventBookingsQuery, GetEventBookingsQueryVariables>(GetEventBookingsDocument, options);
      }
export function useGetEventBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventBookingsQuery, GetEventBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventBookingsQuery, GetEventBookingsQueryVariables>(GetEventBookingsDocument, options);
        }
export function useGetEventBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventBookingsQuery, GetEventBookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventBookingsQuery, GetEventBookingsQueryVariables>(GetEventBookingsDocument, options);
        }
export type GetEventBookingsQueryHookResult = ReturnType<typeof useGetEventBookingsQuery>;
export type GetEventBookingsLazyQueryHookResult = ReturnType<typeof useGetEventBookingsLazyQuery>;
export type GetEventBookingsSuspenseQueryHookResult = ReturnType<typeof useGetEventBookingsSuspenseQuery>;
export type GetEventBookingsQueryResult = Apollo.QueryResult<GetEventBookingsQuery, GetEventBookingsQueryVariables>;
export const GetAllSavedListNameDocument = gql`
    query GetAllSavedListName {
  event {
    listSaveGuestListNames
  }
}
    `;

/**
 * __useGetAllSavedListNameQuery__
 *
 * To run a query within a React component, call `useGetAllSavedListNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSavedListNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSavedListNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSavedListNameQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSavedListNameQuery, GetAllSavedListNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSavedListNameQuery, GetAllSavedListNameQueryVariables>(GetAllSavedListNameDocument, options);
      }
export function useGetAllSavedListNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSavedListNameQuery, GetAllSavedListNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSavedListNameQuery, GetAllSavedListNameQueryVariables>(GetAllSavedListNameDocument, options);
        }
export function useGetAllSavedListNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllSavedListNameQuery, GetAllSavedListNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllSavedListNameQuery, GetAllSavedListNameQueryVariables>(GetAllSavedListNameDocument, options);
        }
export type GetAllSavedListNameQueryHookResult = ReturnType<typeof useGetAllSavedListNameQuery>;
export type GetAllSavedListNameLazyQueryHookResult = ReturnType<typeof useGetAllSavedListNameLazyQuery>;
export type GetAllSavedListNameSuspenseQueryHookResult = ReturnType<typeof useGetAllSavedListNameSuspenseQuery>;
export type GetAllSavedListNameQueryResult = Apollo.QueryResult<GetAllSavedListNameQuery, GetAllSavedListNameQueryVariables>;
export const GetSavedListDetailsDocument = gql`
    query GetSavedListDetails($listName: String!) {
  event {
    getSavedGuestList(listName: $listName) {
      name
      lastUpdatedUtc
      guestInvitations {
        fullName
        phoneNumber
        email
        plus1
      }
    }
  }
}
    `;

/**
 * __useGetSavedListDetailsQuery__
 *
 * To run a query within a React component, call `useGetSavedListDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedListDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedListDetailsQuery({
 *   variables: {
 *      listName: // value for 'listName'
 *   },
 * });
 */
export function useGetSavedListDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSavedListDetailsQuery, GetSavedListDetailsQueryVariables> & ({ variables: GetSavedListDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedListDetailsQuery, GetSavedListDetailsQueryVariables>(GetSavedListDetailsDocument, options);
      }
export function useGetSavedListDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedListDetailsQuery, GetSavedListDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedListDetailsQuery, GetSavedListDetailsQueryVariables>(GetSavedListDetailsDocument, options);
        }
export function useGetSavedListDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedListDetailsQuery, GetSavedListDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavedListDetailsQuery, GetSavedListDetailsQueryVariables>(GetSavedListDetailsDocument, options);
        }
export type GetSavedListDetailsQueryHookResult = ReturnType<typeof useGetSavedListDetailsQuery>;
export type GetSavedListDetailsLazyQueryHookResult = ReturnType<typeof useGetSavedListDetailsLazyQuery>;
export type GetSavedListDetailsSuspenseQueryHookResult = ReturnType<typeof useGetSavedListDetailsSuspenseQuery>;
export type GetSavedListDetailsQueryResult = Apollo.QueryResult<GetSavedListDetailsQuery, GetSavedListDetailsQueryVariables>;
export const CountUniqueInviteesDocument = gql`
    query CountUniqueInvitees($includeSources: [EventInvitationSourceArgsInput!]) {
  event {
    countUniqueInvitees(includeSources: $includeSources)
  }
}
    `;

/**
 * __useCountUniqueInviteesQuery__
 *
 * To run a query within a React component, call `useCountUniqueInviteesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountUniqueInviteesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountUniqueInviteesQuery({
 *   variables: {
 *      includeSources: // value for 'includeSources'
 *   },
 * });
 */
export function useCountUniqueInviteesQuery(baseOptions?: Apollo.QueryHookOptions<CountUniqueInviteesQuery, CountUniqueInviteesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountUniqueInviteesQuery, CountUniqueInviteesQueryVariables>(CountUniqueInviteesDocument, options);
      }
export function useCountUniqueInviteesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountUniqueInviteesQuery, CountUniqueInviteesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountUniqueInviteesQuery, CountUniqueInviteesQueryVariables>(CountUniqueInviteesDocument, options);
        }
export function useCountUniqueInviteesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountUniqueInviteesQuery, CountUniqueInviteesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountUniqueInviteesQuery, CountUniqueInviteesQueryVariables>(CountUniqueInviteesDocument, options);
        }
export type CountUniqueInviteesQueryHookResult = ReturnType<typeof useCountUniqueInviteesQuery>;
export type CountUniqueInviteesLazyQueryHookResult = ReturnType<typeof useCountUniqueInviteesLazyQuery>;
export type CountUniqueInviteesSuspenseQueryHookResult = ReturnType<typeof useCountUniqueInviteesSuspenseQuery>;
export type CountUniqueInviteesQueryResult = Apollo.QueryResult<CountUniqueInviteesQuery, CountUniqueInviteesQueryVariables>;
export const GetTicketsAmountRequiredForApprovalDocument = gql`
    query GetTicketsAmountRequiredForApproval($eventId: UUID!) {
  event {
    getTicketsAmountRequiredForApproval(eventId: $eventId) {
      requiredAmount
      eventTicket {
        eventTicketId
        ticketType
      }
    }
  }
}
    `;

/**
 * __useGetTicketsAmountRequiredForApprovalQuery__
 *
 * To run a query within a React component, call `useGetTicketsAmountRequiredForApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketsAmountRequiredForApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketsAmountRequiredForApprovalQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetTicketsAmountRequiredForApprovalQuery(baseOptions: Apollo.QueryHookOptions<GetTicketsAmountRequiredForApprovalQuery, GetTicketsAmountRequiredForApprovalQueryVariables> & ({ variables: GetTicketsAmountRequiredForApprovalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTicketsAmountRequiredForApprovalQuery, GetTicketsAmountRequiredForApprovalQueryVariables>(GetTicketsAmountRequiredForApprovalDocument, options);
      }
export function useGetTicketsAmountRequiredForApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketsAmountRequiredForApprovalQuery, GetTicketsAmountRequiredForApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTicketsAmountRequiredForApprovalQuery, GetTicketsAmountRequiredForApprovalQueryVariables>(GetTicketsAmountRequiredForApprovalDocument, options);
        }
export function useGetTicketsAmountRequiredForApprovalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTicketsAmountRequiredForApprovalQuery, GetTicketsAmountRequiredForApprovalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTicketsAmountRequiredForApprovalQuery, GetTicketsAmountRequiredForApprovalQueryVariables>(GetTicketsAmountRequiredForApprovalDocument, options);
        }
export type GetTicketsAmountRequiredForApprovalQueryHookResult = ReturnType<typeof useGetTicketsAmountRequiredForApprovalQuery>;
export type GetTicketsAmountRequiredForApprovalLazyQueryHookResult = ReturnType<typeof useGetTicketsAmountRequiredForApprovalLazyQuery>;
export type GetTicketsAmountRequiredForApprovalSuspenseQueryHookResult = ReturnType<typeof useGetTicketsAmountRequiredForApprovalSuspenseQuery>;
export type GetTicketsAmountRequiredForApprovalQueryResult = Apollo.QueryResult<GetTicketsAmountRequiredForApprovalQuery, GetTicketsAmountRequiredForApprovalQueryVariables>;
export const GetEventTicketBalancesDocument = gql`
    query GetEventTicketBalances($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      eventTickets {
        nodes {
          eventTicketId
          ticketType
          price
          balance {
            availableAmount
            limitedAmount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventTicketBalancesQuery__
 *
 * To run a query within a React component, call `useGetEventTicketBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTicketBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTicketBalancesQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useGetEventTicketBalancesQuery(baseOptions: Apollo.QueryHookOptions<GetEventTicketBalancesQuery, GetEventTicketBalancesQueryVariables> & ({ variables: GetEventTicketBalancesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventTicketBalancesQuery, GetEventTicketBalancesQueryVariables>(GetEventTicketBalancesDocument, options);
      }
export function useGetEventTicketBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventTicketBalancesQuery, GetEventTicketBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventTicketBalancesQuery, GetEventTicketBalancesQueryVariables>(GetEventTicketBalancesDocument, options);
        }
export function useGetEventTicketBalancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventTicketBalancesQuery, GetEventTicketBalancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventTicketBalancesQuery, GetEventTicketBalancesQueryVariables>(GetEventTicketBalancesDocument, options);
        }
export type GetEventTicketBalancesQueryHookResult = ReturnType<typeof useGetEventTicketBalancesQuery>;
export type GetEventTicketBalancesLazyQueryHookResult = ReturnType<typeof useGetEventTicketBalancesLazyQuery>;
export type GetEventTicketBalancesSuspenseQueryHookResult = ReturnType<typeof useGetEventTicketBalancesSuspenseQuery>;
export type GetEventTicketBalancesQueryResult = Apollo.QueryResult<GetEventTicketBalancesQuery, GetEventTicketBalancesQueryVariables>;
export const GetEventCommentsDocument = gql`
    query GetEventComments($slugOrId: String!) {
  event {
    bySlugOrId(slugOrId: $slugOrId) {
      comments {
        nodes {
          comment
          commentId
          createdAt
          eventId
          medias
          parentCommentId
          reactions {
            reaction
            reactionId
            user {
              avatarUrl
              avatarSource
              instagramAvatarUrl
              tikTokAvatarUrl
              twitchAvatarUrl
              displayNameSource
              instagramDisplayName
              tikTokDisplayName
              twitchDisplayName
              instagramFollowsCount
              tikTokFollowsCount
              twitchFollowsCount
              isVerified
              name
              tier
              userId
              userName
            }
          }
          replies {
            nodes {
              comment
              commentId
              createdAt
              eventId
              medias
              parentCommentId
              reactions {
                reaction
                reactionId
                user {
                  avatarUrl
                  avatarSource
                  instagramAvatarUrl
                  tikTokAvatarUrl
                  twitchAvatarUrl
                  displayNameSource
                  instagramDisplayName
                  tikTokDisplayName
                  twitchDisplayName
                  instagramFollowsCount
                  tikTokFollowsCount
                  twitchFollowsCount
                  isVerified
                  name
                  userName
                  userId
                  tier
                }
              }
              user {
                avatarUrl
                avatarSource
                instagramAvatarUrl
                tikTokAvatarUrl
                twitchAvatarUrl
                displayNameSource
                instagramDisplayName
                tikTokDisplayName
                twitchDisplayName
                instagramFollowsCount
                tikTokFollowsCount
                twitchFollowsCount
                isVerified
                name
                userName
                userId
                tier
              }
              replies {
                totalCount
                pageInfo {
                  endCursor
                  hasNextPage
                }
                nodes {
                  comment
                  commentId
                  createdAt
                  eventId
                  medias
                  parentCommentId
                  user {
                    avatarUrl
                    avatarSource
                    instagramAvatarUrl
                    tikTokAvatarUrl
                    twitchAvatarUrl
                    displayNameSource
                    instagramDisplayName
                    tikTokDisplayName
                    twitchDisplayName
                    instagramFollowsCount
                    tikTokFollowsCount
                    twitchFollowsCount
                    isVerified
                    name
                    userName
                    userId
                    tier
                  }
                  reactions {
                    reaction
                    reactionId
                    user {
                      avatarUrl
                      avatarSource
                      instagramAvatarUrl
                      tikTokAvatarUrl
                      twitchAvatarUrl
                      displayNameSource
                      instagramDisplayName
                      tikTokDisplayName
                      twitchDisplayName
                      instagramFollowsCount
                      tikTokFollowsCount
                      twitchFollowsCount
                      isVerified
                      name
                      tier
                      userId
                      userName
                    }
                  }
                }
              }
            }
            totalCount
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          user {
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
            isVerified
            name
            userName
            userId
            tier
          }
        }
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventCommentsQuery__
 *
 * To run a query within a React component, call `useGetEventCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventCommentsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useGetEventCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetEventCommentsQuery, GetEventCommentsQueryVariables> & ({ variables: GetEventCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventCommentsQuery, GetEventCommentsQueryVariables>(GetEventCommentsDocument, options);
      }
export function useGetEventCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventCommentsQuery, GetEventCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventCommentsQuery, GetEventCommentsQueryVariables>(GetEventCommentsDocument, options);
        }
export function useGetEventCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventCommentsQuery, GetEventCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventCommentsQuery, GetEventCommentsQueryVariables>(GetEventCommentsDocument, options);
        }
export type GetEventCommentsQueryHookResult = ReturnType<typeof useGetEventCommentsQuery>;
export type GetEventCommentsLazyQueryHookResult = ReturnType<typeof useGetEventCommentsLazyQuery>;
export type GetEventCommentsSuspenseQueryHookResult = ReturnType<typeof useGetEventCommentsSuspenseQuery>;
export type GetEventCommentsQueryResult = Apollo.QueryResult<GetEventCommentsQuery, GetEventCommentsQueryVariables>;
export const GetBillInfoDocument = gql`
    query GetBillInfo($subTotal: Decimal!) {
  event {
    getBillInfo(subTotal: $subTotal) {
      serviceFee
      processingFee
      subTotal
      total
    }
  }
}
    `;

/**
 * __useGetBillInfoQuery__
 *
 * To run a query within a React component, call `useGetBillInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillInfoQuery({
 *   variables: {
 *      subTotal: // value for 'subTotal'
 *   },
 * });
 */
export function useGetBillInfoQuery(baseOptions: Apollo.QueryHookOptions<GetBillInfoQuery, GetBillInfoQueryVariables> & ({ variables: GetBillInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillInfoQuery, GetBillInfoQueryVariables>(GetBillInfoDocument, options);
      }
export function useGetBillInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillInfoQuery, GetBillInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillInfoQuery, GetBillInfoQueryVariables>(GetBillInfoDocument, options);
        }
export function useGetBillInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBillInfoQuery, GetBillInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBillInfoQuery, GetBillInfoQueryVariables>(GetBillInfoDocument, options);
        }
export type GetBillInfoQueryHookResult = ReturnType<typeof useGetBillInfoQuery>;
export type GetBillInfoLazyQueryHookResult = ReturnType<typeof useGetBillInfoLazyQuery>;
export type GetBillInfoSuspenseQueryHookResult = ReturnType<typeof useGetBillInfoSuspenseQuery>;
export type GetBillInfoQueryResult = Apollo.QueryResult<GetBillInfoQuery, GetBillInfoQueryVariables>;
export const GetEventTicketFeesDocument = gql`
    query GetEventTicketFees($items: [PaymentItemInput!]!) {
  event {
    calculateFees(items: $items) {
      partnerFeeAmount
      processingFeeAmount
      serviceFeeAmount
      subTotalAmount
      taxes {
        taxCode
        amount
      }
      totalAmount
      totalTaxFeeAmount
    }
  }
}
    `;

/**
 * __useGetEventTicketFeesQuery__
 *
 * To run a query within a React component, call `useGetEventTicketFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTicketFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTicketFeesQuery({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useGetEventTicketFeesQuery(baseOptions: Apollo.QueryHookOptions<GetEventTicketFeesQuery, GetEventTicketFeesQueryVariables> & ({ variables: GetEventTicketFeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventTicketFeesQuery, GetEventTicketFeesQueryVariables>(GetEventTicketFeesDocument, options);
      }
export function useGetEventTicketFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventTicketFeesQuery, GetEventTicketFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventTicketFeesQuery, GetEventTicketFeesQueryVariables>(GetEventTicketFeesDocument, options);
        }
export function useGetEventTicketFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventTicketFeesQuery, GetEventTicketFeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventTicketFeesQuery, GetEventTicketFeesQueryVariables>(GetEventTicketFeesDocument, options);
        }
export type GetEventTicketFeesQueryHookResult = ReturnType<typeof useGetEventTicketFeesQuery>;
export type GetEventTicketFeesLazyQueryHookResult = ReturnType<typeof useGetEventTicketFeesLazyQuery>;
export type GetEventTicketFeesSuspenseQueryHookResult = ReturnType<typeof useGetEventTicketFeesSuspenseQuery>;
export type GetEventTicketFeesQueryResult = Apollo.QueryResult<GetEventTicketFeesQuery, GetEventTicketFeesQueryVariables>;
export const GetApprovedAttendeesListDocument = gql`
    query GetApprovedAttendeesList($slugOrId: String!, $first: Int, $after: String) {
  event {
    bySlugOrId(slugOrId: $slugOrId) {
      attendeesPage(first: $first, after: $after) {
        nodes {
          userInfo {
            age
            ageRange
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
            dateOfBirth
            gender
            isVerified
            name
            tier
            userId
            userName
          }
        }
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;

/**
 * __useGetApprovedAttendeesListQuery__
 *
 * To run a query within a React component, call `useGetApprovedAttendeesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovedAttendeesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovedAttendeesListQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetApprovedAttendeesListQuery(baseOptions: Apollo.QueryHookOptions<GetApprovedAttendeesListQuery, GetApprovedAttendeesListQueryVariables> & ({ variables: GetApprovedAttendeesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovedAttendeesListQuery, GetApprovedAttendeesListQueryVariables>(GetApprovedAttendeesListDocument, options);
      }
export function useGetApprovedAttendeesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovedAttendeesListQuery, GetApprovedAttendeesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovedAttendeesListQuery, GetApprovedAttendeesListQueryVariables>(GetApprovedAttendeesListDocument, options);
        }
export function useGetApprovedAttendeesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApprovedAttendeesListQuery, GetApprovedAttendeesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApprovedAttendeesListQuery, GetApprovedAttendeesListQueryVariables>(GetApprovedAttendeesListDocument, options);
        }
export type GetApprovedAttendeesListQueryHookResult = ReturnType<typeof useGetApprovedAttendeesListQuery>;
export type GetApprovedAttendeesListLazyQueryHookResult = ReturnType<typeof useGetApprovedAttendeesListLazyQuery>;
export type GetApprovedAttendeesListSuspenseQueryHookResult = ReturnType<typeof useGetApprovedAttendeesListSuspenseQuery>;
export type GetApprovedAttendeesListQueryResult = Apollo.QueryResult<GetApprovedAttendeesListQuery, GetApprovedAttendeesListQueryVariables>;
export const GetAttendeeBookingsDocument = gql`
    query GetAttendeeBookings($slugOrId: String!, $after: String, $first: Int, $filter: DetailsAttendeeFilterArgsInput) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      displayName
      startDate
      endDate
      location {
        locationName
        address
        city
        region
        postalCode
        countryCode
      }
      avatarUrl
      isListFull
      pendingAttendees2
      approvedTickets
      scannedTickets
      totalAvailableTickets
      invitedAttendees
      isExpired
      isEnded
      waitingTickets
      scanningZones {
        id
        isPrimary
        name
        resetScansDaily
        eventTicketSettings {
          eventTicketId
          maxScans
          isUnlimitedScans
        }
      }
      waitingTicketsUsersCount {
        count
        eventTicketId
      }
      usersRoles {
        role
        user {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
          repScore
        }
      }
      createdBy {
        age
        ageRange
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        dateOfBirth
        gender
        isVerified
        name
        tier
        userId
        userName
      }
      attendeeInfo {
        attendeeInfo {
          attendeeState
          isActive
          note
          stateChangedUtc
          questionRequirementAnswers {
            answer
            question
          }
          permissions
        }
      }
      promoters {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
        }
      }
      coHosts {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
        }
      }
      sponsors {
        nodes {
          age
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          dateOfBirth
          gender
          isVerified
          name
          tier
          userId
          userName
        }
      }
      eventTickets {
        nodes {
          balance {
            releasedAmount
            lockedAmount
            limitedAmount
            availableAmount
          }
          isFull
          eventTicketId
          isActive
          price
          repPoints
          ticketType
          isPrivate
          isEnabledWishList
          isRequiredApproval
          eventId
          creatorId
          optInShowTicketAmount
          visibleStartAt
          visibleEndAt
          optInQrCodePass
        }
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      detailsAttendees(after: $after, first: $first, filter: $filter) {
        totalCount
        ticketCount
        invitedCount
        checkedInCount
        pendingAttendeesCount
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        nodes {
          approvalUser {
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
            gender
            isVerified
            tier
            userId
            userName
            name
            repScore
          }
          inviter {
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
            isVerified
            userName
            name
            userId
            tier
            repScore
          }
          attendeeRoles
          attendeeInfo {
            attendeeRole
            attendeeState
            isActive
            privacyPolicyState
            questionRequirementAnswers {
              question
              answer
            }
            permissions
            approvalAt
            privacyPolicyStateUpdatedAt
          }
          waiverStatus
          checkedInCount
          status
          tickets {
            ticketId
            ticketInfo {
              ticketName
              firstSeen
              originalTicketId
              transactionId
              ticketType
              count
              associatedUserId
              status
              parentTicketId
              displayEventTicket {
                eventTicketId
                ticketType
              }
              displayEventTicketId
            }
            bookingInfo {
              captureOrderId
              createdAtUtc
              eventId
              giftSenderId
              paidDateUtc
              paymentMethod
              quantity
              status
              totalPrice
              transactionId
              transactionStatus
              type
              updateAtUtc
              userId
              items {
                entityId
                eventId
                isFree
                name
                price
                productType
                quantity
                taxCode
                ticketType
              }
            }
          }
          user {
            ageRange
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
            gender
            address {
              address
              city
              countryCode
              postalCode
              region
            }
            isVerified
            tier
            userId
            userName
            socialMediaConnections {
              avatarUrl
              displayName
              profileLink
              scheme
              userId
              username
            }
            age
            dateOfBirth
            name
            repScore
          }
          bookings {
            transactionId
            totalPrice
            transactionStatus
            eventTickets {
              ticketType
              eventTicketId
              purchaseAmount
              price
              eventId
              eventTicket {
                additionalGuests
              }
            }
            status
            paymentMethod
            paidDateUtc
            createdAtUtc
            eventId
            quantity
            type
            updateAtUtc
            userId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAttendeeBookingsQuery__
 *
 * To run a query within a React component, call `useGetAttendeeBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeBookingsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAttendeeBookingsQuery(baseOptions: Apollo.QueryHookOptions<GetAttendeeBookingsQuery, GetAttendeeBookingsQueryVariables> & ({ variables: GetAttendeeBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttendeeBookingsQuery, GetAttendeeBookingsQueryVariables>(GetAttendeeBookingsDocument, options);
      }
export function useGetAttendeeBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendeeBookingsQuery, GetAttendeeBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttendeeBookingsQuery, GetAttendeeBookingsQueryVariables>(GetAttendeeBookingsDocument, options);
        }
export function useGetAttendeeBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAttendeeBookingsQuery, GetAttendeeBookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAttendeeBookingsQuery, GetAttendeeBookingsQueryVariables>(GetAttendeeBookingsDocument, options);
        }
export type GetAttendeeBookingsQueryHookResult = ReturnType<typeof useGetAttendeeBookingsQuery>;
export type GetAttendeeBookingsLazyQueryHookResult = ReturnType<typeof useGetAttendeeBookingsLazyQuery>;
export type GetAttendeeBookingsSuspenseQueryHookResult = ReturnType<typeof useGetAttendeeBookingsSuspenseQuery>;
export type GetAttendeeBookingsQueryResult = Apollo.QueryResult<GetAttendeeBookingsQuery, GetAttendeeBookingsQueryVariables>;
export const GetDetailsAttendeeDocument = gql`
    query GetDetailsAttendee($attendeeId: UUID!, $slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      detailsAttendee(attendeeId: $attendeeId) {
        approvalUser {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          gender
          isVerified
          tier
          userId
          userName
          name
          repScore
        }
        attendeeRoles
        attendeeInfo {
          attendeeRole
          attendeeState
          isActive
          privacyPolicyState
          questionRequirementAnswers {
            question
            answer
          }
          permissions
          approvalAt
          privacyPolicyStateUpdatedAt
        }
        waiverStatus
        checkedInCount
        status
        tickets {
          ticketId
          ticketInfo {
            firstSeen
            originalTicketId
            transactionId
            ticketType
            count
            associatedUserId
            status
            parentTicketId
            displayEventTicket {
              eventTicketId
              ticketType
            }
            displayEventTicketId
          }
          bookingInfo {
            captureOrderId
            createdAtUtc
            eventId
            giftSenderId
            paidDateUtc
            paymentMethod
            quantity
            status
            totalPrice
            transactionId
            transactionStatus
            type
            updateAtUtc
            userId
            items {
              entityId
              eventId
              isFree
              name
              price
              productType
              quantity
              taxCode
              ticketType
            }
          }
        }
        user {
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          gender
          address {
            address
            city
            countryCode
            postalCode
            region
          }
          isVerified
          tier
          userId
          userName
          socialMediaConnections {
            avatarUrl
            displayName
            profileLink
            scheme
            userId
            username
          }
          age
          dateOfBirth
          name
          repScore
        }
        eligibility {
          hasProfilePicture
          hasConnectedInstagram
          instagramHandle
          instagramConnectedAt
          hasDownloadedApp
        }
        shareStats {
          clicks
          logins
          ticketAcquisitions
        }
        bookings {
          transactionId
          totalPrice
          transactionStatus
          eventTickets {
            ticketType
            eventTicketId
            purchaseAmount
            price
            eventId
          }
          status
          paymentMethod
          paidDateUtc
          createdAtUtc
          eventId
          quantity
          type
          updateAtUtc
          userId
        }
      }
    }
  }
}
    `;

/**
 * __useGetDetailsAttendeeQuery__
 *
 * To run a query within a React component, call `useGetDetailsAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailsAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailsAttendeeQuery({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useGetDetailsAttendeeQuery(baseOptions: Apollo.QueryHookOptions<GetDetailsAttendeeQuery, GetDetailsAttendeeQueryVariables> & ({ variables: GetDetailsAttendeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailsAttendeeQuery, GetDetailsAttendeeQueryVariables>(GetDetailsAttendeeDocument, options);
      }
export function useGetDetailsAttendeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailsAttendeeQuery, GetDetailsAttendeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailsAttendeeQuery, GetDetailsAttendeeQueryVariables>(GetDetailsAttendeeDocument, options);
        }
export function useGetDetailsAttendeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailsAttendeeQuery, GetDetailsAttendeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailsAttendeeQuery, GetDetailsAttendeeQueryVariables>(GetDetailsAttendeeDocument, options);
        }
export type GetDetailsAttendeeQueryHookResult = ReturnType<typeof useGetDetailsAttendeeQuery>;
export type GetDetailsAttendeeLazyQueryHookResult = ReturnType<typeof useGetDetailsAttendeeLazyQuery>;
export type GetDetailsAttendeeSuspenseQueryHookResult = ReturnType<typeof useGetDetailsAttendeeSuspenseQuery>;
export type GetDetailsAttendeeQueryResult = Apollo.QueryResult<GetDetailsAttendeeQuery, GetDetailsAttendeeQueryVariables>;
export const ExportAttendeesDocument = gql`
    query ExportAttendees($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      attendeesExport {
        eventTickets {
          id
          name
          additionalGuests
        }
        guestList {
          emailAddress
          quantity
          phoneNumber
          fullName
          guestId
          eventTicket {
            ticketType
            eventTicketId
          }
          checkedInQuantity
        }
        attendees {
          userId
          name
          gender
          emailAddress
          ageRange
          answers
          tickets
          additionalGuests
          ticketPrices
          totalSpent
          questions
          repScore
          status
          acceptedPolicyTime
          transactionTime
          approvedTime
          checkedInCount
          totalAmountWithoutFees
          paypalOrderId
          paypalPaymentId
          paypalTransactionFee
          paypalTotalPrice
          approvedBy
          purchasedItems {
            ticketType
            eventId
            quantity
            price
          }
          displayEventTickets {
            ticketType
            eventTicketId
            checkedInCount
            count
            price
            totalPrice
            additionalGuests
            gratuityPercentage
            createdDate
            tickets {
              ticketId
              ticketInfo {
                count
                ticketType
              }
              bookingInfo {
                type
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useExportAttendeesQuery__
 *
 * To run a query within a React component, call `useExportAttendeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportAttendeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportAttendeesQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useExportAttendeesQuery(baseOptions: Apollo.QueryHookOptions<ExportAttendeesQuery, ExportAttendeesQueryVariables> & ({ variables: ExportAttendeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportAttendeesQuery, ExportAttendeesQueryVariables>(ExportAttendeesDocument, options);
      }
export function useExportAttendeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportAttendeesQuery, ExportAttendeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportAttendeesQuery, ExportAttendeesQueryVariables>(ExportAttendeesDocument, options);
        }
export function useExportAttendeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportAttendeesQuery, ExportAttendeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportAttendeesQuery, ExportAttendeesQueryVariables>(ExportAttendeesDocument, options);
        }
export type ExportAttendeesQueryHookResult = ReturnType<typeof useExportAttendeesQuery>;
export type ExportAttendeesLazyQueryHookResult = ReturnType<typeof useExportAttendeesLazyQuery>;
export type ExportAttendeesSuspenseQueryHookResult = ReturnType<typeof useExportAttendeesSuspenseQuery>;
export type ExportAttendeesQueryResult = Apollo.QueryResult<ExportAttendeesQuery, ExportAttendeesQueryVariables>;
export const GetEventAttendeeStatisticsDocument = gql`
    query GetEventAttendeeStatistics($slugOrId: String!, $filter: DetailsAttendeeFilterArgsInput) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      displayName
      avatarUrl
      isListFull
      pendingAttendees2
      approvedTickets
      scannedTickets
      totalAvailableTickets
      invitedAttendees
      detailsAttendees(filter: $filter) {
        totalCount
        ticketCount
        invitedCount
        checkedInCount
        pendingAttendeesCount
      }
    }
  }
}
    `;

/**
 * __useGetEventAttendeeStatisticsQuery__
 *
 * To run a query within a React component, call `useGetEventAttendeeStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAttendeeStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAttendeeStatisticsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEventAttendeeStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetEventAttendeeStatisticsQuery, GetEventAttendeeStatisticsQueryVariables> & ({ variables: GetEventAttendeeStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventAttendeeStatisticsQuery, GetEventAttendeeStatisticsQueryVariables>(GetEventAttendeeStatisticsDocument, options);
      }
export function useGetEventAttendeeStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventAttendeeStatisticsQuery, GetEventAttendeeStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventAttendeeStatisticsQuery, GetEventAttendeeStatisticsQueryVariables>(GetEventAttendeeStatisticsDocument, options);
        }
export function useGetEventAttendeeStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventAttendeeStatisticsQuery, GetEventAttendeeStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventAttendeeStatisticsQuery, GetEventAttendeeStatisticsQueryVariables>(GetEventAttendeeStatisticsDocument, options);
        }
export type GetEventAttendeeStatisticsQueryHookResult = ReturnType<typeof useGetEventAttendeeStatisticsQuery>;
export type GetEventAttendeeStatisticsLazyQueryHookResult = ReturnType<typeof useGetEventAttendeeStatisticsLazyQuery>;
export type GetEventAttendeeStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetEventAttendeeStatisticsSuspenseQuery>;
export type GetEventAttendeeStatisticsQueryResult = Apollo.QueryResult<GetEventAttendeeStatisticsQuery, GetEventAttendeeStatisticsQueryVariables>;
export const CalculateTicketCostDocument = gql`
    query CalculateTicketCost($eventId: UUID!, $items: [TicketCostItemArgsInput!]!, $referralCode: String, $shippingAddress: AddressModelInput) {
  event {
    calculateTicketCost(
      ticketCostArgs: {eventId: $eventId, items: $items, referralCode: $referralCode, shippingAddress: $shippingAddress}
    ) {
      hostBalance
      isAllInPricing
      processingFee
      serviceFee
      subTotal
      total
      items {
        price
        originalPrice
        quantity
        eventTicketId
        gratuityPercentage
      }
      paymentAuthCode
      totalGratuity
      totalTaxes
      taxName
      taxPercentage
      useAutomaticTax
    }
  }
}
    `;

/**
 * __useCalculateTicketCostQuery__
 *
 * To run a query within a React component, call `useCalculateTicketCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateTicketCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateTicketCostQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      items: // value for 'items'
 *      referralCode: // value for 'referralCode'
 *      shippingAddress: // value for 'shippingAddress'
 *   },
 * });
 */
export function useCalculateTicketCostQuery(baseOptions: Apollo.QueryHookOptions<CalculateTicketCostQuery, CalculateTicketCostQueryVariables> & ({ variables: CalculateTicketCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateTicketCostQuery, CalculateTicketCostQueryVariables>(CalculateTicketCostDocument, options);
      }
export function useCalculateTicketCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateTicketCostQuery, CalculateTicketCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateTicketCostQuery, CalculateTicketCostQueryVariables>(CalculateTicketCostDocument, options);
        }
export function useCalculateTicketCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalculateTicketCostQuery, CalculateTicketCostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalculateTicketCostQuery, CalculateTicketCostQueryVariables>(CalculateTicketCostDocument, options);
        }
export type CalculateTicketCostQueryHookResult = ReturnType<typeof useCalculateTicketCostQuery>;
export type CalculateTicketCostLazyQueryHookResult = ReturnType<typeof useCalculateTicketCostLazyQuery>;
export type CalculateTicketCostSuspenseQueryHookResult = ReturnType<typeof useCalculateTicketCostSuspenseQuery>;
export type CalculateTicketCostQueryResult = Apollo.QueryResult<CalculateTicketCostQuery, CalculateTicketCostQueryVariables>;
export const SimulateTicketCostDocument = gql`
    query SimulateTicketCost($items: [TicketCostSimulationItemInput!]!, $isAllInPricing: Boolean) {
  event {
    simulateTicketCost(items: $items, isAllInPricing: $isAllInPricing) {
      hostBalance
      isAllInPricing
      processingFee
      serviceFee
      subTotal
      total
      items {
        price
        originalPrice
        quantity
      }
      totalGratuity
      totalTaxes
    }
  }
}
    `;

/**
 * __useSimulateTicketCostQuery__
 *
 * To run a query within a React component, call `useSimulateTicketCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimulateTicketCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimulateTicketCostQuery({
 *   variables: {
 *      items: // value for 'items'
 *      isAllInPricing: // value for 'isAllInPricing'
 *   },
 * });
 */
export function useSimulateTicketCostQuery(baseOptions: Apollo.QueryHookOptions<SimulateTicketCostQuery, SimulateTicketCostQueryVariables> & ({ variables: SimulateTicketCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimulateTicketCostQuery, SimulateTicketCostQueryVariables>(SimulateTicketCostDocument, options);
      }
export function useSimulateTicketCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimulateTicketCostQuery, SimulateTicketCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimulateTicketCostQuery, SimulateTicketCostQueryVariables>(SimulateTicketCostDocument, options);
        }
export function useSimulateTicketCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimulateTicketCostQuery, SimulateTicketCostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimulateTicketCostQuery, SimulateTicketCostQueryVariables>(SimulateTicketCostDocument, options);
        }
export type SimulateTicketCostQueryHookResult = ReturnType<typeof useSimulateTicketCostQuery>;
export type SimulateTicketCostLazyQueryHookResult = ReturnType<typeof useSimulateTicketCostLazyQuery>;
export type SimulateTicketCostSuspenseQueryHookResult = ReturnType<typeof useSimulateTicketCostSuspenseQuery>;
export type SimulateTicketCostQueryResult = Apollo.QueryResult<SimulateTicketCostQuery, SimulateTicketCostQueryVariables>;
export const GetRequestedPayoutInfoDocument = gql`
    query GetRequestedPayoutInfo {
  event {
    requestedPayoutInfo {
      canRequestPayout
      lastRequestedTime
      totalBalance
      totalAmount
      totalReleasedAmount
    }
  }
}
    `;

/**
 * __useGetRequestedPayoutInfoQuery__
 *
 * To run a query within a React component, call `useGetRequestedPayoutInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestedPayoutInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestedPayoutInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequestedPayoutInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetRequestedPayoutInfoQuery, GetRequestedPayoutInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestedPayoutInfoQuery, GetRequestedPayoutInfoQueryVariables>(GetRequestedPayoutInfoDocument, options);
      }
export function useGetRequestedPayoutInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestedPayoutInfoQuery, GetRequestedPayoutInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestedPayoutInfoQuery, GetRequestedPayoutInfoQueryVariables>(GetRequestedPayoutInfoDocument, options);
        }
export function useGetRequestedPayoutInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestedPayoutInfoQuery, GetRequestedPayoutInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestedPayoutInfoQuery, GetRequestedPayoutInfoQueryVariables>(GetRequestedPayoutInfoDocument, options);
        }
export type GetRequestedPayoutInfoQueryHookResult = ReturnType<typeof useGetRequestedPayoutInfoQuery>;
export type GetRequestedPayoutInfoLazyQueryHookResult = ReturnType<typeof useGetRequestedPayoutInfoLazyQuery>;
export type GetRequestedPayoutInfoSuspenseQueryHookResult = ReturnType<typeof useGetRequestedPayoutInfoSuspenseQuery>;
export type GetRequestedPayoutInfoQueryResult = Apollo.QueryResult<GetRequestedPayoutInfoQuery, GetRequestedPayoutInfoQueryVariables>;
export const GetRequestedPayoutInfoByCurrencyDocument = gql`
    query GetRequestedPayoutInfoByCurrency($currency: String!) {
  event {
    requestedPayoutInfoByCurrency(currency: $currency) {
      canRequestPayout
      lastRequestedTime
      totalBalance
      totalAmount
      totalReleasedAmount
    }
  }
}
    `;

/**
 * __useGetRequestedPayoutInfoByCurrencyQuery__
 *
 * To run a query within a React component, call `useGetRequestedPayoutInfoByCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestedPayoutInfoByCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestedPayoutInfoByCurrencyQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetRequestedPayoutInfoByCurrencyQuery(baseOptions: Apollo.QueryHookOptions<GetRequestedPayoutInfoByCurrencyQuery, GetRequestedPayoutInfoByCurrencyQueryVariables> & ({ variables: GetRequestedPayoutInfoByCurrencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestedPayoutInfoByCurrencyQuery, GetRequestedPayoutInfoByCurrencyQueryVariables>(GetRequestedPayoutInfoByCurrencyDocument, options);
      }
export function useGetRequestedPayoutInfoByCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestedPayoutInfoByCurrencyQuery, GetRequestedPayoutInfoByCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestedPayoutInfoByCurrencyQuery, GetRequestedPayoutInfoByCurrencyQueryVariables>(GetRequestedPayoutInfoByCurrencyDocument, options);
        }
export function useGetRequestedPayoutInfoByCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestedPayoutInfoByCurrencyQuery, GetRequestedPayoutInfoByCurrencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestedPayoutInfoByCurrencyQuery, GetRequestedPayoutInfoByCurrencyQueryVariables>(GetRequestedPayoutInfoByCurrencyDocument, options);
        }
export type GetRequestedPayoutInfoByCurrencyQueryHookResult = ReturnType<typeof useGetRequestedPayoutInfoByCurrencyQuery>;
export type GetRequestedPayoutInfoByCurrencyLazyQueryHookResult = ReturnType<typeof useGetRequestedPayoutInfoByCurrencyLazyQuery>;
export type GetRequestedPayoutInfoByCurrencySuspenseQueryHookResult = ReturnType<typeof useGetRequestedPayoutInfoByCurrencySuspenseQuery>;
export type GetRequestedPayoutInfoByCurrencyQueryResult = Apollo.QueryResult<GetRequestedPayoutInfoByCurrencyQuery, GetRequestedPayoutInfoByCurrencyQueryVariables>;
export const MyReferralCodeDocument = gql`
    query MyReferralCode {
  myReferralCode
}
    `;

/**
 * __useMyReferralCodeQuery__
 *
 * To run a query within a React component, call `useMyReferralCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyReferralCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyReferralCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyReferralCodeQuery(baseOptions?: Apollo.QueryHookOptions<MyReferralCodeQuery, MyReferralCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyReferralCodeQuery, MyReferralCodeQueryVariables>(MyReferralCodeDocument, options);
      }
export function useMyReferralCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyReferralCodeQuery, MyReferralCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyReferralCodeQuery, MyReferralCodeQueryVariables>(MyReferralCodeDocument, options);
        }
export function useMyReferralCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyReferralCodeQuery, MyReferralCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyReferralCodeQuery, MyReferralCodeQueryVariables>(MyReferralCodeDocument, options);
        }
export type MyReferralCodeQueryHookResult = ReturnType<typeof useMyReferralCodeQuery>;
export type MyReferralCodeLazyQueryHookResult = ReturnType<typeof useMyReferralCodeLazyQuery>;
export type MyReferralCodeSuspenseQueryHookResult = ReturnType<typeof useMyReferralCodeSuspenseQuery>;
export type MyReferralCodeQueryResult = Apollo.QueryResult<MyReferralCodeQuery, MyReferralCodeQueryVariables>;
export const SearchEventGuestsDocument = gql`
    query SearchEventGuests($eventId: UUID!, $query: String, $first: Int, $after: String) {
  event {
    searchEventGuests(
      eventId: $eventId
      query: $query
      first: $first
      after: $after
    ) {
      edges {
        node {
          eventId
          guestId
          eventTicketIds
          fullName
          emailAddress
          phoneNumber
          avatarUrl
          note
          createdAt
          createdBy
          customFields {
            key
            label
            value
          }
          tickets {
            ticketId
            ticketNo
            eventTicketId
            eventTicket {
              ticketType
            }
            guestName
            createdAt
            createdBy
            checkedInAt
            guestId
            avatarUrl
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
}
    `;

/**
 * __useSearchEventGuestsQuery__
 *
 * To run a query within a React component, call `useSearchEventGuestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEventGuestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEventGuestsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchEventGuestsQuery(baseOptions: Apollo.QueryHookOptions<SearchEventGuestsQuery, SearchEventGuestsQueryVariables> & ({ variables: SearchEventGuestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEventGuestsQuery, SearchEventGuestsQueryVariables>(SearchEventGuestsDocument, options);
      }
export function useSearchEventGuestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEventGuestsQuery, SearchEventGuestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEventGuestsQuery, SearchEventGuestsQueryVariables>(SearchEventGuestsDocument, options);
        }
export function useSearchEventGuestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchEventGuestsQuery, SearchEventGuestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchEventGuestsQuery, SearchEventGuestsQueryVariables>(SearchEventGuestsDocument, options);
        }
export type SearchEventGuestsQueryHookResult = ReturnType<typeof useSearchEventGuestsQuery>;
export type SearchEventGuestsLazyQueryHookResult = ReturnType<typeof useSearchEventGuestsLazyQuery>;
export type SearchEventGuestsSuspenseQueryHookResult = ReturnType<typeof useSearchEventGuestsSuspenseQuery>;
export type SearchEventGuestsQueryResult = Apollo.QueryResult<SearchEventGuestsQuery, SearchEventGuestsQueryVariables>;
export const CheckContactEmailExistsDocument = gql`
    query CheckContactEmailExists($emails: [String!]!) {
  contactList {
    emailsExist(emails: $emails)
  }
}
    `;

/**
 * __useCheckContactEmailExistsQuery__
 *
 * To run a query within a React component, call `useCheckContactEmailExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckContactEmailExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckContactEmailExistsQuery({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useCheckContactEmailExistsQuery(baseOptions: Apollo.QueryHookOptions<CheckContactEmailExistsQuery, CheckContactEmailExistsQueryVariables> & ({ variables: CheckContactEmailExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckContactEmailExistsQuery, CheckContactEmailExistsQueryVariables>(CheckContactEmailExistsDocument, options);
      }
export function useCheckContactEmailExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckContactEmailExistsQuery, CheckContactEmailExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckContactEmailExistsQuery, CheckContactEmailExistsQueryVariables>(CheckContactEmailExistsDocument, options);
        }
export function useCheckContactEmailExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckContactEmailExistsQuery, CheckContactEmailExistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckContactEmailExistsQuery, CheckContactEmailExistsQueryVariables>(CheckContactEmailExistsDocument, options);
        }
export type CheckContactEmailExistsQueryHookResult = ReturnType<typeof useCheckContactEmailExistsQuery>;
export type CheckContactEmailExistsLazyQueryHookResult = ReturnType<typeof useCheckContactEmailExistsLazyQuery>;
export type CheckContactEmailExistsSuspenseQueryHookResult = ReturnType<typeof useCheckContactEmailExistsSuspenseQuery>;
export type CheckContactEmailExistsQueryResult = Apollo.QueryResult<CheckContactEmailExistsQuery, CheckContactEmailExistsQueryVariables>;
export const CheckContactPhoneNumbersExistDocument = gql`
    query CheckContactPhoneNumbersExist($phones: [String!]!) {
  contactList {
    phonesExist(phones: $phones)
  }
}
    `;

/**
 * __useCheckContactPhoneNumbersExistQuery__
 *
 * To run a query within a React component, call `useCheckContactPhoneNumbersExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckContactPhoneNumbersExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckContactPhoneNumbersExistQuery({
 *   variables: {
 *      phones: // value for 'phones'
 *   },
 * });
 */
export function useCheckContactPhoneNumbersExistQuery(baseOptions: Apollo.QueryHookOptions<CheckContactPhoneNumbersExistQuery, CheckContactPhoneNumbersExistQueryVariables> & ({ variables: CheckContactPhoneNumbersExistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckContactPhoneNumbersExistQuery, CheckContactPhoneNumbersExistQueryVariables>(CheckContactPhoneNumbersExistDocument, options);
      }
export function useCheckContactPhoneNumbersExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckContactPhoneNumbersExistQuery, CheckContactPhoneNumbersExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckContactPhoneNumbersExistQuery, CheckContactPhoneNumbersExistQueryVariables>(CheckContactPhoneNumbersExistDocument, options);
        }
export function useCheckContactPhoneNumbersExistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckContactPhoneNumbersExistQuery, CheckContactPhoneNumbersExistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckContactPhoneNumbersExistQuery, CheckContactPhoneNumbersExistQueryVariables>(CheckContactPhoneNumbersExistDocument, options);
        }
export type CheckContactPhoneNumbersExistQueryHookResult = ReturnType<typeof useCheckContactPhoneNumbersExistQuery>;
export type CheckContactPhoneNumbersExistLazyQueryHookResult = ReturnType<typeof useCheckContactPhoneNumbersExistLazyQuery>;
export type CheckContactPhoneNumbersExistSuspenseQueryHookResult = ReturnType<typeof useCheckContactPhoneNumbersExistSuspenseQuery>;
export type CheckContactPhoneNumbersExistQueryResult = Apollo.QueryResult<CheckContactPhoneNumbersExistQuery, CheckContactPhoneNumbersExistQueryVariables>;
export const GetUserEventPolicyReactionsDocument = gql`
    query GetUserEventPolicyReactions($eventId: UUID!, $userId: UUID!) {
  event {
    getUserEventPolicyReactions(eventId: $eventId, userId: $userId) {
      policyFileUrl
      policyTitle
      reaction
      reactionTime
      signedDisclosureFileUrl
      disclosureReferenceId
      signedWaiverFileUrl
      signedEventId
      signedEventName
    }
  }
}
    `;

/**
 * __useGetUserEventPolicyReactionsQuery__
 *
 * To run a query within a React component, call `useGetUserEventPolicyReactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEventPolicyReactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEventPolicyReactionsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserEventPolicyReactionsQuery(baseOptions: Apollo.QueryHookOptions<GetUserEventPolicyReactionsQuery, GetUserEventPolicyReactionsQueryVariables> & ({ variables: GetUserEventPolicyReactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEventPolicyReactionsQuery, GetUserEventPolicyReactionsQueryVariables>(GetUserEventPolicyReactionsDocument, options);
      }
export function useGetUserEventPolicyReactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEventPolicyReactionsQuery, GetUserEventPolicyReactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEventPolicyReactionsQuery, GetUserEventPolicyReactionsQueryVariables>(GetUserEventPolicyReactionsDocument, options);
        }
export function useGetUserEventPolicyReactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserEventPolicyReactionsQuery, GetUserEventPolicyReactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserEventPolicyReactionsQuery, GetUserEventPolicyReactionsQueryVariables>(GetUserEventPolicyReactionsDocument, options);
        }
export type GetUserEventPolicyReactionsQueryHookResult = ReturnType<typeof useGetUserEventPolicyReactionsQuery>;
export type GetUserEventPolicyReactionsLazyQueryHookResult = ReturnType<typeof useGetUserEventPolicyReactionsLazyQuery>;
export type GetUserEventPolicyReactionsSuspenseQueryHookResult = ReturnType<typeof useGetUserEventPolicyReactionsSuspenseQuery>;
export type GetUserEventPolicyReactionsQueryResult = Apollo.QueryResult<GetUserEventPolicyReactionsQuery, GetUserEventPolicyReactionsQueryVariables>;
export const GetScheduledEventMessagesDocument = gql`
    query GetScheduledEventMessages($eventId: UUID!, $status: ScheduledMessageStatus) {
  event {
    scheduledEventMessages(eventId: $eventId, status: $status) {
      id
      message
      smsMessage
      sendAt
      isViaEmail
      isViaSms
      filterArgs {
        eventMessageType
        eventTicketIds
        eventAttendeeRoles
        attendeeStatuses
      }
      status
      createdBy
      createdAt
      sentAt
      canceledAt
      canceledBy
      updatedAt
      updatedBy
    }
  }
}
    `;

/**
 * __useGetScheduledEventMessagesQuery__
 *
 * To run a query within a React component, call `useGetScheduledEventMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledEventMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledEventMessagesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetScheduledEventMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetScheduledEventMessagesQuery, GetScheduledEventMessagesQueryVariables> & ({ variables: GetScheduledEventMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledEventMessagesQuery, GetScheduledEventMessagesQueryVariables>(GetScheduledEventMessagesDocument, options);
      }
export function useGetScheduledEventMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledEventMessagesQuery, GetScheduledEventMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledEventMessagesQuery, GetScheduledEventMessagesQueryVariables>(GetScheduledEventMessagesDocument, options);
        }
export function useGetScheduledEventMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScheduledEventMessagesQuery, GetScheduledEventMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScheduledEventMessagesQuery, GetScheduledEventMessagesQueryVariables>(GetScheduledEventMessagesDocument, options);
        }
export type GetScheduledEventMessagesQueryHookResult = ReturnType<typeof useGetScheduledEventMessagesQuery>;
export type GetScheduledEventMessagesLazyQueryHookResult = ReturnType<typeof useGetScheduledEventMessagesLazyQuery>;
export type GetScheduledEventMessagesSuspenseQueryHookResult = ReturnType<typeof useGetScheduledEventMessagesSuspenseQuery>;
export type GetScheduledEventMessagesQueryResult = Apollo.QueryResult<GetScheduledEventMessagesQuery, GetScheduledEventMessagesQueryVariables>;
export const CheckedInTicketSummaryDocument = gql`
    query CheckedInTicketSummary($eventId: UUID!) {
  event {
    ticketSummary(eventId: $eventId) {
      eventId
      event {
        displayName
      }
      totalIssuedTickets
      totalCheckedInTickets
      totalScans
      dailyScans {
        date
        totalScans
      }
      ticketSummaries {
        eventTicketId
        eventTicket {
          ticketType
          isPrivate
        }
        totalIssuedTickets
        totalCheckedInTickets
        totalScans
        zoneSummaries {
          eventTicketZoneId
          totalCheckedInTickets
          totalScans
          zoneName
          dailyScans {
            date
            totalScans
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCheckedInTicketSummaryQuery__
 *
 * To run a query within a React component, call `useCheckedInTicketSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckedInTicketSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckedInTicketSummaryQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useCheckedInTicketSummaryQuery(baseOptions: Apollo.QueryHookOptions<CheckedInTicketSummaryQuery, CheckedInTicketSummaryQueryVariables> & ({ variables: CheckedInTicketSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckedInTicketSummaryQuery, CheckedInTicketSummaryQueryVariables>(CheckedInTicketSummaryDocument, options);
      }
export function useCheckedInTicketSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckedInTicketSummaryQuery, CheckedInTicketSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckedInTicketSummaryQuery, CheckedInTicketSummaryQueryVariables>(CheckedInTicketSummaryDocument, options);
        }
export function useCheckedInTicketSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckedInTicketSummaryQuery, CheckedInTicketSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckedInTicketSummaryQuery, CheckedInTicketSummaryQueryVariables>(CheckedInTicketSummaryDocument, options);
        }
export type CheckedInTicketSummaryQueryHookResult = ReturnType<typeof useCheckedInTicketSummaryQuery>;
export type CheckedInTicketSummaryLazyQueryHookResult = ReturnType<typeof useCheckedInTicketSummaryLazyQuery>;
export type CheckedInTicketSummarySuspenseQueryHookResult = ReturnType<typeof useCheckedInTicketSummarySuspenseQuery>;
export type CheckedInTicketSummaryQueryResult = Apollo.QueryResult<CheckedInTicketSummaryQuery, CheckedInTicketSummaryQueryVariables>;
export const EventScanRecordsDocument = gql`
    query EventScanRecords($eventId: UUID!, $first: Int, $after: String, $sortType: ScanRecordSortType = SCAN_TIME, $sortOrder: PageSortOrder = DESCENDING, $filterArgs: ScanRecordFilterArgsInput) {
  event {
    eventScanRecords(
      eventId: $eventId
      first: $first
      after: $after
      sortType: $sortType
      sortOrder: $sortOrder
      filterArgs: $filterArgs
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          scanTime
          zoneId
          zoneName
          ticketId
          eventTicketId
          associatedUserId
          isSeriesPass
          memberEventId
          ticketType {
            eventTicketId
            ticketType
          }
          attendee {
            userId
            name
            avatarUrl
            emailAddress
          }
          scanner {
            userId
            name
            avatarUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEventScanRecordsQuery__
 *
 * To run a query within a React component, call `useEventScanRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventScanRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventScanRecordsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortType: // value for 'sortType'
 *      sortOrder: // value for 'sortOrder'
 *      filterArgs: // value for 'filterArgs'
 *   },
 * });
 */
export function useEventScanRecordsQuery(baseOptions: Apollo.QueryHookOptions<EventScanRecordsQuery, EventScanRecordsQueryVariables> & ({ variables: EventScanRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventScanRecordsQuery, EventScanRecordsQueryVariables>(EventScanRecordsDocument, options);
      }
export function useEventScanRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventScanRecordsQuery, EventScanRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventScanRecordsQuery, EventScanRecordsQueryVariables>(EventScanRecordsDocument, options);
        }
export function useEventScanRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventScanRecordsQuery, EventScanRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventScanRecordsQuery, EventScanRecordsQueryVariables>(EventScanRecordsDocument, options);
        }
export type EventScanRecordsQueryHookResult = ReturnType<typeof useEventScanRecordsQuery>;
export type EventScanRecordsLazyQueryHookResult = ReturnType<typeof useEventScanRecordsLazyQuery>;
export type EventScanRecordsSuspenseQueryHookResult = ReturnType<typeof useEventScanRecordsSuspenseQuery>;
export type EventScanRecordsQueryResult = Apollo.QueryResult<EventScanRecordsQuery, EventScanRecordsQueryVariables>;
export const GetEventEarningsDocument = gql`
    query GetEventEarnings($filter: EventEarningsFilterInput!) {
  event {
    getEventEarnings(filter: $filter) {
      hostBalance
      processingFee
      serviceFee
      totalFees
      subTotal
      totalQuantity
      totalPrice
      totalTaxes
      totalGratuity
      ticketBreakdown {
        eventTicketId
        ticketType
        unitPrice
        totalQuantity
        totalPrice
        event {
          eventId
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventEarningsQuery__
 *
 * To run a query within a React component, call `useGetEventEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventEarningsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEventEarningsQuery(baseOptions: Apollo.QueryHookOptions<GetEventEarningsQuery, GetEventEarningsQueryVariables> & ({ variables: GetEventEarningsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventEarningsQuery, GetEventEarningsQueryVariables>(GetEventEarningsDocument, options);
      }
export function useGetEventEarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventEarningsQuery, GetEventEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventEarningsQuery, GetEventEarningsQueryVariables>(GetEventEarningsDocument, options);
        }
export function useGetEventEarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventEarningsQuery, GetEventEarningsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventEarningsQuery, GetEventEarningsQueryVariables>(GetEventEarningsDocument, options);
        }
export type GetEventEarningsQueryHookResult = ReturnType<typeof useGetEventEarningsQuery>;
export type GetEventEarningsLazyQueryHookResult = ReturnType<typeof useGetEventEarningsLazyQuery>;
export type GetEventEarningsSuspenseQueryHookResult = ReturnType<typeof useGetEventEarningsSuspenseQuery>;
export type GetEventEarningsQueryResult = Apollo.QueryResult<GetEventEarningsQuery, GetEventEarningsQueryVariables>;
export const EventPayoutRequestsDocument = gql`
    query EventPayoutRequests {
  event {
    listPayoutRequests {
      amount
      lastRequestedTime
      paidDate
      requestId
      requestId
      status
      userId
    }
  }
}
    `;

/**
 * __useEventPayoutRequestsQuery__
 *
 * To run a query within a React component, call `useEventPayoutRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventPayoutRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventPayoutRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventPayoutRequestsQuery(baseOptions?: Apollo.QueryHookOptions<EventPayoutRequestsQuery, EventPayoutRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventPayoutRequestsQuery, EventPayoutRequestsQueryVariables>(EventPayoutRequestsDocument, options);
      }
export function useEventPayoutRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventPayoutRequestsQuery, EventPayoutRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventPayoutRequestsQuery, EventPayoutRequestsQueryVariables>(EventPayoutRequestsDocument, options);
        }
export function useEventPayoutRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventPayoutRequestsQuery, EventPayoutRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventPayoutRequestsQuery, EventPayoutRequestsQueryVariables>(EventPayoutRequestsDocument, options);
        }
export type EventPayoutRequestsQueryHookResult = ReturnType<typeof useEventPayoutRequestsQuery>;
export type EventPayoutRequestsLazyQueryHookResult = ReturnType<typeof useEventPayoutRequestsLazyQuery>;
export type EventPayoutRequestsSuspenseQueryHookResult = ReturnType<typeof useEventPayoutRequestsSuspenseQuery>;
export type EventPayoutRequestsQueryResult = Apollo.QueryResult<EventPayoutRequestsQuery, EventPayoutRequestsQueryVariables>;
export const EventPayoutRequestsByCurrencyDocument = gql`
    query EventPayoutRequestsByCurrency($currency: String!) {
  event {
    listPayoutRequestsByCurrency(currency: $currency) {
      amount
      lastRequestedTime
      paidDate
      requestId
      requestId
      status
      userId
    }
  }
}
    `;

/**
 * __useEventPayoutRequestsByCurrencyQuery__
 *
 * To run a query within a React component, call `useEventPayoutRequestsByCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventPayoutRequestsByCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventPayoutRequestsByCurrencyQuery({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useEventPayoutRequestsByCurrencyQuery(baseOptions: Apollo.QueryHookOptions<EventPayoutRequestsByCurrencyQuery, EventPayoutRequestsByCurrencyQueryVariables> & ({ variables: EventPayoutRequestsByCurrencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventPayoutRequestsByCurrencyQuery, EventPayoutRequestsByCurrencyQueryVariables>(EventPayoutRequestsByCurrencyDocument, options);
      }
export function useEventPayoutRequestsByCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventPayoutRequestsByCurrencyQuery, EventPayoutRequestsByCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventPayoutRequestsByCurrencyQuery, EventPayoutRequestsByCurrencyQueryVariables>(EventPayoutRequestsByCurrencyDocument, options);
        }
export function useEventPayoutRequestsByCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventPayoutRequestsByCurrencyQuery, EventPayoutRequestsByCurrencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventPayoutRequestsByCurrencyQuery, EventPayoutRequestsByCurrencyQueryVariables>(EventPayoutRequestsByCurrencyDocument, options);
        }
export type EventPayoutRequestsByCurrencyQueryHookResult = ReturnType<typeof useEventPayoutRequestsByCurrencyQuery>;
export type EventPayoutRequestsByCurrencyLazyQueryHookResult = ReturnType<typeof useEventPayoutRequestsByCurrencyLazyQuery>;
export type EventPayoutRequestsByCurrencySuspenseQueryHookResult = ReturnType<typeof useEventPayoutRequestsByCurrencySuspenseQuery>;
export type EventPayoutRequestsByCurrencyQueryResult = Apollo.QueryResult<EventPayoutRequestsByCurrencyQuery, EventPayoutRequestsByCurrencyQueryVariables>;
export const ValidatePdfWatermarkDocument = gql`
    query ValidatePdfWatermark($fileUrl: String!) {
  event {
    validatePdfWatermark(fileUrl: $fileUrl) {
      errorMessage
      fileExists
      isValid
    }
  }
}
    `;

/**
 * __useValidatePdfWatermarkQuery__
 *
 * To run a query within a React component, call `useValidatePdfWatermarkQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePdfWatermarkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePdfWatermarkQuery({
 *   variables: {
 *      fileUrl: // value for 'fileUrl'
 *   },
 * });
 */
export function useValidatePdfWatermarkQuery(baseOptions: Apollo.QueryHookOptions<ValidatePdfWatermarkQuery, ValidatePdfWatermarkQueryVariables> & ({ variables: ValidatePdfWatermarkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatePdfWatermarkQuery, ValidatePdfWatermarkQueryVariables>(ValidatePdfWatermarkDocument, options);
      }
export function useValidatePdfWatermarkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatePdfWatermarkQuery, ValidatePdfWatermarkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatePdfWatermarkQuery, ValidatePdfWatermarkQueryVariables>(ValidatePdfWatermarkDocument, options);
        }
export function useValidatePdfWatermarkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidatePdfWatermarkQuery, ValidatePdfWatermarkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidatePdfWatermarkQuery, ValidatePdfWatermarkQueryVariables>(ValidatePdfWatermarkDocument, options);
        }
export type ValidatePdfWatermarkQueryHookResult = ReturnType<typeof useValidatePdfWatermarkQuery>;
export type ValidatePdfWatermarkLazyQueryHookResult = ReturnType<typeof useValidatePdfWatermarkLazyQuery>;
export type ValidatePdfWatermarkSuspenseQueryHookResult = ReturnType<typeof useValidatePdfWatermarkSuspenseQuery>;
export type ValidatePdfWatermarkQueryResult = Apollo.QueryResult<ValidatePdfWatermarkQuery, ValidatePdfWatermarkQueryVariables>;
export const GetBulkInviteStatusDocument = gql`
    query GetBulkInviteStatus($eventId: UUID!, $jobId: String!) {
  event {
    bulkInviteStatus(eventId: $eventId, jobId: $jobId) {
      status
      totalCount
      processedCount
      sentCount
      skippedCount
      failCount
      startedAt
      completedAt
    }
  }
}
    `;

/**
 * __useGetBulkInviteStatusQuery__
 *
 * To run a query within a React component, call `useGetBulkInviteStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkInviteStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkInviteStatusQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetBulkInviteStatusQuery(baseOptions: Apollo.QueryHookOptions<GetBulkInviteStatusQuery, GetBulkInviteStatusQueryVariables> & ({ variables: GetBulkInviteStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkInviteStatusQuery, GetBulkInviteStatusQueryVariables>(GetBulkInviteStatusDocument, options);
      }
export function useGetBulkInviteStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkInviteStatusQuery, GetBulkInviteStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkInviteStatusQuery, GetBulkInviteStatusQueryVariables>(GetBulkInviteStatusDocument, options);
        }
export function useGetBulkInviteStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBulkInviteStatusQuery, GetBulkInviteStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBulkInviteStatusQuery, GetBulkInviteStatusQueryVariables>(GetBulkInviteStatusDocument, options);
        }
export type GetBulkInviteStatusQueryHookResult = ReturnType<typeof useGetBulkInviteStatusQuery>;
export type GetBulkInviteStatusLazyQueryHookResult = ReturnType<typeof useGetBulkInviteStatusLazyQuery>;
export type GetBulkInviteStatusSuspenseQueryHookResult = ReturnType<typeof useGetBulkInviteStatusSuspenseQuery>;
export type GetBulkInviteStatusQueryResult = Apollo.QueryResult<GetBulkInviteStatusQuery, GetBulkInviteStatusQueryVariables>;
export const CheckoutStatusDocument = gql`
    query CheckoutStatus($paymentReferenceId: String!) {
  eventTicket {
    checkoutStatus(paymentReferenceId: $paymentReferenceId)
  }
}
    `;

/**
 * __useCheckoutStatusQuery__
 *
 * To run a query within a React component, call `useCheckoutStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutStatusQuery({
 *   variables: {
 *      paymentReferenceId: // value for 'paymentReferenceId'
 *   },
 * });
 */
export function useCheckoutStatusQuery(baseOptions: Apollo.QueryHookOptions<CheckoutStatusQuery, CheckoutStatusQueryVariables> & ({ variables: CheckoutStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutStatusQuery, CheckoutStatusQueryVariables>(CheckoutStatusDocument, options);
      }
export function useCheckoutStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutStatusQuery, CheckoutStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutStatusQuery, CheckoutStatusQueryVariables>(CheckoutStatusDocument, options);
        }
export function useCheckoutStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutStatusQuery, CheckoutStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutStatusQuery, CheckoutStatusQueryVariables>(CheckoutStatusDocument, options);
        }
export type CheckoutStatusQueryHookResult = ReturnType<typeof useCheckoutStatusQuery>;
export type CheckoutStatusLazyQueryHookResult = ReturnType<typeof useCheckoutStatusLazyQuery>;
export type CheckoutStatusSuspenseQueryHookResult = ReturnType<typeof useCheckoutStatusSuspenseQuery>;
export type CheckoutStatusQueryResult = Apollo.QueryResult<CheckoutStatusQuery, CheckoutStatusQueryVariables>;
export const GetHostMessageInboxDocument = gql`
    query GetHostMessageInbox($count: Int!, $after: String, $eventId: UUID) {
  hostMessage {
    inbox(count: $count, after: $after, eventId: $eventId) {
      messages {
        messageId
        body
        sentAt
        isRead
        senderId
        eventId
        hostId
        readAt
        senderAvatar
        senderAvatarSource
        senderInstagramAvatarUrl
        senderTikTokAvatarUrl
        senderTwitchAvatarUrl
        senderName
        parentMessageId
        threadId
        eventSlug
        eventName
        eventAvatar
        kind
        isViaEmail
        isViaSms
        recipientCount
        delivery {
          sentCount
          failCount
          suppressedCount
          completedAt
        }
      }
      total
      endCursor
    }
  }
}
    `;

/**
 * __useGetHostMessageInboxQuery__
 *
 * To run a query within a React component, call `useGetHostMessageInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostMessageInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostMessageInboxQuery({
 *   variables: {
 *      count: // value for 'count'
 *      after: // value for 'after'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetHostMessageInboxQuery(baseOptions: Apollo.QueryHookOptions<GetHostMessageInboxQuery, GetHostMessageInboxQueryVariables> & ({ variables: GetHostMessageInboxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHostMessageInboxQuery, GetHostMessageInboxQueryVariables>(GetHostMessageInboxDocument, options);
      }
export function useGetHostMessageInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostMessageInboxQuery, GetHostMessageInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHostMessageInboxQuery, GetHostMessageInboxQueryVariables>(GetHostMessageInboxDocument, options);
        }
export function useGetHostMessageInboxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHostMessageInboxQuery, GetHostMessageInboxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHostMessageInboxQuery, GetHostMessageInboxQueryVariables>(GetHostMessageInboxDocument, options);
        }
export type GetHostMessageInboxQueryHookResult = ReturnType<typeof useGetHostMessageInboxQuery>;
export type GetHostMessageInboxLazyQueryHookResult = ReturnType<typeof useGetHostMessageInboxLazyQuery>;
export type GetHostMessageInboxSuspenseQueryHookResult = ReturnType<typeof useGetHostMessageInboxSuspenseQuery>;
export type GetHostMessageInboxQueryResult = Apollo.QueryResult<GetHostMessageInboxQuery, GetHostMessageInboxQueryVariables>;
export const GetHostMessageDocument = gql`
    query GetHostMessage($messageId: UUID!) {
  hostMessage {
    get(messageId: $messageId) {
      messageId
      threadId
      body
      sentAt
      isRead
      senderId
      eventId
      kind
      isViaEmail
      isViaSms
      recipientCount
      delivery {
        sentCount
        failCount
        suppressedCount
        completedAt
      }
    }
  }
}
    `;

/**
 * __useGetHostMessageQuery__
 *
 * To run a query within a React component, call `useGetHostMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostMessageQuery({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useGetHostMessageQuery(baseOptions: Apollo.QueryHookOptions<GetHostMessageQuery, GetHostMessageQueryVariables> & ({ variables: GetHostMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHostMessageQuery, GetHostMessageQueryVariables>(GetHostMessageDocument, options);
      }
export function useGetHostMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostMessageQuery, GetHostMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHostMessageQuery, GetHostMessageQueryVariables>(GetHostMessageDocument, options);
        }
export function useGetHostMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHostMessageQuery, GetHostMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHostMessageQuery, GetHostMessageQueryVariables>(GetHostMessageDocument, options);
        }
export type GetHostMessageQueryHookResult = ReturnType<typeof useGetHostMessageQuery>;
export type GetHostMessageLazyQueryHookResult = ReturnType<typeof useGetHostMessageLazyQuery>;
export type GetHostMessageSuspenseQueryHookResult = ReturnType<typeof useGetHostMessageSuspenseQuery>;
export type GetHostMessageQueryResult = Apollo.QueryResult<GetHostMessageQuery, GetHostMessageQueryVariables>;
export const GetIndividualAssetDocument = gql`
    query GetIndividualAsset {
  individual_asset {
    list {
      individualAssetId
      price {
        symbol
        value
      }
      imageUrl
      name
      category
      createdUtc
      maxSupply
      currentSupply
      priority
      status
      isHidden
    }
  }
}
    `;

/**
 * __useGetIndividualAssetQuery__
 *
 * To run a query within a React component, call `useGetIndividualAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndividualAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndividualAssetQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIndividualAssetQuery(baseOptions?: Apollo.QueryHookOptions<GetIndividualAssetQuery, GetIndividualAssetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndividualAssetQuery, GetIndividualAssetQueryVariables>(GetIndividualAssetDocument, options);
      }
export function useGetIndividualAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndividualAssetQuery, GetIndividualAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndividualAssetQuery, GetIndividualAssetQueryVariables>(GetIndividualAssetDocument, options);
        }
export function useGetIndividualAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndividualAssetQuery, GetIndividualAssetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndividualAssetQuery, GetIndividualAssetQueryVariables>(GetIndividualAssetDocument, options);
        }
export type GetIndividualAssetQueryHookResult = ReturnType<typeof useGetIndividualAssetQuery>;
export type GetIndividualAssetLazyQueryHookResult = ReturnType<typeof useGetIndividualAssetLazyQuery>;
export type GetIndividualAssetSuspenseQueryHookResult = ReturnType<typeof useGetIndividualAssetSuspenseQuery>;
export type GetIndividualAssetQueryResult = Apollo.QueryResult<GetIndividualAssetQuery, GetIndividualAssetQueryVariables>;
export const GetNotificationsDocument = gql`
    query GetNotifications($first: Int!, $after: String, $isRead: Boolean, $notificationTypes: [NotificationType!]) {
  notification {
    listNotifications2(
      first: $first
      after: $after
      isRead: $isRead
      notificationTypes: $notificationTypes
    ) {
      nodes {
        notificationId
        receiver {
          userId
        }
        content {
          defaultMessage
          defaultPayload {
            notificationType
            createdAt
            customProperties {
              key
              value
            }
          }
        }
        isRead
        readAt
        createdAt
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    countUnreadNotifications
    activeJobs {
      jobId
      type
      status
      totalCount
      processedCount
      eventId
      startedAt
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      isRead: // value for 'isRead'
 *      notificationTypes: // value for 'notificationTypes'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables> & ({ variables: GetNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetClubOfferBySlugDocument = gql`
    query GetClubOfferBySlug($first: Int, $after: String, $slug: String!, $filter: FilterOfferCriteriaInput) {
  clubBySlug(slug: $slug) {
    offers(first: $first, after: $after, filter: $filter) {
      edges {
        cursor
        node {
          access
          published
          type
        }
      }
      nodes {
        offerId
        access
        published
        type
        rewards {
          avatarUrl
          coverUrl
          description
          name
          quantity
          rewardId
          type
          timeFrameConstraint {
            endDateTime
            expiresDateTime
            startDateTime
            timeFrameType
            timeZoneId
          }
          conditions {
            ... on AchievementsRewardCondition {
              achievements {
                achievementId
                avatarUrl
                description
                name
                type
              }
              type
            }
            ... on LoyaltyTierRewardCondition {
              loyaltyTiersByClub {
                club {
                  clubId
                  name
                  images {
                    background
                  }
                  tiers {
                    backgroundImageUrl
                    colors {
                      background
                      border
                      foreground
                    }
                    description
                    level
                    name
                    title
                  }
                  membership {
                    tier {
                      level
                      name
                      title
                    }
                  }
                }
                level
              }
              type
            }
            ... on PriceRewardCondition {
              price
              repPoints
              type
            }
            ... on RepScoreRewardCondition {
              repScore
              type
            }
            ... on RepPointsRewardCondition {
              repPointsByClub {
                club {
                  clubId
                  name
                  images {
                    background
                  }
                  tiers {
                    backgroundImageUrl
                    colors {
                      background
                      border
                      foreground
                    }
                    description
                    level
                    name
                    title
                  }
                }
                repPoints
              }
              type
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    clubId
  }
}
    `;

/**
 * __useGetClubOfferBySlugQuery__
 *
 * To run a query within a React component, call `useGetClubOfferBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubOfferBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubOfferBySlugQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      slug: // value for 'slug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetClubOfferBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetClubOfferBySlugQuery, GetClubOfferBySlugQueryVariables> & ({ variables: GetClubOfferBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubOfferBySlugQuery, GetClubOfferBySlugQueryVariables>(GetClubOfferBySlugDocument, options);
      }
export function useGetClubOfferBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubOfferBySlugQuery, GetClubOfferBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubOfferBySlugQuery, GetClubOfferBySlugQueryVariables>(GetClubOfferBySlugDocument, options);
        }
export function useGetClubOfferBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubOfferBySlugQuery, GetClubOfferBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubOfferBySlugQuery, GetClubOfferBySlugQueryVariables>(GetClubOfferBySlugDocument, options);
        }
export type GetClubOfferBySlugQueryHookResult = ReturnType<typeof useGetClubOfferBySlugQuery>;
export type GetClubOfferBySlugLazyQueryHookResult = ReturnType<typeof useGetClubOfferBySlugLazyQuery>;
export type GetClubOfferBySlugSuspenseQueryHookResult = ReturnType<typeof useGetClubOfferBySlugSuspenseQuery>;
export type GetClubOfferBySlugQueryResult = Apollo.QueryResult<GetClubOfferBySlugQuery, GetClubOfferBySlugQueryVariables>;
export const GetClubOfferByIdDocument = gql`
    query GetClubOfferById($slug: String!, $offerId: UUID!) {
  clubBySlug(slug: $slug) {
    offers(filter: {offerId: $offerId}) {
      nodes {
        access
        offerId
        published
        type
        configuration {
          pointsPurchase {
            isDefault
            strategy {
              percentageDiscountStrategy {
                baseCostPerPoint
                discountBuckets {
                  discountPercentage
                  points
                }
              }
            }
          }
        }
        requirements {
          age {
            minimumAge
          }
          membershipAge {
            age
          }
          minimumPoints {
            amount
            class
          }
          notAfter {
            notAfter
          }
          notBefore {
            notBefore
          }
          clubMembership {
            minimumMembershipAge
          }
        }
        rewards {
          avatarUrl
          coverUrl
          description
          name
          quantity
          conditions {
            ... on AchievementsRewardCondition {
              achievements {
                achievementId
                avatarUrl
                description
                name
                type
              }
              type
            }
            ... on LoyaltyTierRewardCondition {
              loyaltyTiersByClub {
                club {
                  clubId
                  name
                  images {
                    background
                  }
                  tiers {
                    backgroundImageUrl
                    colors {
                      background
                      border
                      foreground
                    }
                    description
                    level
                    name
                    title
                  }
                  membership {
                    tier {
                      level
                      name
                      title
                    }
                  }
                }
                level
              }
              type
            }
            ... on PriceRewardCondition {
              price
              repPoints
              type
            }
            ... on RepScoreRewardCondition {
              repScore
              type
            }
            ... on RepPointsRewardCondition {
              repPointsByClub {
                club {
                  clubId
                  name
                  images {
                    background
                  }
                  tiers {
                    backgroundImageUrl
                    colors {
                      background
                      border
                      foreground
                    }
                    description
                    level
                    name
                    title
                  }
                }
                repPoints
              }
              type
            }
          }
          redemption {
            ... on AccessPassRewardRedemption {
              code
              guide
              isGenerated
              note
              redemptionType
            }
            ... on CustomerInformationRewardRedemption {
              guide
              note
              redemptionType
              customerInformationScope {
                isAddressEnabled
                isEmailEnabled
                isNameEnabled
                isPhoneNumberEnabled
                isSocialMediaAccountEnabled
                isUserNameEnabled
                socialMediaAccountScope {
                  apple
                  facebook
                  instagram
                  linkedIn
                  tikTok
                  twitch
                  x
                  youTube
                }
              }
            }
            ... on InviteLinkRewardRedemption {
              guide
              code
              isGenerated
              link
              note
              redemptionType
            }
            ... on PromoCodeRewardRedemption {
              guide
              code
              isGenerated
              note
              redemptionType
            }
            ... on LocationInformationRewardRedemption {
              guide
              note
              redemptionType
              code
              isGenerated
              addressDetails {
                city
                countryCode
                phoneNumber
                postalCode
                state
                streetAddress
              }
            }
          }
          rewardId
          type
          timeFrameConstraint {
            endDateTime
            expiresDateTime
            startDateTime
            timeFrameType
            timeZoneId
          }
          ageConstraint {
            maximumAge
            minimumAge
          }
        }
      }
    }
    clubId
    name
    teamMemberRoles {
      roleId
      user {
        userId
      }
    }
  }
}
    `;

/**
 * __useGetClubOfferByIdQuery__
 *
 * To run a query within a React component, call `useGetClubOfferByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubOfferByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubOfferByIdQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useGetClubOfferByIdQuery(baseOptions: Apollo.QueryHookOptions<GetClubOfferByIdQuery, GetClubOfferByIdQueryVariables> & ({ variables: GetClubOfferByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubOfferByIdQuery, GetClubOfferByIdQueryVariables>(GetClubOfferByIdDocument, options);
      }
export function useGetClubOfferByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubOfferByIdQuery, GetClubOfferByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubOfferByIdQuery, GetClubOfferByIdQueryVariables>(GetClubOfferByIdDocument, options);
        }
export function useGetClubOfferByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubOfferByIdQuery, GetClubOfferByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubOfferByIdQuery, GetClubOfferByIdQueryVariables>(GetClubOfferByIdDocument, options);
        }
export type GetClubOfferByIdQueryHookResult = ReturnType<typeof useGetClubOfferByIdQuery>;
export type GetClubOfferByIdLazyQueryHookResult = ReturnType<typeof useGetClubOfferByIdLazyQuery>;
export type GetClubOfferByIdSuspenseQueryHookResult = ReturnType<typeof useGetClubOfferByIdSuspenseQuery>;
export type GetClubOfferByIdQueryResult = Apollo.QueryResult<GetClubOfferByIdQuery, GetClubOfferByIdQueryVariables>;
export const GetTransactionFeesDocument = gql`
    query GetTransactionFees {
  paypal {
    options {
      clientId
      transactionFees {
        amount
        percentage
      }
      payoutFees {
        percentageSplit
      }
    }
  }
}
    `;

/**
 * __useGetTransactionFeesQuery__
 *
 * To run a query within a React component, call `useGetTransactionFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionFeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransactionFeesQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionFeesQuery, GetTransactionFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionFeesQuery, GetTransactionFeesQueryVariables>(GetTransactionFeesDocument, options);
      }
export function useGetTransactionFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionFeesQuery, GetTransactionFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionFeesQuery, GetTransactionFeesQueryVariables>(GetTransactionFeesDocument, options);
        }
export function useGetTransactionFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionFeesQuery, GetTransactionFeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionFeesQuery, GetTransactionFeesQueryVariables>(GetTransactionFeesDocument, options);
        }
export type GetTransactionFeesQueryHookResult = ReturnType<typeof useGetTransactionFeesQuery>;
export type GetTransactionFeesLazyQueryHookResult = ReturnType<typeof useGetTransactionFeesLazyQuery>;
export type GetTransactionFeesSuspenseQueryHookResult = ReturnType<typeof useGetTransactionFeesSuspenseQuery>;
export type GetTransactionFeesQueryResult = Apollo.QueryResult<GetTransactionFeesQuery, GetTransactionFeesQueryVariables>;
export const GetPieByIdDocument = gql`
    query GetPieById($id: UUID!) {
  pie {
    byId(id: $id) {
      pieId
      slug
      displayName
      bio
      rank
      socialMedia {
        value
        scheme
      }
      isVerified
      issuedSlices
      holdingSlices
      slicesHeld
      individualAssets {
        nodes {
          individualAssetId
          imageUrl
          price {
            symbol
            value
          }
          category
        }
      }
      uploadedAssets {
        nodes {
          uploadedAssetId
          url
          target
        }
      }
      pieAvatarUrl
      rewardList2(first: 50, after: null, onlyActive: true) {
        nodes {
          rewardId
          displayName
          status
          avatarUrl
          bio
          type
          slug
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      slicePrice {
        symbol
        value
      }
      canBuy
      canSell
      canTransfer
      canBeForSale
      createdUtc
      initialOffer {
        maximumPurchaseVolume
        minimumPurchaseVolume
        purchaseMultiple
      }
      createdBy {
        userId
        name
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        userName
        tier
      }
      moderators {
        nodes {
          assignDate
          pieRole
          user {
            userId
            name
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
            isVerified
            userName
            tier
          }
        }
      }
      balance
      totalValue {
        symbol
        value
      }
      floatPercentage
      pieBalance {
        availableSlices
        soldSlices
        sentSlices
        receivedSlices
        slicesOwnedByUsers
      }
      totalMembers
      hasPurchasedPiePreviously
      maxSlices
      userPermissions
    }
  }
}
    `;

/**
 * __useGetPieByIdQuery__
 *
 * To run a query within a React component, call `useGetPieByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPieByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPieByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPieByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPieByIdQuery, GetPieByIdQueryVariables> & ({ variables: GetPieByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPieByIdQuery, GetPieByIdQueryVariables>(GetPieByIdDocument, options);
      }
export function useGetPieByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPieByIdQuery, GetPieByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPieByIdQuery, GetPieByIdQueryVariables>(GetPieByIdDocument, options);
        }
export function useGetPieByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPieByIdQuery, GetPieByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPieByIdQuery, GetPieByIdQueryVariables>(GetPieByIdDocument, options);
        }
export type GetPieByIdQueryHookResult = ReturnType<typeof useGetPieByIdQuery>;
export type GetPieByIdLazyQueryHookResult = ReturnType<typeof useGetPieByIdLazyQuery>;
export type GetPieByIdSuspenseQueryHookResult = ReturnType<typeof useGetPieByIdSuspenseQuery>;
export type GetPieByIdQueryResult = Apollo.QueryResult<GetPieByIdQuery, GetPieByIdQueryVariables>;
export const GetPieBySlugOrIdDocument = gql`
    query GetPieBySlugOrId($slugOrId: String!) {
  pie {
    bySlugOrId(slugOrId: $slugOrId) {
      pieId
      slug
      displayName
      bio
      rank
      socialMedia {
        value
        scheme
      }
      isVerified
      issuedSlices
      holdingSlices
      slicesHeld
      individualAssets {
        nodes {
          individualAssetId
          imageUrl
          price {
            symbol
            value
          }
          category
        }
      }
      uploadedAssets {
        nodes {
          uploadedAssetId
          url
          target
        }
      }
      pieAvatarUrl
      rewardList2(first: 50, after: null, onlyActive: true) {
        nodes {
          rewardId
          displayName
          status
          avatarUrl
          bio
          type
          slug
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      slicePrice {
        symbol
        value
      }
      canBuy
      canSell
      canTransfer
      canBeForSale
      createdUtc
      initialOffer {
        maximumPurchaseVolume
        minimumPurchaseVolume
        purchaseMultiple
      }
      createdBy {
        userId
        name
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        userName
        tier
      }
      balance
      totalValue {
        symbol
        value
      }
      floatPercentage
      pieBalance {
        availableSlices
        soldSlices
        sentSlices
        receivedSlices
        slicesOwnedByUsers
      }
      totalMembers
      hasPurchasedPiePreviously
      wished
      wishersCount
      maxSlices
      userPermissions
    }
  }
}
    `;

/**
 * __useGetPieBySlugOrIdQuery__
 *
 * To run a query within a React component, call `useGetPieBySlugOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPieBySlugOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPieBySlugOrIdQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useGetPieBySlugOrIdQuery(baseOptions: Apollo.QueryHookOptions<GetPieBySlugOrIdQuery, GetPieBySlugOrIdQueryVariables> & ({ variables: GetPieBySlugOrIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPieBySlugOrIdQuery, GetPieBySlugOrIdQueryVariables>(GetPieBySlugOrIdDocument, options);
      }
export function useGetPieBySlugOrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPieBySlugOrIdQuery, GetPieBySlugOrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPieBySlugOrIdQuery, GetPieBySlugOrIdQueryVariables>(GetPieBySlugOrIdDocument, options);
        }
export function useGetPieBySlugOrIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPieBySlugOrIdQuery, GetPieBySlugOrIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPieBySlugOrIdQuery, GetPieBySlugOrIdQueryVariables>(GetPieBySlugOrIdDocument, options);
        }
export type GetPieBySlugOrIdQueryHookResult = ReturnType<typeof useGetPieBySlugOrIdQuery>;
export type GetPieBySlugOrIdLazyQueryHookResult = ReturnType<typeof useGetPieBySlugOrIdLazyQuery>;
export type GetPieBySlugOrIdSuspenseQueryHookResult = ReturnType<typeof useGetPieBySlugOrIdSuspenseQuery>;
export type GetPieBySlugOrIdQueryResult = Apollo.QueryResult<GetPieBySlugOrIdQuery, GetPieBySlugOrIdQueryVariables>;
export const GetPiePublicBySlugOrIdDocument = gql`
    query GetPiePublicBySlugOrId($slugOrId: String!) {
  piePublic {
    bySlugOrId(slugOrId: $slugOrId) {
      pieId
      slug
      displayName
    }
  }
}
    `;

/**
 * __useGetPiePublicBySlugOrIdQuery__
 *
 * To run a query within a React component, call `useGetPiePublicBySlugOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPiePublicBySlugOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPiePublicBySlugOrIdQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useGetPiePublicBySlugOrIdQuery(baseOptions: Apollo.QueryHookOptions<GetPiePublicBySlugOrIdQuery, GetPiePublicBySlugOrIdQueryVariables> & ({ variables: GetPiePublicBySlugOrIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPiePublicBySlugOrIdQuery, GetPiePublicBySlugOrIdQueryVariables>(GetPiePublicBySlugOrIdDocument, options);
      }
export function useGetPiePublicBySlugOrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPiePublicBySlugOrIdQuery, GetPiePublicBySlugOrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPiePublicBySlugOrIdQuery, GetPiePublicBySlugOrIdQueryVariables>(GetPiePublicBySlugOrIdDocument, options);
        }
export function useGetPiePublicBySlugOrIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPiePublicBySlugOrIdQuery, GetPiePublicBySlugOrIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPiePublicBySlugOrIdQuery, GetPiePublicBySlugOrIdQueryVariables>(GetPiePublicBySlugOrIdDocument, options);
        }
export type GetPiePublicBySlugOrIdQueryHookResult = ReturnType<typeof useGetPiePublicBySlugOrIdQuery>;
export type GetPiePublicBySlugOrIdLazyQueryHookResult = ReturnType<typeof useGetPiePublicBySlugOrIdLazyQuery>;
export type GetPiePublicBySlugOrIdSuspenseQueryHookResult = ReturnType<typeof useGetPiePublicBySlugOrIdSuspenseQuery>;
export type GetPiePublicBySlugOrIdQueryResult = Apollo.QueryResult<GetPiePublicBySlugOrIdQuery, GetPiePublicBySlugOrIdQueryVariables>;
export const GetPiesDocument = gql`
    query GetPies($first: Int!, $after: String, $type: PieType, $keyword: String, $repbetsPieFirst: Boolean) {
  pie {
    search2(
      first: $first
      after: $after
      type: $type
      keyword: $keyword
      repbetsPieFirst: $repbetsPieFirst
    ) {
      nodes {
        pieId
        slug
        displayName
        rank
        bio
        pieAvatarUrl
        slicePrice {
          value
        }
        canBeForSale
        issuedSlices
        holdingSlices
        totalUniqueSubscribers
        createdBy {
          userId
          name
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          userName
          tier
        }
        createdUtc
        rewardList2(first: 3, after: null, onlyActive: true) {
          nodes {
            rewardId
            displayName
            status
            avatarUrl
            bio
            type
          }
          totalCount
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        slicesHeld
        pieBalance {
          availableSlices
          soldSlices
          sentSlices
          receivedSlices
          slicesOwnedByUsers
        }
        totalMembers
        wished
        wishersCount
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useGetPiesQuery__
 *
 * To run a query within a React component, call `useGetPiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      type: // value for 'type'
 *      keyword: // value for 'keyword'
 *      repbetsPieFirst: // value for 'repbetsPieFirst'
 *   },
 * });
 */
export function useGetPiesQuery(baseOptions: Apollo.QueryHookOptions<GetPiesQuery, GetPiesQueryVariables> & ({ variables: GetPiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPiesQuery, GetPiesQueryVariables>(GetPiesDocument, options);
      }
export function useGetPiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPiesQuery, GetPiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPiesQuery, GetPiesQueryVariables>(GetPiesDocument, options);
        }
export function useGetPiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPiesQuery, GetPiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPiesQuery, GetPiesQueryVariables>(GetPiesDocument, options);
        }
export type GetPiesQueryHookResult = ReturnType<typeof useGetPiesQuery>;
export type GetPiesLazyQueryHookResult = ReturnType<typeof useGetPiesLazyQuery>;
export type GetPiesSuspenseQueryHookResult = ReturnType<typeof useGetPiesSuspenseQuery>;
export type GetPiesQueryResult = Apollo.QueryResult<GetPiesQuery, GetPiesQueryVariables>;
export const GetSliderPiesDocument = gql`
    query GetSliderPies($first: Int!) {
  pie {
    searchRandom(first: $first) {
      nodes {
        pieId
        slug
        displayName
        rank
        bio
        pieAvatarUrl
        slicePrice {
          value
        }
        canBeForSale
        issuedSlices
        holdingSlices
        totalUniqueSubscribers
        createdBy {
          userId
          name
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          userName
          tier
        }
        createdUtc
        rewardList2(first: 3, after: null, onlyActive: true) {
          nodes {
            rewardId
            displayName
            status
            avatarUrl
            bio
            type
          }
          totalCount
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        slicesHeld
        pieBalance {
          availableSlices
          soldSlices
          sentSlices
          receivedSlices
          slicesOwnedByUsers
        }
        totalMembers
        wished
        wishersCount
      }
      totalCount
    }
  }
}
    `;

/**
 * __useGetSliderPiesQuery__
 *
 * To run a query within a React component, call `useGetSliderPiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSliderPiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSliderPiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetSliderPiesQuery(baseOptions: Apollo.QueryHookOptions<GetSliderPiesQuery, GetSliderPiesQueryVariables> & ({ variables: GetSliderPiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSliderPiesQuery, GetSliderPiesQueryVariables>(GetSliderPiesDocument, options);
      }
export function useGetSliderPiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSliderPiesQuery, GetSliderPiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSliderPiesQuery, GetSliderPiesQueryVariables>(GetSliderPiesDocument, options);
        }
export function useGetSliderPiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSliderPiesQuery, GetSliderPiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSliderPiesQuery, GetSliderPiesQueryVariables>(GetSliderPiesDocument, options);
        }
export type GetSliderPiesQueryHookResult = ReturnType<typeof useGetSliderPiesQuery>;
export type GetSliderPiesLazyQueryHookResult = ReturnType<typeof useGetSliderPiesLazyQuery>;
export type GetSliderPiesSuspenseQueryHookResult = ReturnType<typeof useGetSliderPiesSuspenseQuery>;
export type GetSliderPiesQueryResult = Apollo.QueryResult<GetSliderPiesQuery, GetSliderPiesQueryVariables>;
export const GetRepbetsPieDocument = gql`
    query GetRepbetsPie {
  pie {
    repbets {
      pieId
      slug
      displayName
      rank
      bio
      pieAvatarUrl
      slicePrice {
        value
      }
      canBeForSale
      issuedSlices
      holdingSlices
      totalUniqueSubscribers
      createdBy {
        userId
        name
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        userName
        tier
      }
      createdUtc
      rewardList2(first: 3, after: null, onlyActive: true) {
        nodes {
          rewardId
          displayName
          status
          avatarUrl
          bio
          type
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      slicesHeld
      pieBalance {
        availableSlices
        soldSlices
        sentSlices
        receivedSlices
        slicesOwnedByUsers
      }
      totalMembers
    }
  }
}
    `;

/**
 * __useGetRepbetsPieQuery__
 *
 * To run a query within a React component, call `useGetRepbetsPieQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRepbetsPieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRepbetsPieQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRepbetsPieQuery(baseOptions?: Apollo.QueryHookOptions<GetRepbetsPieQuery, GetRepbetsPieQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRepbetsPieQuery, GetRepbetsPieQueryVariables>(GetRepbetsPieDocument, options);
      }
export function useGetRepbetsPieLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRepbetsPieQuery, GetRepbetsPieQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRepbetsPieQuery, GetRepbetsPieQueryVariables>(GetRepbetsPieDocument, options);
        }
export function useGetRepbetsPieSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRepbetsPieQuery, GetRepbetsPieQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRepbetsPieQuery, GetRepbetsPieQueryVariables>(GetRepbetsPieDocument, options);
        }
export type GetRepbetsPieQueryHookResult = ReturnType<typeof useGetRepbetsPieQuery>;
export type GetRepbetsPieLazyQueryHookResult = ReturnType<typeof useGetRepbetsPieLazyQuery>;
export type GetRepbetsPieSuspenseQueryHookResult = ReturnType<typeof useGetRepbetsPieSuspenseQuery>;
export type GetRepbetsPieQueryResult = Apollo.QueryResult<GetRepbetsPieQuery, GetRepbetsPieQueryVariables>;
export const GetMyPiesDocument = gql`
    query GetMyPies {
  pie {
    myPies {
      nodes {
        pieId
        slug
        displayName
        rank
        bio
        pieAvatarUrl
        truePieAvatarUrl
        slicePrice {
          value
        }
        canBuy
        canSell
        canTransfer
        canBeForSale
        onBoardingProcess
        issuedSlices
        holdingSlices
        totalUniqueSubscribers
        createdBy {
          userId
          name
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          userName
          tier
        }
        createdUtc
        rewardList2 {
          nodes {
            rewardId
            displayName
            status
            avatarUrl
            bio
            type
          }
          totalCount
        }
        slicesHeld
        totalValue {
          symbol
          value
        }
        floatPercentage
        operationalState
        individualAssets {
          nodes {
            individualAssetId
            imageUrl
            price {
              symbol
              value
            }
            category
          }
        }
        pieBalance {
          availableSlices
          soldSlices
          sentSlices
          receivedSlices
          slicesOwnedByUsers
        }
        uploadedAssets {
          nodes {
            uploadedAssetId
            url
            target
          }
        }
        totalMembers
        maxSlices
        userPermissions
        isTransfering
      }
      totalCount
    }
    myModeratorPies {
      nodes {
        pieId
        slug
        displayName
        rank
        bio
        pieAvatarUrl
        truePieAvatarUrl
        slicePrice {
          value
        }
        canBuy
        canSell
        canTransfer
        canBeForSale
        onBoardingProcess
        issuedSlices
        holdingSlices
        totalUniqueSubscribers
        createdBy {
          userId
          name
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          userName
          tier
        }
        createdUtc
        rewardList2 {
          nodes {
            rewardId
            displayName
            status
            avatarUrl
            bio
            type
          }
          totalCount
        }
        slicesHeld
        totalValue {
          symbol
          value
        }
        floatPercentage
        operationalState
        individualAssets {
          nodes {
            individualAssetId
            imageUrl
            price {
              symbol
              value
            }
            category
          }
        }
        pieBalance {
          availableSlices
          soldSlices
          sentSlices
          receivedSlices
          slicesOwnedByUsers
        }
        uploadedAssets {
          nodes {
            uploadedAssetId
            url
            target
          }
        }
        totalMembers
        maxSlices
        userPermissions
      }
      totalCount
    }
  }
}
    `;

/**
 * __useGetMyPiesQuery__
 *
 * To run a query within a React component, call `useGetMyPiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyPiesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyPiesQuery, GetMyPiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPiesQuery, GetMyPiesQueryVariables>(GetMyPiesDocument, options);
      }
export function useGetMyPiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPiesQuery, GetMyPiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPiesQuery, GetMyPiesQueryVariables>(GetMyPiesDocument, options);
        }
export function useGetMyPiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyPiesQuery, GetMyPiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyPiesQuery, GetMyPiesQueryVariables>(GetMyPiesDocument, options);
        }
export type GetMyPiesQueryHookResult = ReturnType<typeof useGetMyPiesQuery>;
export type GetMyPiesLazyQueryHookResult = ReturnType<typeof useGetMyPiesLazyQuery>;
export type GetMyPiesSuspenseQueryHookResult = ReturnType<typeof useGetMyPiesSuspenseQuery>;
export type GetMyPiesQueryResult = Apollo.QueryResult<GetMyPiesQuery, GetMyPiesQueryVariables>;
export const GetPieSalesDocument = gql`
    query GetPieSales($pieId: UUID!, $first: Int!, $after: String, $sortingType: TradingTransactionSortingType, $sortingOrder: PageSortOrder) {
  pie {
    listSales2(
      pieId: $pieId
      first: $first
      after: $after
      sortingType: $sortingType
      sortingOrder: $sortingOrder
    ) {
      nodes {
        transactionId
        type
        user {
          name
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          userId
          userName
        }
        price
        status
        tradeSlices
        totalPrice
        paymentMethod
        createdAtUtc
        pie {
          pieId
          slug
          displayName
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useGetPieSalesQuery__
 *
 * To run a query within a React component, call `useGetPieSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPieSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPieSalesQuery({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortingType: // value for 'sortingType'
 *      sortingOrder: // value for 'sortingOrder'
 *   },
 * });
 */
export function useGetPieSalesQuery(baseOptions: Apollo.QueryHookOptions<GetPieSalesQuery, GetPieSalesQueryVariables> & ({ variables: GetPieSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPieSalesQuery, GetPieSalesQueryVariables>(GetPieSalesDocument, options);
      }
export function useGetPieSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPieSalesQuery, GetPieSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPieSalesQuery, GetPieSalesQueryVariables>(GetPieSalesDocument, options);
        }
export function useGetPieSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPieSalesQuery, GetPieSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPieSalesQuery, GetPieSalesQueryVariables>(GetPieSalesDocument, options);
        }
export type GetPieSalesQueryHookResult = ReturnType<typeof useGetPieSalesQuery>;
export type GetPieSalesLazyQueryHookResult = ReturnType<typeof useGetPieSalesLazyQuery>;
export type GetPieSalesSuspenseQueryHookResult = ReturnType<typeof useGetPieSalesSuspenseQuery>;
export type GetPieSalesQueryResult = Apollo.QueryResult<GetPieSalesQuery, GetPieSalesQueryVariables>;
export const GetNumberOfSlicesOptionsDocument = gql`
    query GetNumberOfSlicesOptions {
  pie {
    numberOfSlicesOptions {
      slice
      price
    }
  }
}
    `;

/**
 * __useGetNumberOfSlicesOptionsQuery__
 *
 * To run a query within a React component, call `useGetNumberOfSlicesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfSlicesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfSlicesOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNumberOfSlicesOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfSlicesOptionsQuery, GetNumberOfSlicesOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfSlicesOptionsQuery, GetNumberOfSlicesOptionsQueryVariables>(GetNumberOfSlicesOptionsDocument, options);
      }
export function useGetNumberOfSlicesOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfSlicesOptionsQuery, GetNumberOfSlicesOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfSlicesOptionsQuery, GetNumberOfSlicesOptionsQueryVariables>(GetNumberOfSlicesOptionsDocument, options);
        }
export function useGetNumberOfSlicesOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfSlicesOptionsQuery, GetNumberOfSlicesOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfSlicesOptionsQuery, GetNumberOfSlicesOptionsQueryVariables>(GetNumberOfSlicesOptionsDocument, options);
        }
export type GetNumberOfSlicesOptionsQueryHookResult = ReturnType<typeof useGetNumberOfSlicesOptionsQuery>;
export type GetNumberOfSlicesOptionsLazyQueryHookResult = ReturnType<typeof useGetNumberOfSlicesOptionsLazyQuery>;
export type GetNumberOfSlicesOptionsSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfSlicesOptionsSuspenseQuery>;
export type GetNumberOfSlicesOptionsQueryResult = Apollo.QueryResult<GetNumberOfSlicesOptionsQuery, GetNumberOfSlicesOptionsQueryVariables>;
export const GetPieSettingsDocument = gql`
    query GetPieSettings {
  pie {
    pieSettings {
      maxNumberOfSlicesForFreePie
    }
  }
}
    `;

/**
 * __useGetPieSettingsQuery__
 *
 * To run a query within a React component, call `useGetPieSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPieSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPieSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPieSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetPieSettingsQuery, GetPieSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPieSettingsQuery, GetPieSettingsQueryVariables>(GetPieSettingsDocument, options);
      }
export function useGetPieSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPieSettingsQuery, GetPieSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPieSettingsQuery, GetPieSettingsQueryVariables>(GetPieSettingsDocument, options);
        }
export function useGetPieSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPieSettingsQuery, GetPieSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPieSettingsQuery, GetPieSettingsQueryVariables>(GetPieSettingsDocument, options);
        }
export type GetPieSettingsQueryHookResult = ReturnType<typeof useGetPieSettingsQuery>;
export type GetPieSettingsLazyQueryHookResult = ReturnType<typeof useGetPieSettingsLazyQuery>;
export type GetPieSettingsSuspenseQueryHookResult = ReturnType<typeof useGetPieSettingsSuspenseQuery>;
export type GetPieSettingsQueryResult = Apollo.QueryResult<GetPieSettingsQuery, GetPieSettingsQueryVariables>;
export const GetDefaultMaxSlicesDocument = gql`
    query GetDefaultMaxSlices {
  pie {
    defaultMaxSlices
  }
}
    `;

/**
 * __useGetDefaultMaxSlicesQuery__
 *
 * To run a query within a React component, call `useGetDefaultMaxSlicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultMaxSlicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultMaxSlicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultMaxSlicesQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultMaxSlicesQuery, GetDefaultMaxSlicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultMaxSlicesQuery, GetDefaultMaxSlicesQueryVariables>(GetDefaultMaxSlicesDocument, options);
      }
export function useGetDefaultMaxSlicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultMaxSlicesQuery, GetDefaultMaxSlicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultMaxSlicesQuery, GetDefaultMaxSlicesQueryVariables>(GetDefaultMaxSlicesDocument, options);
        }
export function useGetDefaultMaxSlicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefaultMaxSlicesQuery, GetDefaultMaxSlicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefaultMaxSlicesQuery, GetDefaultMaxSlicesQueryVariables>(GetDefaultMaxSlicesDocument, options);
        }
export type GetDefaultMaxSlicesQueryHookResult = ReturnType<typeof useGetDefaultMaxSlicesQuery>;
export type GetDefaultMaxSlicesLazyQueryHookResult = ReturnType<typeof useGetDefaultMaxSlicesLazyQuery>;
export type GetDefaultMaxSlicesSuspenseQueryHookResult = ReturnType<typeof useGetDefaultMaxSlicesSuspenseQuery>;
export type GetDefaultMaxSlicesQueryResult = Apollo.QueryResult<GetDefaultMaxSlicesQuery, GetDefaultMaxSlicesQueryVariables>;
export const PublicGetEmailSubscriptionsDocument = gql`
    query PublicGetEmailSubscriptions($emailAddress: String!) {
  public {
    userByEmail(emailAddress: $emailAddress) {
      emailSubscriptions {
        status
        type
      }
    }
  }
}
    `;

/**
 * __usePublicGetEmailSubscriptionsQuery__
 *
 * To run a query within a React component, call `usePublicGetEmailSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicGetEmailSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicGetEmailSubscriptionsQuery({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function usePublicGetEmailSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<PublicGetEmailSubscriptionsQuery, PublicGetEmailSubscriptionsQueryVariables> & ({ variables: PublicGetEmailSubscriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicGetEmailSubscriptionsQuery, PublicGetEmailSubscriptionsQueryVariables>(PublicGetEmailSubscriptionsDocument, options);
      }
export function usePublicGetEmailSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicGetEmailSubscriptionsQuery, PublicGetEmailSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicGetEmailSubscriptionsQuery, PublicGetEmailSubscriptionsQueryVariables>(PublicGetEmailSubscriptionsDocument, options);
        }
export function usePublicGetEmailSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicGetEmailSubscriptionsQuery, PublicGetEmailSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicGetEmailSubscriptionsQuery, PublicGetEmailSubscriptionsQueryVariables>(PublicGetEmailSubscriptionsDocument, options);
        }
export type PublicGetEmailSubscriptionsQueryHookResult = ReturnType<typeof usePublicGetEmailSubscriptionsQuery>;
export type PublicGetEmailSubscriptionsLazyQueryHookResult = ReturnType<typeof usePublicGetEmailSubscriptionsLazyQuery>;
export type PublicGetEmailSubscriptionsSuspenseQueryHookResult = ReturnType<typeof usePublicGetEmailSubscriptionsSuspenseQuery>;
export type PublicGetEmailSubscriptionsQueryResult = Apollo.QueryResult<PublicGetEmailSubscriptionsQuery, PublicGetEmailSubscriptionsQueryVariables>;
export const GetPublicConfigurationDocument = gql`
    query GetPublicConfiguration {
  publicConfiguration {
    paymentProcessor
    defaultTaxName
    defaultTaxPercentage
  }
}
    `;

/**
 * __useGetPublicConfigurationQuery__
 *
 * To run a query within a React component, call `useGetPublicConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublicConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicConfigurationQuery, GetPublicConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicConfigurationQuery, GetPublicConfigurationQueryVariables>(GetPublicConfigurationDocument, options);
      }
export function useGetPublicConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicConfigurationQuery, GetPublicConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicConfigurationQuery, GetPublicConfigurationQueryVariables>(GetPublicConfigurationDocument, options);
        }
export function useGetPublicConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicConfigurationQuery, GetPublicConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicConfigurationQuery, GetPublicConfigurationQueryVariables>(GetPublicConfigurationDocument, options);
        }
export type GetPublicConfigurationQueryHookResult = ReturnType<typeof useGetPublicConfigurationQuery>;
export type GetPublicConfigurationLazyQueryHookResult = ReturnType<typeof useGetPublicConfigurationLazyQuery>;
export type GetPublicConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetPublicConfigurationSuspenseQuery>;
export type GetPublicConfigurationQueryResult = Apollo.QueryResult<GetPublicConfigurationQuery, GetPublicConfigurationQueryVariables>;
export const GetSupportedCurrenciesDocument = gql`
    query GetSupportedCurrencies {
  supportedCurrencies {
    code
    isZeroDecimal
    name
    symbol
  }
}
    `;

/**
 * __useGetSupportedCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetSupportedCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportedCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportedCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetSupportedCurrenciesQuery, GetSupportedCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportedCurrenciesQuery, GetSupportedCurrenciesQueryVariables>(GetSupportedCurrenciesDocument, options);
      }
export function useGetSupportedCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportedCurrenciesQuery, GetSupportedCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportedCurrenciesQuery, GetSupportedCurrenciesQueryVariables>(GetSupportedCurrenciesDocument, options);
        }
export function useGetSupportedCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupportedCurrenciesQuery, GetSupportedCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupportedCurrenciesQuery, GetSupportedCurrenciesQueryVariables>(GetSupportedCurrenciesDocument, options);
        }
export type GetSupportedCurrenciesQueryHookResult = ReturnType<typeof useGetSupportedCurrenciesQuery>;
export type GetSupportedCurrenciesLazyQueryHookResult = ReturnType<typeof useGetSupportedCurrenciesLazyQuery>;
export type GetSupportedCurrenciesSuspenseQueryHookResult = ReturnType<typeof useGetSupportedCurrenciesSuspenseQuery>;
export type GetSupportedCurrenciesQueryResult = Apollo.QueryResult<GetSupportedCurrenciesQuery, GetSupportedCurrenciesQueryVariables>;
export const GetListOfRepClubsDocument = gql`
    query GetListOfRepClubs($first: Int, $after: String) {
  clubs(first: $first, after: $after) {
    nodes {
      access
      canJoin
      clubId
      createdAt
      description
      isMember
      isVerified
      name
      published
      memberCount
      slug
      colors {
        background
        border
        dropShadow
        foreground
      }
      images {
        background
        icon
      }
      tiers {
        description
        level
        name
        colors {
          background
          border
          foreground
        }
        backgroundImageUrl
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetListOfRepClubsQuery__
 *
 * To run a query within a React component, call `useGetListOfRepClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfRepClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListOfRepClubsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetListOfRepClubsQuery(baseOptions?: Apollo.QueryHookOptions<GetListOfRepClubsQuery, GetListOfRepClubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListOfRepClubsQuery, GetListOfRepClubsQueryVariables>(GetListOfRepClubsDocument, options);
      }
export function useGetListOfRepClubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListOfRepClubsQuery, GetListOfRepClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListOfRepClubsQuery, GetListOfRepClubsQueryVariables>(GetListOfRepClubsDocument, options);
        }
export function useGetListOfRepClubsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetListOfRepClubsQuery, GetListOfRepClubsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetListOfRepClubsQuery, GetListOfRepClubsQueryVariables>(GetListOfRepClubsDocument, options);
        }
export type GetListOfRepClubsQueryHookResult = ReturnType<typeof useGetListOfRepClubsQuery>;
export type GetListOfRepClubsLazyQueryHookResult = ReturnType<typeof useGetListOfRepClubsLazyQuery>;
export type GetListOfRepClubsSuspenseQueryHookResult = ReturnType<typeof useGetListOfRepClubsSuspenseQuery>;
export type GetListOfRepClubsQueryResult = Apollo.QueryResult<GetListOfRepClubsQuery, GetListOfRepClubsQueryVariables>;
export const GetSingleClubDocument = gql`
    query GetSingleClub($id: UUID!) {
  club(id: $id) {
    name
    access
    published
    description
    tiers {
      level
      name
      backgroundImageUrl
    }
    membership {
      joinedAt
      tier {
        level
        name
        backgroundImageUrl
      }
    }
  }
}
    `;

/**
 * __useGetSingleClubQuery__
 *
 * To run a query within a React component, call `useGetSingleClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleClubQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleClubQuery(baseOptions: Apollo.QueryHookOptions<GetSingleClubQuery, GetSingleClubQueryVariables> & ({ variables: GetSingleClubQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleClubQuery, GetSingleClubQueryVariables>(GetSingleClubDocument, options);
      }
export function useGetSingleClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleClubQuery, GetSingleClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleClubQuery, GetSingleClubQueryVariables>(GetSingleClubDocument, options);
        }
export function useGetSingleClubSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleClubQuery, GetSingleClubQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleClubQuery, GetSingleClubQueryVariables>(GetSingleClubDocument, options);
        }
export type GetSingleClubQueryHookResult = ReturnType<typeof useGetSingleClubQuery>;
export type GetSingleClubLazyQueryHookResult = ReturnType<typeof useGetSingleClubLazyQuery>;
export type GetSingleClubSuspenseQueryHookResult = ReturnType<typeof useGetSingleClubSuspenseQuery>;
export type GetSingleClubQueryResult = Apollo.QueryResult<GetSingleClubQuery, GetSingleClubQueryVariables>;
export const GetSingleRepClubBySlugDocument = gql`
    query GetSingleRepClubBySlug($slug: String!) {
  clubBySlug(slug: $slug) {
    access
    canJoin
    clubId
    createdAt
    description
    isMember
    isVerified
    name
    published
    memberCount
    slug
    colors {
      background
      border
      dropShadow
      foreground
    }
    images {
      background
      icon
    }
    membership {
      joinedAt
      tier {
        description
        level
        name
        colors {
          background
          border
          foreground
        }
        backgroundImageUrl
      }
    }
    tiers {
      description
      level
      name
      backgroundImageUrl
      colors {
        background
        border
        foreground
      }
    }
    permissions {
      name
      description
    }
  }
}
    `;

/**
 * __useGetSingleRepClubBySlugQuery__
 *
 * To run a query within a React component, call `useGetSingleRepClubBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleRepClubBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleRepClubBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetSingleRepClubBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetSingleRepClubBySlugQuery, GetSingleRepClubBySlugQueryVariables> & ({ variables: GetSingleRepClubBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleRepClubBySlugQuery, GetSingleRepClubBySlugQueryVariables>(GetSingleRepClubBySlugDocument, options);
      }
export function useGetSingleRepClubBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleRepClubBySlugQuery, GetSingleRepClubBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleRepClubBySlugQuery, GetSingleRepClubBySlugQueryVariables>(GetSingleRepClubBySlugDocument, options);
        }
export function useGetSingleRepClubBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleRepClubBySlugQuery, GetSingleRepClubBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleRepClubBySlugQuery, GetSingleRepClubBySlugQueryVariables>(GetSingleRepClubBySlugDocument, options);
        }
export type GetSingleRepClubBySlugQueryHookResult = ReturnType<typeof useGetSingleRepClubBySlugQuery>;
export type GetSingleRepClubBySlugLazyQueryHookResult = ReturnType<typeof useGetSingleRepClubBySlugLazyQuery>;
export type GetSingleRepClubBySlugSuspenseQueryHookResult = ReturnType<typeof useGetSingleRepClubBySlugSuspenseQuery>;
export type GetSingleRepClubBySlugQueryResult = Apollo.QueryResult<GetSingleRepClubBySlugQuery, GetSingleRepClubBySlugQueryVariables>;
export const SearchClubsDocument = gql`
    query SearchClubs($first: Int, $after: String, $keyword: String!) {
  searchClubs(text: $keyword, first: $first, after: $after) {
    nodes {
      access
      canJoin
      clubId
      createdAt
      description
      isMember
      isVerified
      name
      published
      memberCount
      slug
      colors {
        background
        border
        dropShadow
        foreground
      }
      images {
        background
        icon
      }
      membership {
        joinedAt
        tier {
          description
          level
          name
          colors {
            background
            border
            foreground
          }
          backgroundImageUrl
        }
        balances {
          balance
          isTransferable
          class
          name
          symbol
        }
      }
      tiers {
        description
        level
        name
        colors {
          background
          border
          foreground
        }
        backgroundImageUrl
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useSearchClubsQuery__
 *
 * To run a query within a React component, call `useSearchClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClubsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useSearchClubsQuery(baseOptions: Apollo.QueryHookOptions<SearchClubsQuery, SearchClubsQueryVariables> & ({ variables: SearchClubsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchClubsQuery, SearchClubsQueryVariables>(SearchClubsDocument, options);
      }
export function useSearchClubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchClubsQuery, SearchClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchClubsQuery, SearchClubsQueryVariables>(SearchClubsDocument, options);
        }
export function useSearchClubsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchClubsQuery, SearchClubsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchClubsQuery, SearchClubsQueryVariables>(SearchClubsDocument, options);
        }
export type SearchClubsQueryHookResult = ReturnType<typeof useSearchClubsQuery>;
export type SearchClubsLazyQueryHookResult = ReturnType<typeof useSearchClubsLazyQuery>;
export type SearchClubsSuspenseQueryHookResult = ReturnType<typeof useSearchClubsSuspenseQuery>;
export type SearchClubsQueryResult = Apollo.QueryResult<SearchClubsQuery, SearchClubsQueryVariables>;
export const GetUserClubsDocument = gql`
    query GetUserClubs($first: Int, $after: String) {
  me {
    memberships(first: $first, after: $after) {
      nodes {
        balances {
          balance
          isTransferable
          class
          name
          symbol
        }
        club {
          clubId
          name
          slug
          published
          description
          images {
            icon
            background
          }
          isVerified
          tiers {
            description
            level
            name
            backgroundImageUrl
            colors {
              background
              border
              foreground
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    `;

/**
 * __useGetUserClubsQuery__
 *
 * To run a query within a React component, call `useGetUserClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserClubsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetUserClubsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserClubsQuery, GetUserClubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserClubsQuery, GetUserClubsQueryVariables>(GetUserClubsDocument, options);
      }
export function useGetUserClubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserClubsQuery, GetUserClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserClubsQuery, GetUserClubsQueryVariables>(GetUserClubsDocument, options);
        }
export function useGetUserClubsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserClubsQuery, GetUserClubsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserClubsQuery, GetUserClubsQueryVariables>(GetUserClubsDocument, options);
        }
export type GetUserClubsQueryHookResult = ReturnType<typeof useGetUserClubsQuery>;
export type GetUserClubsLazyQueryHookResult = ReturnType<typeof useGetUserClubsLazyQuery>;
export type GetUserClubsSuspenseQueryHookResult = ReturnType<typeof useGetUserClubsSuspenseQuery>;
export type GetUserClubsQueryResult = Apollo.QueryResult<GetUserClubsQuery, GetUserClubsQueryVariables>;
export const GetManagedClubsDocument = gql`
    query GetManagedClubs {
  me {
    managedClubs {
      clubId
      colors {
        foreground
        dropShadow
        border
        background
      }
      createdAt
      description
      images {
        icon
        background
      }
      isVerified
      access
      name
      published
      slug
      isMember
      owner {
        userId
        userName
      }
      teamCollaborators {
        user {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
          userName
        }
        assignDate
        role
      }
      teamMemberRoles {
        roleId
        user {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
          userName
        }
      }
      tiers {
        colors {
          background
          border
          foreground
        }
        description
        level
        name
        backgroundImageUrl
      }
      permissions {
        name
        description
      }
    }
  }
}
    `;

/**
 * __useGetManagedClubsQuery__
 *
 * To run a query within a React component, call `useGetManagedClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagedClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagedClubsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagedClubsQuery(baseOptions?: Apollo.QueryHookOptions<GetManagedClubsQuery, GetManagedClubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagedClubsQuery, GetManagedClubsQueryVariables>(GetManagedClubsDocument, options);
      }
export function useGetManagedClubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagedClubsQuery, GetManagedClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagedClubsQuery, GetManagedClubsQueryVariables>(GetManagedClubsDocument, options);
        }
export function useGetManagedClubsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManagedClubsQuery, GetManagedClubsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManagedClubsQuery, GetManagedClubsQueryVariables>(GetManagedClubsDocument, options);
        }
export type GetManagedClubsQueryHookResult = ReturnType<typeof useGetManagedClubsQuery>;
export type GetManagedClubsLazyQueryHookResult = ReturnType<typeof useGetManagedClubsLazyQuery>;
export type GetManagedClubsSuspenseQueryHookResult = ReturnType<typeof useGetManagedClubsSuspenseQuery>;
export type GetManagedClubsQueryResult = Apollo.QueryResult<GetManagedClubsQuery, GetManagedClubsQueryVariables>;
export const GetClubBySlugDocument = gql`
    query GetClubBySlug($slug: String!) {
  clubBySlug(slug: $slug) {
    clubId
    colors {
      foreground
      dropShadow
      border
      background
    }
    memberCount
    createdAt
    description
    images {
      icon
      background
    }
    isVerified
    access
    name
    published
    slug
    owner {
      avatarUrl
      avatarSource
      instagramAvatarUrl
      tikTokAvatarUrl
      twitchAvatarUrl
      displayNameSource
      instagramDisplayName
      tikTokDisplayName
      twitchDisplayName
      instagramFollowsCount
      tikTokFollowsCount
      twitchFollowsCount
      isVerified
      name
      tier
      userId
      userName
    }
    teamCollaborators {
      user {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        name
        tier
        userId
        userName
      }
      assignDate
      role
    }
    teamMemberRoles {
      roleId
      user {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        name
        tier
        userId
        userName
      }
      role {
        roleName
        permissions
      }
    }
    tiers {
      colors {
        background
        border
        foreground
      }
      requirements {
        minimumPoints {
          amount
        }
      }
      description
      level
      name
      backgroundImageUrl
    }
    permissions {
      name
      description
    }
    visibleRequirements {
      age {
        minimumAge
      }
    }
    permissions {
      name
      description
    }
  }
}
    `;

/**
 * __useGetClubBySlugQuery__
 *
 * To run a query within a React component, call `useGetClubBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetClubBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetClubBySlugQuery, GetClubBySlugQueryVariables> & ({ variables: GetClubBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubBySlugQuery, GetClubBySlugQueryVariables>(GetClubBySlugDocument, options);
      }
export function useGetClubBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubBySlugQuery, GetClubBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubBySlugQuery, GetClubBySlugQueryVariables>(GetClubBySlugDocument, options);
        }
export function useGetClubBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubBySlugQuery, GetClubBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubBySlugQuery, GetClubBySlugQueryVariables>(GetClubBySlugDocument, options);
        }
export type GetClubBySlugQueryHookResult = ReturnType<typeof useGetClubBySlugQuery>;
export type GetClubBySlugLazyQueryHookResult = ReturnType<typeof useGetClubBySlugLazyQuery>;
export type GetClubBySlugSuspenseQueryHookResult = ReturnType<typeof useGetClubBySlugSuspenseQuery>;
export type GetClubBySlugQueryResult = Apollo.QueryResult<GetClubBySlugQuery, GetClubBySlugQueryVariables>;
export const GetClubAchievementsBySlugDocument = gql`
    query GetClubAchievementsBySlug($first: Int, $after: String, $slug: String!) {
  clubBySlug(slug: $slug) {
    achievements(first: $first, after: $after) {
      nodes {
        achievementId
        avatarUrl
        description
        name
        type
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
      }
    }
    clubId
  }
}
    `;

/**
 * __useGetClubAchievementsBySlugQuery__
 *
 * To run a query within a React component, call `useGetClubAchievementsBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubAchievementsBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubAchievementsBySlugQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetClubAchievementsBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetClubAchievementsBySlugQuery, GetClubAchievementsBySlugQueryVariables> & ({ variables: GetClubAchievementsBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubAchievementsBySlugQuery, GetClubAchievementsBySlugQueryVariables>(GetClubAchievementsBySlugDocument, options);
      }
export function useGetClubAchievementsBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubAchievementsBySlugQuery, GetClubAchievementsBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubAchievementsBySlugQuery, GetClubAchievementsBySlugQueryVariables>(GetClubAchievementsBySlugDocument, options);
        }
export function useGetClubAchievementsBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubAchievementsBySlugQuery, GetClubAchievementsBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubAchievementsBySlugQuery, GetClubAchievementsBySlugQueryVariables>(GetClubAchievementsBySlugDocument, options);
        }
export type GetClubAchievementsBySlugQueryHookResult = ReturnType<typeof useGetClubAchievementsBySlugQuery>;
export type GetClubAchievementsBySlugLazyQueryHookResult = ReturnType<typeof useGetClubAchievementsBySlugLazyQuery>;
export type GetClubAchievementsBySlugSuspenseQueryHookResult = ReturnType<typeof useGetClubAchievementsBySlugSuspenseQuery>;
export type GetClubAchievementsBySlugQueryResult = Apollo.QueryResult<GetClubAchievementsBySlugQuery, GetClubAchievementsBySlugQueryVariables>;
export const GetDefaultBuyPointsOfferDocument = gql`
    query GetDefaultBuyPointsOffer($slug: String!) {
  clubBySlug(slug: $slug) {
    defaultBuyPointsOffer {
      access
      configuration {
        pointsPurchase {
          isDefault
          strategy {
            percentageDiscountStrategy {
              discountBuckets {
                discountPercentage
                points
              }
              baseCostPerPoint
            }
          }
        }
      }
      offerId
      published
      type
    }
  }
}
    `;

/**
 * __useGetDefaultBuyPointsOfferQuery__
 *
 * To run a query within a React component, call `useGetDefaultBuyPointsOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultBuyPointsOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultBuyPointsOfferQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetDefaultBuyPointsOfferQuery(baseOptions: Apollo.QueryHookOptions<GetDefaultBuyPointsOfferQuery, GetDefaultBuyPointsOfferQueryVariables> & ({ variables: GetDefaultBuyPointsOfferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultBuyPointsOfferQuery, GetDefaultBuyPointsOfferQueryVariables>(GetDefaultBuyPointsOfferDocument, options);
      }
export function useGetDefaultBuyPointsOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultBuyPointsOfferQuery, GetDefaultBuyPointsOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultBuyPointsOfferQuery, GetDefaultBuyPointsOfferQueryVariables>(GetDefaultBuyPointsOfferDocument, options);
        }
export function useGetDefaultBuyPointsOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefaultBuyPointsOfferQuery, GetDefaultBuyPointsOfferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefaultBuyPointsOfferQuery, GetDefaultBuyPointsOfferQueryVariables>(GetDefaultBuyPointsOfferDocument, options);
        }
export type GetDefaultBuyPointsOfferQueryHookResult = ReturnType<typeof useGetDefaultBuyPointsOfferQuery>;
export type GetDefaultBuyPointsOfferLazyQueryHookResult = ReturnType<typeof useGetDefaultBuyPointsOfferLazyQuery>;
export type GetDefaultBuyPointsOfferSuspenseQueryHookResult = ReturnType<typeof useGetDefaultBuyPointsOfferSuspenseQuery>;
export type GetDefaultBuyPointsOfferQueryResult = Apollo.QueryResult<GetDefaultBuyPointsOfferQuery, GetDefaultBuyPointsOfferQueryVariables>;
export const GetRewardByIdDocument = gql`
    query GetRewardById($id: UUID!) {
  reward {
    byId(id: $id) {
      rewardId
      displayName
      bio
      slug
      createdUtc
      avatarUrl
      individualApiUrl
      mustOwnSlicesAmount
      mustOwnSlicesStartDate
      mustOwnSlicesEndDate
      notes
      redeemCode
      redeemDescription
      redeemType
      ageLimit
      maxWinners
      status
      type
      category
      isHidden
      winnersChosenOption
      expiresAt
      startDate
      endDate
      isStarted
      canShareByParticipants
      needNewSlices
      optInParticipantPrivacyPolicy
      participantPrivacyPolicyTitle
      participantPrivacyPolicyContent
      policyFileUrl
      requireAllAchievements
      listPolicyInfo(after: null, first: 10) {
        nodes {
          policyInfo {
            url
            createdUtc
          }
        }
      }
      geoRangeCondition {
        address
        latitude
        longitude
        isActive
        radius
        locationUnitLengthType
      }
      pie {
        pieId
        slug
        displayName
        createdBy {
          userId
          name
          avatarUrl
          isVerified
          userName
          tier
        }
        balance
        pieBalance {
          availableSlices
        }
        userPermissions
      }
      ownSlicesConditions {
        nodes {
          id
          pieId
          amount
          startDate
          endDate
        }
      }
      achievementBadgeConditions {
        nodes {
          id
          achievementId
          achievement {
            achievementId
            bio
            displayName
            avatarUrl
            createdUtc
            status
            category
            isHidden
            slug
          }
          startDate
          endDate
        }
      }
      winningBoosts {
        nodes {
          id
          key
          score
          type
        }
      }
      bonusAchievements {
        nodes {
          achievementId
          bio
          displayName
          avatarUrl
          createdUtc
          status
          category
          isHidden
          slug
        }
      }
      tickets(first: 100) {
        nodes {
          ticketId
        }
      }
      userRewardInfo {
        userInfo {
          userId
          userName
        }
        userRewardInfo {
          createdUtc
          participateState
          participateReason
          ordinalWinner
          sharedAddress {
            address
            city
            region
            postalCode
            countryCode
          }
          sharedPhoneNumber
          sharedEmailAddress
          socialMediaAccounts {
            isRequired
            scheme
            avatarUrl
            displayName
            profileLink
          }
          sharedName
          confirmSharedUserInfo
          participantPrivacyPolicyState
        }
      }
    }
  }
}
    `;

/**
 * __useGetRewardByIdQuery__
 *
 * To run a query within a React component, call `useGetRewardByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRewardByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRewardByIdQuery, GetRewardByIdQueryVariables> & ({ variables: GetRewardByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewardByIdQuery, GetRewardByIdQueryVariables>(GetRewardByIdDocument, options);
      }
export function useGetRewardByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewardByIdQuery, GetRewardByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewardByIdQuery, GetRewardByIdQueryVariables>(GetRewardByIdDocument, options);
        }
export function useGetRewardByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRewardByIdQuery, GetRewardByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRewardByIdQuery, GetRewardByIdQueryVariables>(GetRewardByIdDocument, options);
        }
export type GetRewardByIdQueryHookResult = ReturnType<typeof useGetRewardByIdQuery>;
export type GetRewardByIdLazyQueryHookResult = ReturnType<typeof useGetRewardByIdLazyQuery>;
export type GetRewardByIdSuspenseQueryHookResult = ReturnType<typeof useGetRewardByIdSuspenseQuery>;
export type GetRewardByIdQueryResult = Apollo.QueryResult<GetRewardByIdQuery, GetRewardByIdQueryVariables>;
export const GetRewardBySlugOrIdDocument = gql`
    query GetRewardBySlugOrId($pieSlugOrId: String!, $rewardSlugOrId: String!) {
  reward {
    bySlugOrId(pieSlugOrId: $pieSlugOrId, rewardSlugOrId: $rewardSlugOrId) {
      rewardId
      displayName
      bio
      slug
      createdUtc
      avatarUrl
      individualApiUrl
      mustOwnSlicesAmount
      mustOwnSlicesStartDate
      mustOwnSlicesEndDate
      notes
      redeemCode
      redeemDescription
      redeemType
      ageLimit
      maxWinners
      status
      type
      category
      isHidden
      winnersChosenOption
      expiresAt
      startDate
      endDate
      isStarted
      canShareByParticipants
      needNewSlices
      optInParticipantPrivacyPolicy
      participantPrivacyPolicyTitle
      participantPrivacyPolicyContent
      policyFileUrl
      requireAllAchievements
      listPolicyInfo(after: null, first: 10) {
        nodes {
          policyInfo {
            url
            createdUtc
          }
        }
      }
      geoRangeCondition {
        address
        latitude
        longitude
        isActive
        radius
        locationUnitLengthType
      }
      pie {
        pieId
        slug
        displayName
        createdBy {
          userId
          name
          avatarUrl
          isVerified
          userName
          tier
        }
        balance
        pieBalance {
          availableSlices
        }
        userPermissions
      }
      ownSlicesConditions {
        nodes {
          id
          pieId
          amount
          startDate
          endDate
        }
      }
      achievementBadgeConditions {
        nodes {
          id
          achievementId
          achievement {
            achievementId
            bio
            displayName
            avatarUrl
            createdUtc
            status
            category
            isHidden
            slug
          }
          startDate
          endDate
        }
      }
      winningBoosts {
        nodes {
          id
          key
          score
          type
        }
      }
      bonusAchievements {
        nodes {
          achievementId
          bio
          displayName
          avatarUrl
          createdUtc
          status
          category
          isHidden
          slug
        }
      }
      tickets(first: 100) {
        nodes {
          ticketId
        }
      }
      userRewardInfo {
        userInfo {
          userId
          userName
        }
        userRewardInfo {
          createdUtc
          participateState
          participateReason
          ordinalWinner
          sharedAddress {
            address
            city
            region
            postalCode
            countryCode
          }
          sharedPhoneNumber
          sharedEmailAddress
          socialMediaAccounts {
            isRequired
            scheme
            avatarUrl
            displayName
            profileLink
          }
          sharedName
          confirmSharedUserInfo
          participantPrivacyPolicyState
        }
      }
    }
  }
}
    `;

/**
 * __useGetRewardBySlugOrIdQuery__
 *
 * To run a query within a React component, call `useGetRewardBySlugOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardBySlugOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardBySlugOrIdQuery({
 *   variables: {
 *      pieSlugOrId: // value for 'pieSlugOrId'
 *      rewardSlugOrId: // value for 'rewardSlugOrId'
 *   },
 * });
 */
export function useGetRewardBySlugOrIdQuery(baseOptions: Apollo.QueryHookOptions<GetRewardBySlugOrIdQuery, GetRewardBySlugOrIdQueryVariables> & ({ variables: GetRewardBySlugOrIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewardBySlugOrIdQuery, GetRewardBySlugOrIdQueryVariables>(GetRewardBySlugOrIdDocument, options);
      }
export function useGetRewardBySlugOrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewardBySlugOrIdQuery, GetRewardBySlugOrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewardBySlugOrIdQuery, GetRewardBySlugOrIdQueryVariables>(GetRewardBySlugOrIdDocument, options);
        }
export function useGetRewardBySlugOrIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRewardBySlugOrIdQuery, GetRewardBySlugOrIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRewardBySlugOrIdQuery, GetRewardBySlugOrIdQueryVariables>(GetRewardBySlugOrIdDocument, options);
        }
export type GetRewardBySlugOrIdQueryHookResult = ReturnType<typeof useGetRewardBySlugOrIdQuery>;
export type GetRewardBySlugOrIdLazyQueryHookResult = ReturnType<typeof useGetRewardBySlugOrIdLazyQuery>;
export type GetRewardBySlugOrIdSuspenseQueryHookResult = ReturnType<typeof useGetRewardBySlugOrIdSuspenseQuery>;
export type GetRewardBySlugOrIdQueryResult = Apollo.QueryResult<GetRewardBySlugOrIdQuery, GetRewardBySlugOrIdQueryVariables>;
export const GetRewardListPolicyReactionBySlugOrIdDocument = gql`
    query GetRewardListPolicyReactionBySlugOrId($pieSlugOrId: String!, $rewardSlugOrId: String!) {
  reward {
    bySlugOrId(pieSlugOrId: $pieSlugOrId, rewardSlugOrId: $rewardSlugOrId) {
      listPolicyReaction(after: null, first: 10) {
        nodes {
          userInfo {
            userId
            name
          }
          reactionInfo {
            userId
            reaction
            reactionTime
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRewardListPolicyReactionBySlugOrIdQuery__
 *
 * To run a query within a React component, call `useGetRewardListPolicyReactionBySlugOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardListPolicyReactionBySlugOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardListPolicyReactionBySlugOrIdQuery({
 *   variables: {
 *      pieSlugOrId: // value for 'pieSlugOrId'
 *      rewardSlugOrId: // value for 'rewardSlugOrId'
 *   },
 * });
 */
export function useGetRewardListPolicyReactionBySlugOrIdQuery(baseOptions: Apollo.QueryHookOptions<GetRewardListPolicyReactionBySlugOrIdQuery, GetRewardListPolicyReactionBySlugOrIdQueryVariables> & ({ variables: GetRewardListPolicyReactionBySlugOrIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewardListPolicyReactionBySlugOrIdQuery, GetRewardListPolicyReactionBySlugOrIdQueryVariables>(GetRewardListPolicyReactionBySlugOrIdDocument, options);
      }
export function useGetRewardListPolicyReactionBySlugOrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewardListPolicyReactionBySlugOrIdQuery, GetRewardListPolicyReactionBySlugOrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewardListPolicyReactionBySlugOrIdQuery, GetRewardListPolicyReactionBySlugOrIdQueryVariables>(GetRewardListPolicyReactionBySlugOrIdDocument, options);
        }
export function useGetRewardListPolicyReactionBySlugOrIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRewardListPolicyReactionBySlugOrIdQuery, GetRewardListPolicyReactionBySlugOrIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRewardListPolicyReactionBySlugOrIdQuery, GetRewardListPolicyReactionBySlugOrIdQueryVariables>(GetRewardListPolicyReactionBySlugOrIdDocument, options);
        }
export type GetRewardListPolicyReactionBySlugOrIdQueryHookResult = ReturnType<typeof useGetRewardListPolicyReactionBySlugOrIdQuery>;
export type GetRewardListPolicyReactionBySlugOrIdLazyQueryHookResult = ReturnType<typeof useGetRewardListPolicyReactionBySlugOrIdLazyQuery>;
export type GetRewardListPolicyReactionBySlugOrIdSuspenseQueryHookResult = ReturnType<typeof useGetRewardListPolicyReactionBySlugOrIdSuspenseQuery>;
export type GetRewardListPolicyReactionBySlugOrIdQueryResult = Apollo.QueryResult<GetRewardListPolicyReactionBySlugOrIdQuery, GetRewardListPolicyReactionBySlugOrIdQueryVariables>;
export const GetRewardsDocument = gql`
    query GetRewards($first: Int!, $after: String, $keyword: String, $participateState: ParticipateState, $participateReason: ParticipateReason, $sortingType: UserRewardSortType, $sortingOrder: PageSortOrder) {
  reward {
    search2(
      first: $first
      after: $after
      keyword: $keyword
      participateState: $participateState
      participateReason: $participateReason
      sortingType: $sortingType
      sortingOrder: $sortingOrder
    ) {
      nodes {
        rewardId
        displayName
        createdUtc
        bio
        slug
        avatarUrl
        status
        type
        category
        winnersChosenOption
        expiresAt
        mustOwnSlicesAmount
        mustOwnSlicesStartDate
        mustOwnSlicesEndDate
        userRewardInfo {
          userRewardInfo {
            participateReason
            participateState
          }
        }
        startDate
        endDate
        pie {
          pieId
          slug
          displayName
          createdBy {
            userId
            name
            avatarUrl
            isVerified
            userName
            tier
          }
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useGetRewardsQuery__
 *
 * To run a query within a React component, call `useGetRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      keyword: // value for 'keyword'
 *      participateState: // value for 'participateState'
 *      participateReason: // value for 'participateReason'
 *      sortingType: // value for 'sortingType'
 *      sortingOrder: // value for 'sortingOrder'
 *   },
 * });
 */
export function useGetRewardsQuery(baseOptions: Apollo.QueryHookOptions<GetRewardsQuery, GetRewardsQueryVariables> & ({ variables: GetRewardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewardsQuery, GetRewardsQueryVariables>(GetRewardsDocument, options);
      }
export function useGetRewardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewardsQuery, GetRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewardsQuery, GetRewardsQueryVariables>(GetRewardsDocument, options);
        }
export function useGetRewardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRewardsQuery, GetRewardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRewardsQuery, GetRewardsQueryVariables>(GetRewardsDocument, options);
        }
export type GetRewardsQueryHookResult = ReturnType<typeof useGetRewardsQuery>;
export type GetRewardsLazyQueryHookResult = ReturnType<typeof useGetRewardsLazyQuery>;
export type GetRewardsSuspenseQueryHookResult = ReturnType<typeof useGetRewardsSuspenseQuery>;
export type GetRewardsQueryResult = Apollo.QueryResult<GetRewardsQuery, GetRewardsQueryVariables>;
export const GetRewardsByPieIdDocument = gql`
    query GetRewardsByPieId($first: Int!, $after: String, $pieId: UUID!, $keyword: String, $rewardLaunchStatus: RewardLaunchStatus) {
  reward {
    listByPieId2(
      first: $first
      after: $after
      pieId: $pieId
      keyword: $keyword
      rewardLaunchStatus: $rewardLaunchStatus
    ) {
      totalUnlockRewardAmount
      rewardList {
        nodes {
          rewardId
          displayName
          createdUtc
          bio
          slug
          avatarUrl
          status
          type
          category
          winnersChosenOption
          expiresAt
          mustOwnSlicesAmount
          mustOwnSlicesStartDate
          mustOwnSlicesEndDate
          startDate
          endDate
          pie {
            pieId
            slug
            displayName
            createdBy {
              userId
              name
              avatarUrl
              isVerified
              userName
              tier
            }
          }
          totalActivatedUserAmount
          totalParticipants(participateStates: [PARTICIPATING, AWARDED])
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}
    `;

/**
 * __useGetRewardsByPieIdQuery__
 *
 * To run a query within a React component, call `useGetRewardsByPieIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardsByPieIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardsByPieIdQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      pieId: // value for 'pieId'
 *      keyword: // value for 'keyword'
 *      rewardLaunchStatus: // value for 'rewardLaunchStatus'
 *   },
 * });
 */
export function useGetRewardsByPieIdQuery(baseOptions: Apollo.QueryHookOptions<GetRewardsByPieIdQuery, GetRewardsByPieIdQueryVariables> & ({ variables: GetRewardsByPieIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewardsByPieIdQuery, GetRewardsByPieIdQueryVariables>(GetRewardsByPieIdDocument, options);
      }
export function useGetRewardsByPieIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewardsByPieIdQuery, GetRewardsByPieIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewardsByPieIdQuery, GetRewardsByPieIdQueryVariables>(GetRewardsByPieIdDocument, options);
        }
export function useGetRewardsByPieIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRewardsByPieIdQuery, GetRewardsByPieIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRewardsByPieIdQuery, GetRewardsByPieIdQueryVariables>(GetRewardsByPieIdDocument, options);
        }
export type GetRewardsByPieIdQueryHookResult = ReturnType<typeof useGetRewardsByPieIdQuery>;
export type GetRewardsByPieIdLazyQueryHookResult = ReturnType<typeof useGetRewardsByPieIdLazyQuery>;
export type GetRewardsByPieIdSuspenseQueryHookResult = ReturnType<typeof useGetRewardsByPieIdSuspenseQuery>;
export type GetRewardsByPieIdQueryResult = Apollo.QueryResult<GetRewardsByPieIdQuery, GetRewardsByPieIdQueryVariables>;
export const GetRewardUsersStatisticByIdDocument = gql`
    query GetRewardUsersStatisticById($id: UUID!, $participateStates: [ParticipateState!]) {
  reward {
    byId(id: $id) {
      activatedUserAgeRangeStatistic(participateStates: $participateStates) {
        ageRangeFrom18To24 {
          totalFemaleAmount
          totalFemaleAmountPercentage
          totalMaleAmount
          totalMaleAmountPercentage
          totalOtherAmount
          totalOtherAmountPercentage
        }
        ageRangeFrom25To34 {
          totalFemaleAmount
          totalFemaleAmountPercentage
          totalMaleAmount
          totalMaleAmountPercentage
          totalOtherAmount
          totalOtherAmountPercentage
        }
        ageRangeFrom35To44 {
          totalFemaleAmount
          totalFemaleAmountPercentage
          totalMaleAmount
          totalMaleAmountPercentage
          totalOtherAmount
          totalOtherAmountPercentage
        }
        ageOver44 {
          totalFemaleAmount
          totalFemaleAmountPercentage
          totalMaleAmount
          totalMaleAmountPercentage
          totalOtherAmount
          totalOtherAmountPercentage
        }
        totalFemaleAmount
        totalFemaleAmountPercentage
        totalMaleAmount
        totalMaleAmountPercentage
        totalOtherAmount
        totalOtherAmountPercentage
      }
    }
  }
}
    `;

/**
 * __useGetRewardUsersStatisticByIdQuery__
 *
 * To run a query within a React component, call `useGetRewardUsersStatisticByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardUsersStatisticByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardUsersStatisticByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      participateStates: // value for 'participateStates'
 *   },
 * });
 */
export function useGetRewardUsersStatisticByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRewardUsersStatisticByIdQuery, GetRewardUsersStatisticByIdQueryVariables> & ({ variables: GetRewardUsersStatisticByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewardUsersStatisticByIdQuery, GetRewardUsersStatisticByIdQueryVariables>(GetRewardUsersStatisticByIdDocument, options);
      }
export function useGetRewardUsersStatisticByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewardUsersStatisticByIdQuery, GetRewardUsersStatisticByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewardUsersStatisticByIdQuery, GetRewardUsersStatisticByIdQueryVariables>(GetRewardUsersStatisticByIdDocument, options);
        }
export function useGetRewardUsersStatisticByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRewardUsersStatisticByIdQuery, GetRewardUsersStatisticByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRewardUsersStatisticByIdQuery, GetRewardUsersStatisticByIdQueryVariables>(GetRewardUsersStatisticByIdDocument, options);
        }
export type GetRewardUsersStatisticByIdQueryHookResult = ReturnType<typeof useGetRewardUsersStatisticByIdQuery>;
export type GetRewardUsersStatisticByIdLazyQueryHookResult = ReturnType<typeof useGetRewardUsersStatisticByIdLazyQuery>;
export type GetRewardUsersStatisticByIdSuspenseQueryHookResult = ReturnType<typeof useGetRewardUsersStatisticByIdSuspenseQuery>;
export type GetRewardUsersStatisticByIdQueryResult = Apollo.QueryResult<GetRewardUsersStatisticByIdQuery, GetRewardUsersStatisticByIdQueryVariables>;
export const GetRewardUsersByIdDocument = gql`
    query GetRewardUsersById($id: UUID!, $first: Int!, $after: String, $sortingType: RewardSortingType, $sortingOrder: PageSortOrder, $keyword: String, $participateStates: [ParticipateState!]) {
  reward {
    byId(id: $id) {
      rewardUsers2(
        first: $first
        after: $after
        sortingType: $sortingType
        sortingOrder: $sortingOrder
        keyword: $keyword
        participateStates: $participateStates
      ) {
        nodes {
          userInfo {
            userId
            isVerified
            name
            gender
            ageRange
            dateOfBirth
            userName
            address {
              address
              city
              region
              postalCode
              countryCode
            }
          }
          userRewardInfo {
            createdUtc
            participateState
            participateReason
            ordinalWinner
            sharedAddress {
              address
              city
              region
              postalCode
              countryCode
            }
            sharedPhoneNumber
            sharedEmailAddress
            socialMediaAccounts {
              isRequired
              scheme
              avatarUrl
              displayName
              profileLink
            }
            sharedName
            confirmSharedUserInfo
          }
          holdingSlices
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}
    `;

/**
 * __useGetRewardUsersByIdQuery__
 *
 * To run a query within a React component, call `useGetRewardUsersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardUsersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardUsersByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortingType: // value for 'sortingType'
 *      sortingOrder: // value for 'sortingOrder'
 *      keyword: // value for 'keyword'
 *      participateStates: // value for 'participateStates'
 *   },
 * });
 */
export function useGetRewardUsersByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRewardUsersByIdQuery, GetRewardUsersByIdQueryVariables> & ({ variables: GetRewardUsersByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewardUsersByIdQuery, GetRewardUsersByIdQueryVariables>(GetRewardUsersByIdDocument, options);
      }
export function useGetRewardUsersByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewardUsersByIdQuery, GetRewardUsersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewardUsersByIdQuery, GetRewardUsersByIdQueryVariables>(GetRewardUsersByIdDocument, options);
        }
export function useGetRewardUsersByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRewardUsersByIdQuery, GetRewardUsersByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRewardUsersByIdQuery, GetRewardUsersByIdQueryVariables>(GetRewardUsersByIdDocument, options);
        }
export type GetRewardUsersByIdQueryHookResult = ReturnType<typeof useGetRewardUsersByIdQuery>;
export type GetRewardUsersByIdLazyQueryHookResult = ReturnType<typeof useGetRewardUsersByIdLazyQuery>;
export type GetRewardUsersByIdSuspenseQueryHookResult = ReturnType<typeof useGetRewardUsersByIdSuspenseQuery>;
export type GetRewardUsersByIdQueryResult = Apollo.QueryResult<GetRewardUsersByIdQuery, GetRewardUsersByIdQueryVariables>;
export const GetRewardParticipantsDocument = gql`
    query GetRewardParticipants($rewardId: UUID!, $participateStates: [ParticipateState!]) {
  reward {
    byId(id: $rewardId) {
      participants(participateStates: $participateStates) {
        achievementEarned
        ageRange
        dateUsed
        gender
        isWinner
        location
        slicePurchaseDate
        unlockDate
        location
        userId
      }
    }
  }
}
    `;

/**
 * __useGetRewardParticipantsQuery__
 *
 * To run a query within a React component, call `useGetRewardParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardParticipantsQuery({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *      participateStates: // value for 'participateStates'
 *   },
 * });
 */
export function useGetRewardParticipantsQuery(baseOptions: Apollo.QueryHookOptions<GetRewardParticipantsQuery, GetRewardParticipantsQueryVariables> & ({ variables: GetRewardParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewardParticipantsQuery, GetRewardParticipantsQueryVariables>(GetRewardParticipantsDocument, options);
      }
export function useGetRewardParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewardParticipantsQuery, GetRewardParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewardParticipantsQuery, GetRewardParticipantsQueryVariables>(GetRewardParticipantsDocument, options);
        }
export function useGetRewardParticipantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRewardParticipantsQuery, GetRewardParticipantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRewardParticipantsQuery, GetRewardParticipantsQueryVariables>(GetRewardParticipantsDocument, options);
        }
export type GetRewardParticipantsQueryHookResult = ReturnType<typeof useGetRewardParticipantsQuery>;
export type GetRewardParticipantsLazyQueryHookResult = ReturnType<typeof useGetRewardParticipantsLazyQuery>;
export type GetRewardParticipantsSuspenseQueryHookResult = ReturnType<typeof useGetRewardParticipantsSuspenseQuery>;
export type GetRewardParticipantsQueryResult = Apollo.QueryResult<GetRewardParticipantsQuery, GetRewardParticipantsQueryVariables>;
export const GetHighestSlicesOfParticipatingRewardsDocument = gql`
    query GetHighestSlicesOfParticipatingRewards($pieId: UUID!) {
  reward {
    getHighestSlicesOfParticipatingRewards(pieId: $pieId)
  }
}
    `;

/**
 * __useGetHighestSlicesOfParticipatingRewardsQuery__
 *
 * To run a query within a React component, call `useGetHighestSlicesOfParticipatingRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHighestSlicesOfParticipatingRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHighestSlicesOfParticipatingRewardsQuery({
 *   variables: {
 *      pieId: // value for 'pieId'
 *   },
 * });
 */
export function useGetHighestSlicesOfParticipatingRewardsQuery(baseOptions: Apollo.QueryHookOptions<GetHighestSlicesOfParticipatingRewardsQuery, GetHighestSlicesOfParticipatingRewardsQueryVariables> & ({ variables: GetHighestSlicesOfParticipatingRewardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHighestSlicesOfParticipatingRewardsQuery, GetHighestSlicesOfParticipatingRewardsQueryVariables>(GetHighestSlicesOfParticipatingRewardsDocument, options);
      }
export function useGetHighestSlicesOfParticipatingRewardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHighestSlicesOfParticipatingRewardsQuery, GetHighestSlicesOfParticipatingRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHighestSlicesOfParticipatingRewardsQuery, GetHighestSlicesOfParticipatingRewardsQueryVariables>(GetHighestSlicesOfParticipatingRewardsDocument, options);
        }
export function useGetHighestSlicesOfParticipatingRewardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHighestSlicesOfParticipatingRewardsQuery, GetHighestSlicesOfParticipatingRewardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHighestSlicesOfParticipatingRewardsQuery, GetHighestSlicesOfParticipatingRewardsQueryVariables>(GetHighestSlicesOfParticipatingRewardsDocument, options);
        }
export type GetHighestSlicesOfParticipatingRewardsQueryHookResult = ReturnType<typeof useGetHighestSlicesOfParticipatingRewardsQuery>;
export type GetHighestSlicesOfParticipatingRewardsLazyQueryHookResult = ReturnType<typeof useGetHighestSlicesOfParticipatingRewardsLazyQuery>;
export type GetHighestSlicesOfParticipatingRewardsSuspenseQueryHookResult = ReturnType<typeof useGetHighestSlicesOfParticipatingRewardsSuspenseQuery>;
export type GetHighestSlicesOfParticipatingRewardsQueryResult = Apollo.QueryResult<GetHighestSlicesOfParticipatingRewardsQuery, GetHighestSlicesOfParticipatingRewardsQueryVariables>;
export const GetHighestSlicesOfParticipateRewardsDocument = gql`
    query GetHighestSlicesOfParticipateRewards($pieId: UUID!) {
  reward {
    getHighestSlicesOfParticipateRewards(pieId: $pieId) {
      slicesOfParticipating
      slicesOfAwarded
    }
  }
}
    `;

/**
 * __useGetHighestSlicesOfParticipateRewardsQuery__
 *
 * To run a query within a React component, call `useGetHighestSlicesOfParticipateRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHighestSlicesOfParticipateRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHighestSlicesOfParticipateRewardsQuery({
 *   variables: {
 *      pieId: // value for 'pieId'
 *   },
 * });
 */
export function useGetHighestSlicesOfParticipateRewardsQuery(baseOptions: Apollo.QueryHookOptions<GetHighestSlicesOfParticipateRewardsQuery, GetHighestSlicesOfParticipateRewardsQueryVariables> & ({ variables: GetHighestSlicesOfParticipateRewardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHighestSlicesOfParticipateRewardsQuery, GetHighestSlicesOfParticipateRewardsQueryVariables>(GetHighestSlicesOfParticipateRewardsDocument, options);
      }
export function useGetHighestSlicesOfParticipateRewardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHighestSlicesOfParticipateRewardsQuery, GetHighestSlicesOfParticipateRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHighestSlicesOfParticipateRewardsQuery, GetHighestSlicesOfParticipateRewardsQueryVariables>(GetHighestSlicesOfParticipateRewardsDocument, options);
        }
export function useGetHighestSlicesOfParticipateRewardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHighestSlicesOfParticipateRewardsQuery, GetHighestSlicesOfParticipateRewardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHighestSlicesOfParticipateRewardsQuery, GetHighestSlicesOfParticipateRewardsQueryVariables>(GetHighestSlicesOfParticipateRewardsDocument, options);
        }
export type GetHighestSlicesOfParticipateRewardsQueryHookResult = ReturnType<typeof useGetHighestSlicesOfParticipateRewardsQuery>;
export type GetHighestSlicesOfParticipateRewardsLazyQueryHookResult = ReturnType<typeof useGetHighestSlicesOfParticipateRewardsLazyQuery>;
export type GetHighestSlicesOfParticipateRewardsSuspenseQueryHookResult = ReturnType<typeof useGetHighestSlicesOfParticipateRewardsSuspenseQuery>;
export type GetHighestSlicesOfParticipateRewardsQueryResult = Apollo.QueryResult<GetHighestSlicesOfParticipateRewardsQuery, GetHighestSlicesOfParticipateRewardsQueryVariables>;
export const CheckRewardSlugAvailabilityDocument = gql`
    query CheckRewardSlugAvailability($pieId: UUID!, $rewardSlug: String!) {
  reward {
    slugAvailable(pieId: $pieId, slug: $rewardSlug)
  }
}
    `;

/**
 * __useCheckRewardSlugAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckRewardSlugAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRewardSlugAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRewardSlugAvailabilityQuery({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      rewardSlug: // value for 'rewardSlug'
 *   },
 * });
 */
export function useCheckRewardSlugAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<CheckRewardSlugAvailabilityQuery, CheckRewardSlugAvailabilityQueryVariables> & ({ variables: CheckRewardSlugAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckRewardSlugAvailabilityQuery, CheckRewardSlugAvailabilityQueryVariables>(CheckRewardSlugAvailabilityDocument, options);
      }
export function useCheckRewardSlugAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckRewardSlugAvailabilityQuery, CheckRewardSlugAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckRewardSlugAvailabilityQuery, CheckRewardSlugAvailabilityQueryVariables>(CheckRewardSlugAvailabilityDocument, options);
        }
export function useCheckRewardSlugAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckRewardSlugAvailabilityQuery, CheckRewardSlugAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckRewardSlugAvailabilityQuery, CheckRewardSlugAvailabilityQueryVariables>(CheckRewardSlugAvailabilityDocument, options);
        }
export type CheckRewardSlugAvailabilityQueryHookResult = ReturnType<typeof useCheckRewardSlugAvailabilityQuery>;
export type CheckRewardSlugAvailabilityLazyQueryHookResult = ReturnType<typeof useCheckRewardSlugAvailabilityLazyQuery>;
export type CheckRewardSlugAvailabilitySuspenseQueryHookResult = ReturnType<typeof useCheckRewardSlugAvailabilitySuspenseQuery>;
export type CheckRewardSlugAvailabilityQueryResult = Apollo.QueryResult<CheckRewardSlugAvailabilityQuery, CheckRewardSlugAvailabilityQueryVariables>;
export const GetNeededSlicesDocument = gql`
    query GetNeededSlices($rewardId: UUID!) {
  reward {
    getNeededSlices(rewardId: $rewardId) {
      pieId
      amount
    }
  }
}
    `;

/**
 * __useGetNeededSlicesQuery__
 *
 * To run a query within a React component, call `useGetNeededSlicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNeededSlicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNeededSlicesQuery({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *   },
 * });
 */
export function useGetNeededSlicesQuery(baseOptions: Apollo.QueryHookOptions<GetNeededSlicesQuery, GetNeededSlicesQueryVariables> & ({ variables: GetNeededSlicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNeededSlicesQuery, GetNeededSlicesQueryVariables>(GetNeededSlicesDocument, options);
      }
export function useGetNeededSlicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNeededSlicesQuery, GetNeededSlicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNeededSlicesQuery, GetNeededSlicesQueryVariables>(GetNeededSlicesDocument, options);
        }
export function useGetNeededSlicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNeededSlicesQuery, GetNeededSlicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNeededSlicesQuery, GetNeededSlicesQueryVariables>(GetNeededSlicesDocument, options);
        }
export type GetNeededSlicesQueryHookResult = ReturnType<typeof useGetNeededSlicesQuery>;
export type GetNeededSlicesLazyQueryHookResult = ReturnType<typeof useGetNeededSlicesLazyQuery>;
export type GetNeededSlicesSuspenseQueryHookResult = ReturnType<typeof useGetNeededSlicesSuspenseQuery>;
export type GetNeededSlicesQueryResult = Apollo.QueryResult<GetNeededSlicesQuery, GetNeededSlicesQueryVariables>;
export const CheckRewardSlugAvailability2Document = gql`
    query CheckRewardSlugAvailability2($pieId: UUID!, $rewardSlug: String!) {
  reward {
    slugAvailable2(slug: $rewardSlug, pieId: $pieId) {
      isAvailable
      objectId
    }
  }
}
    `;

/**
 * __useCheckRewardSlugAvailability2Query__
 *
 * To run a query within a React component, call `useCheckRewardSlugAvailability2Query` and pass it any options that fit your needs.
 * When your component renders, `useCheckRewardSlugAvailability2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRewardSlugAvailability2Query({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      rewardSlug: // value for 'rewardSlug'
 *   },
 * });
 */
export function useCheckRewardSlugAvailability2Query(baseOptions: Apollo.QueryHookOptions<CheckRewardSlugAvailability2Query, CheckRewardSlugAvailability2QueryVariables> & ({ variables: CheckRewardSlugAvailability2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckRewardSlugAvailability2Query, CheckRewardSlugAvailability2QueryVariables>(CheckRewardSlugAvailability2Document, options);
      }
export function useCheckRewardSlugAvailability2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckRewardSlugAvailability2Query, CheckRewardSlugAvailability2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckRewardSlugAvailability2Query, CheckRewardSlugAvailability2QueryVariables>(CheckRewardSlugAvailability2Document, options);
        }
export function useCheckRewardSlugAvailability2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckRewardSlugAvailability2Query, CheckRewardSlugAvailability2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckRewardSlugAvailability2Query, CheckRewardSlugAvailability2QueryVariables>(CheckRewardSlugAvailability2Document, options);
        }
export type CheckRewardSlugAvailability2QueryHookResult = ReturnType<typeof useCheckRewardSlugAvailability2Query>;
export type CheckRewardSlugAvailability2LazyQueryHookResult = ReturnType<typeof useCheckRewardSlugAvailability2LazyQuery>;
export type CheckRewardSlugAvailability2SuspenseQueryHookResult = ReturnType<typeof useCheckRewardSlugAvailability2SuspenseQuery>;
export type CheckRewardSlugAvailability2QueryResult = Apollo.QueryResult<CheckRewardSlugAvailability2Query, CheckRewardSlugAvailability2QueryVariables>;
export const SeriesMemberEventsDocument = gql`
    query SeriesMemberEvents($id: UUID!, $first: Int) {
  eventSeries {
    seriesEvents(id: $id, first: $first) {
      nodes {
        eventId
        displayName
        startDate
        endDate
        timeZone
        avatarUrl
        currency
      }
    }
  }
}
    `;

/**
 * __useSeriesMemberEventsQuery__
 *
 * To run a query within a React component, call `useSeriesMemberEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesMemberEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesMemberEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSeriesMemberEventsQuery(baseOptions: Apollo.QueryHookOptions<SeriesMemberEventsQuery, SeriesMemberEventsQueryVariables> & ({ variables: SeriesMemberEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeriesMemberEventsQuery, SeriesMemberEventsQueryVariables>(SeriesMemberEventsDocument, options);
      }
export function useSeriesMemberEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeriesMemberEventsQuery, SeriesMemberEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeriesMemberEventsQuery, SeriesMemberEventsQueryVariables>(SeriesMemberEventsDocument, options);
        }
export function useSeriesMemberEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeriesMemberEventsQuery, SeriesMemberEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeriesMemberEventsQuery, SeriesMemberEventsQueryVariables>(SeriesMemberEventsDocument, options);
        }
export type SeriesMemberEventsQueryHookResult = ReturnType<typeof useSeriesMemberEventsQuery>;
export type SeriesMemberEventsLazyQueryHookResult = ReturnType<typeof useSeriesMemberEventsLazyQuery>;
export type SeriesMemberEventsSuspenseQueryHookResult = ReturnType<typeof useSeriesMemberEventsSuspenseQuery>;
export type SeriesMemberEventsQueryResult = Apollo.QueryResult<SeriesMemberEventsQuery, SeriesMemberEventsQueryVariables>;
export const RevenueSeriesScopeDocument = gql`
    query RevenueSeriesScope($id: UUID!, $first: Int) {
  eventSeries {
    series(id: $id) {
      eventSeriesId
      name
      parentEventId
    }
    seriesEvents(id: $id, first: $first) {
      nodes {
        eventId
        displayName
        startDate
        endDate
        timeZone
        avatarUrl
        currency
      }
    }
  }
}
    `;

/**
 * __useRevenueSeriesScopeQuery__
 *
 * To run a query within a React component, call `useRevenueSeriesScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevenueSeriesScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevenueSeriesScopeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRevenueSeriesScopeQuery(baseOptions: Apollo.QueryHookOptions<RevenueSeriesScopeQuery, RevenueSeriesScopeQueryVariables> & ({ variables: RevenueSeriesScopeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RevenueSeriesScopeQuery, RevenueSeriesScopeQueryVariables>(RevenueSeriesScopeDocument, options);
      }
export function useRevenueSeriesScopeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RevenueSeriesScopeQuery, RevenueSeriesScopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RevenueSeriesScopeQuery, RevenueSeriesScopeQueryVariables>(RevenueSeriesScopeDocument, options);
        }
export function useRevenueSeriesScopeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RevenueSeriesScopeQuery, RevenueSeriesScopeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RevenueSeriesScopeQuery, RevenueSeriesScopeQueryVariables>(RevenueSeriesScopeDocument, options);
        }
export type RevenueSeriesScopeQueryHookResult = ReturnType<typeof useRevenueSeriesScopeQuery>;
export type RevenueSeriesScopeLazyQueryHookResult = ReturnType<typeof useRevenueSeriesScopeLazyQuery>;
export type RevenueSeriesScopeSuspenseQueryHookResult = ReturnType<typeof useRevenueSeriesScopeSuspenseQuery>;
export type RevenueSeriesScopeQueryResult = Apollo.QueryResult<RevenueSeriesScopeQuery, RevenueSeriesScopeQueryVariables>;
export const GetTermsConditionsAndPrivacyDocument = gql`
    query GetTermsConditionsAndPrivacy {
  termsAndConditions {
    current {
      version
      termsAndConditionsUrl
      privacyPolicyUrl
      marketingTermsUrl
      createdAtUtc
    }
  }
}
    `;

/**
 * __useGetTermsConditionsAndPrivacyQuery__
 *
 * To run a query within a React component, call `useGetTermsConditionsAndPrivacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsConditionsAndPrivacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsConditionsAndPrivacyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTermsConditionsAndPrivacyQuery(baseOptions?: Apollo.QueryHookOptions<GetTermsConditionsAndPrivacyQuery, GetTermsConditionsAndPrivacyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsConditionsAndPrivacyQuery, GetTermsConditionsAndPrivacyQueryVariables>(GetTermsConditionsAndPrivacyDocument, options);
      }
export function useGetTermsConditionsAndPrivacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsConditionsAndPrivacyQuery, GetTermsConditionsAndPrivacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsConditionsAndPrivacyQuery, GetTermsConditionsAndPrivacyQueryVariables>(GetTermsConditionsAndPrivacyDocument, options);
        }
export function useGetTermsConditionsAndPrivacySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTermsConditionsAndPrivacyQuery, GetTermsConditionsAndPrivacyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTermsConditionsAndPrivacyQuery, GetTermsConditionsAndPrivacyQueryVariables>(GetTermsConditionsAndPrivacyDocument, options);
        }
export type GetTermsConditionsAndPrivacyQueryHookResult = ReturnType<typeof useGetTermsConditionsAndPrivacyQuery>;
export type GetTermsConditionsAndPrivacyLazyQueryHookResult = ReturnType<typeof useGetTermsConditionsAndPrivacyLazyQuery>;
export type GetTermsConditionsAndPrivacySuspenseQueryHookResult = ReturnType<typeof useGetTermsConditionsAndPrivacySuspenseQuery>;
export type GetTermsConditionsAndPrivacyQueryResult = Apollo.QueryResult<GetTermsConditionsAndPrivacyQuery, GetTermsConditionsAndPrivacyQueryVariables>;
export const GetUploadedAssetsDocument = gql`
    query GetUploadedAssets($pieId: UUID!, $target: UploadedAssetTarget, $first: Int!, $after: String) {
  uploadedAsset {
    listByPieId2(pieId: $pieId, target: $target, first: $first, after: $after) {
      nodes {
        uploadedAssetId
        url
        target
        status
        createdUtc
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useGetUploadedAssetsQuery__
 *
 * To run a query within a React component, call `useGetUploadedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadedAssetsQuery({
 *   variables: {
 *      pieId: // value for 'pieId'
 *      target: // value for 'target'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetUploadedAssetsQuery(baseOptions: Apollo.QueryHookOptions<GetUploadedAssetsQuery, GetUploadedAssetsQueryVariables> & ({ variables: GetUploadedAssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadedAssetsQuery, GetUploadedAssetsQueryVariables>(GetUploadedAssetsDocument, options);
      }
export function useGetUploadedAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadedAssetsQuery, GetUploadedAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadedAssetsQuery, GetUploadedAssetsQueryVariables>(GetUploadedAssetsDocument, options);
        }
export function useGetUploadedAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadedAssetsQuery, GetUploadedAssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadedAssetsQuery, GetUploadedAssetsQueryVariables>(GetUploadedAssetsDocument, options);
        }
export type GetUploadedAssetsQueryHookResult = ReturnType<typeof useGetUploadedAssetsQuery>;
export type GetUploadedAssetsLazyQueryHookResult = ReturnType<typeof useGetUploadedAssetsLazyQuery>;
export type GetUploadedAssetsSuspenseQueryHookResult = ReturnType<typeof useGetUploadedAssetsSuspenseQuery>;
export type GetUploadedAssetsQueryResult = Apollo.QueryResult<GetUploadedAssetsQuery, GetUploadedAssetsQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  me {
    userId
    gender
    bio
    isVerified
    tier
    address {
      address
      city
      region
      postalCode
      countryCode
    }
    userName
    name
    avatarUrl
    avatarSource
    instagramAvatarUrl
    tikTokAvatarUrl
    instagramFollowsCount
    tikTokFollowsCount
    twitchAvatarUrl
    twitchFollowsCount
    displayNameSource
    instagramDisplayName
    tikTokDisplayName
    twitchDisplayName
    emailAddress
    verifiedEmailAddress
    phoneNumber
    verifiedPhoneNumber
    dateOfBirth
    countryCode
    socialMedias {
      scheme
      userId
      displayName
      avatarUrl
      profileLink
      username
    }
    payoutAccounts {
      provider
      accountId
      isPrimary
    }
    stripeAccount {
      accountStatus
      hasConnectAccount
    }
    agreeToTermsAndConditions
    isDeleted
    profileCompletionRequired
    canCreatePies
    isInWaitingList
    userInvitesRemaining
    emailSubscriptions {
      status
      type
    }
    walkthrough {
      status
      type
    }
    isSkipMultiFactorAuthentication
    disableSendSms
    enableCreateEvent
    enableCreateContestEvent
    brandedEventId
    brandedUrl
    canProcessPayment
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetUserByIdDocument = gql`
    query GetUserById($id: UUID!) {
  user(id: $id) {
    userId
    isVerified
    tier
    name
    avatarUrl
    userName
    socialMedias {
      scheme
      userId
      displayName
      avatarUrl
      profileLink
      username
    }
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables> & ({ variables: GetUserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdSuspenseQueryHookResult = ReturnType<typeof useGetUserByIdSuspenseQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($keyword: String, $offset: Int, $limit: Int) {
  users(keyword: $keyword, offset: $offset, limit: $limit) {
    nodes {
      userId
      isVerified
      tier
      name
      avatarUrl
      avatarSource
      instagramAvatarUrl
      tikTokAvatarUrl
      twitchAvatarUrl
      displayNameSource
      instagramDisplayName
      tikTokDisplayName
      twitchDisplayName
      instagramFollowsCount
      tikTokFollowsCount
      twitchFollowsCount
      userName
      emailAddress
      socialMediaConnections {
        scheme
        userId
        displayName
        avatarUrl
        profileLink
        username
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions?: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const GetMySocialMediaConnectionsDocument = gql`
    query GetMySocialMediaConnections {
  me {
    socialMediaConnections {
      scheme
      displayName
      avatarUrl
      followsCount
      profileLink
      username
    }
  }
}
    `;

/**
 * __useGetMySocialMediaConnectionsQuery__
 *
 * To run a query within a React component, call `useGetMySocialMediaConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySocialMediaConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySocialMediaConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySocialMediaConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMySocialMediaConnectionsQuery, GetMySocialMediaConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySocialMediaConnectionsQuery, GetMySocialMediaConnectionsQueryVariables>(GetMySocialMediaConnectionsDocument, options);
      }
export function useGetMySocialMediaConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySocialMediaConnectionsQuery, GetMySocialMediaConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySocialMediaConnectionsQuery, GetMySocialMediaConnectionsQueryVariables>(GetMySocialMediaConnectionsDocument, options);
        }
export function useGetMySocialMediaConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySocialMediaConnectionsQuery, GetMySocialMediaConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySocialMediaConnectionsQuery, GetMySocialMediaConnectionsQueryVariables>(GetMySocialMediaConnectionsDocument, options);
        }
export type GetMySocialMediaConnectionsQueryHookResult = ReturnType<typeof useGetMySocialMediaConnectionsQuery>;
export type GetMySocialMediaConnectionsLazyQueryHookResult = ReturnType<typeof useGetMySocialMediaConnectionsLazyQuery>;
export type GetMySocialMediaConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetMySocialMediaConnectionsSuspenseQuery>;
export type GetMySocialMediaConnectionsQueryResult = Apollo.QueryResult<GetMySocialMediaConnectionsQuery, GetMySocialMediaConnectionsQueryVariables>;
export const MyPasskeyCredentialsDocument = gql`
    query MyPasskeyCredentials {
  myPasskeyCredentials {
    userId
    publicKey
    publicKeyCredential {
      id
    }
    aaGuid
    displayName
    lastUsedDate
    regDate
    credType
    credentialId
    signatureCounter
    userHandle
    userName
  }
}
    `;

/**
 * __useMyPasskeyCredentialsQuery__
 *
 * To run a query within a React component, call `useMyPasskeyCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPasskeyCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPasskeyCredentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPasskeyCredentialsQuery(baseOptions?: Apollo.QueryHookOptions<MyPasskeyCredentialsQuery, MyPasskeyCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPasskeyCredentialsQuery, MyPasskeyCredentialsQueryVariables>(MyPasskeyCredentialsDocument, options);
      }
export function useMyPasskeyCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPasskeyCredentialsQuery, MyPasskeyCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPasskeyCredentialsQuery, MyPasskeyCredentialsQueryVariables>(MyPasskeyCredentialsDocument, options);
        }
export function useMyPasskeyCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPasskeyCredentialsQuery, MyPasskeyCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPasskeyCredentialsQuery, MyPasskeyCredentialsQueryVariables>(MyPasskeyCredentialsDocument, options);
        }
export type MyPasskeyCredentialsQueryHookResult = ReturnType<typeof useMyPasskeyCredentialsQuery>;
export type MyPasskeyCredentialsLazyQueryHookResult = ReturnType<typeof useMyPasskeyCredentialsLazyQuery>;
export type MyPasskeyCredentialsSuspenseQueryHookResult = ReturnType<typeof useMyPasskeyCredentialsSuspenseQuery>;
export type MyPasskeyCredentialsQueryResult = Apollo.QueryResult<MyPasskeyCredentialsQuery, MyPasskeyCredentialsQueryVariables>;
export const GetHoldingPiesDocument = gql`
    query GetHoldingPies($first: Int!, $after: String, $sortingOrder: PageSortOrder!, $sortingType: PieSortingType!, $keyword: String) {
  wallet {
    listHoldingPies2(
      first: $first
      after: $after
      sortingOrder: $sortingOrder
      sortingType: $sortingType
      keyword: $keyword
    ) {
      nodes {
        pieId
        slug
        displayName
        createdUtc
        rank
        totalUniqueSubscribers
        slicePrice {
          symbol
          value
        }
        balance
        rewardList2(onlyActive: true) {
          nodes {
            rewardId
            displayName
            status
            avatarUrl
            bio
            type
          }
          totalCount
        }
        createdBy {
          userId
          name
          avatarUrl
          isVerified
          userName
          tier
        }
        pieAvatarUrl
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useGetHoldingPiesQuery__
 *
 * To run a query within a React component, call `useGetHoldingPiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHoldingPiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHoldingPiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortingOrder: // value for 'sortingOrder'
 *      sortingType: // value for 'sortingType'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useGetHoldingPiesQuery(baseOptions: Apollo.QueryHookOptions<GetHoldingPiesQuery, GetHoldingPiesQueryVariables> & ({ variables: GetHoldingPiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHoldingPiesQuery, GetHoldingPiesQueryVariables>(GetHoldingPiesDocument, options);
      }
export function useGetHoldingPiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHoldingPiesQuery, GetHoldingPiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHoldingPiesQuery, GetHoldingPiesQueryVariables>(GetHoldingPiesDocument, options);
        }
export function useGetHoldingPiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHoldingPiesQuery, GetHoldingPiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHoldingPiesQuery, GetHoldingPiesQueryVariables>(GetHoldingPiesDocument, options);
        }
export type GetHoldingPiesQueryHookResult = ReturnType<typeof useGetHoldingPiesQuery>;
export type GetHoldingPiesLazyQueryHookResult = ReturnType<typeof useGetHoldingPiesLazyQuery>;
export type GetHoldingPiesSuspenseQueryHookResult = ReturnType<typeof useGetHoldingPiesSuspenseQuery>;
export type GetHoldingPiesQueryResult = Apollo.QueryResult<GetHoldingPiesQuery, GetHoldingPiesQueryVariables>;
export const GetBalanceDocument = gql`
    query GetBalance {
  wallet {
    listBalance {
      symbol
      balance
      type
    }
  }
}
    `;

/**
 * __useGetBalanceQuery__
 *
 * To run a query within a React component, call `useGetBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBalanceQuery(baseOptions?: Apollo.QueryHookOptions<GetBalanceQuery, GetBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBalanceQuery, GetBalanceQueryVariables>(GetBalanceDocument, options);
      }
export function useGetBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBalanceQuery, GetBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBalanceQuery, GetBalanceQueryVariables>(GetBalanceDocument, options);
        }
export function useGetBalanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBalanceQuery, GetBalanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBalanceQuery, GetBalanceQueryVariables>(GetBalanceDocument, options);
        }
export type GetBalanceQueryHookResult = ReturnType<typeof useGetBalanceQuery>;
export type GetBalanceLazyQueryHookResult = ReturnType<typeof useGetBalanceLazyQuery>;
export type GetBalanceSuspenseQueryHookResult = ReturnType<typeof useGetBalanceSuspenseQuery>;
export type GetBalanceQueryResult = Apollo.QueryResult<GetBalanceQuery, GetBalanceQueryVariables>;
export const GetTradingTransactionsByIdDocument = gql`
    query GetTradingTransactionsById($id: UUID!, $first: Int!, $after: String, $onlyMyTransaction: Boolean) {
  wallet {
    listTradingTransactions2(
      pieId: $id
      first: $first
      after: $after
      onlyMyTransaction: $onlyMyTransaction
    ) {
      nodes {
        type
        pie {
          pieId
          slug
        }
        price
        tradeSlices
        createdAtUtc
        user {
          userId
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useGetTradingTransactionsByIdQuery__
 *
 * To run a query within a React component, call `useGetTradingTransactionsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTradingTransactionsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTradingTransactionsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      onlyMyTransaction: // value for 'onlyMyTransaction'
 *   },
 * });
 */
export function useGetTradingTransactionsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTradingTransactionsByIdQuery, GetTradingTransactionsByIdQueryVariables> & ({ variables: GetTradingTransactionsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTradingTransactionsByIdQuery, GetTradingTransactionsByIdQueryVariables>(GetTradingTransactionsByIdDocument, options);
      }
export function useGetTradingTransactionsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTradingTransactionsByIdQuery, GetTradingTransactionsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTradingTransactionsByIdQuery, GetTradingTransactionsByIdQueryVariables>(GetTradingTransactionsByIdDocument, options);
        }
export function useGetTradingTransactionsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTradingTransactionsByIdQuery, GetTradingTransactionsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTradingTransactionsByIdQuery, GetTradingTransactionsByIdQueryVariables>(GetTradingTransactionsByIdDocument, options);
        }
export type GetTradingTransactionsByIdQueryHookResult = ReturnType<typeof useGetTradingTransactionsByIdQuery>;
export type GetTradingTransactionsByIdLazyQueryHookResult = ReturnType<typeof useGetTradingTransactionsByIdLazyQuery>;
export type GetTradingTransactionsByIdSuspenseQueryHookResult = ReturnType<typeof useGetTradingTransactionsByIdSuspenseQuery>;
export type GetTradingTransactionsByIdQueryResult = Apollo.QueryResult<GetTradingTransactionsByIdQuery, GetTradingTransactionsByIdQueryVariables>;
export const EventsPageSearchEventsDocument = gql`
    query EventsPageSearchEvents($criteria: SearchEventCriteriaInput, $first: Int, $after: String) {
  event {
    search(criteria: $criteria, first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        avatarUrl
        exclusiveAvatarUrl
        displayName
        slug
        eventId
        startDate
        createdBy {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          tier
          userId
          userName
          isVerified
        }
        attendeeInfo {
          attendeeInfo {
            attendeeState
            attendeeRole
            permissions
          }
        }
        mySeriesRoles
        seriesPassAttendeeState
        promoters {
          nodes {
            userId
          }
        }
        coHosts {
          nodes {
            userId
          }
        }
        sponsors {
          nodes {
            userId
          }
        }
        eventTickets {
          nodes {
            price
            repPoints
          }
        }
        timeZone
        clubId
        currency
        eventType
      }
    }
  }
}
    `;

/**
 * __useEventsPageSearchEventsQuery__
 *
 * To run a query within a React component, call `useEventsPageSearchEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsPageSearchEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsPageSearchEventsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEventsPageSearchEventsQuery(baseOptions?: Apollo.QueryHookOptions<EventsPageSearchEventsQuery, EventsPageSearchEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsPageSearchEventsQuery, EventsPageSearchEventsQueryVariables>(EventsPageSearchEventsDocument, options);
      }
export function useEventsPageSearchEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsPageSearchEventsQuery, EventsPageSearchEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsPageSearchEventsQuery, EventsPageSearchEventsQueryVariables>(EventsPageSearchEventsDocument, options);
        }
export function useEventsPageSearchEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsPageSearchEventsQuery, EventsPageSearchEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsPageSearchEventsQuery, EventsPageSearchEventsQueryVariables>(EventsPageSearchEventsDocument, options);
        }
export type EventsPageSearchEventsQueryHookResult = ReturnType<typeof useEventsPageSearchEventsQuery>;
export type EventsPageSearchEventsLazyQueryHookResult = ReturnType<typeof useEventsPageSearchEventsLazyQuery>;
export type EventsPageSearchEventsSuspenseQueryHookResult = ReturnType<typeof useEventsPageSearchEventsSuspenseQuery>;
export type EventsPageSearchEventsQueryResult = Apollo.QueryResult<EventsPageSearchEventsQuery, EventsPageSearchEventsQueryVariables>;
export const EventsPageGetEventDetailsPublicDocument = gql`
    query EventsPageGetEventDetailsPublic($slugOrId: String!) {
  event {
    bySlugOrId(slugOrId: $slugOrId) {
      eventType
      avatarUrl
      exclusiveAvatarUrl
      description
      terms
      faqs
      faqEntries {
        question
        answer
      }
      displayName
      endDate
      eventId
      eventSeriesId
      isSeriesParentEvent
      isPrivate
      ticketTermsPurchasePolicy
      optInShowGuestCount
      slug
      startDate
      waitingTickets
      eventTickets2 {
        isEnabledWishList
        color
        balance {
          availableAmount
        }
        eventTicketId
        isActive
        price
        ticketType
        isPrivate
        optInShowTicketAmount
        additionalGuests
        transactionStatus
        note
        isRequiredApproval
        sortOrder
        actionLabel
        requiresDisclosureSignature
        fulfillmentMethods {
          electronic
          ship
          pickup
        }
      }
      location {
        locationName
        address
        city
        region
        postalCode
        countryCode
        isOnlyVisibleToApprovedAttendees
        latitude
        longitude
      }
      createdBy {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        isVerified
        name
        tier
        userId
        userName
      }
      sponsors {
        nodes {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          isVerified
          name
          tier
          userId
          userName
        }
      }
      coordinators {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        isVerified
        name
        tier
        userId
        userName
      }
      talents {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        isVerified
        name
        tier
        userId
        userName
      }
      talentLineup {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        isVerified
        name
        tier
        userId
        userName
      }
      seriesTeam {
        role
        user {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          isVerified
          name
          tier
          userId
          userName
        }
      }
      attendeeInfo {
        attendeeInfo {
          attendeeState
          contestEntryType
        }
      }
      approvedTickets
      optInAllowPublicEventPagePreview
      isExpired
      isEnded
      canProcessPayment
      paymentProcessor
      totalEventTickets
      timeZone
      optInShowMusicEmbed
      musicEmbedUrl
      currency
    }
  }
}
    `;

/**
 * __useEventsPageGetEventDetailsPublicQuery__
 *
 * To run a query within a React component, call `useEventsPageGetEventDetailsPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsPageGetEventDetailsPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsPageGetEventDetailsPublicQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventsPageGetEventDetailsPublicQuery(baseOptions: Apollo.QueryHookOptions<EventsPageGetEventDetailsPublicQuery, EventsPageGetEventDetailsPublicQueryVariables> & ({ variables: EventsPageGetEventDetailsPublicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsPageGetEventDetailsPublicQuery, EventsPageGetEventDetailsPublicQueryVariables>(EventsPageGetEventDetailsPublicDocument, options);
      }
export function useEventsPageGetEventDetailsPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsPageGetEventDetailsPublicQuery, EventsPageGetEventDetailsPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsPageGetEventDetailsPublicQuery, EventsPageGetEventDetailsPublicQueryVariables>(EventsPageGetEventDetailsPublicDocument, options);
        }
export function useEventsPageGetEventDetailsPublicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsPageGetEventDetailsPublicQuery, EventsPageGetEventDetailsPublicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsPageGetEventDetailsPublicQuery, EventsPageGetEventDetailsPublicQueryVariables>(EventsPageGetEventDetailsPublicDocument, options);
        }
export type EventsPageGetEventDetailsPublicQueryHookResult = ReturnType<typeof useEventsPageGetEventDetailsPublicQuery>;
export type EventsPageGetEventDetailsPublicLazyQueryHookResult = ReturnType<typeof useEventsPageGetEventDetailsPublicLazyQuery>;
export type EventsPageGetEventDetailsPublicSuspenseQueryHookResult = ReturnType<typeof useEventsPageGetEventDetailsPublicSuspenseQuery>;
export type EventsPageGetEventDetailsPublicQueryResult = Apollo.QueryResult<EventsPageGetEventDetailsPublicQuery, EventsPageGetEventDetailsPublicQueryVariables>;
export const EventsPageGetEventDetailsDocument = gql`
    query EventsPageGetEventDetails($slugOrId: String!, $scanEventId: UUID) {
  event {
    bySlugOrId(slugOrId: $slugOrId) {
      eventType
      ageLimit
      avatarUrl
      exclusiveAvatarUrl
      description
      terms
      faqs
      faqEntries {
        question
        answer
      }
      disclosureOrPrivacyPolicyTitle
      disclosureOrPrivacyPolicyFileUrl
      displayName
      endDate
      eventId
      isPrivate
      note
      optInAgeLimit
      optInAllowGuestInviteOthers
      optInDisclosureOrPrivacyPolicy
      requiresDisclosureSignature
      ticketTermsPurchasePolicy
      optInQuestionRequirements
      optInShowGuestCount
      optInShowGuestList
      optInSocialAccountRequirements
      requireSocialAccountConnection
      optInAllowPublicEventPagePreview
      optInLocationRadius
      locationRadius {
        address
        isActive
        latitude
        longitude
        radius
        unitLengthType
      }
      slug
      startDate
      waitingTickets
      tickets {
        firstSeen
        status
        ticketId
        eventTicket {
          color
          ticketType
          eventTicketId
          isPrivate
          note
          price
          additionalGuests
          resetAdditionalGuestsAfterEachEvent
          optInQrCodePass
          requiresDisclosureSignature
        }
        isShareable
        isStaffTicket
        isGuestTicket
        guestOf {
          name
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          userId
        }
        invitedBy {
          name
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          userId
        }
        displayEventTicket {
          eventTicketId
          ticketType
          color
          optInQrCodePass
          requiresDisclosureSignature
        }
        scanZones(eventId: $scanEventId) {
          id
          name
          scanCount
          scannedAtUtc
          scanTimes
          maxScans
          isUnlimitedScans
        }
        isExpired
        expiredAt
        validForEvent {
          eventId
          displayName
          startDate
          endDate
          timeZone
          location {
            locationName
            address
            city
            region
            postalCode
            countryCode
            latitude
            longitude
          }
        }
        associatedUser {
          userId
        }
        plusOneHolder {
          name
          avatarUrl
          avatarSource
          instagramAvatarUrl
          displayNameSource
          instagramDisplayName
          instagramFollowsCount
          userId
        }
        sharedAdditionalGuests {
          guest {
            name
            avatarUrl
            avatarSource
            instagramAvatarUrl
            displayNameSource
            instagramDisplayName
            instagramFollowsCount
            userId
          }
          validForEvent {
            eventId
            displayName
            startDate
            endDate
            timeZone
          }
        }
      }
      eventTickets2 {
        isEnabledWishList
        color
        balance {
          availableAmount
        }
        isFull
        eventTicketId
        isActive
        price
        ticketType
        isPrivate
        specialGuestInfo {
          remainingAmount
        }
        optInShowTicketAmount
        transactionStatus(forEventId: $scanEventId)
        note
        additionalGuests
        isRequiredApproval
        sortOrder
        actionLabel
        requiresDisclosureSignature
        fulfillmentMethods {
          electronic
          ship
          pickup
        }
      }
      location {
        locationName
        address
        city
        region
        postalCode
        countryCode
        isOnlyVisibleToApprovedAttendees
        latitude
        longitude
      }
      questionRequirements {
        isRequired
        question
        showPublicTickets
        showPrivateTickets
        optInSpecificTicketTypes
        ticketTypeIds
      }
      socialAccountRequirements {
        isRequired
        scheme
      }
      createdBy {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        isVerified
        name
        tier
        userId
        userName
        isFollowedByCurrentUser
      }
      promoters {
        nodes {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          isVerified
          name
          tier
          userId
          userName
        }
      }
      coHosts {
        nodes {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          isVerified
          name
          tier
          userId
          userName
        }
      }
      sponsors {
        nodes {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          isVerified
          name
          tier
          userId
          userName
          isFollowedByCurrentUser
        }
      }
      coordinators {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        isVerified
        name
        tier
        userId
        userName
        isFollowedByCurrentUser
      }
      talents {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        isVerified
        name
        tier
        userId
        userName
        isFollowedByCurrentUser
      }
      talentLineup {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        isVerified
        name
        tier
        userId
        userName
        isFollowedByCurrentUser
      }
      seriesTeam {
        role
        user {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          isVerified
          name
          tier
          userId
          userName
          isFollowedByCurrentUser
        }
      }
      attendeeInfo {
        attendeeInfo {
          attendeeState
          contestEntryType
          isContestWinner
          questionRequirementAnswers {
            answer
            question
          }
          privacyPolicyState
          signedDisclosureFileUrl
          signedWaiverFileUrl
        }
      }
      myAchievements {
        avatarUrl
        displayName
      }
      userEventBookings {
        eventTickets {
          eventTicket {
            isPrivate
          }
        }
      }
      approvedTickets
      isExpired
      isEnded
      canProcessPayment
      paymentProcessor
      connectedSocialNetworks
      totalEventTickets
      timeZone
      isInvited
      isSpecialGuest
      optInShowMusicEmbed
      musicEmbedUrl
      pendingRoleInvites
      currency
      eventSeriesId
      isSeriesParentEvent
      seriesPassAttendeeState
    }
  }
}
    `;

/**
 * __useEventsPageGetEventDetailsQuery__
 *
 * To run a query within a React component, call `useEventsPageGetEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsPageGetEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsPageGetEventDetailsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      scanEventId: // value for 'scanEventId'
 *   },
 * });
 */
export function useEventsPageGetEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<EventsPageGetEventDetailsQuery, EventsPageGetEventDetailsQueryVariables> & ({ variables: EventsPageGetEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsPageGetEventDetailsQuery, EventsPageGetEventDetailsQueryVariables>(EventsPageGetEventDetailsDocument, options);
      }
export function useEventsPageGetEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsPageGetEventDetailsQuery, EventsPageGetEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsPageGetEventDetailsQuery, EventsPageGetEventDetailsQueryVariables>(EventsPageGetEventDetailsDocument, options);
        }
export function useEventsPageGetEventDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsPageGetEventDetailsQuery, EventsPageGetEventDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsPageGetEventDetailsQuery, EventsPageGetEventDetailsQueryVariables>(EventsPageGetEventDetailsDocument, options);
        }
export type EventsPageGetEventDetailsQueryHookResult = ReturnType<typeof useEventsPageGetEventDetailsQuery>;
export type EventsPageGetEventDetailsLazyQueryHookResult = ReturnType<typeof useEventsPageGetEventDetailsLazyQuery>;
export type EventsPageGetEventDetailsSuspenseQueryHookResult = ReturnType<typeof useEventsPageGetEventDetailsSuspenseQuery>;
export type EventsPageGetEventDetailsQueryResult = Apollo.QueryResult<EventsPageGetEventDetailsQuery, EventsPageGetEventDetailsQueryVariables>;
export const EventsPageGetEventTicketsDocument = gql`
    query EventsPageGetEventTickets($slugOrId: String!) {
  event {
    bySlugOrId(slugOrId: $slugOrId) {
      tickets {
        firstSeen
        status
        ticketId
        eventTicket {
          color
          ticketType
          eventTicketId
          isPrivate
          note
        }
        isShareable
        isStaffTicket
        displayEventTicket {
          eventTicketId
          ticketType
          color
        }
      }
      eventTickets2 {
        isFull
        eventTicketId
        isActive
        price
        repPoints
        ticketType
      }
    }
  }
}
    `;

/**
 * __useEventsPageGetEventTicketsQuery__
 *
 * To run a query within a React component, call `useEventsPageGetEventTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsPageGetEventTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsPageGetEventTicketsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventsPageGetEventTicketsQuery(baseOptions: Apollo.QueryHookOptions<EventsPageGetEventTicketsQuery, EventsPageGetEventTicketsQueryVariables> & ({ variables: EventsPageGetEventTicketsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsPageGetEventTicketsQuery, EventsPageGetEventTicketsQueryVariables>(EventsPageGetEventTicketsDocument, options);
      }
export function useEventsPageGetEventTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsPageGetEventTicketsQuery, EventsPageGetEventTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsPageGetEventTicketsQuery, EventsPageGetEventTicketsQueryVariables>(EventsPageGetEventTicketsDocument, options);
        }
export function useEventsPageGetEventTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsPageGetEventTicketsQuery, EventsPageGetEventTicketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsPageGetEventTicketsQuery, EventsPageGetEventTicketsQueryVariables>(EventsPageGetEventTicketsDocument, options);
        }
export type EventsPageGetEventTicketsQueryHookResult = ReturnType<typeof useEventsPageGetEventTicketsQuery>;
export type EventsPageGetEventTicketsLazyQueryHookResult = ReturnType<typeof useEventsPageGetEventTicketsLazyQuery>;
export type EventsPageGetEventTicketsSuspenseQueryHookResult = ReturnType<typeof useEventsPageGetEventTicketsSuspenseQuery>;
export type EventsPageGetEventTicketsQueryResult = Apollo.QueryResult<EventsPageGetEventTicketsQuery, EventsPageGetEventTicketsQueryVariables>;
export const EventsPageGetApprovedAttendeesListDocument = gql`
    query EventsPageGetApprovedAttendeesList($slugOrId: String!, $first: Int, $after: String) {
  event {
    bySlugOrId(slugOrId: $slugOrId) {
      attendeesPage(first: $first, after: $after) {
        nodes {
          userInfo {
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            isVerified
            name
            tier
            userName
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;

/**
 * __useEventsPageGetApprovedAttendeesListQuery__
 *
 * To run a query within a React component, call `useEventsPageGetApprovedAttendeesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsPageGetApprovedAttendeesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsPageGetApprovedAttendeesListQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEventsPageGetApprovedAttendeesListQuery(baseOptions: Apollo.QueryHookOptions<EventsPageGetApprovedAttendeesListQuery, EventsPageGetApprovedAttendeesListQueryVariables> & ({ variables: EventsPageGetApprovedAttendeesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsPageGetApprovedAttendeesListQuery, EventsPageGetApprovedAttendeesListQueryVariables>(EventsPageGetApprovedAttendeesListDocument, options);
      }
export function useEventsPageGetApprovedAttendeesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsPageGetApprovedAttendeesListQuery, EventsPageGetApprovedAttendeesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsPageGetApprovedAttendeesListQuery, EventsPageGetApprovedAttendeesListQueryVariables>(EventsPageGetApprovedAttendeesListDocument, options);
        }
export function useEventsPageGetApprovedAttendeesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsPageGetApprovedAttendeesListQuery, EventsPageGetApprovedAttendeesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsPageGetApprovedAttendeesListQuery, EventsPageGetApprovedAttendeesListQueryVariables>(EventsPageGetApprovedAttendeesListDocument, options);
        }
export type EventsPageGetApprovedAttendeesListQueryHookResult = ReturnType<typeof useEventsPageGetApprovedAttendeesListQuery>;
export type EventsPageGetApprovedAttendeesListLazyQueryHookResult = ReturnType<typeof useEventsPageGetApprovedAttendeesListLazyQuery>;
export type EventsPageGetApprovedAttendeesListSuspenseQueryHookResult = ReturnType<typeof useEventsPageGetApprovedAttendeesListSuspenseQuery>;
export type EventsPageGetApprovedAttendeesListQueryResult = Apollo.QueryResult<EventsPageGetApprovedAttendeesListQuery, EventsPageGetApprovedAttendeesListQueryVariables>;
export const EventsPageGetEventCommentsDocument = gql`
    query EventsPageGetEventComments($slugOrId: String!) {
  event {
    bySlugOrId(slugOrId: $slugOrId) {
      comments {
        nodes {
          comment
          commentId
          createdAt
          medias
          reactions {
            reaction
            reactionId
            user {
              userId
            }
          }
          replies {
            nodes {
              comment
              commentId
              createdAt
              medias
              reactions {
                reaction
                reactionId
                user {
                  userId
                }
              }
              user {
                userId
                name
              }
              replies {
                nodes {
                  comment
                  commentId
                  createdAt
                  medias
                  user {
                    userId
                    name
                  }
                  reactions {
                    reaction
                    reactionId
                    user {
                      userId
                    }
                  }
                }
              }
            }
          }
          user {
            userId
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEventsPageGetEventCommentsQuery__
 *
 * To run a query within a React component, call `useEventsPageGetEventCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsPageGetEventCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsPageGetEventCommentsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventsPageGetEventCommentsQuery(baseOptions: Apollo.QueryHookOptions<EventsPageGetEventCommentsQuery, EventsPageGetEventCommentsQueryVariables> & ({ variables: EventsPageGetEventCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsPageGetEventCommentsQuery, EventsPageGetEventCommentsQueryVariables>(EventsPageGetEventCommentsDocument, options);
      }
export function useEventsPageGetEventCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsPageGetEventCommentsQuery, EventsPageGetEventCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsPageGetEventCommentsQuery, EventsPageGetEventCommentsQueryVariables>(EventsPageGetEventCommentsDocument, options);
        }
export function useEventsPageGetEventCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsPageGetEventCommentsQuery, EventsPageGetEventCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsPageGetEventCommentsQuery, EventsPageGetEventCommentsQueryVariables>(EventsPageGetEventCommentsDocument, options);
        }
export type EventsPageGetEventCommentsQueryHookResult = ReturnType<typeof useEventsPageGetEventCommentsQuery>;
export type EventsPageGetEventCommentsLazyQueryHookResult = ReturnType<typeof useEventsPageGetEventCommentsLazyQuery>;
export type EventsPageGetEventCommentsSuspenseQueryHookResult = ReturnType<typeof useEventsPageGetEventCommentsSuspenseQuery>;
export type EventsPageGetEventCommentsQueryResult = Apollo.QueryResult<EventsPageGetEventCommentsQuery, EventsPageGetEventCommentsQueryVariables>;
export const ContactsInviteGetEventDetailsDocument = gql`
    query ContactsInviteGetEventDetails($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      displayName
      slug
      avatarUrl
      isExpired
      isEnded
      createdBy {
        userId
      }
      coHosts {
        nodes {
          userId
        }
      }
      promoters {
        nodes {
          userId
        }
      }
      attendeeInfo {
        attendeeInfo {
          permissions
        }
      }
      eventTickets {
        nodes {
          eventTicketId
          ticketType
          isPrivate
          isActive
        }
      }
      seriesPassTickets(first: 100) {
        nodes {
          eventTicketId
          ticketType
          isPrivate
          isActive
        }
      }
    }
  }
}
    `;

/**
 * __useContactsInviteGetEventDetailsQuery__
 *
 * To run a query within a React component, call `useContactsInviteGetEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsInviteGetEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsInviteGetEventDetailsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useContactsInviteGetEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<ContactsInviteGetEventDetailsQuery, ContactsInviteGetEventDetailsQueryVariables> & ({ variables: ContactsInviteGetEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsInviteGetEventDetailsQuery, ContactsInviteGetEventDetailsQueryVariables>(ContactsInviteGetEventDetailsDocument, options);
      }
export function useContactsInviteGetEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsInviteGetEventDetailsQuery, ContactsInviteGetEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsInviteGetEventDetailsQuery, ContactsInviteGetEventDetailsQueryVariables>(ContactsInviteGetEventDetailsDocument, options);
        }
export function useContactsInviteGetEventDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsInviteGetEventDetailsQuery, ContactsInviteGetEventDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsInviteGetEventDetailsQuery, ContactsInviteGetEventDetailsQueryVariables>(ContactsInviteGetEventDetailsDocument, options);
        }
export type ContactsInviteGetEventDetailsQueryHookResult = ReturnType<typeof useContactsInviteGetEventDetailsQuery>;
export type ContactsInviteGetEventDetailsLazyQueryHookResult = ReturnType<typeof useContactsInviteGetEventDetailsLazyQuery>;
export type ContactsInviteGetEventDetailsSuspenseQueryHookResult = ReturnType<typeof useContactsInviteGetEventDetailsSuspenseQuery>;
export type ContactsInviteGetEventDetailsQueryResult = Apollo.QueryResult<ContactsInviteGetEventDetailsQuery, ContactsInviteGetEventDetailsQueryVariables>;
export const ContactsInviteEventSearchContactsDocument = gql`
    query ContactsInviteEventSearchContacts($eventId: UUID!, $clubId: UUID, $filterArgs: ContactPageFilterArgsInput!, $first: Int, $after: String) {
  contactList {
    contacts(
      clubId: $clubId
      filterArgs: $filterArgs
      first: $first
      after: $after
      eventId: $eventId
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
      nodes {
        contactId
        emailAddress
        events {
          nodes {
            avatarUrl
            displayName
          }
        }
        invitationStatus(eventId: $eventId)
        inviteInfo(eventId: $eventId) {
          giftTicketName
          giftTicketQuantity
          privateTicketName
          privateTicketQuantity
        }
        inviter(eventId: $eventId) {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          userName
          name
        }
        invitedTickets(eventId: $eventId) {
          invitedAt
          giftEventTicketId
          giftEventTicketName
          giftEventTicketAmount
          privateEventTicketId
          privateEventTicketName
          privateEventTicketAmount
        }
        name
        phoneNumber
        userId
        gender
        dateOfBirth
        userInfo {
          address {
            city
            countryCode
          }
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          userName
          socialMediaConnections {
            displayName
            scheme
            avatarUrl
            profileLink
            username
          }
          gender
          ageRange
          name
        }
      }
    }
  }
}
    `;

/**
 * __useContactsInviteEventSearchContactsQuery__
 *
 * To run a query within a React component, call `useContactsInviteEventSearchContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsInviteEventSearchContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsInviteEventSearchContactsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      clubId: // value for 'clubId'
 *      filterArgs: // value for 'filterArgs'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useContactsInviteEventSearchContactsQuery(baseOptions: Apollo.QueryHookOptions<ContactsInviteEventSearchContactsQuery, ContactsInviteEventSearchContactsQueryVariables> & ({ variables: ContactsInviteEventSearchContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsInviteEventSearchContactsQuery, ContactsInviteEventSearchContactsQueryVariables>(ContactsInviteEventSearchContactsDocument, options);
      }
export function useContactsInviteEventSearchContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsInviteEventSearchContactsQuery, ContactsInviteEventSearchContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsInviteEventSearchContactsQuery, ContactsInviteEventSearchContactsQueryVariables>(ContactsInviteEventSearchContactsDocument, options);
        }
export function useContactsInviteEventSearchContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsInviteEventSearchContactsQuery, ContactsInviteEventSearchContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsInviteEventSearchContactsQuery, ContactsInviteEventSearchContactsQueryVariables>(ContactsInviteEventSearchContactsDocument, options);
        }
export type ContactsInviteEventSearchContactsQueryHookResult = ReturnType<typeof useContactsInviteEventSearchContactsQuery>;
export type ContactsInviteEventSearchContactsLazyQueryHookResult = ReturnType<typeof useContactsInviteEventSearchContactsLazyQuery>;
export type ContactsInviteEventSearchContactsSuspenseQueryHookResult = ReturnType<typeof useContactsInviteEventSearchContactsSuspenseQuery>;
export type ContactsInviteEventSearchContactsQueryResult = Apollo.QueryResult<ContactsInviteEventSearchContactsQuery, ContactsInviteEventSearchContactsQueryVariables>;
export const ContactsInviteOfferSearchContactsDocument = gql`
    query ContactsInviteOfferSearchContacts($offerId: UUID!, $clubId: UUID!, $filterArgs: ContactPageFilterArgsInput!, $first: Int, $after: String) {
  contactList {
    contacts(
      clubId: $clubId
      filterArgs: $filterArgs
      first: $first
      after: $after
      offerId: $offerId
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
      nodes {
        contactId
        emailAddress
        events {
          nodes {
            avatarUrl
            displayName
          }
        }
        offerInvitationStatus(offerId: $offerId, clubId: $clubId)
        offerInviter(offerId: $offerId, clubId: $clubId) {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          userName
          name
        }
        name
        phoneNumber
        userId
        userInfo {
          address {
            city
            countryCode
          }
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          userName
          socialMediaConnections {
            displayName
            scheme
            avatarUrl
            profileLink
            username
          }
          gender
          ageRange
          name
        }
      }
    }
  }
}
    `;

/**
 * __useContactsInviteOfferSearchContactsQuery__
 *
 * To run a query within a React component, call `useContactsInviteOfferSearchContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsInviteOfferSearchContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsInviteOfferSearchContactsQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      clubId: // value for 'clubId'
 *      filterArgs: // value for 'filterArgs'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useContactsInviteOfferSearchContactsQuery(baseOptions: Apollo.QueryHookOptions<ContactsInviteOfferSearchContactsQuery, ContactsInviteOfferSearchContactsQueryVariables> & ({ variables: ContactsInviteOfferSearchContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsInviteOfferSearchContactsQuery, ContactsInviteOfferSearchContactsQueryVariables>(ContactsInviteOfferSearchContactsDocument, options);
      }
export function useContactsInviteOfferSearchContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsInviteOfferSearchContactsQuery, ContactsInviteOfferSearchContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsInviteOfferSearchContactsQuery, ContactsInviteOfferSearchContactsQueryVariables>(ContactsInviteOfferSearchContactsDocument, options);
        }
export function useContactsInviteOfferSearchContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsInviteOfferSearchContactsQuery, ContactsInviteOfferSearchContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsInviteOfferSearchContactsQuery, ContactsInviteOfferSearchContactsQueryVariables>(ContactsInviteOfferSearchContactsDocument, options);
        }
export type ContactsInviteOfferSearchContactsQueryHookResult = ReturnType<typeof useContactsInviteOfferSearchContactsQuery>;
export type ContactsInviteOfferSearchContactsLazyQueryHookResult = ReturnType<typeof useContactsInviteOfferSearchContactsLazyQuery>;
export type ContactsInviteOfferSearchContactsSuspenseQueryHookResult = ReturnType<typeof useContactsInviteOfferSearchContactsSuspenseQuery>;
export type ContactsInviteOfferSearchContactsQueryResult = Apollo.QueryResult<ContactsInviteOfferSearchContactsQuery, ContactsInviteOfferSearchContactsQueryVariables>;
export const ContactsInviteOfferGetClubDetailsDocument = gql`
    query ContactsInviteOfferGetClubDetails($slug: String!) {
  clubBySlug(slug: $slug) {
    clubId
  }
}
    `;

/**
 * __useContactsInviteOfferGetClubDetailsQuery__
 *
 * To run a query within a React component, call `useContactsInviteOfferGetClubDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsInviteOfferGetClubDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsInviteOfferGetClubDetailsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useContactsInviteOfferGetClubDetailsQuery(baseOptions: Apollo.QueryHookOptions<ContactsInviteOfferGetClubDetailsQuery, ContactsInviteOfferGetClubDetailsQueryVariables> & ({ variables: ContactsInviteOfferGetClubDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsInviteOfferGetClubDetailsQuery, ContactsInviteOfferGetClubDetailsQueryVariables>(ContactsInviteOfferGetClubDetailsDocument, options);
      }
export function useContactsInviteOfferGetClubDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsInviteOfferGetClubDetailsQuery, ContactsInviteOfferGetClubDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsInviteOfferGetClubDetailsQuery, ContactsInviteOfferGetClubDetailsQueryVariables>(ContactsInviteOfferGetClubDetailsDocument, options);
        }
export function useContactsInviteOfferGetClubDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsInviteOfferGetClubDetailsQuery, ContactsInviteOfferGetClubDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsInviteOfferGetClubDetailsQuery, ContactsInviteOfferGetClubDetailsQueryVariables>(ContactsInviteOfferGetClubDetailsDocument, options);
        }
export type ContactsInviteOfferGetClubDetailsQueryHookResult = ReturnType<typeof useContactsInviteOfferGetClubDetailsQuery>;
export type ContactsInviteOfferGetClubDetailsLazyQueryHookResult = ReturnType<typeof useContactsInviteOfferGetClubDetailsLazyQuery>;
export type ContactsInviteOfferGetClubDetailsSuspenseQueryHookResult = ReturnType<typeof useContactsInviteOfferGetClubDetailsSuspenseQuery>;
export type ContactsInviteOfferGetClubDetailsQueryResult = Apollo.QueryResult<ContactsInviteOfferGetClubDetailsQuery, ContactsInviteOfferGetClubDetailsQueryVariables>;
export const ContactsInviteOfferGetOfferDetailsDocument = gql`
    query ContactsInviteOfferGetOfferDetails($clubSlug: String!, $offerId: UUID!) {
  clubOffer(clubSlug: $clubSlug, offerId: $offerId) {
    rewardOffer {
      state {
        avatarUrl
        name
      }
    }
  }
}
    `;

/**
 * __useContactsInviteOfferGetOfferDetailsQuery__
 *
 * To run a query within a React component, call `useContactsInviteOfferGetOfferDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsInviteOfferGetOfferDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsInviteOfferGetOfferDetailsQuery({
 *   variables: {
 *      clubSlug: // value for 'clubSlug'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useContactsInviteOfferGetOfferDetailsQuery(baseOptions: Apollo.QueryHookOptions<ContactsInviteOfferGetOfferDetailsQuery, ContactsInviteOfferGetOfferDetailsQueryVariables> & ({ variables: ContactsInviteOfferGetOfferDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsInviteOfferGetOfferDetailsQuery, ContactsInviteOfferGetOfferDetailsQueryVariables>(ContactsInviteOfferGetOfferDetailsDocument, options);
      }
export function useContactsInviteOfferGetOfferDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsInviteOfferGetOfferDetailsQuery, ContactsInviteOfferGetOfferDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsInviteOfferGetOfferDetailsQuery, ContactsInviteOfferGetOfferDetailsQueryVariables>(ContactsInviteOfferGetOfferDetailsDocument, options);
        }
export function useContactsInviteOfferGetOfferDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsInviteOfferGetOfferDetailsQuery, ContactsInviteOfferGetOfferDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsInviteOfferGetOfferDetailsQuery, ContactsInviteOfferGetOfferDetailsQueryVariables>(ContactsInviteOfferGetOfferDetailsDocument, options);
        }
export type ContactsInviteOfferGetOfferDetailsQueryHookResult = ReturnType<typeof useContactsInviteOfferGetOfferDetailsQuery>;
export type ContactsInviteOfferGetOfferDetailsLazyQueryHookResult = ReturnType<typeof useContactsInviteOfferGetOfferDetailsLazyQuery>;
export type ContactsInviteOfferGetOfferDetailsSuspenseQueryHookResult = ReturnType<typeof useContactsInviteOfferGetOfferDetailsSuspenseQuery>;
export type ContactsInviteOfferGetOfferDetailsQueryResult = Apollo.QueryResult<ContactsInviteOfferGetOfferDetailsQuery, ContactsInviteOfferGetOfferDetailsQueryVariables>;
export const ContactsInviteOfferGetMyClubEventsDropdownDocument = gql`
    query ContactsInviteOfferGetMyClubEventsDropdown($clubSlugOrId: String!, $criteria: SearchMyCreatedEventCriteriaInput) {
  event {
    myClubEvents(clubSlugOrId: $clubSlugOrId, criteria: $criteria) {
      nodes {
        avatarUrl
        eventId
        displayName
      }
    }
  }
}
    `;

/**
 * __useContactsInviteOfferGetMyClubEventsDropdownQuery__
 *
 * To run a query within a React component, call `useContactsInviteOfferGetMyClubEventsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsInviteOfferGetMyClubEventsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsInviteOfferGetMyClubEventsDropdownQuery({
 *   variables: {
 *      clubSlugOrId: // value for 'clubSlugOrId'
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useContactsInviteOfferGetMyClubEventsDropdownQuery(baseOptions: Apollo.QueryHookOptions<ContactsInviteOfferGetMyClubEventsDropdownQuery, ContactsInviteOfferGetMyClubEventsDropdownQueryVariables> & ({ variables: ContactsInviteOfferGetMyClubEventsDropdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsInviteOfferGetMyClubEventsDropdownQuery, ContactsInviteOfferGetMyClubEventsDropdownQueryVariables>(ContactsInviteOfferGetMyClubEventsDropdownDocument, options);
      }
export function useContactsInviteOfferGetMyClubEventsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsInviteOfferGetMyClubEventsDropdownQuery, ContactsInviteOfferGetMyClubEventsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsInviteOfferGetMyClubEventsDropdownQuery, ContactsInviteOfferGetMyClubEventsDropdownQueryVariables>(ContactsInviteOfferGetMyClubEventsDropdownDocument, options);
        }
export function useContactsInviteOfferGetMyClubEventsDropdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsInviteOfferGetMyClubEventsDropdownQuery, ContactsInviteOfferGetMyClubEventsDropdownQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsInviteOfferGetMyClubEventsDropdownQuery, ContactsInviteOfferGetMyClubEventsDropdownQueryVariables>(ContactsInviteOfferGetMyClubEventsDropdownDocument, options);
        }
export type ContactsInviteOfferGetMyClubEventsDropdownQueryHookResult = ReturnType<typeof useContactsInviteOfferGetMyClubEventsDropdownQuery>;
export type ContactsInviteOfferGetMyClubEventsDropdownLazyQueryHookResult = ReturnType<typeof useContactsInviteOfferGetMyClubEventsDropdownLazyQuery>;
export type ContactsInviteOfferGetMyClubEventsDropdownSuspenseQueryHookResult = ReturnType<typeof useContactsInviteOfferGetMyClubEventsDropdownSuspenseQuery>;
export type ContactsInviteOfferGetMyClubEventsDropdownQueryResult = Apollo.QueryResult<ContactsInviteOfferGetMyClubEventsDropdownQuery, ContactsInviteOfferGetMyClubEventsDropdownQueryVariables>;
export const ContactsInviteOfferGetOffersDropdownDocument = gql`
    query ContactsInviteOfferGetOffersDropdown($slug: String!, $filter: FilterOfferCriteriaInput) {
  clubBySlug(slug: $slug) {
    offers(filter: $filter) {
      nodes {
        rewardOffer {
          state {
            avatarUrl
            name
          }
        }
        offerId
      }
    }
  }
}
    `;

/**
 * __useContactsInviteOfferGetOffersDropdownQuery__
 *
 * To run a query within a React component, call `useContactsInviteOfferGetOffersDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsInviteOfferGetOffersDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsInviteOfferGetOffersDropdownQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useContactsInviteOfferGetOffersDropdownQuery(baseOptions: Apollo.QueryHookOptions<ContactsInviteOfferGetOffersDropdownQuery, ContactsInviteOfferGetOffersDropdownQueryVariables> & ({ variables: ContactsInviteOfferGetOffersDropdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsInviteOfferGetOffersDropdownQuery, ContactsInviteOfferGetOffersDropdownQueryVariables>(ContactsInviteOfferGetOffersDropdownDocument, options);
      }
export function useContactsInviteOfferGetOffersDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsInviteOfferGetOffersDropdownQuery, ContactsInviteOfferGetOffersDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsInviteOfferGetOffersDropdownQuery, ContactsInviteOfferGetOffersDropdownQueryVariables>(ContactsInviteOfferGetOffersDropdownDocument, options);
        }
export function useContactsInviteOfferGetOffersDropdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsInviteOfferGetOffersDropdownQuery, ContactsInviteOfferGetOffersDropdownQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsInviteOfferGetOffersDropdownQuery, ContactsInviteOfferGetOffersDropdownQueryVariables>(ContactsInviteOfferGetOffersDropdownDocument, options);
        }
export type ContactsInviteOfferGetOffersDropdownQueryHookResult = ReturnType<typeof useContactsInviteOfferGetOffersDropdownQuery>;
export type ContactsInviteOfferGetOffersDropdownLazyQueryHookResult = ReturnType<typeof useContactsInviteOfferGetOffersDropdownLazyQuery>;
export type ContactsInviteOfferGetOffersDropdownSuspenseQueryHookResult = ReturnType<typeof useContactsInviteOfferGetOffersDropdownSuspenseQuery>;
export type ContactsInviteOfferGetOffersDropdownQueryResult = Apollo.QueryResult<ContactsInviteOfferGetOffersDropdownQuery, ContactsInviteOfferGetOffersDropdownQueryVariables>;
export const EventSeriesRolesCatalogDocument = gql`
    query EventSeriesRolesCatalog {
  eventSeries {
    roles {
      roleId
      roleName
      permissions
    }
  }
}
    `;

/**
 * __useEventSeriesRolesCatalogQuery__
 *
 * To run a query within a React component, call `useEventSeriesRolesCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSeriesRolesCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSeriesRolesCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventSeriesRolesCatalogQuery(baseOptions?: Apollo.QueryHookOptions<EventSeriesRolesCatalogQuery, EventSeriesRolesCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventSeriesRolesCatalogQuery, EventSeriesRolesCatalogQueryVariables>(EventSeriesRolesCatalogDocument, options);
      }
export function useEventSeriesRolesCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventSeriesRolesCatalogQuery, EventSeriesRolesCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventSeriesRolesCatalogQuery, EventSeriesRolesCatalogQueryVariables>(EventSeriesRolesCatalogDocument, options);
        }
export function useEventSeriesRolesCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventSeriesRolesCatalogQuery, EventSeriesRolesCatalogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventSeriesRolesCatalogQuery, EventSeriesRolesCatalogQueryVariables>(EventSeriesRolesCatalogDocument, options);
        }
export type EventSeriesRolesCatalogQueryHookResult = ReturnType<typeof useEventSeriesRolesCatalogQuery>;
export type EventSeriesRolesCatalogLazyQueryHookResult = ReturnType<typeof useEventSeriesRolesCatalogLazyQuery>;
export type EventSeriesRolesCatalogSuspenseQueryHookResult = ReturnType<typeof useEventSeriesRolesCatalogSuspenseQuery>;
export type EventSeriesRolesCatalogQueryResult = Apollo.QueryResult<EventSeriesRolesCatalogQuery, EventSeriesRolesCatalogQueryVariables>;
export const SeriesMemberRolesDocument = gql`
    query SeriesMemberRoles($seriesId: UUID!) {
  eventSeries {
    seriesMemberRoles(seriesId: $seriesId) {
      userId
      roleId
      user {
        userId
        userName
        name
        avatarUrl
      }
      role {
        roleId
        roleName
      }
    }
  }
}
    `;

/**
 * __useSeriesMemberRolesQuery__
 *
 * To run a query within a React component, call `useSeriesMemberRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesMemberRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesMemberRolesQuery({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useSeriesMemberRolesQuery(baseOptions: Apollo.QueryHookOptions<SeriesMemberRolesQuery, SeriesMemberRolesQueryVariables> & ({ variables: SeriesMemberRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeriesMemberRolesQuery, SeriesMemberRolesQueryVariables>(SeriesMemberRolesDocument, options);
      }
export function useSeriesMemberRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeriesMemberRolesQuery, SeriesMemberRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeriesMemberRolesQuery, SeriesMemberRolesQueryVariables>(SeriesMemberRolesDocument, options);
        }
export function useSeriesMemberRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeriesMemberRolesQuery, SeriesMemberRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeriesMemberRolesQuery, SeriesMemberRolesQueryVariables>(SeriesMemberRolesDocument, options);
        }
export type SeriesMemberRolesQueryHookResult = ReturnType<typeof useSeriesMemberRolesQuery>;
export type SeriesMemberRolesLazyQueryHookResult = ReturnType<typeof useSeriesMemberRolesLazyQuery>;
export type SeriesMemberRolesSuspenseQueryHookResult = ReturnType<typeof useSeriesMemberRolesSuspenseQuery>;
export type SeriesMemberRolesQueryResult = Apollo.QueryResult<SeriesMemberRolesQuery, SeriesMemberRolesQueryVariables>;
export const PendingSeriesRolesDocument = gql`
    query PendingSeriesRoles($seriesId: UUID!) {
  eventSeries {
    pendingSeriesRoles(seriesId: $seriesId) {
      userId
      email
      roleId
      user {
        userId
        userName
        name
        avatarUrl
      }
      role {
        roleId
        roleName
      }
    }
  }
}
    `;

/**
 * __usePendingSeriesRolesQuery__
 *
 * To run a query within a React component, call `usePendingSeriesRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingSeriesRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingSeriesRolesQuery({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function usePendingSeriesRolesQuery(baseOptions: Apollo.QueryHookOptions<PendingSeriesRolesQuery, PendingSeriesRolesQueryVariables> & ({ variables: PendingSeriesRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingSeriesRolesQuery, PendingSeriesRolesQueryVariables>(PendingSeriesRolesDocument, options);
      }
export function usePendingSeriesRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingSeriesRolesQuery, PendingSeriesRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingSeriesRolesQuery, PendingSeriesRolesQueryVariables>(PendingSeriesRolesDocument, options);
        }
export function usePendingSeriesRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingSeriesRolesQuery, PendingSeriesRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingSeriesRolesQuery, PendingSeriesRolesQueryVariables>(PendingSeriesRolesDocument, options);
        }
export type PendingSeriesRolesQueryHookResult = ReturnType<typeof usePendingSeriesRolesQuery>;
export type PendingSeriesRolesLazyQueryHookResult = ReturnType<typeof usePendingSeriesRolesLazyQuery>;
export type PendingSeriesRolesSuspenseQueryHookResult = ReturnType<typeof usePendingSeriesRolesSuspenseQuery>;
export type PendingSeriesRolesQueryResult = Apollo.QueryResult<PendingSeriesRolesQuery, PendingSeriesRolesQueryVariables>;
export const CreateSeriesDocument = gql`
    mutation CreateSeries($name: String!, $currency: String, $avatarUrl: String) {
  eventSeries {
    createSeries(name: $name, currency: $currency, avatarUrl: $avatarUrl) {
      eventSeriesId
      name
      slug
      memberCount
    }
  }
}
    `;
export type CreateSeriesMutationFn = Apollo.MutationFunction<CreateSeriesMutation, CreateSeriesMutationVariables>;

/**
 * __useCreateSeriesMutation__
 *
 * To run a mutation, you first call `useCreateSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeriesMutation, { data, loading, error }] = useCreateSeriesMutation({
 *   variables: {
 *      name: // value for 'name'
 *      currency: // value for 'currency'
 *      avatarUrl: // value for 'avatarUrl'
 *   },
 * });
 */
export function useCreateSeriesMutation(baseOptions?: Apollo.MutationHookOptions<CreateSeriesMutation, CreateSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSeriesMutation, CreateSeriesMutationVariables>(CreateSeriesDocument, options);
      }
export type CreateSeriesMutationHookResult = ReturnType<typeof useCreateSeriesMutation>;
export type CreateSeriesMutationResult = Apollo.MutationResult<CreateSeriesMutation>;
export type CreateSeriesMutationOptions = Apollo.BaseMutationOptions<CreateSeriesMutation, CreateSeriesMutationVariables>;
export const UpdateSeriesDocument = gql`
    mutation UpdateSeries($seriesId: UUID!, $name: String!, $avatarUrl: String) {
  eventSeries {
    updateSeries(seriesId: $seriesId, name: $name, avatarUrl: $avatarUrl) {
      eventSeriesId
      name
      avatarUrl
    }
  }
}
    `;
export type UpdateSeriesMutationFn = Apollo.MutationFunction<UpdateSeriesMutation, UpdateSeriesMutationVariables>;

/**
 * __useUpdateSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeriesMutation, { data, loading, error }] = useUpdateSeriesMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      name: // value for 'name'
 *      avatarUrl: // value for 'avatarUrl'
 *   },
 * });
 */
export function useUpdateSeriesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeriesMutation, UpdateSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeriesMutation, UpdateSeriesMutationVariables>(UpdateSeriesDocument, options);
      }
export type UpdateSeriesMutationHookResult = ReturnType<typeof useUpdateSeriesMutation>;
export type UpdateSeriesMutationResult = Apollo.MutationResult<UpdateSeriesMutation>;
export type UpdateSeriesMutationOptions = Apollo.BaseMutationOptions<UpdateSeriesMutation, UpdateSeriesMutationVariables>;
export const AddEventToSeriesDocument = gql`
    mutation AddEventToSeries($seriesId: UUID!, $eventIds: [UUID!]!) {
  eventSeries {
    addEventToSeries(seriesId: $seriesId, eventIds: $eventIds) {
      eventSeriesId
      memberCount
    }
  }
}
    `;
export type AddEventToSeriesMutationFn = Apollo.MutationFunction<AddEventToSeriesMutation, AddEventToSeriesMutationVariables>;

/**
 * __useAddEventToSeriesMutation__
 *
 * To run a mutation, you first call `useAddEventToSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventToSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventToSeriesMutation, { data, loading, error }] = useAddEventToSeriesMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useAddEventToSeriesMutation(baseOptions?: Apollo.MutationHookOptions<AddEventToSeriesMutation, AddEventToSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventToSeriesMutation, AddEventToSeriesMutationVariables>(AddEventToSeriesDocument, options);
      }
export type AddEventToSeriesMutationHookResult = ReturnType<typeof useAddEventToSeriesMutation>;
export type AddEventToSeriesMutationResult = Apollo.MutationResult<AddEventToSeriesMutation>;
export type AddEventToSeriesMutationOptions = Apollo.BaseMutationOptions<AddEventToSeriesMutation, AddEventToSeriesMutationVariables>;
export const RemoveEventFromSeriesDocument = gql`
    mutation RemoveEventFromSeries($seriesId: UUID!, $eventIds: [UUID!]!) {
  eventSeries {
    removeEventFromSeries(seriesId: $seriesId, eventIds: $eventIds) {
      eventSeriesId
      memberCount
    }
  }
}
    `;
export type RemoveEventFromSeriesMutationFn = Apollo.MutationFunction<RemoveEventFromSeriesMutation, RemoveEventFromSeriesMutationVariables>;

/**
 * __useRemoveEventFromSeriesMutation__
 *
 * To run a mutation, you first call `useRemoveEventFromSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventFromSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventFromSeriesMutation, { data, loading, error }] = useRemoveEventFromSeriesMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useRemoveEventFromSeriesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventFromSeriesMutation, RemoveEventFromSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventFromSeriesMutation, RemoveEventFromSeriesMutationVariables>(RemoveEventFromSeriesDocument, options);
      }
export type RemoveEventFromSeriesMutationHookResult = ReturnType<typeof useRemoveEventFromSeriesMutation>;
export type RemoveEventFromSeriesMutationResult = Apollo.MutationResult<RemoveEventFromSeriesMutation>;
export type RemoveEventFromSeriesMutationOptions = Apollo.BaseMutationOptions<RemoveEventFromSeriesMutation, RemoveEventFromSeriesMutationVariables>;
export const MoveEventDocument = gql`
    mutation MoveEvent($eventIds: [UUID!]!, $toSeriesId: UUID!) {
  eventSeries {
    moveEvent(eventIds: $eventIds, toSeriesId: $toSeriesId) {
      eventSeriesId
      memberCount
    }
  }
}
    `;
export type MoveEventMutationFn = Apollo.MutationFunction<MoveEventMutation, MoveEventMutationVariables>;

/**
 * __useMoveEventMutation__
 *
 * To run a mutation, you first call `useMoveEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveEventMutation, { data, loading, error }] = useMoveEventMutation({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *      toSeriesId: // value for 'toSeriesId'
 *   },
 * });
 */
export function useMoveEventMutation(baseOptions?: Apollo.MutationHookOptions<MoveEventMutation, MoveEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveEventMutation, MoveEventMutationVariables>(MoveEventDocument, options);
      }
export type MoveEventMutationHookResult = ReturnType<typeof useMoveEventMutation>;
export type MoveEventMutationResult = Apollo.MutationResult<MoveEventMutation>;
export type MoveEventMutationOptions = Apollo.BaseMutationOptions<MoveEventMutation, MoveEventMutationVariables>;
export const DeleteSeriesDocument = gql`
    mutation DeleteSeries($seriesId: UUID!) {
  eventSeries {
    deleteSeries(seriesId: $seriesId)
  }
}
    `;
export type DeleteSeriesMutationFn = Apollo.MutationFunction<DeleteSeriesMutation, DeleteSeriesMutationVariables>;

/**
 * __useDeleteSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSeriesMutation, { data, loading, error }] = useDeleteSeriesMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useDeleteSeriesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSeriesMutation, DeleteSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSeriesMutation, DeleteSeriesMutationVariables>(DeleteSeriesDocument, options);
      }
export type DeleteSeriesMutationHookResult = ReturnType<typeof useDeleteSeriesMutation>;
export type DeleteSeriesMutationResult = Apollo.MutationResult<DeleteSeriesMutation>;
export type DeleteSeriesMutationOptions = Apollo.BaseMutationOptions<DeleteSeriesMutation, DeleteSeriesMutationVariables>;
export const AssignSeriesRoleDocument = gql`
    mutation AssignSeriesRole($seriesId: UUID!, $userId: UUID!, $roleId: UUID!) {
  eventSeries {
    assignSeriesRole(seriesId: $seriesId, userId: $userId, roleId: $roleId) {
      eventSeriesId
    }
  }
}
    `;
export type AssignSeriesRoleMutationFn = Apollo.MutationFunction<AssignSeriesRoleMutation, AssignSeriesRoleMutationVariables>;

/**
 * __useAssignSeriesRoleMutation__
 *
 * To run a mutation, you first call `useAssignSeriesRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignSeriesRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignSeriesRoleMutation, { data, loading, error }] = useAssignSeriesRoleMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAssignSeriesRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignSeriesRoleMutation, AssignSeriesRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignSeriesRoleMutation, AssignSeriesRoleMutationVariables>(AssignSeriesRoleDocument, options);
      }
export type AssignSeriesRoleMutationHookResult = ReturnType<typeof useAssignSeriesRoleMutation>;
export type AssignSeriesRoleMutationResult = Apollo.MutationResult<AssignSeriesRoleMutation>;
export type AssignSeriesRoleMutationOptions = Apollo.BaseMutationOptions<AssignSeriesRoleMutation, AssignSeriesRoleMutationVariables>;
export const RemoveSeriesRoleDocument = gql`
    mutation RemoveSeriesRole($seriesId: UUID!, $userId: UUID!, $roleId: UUID!) {
  eventSeries {
    removeSeriesRole(seriesId: $seriesId, userId: $userId, roleId: $roleId) {
      eventSeriesId
    }
  }
}
    `;
export type RemoveSeriesRoleMutationFn = Apollo.MutationFunction<RemoveSeriesRoleMutation, RemoveSeriesRoleMutationVariables>;

/**
 * __useRemoveSeriesRoleMutation__
 *
 * To run a mutation, you first call `useRemoveSeriesRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSeriesRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSeriesRoleMutation, { data, loading, error }] = useRemoveSeriesRoleMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRemoveSeriesRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSeriesRoleMutation, RemoveSeriesRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSeriesRoleMutation, RemoveSeriesRoleMutationVariables>(RemoveSeriesRoleDocument, options);
      }
export type RemoveSeriesRoleMutationHookResult = ReturnType<typeof useRemoveSeriesRoleMutation>;
export type RemoveSeriesRoleMutationResult = Apollo.MutationResult<RemoveSeriesRoleMutation>;
export type RemoveSeriesRoleMutationOptions = Apollo.BaseMutationOptions<RemoveSeriesRoleMutation, RemoveSeriesRoleMutationVariables>;
export const InviteSeriesRoleDocument = gql`
    mutation InviteSeriesRole($seriesId: UUID!, $roleId: UUID!, $invitees: [SeriesRoleInviteeInput!]!) {
  eventSeries {
    inviteSeriesRole(seriesId: $seriesId, roleId: $roleId, invitees: $invitees) {
      eventSeriesId
    }
  }
}
    `;
export type InviteSeriesRoleMutationFn = Apollo.MutationFunction<InviteSeriesRoleMutation, InviteSeriesRoleMutationVariables>;

/**
 * __useInviteSeriesRoleMutation__
 *
 * To run a mutation, you first call `useInviteSeriesRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteSeriesRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteSeriesRoleMutation, { data, loading, error }] = useInviteSeriesRoleMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      roleId: // value for 'roleId'
 *      invitees: // value for 'invitees'
 *   },
 * });
 */
export function useInviteSeriesRoleMutation(baseOptions?: Apollo.MutationHookOptions<InviteSeriesRoleMutation, InviteSeriesRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteSeriesRoleMutation, InviteSeriesRoleMutationVariables>(InviteSeriesRoleDocument, options);
      }
export type InviteSeriesRoleMutationHookResult = ReturnType<typeof useInviteSeriesRoleMutation>;
export type InviteSeriesRoleMutationResult = Apollo.MutationResult<InviteSeriesRoleMutation>;
export type InviteSeriesRoleMutationOptions = Apollo.BaseMutationOptions<InviteSeriesRoleMutation, InviteSeriesRoleMutationVariables>;
export const RemovePendingSeriesRoleDocument = gql`
    mutation RemovePendingSeriesRole($seriesId: UUID!, $userKey: String!, $roleId: UUID!) {
  eventSeries {
    removePendingSeriesRole(seriesId: $seriesId, userKey: $userKey, roleId: $roleId) {
      eventSeriesId
    }
  }
}
    `;
export type RemovePendingSeriesRoleMutationFn = Apollo.MutationFunction<RemovePendingSeriesRoleMutation, RemovePendingSeriesRoleMutationVariables>;

/**
 * __useRemovePendingSeriesRoleMutation__
 *
 * To run a mutation, you first call `useRemovePendingSeriesRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePendingSeriesRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePendingSeriesRoleMutation, { data, loading, error }] = useRemovePendingSeriesRoleMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      userKey: // value for 'userKey'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRemovePendingSeriesRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemovePendingSeriesRoleMutation, RemovePendingSeriesRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePendingSeriesRoleMutation, RemovePendingSeriesRoleMutationVariables>(RemovePendingSeriesRoleDocument, options);
      }
export type RemovePendingSeriesRoleMutationHookResult = ReturnType<typeof useRemovePendingSeriesRoleMutation>;
export type RemovePendingSeriesRoleMutationResult = Apollo.MutationResult<RemovePendingSeriesRoleMutation>;
export type RemovePendingSeriesRoleMutationOptions = Apollo.BaseMutationOptions<RemovePendingSeriesRoleMutation, RemovePendingSeriesRoleMutationVariables>;
export const EventsManageGetMyEventsDocument = gql`
    query EventsManageGetMyEvents($criteria: SearchMyCreatedEventCriteriaInput, $first: Int, $after: String) {
  event {
    myEvents(criteria: $criteria, first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        eventType
        avatarUrl
        displayName
        slug
        eventId
        startDate
        endDate
        isEnded
        createdBy {
          userId
        }
        promoters {
          nodes {
            userId
          }
        }
        coHosts {
          nodes {
            userId
          }
        }
        sponsors {
          nodes {
            userId
          }
        }
        attendeeInfo {
          attendeeInfo {
            attendeeRole
          }
        }
        approvedTickets
        timeZone
        scannedTickets
        clubId
        eventSeriesId
      }
    }
  }
}
    `;

/**
 * __useEventsManageGetMyEventsQuery__
 *
 * To run a query within a React component, call `useEventsManageGetMyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetMyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetMyEventsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEventsManageGetMyEventsQuery(baseOptions?: Apollo.QueryHookOptions<EventsManageGetMyEventsQuery, EventsManageGetMyEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetMyEventsQuery, EventsManageGetMyEventsQueryVariables>(EventsManageGetMyEventsDocument, options);
      }
export function useEventsManageGetMyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetMyEventsQuery, EventsManageGetMyEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetMyEventsQuery, EventsManageGetMyEventsQueryVariables>(EventsManageGetMyEventsDocument, options);
        }
export function useEventsManageGetMyEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetMyEventsQuery, EventsManageGetMyEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetMyEventsQuery, EventsManageGetMyEventsQueryVariables>(EventsManageGetMyEventsDocument, options);
        }
export type EventsManageGetMyEventsQueryHookResult = ReturnType<typeof useEventsManageGetMyEventsQuery>;
export type EventsManageGetMyEventsLazyQueryHookResult = ReturnType<typeof useEventsManageGetMyEventsLazyQuery>;
export type EventsManageGetMyEventsSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetMyEventsSuspenseQuery>;
export type EventsManageGetMyEventsQueryResult = Apollo.QueryResult<EventsManageGetMyEventsQuery, EventsManageGetMyEventsQueryVariables>;
export const EventsManageGetMySeriesDocument = gql`
    query EventsManageGetMySeries($keyword: String, $first: Int, $after: String) {
  eventSeries {
    mySeries(keyword: $keyword, first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        eventSeriesId
        name
        slug
        avatarUrl
        memberCount
        myEventsCount
        isOwner
        owner {
          userId
          name
        }
        createdDate
        updatedDate
      }
    }
  }
}
    `;

/**
 * __useEventsManageGetMySeriesQuery__
 *
 * To run a query within a React component, call `useEventsManageGetMySeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetMySeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetMySeriesQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEventsManageGetMySeriesQuery(baseOptions?: Apollo.QueryHookOptions<EventsManageGetMySeriesQuery, EventsManageGetMySeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetMySeriesQuery, EventsManageGetMySeriesQueryVariables>(EventsManageGetMySeriesDocument, options);
      }
export function useEventsManageGetMySeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetMySeriesQuery, EventsManageGetMySeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetMySeriesQuery, EventsManageGetMySeriesQueryVariables>(EventsManageGetMySeriesDocument, options);
        }
export function useEventsManageGetMySeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetMySeriesQuery, EventsManageGetMySeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetMySeriesQuery, EventsManageGetMySeriesQueryVariables>(EventsManageGetMySeriesDocument, options);
        }
export type EventsManageGetMySeriesQueryHookResult = ReturnType<typeof useEventsManageGetMySeriesQuery>;
export type EventsManageGetMySeriesLazyQueryHookResult = ReturnType<typeof useEventsManageGetMySeriesLazyQuery>;
export type EventsManageGetMySeriesSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetMySeriesSuspenseQuery>;
export type EventsManageGetMySeriesQueryResult = Apollo.QueryResult<EventsManageGetMySeriesQuery, EventsManageGetMySeriesQueryVariables>;
export const EventsManageGetSeriesDocument = gql`
    query EventsManageGetSeries($id: UUID!) {
  eventSeries {
    series(id: $id) {
      eventSeriesId
      name
      slug
      avatarUrl
      memberCount
      isOwner
      mySeriesPermissions
      parentEventId
      owner {
        userId
        name
        avatarUrl
        isVerified
        tier
      }
    }
  }
}
    `;

/**
 * __useEventsManageGetSeriesQuery__
 *
 * To run a query within a React component, call `useEventsManageGetSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetSeriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventsManageGetSeriesQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetSeriesQuery, EventsManageGetSeriesQueryVariables> & ({ variables: EventsManageGetSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetSeriesQuery, EventsManageGetSeriesQueryVariables>(EventsManageGetSeriesDocument, options);
      }
export function useEventsManageGetSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetSeriesQuery, EventsManageGetSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetSeriesQuery, EventsManageGetSeriesQueryVariables>(EventsManageGetSeriesDocument, options);
        }
export function useEventsManageGetSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetSeriesQuery, EventsManageGetSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetSeriesQuery, EventsManageGetSeriesQueryVariables>(EventsManageGetSeriesDocument, options);
        }
export type EventsManageGetSeriesQueryHookResult = ReturnType<typeof useEventsManageGetSeriesQuery>;
export type EventsManageGetSeriesLazyQueryHookResult = ReturnType<typeof useEventsManageGetSeriesLazyQuery>;
export type EventsManageGetSeriesSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetSeriesSuspenseQuery>;
export type EventsManageGetSeriesQueryResult = Apollo.QueryResult<EventsManageGetSeriesQuery, EventsManageGetSeriesQueryVariables>;
export const EventsManageGetSeriesPassCapacityDocument = gql`
    query EventsManageGetSeriesPassCapacity($id: UUID!) {
  eventSeries {
    series(id: $id) {
      eventSeriesId
      passes {
        capacityTickets
        passTypes {
          eventTicketId
          capacity
          additionalGuests
        }
      }
    }
  }
}
    `;

/**
 * __useEventsManageGetSeriesPassCapacityQuery__
 *
 * To run a query within a React component, call `useEventsManageGetSeriesPassCapacityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetSeriesPassCapacityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetSeriesPassCapacityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventsManageGetSeriesPassCapacityQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetSeriesPassCapacityQuery, EventsManageGetSeriesPassCapacityQueryVariables> & ({ variables: EventsManageGetSeriesPassCapacityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetSeriesPassCapacityQuery, EventsManageGetSeriesPassCapacityQueryVariables>(EventsManageGetSeriesPassCapacityDocument, options);
      }
export function useEventsManageGetSeriesPassCapacityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetSeriesPassCapacityQuery, EventsManageGetSeriesPassCapacityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetSeriesPassCapacityQuery, EventsManageGetSeriesPassCapacityQueryVariables>(EventsManageGetSeriesPassCapacityDocument, options);
        }
export function useEventsManageGetSeriesPassCapacitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetSeriesPassCapacityQuery, EventsManageGetSeriesPassCapacityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetSeriesPassCapacityQuery, EventsManageGetSeriesPassCapacityQueryVariables>(EventsManageGetSeriesPassCapacityDocument, options);
        }
export type EventsManageGetSeriesPassCapacityQueryHookResult = ReturnType<typeof useEventsManageGetSeriesPassCapacityQuery>;
export type EventsManageGetSeriesPassCapacityLazyQueryHookResult = ReturnType<typeof useEventsManageGetSeriesPassCapacityLazyQuery>;
export type EventsManageGetSeriesPassCapacitySuspenseQueryHookResult = ReturnType<typeof useEventsManageGetSeriesPassCapacitySuspenseQuery>;
export type EventsManageGetSeriesPassCapacityQueryResult = Apollo.QueryResult<EventsManageGetSeriesPassCapacityQuery, EventsManageGetSeriesPassCapacityQueryVariables>;
export const EventsManageGetSeriesEventsDocument = gql`
    query EventsManageGetSeriesEvents($id: UUID!, $keyword: String, $status: SearchEventStatus, $sortBy: SeriesEventsSortBy, $sortOrder: PageSortOrder, $first: Int, $after: String) {
  eventSeries {
    seriesEvents(
      id: $id
      keyword: $keyword
      status: $status
      sortBy: $sortBy
      sortOrder: $sortOrder
      first: $first
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        eventType
        avatarUrl
        displayName
        slug
        eventId
        startDate
        endDate
        isEnded
        isPrivate
        isListed
        createdBy {
          userId
        }
        promoters {
          nodes {
            userId
          }
        }
        coHosts {
          nodes {
            userId
          }
        }
        sponsors {
          nodes {
            userId
          }
        }
        attendeeInfo {
          attendeeInfo {
            attendeeRole
            permissions
          }
        }
        approvedTickets
        timeZone
        scannedTickets
        clubId
        eventSeriesId
      }
    }
  }
}
    `;

/**
 * __useEventsManageGetSeriesEventsQuery__
 *
 * To run a query within a React component, call `useEventsManageGetSeriesEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetSeriesEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetSeriesEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      keyword: // value for 'keyword'
 *      status: // value for 'status'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEventsManageGetSeriesEventsQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetSeriesEventsQuery, EventsManageGetSeriesEventsQueryVariables> & ({ variables: EventsManageGetSeriesEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetSeriesEventsQuery, EventsManageGetSeriesEventsQueryVariables>(EventsManageGetSeriesEventsDocument, options);
      }
export function useEventsManageGetSeriesEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetSeriesEventsQuery, EventsManageGetSeriesEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetSeriesEventsQuery, EventsManageGetSeriesEventsQueryVariables>(EventsManageGetSeriesEventsDocument, options);
        }
export function useEventsManageGetSeriesEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetSeriesEventsQuery, EventsManageGetSeriesEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetSeriesEventsQuery, EventsManageGetSeriesEventsQueryVariables>(EventsManageGetSeriesEventsDocument, options);
        }
export type EventsManageGetSeriesEventsQueryHookResult = ReturnType<typeof useEventsManageGetSeriesEventsQuery>;
export type EventsManageGetSeriesEventsLazyQueryHookResult = ReturnType<typeof useEventsManageGetSeriesEventsLazyQuery>;
export type EventsManageGetSeriesEventsSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetSeriesEventsSuspenseQuery>;
export type EventsManageGetSeriesEventsQueryResult = Apollo.QueryResult<EventsManageGetSeriesEventsQuery, EventsManageGetSeriesEventsQueryVariables>;
export const EventsManageGetEventDetailsDocument = gql`
    query EventsManageGetEventDetails($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventType
      hasTicketsForSale
      isSeriesParentEvent
      entryStats {
        eventId
        own {
          entries
          checkedIn
          scans
        }
        passHolders {
          entries
          checkedIn
          scans
        }
        passGuests {
          entries
          checkedIn
          scans
        }
        plusOnes {
          shared
          live
          everyEvent
        }
        entries
        checkedIn
        capacity
      }
      paymentProcessor
      taxCollection {
        hasActiveRegistration
        homeState
        registeredStates
      }
      taxConfiguration {
        name
        percent
        isCollect
        useAutomaticTax
      }
      avatarUrl
      exclusiveAvatarUrl
      description
      displayName
      endDate
      eventId
      isPrivate
      slug
      startDate
      eventTickets {
        nodes {
          eventTicketId
          ticketType
          isPrivate
          isActive
          price
          isRsvpOnly
          sortOrder
          additionalGuests
          balance {
            availableAmount
            limitedAmount
            releasedAmount
            isUnlimitedAvailableAmount
          }
        }
      }
      seriesPassTickets(first: 100) {
        nodes {
          eventTicketId
          ticketType
          isPrivate
          isActive
        }
      }
      location {
        locationName
        address
        region
        city
        postalCode
        countryCode
        latitude
        longitude
      }
      createdBy {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        name
        tier
        userId
      }
      promoters {
        nodes {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
        }
      }
      coHosts {
        nodes {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
        }
      }
      sponsors {
        nodes {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
        }
      }
      doors {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        name
        tier
        userId
      }
      coordinators {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        name
        tier
        userId
      }
      talents {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        name
        tier
        userId
      }
      talentOrder
      attendeeInfo {
        attendeeInfo {
          permissions
        }
      }
      achievements {
        nodes {
          avatarUrl
          displayName
        }
      }
      isExpired
      isEnded
      canDelete
      cannotDeleteReason
      timeZone
      pendingAttendees2
      approvedAttendees
      seriesPassAttendeeCounts {
        approvedPeople
        pendingPeople
      }
      approvedTickets
      scannedTickets
      totalAvailableTickets
      invitedAttendees
      declinedAttendees: detailsAttendees(filter: {statuses: [DECLINED]}) {
        totalCount
      }
      waitingTicketsUsersCount {
        count
        eventTicketId
      }
      usersRoles {
        user {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
        }
        role
      }
      pendingUsersRoles {
        user {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
          emailAddress
        }
        email
        role
      }
      linkedOffers(filter: {status: APPROVED, sortingType: LINKED_AT}, first: 100) {
        nodes {
          offer {
            offerId
            access
            published
            type
            rewardOffer {
              state {
                avatarUrl
                coverUrl
                description
                name
                quantity
                limitedQty
                rewardId
                type
                timeFrameConstraint {
                  endDateTime
                  expiresDateTime
                  startDateTime
                  timeFrameType
                  timeZoneId
                }
                redemptionMethod {
                  ... on PriceRewardRedemptionMethod {
                    price
                    redemptionMethodType
                  }
                  ... on NoneRewardRedemptionMethod {
                    redemptionMethodType
                  }
                  ... on RepPointsRewardRedemptionMethod {
                    redemptionMethodType
                    repPoints
                  }
                }
              }
            }
          }
          status
        }
        totalCount
      }
      scanningZones {
        id
        isPrimary
        name
        resetScansDaily
        eventTicketSettings {
          eventTicketId
          maxScans
          isUnlimitedScans
        }
      }
      clubId
      currency
      eventSeriesId
    }
  }
}
    `;

/**
 * __useEventsManageGetEventDetailsQuery__
 *
 * To run a query within a React component, call `useEventsManageGetEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetEventDetailsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventsManageGetEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetEventDetailsQuery, EventsManageGetEventDetailsQueryVariables> & ({ variables: EventsManageGetEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetEventDetailsQuery, EventsManageGetEventDetailsQueryVariables>(EventsManageGetEventDetailsDocument, options);
      }
export function useEventsManageGetEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetEventDetailsQuery, EventsManageGetEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetEventDetailsQuery, EventsManageGetEventDetailsQueryVariables>(EventsManageGetEventDetailsDocument, options);
        }
export function useEventsManageGetEventDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetEventDetailsQuery, EventsManageGetEventDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetEventDetailsQuery, EventsManageGetEventDetailsQueryVariables>(EventsManageGetEventDetailsDocument, options);
        }
export type EventsManageGetEventDetailsQueryHookResult = ReturnType<typeof useEventsManageGetEventDetailsQuery>;
export type EventsManageGetEventDetailsLazyQueryHookResult = ReturnType<typeof useEventsManageGetEventDetailsLazyQuery>;
export type EventsManageGetEventDetailsSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetEventDetailsSuspenseQuery>;
export type EventsManageGetEventDetailsQueryResult = Apollo.QueryResult<EventsManageGetEventDetailsQuery, EventsManageGetEventDetailsQueryVariables>;
export const EventsManageGetAttendeeAgeRangeStatisticDocument = gql`
    query EventsManageGetAttendeeAgeRangeStatistic($slugOrId: String!, $inviterId: UUID, $attendeeFilterStatus: AttendeeFilterStatus) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      attendeeAgeRangeStatistic(
        inviterId: $inviterId
        attendeeFilterStatus: $attendeeFilterStatus
      ) {
        ageRangeUnder18 {
          totalFemaleAmount
          totalMaleAmount
          totalOtherAmount
          totalFemaleAmountPercentage
          totalMaleAmountPercentage
          totalOtherAmountPercentage
          totalFemaleTicketAmount
          totalMaleTicketAmount
          totalOtherTicketAmount
        }
        ageRangeFrom18To24 {
          totalFemaleAmount
          totalMaleAmount
          totalOtherAmount
          totalFemaleAmountPercentage
          totalMaleAmountPercentage
          totalOtherAmountPercentage
          totalFemaleTicketAmount
          totalMaleTicketAmount
          totalOtherTicketAmount
        }
        ageRangeFrom25To34 {
          totalFemaleAmount
          totalMaleAmount
          totalOtherAmount
          totalFemaleAmountPercentage
          totalMaleAmountPercentage
          totalOtherAmountPercentage
          totalFemaleTicketAmount
          totalMaleTicketAmount
          totalOtherTicketAmount
        }
        ageRangeFrom35To44 {
          totalFemaleAmount
          totalMaleAmount
          totalOtherAmount
          totalFemaleAmountPercentage
          totalMaleAmountPercentage
          totalOtherAmountPercentage
          totalFemaleTicketAmount
          totalMaleTicketAmount
          totalOtherTicketAmount
        }
        ageOver44 {
          totalFemaleAmount
          totalMaleAmount
          totalOtherAmount
          totalFemaleAmountPercentage
          totalMaleAmountPercentage
          totalOtherAmountPercentage
          totalFemaleTicketAmount
          totalMaleTicketAmount
          totalOtherTicketAmount
        }
        totalFemaleAmount
        totalMaleAmount
        totalOtherAmount
        totalFemaleAmountPercentage
        totalMaleAmountPercentage
        totalOtherAmountPercentage
        totalUserAmount
        totalFemaleTicketAmount
        totalMaleTicketAmount
        totalOtherTicketAmount
        totalTicketAmount
      }
    }
  }
}
    `;

/**
 * __useEventsManageGetAttendeeAgeRangeStatisticQuery__
 *
 * To run a query within a React component, call `useEventsManageGetAttendeeAgeRangeStatisticQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetAttendeeAgeRangeStatisticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetAttendeeAgeRangeStatisticQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      inviterId: // value for 'inviterId'
 *      attendeeFilterStatus: // value for 'attendeeFilterStatus'
 *   },
 * });
 */
export function useEventsManageGetAttendeeAgeRangeStatisticQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetAttendeeAgeRangeStatisticQuery, EventsManageGetAttendeeAgeRangeStatisticQueryVariables> & ({ variables: EventsManageGetAttendeeAgeRangeStatisticQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetAttendeeAgeRangeStatisticQuery, EventsManageGetAttendeeAgeRangeStatisticQueryVariables>(EventsManageGetAttendeeAgeRangeStatisticDocument, options);
      }
export function useEventsManageGetAttendeeAgeRangeStatisticLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetAttendeeAgeRangeStatisticQuery, EventsManageGetAttendeeAgeRangeStatisticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetAttendeeAgeRangeStatisticQuery, EventsManageGetAttendeeAgeRangeStatisticQueryVariables>(EventsManageGetAttendeeAgeRangeStatisticDocument, options);
        }
export function useEventsManageGetAttendeeAgeRangeStatisticSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetAttendeeAgeRangeStatisticQuery, EventsManageGetAttendeeAgeRangeStatisticQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetAttendeeAgeRangeStatisticQuery, EventsManageGetAttendeeAgeRangeStatisticQueryVariables>(EventsManageGetAttendeeAgeRangeStatisticDocument, options);
        }
export type EventsManageGetAttendeeAgeRangeStatisticQueryHookResult = ReturnType<typeof useEventsManageGetAttendeeAgeRangeStatisticQuery>;
export type EventsManageGetAttendeeAgeRangeStatisticLazyQueryHookResult = ReturnType<typeof useEventsManageGetAttendeeAgeRangeStatisticLazyQuery>;
export type EventsManageGetAttendeeAgeRangeStatisticSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetAttendeeAgeRangeStatisticSuspenseQuery>;
export type EventsManageGetAttendeeAgeRangeStatisticQueryResult = Apollo.QueryResult<EventsManageGetAttendeeAgeRangeStatisticQuery, EventsManageGetAttendeeAgeRangeStatisticQueryVariables>;
export const EventsManageGetSocialReachesDocument = gql`
    query EventsManageGetSocialReaches($slugOrId: String!, $inviterId: UUID) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      socialReaches(inviterId: $inviterId) {
        socialNetworkScheme
        reaches
      }
    }
  }
}
    `;

/**
 * __useEventsManageGetSocialReachesQuery__
 *
 * To run a query within a React component, call `useEventsManageGetSocialReachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetSocialReachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetSocialReachesQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      inviterId: // value for 'inviterId'
 *   },
 * });
 */
export function useEventsManageGetSocialReachesQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetSocialReachesQuery, EventsManageGetSocialReachesQueryVariables> & ({ variables: EventsManageGetSocialReachesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetSocialReachesQuery, EventsManageGetSocialReachesQueryVariables>(EventsManageGetSocialReachesDocument, options);
      }
export function useEventsManageGetSocialReachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetSocialReachesQuery, EventsManageGetSocialReachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetSocialReachesQuery, EventsManageGetSocialReachesQueryVariables>(EventsManageGetSocialReachesDocument, options);
        }
export function useEventsManageGetSocialReachesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetSocialReachesQuery, EventsManageGetSocialReachesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetSocialReachesQuery, EventsManageGetSocialReachesQueryVariables>(EventsManageGetSocialReachesDocument, options);
        }
export type EventsManageGetSocialReachesQueryHookResult = ReturnType<typeof useEventsManageGetSocialReachesQuery>;
export type EventsManageGetSocialReachesLazyQueryHookResult = ReturnType<typeof useEventsManageGetSocialReachesLazyQuery>;
export type EventsManageGetSocialReachesSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetSocialReachesSuspenseQuery>;
export type EventsManageGetSocialReachesQueryResult = Apollo.QueryResult<EventsManageGetSocialReachesQuery, EventsManageGetSocialReachesQueryVariables>;
export const EventsManageGetEventEarningsDocument = gql`
    query EventsManageGetEventEarnings($filter: EventEarningsFilterInput!) {
  event {
    getEventEarnings(filter: $filter) {
      totalFees
      totalPrice
      totalQuantity
      totalGratuity
      totalTaxes
      serviceFee
      processingFee
      hostBalance
      ticketBreakdown {
        eventTicketId
        ticketType
        unitPrice
        totalQuantity
        totalPrice
      }
    }
  }
}
    `;

/**
 * __useEventsManageGetEventEarningsQuery__
 *
 * To run a query within a React component, call `useEventsManageGetEventEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetEventEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetEventEarningsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEventsManageGetEventEarningsQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetEventEarningsQuery, EventsManageGetEventEarningsQueryVariables> & ({ variables: EventsManageGetEventEarningsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetEventEarningsQuery, EventsManageGetEventEarningsQueryVariables>(EventsManageGetEventEarningsDocument, options);
      }
export function useEventsManageGetEventEarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetEventEarningsQuery, EventsManageGetEventEarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetEventEarningsQuery, EventsManageGetEventEarningsQueryVariables>(EventsManageGetEventEarningsDocument, options);
        }
export function useEventsManageGetEventEarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetEventEarningsQuery, EventsManageGetEventEarningsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetEventEarningsQuery, EventsManageGetEventEarningsQueryVariables>(EventsManageGetEventEarningsDocument, options);
        }
export type EventsManageGetEventEarningsQueryHookResult = ReturnType<typeof useEventsManageGetEventEarningsQuery>;
export type EventsManageGetEventEarningsLazyQueryHookResult = ReturnType<typeof useEventsManageGetEventEarningsLazyQuery>;
export type EventsManageGetEventEarningsSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetEventEarningsSuspenseQuery>;
export type EventsManageGetEventEarningsQueryResult = Apollo.QueryResult<EventsManageGetEventEarningsQuery, EventsManageGetEventEarningsQueryVariables>;
export const EventsManageGetEventForEditDocument = gql`
    query EventsManageGetEventForEdit($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      paymentProcessor
      taxCollection {
        hasActiveRegistration
        homeState
        registeredStates
      }
      taxConfiguration {
        name
        percent
        isCollect
        useAutomaticTax
      }
      eventType
      ageLimit
      avatarUrl
      exclusiveAvatarUrl
      description
      terms
      faqs
      faqEntries {
        question
        answer
      }
      disclosureOrPrivacyPolicyTitle
      disclosureOrPrivacyPolicyFileUrl
      disclosureOrPrivacyPolicyChecksum
      displayName
      endDate
      eventId
      eventSeriesId
      isSeriesParentEvent
      isPrivate
      minimumRepScore
      note
      optInAgeLimit
      optInAllowGuestInviteOthers
      optInDisclosureOrPrivacyPolicy
      optInDisplayRepScore
      optInLocationRadius
      ticketTermsPurchasePolicy
      socialReaches {
        reaches
        socialNetworkScheme
      }
      locationRadius {
        address
        isActive
        latitude
        longitude
        radius
        unitLengthType
      }
      optInQuestionRequirements
      optInShowGuestCount
      optInAllowPublicEventPagePreview
      optInShowGuestList
      optInSocialAccountRequirements
      requireSocialAccountConnection
      slug
      startDate
      eventTickets {
        nodes {
          isEnabledWishList
          color
          balance {
            availableAmount
            limitedAmount
            releasedAmount
          }
          eventTicketId
          isActive
          price
          repPoints
          ticketType
          additionalGuests
          isRequiredApproval
          isPrivate
          isShareable
          resetAdditionalGuestsAfterEachEvent
          requiresDisclosureSignature
          optInShowTicketAmount
          visibleStartAt
          visibleEndAt
          gratuityPercentage
          note
          createdDate
          sortOrder
          actionLabel
          optInQrCodePass
        }
      }
      location {
        locationName
        address
        region
        city
        postalCode
        countryCode
        isOnlyVisibleToApprovedAttendees
        latitude
        longitude
      }
      questionRequirements {
        isRequired
        question
        showPublicTickets
        showPrivateTickets
        optInSpecificTicketTypes
        ticketTypeIds
      }
      socialAccountRequirements {
        isRequired
        scheme
      }
      createdBy {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        name
        tier
        userId
        emailAddress
        userName
      }
      promoters {
        nodes {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
          emailAddress
          userName
        }
      }
      coHosts {
        nodes {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
          emailAddress
          userName
        }
      }
      sponsors {
        nodes {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
          emailAddress
          userName
        }
      }
      doors {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        name
        tier
        userId
        emailAddress
        userName
      }
      coordinators {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        name
        tier
        userId
        emailAddress
      }
      talents {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        name
        tier
        userId
        emailAddress
        userName
      }
      talentOrder
      seriesTeam {
        role
        user {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
          emailAddress
          userName
        }
      }
      attendeeInfo {
        attendeeInfo {
          permissions
        }
      }
      timeZone
      isAllInPricing
      usersRoles {
        user {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          gender
          isVerified
          name
          tier
          userId
          userName
          emailAddress
        }
        role
      }
      pendingUsersRoles {
        user {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          gender
          isVerified
          name
          tier
          userId
          userName
          emailAddress
        }
        email
        role
      }
      scanningZones {
        eventTicketIds
        id
        isPrimary
        name
        resetScansDaily
        eventTicketSettings {
          eventTicketId
          maxScans
          isUnlimitedScans
        }
      }
      zoneDeletability {
        zoneId
        canDelete
      }
      optInShowMusicEmbed
      musicEmbedUrl
      isListed
      isStarted
      isExpired
      isEnded
      canProcessPayment
      currency
      totalEarnings
    }
  }
}
    `;

/**
 * __useEventsManageGetEventForEditQuery__
 *
 * To run a query within a React component, call `useEventsManageGetEventForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetEventForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetEventForEditQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventsManageGetEventForEditQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetEventForEditQuery, EventsManageGetEventForEditQueryVariables> & ({ variables: EventsManageGetEventForEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetEventForEditQuery, EventsManageGetEventForEditQueryVariables>(EventsManageGetEventForEditDocument, options);
      }
export function useEventsManageGetEventForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetEventForEditQuery, EventsManageGetEventForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetEventForEditQuery, EventsManageGetEventForEditQueryVariables>(EventsManageGetEventForEditDocument, options);
        }
export function useEventsManageGetEventForEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetEventForEditQuery, EventsManageGetEventForEditQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetEventForEditQuery, EventsManageGetEventForEditQueryVariables>(EventsManageGetEventForEditDocument, options);
        }
export type EventsManageGetEventForEditQueryHookResult = ReturnType<typeof useEventsManageGetEventForEditQuery>;
export type EventsManageGetEventForEditLazyQueryHookResult = ReturnType<typeof useEventsManageGetEventForEditLazyQuery>;
export type EventsManageGetEventForEditSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetEventForEditSuspenseQuery>;
export type EventsManageGetEventForEditQueryResult = Apollo.QueryResult<EventsManageGetEventForEditQuery, EventsManageGetEventForEditQueryVariables>;
export const EventsManageGetAttendeeBookingsDocument = gql`
    query EventsManageGetAttendeeBookings($slugOrId: String!, $after: String, $first: Int, $filter: DetailsAttendeeFilterArgsInput) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      displayName
      startDate
      endDate
      location {
        locationName
        address
        city
        region
        postalCode
        countryCode
      }
      avatarUrl
      isListFull
      approvedTickets
      scannedTickets
      totalAvailableTickets
      invitedAttendees
      pendingAttendees2
      approvedAttendees
      entryStats {
        entries
        checkedIn
        capacity
      }
      seriesPassAttendeeCounts {
        approvedPeople
        pendingPeople
      }
      isExpired
      isEnded
      eventType
      isSeriesParentEvent
      optInDisclosureOrPrivacyPolicy
      waitingTicketsUsersCount {
        count
        eventTicketId
      }
      waitingTicketsUsers {
        eventTicketId
        users {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          isVerified
          name
          tier
          userId
          userName
          emailAddress
        }
      }
      seriesPassTickets(first: 100) {
        nodes {
          eventTicketId
          ticketType
          isActive
          price
        }
      }
      scanningZones {
        id
        isPrimary
        name
        eventTicketSettings {
          eventTicketId
        }
      }
      usersRoles {
        role
        user {
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          isVerified
          name
          tier
          userId
        }
      }
      createdBy {
        avatarUrl
        avatarSource
        instagramAvatarUrl
        tikTokAvatarUrl
        twitchAvatarUrl
        displayNameSource
        instagramDisplayName
        tikTokDisplayName
        twitchDisplayName
        instagramFollowsCount
        tikTokFollowsCount
        twitchFollowsCount
        isVerified
        name
        tier
        userId
      }
      attendeeInfo {
        attendeeInfo {
          permissions
        }
      }
      promoters {
        nodes {
          userId
          isVerified
          tier
        }
      }
      coHosts {
        nodes {
          userId
          isVerified
          tier
        }
      }
      sponsors {
        nodes {
          userId
          isVerified
          tier
        }
      }
      eventTickets {
        nodes {
          isFull
          eventTicketId
          price
          ticketType
          isPrivate
          balance {
            availableAmount
            limitedAmount
          }
          creatorId
          eventId
          isActive
          isEnabledWishList
          isRequiredApproval
          optInShowTicketAmount
        }
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      detailsAttendees(after: $after, first: $first, filter: $filter) {
        totalCount
        ticketCount
        invitedCount
        checkedInCount
        totalCheckedInCount
        pendingAttendeesCount
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        nodes {
          approvalUser {
            name
          }
          inviter {
            name
            userName
          }
          attendeeRoles
          attendeeInfo {
            attendeeRole
            attendeeState
            contestEntryType
            questionRequirementAnswers {
              question
              answer
            }
            permissions
            approvalAt
            privacyPolicyState
            privacyPolicyStateUpdatedAt
          }
          waiverStatus
          checkedInCount
          status
          tickets {
            ticketId
            isSeriesPass
            ticketInfo {
              firstSeen
              originalTicketId
              ticketType
              count
              parentTicketId
              displayEventTicketId
              status
              ...AttendeeTicketInfoFields
            }
            bookingInfo {
              totalPrice
              transactionId
              type
              shippingAddress {
                address
                city
                region
                postalCode
                countryCode
              }
            }
          }
          user {
            ageRange
            avatarUrl
            avatarSource
            instagramAvatarUrl
            tikTokAvatarUrl
            twitchAvatarUrl
            displayNameSource
            instagramDisplayName
            tikTokDisplayName
            twitchDisplayName
            instagramFollowsCount
            tikTokFollowsCount
            twitchFollowsCount
            gender
            isVerified
            tier
            userId
            name
            userName
            socialMediaConnections {
              scheme
              userId
              displayName
              avatarUrl
              profileLink
              username
            }
            address {
              address
              city
              countryCode
              postalCode
              region
            }
          }
          eligibility {
            hasProfilePicture
            hasConnectedInstagram
            instagramHandle
            instagramConnectedAt
            hasDownloadedApp
          }
          shareStats {
            clicks
            logins
            ticketAcquisitions
          }
          bookings {
            transactionId
            transactionStatus
            eventId
            eventTickets {
              ticketType
              purchaseAmount
              eventTicket {
                additionalGuests
              }
            }
          }
        }
      }
    }
  }
}
    ${AttendeeTicketInfoFieldsFragmentDoc}`;

/**
 * __useEventsManageGetAttendeeBookingsQuery__
 *
 * To run a query within a React component, call `useEventsManageGetAttendeeBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetAttendeeBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetAttendeeBookingsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEventsManageGetAttendeeBookingsQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetAttendeeBookingsQuery, EventsManageGetAttendeeBookingsQueryVariables> & ({ variables: EventsManageGetAttendeeBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetAttendeeBookingsQuery, EventsManageGetAttendeeBookingsQueryVariables>(EventsManageGetAttendeeBookingsDocument, options);
      }
export function useEventsManageGetAttendeeBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetAttendeeBookingsQuery, EventsManageGetAttendeeBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetAttendeeBookingsQuery, EventsManageGetAttendeeBookingsQueryVariables>(EventsManageGetAttendeeBookingsDocument, options);
        }
export function useEventsManageGetAttendeeBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetAttendeeBookingsQuery, EventsManageGetAttendeeBookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetAttendeeBookingsQuery, EventsManageGetAttendeeBookingsQueryVariables>(EventsManageGetAttendeeBookingsDocument, options);
        }
export type EventsManageGetAttendeeBookingsQueryHookResult = ReturnType<typeof useEventsManageGetAttendeeBookingsQuery>;
export type EventsManageGetAttendeeBookingsLazyQueryHookResult = ReturnType<typeof useEventsManageGetAttendeeBookingsLazyQuery>;
export type EventsManageGetAttendeeBookingsSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetAttendeeBookingsSuspenseQuery>;
export type EventsManageGetAttendeeBookingsQueryResult = Apollo.QueryResult<EventsManageGetAttendeeBookingsQuery, EventsManageGetAttendeeBookingsQueryVariables>;
export const EventsManageGetDetailsAttendeeDocument = gql`
    query EventsManageGetDetailsAttendee($attendeeId: UUID!, $slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      detailsAttendee(attendeeId: $attendeeId) {
        approvalUser {
          name
        }
        inviter {
          name
          userName
        }
        attendeeRoles
        attendeeInfo {
          attendeeRole
          attendeeState
          questionRequirementAnswers {
            question
            answer
          }
          permissions
          approvalAt
          privacyPolicyStateUpdatedAt
        }
        checkedInCount
        status
        tickets {
          ticketId
          isSeriesPass
          ticketInfo {
            firstSeen
            originalTicketId
            ticketType
            count
            parentTicketId
            displayEventTicketId
            status
            ...AttendeeTicketInfoFields
          }
          bookingInfo {
            totalPrice
            transactionId
            type
            shippingAddress {
              address
              city
              region
              postalCode
              countryCode
            }
          }
        }
        user {
          ageRange
          avatarUrl
          avatarSource
          instagramAvatarUrl
          tikTokAvatarUrl
          twitchAvatarUrl
          displayNameSource
          instagramDisplayName
          tikTokDisplayName
          twitchDisplayName
          instagramFollowsCount
          tikTokFollowsCount
          twitchFollowsCount
          gender
          isVerified
          tier
          userId
          name
          userName
          socialMediaConnections {
            scheme
            userId
            displayName
            avatarUrl
            profileLink
            username
          }
          address {
            address
            city
            countryCode
            postalCode
            region
          }
        }
        eligibility {
          hasProfilePicture
          hasConnectedInstagram
          instagramHandle
          instagramConnectedAt
          hasDownloadedApp
        }
        shareStats {
          clicks
          logins
          ticketAcquisitions
        }
        bookings {
          transactionId
          transactionStatus
          eventId
          eventTickets {
            ticketType
            purchaseAmount
            eventTicket {
              additionalGuests
            }
          }
        }
      }
    }
  }
}
    ${AttendeeTicketInfoFieldsFragmentDoc}`;

/**
 * __useEventsManageGetDetailsAttendeeQuery__
 *
 * To run a query within a React component, call `useEventsManageGetDetailsAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetDetailsAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetDetailsAttendeeQuery({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventsManageGetDetailsAttendeeQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetDetailsAttendeeQuery, EventsManageGetDetailsAttendeeQueryVariables> & ({ variables: EventsManageGetDetailsAttendeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetDetailsAttendeeQuery, EventsManageGetDetailsAttendeeQueryVariables>(EventsManageGetDetailsAttendeeDocument, options);
      }
export function useEventsManageGetDetailsAttendeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetDetailsAttendeeQuery, EventsManageGetDetailsAttendeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetDetailsAttendeeQuery, EventsManageGetDetailsAttendeeQueryVariables>(EventsManageGetDetailsAttendeeDocument, options);
        }
export function useEventsManageGetDetailsAttendeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetDetailsAttendeeQuery, EventsManageGetDetailsAttendeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetDetailsAttendeeQuery, EventsManageGetDetailsAttendeeQueryVariables>(EventsManageGetDetailsAttendeeDocument, options);
        }
export type EventsManageGetDetailsAttendeeQueryHookResult = ReturnType<typeof useEventsManageGetDetailsAttendeeQuery>;
export type EventsManageGetDetailsAttendeeLazyQueryHookResult = ReturnType<typeof useEventsManageGetDetailsAttendeeLazyQuery>;
export type EventsManageGetDetailsAttendeeSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetDetailsAttendeeSuspenseQuery>;
export type EventsManageGetDetailsAttendeeQueryResult = Apollo.QueryResult<EventsManageGetDetailsAttendeeQuery, EventsManageGetDetailsAttendeeQueryVariables>;
export const EventsManageExportAttendeesDocument = gql`
    query EventsManageExportAttendees($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      attendeesExport {
        eventTickets {
          id
          name
          additionalGuests
        }
        guestList {
          emailAddress
          fullName
          eventTicket {
            ticketType
          }
          checkedInQuantity
        }
        attendees {
          userId
          name
          gender
          emailAddress
          ageRange
          answers
          tickets
          totalSpent
          questions
          repScore
          status
          acceptedPolicyTime
          waiverStatus
          transactionTime
          approvedTime
          checkedInCount
          totalAmountWithoutFees
          paypalOrderId
          paypalPaymentId
          paypalTransactionFee
          paypalTotalPrice
          approvedBy
          purchasedItems {
            ticketType
            eventId
            quantity
            price
          }
          displayEventTickets {
            ticketType
            checkedInCount
            count
            additionalGuests
            tickets {
              ticketId
              ticketInfo {
                count
                ticketType
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEventsManageExportAttendeesQuery__
 *
 * To run a query within a React component, call `useEventsManageExportAttendeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageExportAttendeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageExportAttendeesQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventsManageExportAttendeesQuery(baseOptions: Apollo.QueryHookOptions<EventsManageExportAttendeesQuery, EventsManageExportAttendeesQueryVariables> & ({ variables: EventsManageExportAttendeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageExportAttendeesQuery, EventsManageExportAttendeesQueryVariables>(EventsManageExportAttendeesDocument, options);
      }
export function useEventsManageExportAttendeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageExportAttendeesQuery, EventsManageExportAttendeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageExportAttendeesQuery, EventsManageExportAttendeesQueryVariables>(EventsManageExportAttendeesDocument, options);
        }
export function useEventsManageExportAttendeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageExportAttendeesQuery, EventsManageExportAttendeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageExportAttendeesQuery, EventsManageExportAttendeesQueryVariables>(EventsManageExportAttendeesDocument, options);
        }
export type EventsManageExportAttendeesQueryHookResult = ReturnType<typeof useEventsManageExportAttendeesQuery>;
export type EventsManageExportAttendeesLazyQueryHookResult = ReturnType<typeof useEventsManageExportAttendeesLazyQuery>;
export type EventsManageExportAttendeesSuspenseQueryHookResult = ReturnType<typeof useEventsManageExportAttendeesSuspenseQuery>;
export type EventsManageExportAttendeesQueryResult = Apollo.QueryResult<EventsManageExportAttendeesQuery, EventsManageExportAttendeesQueryVariables>;
export const EventsManageGetEventAttendeeStatisticsDocument = gql`
    query EventsManageGetEventAttendeeStatistics($slugOrId: String!, $filter: DetailsAttendeeFilterArgsInput) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      approvedTickets
      scannedTickets
      totalAvailableTickets
      invitedAttendees
      pendingAttendees2
      approvedAttendees
      entryStats {
        entries
        checkedIn
        capacity
      }
      seriesPassAttendeeCounts {
        approvedPeople
        pendingPeople
      }
      detailsAttendees(filter: $filter) {
        ticketCount
        invitedCount
        checkedInCount
        totalCheckedInCount
        pendingAttendeesCount
      }
    }
  }
}
    `;

/**
 * __useEventsManageGetEventAttendeeStatisticsQuery__
 *
 * To run a query within a React component, call `useEventsManageGetEventAttendeeStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsManageGetEventAttendeeStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsManageGetEventAttendeeStatisticsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEventsManageGetEventAttendeeStatisticsQuery(baseOptions: Apollo.QueryHookOptions<EventsManageGetEventAttendeeStatisticsQuery, EventsManageGetEventAttendeeStatisticsQueryVariables> & ({ variables: EventsManageGetEventAttendeeStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsManageGetEventAttendeeStatisticsQuery, EventsManageGetEventAttendeeStatisticsQueryVariables>(EventsManageGetEventAttendeeStatisticsDocument, options);
      }
export function useEventsManageGetEventAttendeeStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsManageGetEventAttendeeStatisticsQuery, EventsManageGetEventAttendeeStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsManageGetEventAttendeeStatisticsQuery, EventsManageGetEventAttendeeStatisticsQueryVariables>(EventsManageGetEventAttendeeStatisticsDocument, options);
        }
export function useEventsManageGetEventAttendeeStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsManageGetEventAttendeeStatisticsQuery, EventsManageGetEventAttendeeStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsManageGetEventAttendeeStatisticsQuery, EventsManageGetEventAttendeeStatisticsQueryVariables>(EventsManageGetEventAttendeeStatisticsDocument, options);
        }
export type EventsManageGetEventAttendeeStatisticsQueryHookResult = ReturnType<typeof useEventsManageGetEventAttendeeStatisticsQuery>;
export type EventsManageGetEventAttendeeStatisticsLazyQueryHookResult = ReturnType<typeof useEventsManageGetEventAttendeeStatisticsLazyQuery>;
export type EventsManageGetEventAttendeeStatisticsSuspenseQueryHookResult = ReturnType<typeof useEventsManageGetEventAttendeeStatisticsSuspenseQuery>;
export type EventsManageGetEventAttendeeStatisticsQueryResult = Apollo.QueryResult<EventsManageGetEventAttendeeStatisticsQuery, EventsManageGetEventAttendeeStatisticsQueryVariables>;
export const EventsInviteGetEventDetailsDocument = gql`
    query EventsInviteGetEventDetails($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      displayName
      slug
      avatarUrl
      isExpired
      isEnded
      createdBy {
        userId
      }
      coHosts {
        nodes {
          userId
        }
      }
      promoters {
        nodes {
          userId
        }
      }
      attendeeInfo {
        attendeeInfo {
          permissions
        }
      }
      eventTickets {
        nodes {
          eventTicketId
          ticketType
          isPrivate
          isActive
        }
      }
    }
  }
}
    `;

/**
 * __useEventsInviteGetEventDetailsQuery__
 *
 * To run a query within a React component, call `useEventsInviteGetEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsInviteGetEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsInviteGetEventDetailsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventsInviteGetEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<EventsInviteGetEventDetailsQuery, EventsInviteGetEventDetailsQueryVariables> & ({ variables: EventsInviteGetEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsInviteGetEventDetailsQuery, EventsInviteGetEventDetailsQueryVariables>(EventsInviteGetEventDetailsDocument, options);
      }
export function useEventsInviteGetEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsInviteGetEventDetailsQuery, EventsInviteGetEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsInviteGetEventDetailsQuery, EventsInviteGetEventDetailsQueryVariables>(EventsInviteGetEventDetailsDocument, options);
        }
export function useEventsInviteGetEventDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsInviteGetEventDetailsQuery, EventsInviteGetEventDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsInviteGetEventDetailsQuery, EventsInviteGetEventDetailsQueryVariables>(EventsInviteGetEventDetailsDocument, options);
        }
export type EventsInviteGetEventDetailsQueryHookResult = ReturnType<typeof useEventsInviteGetEventDetailsQuery>;
export type EventsInviteGetEventDetailsLazyQueryHookResult = ReturnType<typeof useEventsInviteGetEventDetailsLazyQuery>;
export type EventsInviteGetEventDetailsSuspenseQueryHookResult = ReturnType<typeof useEventsInviteGetEventDetailsSuspenseQuery>;
export type EventsInviteGetEventDetailsQueryResult = Apollo.QueryResult<EventsInviteGetEventDetailsQuery, EventsInviteGetEventDetailsQueryVariables>;
export const EventsInviteSearchContactsDocument = gql`
    query EventsInviteSearchContacts($eventId: UUID!, $filterArgs: ContactPageFilterArgsInput!, $first: Int, $after: String) {
  contactList {
    contacts(
      eventId: $eventId
      filterArgs: $filterArgs
      first: $first
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
      nodes {
        contactId
        emailAddress
        events {
          nodes {
            avatarUrl
            displayName
          }
        }
        invitationStatus(eventId: $eventId)
        inviteInfo(eventId: $eventId) {
          giftTicketName
          giftTicketQuantity
          privateTicketName
          privateTicketQuantity
        }
        inviter(eventId: $eventId) {
          avatarUrl
          userName
          name
        }
        name
        phoneNumber
        userId
        userInfo {
          address {
            city
            countryCode
          }
          avatarUrl
          isVerified
          userName
          socialMediaConnections {
            displayName
            scheme
            avatarUrl
            profileLink
            username
          }
          gender
          ageRange
          name
        }
      }
    }
  }
}
    `;

/**
 * __useEventsInviteSearchContactsQuery__
 *
 * To run a query within a React component, call `useEventsInviteSearchContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsInviteSearchContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsInviteSearchContactsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      filterArgs: // value for 'filterArgs'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEventsInviteSearchContactsQuery(baseOptions: Apollo.QueryHookOptions<EventsInviteSearchContactsQuery, EventsInviteSearchContactsQueryVariables> & ({ variables: EventsInviteSearchContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsInviteSearchContactsQuery, EventsInviteSearchContactsQueryVariables>(EventsInviteSearchContactsDocument, options);
      }
export function useEventsInviteSearchContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsInviteSearchContactsQuery, EventsInviteSearchContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsInviteSearchContactsQuery, EventsInviteSearchContactsQueryVariables>(EventsInviteSearchContactsDocument, options);
        }
export function useEventsInviteSearchContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsInviteSearchContactsQuery, EventsInviteSearchContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsInviteSearchContactsQuery, EventsInviteSearchContactsQueryVariables>(EventsInviteSearchContactsDocument, options);
        }
export type EventsInviteSearchContactsQueryHookResult = ReturnType<typeof useEventsInviteSearchContactsQuery>;
export type EventsInviteSearchContactsLazyQueryHookResult = ReturnType<typeof useEventsInviteSearchContactsLazyQuery>;
export type EventsInviteSearchContactsSuspenseQueryHookResult = ReturnType<typeof useEventsInviteSearchContactsSuspenseQuery>;
export type EventsInviteSearchContactsQueryResult = Apollo.QueryResult<EventsInviteSearchContactsQuery, EventsInviteSearchContactsQueryVariables>;
export const EventsGuestGetEventDetailsDocument = gql`
    query EventsGuestGetEventDetails($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      eventTickets {
        nodes {
          eventTicketId
          ticketType
          isPrivate
          isActive
        }
      }
      createdBy {
        userId
      }
      promoters {
        nodes {
          userId
        }
      }
      coHosts {
        nodes {
          userId
        }
      }
      attendeeInfo {
        attendeeInfo {
          permissions
        }
      }
    }
  }
}
    `;

/**
 * __useEventsGuestGetEventDetailsQuery__
 *
 * To run a query within a React component, call `useEventsGuestGetEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsGuestGetEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsGuestGetEventDetailsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventsGuestGetEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<EventsGuestGetEventDetailsQuery, EventsGuestGetEventDetailsQueryVariables> & ({ variables: EventsGuestGetEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsGuestGetEventDetailsQuery, EventsGuestGetEventDetailsQueryVariables>(EventsGuestGetEventDetailsDocument, options);
      }
export function useEventsGuestGetEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsGuestGetEventDetailsQuery, EventsGuestGetEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsGuestGetEventDetailsQuery, EventsGuestGetEventDetailsQueryVariables>(EventsGuestGetEventDetailsDocument, options);
        }
export function useEventsGuestGetEventDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsGuestGetEventDetailsQuery, EventsGuestGetEventDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsGuestGetEventDetailsQuery, EventsGuestGetEventDetailsQueryVariables>(EventsGuestGetEventDetailsDocument, options);
        }
export type EventsGuestGetEventDetailsQueryHookResult = ReturnType<typeof useEventsGuestGetEventDetailsQuery>;
export type EventsGuestGetEventDetailsLazyQueryHookResult = ReturnType<typeof useEventsGuestGetEventDetailsLazyQuery>;
export type EventsGuestGetEventDetailsSuspenseQueryHookResult = ReturnType<typeof useEventsGuestGetEventDetailsSuspenseQuery>;
export type EventsGuestGetEventDetailsQueryResult = Apollo.QueryResult<EventsGuestGetEventDetailsQuery, EventsGuestGetEventDetailsQueryVariables>;
export const EventsGuestSearchGuestsDocument = gql`
    query EventsGuestSearchGuests($eventId: UUID!, $query: String, $first: Int, $after: String, $filterArgs: SearchEventGuestFilterArgsInput) {
  event {
    searchEventGuests(
      eventId: $eventId
      query: $query
      first: $first
      after: $after
      filterArgs: $filterArgs
    ) {
      guestCount
      ticketCount
      checkedInCount
      edges {
        node {
          guestId
          eventTicketIds
          fullName
          emailAddress
          phoneNumber
          avatarUrl
          note
          qrPassQuantity
          qrPassCheckedInQuantity
          qrPassEmailSentAt
          qrPassTextSentAt
          customFields {
            key
            label
            value
          }
          tickets {
            ticketId
            eventTicketId
            eventTicket {
              ticketType
              isPrivate
            }
            guestName
            checkedInAt
            guestId
            avatarUrl
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
}
    `;

/**
 * __useEventsGuestSearchGuestsQuery__
 *
 * To run a query within a React component, call `useEventsGuestSearchGuestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsGuestSearchGuestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsGuestSearchGuestsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filterArgs: // value for 'filterArgs'
 *   },
 * });
 */
export function useEventsGuestSearchGuestsQuery(baseOptions: Apollo.QueryHookOptions<EventsGuestSearchGuestsQuery, EventsGuestSearchGuestsQueryVariables> & ({ variables: EventsGuestSearchGuestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsGuestSearchGuestsQuery, EventsGuestSearchGuestsQueryVariables>(EventsGuestSearchGuestsDocument, options);
      }
export function useEventsGuestSearchGuestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsGuestSearchGuestsQuery, EventsGuestSearchGuestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsGuestSearchGuestsQuery, EventsGuestSearchGuestsQueryVariables>(EventsGuestSearchGuestsDocument, options);
        }
export function useEventsGuestSearchGuestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsGuestSearchGuestsQuery, EventsGuestSearchGuestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsGuestSearchGuestsQuery, EventsGuestSearchGuestsQueryVariables>(EventsGuestSearchGuestsDocument, options);
        }
export type EventsGuestSearchGuestsQueryHookResult = ReturnType<typeof useEventsGuestSearchGuestsQuery>;
export type EventsGuestSearchGuestsLazyQueryHookResult = ReturnType<typeof useEventsGuestSearchGuestsLazyQuery>;
export type EventsGuestSearchGuestsSuspenseQueryHookResult = ReturnType<typeof useEventsGuestSearchGuestsSuspenseQuery>;
export type EventsGuestSearchGuestsQueryResult = Apollo.QueryResult<EventsGuestSearchGuestsQuery, EventsGuestSearchGuestsQueryVariables>;
export const GuestQrLinkDocument = gql`
    query GuestQrLink($eventId: UUID!, $guestId: UUID!) {
  event {
    guestQrLink(eventId: $eventId, guestId: $guestId)
  }
}
    `;

/**
 * __useGuestQrLinkQuery__
 *
 * To run a query within a React component, call `useGuestQrLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestQrLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestQrLinkQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestId: // value for 'guestId'
 *   },
 * });
 */
export function useGuestQrLinkQuery(baseOptions: Apollo.QueryHookOptions<GuestQrLinkQuery, GuestQrLinkQueryVariables> & ({ variables: GuestQrLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestQrLinkQuery, GuestQrLinkQueryVariables>(GuestQrLinkDocument, options);
      }
export function useGuestQrLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestQrLinkQuery, GuestQrLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestQrLinkQuery, GuestQrLinkQueryVariables>(GuestQrLinkDocument, options);
        }
export function useGuestQrLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GuestQrLinkQuery, GuestQrLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GuestQrLinkQuery, GuestQrLinkQueryVariables>(GuestQrLinkDocument, options);
        }
export type GuestQrLinkQueryHookResult = ReturnType<typeof useGuestQrLinkQuery>;
export type GuestQrLinkLazyQueryHookResult = ReturnType<typeof useGuestQrLinkLazyQuery>;
export type GuestQrLinkSuspenseQueryHookResult = ReturnType<typeof useGuestQrLinkSuspenseQuery>;
export type GuestQrLinkQueryResult = Apollo.QueryResult<GuestQrLinkQuery, GuestQrLinkQueryVariables>;
export const EventLinkOfferGetEventDetailsDocument = gql`
    query EventLinkOfferGetEventDetails($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      avatarUrl
      slug
      eventId
    }
  }
}
    `;

/**
 * __useEventLinkOfferGetEventDetailsQuery__
 *
 * To run a query within a React component, call `useEventLinkOfferGetEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventLinkOfferGetEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventLinkOfferGetEventDetailsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventLinkOfferGetEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<EventLinkOfferGetEventDetailsQuery, EventLinkOfferGetEventDetailsQueryVariables> & ({ variables: EventLinkOfferGetEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventLinkOfferGetEventDetailsQuery, EventLinkOfferGetEventDetailsQueryVariables>(EventLinkOfferGetEventDetailsDocument, options);
      }
export function useEventLinkOfferGetEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventLinkOfferGetEventDetailsQuery, EventLinkOfferGetEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventLinkOfferGetEventDetailsQuery, EventLinkOfferGetEventDetailsQueryVariables>(EventLinkOfferGetEventDetailsDocument, options);
        }
export function useEventLinkOfferGetEventDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventLinkOfferGetEventDetailsQuery, EventLinkOfferGetEventDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventLinkOfferGetEventDetailsQuery, EventLinkOfferGetEventDetailsQueryVariables>(EventLinkOfferGetEventDetailsDocument, options);
        }
export type EventLinkOfferGetEventDetailsQueryHookResult = ReturnType<typeof useEventLinkOfferGetEventDetailsQuery>;
export type EventLinkOfferGetEventDetailsLazyQueryHookResult = ReturnType<typeof useEventLinkOfferGetEventDetailsLazyQuery>;
export type EventLinkOfferGetEventDetailsSuspenseQueryHookResult = ReturnType<typeof useEventLinkOfferGetEventDetailsSuspenseQuery>;
export type EventLinkOfferGetEventDetailsQueryResult = Apollo.QueryResult<EventLinkOfferGetEventDetailsQuery, EventLinkOfferGetEventDetailsQueryVariables>;
export const EventLinkOfferGetAvailableClubsDocument = gql`
    query EventLinkOfferGetAvailableClubs($eventId: UUID!) {
  event {
    availableClubsForOfferLink(eventId: $eventId) {
      name
      clubId
      slug
      images {
        background
      }
      createdBy
    }
  }
}
    `;

/**
 * __useEventLinkOfferGetAvailableClubsQuery__
 *
 * To run a query within a React component, call `useEventLinkOfferGetAvailableClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventLinkOfferGetAvailableClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventLinkOfferGetAvailableClubsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventLinkOfferGetAvailableClubsQuery(baseOptions: Apollo.QueryHookOptions<EventLinkOfferGetAvailableClubsQuery, EventLinkOfferGetAvailableClubsQueryVariables> & ({ variables: EventLinkOfferGetAvailableClubsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventLinkOfferGetAvailableClubsQuery, EventLinkOfferGetAvailableClubsQueryVariables>(EventLinkOfferGetAvailableClubsDocument, options);
      }
export function useEventLinkOfferGetAvailableClubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventLinkOfferGetAvailableClubsQuery, EventLinkOfferGetAvailableClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventLinkOfferGetAvailableClubsQuery, EventLinkOfferGetAvailableClubsQueryVariables>(EventLinkOfferGetAvailableClubsDocument, options);
        }
export function useEventLinkOfferGetAvailableClubsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventLinkOfferGetAvailableClubsQuery, EventLinkOfferGetAvailableClubsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventLinkOfferGetAvailableClubsQuery, EventLinkOfferGetAvailableClubsQueryVariables>(EventLinkOfferGetAvailableClubsDocument, options);
        }
export type EventLinkOfferGetAvailableClubsQueryHookResult = ReturnType<typeof useEventLinkOfferGetAvailableClubsQuery>;
export type EventLinkOfferGetAvailableClubsLazyQueryHookResult = ReturnType<typeof useEventLinkOfferGetAvailableClubsLazyQuery>;
export type EventLinkOfferGetAvailableClubsSuspenseQueryHookResult = ReturnType<typeof useEventLinkOfferGetAvailableClubsSuspenseQuery>;
export type EventLinkOfferGetAvailableClubsQueryResult = Apollo.QueryResult<EventLinkOfferGetAvailableClubsQuery, EventLinkOfferGetAvailableClubsQueryVariables>;
export const EventLinkOfferGetLinkedOffersDocument = gql`
    query EventLinkOfferGetLinkedOffers($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      linkedClubOffers {
        clubId
        images {
          background
        }
        offers {
          offer {
            offerId
            rewards {
              avatarUrl
              name
            }
          }
          status
          linkedAt
          linkedBy
        }
      }
    }
  }
}
    `;

/**
 * __useEventLinkOfferGetLinkedOffersQuery__
 *
 * To run a query within a React component, call `useEventLinkOfferGetLinkedOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventLinkOfferGetLinkedOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventLinkOfferGetLinkedOffersQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventLinkOfferGetLinkedOffersQuery(baseOptions: Apollo.QueryHookOptions<EventLinkOfferGetLinkedOffersQuery, EventLinkOfferGetLinkedOffersQueryVariables> & ({ variables: EventLinkOfferGetLinkedOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventLinkOfferGetLinkedOffersQuery, EventLinkOfferGetLinkedOffersQueryVariables>(EventLinkOfferGetLinkedOffersDocument, options);
      }
export function useEventLinkOfferGetLinkedOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventLinkOfferGetLinkedOffersQuery, EventLinkOfferGetLinkedOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventLinkOfferGetLinkedOffersQuery, EventLinkOfferGetLinkedOffersQueryVariables>(EventLinkOfferGetLinkedOffersDocument, options);
        }
export function useEventLinkOfferGetLinkedOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventLinkOfferGetLinkedOffersQuery, EventLinkOfferGetLinkedOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventLinkOfferGetLinkedOffersQuery, EventLinkOfferGetLinkedOffersQueryVariables>(EventLinkOfferGetLinkedOffersDocument, options);
        }
export type EventLinkOfferGetLinkedOffersQueryHookResult = ReturnType<typeof useEventLinkOfferGetLinkedOffersQuery>;
export type EventLinkOfferGetLinkedOffersLazyQueryHookResult = ReturnType<typeof useEventLinkOfferGetLinkedOffersLazyQuery>;
export type EventLinkOfferGetLinkedOffersSuspenseQueryHookResult = ReturnType<typeof useEventLinkOfferGetLinkedOffersSuspenseQuery>;
export type EventLinkOfferGetLinkedOffersQueryResult = Apollo.QueryResult<EventLinkOfferGetLinkedOffersQuery, EventLinkOfferGetLinkedOffersQueryVariables>;
export const EventLinkOfferGetClubOffersByIdDocument = gql`
    query EventLinkOfferGetClubOffersById($first: Int, $after: String, $id: UUID!, $filter: FilterOfferCriteriaInput) {
  club(id: $id) {
    offers(first: $first, after: $after, filter: $filter) {
      nodes {
        offerId
        rewards {
          avatarUrl
          name
        }
      }
    }
  }
}
    `;

/**
 * __useEventLinkOfferGetClubOffersByIdQuery__
 *
 * To run a query within a React component, call `useEventLinkOfferGetClubOffersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventLinkOfferGetClubOffersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventLinkOfferGetClubOffersByIdQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEventLinkOfferGetClubOffersByIdQuery(baseOptions: Apollo.QueryHookOptions<EventLinkOfferGetClubOffersByIdQuery, EventLinkOfferGetClubOffersByIdQueryVariables> & ({ variables: EventLinkOfferGetClubOffersByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventLinkOfferGetClubOffersByIdQuery, EventLinkOfferGetClubOffersByIdQueryVariables>(EventLinkOfferGetClubOffersByIdDocument, options);
      }
export function useEventLinkOfferGetClubOffersByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventLinkOfferGetClubOffersByIdQuery, EventLinkOfferGetClubOffersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventLinkOfferGetClubOffersByIdQuery, EventLinkOfferGetClubOffersByIdQueryVariables>(EventLinkOfferGetClubOffersByIdDocument, options);
        }
export function useEventLinkOfferGetClubOffersByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventLinkOfferGetClubOffersByIdQuery, EventLinkOfferGetClubOffersByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventLinkOfferGetClubOffersByIdQuery, EventLinkOfferGetClubOffersByIdQueryVariables>(EventLinkOfferGetClubOffersByIdDocument, options);
        }
export type EventLinkOfferGetClubOffersByIdQueryHookResult = ReturnType<typeof useEventLinkOfferGetClubOffersByIdQuery>;
export type EventLinkOfferGetClubOffersByIdLazyQueryHookResult = ReturnType<typeof useEventLinkOfferGetClubOffersByIdLazyQuery>;
export type EventLinkOfferGetClubOffersByIdSuspenseQueryHookResult = ReturnType<typeof useEventLinkOfferGetClubOffersByIdSuspenseQuery>;
export type EventLinkOfferGetClubOffersByIdQueryResult = Apollo.QueryResult<EventLinkOfferGetClubOffersByIdQuery, EventLinkOfferGetClubOffersByIdQueryVariables>;
export const EventInviteesGetEventDetailsDocument = gql`
    query EventInviteesGetEventDetails($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      slug
      displayName
      isExpired
      isEnded
      createdBy {
        userId
        name
        avatarUrl
      }
      coHosts {
        nodes {
          userId
          name
          avatarUrl
        }
      }
      promoters {
        nodes {
          userId
          name
          avatarUrl
        }
      }
      attendeeInfo {
        attendeeInfo {
          attendeeRole
          permissions
        }
      }
    }
  }
}
    `;

/**
 * __useEventInviteesGetEventDetailsQuery__
 *
 * To run a query within a React component, call `useEventInviteesGetEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventInviteesGetEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventInviteesGetEventDetailsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventInviteesGetEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<EventInviteesGetEventDetailsQuery, EventInviteesGetEventDetailsQueryVariables> & ({ variables: EventInviteesGetEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventInviteesGetEventDetailsQuery, EventInviteesGetEventDetailsQueryVariables>(EventInviteesGetEventDetailsDocument, options);
      }
export function useEventInviteesGetEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventInviteesGetEventDetailsQuery, EventInviteesGetEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventInviteesGetEventDetailsQuery, EventInviteesGetEventDetailsQueryVariables>(EventInviteesGetEventDetailsDocument, options);
        }
export function useEventInviteesGetEventDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventInviteesGetEventDetailsQuery, EventInviteesGetEventDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventInviteesGetEventDetailsQuery, EventInviteesGetEventDetailsQueryVariables>(EventInviteesGetEventDetailsDocument, options);
        }
export type EventInviteesGetEventDetailsQueryHookResult = ReturnType<typeof useEventInviteesGetEventDetailsQuery>;
export type EventInviteesGetEventDetailsLazyQueryHookResult = ReturnType<typeof useEventInviteesGetEventDetailsLazyQuery>;
export type EventInviteesGetEventDetailsSuspenseQueryHookResult = ReturnType<typeof useEventInviteesGetEventDetailsSuspenseQuery>;
export type EventInviteesGetEventDetailsQueryResult = Apollo.QueryResult<EventInviteesGetEventDetailsQuery, EventInviteesGetEventDetailsQueryVariables>;
export const EventInviteesSearchInviteesDocument = gql`
    query EventInviteesSearchInvitees($slugOrId: String!, $filter: SearchInviteesFilterArgs, $first: Int, $after: String) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      searchInvitees(filter: $filter, first: $first, after: $after) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          eventId
          contactId
          inviteeUserId
          name
          emailAddress
          phoneNumber
          source
          methodOfEntry
          deliveryStatus
          actionTaken
          sends {
            sendId
            sentAt
            lastDeliveryAt
            invitationMessage
            status
            source
            acceptedAt
            acceptanceSource
            acceptedDeliveryId
            sentBy {
              userId
              name
              avatarUrl
            }
            giftTickets {
              eventTicketId
              amount
            }
            privateTickets {
              eventTicketId
              amount
            }
            deliveries {
              deliveryId
              sentAt
              channels
              reminderTemplateKey
              firstViewedAt
              lastViewedAt
              viewSource
              bouncedAt
              triggeredBy {
                userId
                name
                avatarUrl
              }
            }
          }
          invitee {
            userId
            name
            avatarUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEventInviteesSearchInviteesQuery__
 *
 * To run a query within a React component, call `useEventInviteesSearchInviteesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventInviteesSearchInviteesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventInviteesSearchInviteesQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEventInviteesSearchInviteesQuery(baseOptions: Apollo.QueryHookOptions<EventInviteesSearchInviteesQuery, EventInviteesSearchInviteesQueryVariables> & ({ variables: EventInviteesSearchInviteesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventInviteesSearchInviteesQuery, EventInviteesSearchInviteesQueryVariables>(EventInviteesSearchInviteesDocument, options);
      }
export function useEventInviteesSearchInviteesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventInviteesSearchInviteesQuery, EventInviteesSearchInviteesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventInviteesSearchInviteesQuery, EventInviteesSearchInviteesQueryVariables>(EventInviteesSearchInviteesDocument, options);
        }
export function useEventInviteesSearchInviteesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventInviteesSearchInviteesQuery, EventInviteesSearchInviteesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventInviteesSearchInviteesQuery, EventInviteesSearchInviteesQueryVariables>(EventInviteesSearchInviteesDocument, options);
        }
export type EventInviteesSearchInviteesQueryHookResult = ReturnType<typeof useEventInviteesSearchInviteesQuery>;
export type EventInviteesSearchInviteesLazyQueryHookResult = ReturnType<typeof useEventInviteesSearchInviteesLazyQuery>;
export type EventInviteesSearchInviteesSuspenseQueryHookResult = ReturnType<typeof useEventInviteesSearchInviteesSuspenseQuery>;
export type EventInviteesSearchInviteesQueryResult = Apollo.QueryResult<EventInviteesSearchInviteesQuery, EventInviteesSearchInviteesQueryVariables>;
export const EventInviteesResendInvitationDocument = gql`
    mutation EventInviteesResendInvitation($eventId: UUID!, $contactId: UUID, $sendId: UUID) {
  event {
    resendInvitation(eventId: $eventId, contactId: $contactId, sendId: $sendId) {
      resentAt
      invitationMessage
      giftTickets {
        eventTicketId
        amount
      }
      privateTickets {
        eventTicketId
        amount
      }
    }
  }
}
    `;
export type EventInviteesResendInvitationMutationFn = Apollo.MutationFunction<EventInviteesResendInvitationMutation, EventInviteesResendInvitationMutationVariables>;

/**
 * __useEventInviteesResendInvitationMutation__
 *
 * To run a mutation, you first call `useEventInviteesResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventInviteesResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventInviteesResendInvitationMutation, { data, loading, error }] = useEventInviteesResendInvitationMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      contactId: // value for 'contactId'
 *      sendId: // value for 'sendId'
 *   },
 * });
 */
export function useEventInviteesResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<EventInviteesResendInvitationMutation, EventInviteesResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventInviteesResendInvitationMutation, EventInviteesResendInvitationMutationVariables>(EventInviteesResendInvitationDocument, options);
      }
export type EventInviteesResendInvitationMutationHookResult = ReturnType<typeof useEventInviteesResendInvitationMutation>;
export type EventInviteesResendInvitationMutationResult = Apollo.MutationResult<EventInviteesResendInvitationMutation>;
export type EventInviteesResendInvitationMutationOptions = Apollo.BaseMutationOptions<EventInviteesResendInvitationMutation, EventInviteesResendInvitationMutationVariables>;
export const EventInviteesGetStatisticsDocument = gql`
    query EventInviteesGetStatistics($slugOrId: String!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      areInvitationsIndexed
      inviteeStatistics {
        invited
        sharedLinkOrQr
        viewed
        bounced
        notOpened
        opened
        emailNotOpened
        emailOpenedOnly
        emailLinkOpened
        emailBounced
        emailCount
        textCount
        linkCount
      }
      actionTakenStatistics {
        approved
        pending
        denied
      }
    }
  }
}
    `;

/**
 * __useEventInviteesGetStatisticsQuery__
 *
 * To run a query within a React component, call `useEventInviteesGetStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventInviteesGetStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventInviteesGetStatisticsQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *   },
 * });
 */
export function useEventInviteesGetStatisticsQuery(baseOptions: Apollo.QueryHookOptions<EventInviteesGetStatisticsQuery, EventInviteesGetStatisticsQueryVariables> & ({ variables: EventInviteesGetStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventInviteesGetStatisticsQuery, EventInviteesGetStatisticsQueryVariables>(EventInviteesGetStatisticsDocument, options);
      }
export function useEventInviteesGetStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventInviteesGetStatisticsQuery, EventInviteesGetStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventInviteesGetStatisticsQuery, EventInviteesGetStatisticsQueryVariables>(EventInviteesGetStatisticsDocument, options);
        }
export function useEventInviteesGetStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventInviteesGetStatisticsQuery, EventInviteesGetStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventInviteesGetStatisticsQuery, EventInviteesGetStatisticsQueryVariables>(EventInviteesGetStatisticsDocument, options);
        }
export type EventInviteesGetStatisticsQueryHookResult = ReturnType<typeof useEventInviteesGetStatisticsQuery>;
export type EventInviteesGetStatisticsLazyQueryHookResult = ReturnType<typeof useEventInviteesGetStatisticsLazyQuery>;
export type EventInviteesGetStatisticsSuspenseQueryHookResult = ReturnType<typeof useEventInviteesGetStatisticsSuspenseQuery>;
export type EventInviteesGetStatisticsQueryResult = Apollo.QueryResult<EventInviteesGetStatisticsQuery, EventInviteesGetStatisticsQueryVariables>;
export const EventInviteesCountResendCandidatesDocument = gql`
    query EventInviteesCountResendCandidates($slugOrId: String!, $filter: SearchInviteesFilterArgs, $includeBounced: Boolean!) {
  event {
    fullEventBySlugOrId(slugOrId: $slugOrId) {
      eventId
      countResendCandidates(filter: $filter, includeBounced: $includeBounced) {
        resendable
        skippedAccepted
        skippedNoContact
        skippedBounced
        totalMatched
        bounced
      }
    }
  }
}
    `;

/**
 * __useEventInviteesCountResendCandidatesQuery__
 *
 * To run a query within a React component, call `useEventInviteesCountResendCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventInviteesCountResendCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventInviteesCountResendCandidatesQuery({
 *   variables: {
 *      slugOrId: // value for 'slugOrId'
 *      filter: // value for 'filter'
 *      includeBounced: // value for 'includeBounced'
 *   },
 * });
 */
export function useEventInviteesCountResendCandidatesQuery(baseOptions: Apollo.QueryHookOptions<EventInviteesCountResendCandidatesQuery, EventInviteesCountResendCandidatesQueryVariables> & ({ variables: EventInviteesCountResendCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventInviteesCountResendCandidatesQuery, EventInviteesCountResendCandidatesQueryVariables>(EventInviteesCountResendCandidatesDocument, options);
      }
export function useEventInviteesCountResendCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventInviteesCountResendCandidatesQuery, EventInviteesCountResendCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventInviteesCountResendCandidatesQuery, EventInviteesCountResendCandidatesQueryVariables>(EventInviteesCountResendCandidatesDocument, options);
        }
export function useEventInviteesCountResendCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventInviteesCountResendCandidatesQuery, EventInviteesCountResendCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventInviteesCountResendCandidatesQuery, EventInviteesCountResendCandidatesQueryVariables>(EventInviteesCountResendCandidatesDocument, options);
        }
export type EventInviteesCountResendCandidatesQueryHookResult = ReturnType<typeof useEventInviteesCountResendCandidatesQuery>;
export type EventInviteesCountResendCandidatesLazyQueryHookResult = ReturnType<typeof useEventInviteesCountResendCandidatesLazyQuery>;
export type EventInviteesCountResendCandidatesSuspenseQueryHookResult = ReturnType<typeof useEventInviteesCountResendCandidatesSuspenseQuery>;
export type EventInviteesCountResendCandidatesQueryResult = Apollo.QueryResult<EventInviteesCountResendCandidatesQuery, EventInviteesCountResendCandidatesQueryVariables>;
export const EventInviteesStartBulkResendDocument = gql`
    mutation EventInviteesStartBulkResend($eventId: UUID!, $filter: SearchInviteesFilterArgs, $includeBounced: Boolean!, $reminderMessage: String) {
  event {
    startBulkResend(
      eventId: $eventId
      filter: $filter
      includeBounced: $includeBounced
      reminderMessage: $reminderMessage
    )
  }
}
    `;
export type EventInviteesStartBulkResendMutationFn = Apollo.MutationFunction<EventInviteesStartBulkResendMutation, EventInviteesStartBulkResendMutationVariables>;

/**
 * __useEventInviteesStartBulkResendMutation__
 *
 * To run a mutation, you first call `useEventInviteesStartBulkResendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventInviteesStartBulkResendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventInviteesStartBulkResendMutation, { data, loading, error }] = useEventInviteesStartBulkResendMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      filter: // value for 'filter'
 *      includeBounced: // value for 'includeBounced'
 *      reminderMessage: // value for 'reminderMessage'
 *   },
 * });
 */
export function useEventInviteesStartBulkResendMutation(baseOptions?: Apollo.MutationHookOptions<EventInviteesStartBulkResendMutation, EventInviteesStartBulkResendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventInviteesStartBulkResendMutation, EventInviteesStartBulkResendMutationVariables>(EventInviteesStartBulkResendDocument, options);
      }
export type EventInviteesStartBulkResendMutationHookResult = ReturnType<typeof useEventInviteesStartBulkResendMutation>;
export type EventInviteesStartBulkResendMutationResult = Apollo.MutationResult<EventInviteesStartBulkResendMutation>;
export type EventInviteesStartBulkResendMutationOptions = Apollo.BaseMutationOptions<EventInviteesStartBulkResendMutation, EventInviteesStartBulkResendMutationVariables>;
export const SeriesPlusOneReturnHealthDocument = gql`
    query SeriesPlusOneReturnHealth($seriesId: UUID!) {
  eventSeries {
    series(id: $seriesId) {
      eventSeriesId
      plusOneReturnHealth {
        ...PlusOneReturnHealthFields
      }
    }
  }
}
    ${PlusOneReturnHealthFieldsFragmentDoc}`;

/**
 * __useSeriesPlusOneReturnHealthQuery__
 *
 * To run a query within a React component, call `useSeriesPlusOneReturnHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesPlusOneReturnHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesPlusOneReturnHealthQuery({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useSeriesPlusOneReturnHealthQuery(baseOptions: Apollo.QueryHookOptions<SeriesPlusOneReturnHealthQuery, SeriesPlusOneReturnHealthQueryVariables> & ({ variables: SeriesPlusOneReturnHealthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeriesPlusOneReturnHealthQuery, SeriesPlusOneReturnHealthQueryVariables>(SeriesPlusOneReturnHealthDocument, options);
      }
export function useSeriesPlusOneReturnHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeriesPlusOneReturnHealthQuery, SeriesPlusOneReturnHealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeriesPlusOneReturnHealthQuery, SeriesPlusOneReturnHealthQueryVariables>(SeriesPlusOneReturnHealthDocument, options);
        }
export function useSeriesPlusOneReturnHealthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeriesPlusOneReturnHealthQuery, SeriesPlusOneReturnHealthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeriesPlusOneReturnHealthQuery, SeriesPlusOneReturnHealthQueryVariables>(SeriesPlusOneReturnHealthDocument, options);
        }
export type SeriesPlusOneReturnHealthQueryHookResult = ReturnType<typeof useSeriesPlusOneReturnHealthQuery>;
export type SeriesPlusOneReturnHealthLazyQueryHookResult = ReturnType<typeof useSeriesPlusOneReturnHealthLazyQuery>;
export type SeriesPlusOneReturnHealthSuspenseQueryHookResult = ReturnType<typeof useSeriesPlusOneReturnHealthSuspenseQuery>;
export type SeriesPlusOneReturnHealthQueryResult = Apollo.QueryResult<SeriesPlusOneReturnHealthQuery, SeriesPlusOneReturnHealthQueryVariables>;
export const CheckSeriesPlusOneReturnsDocument = gql`
    mutation CheckSeriesPlusOneReturns($seriesId: UUID!, $dryRun: Boolean!) {
  eventSeries {
    fixPlusOneReturns(seriesId: $seriesId, dryRun: $dryRun) {
      dryRun
      plusOnesToReturn
      holdersGetNewPlusOne
      holdersWithoutPass
      waitingForNextEvent
      eventsToRepair
      moreRemain
      health {
        ...PlusOneReturnHealthFields
      }
    }
  }
}
    ${PlusOneReturnHealthFieldsFragmentDoc}`;
export type CheckSeriesPlusOneReturnsMutationFn = Apollo.MutationFunction<CheckSeriesPlusOneReturnsMutation, CheckSeriesPlusOneReturnsMutationVariables>;

/**
 * __useCheckSeriesPlusOneReturnsMutation__
 *
 * To run a mutation, you first call `useCheckSeriesPlusOneReturnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckSeriesPlusOneReturnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkSeriesPlusOneReturnsMutation, { data, loading, error }] = useCheckSeriesPlusOneReturnsMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useCheckSeriesPlusOneReturnsMutation(baseOptions?: Apollo.MutationHookOptions<CheckSeriesPlusOneReturnsMutation, CheckSeriesPlusOneReturnsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckSeriesPlusOneReturnsMutation, CheckSeriesPlusOneReturnsMutationVariables>(CheckSeriesPlusOneReturnsDocument, options);
      }
export type CheckSeriesPlusOneReturnsMutationHookResult = ReturnType<typeof useCheckSeriesPlusOneReturnsMutation>;
export type CheckSeriesPlusOneReturnsMutationResult = Apollo.MutationResult<CheckSeriesPlusOneReturnsMutation>;
export type CheckSeriesPlusOneReturnsMutationOptions = Apollo.BaseMutationOptions<CheckSeriesPlusOneReturnsMutation, CheckSeriesPlusOneReturnsMutationVariables>;
export const CreateOfferDocument = gql`
    mutation CreateOffer($payload: CreateOfferPayloadInput!, $clubId: UUID!) {
  clubById(clubId: $clubId) {
    createOffer(payload: $payload) {
      offerId
      rewardIds
    }
  }
}
    `;
export type CreateOfferMutationFn = Apollo.MutationFunction<CreateOfferMutation, CreateOfferMutationVariables>;

/**
 * __useCreateOfferMutation__
 *
 * To run a mutation, you first call `useCreateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfferMutation, { data, loading, error }] = useCreateOfferMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useCreateOfferMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfferMutation, CreateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfferMutation, CreateOfferMutationVariables>(CreateOfferDocument, options);
      }
export type CreateOfferMutationHookResult = ReturnType<typeof useCreateOfferMutation>;
export type CreateOfferMutationResult = Apollo.MutationResult<CreateOfferMutation>;
export type CreateOfferMutationOptions = Apollo.BaseMutationOptions<CreateOfferMutation, CreateOfferMutationVariables>;
export const UpdateOfferDocument = gql`
    mutation UpdateOffer($payload: UpdateOfferPayloadInput!, $offerId: UUID!, $clubId: UUID!) {
  clubById(clubId: $clubId) {
    offerById(offerId: $offerId) {
      updateOffer(payload: $payload)
    }
  }
}
    `;
export type UpdateOfferMutationFn = Apollo.MutationFunction<UpdateOfferMutation, UpdateOfferMutationVariables>;

/**
 * __useUpdateOfferMutation__
 *
 * To run a mutation, you first call `useUpdateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferMutation, { data, loading, error }] = useUpdateOfferMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      offerId: // value for 'offerId'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useUpdateOfferMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfferMutation, UpdateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfferMutation, UpdateOfferMutationVariables>(UpdateOfferDocument, options);
      }
export type UpdateOfferMutationHookResult = ReturnType<typeof useUpdateOfferMutation>;
export type UpdateOfferMutationResult = Apollo.MutationResult<UpdateOfferMutation>;
export type UpdateOfferMutationOptions = Apollo.BaseMutationOptions<UpdateOfferMutation, UpdateOfferMutationVariables>;
export const OwnerOfferGetAttendeesDocument = gql`
    query OwnerOfferGetAttendees($slug: String!, $offerId: UUID!, $first: Int, $after: String, $filter: DetailsOfferUserFilterArgsInput) {
  clubBySlug(slug: $slug) {
    clubId
    offers(filter: {offerId: $offerId}) {
      nodes {
        listOfferUser(first: $first, after: $after, filter: $filter) {
          nodes {
            userId
            isWinner
            user {
              ageRange
              avatarUrl
              avatarSource
              instagramAvatarUrl
              tikTokAvatarUrl
              twitchAvatarUrl
              displayNameSource
              instagramDisplayName
              tikTokDisplayName
              twitchDisplayName
              instagramFollowsCount
              tikTokFollowsCount
              twitchFollowsCount
              gender
              isVerified
              name
              tier
              userId
              userName
              repScore
            }
            offerUserState {
              status
              approvalAt
            }
          }
          pageInfo {
            startCursor
            hasPreviousPage
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOwnerOfferGetAttendeesQuery__
 *
 * To run a query within a React component, call `useOwnerOfferGetAttendeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnerOfferGetAttendeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnerOfferGetAttendeesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      offerId: // value for 'offerId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOwnerOfferGetAttendeesQuery(baseOptions: Apollo.QueryHookOptions<OwnerOfferGetAttendeesQuery, OwnerOfferGetAttendeesQueryVariables> & ({ variables: OwnerOfferGetAttendeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OwnerOfferGetAttendeesQuery, OwnerOfferGetAttendeesQueryVariables>(OwnerOfferGetAttendeesDocument, options);
      }
export function useOwnerOfferGetAttendeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OwnerOfferGetAttendeesQuery, OwnerOfferGetAttendeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OwnerOfferGetAttendeesQuery, OwnerOfferGetAttendeesQueryVariables>(OwnerOfferGetAttendeesDocument, options);
        }
export function useOwnerOfferGetAttendeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OwnerOfferGetAttendeesQuery, OwnerOfferGetAttendeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OwnerOfferGetAttendeesQuery, OwnerOfferGetAttendeesQueryVariables>(OwnerOfferGetAttendeesDocument, options);
        }
export type OwnerOfferGetAttendeesQueryHookResult = ReturnType<typeof useOwnerOfferGetAttendeesQuery>;
export type OwnerOfferGetAttendeesLazyQueryHookResult = ReturnType<typeof useOwnerOfferGetAttendeesLazyQuery>;
export type OwnerOfferGetAttendeesSuspenseQueryHookResult = ReturnType<typeof useOwnerOfferGetAttendeesSuspenseQuery>;
export type OwnerOfferGetAttendeesQueryResult = Apollo.QueryResult<OwnerOfferGetAttendeesQuery, OwnerOfferGetAttendeesQueryVariables>;
export const GetManageClubOfferByIdDocument = gql`
    query GetManageClubOfferById($slug: String!, $offerId: UUID!) {
  clubBySlug(slug: $slug) {
    offers(filter: {offerId: $offerId}) {
      nodes {
        access
        offerId
        isCurrentUserCanInvite {
          canNotInviteReason
          result
        }
        published
        type
        isWinnerGenerated
        totalWinnerCount
        configuration {
          pointsPurchase {
            isDefault
            strategy {
              percentageDiscountStrategy {
                baseCostPerPoint
                discountBuckets {
                  discountPercentage
                  points
                }
              }
            }
          }
        }
        requirements {
          age {
            minimumAge
          }
          membershipAge {
            age
          }
          minimumPoints {
            amount
            class
          }
          notAfter {
            notAfter
          }
          notBefore {
            notBefore
          }
          clubMembership {
            minimumMembershipAge
          }
        }
        rewardOffer {
          state {
            avatarUrl
            coverUrl
            description
            name
            quantity
            limitedQty
            settings {
              ... on CanShareSetting {
                enabled
                settingType
              }
              ... on OptInPrivacyPolicySetting {
                content
                enabled
                link
                settingType
                title
              }
              ... on LocationRadiusSetting {
                address
                enabled
                latitude
                longitude
                radius
                settingType
                unit
              }
            }
            conditions {
              ... on AchievementsRewardCondition {
                achievements {
                  achievementId
                  avatarUrl
                  description
                  name
                  type
                }
                type
              }
              ... on LoyaltyTierRewardCondition {
                loyaltyTiersByClub {
                  club {
                    clubId
                    name
                    images {
                      background
                    }
                    tiers {
                      backgroundImageUrl
                      colors {
                        background
                        border
                        foreground
                      }
                      description
                      level
                      name
                      title
                    }
                    membership {
                      tier {
                        level
                        name
                        title
                      }
                    }
                  }
                  level
                }
                type
              }
              ... on PriceRewardCondition {
                price
                repPoints
                type
              }
              ... on RepScoreRewardCondition {
                repScore
                type
              }
              ... on RepPointsRewardCondition {
                repPointsByClub {
                  club {
                    clubId
                    name
                    images {
                      background
                    }
                    tiers {
                      backgroundImageUrl
                      colors {
                        background
                        border
                        foreground
                      }
                      description
                      level
                      name
                      title
                    }
                  }
                  repPoints
                }
                type
              }
            }
            redemption {
              ... on AccessPassRewardRedemption {
                code
                guide
                isGenerated
                note
                redemptionType
              }
              ... on CustomerInformationRewardRedemption {
                guide
                note
                redemptionType
                customerInformationScope {
                  isAddressEnabled
                  isEmailEnabled
                  isNameEnabled
                  isPhoneNumberEnabled
                  isSocialMediaAccountEnabled
                  isUserNameEnabled
                  socialMediaAccountScope {
                    apple
                    facebook
                    instagram
                    linkedIn
                    tikTok
                    twitch
                    x
                    youTube
                  }
                }
              }
              ... on InviteLinkRewardRedemption {
                guide
                code
                isGenerated
                link
                note
                redemptionType
              }
              ... on PromoCodeRewardRedemption {
                guide
                code
                isGenerated
                note
                redemptionType
              }
              ... on LocationInformationRewardRedemption {
                guide
                note
                redemptionType
                code
                isGenerated
                addressDetails {
                  city
                  countryCode
                  phoneNumber
                  postalCode
                  state
                  streetAddress
                }
              }
            }
            rewardId
            type
            timeFrameConstraint {
              endDateTime
              expiresDateTime
              startDateTime
              timeFrameType
              timeZoneId
            }
            ageConstraint {
              maximumAge
              minimumAge
            }
            settings {
              ... on CanShareSetting {
                enabled
                settingType
              }
              ... on LocationRadiusSetting {
                enabled
                settingType
                address
                latitude
                longitude
                radius
                unit
              }
              ... on OptInPrivacyPolicySetting {
                enabled
                settingType
                title
                content
                link
              }
              ... on RequireSocialMediaToEarnBonusSetting {
                enabled
                settingType
                socialMediaAccountBonusSetting {
                  instagram
                  instagramBonus
                  tikTok
                  tikTokBonus
                  x
                  xBonus
                  facebook
                  facebookBonus
                  youTube
                  youTubeBonus
                  apple
                  appleBonus
                  linkedIn
                  linkedInBonus
                  twitch
                  twitchBonus
                }
              }
              ... on OptInPublicPagePreviewSetting {
                enabled
                settingType
              }
            }
          }
        }
        isStarted
        isCurrentUserEditable
        isTimeFrameTypeEditable
        isWinnerGenerated
      }
    }
    clubId
    name
    teamMemberRoles {
      roleId
      user {
        userId
      }
    }
  }
}
    `;

/**
 * __useGetManageClubOfferByIdQuery__
 *
 * To run a query within a React component, call `useGetManageClubOfferByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageClubOfferByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageClubOfferByIdQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useGetManageClubOfferByIdQuery(baseOptions: Apollo.QueryHookOptions<GetManageClubOfferByIdQuery, GetManageClubOfferByIdQueryVariables> & ({ variables: GetManageClubOfferByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageClubOfferByIdQuery, GetManageClubOfferByIdQueryVariables>(GetManageClubOfferByIdDocument, options);
      }
export function useGetManageClubOfferByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageClubOfferByIdQuery, GetManageClubOfferByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageClubOfferByIdQuery, GetManageClubOfferByIdQueryVariables>(GetManageClubOfferByIdDocument, options);
        }
export function useGetManageClubOfferByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManageClubOfferByIdQuery, GetManageClubOfferByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManageClubOfferByIdQuery, GetManageClubOfferByIdQueryVariables>(GetManageClubOfferByIdDocument, options);
        }
export type GetManageClubOfferByIdQueryHookResult = ReturnType<typeof useGetManageClubOfferByIdQuery>;
export type GetManageClubOfferByIdLazyQueryHookResult = ReturnType<typeof useGetManageClubOfferByIdLazyQuery>;
export type GetManageClubOfferByIdSuspenseQueryHookResult = ReturnType<typeof useGetManageClubOfferByIdSuspenseQuery>;
export type GetManageClubOfferByIdQueryResult = Apollo.QueryResult<GetManageClubOfferByIdQuery, GetManageClubOfferByIdQueryVariables>;
export const GetManageClubOfferBySlugDocument = gql`
    query GetManageClubOfferBySlug($first: Int, $after: String, $slug: String!) {
  clubBySlug(slug: $slug) {
    offers(first: $first, after: $after) {
      edges {
        cursor
        node {
          access
          published
          type
        }
      }
      nodes {
        offerId
        access
        published
        type
        rewardOffer {
          state {
            avatarUrl
            coverUrl
            description
            name
            quantity
            limitedQty
            rewardId
            type
            timeFrameConstraint {
              endDateTime
              expiresDateTime
              startDateTime
              timeFrameType
              timeZoneId
            }
            settings {
              ... on CanShareSetting {
                enabled
                settingType
              }
              ... on OptInPrivacyPolicySetting {
                content
                enabled
                link
                settingType
                title
              }
              ... on LocationRadiusSetting {
                address
                enabled
                latitude
                longitude
                radius
                settingType
                unit
              }
            }
            conditions {
              ... on AchievementsRewardCondition {
                achievements {
                  achievementId
                  avatarUrl
                  description
                  name
                  type
                }
                type
              }
              ... on LoyaltyTierRewardCondition {
                loyaltyTiersByClub {
                  club {
                    clubId
                    name
                    images {
                      background
                    }
                    tiers {
                      backgroundImageUrl
                      colors {
                        background
                        border
                        foreground
                      }
                      description
                      level
                      name
                      title
                    }
                    membership {
                      tier {
                        level
                        name
                        title
                      }
                    }
                  }
                  level
                }
                type
              }
              ... on PriceRewardCondition {
                price
                repPoints
                type
              }
              ... on RepScoreRewardCondition {
                repScore
                type
              }
              ... on RepPointsRewardCondition {
                repPointsByClub {
                  club {
                    clubId
                    name
                    images {
                      background
                    }
                    tiers {
                      backgroundImageUrl
                      colors {
                        background
                        border
                        foreground
                      }
                      description
                      level
                      name
                      title
                    }
                  }
                  repPoints
                }
                type
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    clubId
  }
}
    `;

/**
 * __useGetManageClubOfferBySlugQuery__
 *
 * To run a query within a React component, call `useGetManageClubOfferBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageClubOfferBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageClubOfferBySlugQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetManageClubOfferBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetManageClubOfferBySlugQuery, GetManageClubOfferBySlugQueryVariables> & ({ variables: GetManageClubOfferBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageClubOfferBySlugQuery, GetManageClubOfferBySlugQueryVariables>(GetManageClubOfferBySlugDocument, options);
      }
export function useGetManageClubOfferBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageClubOfferBySlugQuery, GetManageClubOfferBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageClubOfferBySlugQuery, GetManageClubOfferBySlugQueryVariables>(GetManageClubOfferBySlugDocument, options);
        }
export function useGetManageClubOfferBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManageClubOfferBySlugQuery, GetManageClubOfferBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManageClubOfferBySlugQuery, GetManageClubOfferBySlugQueryVariables>(GetManageClubOfferBySlugDocument, options);
        }
export type GetManageClubOfferBySlugQueryHookResult = ReturnType<typeof useGetManageClubOfferBySlugQuery>;
export type GetManageClubOfferBySlugLazyQueryHookResult = ReturnType<typeof useGetManageClubOfferBySlugLazyQuery>;
export type GetManageClubOfferBySlugSuspenseQueryHookResult = ReturnType<typeof useGetManageClubOfferBySlugSuspenseQuery>;
export type GetManageClubOfferBySlugQueryResult = Apollo.QueryResult<GetManageClubOfferBySlugQuery, GetManageClubOfferBySlugQueryVariables>;
export const SearchOffersDocument = gql`
    query SearchOffers($pageArgs: PageArgsInput!, $last: Int, $first: Int, $criteria: SearchOfferCriteriaInput, $before: String, $after: String) {
  searchOffers(
    pageArgs: $pageArgs
    last: $last
    first: $first
    criteria: $criteria
    before: $before
    after: $after
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    nodes {
      offerId
      club {
        clubId
        slug
        permissions {
          name
        }
      }
      rewardOffer {
        state {
          avatarUrl
          coverUrl
          description
          name
          quantity
          rewardId
          type
          timeFrameConstraint {
            expiresDateTime
            timeZoneId
          }
          redemptionMethod {
            ... on PriceRewardRedemptionMethod {
              price
              redemptionMethodType
            }
            ... on NoneRewardRedemptionMethod {
              redemptionMethodType
            }
            ... on RepPointsRewardRedemptionMethod {
              redemptionMethodType
              repPoints
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchOffersQuery__
 *
 * To run a query within a React component, call `useSearchOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOffersQuery({
 *   variables: {
 *      pageArgs: // value for 'pageArgs'
 *      last: // value for 'last'
 *      first: // value for 'first'
 *      criteria: // value for 'criteria'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchOffersQuery(baseOptions: Apollo.QueryHookOptions<SearchOffersQuery, SearchOffersQueryVariables> & ({ variables: SearchOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOffersQuery, SearchOffersQueryVariables>(SearchOffersDocument, options);
      }
export function useSearchOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOffersQuery, SearchOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOffersQuery, SearchOffersQueryVariables>(SearchOffersDocument, options);
        }
export function useSearchOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOffersQuery, SearchOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchOffersQuery, SearchOffersQueryVariables>(SearchOffersDocument, options);
        }
export type SearchOffersQueryHookResult = ReturnType<typeof useSearchOffersQuery>;
export type SearchOffersLazyQueryHookResult = ReturnType<typeof useSearchOffersLazyQuery>;
export type SearchOffersSuspenseQueryHookResult = ReturnType<typeof useSearchOffersSuspenseQuery>;
export type SearchOffersQueryResult = Apollo.QueryResult<SearchOffersQuery, SearchOffersQueryVariables>;
export const GetMyOffersDocument = gql`
    query GetMyOffers($pageArgs: PageArgsInput!, $criteria: SearchMyOfferCriteriaInput, $first: Int) {
  myOffers(pageArgs: $pageArgs, criteria: $criteria, first: $first) {
    pageInfo {
      endCursor
      hasNextPage
    }
    nodes {
      offerId
      club {
        clubId
        slug
        permissions {
          name
        }
      }
      rewardOffer {
        state {
          avatarUrl
          coverUrl
          description
          name
          quantity
          rewardId
          type
          timeFrameConstraint {
            expiresDateTime
            timeZoneId
          }
          redemptionMethod {
            ... on PriceRewardRedemptionMethod {
              price
              redemptionMethodType
            }
            ... on NoneRewardRedemptionMethod {
              redemptionMethodType
            }
            ... on RepPointsRewardRedemptionMethod {
              redemptionMethodType
              repPoints
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyOffersQuery__
 *
 * To run a query within a React component, call `useGetMyOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOffersQuery({
 *   variables: {
 *      pageArgs: // value for 'pageArgs'
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetMyOffersQuery(baseOptions: Apollo.QueryHookOptions<GetMyOffersQuery, GetMyOffersQueryVariables> & ({ variables: GetMyOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOffersQuery, GetMyOffersQueryVariables>(GetMyOffersDocument, options);
      }
export function useGetMyOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOffersQuery, GetMyOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOffersQuery, GetMyOffersQueryVariables>(GetMyOffersDocument, options);
        }
export function useGetMyOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyOffersQuery, GetMyOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyOffersQuery, GetMyOffersQueryVariables>(GetMyOffersDocument, options);
        }
export type GetMyOffersQueryHookResult = ReturnType<typeof useGetMyOffersQuery>;
export type GetMyOffersLazyQueryHookResult = ReturnType<typeof useGetMyOffersLazyQuery>;
export type GetMyOffersSuspenseQueryHookResult = ReturnType<typeof useGetMyOffersSuspenseQuery>;
export type GetMyOffersQueryResult = Apollo.QueryResult<GetMyOffersQuery, GetMyOffersQueryVariables>;
export const GetClubRolesDocument = gql`
    query GetClubRoles {
  clubRoles {
    roleId
    roleName
  }
}
    `;

/**
 * __useGetClubRolesQuery__
 *
 * To run a query within a React component, call `useGetClubRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClubRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetClubRolesQuery, GetClubRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubRolesQuery, GetClubRolesQueryVariables>(GetClubRolesDocument, options);
      }
export function useGetClubRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubRolesQuery, GetClubRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubRolesQuery, GetClubRolesQueryVariables>(GetClubRolesDocument, options);
        }
export function useGetClubRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubRolesQuery, GetClubRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubRolesQuery, GetClubRolesQueryVariables>(GetClubRolesDocument, options);
        }
export type GetClubRolesQueryHookResult = ReturnType<typeof useGetClubRolesQuery>;
export type GetClubRolesLazyQueryHookResult = ReturnType<typeof useGetClubRolesLazyQuery>;
export type GetClubRolesSuspenseQueryHookResult = ReturnType<typeof useGetClubRolesSuspenseQuery>;
export type GetClubRolesQueryResult = Apollo.QueryResult<GetClubRolesQuery, GetClubRolesQueryVariables>;
export const GetClubEventsDocument = gql`
    query GetClubEvents($clubSlugOrId: String!, $criteria: SearchMyCreatedEventCriteriaInput, $first: Int, $after: String) {
  event {
    clubEvents(
      clubSlugOrId: $clubSlugOrId
      criteria: $criteria
      first: $first
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      nodes {
        eventType
        avatarUrl
        displayName
        slug
        eventId
        startDate
        createdBy {
          userId
        }
        promoters {
          nodes {
            userId
          }
        }
        coHosts {
          nodes {
            userId
          }
        }
        sponsors {
          nodes {
            userId
          }
        }
        attendeeInfo {
          attendeeInfo {
            attendeeRole
          }
        }
        timeZone
      }
    }
  }
}
    `;

/**
 * __useGetClubEventsQuery__
 *
 * To run a query within a React component, call `useGetClubEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubEventsQuery({
 *   variables: {
 *      clubSlugOrId: // value for 'clubSlugOrId'
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetClubEventsQuery(baseOptions: Apollo.QueryHookOptions<GetClubEventsQuery, GetClubEventsQueryVariables> & ({ variables: GetClubEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubEventsQuery, GetClubEventsQueryVariables>(GetClubEventsDocument, options);
      }
export function useGetClubEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubEventsQuery, GetClubEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubEventsQuery, GetClubEventsQueryVariables>(GetClubEventsDocument, options);
        }
export function useGetClubEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubEventsQuery, GetClubEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubEventsQuery, GetClubEventsQueryVariables>(GetClubEventsDocument, options);
        }
export type GetClubEventsQueryHookResult = ReturnType<typeof useGetClubEventsQuery>;
export type GetClubEventsLazyQueryHookResult = ReturnType<typeof useGetClubEventsLazyQuery>;
export type GetClubEventsSuspenseQueryHookResult = ReturnType<typeof useGetClubEventsSuspenseQuery>;
export type GetClubEventsQueryResult = Apollo.QueryResult<GetClubEventsQuery, GetClubEventsQueryVariables>;
export const GetUserProfileDocument = gql`
    query GetUserProfile($id: UUID!) {
  user(id: $id) {
    userId
    userName
    name
    avatarUrl
    avatarSource
    instagramAvatarUrl
    tikTokAvatarUrl
    twitchAvatarUrl
    displayNameSource
    instagramDisplayName
    tikTokDisplayName
    twitchDisplayName
    followersCount
    isVerified
    tier
    isFollowedByCurrentUser
  }
}
    `;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables> & ({ variables: GetUserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export function useGetUserProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileSuspenseQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const GetUserEventsTotalCountDocument = gql`
    query GetUserEventsTotalCount($userName: String!) {
  event {
    userEvents(userName: $userName, criteria: {eventStatus: ALL}) {
      totalCount
    }
  }
}
    `;

/**
 * __useGetUserEventsTotalCountQuery__
 *
 * To run a query within a React component, call `useGetUserEventsTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEventsTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEventsTotalCountQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useGetUserEventsTotalCountQuery(baseOptions: Apollo.QueryHookOptions<GetUserEventsTotalCountQuery, GetUserEventsTotalCountQueryVariables> & ({ variables: GetUserEventsTotalCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEventsTotalCountQuery, GetUserEventsTotalCountQueryVariables>(GetUserEventsTotalCountDocument, options);
      }
export function useGetUserEventsTotalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEventsTotalCountQuery, GetUserEventsTotalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEventsTotalCountQuery, GetUserEventsTotalCountQueryVariables>(GetUserEventsTotalCountDocument, options);
        }
export function useGetUserEventsTotalCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserEventsTotalCountQuery, GetUserEventsTotalCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserEventsTotalCountQuery, GetUserEventsTotalCountQueryVariables>(GetUserEventsTotalCountDocument, options);
        }
export type GetUserEventsTotalCountQueryHookResult = ReturnType<typeof useGetUserEventsTotalCountQuery>;
export type GetUserEventsTotalCountLazyQueryHookResult = ReturnType<typeof useGetUserEventsTotalCountLazyQuery>;
export type GetUserEventsTotalCountSuspenseQueryHookResult = ReturnType<typeof useGetUserEventsTotalCountSuspenseQuery>;
export type GetUserEventsTotalCountQueryResult = Apollo.QueryResult<GetUserEventsTotalCountQuery, GetUserEventsTotalCountQueryVariables>;
export const GetUserEventsDocument = gql`
    query GetUserEvents($userName: String!, $criteria: SearchMyCreatedEventCriteriaInput, $first: Int, $after: String) {
  event {
    userEvents(
      userName: $userName
      criteria: $criteria
      first: $first
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        slug
        eventId
        avatarUrl
        exclusiveAvatarUrl
        displayName
        startDate
        timeZone
        status
        isPrivate
        currency
        attendeeInfo {
          attendeeInfo {
            attendeeState
            permissions
          }
        }
        mySeriesRoles
        seriesPassAttendeeState
        eventTickets {
          nodes {
            price
            repPoints
          }
        }
        createdBy {
          userId
          avatarUrl
          userName
          isVerified
          tier
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserEventsQuery__
 *
 * To run a query within a React component, call `useGetUserEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEventsQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetUserEventsQuery(baseOptions: Apollo.QueryHookOptions<GetUserEventsQuery, GetUserEventsQueryVariables> & ({ variables: GetUserEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEventsQuery, GetUserEventsQueryVariables>(GetUserEventsDocument, options);
      }
export function useGetUserEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEventsQuery, GetUserEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEventsQuery, GetUserEventsQueryVariables>(GetUserEventsDocument, options);
        }
export function useGetUserEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserEventsQuery, GetUserEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserEventsQuery, GetUserEventsQueryVariables>(GetUserEventsDocument, options);
        }
export type GetUserEventsQueryHookResult = ReturnType<typeof useGetUserEventsQuery>;
export type GetUserEventsLazyQueryHookResult = ReturnType<typeof useGetUserEventsLazyQuery>;
export type GetUserEventsSuspenseQueryHookResult = ReturnType<typeof useGetUserEventsSuspenseQuery>;
export type GetUserEventsQueryResult = Apollo.QueryResult<GetUserEventsQuery, GetUserEventsQueryVariables>;
export const GetUserEventsByRoleTotalCountDocument = gql`
    query GetUserEventsByRoleTotalCount($userName: String!, $role: EventAttendeeRole!) {
  event {
    userEventsByRole(userName: $userName, role: $role, criteria: {eventStatus: ALL}) {
      totalCount
    }
  }
}
    `;

/**
 * __useGetUserEventsByRoleTotalCountQuery__
 *
 * To run a query within a React component, call `useGetUserEventsByRoleTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEventsByRoleTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEventsByRoleTotalCountQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetUserEventsByRoleTotalCountQuery(baseOptions: Apollo.QueryHookOptions<GetUserEventsByRoleTotalCountQuery, GetUserEventsByRoleTotalCountQueryVariables> & ({ variables: GetUserEventsByRoleTotalCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEventsByRoleTotalCountQuery, GetUserEventsByRoleTotalCountQueryVariables>(GetUserEventsByRoleTotalCountDocument, options);
      }
export function useGetUserEventsByRoleTotalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEventsByRoleTotalCountQuery, GetUserEventsByRoleTotalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEventsByRoleTotalCountQuery, GetUserEventsByRoleTotalCountQueryVariables>(GetUserEventsByRoleTotalCountDocument, options);
        }
export function useGetUserEventsByRoleTotalCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserEventsByRoleTotalCountQuery, GetUserEventsByRoleTotalCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserEventsByRoleTotalCountQuery, GetUserEventsByRoleTotalCountQueryVariables>(GetUserEventsByRoleTotalCountDocument, options);
        }
export type GetUserEventsByRoleTotalCountQueryHookResult = ReturnType<typeof useGetUserEventsByRoleTotalCountQuery>;
export type GetUserEventsByRoleTotalCountLazyQueryHookResult = ReturnType<typeof useGetUserEventsByRoleTotalCountLazyQuery>;
export type GetUserEventsByRoleTotalCountSuspenseQueryHookResult = ReturnType<typeof useGetUserEventsByRoleTotalCountSuspenseQuery>;
export type GetUserEventsByRoleTotalCountQueryResult = Apollo.QueryResult<GetUserEventsByRoleTotalCountQuery, GetUserEventsByRoleTotalCountQueryVariables>;
export const GetUserEventsByRoleDocument = gql`
    query GetUserEventsByRole($userName: String!, $role: EventAttendeeRole!, $criteria: SearchMyCreatedEventCriteriaInput, $first: Int, $after: String) {
  event {
    userEventsByRole(
      userName: $userName
      role: $role
      criteria: $criteria
      first: $first
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      nodes {
        slug
        eventId
        avatarUrl
        exclusiveAvatarUrl
        displayName
        startDate
        timeZone
        status
        isPrivate
        currency
        attendeeInfo {
          attendeeInfo {
            attendeeState
            permissions
          }
        }
        mySeriesRoles
        seriesPassAttendeeState
        eventTickets {
          nodes {
            price
            repPoints
          }
        }
        createdBy {
          userId
          avatarUrl
          userName
          isVerified
          tier
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserEventsByRoleQuery__
 *
 * To run a query within a React component, call `useGetUserEventsByRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEventsByRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEventsByRoleQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *      role: // value for 'role'
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetUserEventsByRoleQuery(baseOptions: Apollo.QueryHookOptions<GetUserEventsByRoleQuery, GetUserEventsByRoleQueryVariables> & ({ variables: GetUserEventsByRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEventsByRoleQuery, GetUserEventsByRoleQueryVariables>(GetUserEventsByRoleDocument, options);
      }
export function useGetUserEventsByRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEventsByRoleQuery, GetUserEventsByRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEventsByRoleQuery, GetUserEventsByRoleQueryVariables>(GetUserEventsByRoleDocument, options);
        }
export function useGetUserEventsByRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserEventsByRoleQuery, GetUserEventsByRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserEventsByRoleQuery, GetUserEventsByRoleQueryVariables>(GetUserEventsByRoleDocument, options);
        }
export type GetUserEventsByRoleQueryHookResult = ReturnType<typeof useGetUserEventsByRoleQuery>;
export type GetUserEventsByRoleLazyQueryHookResult = ReturnType<typeof useGetUserEventsByRoleLazyQuery>;
export type GetUserEventsByRoleSuspenseQueryHookResult = ReturnType<typeof useGetUserEventsByRoleSuspenseQuery>;
export type GetUserEventsByRoleQueryResult = Apollo.QueryResult<GetUserEventsByRoleQuery, GetUserEventsByRoleQueryVariables>;
export const CertificateGetFileUrlDocument = gql`
    query CertificateGetFileUrl($certificateReferenceId: String!) {
  event {
    certificateFileUrl(certificateReferenceId: $certificateReferenceId)
  }
}
    `;

/**
 * __useCertificateGetFileUrlQuery__
 *
 * To run a query within a React component, call `useCertificateGetFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateGetFileUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateGetFileUrlQuery({
 *   variables: {
 *      certificateReferenceId: // value for 'certificateReferenceId'
 *   },
 * });
 */
export function useCertificateGetFileUrlQuery(baseOptions: Apollo.QueryHookOptions<CertificateGetFileUrlQuery, CertificateGetFileUrlQueryVariables> & ({ variables: CertificateGetFileUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CertificateGetFileUrlQuery, CertificateGetFileUrlQueryVariables>(CertificateGetFileUrlDocument, options);
      }
export function useCertificateGetFileUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CertificateGetFileUrlQuery, CertificateGetFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CertificateGetFileUrlQuery, CertificateGetFileUrlQueryVariables>(CertificateGetFileUrlDocument, options);
        }
export function useCertificateGetFileUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CertificateGetFileUrlQuery, CertificateGetFileUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CertificateGetFileUrlQuery, CertificateGetFileUrlQueryVariables>(CertificateGetFileUrlDocument, options);
        }
export type CertificateGetFileUrlQueryHookResult = ReturnType<typeof useCertificateGetFileUrlQuery>;
export type CertificateGetFileUrlLazyQueryHookResult = ReturnType<typeof useCertificateGetFileUrlLazyQuery>;
export type CertificateGetFileUrlSuspenseQueryHookResult = ReturnType<typeof useCertificateGetFileUrlSuspenseQuery>;
export type CertificateGetFileUrlQueryResult = Apollo.QueryResult<CertificateGetFileUrlQuery, CertificateGetFileUrlQueryVariables>;
export const GenerateGuestQrCodeDocument = gql`
    mutation GenerateGuestQrCode($eventId: UUID!, $token: String!) {
  public {
    generateGuestQrCode(eventId: $eventId, token: $token) {
      id
      guestId
      expiresAt
      qrCode
      firstSeen
      count
    }
  }
}
    `;
export type GenerateGuestQrCodeMutationFn = Apollo.MutationFunction<GenerateGuestQrCodeMutation, GenerateGuestQrCodeMutationVariables>;

/**
 * __useGenerateGuestQrCodeMutation__
 *
 * To run a mutation, you first call `useGenerateGuestQrCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateGuestQrCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateGuestQrCodeMutation, { data, loading, error }] = useGenerateGuestQrCodeMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGenerateGuestQrCodeMutation(baseOptions?: Apollo.MutationHookOptions<GenerateGuestQrCodeMutation, GenerateGuestQrCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateGuestQrCodeMutation, GenerateGuestQrCodeMutationVariables>(GenerateGuestQrCodeDocument, options);
      }
export type GenerateGuestQrCodeMutationHookResult = ReturnType<typeof useGenerateGuestQrCodeMutation>;
export type GenerateGuestQrCodeMutationResult = Apollo.MutationResult<GenerateGuestQrCodeMutation>;
export type GenerateGuestQrCodeMutationOptions = Apollo.BaseMutationOptions<GenerateGuestQrCodeMutation, GenerateGuestQrCodeMutationVariables>;
export const GuestQrPassDocument = gql`
    query GuestQrPass($eventId: UUID!, $token: String!) {
  event {
    guestQrPass(eventId: $eventId, token: $token) {
      guestName
      eventName
      eventImageUrl
      qrValue
      fullyRedeemed
      ticketType
      startDate
      endDate
      timeZone
      walletDownloadToken
    }
  }
}
    `;

/**
 * __useGuestQrPassQuery__
 *
 * To run a query within a React component, call `useGuestQrPassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestQrPassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestQrPassQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGuestQrPassQuery(baseOptions: Apollo.QueryHookOptions<GuestQrPassQuery, GuestQrPassQueryVariables> & ({ variables: GuestQrPassQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestQrPassQuery, GuestQrPassQueryVariables>(GuestQrPassDocument, options);
      }
export function useGuestQrPassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestQrPassQuery, GuestQrPassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestQrPassQuery, GuestQrPassQueryVariables>(GuestQrPassDocument, options);
        }
export function useGuestQrPassSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GuestQrPassQuery, GuestQrPassQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GuestQrPassQuery, GuestQrPassQueryVariables>(GuestQrPassDocument, options);
        }
export type GuestQrPassQueryHookResult = ReturnType<typeof useGuestQrPassQuery>;
export type GuestQrPassLazyQueryHookResult = ReturnType<typeof useGuestQrPassLazyQuery>;
export type GuestQrPassSuspenseQueryHookResult = ReturnType<typeof useGuestQrPassSuspenseQuery>;
export type GuestQrPassQueryResult = Apollo.QueryResult<GuestQrPassQuery, GuestQrPassQueryVariables>;
export const MemberOfferGetClubOfferDocument = gql`
    query MemberOfferGetClubOffer($slug: String!, $offerId: UUID!) {
  clubBySlug(slug: $slug) {
    offers(filter: {offerId: $offerId}) {
      nodes {
        offerId
        isWinnerGenerated
        userOffer {
          status
          redemption {
            ... on UserInviteLinkRedemption {
              inviteLink
            }
          }
        }
        isCurrentUserRedeemable
        isCurrentUserWinner
        isFree
        canProcessPayment
        rewardOffer {
          state {
            avatarUrl
            coverUrl
            description
            name
            quantity
            limitedQty
            ageConstraint {
              minimumAge
              maximumAge
            }
            settings {
              ... on CanShareSetting {
                enabled
                settingType
              }
              ... on OptInPrivacyPolicySetting {
                content
                enabled
                link
                settingType
                title
              }
              ... on LocationRadiusSetting {
                address
                enabled
                latitude
                longitude
                radius
                settingType
                unit
              }
            }
            conditions {
              ... on AchievementsRewardCondition {
                achievements {
                  avatarUrl
                  name
                }
                type
              }
              ... on LoyaltyTierRewardCondition {
                loyaltyTiersByClub {
                  club {
                    name
                    images {
                      background
                    }
                    tiers {
                      backgroundImageUrl
                      colors {
                        background
                        border
                        foreground
                      }
                      description
                      level
                      name
                      title
                    }
                  }
                  level
                }
                type
              }
              ... on PriceRewardCondition {
                price
                type
              }
              ... on RepPointsRewardCondition {
                repPointsByClub {
                  club {
                    clubId
                    name
                    images {
                      background
                    }
                  }
                  repPoints
                }
                type
              }
            }
            redemption {
              ... on AccessPassRewardRedemption {
                code
                guide
                note
                isGenerated
                redemptionType
              }
              ... on InviteLinkRewardRedemption {
                guide
                code
                link
                note
                isGenerated
                redemptionType
              }
              ... on PromoCodeRewardRedemption {
                guide
                code
                note
                isGenerated
                redemptionType
              }
              ... on LocationInformationRewardRedemption {
                guide
                note
                code
                addressDetails {
                  city
                  countryCode
                  phoneNumber
                  postalCode
                  state
                  streetAddress
                }
                isGenerated
                redemptionType
              }
              ... on CustomerInformationRewardRedemption {
                customerInformationScope {
                  isAddressEnabled
                  isEmailEnabled
                  isNameEnabled
                  isPhoneNumberEnabled
                  isSocialMediaAccountEnabled
                  isUserNameEnabled
                  socialMediaAccountScope {
                    apple
                    facebook
                    instagram
                    linkedIn
                    tikTok
                    twitch
                    x
                    youTube
                  }
                }
                guide
                note
                redemptionType
              }
            }
            timeFrameConstraint {
              expiresDateTime
              timeFrameType
              timeZoneId
            }
          }
        }
      }
    }
    clubId
    name
  }
}
    `;

/**
 * __useMemberOfferGetClubOfferQuery__
 *
 * To run a query within a React component, call `useMemberOfferGetClubOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberOfferGetClubOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberOfferGetClubOfferQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useMemberOfferGetClubOfferQuery(baseOptions: Apollo.QueryHookOptions<MemberOfferGetClubOfferQuery, MemberOfferGetClubOfferQueryVariables> & ({ variables: MemberOfferGetClubOfferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberOfferGetClubOfferQuery, MemberOfferGetClubOfferQueryVariables>(MemberOfferGetClubOfferDocument, options);
      }
export function useMemberOfferGetClubOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberOfferGetClubOfferQuery, MemberOfferGetClubOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberOfferGetClubOfferQuery, MemberOfferGetClubOfferQueryVariables>(MemberOfferGetClubOfferDocument, options);
        }
export function useMemberOfferGetClubOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberOfferGetClubOfferQuery, MemberOfferGetClubOfferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberOfferGetClubOfferQuery, MemberOfferGetClubOfferQueryVariables>(MemberOfferGetClubOfferDocument, options);
        }
export type MemberOfferGetClubOfferQueryHookResult = ReturnType<typeof useMemberOfferGetClubOfferQuery>;
export type MemberOfferGetClubOfferLazyQueryHookResult = ReturnType<typeof useMemberOfferGetClubOfferLazyQuery>;
export type MemberOfferGetClubOfferSuspenseQueryHookResult = ReturnType<typeof useMemberOfferGetClubOfferSuspenseQuery>;
export type MemberOfferGetClubOfferQueryResult = Apollo.QueryResult<MemberOfferGetClubOfferQuery, MemberOfferGetClubOfferQueryVariables>;
export const MemberOfferCalculateCostDocument = gql`
    query MemberOfferCalculateCost($slug: String!, $offerId: UUID!, $items: [OfferCostItemArgsInput!]!) {
  clubBySlug(slug: $slug) {
    offers(filter: {offerId: $offerId}) {
      nodes {
        calculateOfferCost(offerCostArgs: {items: $items}) {
          hostBalance
          isAllInPricing
          processingFee
          serviceFee
          totalFees
          subTotal
          total
          totalTaxes
          taxName
          taxPercentage
          totalGratuity
          referralUserId
          items {
            offerId
            price
            quantity
            taxCode
            gratuityPercentage
            originalPrice
          }
          paymentAuthCode
          expiresAt
        }
      }
    }
  }
}
    `;

/**
 * __useMemberOfferCalculateCostQuery__
 *
 * To run a query within a React component, call `useMemberOfferCalculateCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberOfferCalculateCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberOfferCalculateCostQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      offerId: // value for 'offerId'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useMemberOfferCalculateCostQuery(baseOptions: Apollo.QueryHookOptions<MemberOfferCalculateCostQuery, MemberOfferCalculateCostQueryVariables> & ({ variables: MemberOfferCalculateCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberOfferCalculateCostQuery, MemberOfferCalculateCostQueryVariables>(MemberOfferCalculateCostDocument, options);
      }
export function useMemberOfferCalculateCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberOfferCalculateCostQuery, MemberOfferCalculateCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberOfferCalculateCostQuery, MemberOfferCalculateCostQueryVariables>(MemberOfferCalculateCostDocument, options);
        }
export function useMemberOfferCalculateCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberOfferCalculateCostQuery, MemberOfferCalculateCostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberOfferCalculateCostQuery, MemberOfferCalculateCostQueryVariables>(MemberOfferCalculateCostDocument, options);
        }
export type MemberOfferCalculateCostQueryHookResult = ReturnType<typeof useMemberOfferCalculateCostQuery>;
export type MemberOfferCalculateCostLazyQueryHookResult = ReturnType<typeof useMemberOfferCalculateCostLazyQuery>;
export type MemberOfferCalculateCostSuspenseQueryHookResult = ReturnType<typeof useMemberOfferCalculateCostSuspenseQuery>;
export type MemberOfferCalculateCostQueryResult = Apollo.QueryResult<MemberOfferCalculateCostQuery, MemberOfferCalculateCostQueryVariables>;
export const PublicOfferGetOfferDetailsDocument = gql`
    query PublicOfferGetOfferDetails($slug: String!, $offerId: UUID!) {
  clubOffer(clubSlug: $slug, offerId: $offerId) {
    access
    isFree
    isStarted
    offerId
    published
    type
    isPublicUserRedeemable
    rewardOffer {
      state {
        avatarUrl
        coverUrl
        description
        name
        quantity
        limitedQty
        ageConstraint {
          minimumAge
          maximumAge
        }
        settings {
          ... on CanShareSetting {
            enabled
            settingType
          }
          ... on OptInPublicPagePreviewSetting {
            enabled
            settingType
          }
        }
        conditions {
          ... on AchievementsRewardCondition {
            achievements {
              avatarUrl
              name
            }
            type
          }
          ... on LoyaltyTierRewardCondition {
            loyaltyTiersByClub {
              club {
                name
                images {
                  background
                }
                tiers {
                  backgroundImageUrl
                  colors {
                    background
                    border
                    foreground
                  }
                  description
                  level
                  name
                  title
                }
              }
              level
            }
            type
          }
          ... on PriceRewardCondition {
            price
            type
          }
          ... on RepPointsRewardCondition {
            repPointsByClub {
              club {
                clubId
                name
                images {
                  background
                }
              }
              repPoints
            }
            type
          }
        }
        timeFrameConstraint {
          expiresDateTime
          timeFrameType
          timeZoneId
        }
        redemption {
          ... on AccessPassRewardRedemption {
            note
            redemptionType
          }
          ... on InviteLinkRewardRedemption {
            note
            redemptionType
          }
          ... on PromoCodeRewardRedemption {
            note
            redemptionType
          }
          ... on LocationInformationRewardRedemption {
            note
            redemptionType
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePublicOfferGetOfferDetailsQuery__
 *
 * To run a query within a React component, call `usePublicOfferGetOfferDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicOfferGetOfferDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicOfferGetOfferDetailsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function usePublicOfferGetOfferDetailsQuery(baseOptions: Apollo.QueryHookOptions<PublicOfferGetOfferDetailsQuery, PublicOfferGetOfferDetailsQueryVariables> & ({ variables: PublicOfferGetOfferDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicOfferGetOfferDetailsQuery, PublicOfferGetOfferDetailsQueryVariables>(PublicOfferGetOfferDetailsDocument, options);
      }
export function usePublicOfferGetOfferDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicOfferGetOfferDetailsQuery, PublicOfferGetOfferDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicOfferGetOfferDetailsQuery, PublicOfferGetOfferDetailsQueryVariables>(PublicOfferGetOfferDetailsDocument, options);
        }
export function usePublicOfferGetOfferDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicOfferGetOfferDetailsQuery, PublicOfferGetOfferDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicOfferGetOfferDetailsQuery, PublicOfferGetOfferDetailsQueryVariables>(PublicOfferGetOfferDetailsDocument, options);
        }
export type PublicOfferGetOfferDetailsQueryHookResult = ReturnType<typeof usePublicOfferGetOfferDetailsQuery>;
export type PublicOfferGetOfferDetailsLazyQueryHookResult = ReturnType<typeof usePublicOfferGetOfferDetailsLazyQuery>;
export type PublicOfferGetOfferDetailsSuspenseQueryHookResult = ReturnType<typeof usePublicOfferGetOfferDetailsSuspenseQuery>;
export type PublicOfferGetOfferDetailsQueryResult = Apollo.QueryResult<PublicOfferGetOfferDetailsQuery, PublicOfferGetOfferDetailsQueryVariables>;
export const ProfileGetCurrentUserInvitesDocument = gql`
    query ProfileGetCurrentUserInvites {
  me {
    pendingInvites {
      inviteId
      inviteAcceptLink
      memo
      createdAt
    }
    acceptedInvites {
      acceptedAt
      inviteId
      memo
      acceptedBy {
        userId
        avatarUrl
        userName
        isVerified
        tier
        name
        address {
          city
          region
        }
      }
    }
  }
}
    `;

/**
 * __useProfileGetCurrentUserInvitesQuery__
 *
 * To run a query within a React component, call `useProfileGetCurrentUserInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileGetCurrentUserInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileGetCurrentUserInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileGetCurrentUserInvitesQuery(baseOptions?: Apollo.QueryHookOptions<ProfileGetCurrentUserInvitesQuery, ProfileGetCurrentUserInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileGetCurrentUserInvitesQuery, ProfileGetCurrentUserInvitesQueryVariables>(ProfileGetCurrentUserInvitesDocument, options);
      }
export function useProfileGetCurrentUserInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileGetCurrentUserInvitesQuery, ProfileGetCurrentUserInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileGetCurrentUserInvitesQuery, ProfileGetCurrentUserInvitesQueryVariables>(ProfileGetCurrentUserInvitesDocument, options);
        }
export function useProfileGetCurrentUserInvitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileGetCurrentUserInvitesQuery, ProfileGetCurrentUserInvitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileGetCurrentUserInvitesQuery, ProfileGetCurrentUserInvitesQueryVariables>(ProfileGetCurrentUserInvitesDocument, options);
        }
export type ProfileGetCurrentUserInvitesQueryHookResult = ReturnType<typeof useProfileGetCurrentUserInvitesQuery>;
export type ProfileGetCurrentUserInvitesLazyQueryHookResult = ReturnType<typeof useProfileGetCurrentUserInvitesLazyQuery>;
export type ProfileGetCurrentUserInvitesSuspenseQueryHookResult = ReturnType<typeof useProfileGetCurrentUserInvitesSuspenseQuery>;
export type ProfileGetCurrentUserInvitesQueryResult = Apollo.QueryResult<ProfileGetCurrentUserInvitesQuery, ProfileGetCurrentUserInvitesQueryVariables>;
export const GetTaxConfigurationDocument = gql`
    query GetTaxConfiguration {
  me {
    stripeAccount {
      taxCollection {
        hasActiveRegistration
        homeState
        registeredStates
      }
      taxableVenueStates
    }
    taxConfiguration {
      name
      percent
      isCollect
      useAutomaticTax
    }
  }
}
    `;

/**
 * __useGetTaxConfigurationQuery__
 *
 * To run a query within a React component, call `useGetTaxConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxConfigurationQuery, GetTaxConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxConfigurationQuery, GetTaxConfigurationQueryVariables>(GetTaxConfigurationDocument, options);
      }
export function useGetTaxConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxConfigurationQuery, GetTaxConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxConfigurationQuery, GetTaxConfigurationQueryVariables>(GetTaxConfigurationDocument, options);
        }
export function useGetTaxConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaxConfigurationQuery, GetTaxConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaxConfigurationQuery, GetTaxConfigurationQueryVariables>(GetTaxConfigurationDocument, options);
        }
export type GetTaxConfigurationQueryHookResult = ReturnType<typeof useGetTaxConfigurationQuery>;
export type GetTaxConfigurationLazyQueryHookResult = ReturnType<typeof useGetTaxConfigurationLazyQuery>;
export type GetTaxConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetTaxConfigurationSuspenseQuery>;
export type GetTaxConfigurationQueryResult = Apollo.QueryResult<GetTaxConfigurationQuery, GetTaxConfigurationQueryVariables>;